import { KEYS, SegmentKey } from './keys';
import { translate, TranslateFunction, TranslateOptions } from '../index';

function makeTranslator(key: SegmentKey, localeCode?: string) {
    return (options?: TranslateOptions) => {
        options = options || {};
        options = { localeCode, ...options };
        return translate(key, options);
    };
}

export interface TextTranslator<TOptions extends TranslateOptions> {
    (options?: TOptions): string;
}

export type AccountDetailsImageMustBeSquareAndAtLeastMinimumSizeOptions = TranslateOptions & {
    width: string | number;
    height: string | number;
};

export type AccountDetailsMinimumImageDimensionRequirementOptions = TranslateOptions & {
    width: string | number;
    height: string | number;
};

export type AccountMapCreateNewMapForOptions = TranslateOptions & {
    name: string | number;
};

export type AccountMapUnsupportedCurrencyOptions = TranslateOptions & {
    currency_code: string | number;
};

export type AdminBrandsAssignClientsToOptions = TranslateOptions & {
    brand: string | number;
};

export type AdminBrandsCheckClientsToAssignToOptions = TranslateOptions & {
    brand: string | number;
};

export type AdminBrandsThisWillPermanentlyDeleteOptions = TranslateOptions & {
    brand: string | number;
};

export type AdminExternalAuthAppsConfirmDeleteOptions = TranslateOptions & {
    name: string | number;
};

export type AdminMaintenanceStartTimeOptions = TranslateOptions & {
    time: string | number;
};

export type AdminPayableServiceConfirmDeleteCostOptions = TranslateOptions & {
    amount: string | number;
    currency: string | number;
};

export type AdminPayableServiceCostInvalidPrecisionOptions = TranslateOptions & {
    step: string | number;
};

export type AdminSubscriptionsDefaultSubForOptions = TranslateOptions & {
    title : string | number;
};

export type AdminSubscriptionsDeleteRecurringConfirmOptions = TranslateOptions & {
    date: string | number;
};

export type AdminSubscriptionsLocationInitialSubscriptionForOptions = TranslateOptions & {
    title: string | number;
};

export type AgenciesAgencyConfirmDeleteOptions = TranslateOptions & {
    company: string | number;
};

export type AgenciesAgencyDeletedConfirmationMessageOptions = TranslateOptions & {
    company: string | number;
};

export type AgenciesUserAddNewUserToOptions = TranslateOptions & {
    company: string | number;
};

export type AgenciesUserRemoveUserOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
    company: string | number;
};

export type AgenciesUserUserAddedSuccessMessageOptions = TranslateOptions & {
    company: string | number;
};

export type AgenciesUserUserRemovedSuccessMessageOptions = TranslateOptions & {
    company: string | number;
};

export type AgencyClientBrandColoursCreatedBrandColourOptions = TranslateOptions & {
    colour: string | number;
};

export type AgencyClientBrandColoursDeleteConfirmationOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientBrandColoursSuccessfullyAddedBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientBrandColoursSuccessfullyRenamedBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientBrandColoursSuccessfullyUpdatedBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientBrandColoursUpdateBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientBrandColoursUpdatedBrandColourOptions = TranslateOptions & {
    colour: string | number;
};

export type AgencyClientBuilderTemplateCategoriesConfirmDeleteOptions = TranslateOptions & {
    category: string | number;
};

export type AgencyClientLinksDeleteConfirmationOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationActivitiesDeleteActivityOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationActivitiesMigrateChannelConfirmClickDeleteChannelOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationFeaturedTemplateSetsDeleteTemplateTagOptions = TranslateOptions & {
    tagLabel: string | number;
};

export type AgencyClientLocationLearnMenuAddSubSectionToSectionOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationLearnMenuDeleteSectionOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationLearnMenuDeleteSubSectionOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationLearnMenuSubSectionsForOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationLocationDetailsDeleteConfirmationOptions = TranslateOptions & {
    location: string | number;
};

export type AgencyClientLocationManageCreatedLocationErrorOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationManageCreatedLocationSuccessOptions = TranslateOptions & {
    location: string | number;
};

export type AgencyClientLocationManageDeleteLocationErrorOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationManageDeleteLocationLabelOptions = TranslateOptions & {
    location: string | number;
};

export type AgencyClientLocationManageDeleteLocationSuccessOptions = TranslateOptions & {
    location: string | number;
};

export type AgencyClientLocationManageEditDetailsOptions = TranslateOptions & {
    locationName: string | number;
};

export type AgencyClientLocationManageNoFieldValueOptions = TranslateOptions & {
    field: string | number;
};

export type AgencyClientLocationNotifyLocationDeletedOptions = TranslateOptions & {
    location: string | number;
};

export type AgencyClientLocationSummaryFieldsDeleteFieldConfirmOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationUsersAddNewUserToOptions = TranslateOptions & {
    client: string | number;
    location: string | number;
};

export type AgencyClientLocationUsersDeleteConfirmationOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
    location: string | number;
};

export type AgencyClientLocationUsersDeleteUserOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
};

export type AgencyClientLocationUsersUserAddedOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
    location: string | number;
};

export type AgencyClientLocationUsersUserEditUserDeletedOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
};

export type AgencyClientLocationUsersUserEditUserUpdatedOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
};

export type AgencyClientLocationUsersUserRemovedOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
    location: string | number;
};

export type AgencyClientLocationCategoriesDeleteConfirmationOptions = TranslateOptions & {
    option: string | number;
};

export type AgencyClientLocationCategoriesDeleteGroupOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationCategoriesDeleteLocationCategoryConfirmOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationCategoriesDeletedLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationCategoriesNewOptionOptions = TranslateOptions & {
    option: string | number;
};

export type AgencyClientLocationCategoriesOptionAddedOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationCategoriesOptionDeletedOptions = TranslateOptions & {
    label: string | number;
};

export type AgencyClientLocationCategoriesPartiallyAddedLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationCategoriesPartiallyEditedLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationCategoriesSuccessfullyAddedLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationCategoriesSuccessfullyEditedLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationCategoriesUpdatedLocationsForCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type AgencyClientLocationsDeleteClientOptions = TranslateOptions & {
    clientTitle: string | number;
};

export type AgencyClientLocationsEmailsSignUpAgencyInvitedYouOptions = TranslateOptions & {
    agencyName: string | number;
};

export type AgencyClientLocationsEmailsSignUpWelcomeToDigitalStackOptions = TranslateOptions & {
    clientTitle: string | number;
    locationTitle: string | number;
};

export type AgencyClientLocationsEmailsSignedUpLocationSignedUpOptions = TranslateOptions & {
    clientTitle: string | number;
    locationTitle: string | number;
    signedUpDate: string | number;
};

export type AgencyClientLocationsEmailsUpdateBillingDetailsSubjectLineOptions = TranslateOptions & {
    clientTitle: string | number;
    locationTitle: string | number;
};

export type AgencyClientLocationsNoLocationsAssignedOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientLocationsPermanentlyDeletedClientOptions = TranslateOptions & {
    title: string | number;
};

export type AgencyClientPlatformsConfirmRemovePlatformOptions = TranslateOptions & {
    platform: string | number;
    client: string | number;
};

export type AgencyClientPlatformsConfirmRemovePlatformTitleOptions = TranslateOptions & {
    platform: string | number;
};

export type AgencyClientUsersCountSelectedOptions = TranslateOptions & {
    count: number;
};

export type AgencyClientUsersSortDirectionTipOptions = TranslateOptions & {
    direction: string | number;
};

export type AgencyClientsAddClientNewChannelOptions = TranslateOptions & {
    name: string | number;
};

export type AgencyClientsClientTableActionsDeleteClientLabelOptions = TranslateOptions & {
    client: string | number;
};

export type AgencyNotificationsSendConfirmMessageOptions = TranslateOptions & {
    count: number;
};

export type AgencyNotificationsSendConfirmMessagePluralOptions = TranslateOptions & {
    count: number;
};

export type AgencyNotificationsSentByOptions = TranslateOptions & {
    name: string | number;
    sentAt: string | number;
};

export type AgencyPrintSkuGroupsPrintProviderAuthRequestConfirmationOptions = TranslateOptions & {
    email: string | number;
};

export type AgencyPrintSkuGroupsSkuCreateSkuOptions = TranslateOptions & {
    sku: string | number;
};

export type AgencyPrintSkuGroupsSkuEditSkuOptions = TranslateOptions & {
    sku: string | number;
};

export type AgencyPrintSkuGroupsSkuSkuDeleteConfirmationOptions = TranslateOptions & {
    sku: string | number;
};

export type AgencyPrintSkuGroupsSkuGroupsDeleteSkuGroupOptions = TranslateOptions & {
    name: string | number;
};

export type AgencyPrintSkuGroupsSkuGroupsEditSkuGroupOptions = TranslateOptions & {
    name: string | number;
};

export type AgencyPrintSkuGroupsSkuGroupsSkuGroupDeleteConfirmationOptions = TranslateOptions & {
    name: string | number;
};

export type AgencySendReportsReportClickedSubtitleOptions = TranslateOptions & {
    clickedCount: string | number;
};

export type AgencySendReportsReportReadSubtitleOptions = TranslateOptions & {
    readCount: string | number;
};

export type AgencySendReportsReportSentFromOptions = TranslateOptions & {
    email: string | number;
};

export type AgencySendReportsReportSentSubtitleOptions = TranslateOptions & {
    sentCount: string | number;
};

export type AgencySendReportsReportSentToPart2Options = TranslateOptions & {
    count: number;
};

export type AgencySendReportsReportSentToPart2PluralOptions = TranslateOptions & {
    count: number;
};

export type AgencySendReportsReportSubtitleNotSentOptions = TranslateOptions & {
    sentCount: string | number;
};

export type AgencySendReportsReportSubtitleSentByOptions = TranslateOptions & {
    userName: string | number;
};

export type AppsCampaignsFoundInAdwordsThatMatchNameOptions = TranslateOptions & {
    count: number;
};

export type AppsCampaignsFoundInAdwordsThatMatchNamePluralOptions = TranslateOptions & {
    count: number;
};

export type AppsConnectToAccountOptions = TranslateOptions & {
    accountName: string | number;
};

export type AppsConnectingViaAccountOptions = TranslateOptions & {
    accountName: string | number;
};

export type AppsCustomerIdOptions = TranslateOptions & {
    customerId: string | number;
};

export type AppsDisconnectFromAccountOptions = TranslateOptions & {
    accountName: string | number;
};

export type AppsErrorsDebugMessageWrapOptions = TranslateOptions & {
    debugMessage: string | number;
};

export type AppsErrorsWeveEncounteredIssuesOptions = TranslateOptions & {
    num: string | number;
};

export type AppsFetchServiceConfigOptions = TranslateOptions & {
    service: string | number;
};

export type AppsGoogleAdwordsCampaignNameMatchesCountContinueOptions = TranslateOptions & {
    count: number;
};

export type AppsInstagramConnectedAccountInfoOptions = TranslateOptions & {
    account: string | number;
    page: string | number;
};

export type AppsPrintProviderSkuGroupAttachedOptions = TranslateOptions & {
     skuGroup : string | number;
};

export type AssetLibraryCollectionLimitReachedOptions = TranslateOptions & {
    title: string | number;
    collectionLimit: string | number;
};

export type AssetLibraryMoveAssetsToFolderOptions = TranslateOptions & {
    num: string | number;
    folder: string | number;
};

export type AssetLibraryMovingAssetsOptions = TranslateOptions & {
    num: string | number;
};

export type AssetLibrarySavingAssetsOptions = TranslateOptions & {
    num: string | number;
};

export type AssetLibraryUploadingAssetsOptions = TranslateOptions & {
    num: string | number;
};

export type BuildAnimationFrameNumberOfCountOptions = TranslateOptions & {
    frameNumber: string | number;
    frameCount: string | number;
};

export type BuildBuilderTemplateDeleteConfirmationModalConfirmationMessageOptions = TranslateOptions & {
    count: number;
};

export type BuildBuilderTemplateDeleteConfirmationModalConfirmationMessagePluralOptions = TranslateOptions & {
    count: number;
};

export type BuildBuilderTemplateUpdateConfirmationModalConfirmationMessageOptions = TranslateOptions & {
    count: number;
};

export type BuildBuilderTemplateUpdateConfirmationModalConfirmationMessagePluralOptions = TranslateOptions & {
    count: number;
};

export type BuildConfirmDeleteAllChannelDataOptions = TranslateOptions & {
    name: string | number;
};

export type BuildEmailNoCampaginMonitorSetupForLocationOptions = TranslateOptions & {
    location: string | number;
};

export type BuildEmailZipValidationImageMissingOptions = TranslateOptions & {
    image: string | number;
};

export type BuildEmailZipValidationImageUnreferencedOptions = TranslateOptions & {
    image: string | number;
};

export type BuildErrorDimensionsForPngInPrintTemplatesLimitedOptions = TranslateOptions & {
    maxDimensions: string | number;
};

export type BuildFontsAddFontForClientOptions = TranslateOptions & {
    client: string | number;
};

export type BuildFontsAreYouSureDeleteFamilyOptions = TranslateOptions & {
    family: string | number;
};

export type BuildFontsDeleteFontFamilyOptions = TranslateOptions & {
    family: string | number;
};

export type BuildFormatsSelectedOptions = TranslateOptions & {
    count: number;
};

export type BuildFormatsSelectedPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildLocationDraftAreYouSureYouWantToOverrideTemplateRevisionWithTitleOptions = TranslateOptions & {
    title: string | number;
};

export type BuildLocationDraftSaveLocationRevisionWithTitleOptions = TranslateOptions & {
    title: string | number;
};

export type BuildLocationDraftSaveOverCurrentRevisionWithTitleOptions = TranslateOptions & {
    title: string | number;
};

export type BuildLocationLogoNotSetOptions = TranslateOptions & {
    location: string | number;
};

export type BuildLocationMapNotCreatedOptions = TranslateOptions & {
    location: string | number;
};

export type BuildMobileAppTemplateValidationNotMobileCompatibleOptions = TranslateOptions & {
    message: string | number;
};

export type BuildMultiImageMuliImageCounterTooltipOptions = TranslateOptions & {
    count: number;
};

export type BuildMultiImageMuliImageCounterTooltipPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPrintExtraInfoOptions = TranslateOptions & {
    orderNumber: string | number;
};

export type BuildPrintPageNumberOfCountOptions = TranslateOptions & {
    pageNumber: string | number;
    pageCount: string | number;
};

export type BuildPrintPleaseEnterPageNumberBetweenOptions = TranslateOptions & {
    pageCount: string | number;
};

export type BuildPublishClubReadyCustomListDescriptionWarningOptions = TranslateOptions & {
    maxLength: string | number;
};

export type BuildPublishClubReadyCustomListMatchesOptions = TranslateOptions & {
    matches: string | number;
    total: string | number;
};

export type BuildPublishClubReadyMatchedOutOfOptions = TranslateOptions & {
    matches: string | number;
    total: string | number;
};

export type BuildPublishClubReadyMoreClubCountOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishClubReadyMoreClubCountPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishClubReadySenderNotVerifiedMessageOptions = TranslateOptions & {
    domain: string | number;
};

export type BuildPublishClubReadyWarnPublishTooLargeOptions = TranslateOptions & {
    publishSize: string | number;
};

export type BuildPublishFacebookPageListRemainingOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishFacebookPageListRemainingPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishFacebookPagesCountOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishFacebookPagesCountPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishGoogleMyBusinessCharacterLimitReachedOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishHashtagsErrorLimitHashtagCountOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishHashtagsErrorLimitHashtagCountPluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishHashtagsHashtagCharacterCountOptions = TranslateOptions & {
    characterCount: string | number;
    maxCharacters: string | number;
};

export type BuildPublishHashtagsHashtagTagCountOptions = TranslateOptions & {
    tagCount: string | number;
    maxTags: string | number;
};

export type BuildPublishInstagramExceededMaxImageCountHelpTextOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishInstagramPostsWillExpireOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishInstagramPostsWillExpirePluralOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishInstagramScheduledPostMustBeAtLeastMinsInFutureOptions = TranslateOptions & {
    minutes: string | number;
};

export type BuildPublishMultipleLocationsNoAccessHelpOptions = TranslateOptions & {
    connectLink: string | number;
};

export type BuildPublishMultipleLocationsPublishedVideosSuccessfullyOptions = TranslateOptions & {
    platform: string | number;
};

export type BuildPublishMultipleLocationsScheduledVideosSuccessfullyOptions = TranslateOptions & {
    platform: string | number;
    scheduledTime: string | number;
};

export type BuildPublishMultiplePlatformsPublishedToPlatformOptions = TranslateOptions & {
     platform : string | number;
};

export type BuildPublishMultiplePlatformsPublishingToPlatformOptions = TranslateOptions & {
     platform : string | number;
};

export type BuildPublishNoAccessHelpOptions = TranslateOptions & {
    connectLink: string | number;
};

export type BuildPublishPublishedSuccessfullyOptions = TranslateOptions & {
    platform: string | number;
};

export type BuildPublishSavedSuccessfullyOptions = TranslateOptions & {
    platform: string | number;
};

export type BuildPublishScheduledSuccessfullyOptions = TranslateOptions & {
    platform: string | number;
    scheduledTime: string | number;
};

export type BuildPublishTwitterCannotPublishMultiImageHelpTextOptions = TranslateOptions & {
    count: number;
};

export type BuildPublishWillReceiveNotificationOptions = TranslateOptions & {
    assignedUser: string | number;
    platform: string | number;
};

export type BuildPublishWillReceiveScheduledNotificationOptions = TranslateOptions & {
    assignedUser: string | number;
    platform: string | number;
    scheduledTime: string | number;
};

export type BuildPublishWillRecieveSmsDetailsOptions = TranslateOptions & {
    phoneNumber: string | number;
    platform: string | number;
};

export type BuildPublishWillRecieveSmsReminderOptions = TranslateOptions & {
    phoneNumber: string | number;
    platform: string | number;
    scheduledTime: string | number;
};

export type BuildResourcesLoadedOptions = TranslateOptions & {
    loadedCount: string | number;
};

export type BuildResourcesLoadedPluralOptions = TranslateOptions & {
    loadedCount: string | number;
    count: number;
};

export type BuildTemplateAdminCopySuccessOptions = TranslateOptions & {
    clients: string | number;
};

export type BuildTemplateAdminCopySuccessExtendedOptions = TranslateOptions & {
    clients: string | number;
    remainingClientCount: string | number;
};

export type ClientClientUsersLocationModalTitleOptions = TranslateOptions & {
    client: string | number;
};

export type ClientClientUsersTableButtonBulkActionsSecondaryOptions = TranslateOptions & {
    selectedCount: string | number;
};

export type ClientEngagementHelpTextConnectionsCurrentlyRequiredPlatformsOptions = TranslateOptions & {
    platforms: string | number;
};

export type ClientEngagementHelpTextConnectionsHowToSetRequiredPlatformsOptions = TranslateOptions & {
    url: string | number;
};

export type ClientLocationActivityBuiltItemsCountOptions = TranslateOptions & {
    count: number;
};

export type ClientOverviewTemplateCategoriesAssetsUsedOptions = TranslateOptions & {
    count: number;
};

export type ClientOverviewTemplateCategoriesAssetsUsedPluralOptions = TranslateOptions & {
    count: number;
};

export type CommonAndXOtherLocationsOptions = TranslateOptions & {
    count: number;
};

export type CommonAndXOtherLocationsPluralOptions = TranslateOptions & {
    count: number;
};

export type CommonAreYouSureYouWantToDeleteNumAssetsOptions = TranslateOptions & {
    num: string | number;
};

export type CommonClientWithLocationOptions = TranslateOptions & {
    client: string | number;
    location: string | number;
};

export type CommonConfirmModalInputOptions = TranslateOptions & {
    input: string | number;
};

export type CommonCopiedToClipboardOptions = TranslateOptions & {
    item: string | number;
};

export type CommonCurrentLocationUsedMaxCollectionsOptions = TranslateOptions & {
    type: string | number;
};

export type CommonCurrentlySelectedCountOptions = TranslateOptions & {
    count: number;
};

export type CommonDeleteSomethingOptions = TranslateOptions & {
    something: string | number;
};

export type CommonEditMultipleAssetsOptions = TranslateOptions & {
    num: string | number;
};

export type CommonFailedToOptions = TranslateOptions & {
    description: string | number;
};

export type CommonMustBeXOrMoreOptions = TranslateOptions & {
    count: number;
};

export type CommonNumOfTotalOptions = TranslateOptions & {
    num: string | number;
    total: string | number;
};

export type CommonProgressModalStatusMessageOptions = TranslateOptions & {
    status: string | number;
    current: string | number;
    max: string | number;
};

export type CommonRenameSomethingOptions = TranslateOptions & {
    something: string | number;
};

export type CommonSearchWithinOptions = TranslateOptions & {
     name : string | number;
};

export type CommonSortDirectionTipOptions = TranslateOptions & {
    direction: string | number;
};

export type CommonStepNOfCountOptions = TranslateOptions & {
    step: string | number;
    count: number;
};

export type CommonUnsupportedImageFileTypeOptions = TranslateOptions & {
    fileTypes: string | number;
};

export type CommonValidationStringTooLongOptions = TranslateOptions & {
    name: string | number;
    maxCharacters: string | number;
};

export type DashboardDueInNDaysOptions = TranslateOptions & {
    count: number;
};

export type DashboardDueInNDaysPluralOptions = TranslateOptions & {
    count: number;
};

export type DashboardDueInNWeeksOptions = TranslateOptions & {
    count: number;
};

export type DashboardDueInNWeeksPluralOptions = TranslateOptions & {
    count: number;
};

export type DashboardInNWeeksOptions = TranslateOptions & {
    count: number;
};

export type DashboardInNWeeksPluralOptions = TranslateOptions & {
    count: number;
};

export type DashboardPerformanceSummaryConnectAppsToSeePerformanceOptions = TranslateOptions & {
    url: string | number;
};

export type DashboardPerformanceSummaryFailedToGetPerformanceMetricOptions = TranslateOptions & {
     metricName : string | number;
    error: string | number;
};

export type DashboardPerformanceSummaryInsufficientDataRecordedPluralOptions = TranslateOptions & {
     numDays : string | number;
};

export type DashboardPerformanceSummaryPerformanceHeadingOptions = TranslateOptions & {
    period: string | number;
};

export type DashboardWelcomeMessageOptions = TranslateOptions & {
    name: string | number;
};

export type DashboardWelcomePageNumCountriesOptions = TranslateOptions & {
    num: string | number;
};

export type DashboardWelcomePageNumLocationsOptions = TranslateOptions & {
    num: string | number;
};

export type EmailLinkWillExpireOptions = TranslateOptions & {
    count: number;
};

export type EmailLinkWillExpireHourPluralOptions = TranslateOptions & {
    count: number;
};

export type EmailLinkWillExpirePluralOptions = TranslateOptions & {
    count: number;
};

export type EmailSendToPrintArtworkHasBeenSentToOptions = TranslateOptions & {
    providerName: string | number;
};

export type EmailSendToPrintProviderWillBeInTouchOptions = TranslateOptions & {
    providerName: string | number;
};

export type EmailSendToPrintSubjectOptions = TranslateOptions & {
    locationName: string | number;
};

export type EmailSendToPrintSubjectOrderNumberOptions = TranslateOptions & {
    orderNumber: string | number;
};

export type EmailSendToPrintUserInvoiceSubjectOptions = TranslateOptions & {
    providerName: string | number;
};

export type ErrorsBadRequestErrorsPlannerActionDateBelowThresholdOptions = TranslateOptions & {
     count : string | number;
};

export type ErrorsBadRequestErrorsPlannerActionDateBelowThresholdPluralOptions = TranslateOptions & {
     count : string | number;
};

export type ErrorsBadRequestErrorsValidationErrorOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsBrandBrandColoursErrorAddingBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type ErrorsBrandBrandColoursErrorDeletingBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type ErrorsBrandBrandColoursErrorRenamingBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type ErrorsBrandBrandColoursErrorUpdatingBrandColourOptions = TranslateOptions & {
    title: string | number;
};

export type ErrorsBrandLocationCategoriesErrorAddingLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsBrandLocationCategoriesErrorDeletingLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsBrandLocationCategoriesErrorRenamingLocationCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsBrandLocationCategoriesErrorUpdatingLocationsForCategoryOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsExceptionIdOptions = TranslateOptions & {
     id : string | number;
};

export type ErrorsExternalServiceErrorsAcrCloudOptions = TranslateOptions & {
    msg: string | number;
    code: string | number;
};

export type ErrorsExternalServiceErrorsEmailFailureOptions = TranslateOptions & {
    json: string | number;
};

export type ErrorsExternalServiceErrorsEwayErrorOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsExternalServiceErrorsPassthroughOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsExternalServiceErrorsTwitterErrorOptions = TranslateOptions & {
    message: string | number;
    code: string | number;
    locationId: string | number;
};

export type ErrorsExternalServiceErrorsTwitterUnknownErrorOptions = TranslateOptions & {
    statusCode: string | number;
};

export type ErrorsFacebookErrorsUntranslatedErrorMessageOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsFinaliseBillingDetailsUpdateErrorOptions = TranslateOptions & {
    message: string | number;
    billingDetailsUpdate: string | number;
};

export type ErrorsFitwareMemberEngagerUntranslatedErrorMessageOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsFour51ProductMisconfiguredOptions = TranslateOptions & {
    product: string | number;
};

export type ErrorsFour51UntranslatedErrorMessageOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsInstagramErrorsUntranslatedErrorMessageOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsInvalidInputErrorsColourOptions = TranslateOptions & {
    colour: string | number;
};

export type ErrorsInvalidInputErrorsFacebookPageIdMigrationOptions = TranslateOptions & {
    errorMessage: string | number;
};

export type ErrorsInvalidInputErrorsGraphqlInputOptions = TranslateOptions & {
     propertyName : string | number;
};

export type ErrorsMissingValueErrorsFacebookAdSetMissingEndDateOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsMissingValueErrorsFacebookAdSetMissingStartDateOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsMissingValueErrorsReplacementValueForLocalResourceOptions = TranslateOptions & {
    resource: string | number;
};

export type ErrorsNotFoundErrorsAgencyLocaleNotFoundWithIdOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsNotFoundErrorsEntityNotFoundWithIdOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsNotFoundErrorsEntityNotFoundWithTokenOptions = TranslateOptions & {
    token: string | number;
};

export type ErrorsNotFoundErrorsEntityToDeleteNotFoundOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsNotFoundErrorsEntityToUpdateNotFoundOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsNotFoundErrorsNoFacebookAccessTokenForLocationOptions = TranslateOptions & {
    locationId: string | number;
};

export type ErrorsNotFoundErrorsUserNotFoundWithIdOptions = TranslateOptions & {
    id: string | number;
};

export type ErrorsOauthErrorsUnknownGrantTypeOptions = TranslateOptions & {
    grantType: string | number;
};

export type ErrorsPublishErrorsAccessTokenHasExpiredOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsDuplicatePostsDetectedOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsFailedToPublishToLocationOptions = TranslateOptions & {
    location: string | number;
};

export type ErrorsPublishErrorsPermissionsNotGrantedOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsServiceInvalidAspectRatioOptions = TranslateOptions & {
    fileType: string | number;
    service: string | number;
};

export type ErrorsPublishErrorsServiceInvalidScheduleDateOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsServiceMaximumCaptionLengthExceededOptions = TranslateOptions & {
    service: string | number;
    maxLength: string | number;
};

export type ErrorsPublishErrorsServiceMaximumMediaSizeExceededOptions = TranslateOptions & {
    service: string | number;
    fileType: string | number;
    maxSize: string | number;
};

export type ErrorsPublishErrorsServiceMaximumPublishCountReachedOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsUnsupportedFileFormatOptions = TranslateOptions & {
    service: string | number;
    fileType: string | number;
};

export type ErrorsPublishErrorsUserCredentialsChangedOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsPublishErrorsUserInterventionRequiredOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsServiceAccessErrorsAccessExpiredOrForbiddenWithDetailsOptions = TranslateOptions & {
    details: string | number;
};

export type ErrorsServiceAccessErrorsFacebookAccountCannotAccessPageOptions = TranslateOptions & {
    facebookPageName: string | number;
    facebookPageId: string | number;
};

export type ErrorsServiceConfigurationErrorsLocationMissingFitwareClubNumberOptions = TranslateOptions & {
     locationTitle : string | number;
};

export type ErrorsServiceConfigurationErrorsServiceNotConfiguredOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsServiceCredentialsMissingErrorsNoAuthenticationForServiceOptions = TranslateOptions & {
    service: string | number;
};

export type ErrorsStripeUntranslatedErrorMessageOptions = TranslateOptions & {
    message: string | number;
};

export type ErrorsUnexpectedInputErrorsFacebookPageMigrationIdsNotFoundOptions = TranslateOptions & {
    errorMessage: string | number;
};

export type ErrorsUnsupportedCurrencyOptions = TranslateOptions & {
    currencyCode: string | number;
};

export type ErrorsUnsupportedOperationErrorsAccessTokenCannotDetermineAffectedTargetNameOptions = TranslateOptions & {
    accessTokenId: string | number;
};

export type ErrorsUnsupportedOperationErrorsImageFormatConversionOptions = TranslateOptions & {
    format: string | number;
};

export type ErrorsUnsupportedOperationErrorsPlannerOperationNotSupportedOptions = TranslateOptions & {
    operation: string | number;
    applyActionTo: string | number;
};

export type ErrorsUnsupportedOperationErrorsUnsupportedWindowsTimezoneOptions = TranslateOptions & {
    timezone: string | number;
};

export type IntegrationAuthApiKeyPreviousKeyOptions = TranslateOptions & {
    key: string | number;
};

export type IntegrationClientClubReadyEnterChainIdWithClientTitleOptions = TranslateOptions & {
    clientTitle: string | number;
};

export type IntegrationConfigureIntegrationOptions = TranslateOptions & {
    integration: string | number;
};

export type IntegrationDisableForOptions = TranslateOptions & {
    integration: string | number;
    title: string | number;
};

export type IntegrationDisabledIntegrationOptions = TranslateOptions & {
    integration: string | number;
};

export type IntegrationEnableForOptions = TranslateOptions & {
    integration: string | number;
    title: string | number;
};

export type IntegrationEnabledIntegrationOptions = TranslateOptions & {
    integration: string | number;
};

export type IntegrationIntegrationConfigurationOptions = TranslateOptions & {
    integration: string | number;
};

export type IntegrationNotifyAccessCheckFailedOptions = TranslateOptions & {
    serviceDisplayName: string | number;
};

export type IntegrationNotifyCouldNotAuthorizeServiceOptions = TranslateOptions & {
    serviceDisplayName: string | number;
    errorMessage: string | number;
};

export type IntegrationNotifyCouldNotDeauthorizeServiceOptions = TranslateOptions & {
    serviceDisplayName: string | number;
};

export type IntegrationNotifyServiceDeauthorizedOptions = TranslateOptions & {
    serviceDisplayName: string | number;
};

export type IntegrationSetupIntegrationsForOptions = TranslateOptions & {
    title: string | number;
};

export type IntroWelcomeToDigitalStackOptions = TranslateOptions & {
    firstName: string | number;
};

export type LearnDeleteConfirmOptions = TranslateOptions & {
    title: string | number;
};

export type LearnEmailCommentAddedToLearnArticleOptions = TranslateOptions & {
    title: string | number;
};

export type LearnNotifyLearnCreatedOptions = TranslateOptions & {
    title: string | number;
};

export type LearnNotifyLearnUpdatedOptions = TranslateOptions & {
    title: string | number;
};

export type LoginPasswordTooShortOptions = TranslateOptions & {
    count: number;
};

export type LoginPasswordTooShortPluralOptions = TranslateOptions & {
    count: number;
};

export type LoginSignedInAsOptions = TranslateOptions & {
    name: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateCompleteMyMonthPlannerOptions = TranslateOptions & {
    month: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentOptions = TranslateOptions & {
    count: number;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentPluralOptions = TranslateOptions & {
    count: number;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedOptions = TranslateOptions & {
    count: number;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedPluralOptions = TranslateOptions & {
    count: number;
};

export type MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowOptions = TranslateOptions & {
    userFirstName: string | number;
    clientAndLocationName: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowMultipleLocationsOptions = TranslateOptions & {
    userFirstName: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateGetOnTopOfYourPlanningForMonthOptions = TranslateOptions & {
    month: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateLocationForMonthOptions = TranslateOptions & {
    clientAndLocationName: string | number;
    month: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateViewMyMonthPlannerOptions = TranslateOptions & {
    month: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateWhatsOnThisWeekAtLocationOptions = TranslateOptions & {
    clientAndLocationName: string | number;
};

export type MarketingEmailsWeeklyMarketingUpdateYourWeeklyUpdateOptions = TranslateOptions & {
    date: string | number;
};

export type NotificationsMessagesCustomAgencyMessageOptions = TranslateOptions & {
    message: string | number;
};

export type NotificationsMessagesEmailScheduleFailedOptions = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
    error: string | number;
};

export type NotificationsMessagesEmailScheduledOptions = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
};

export type NotificationsMessagesImagePublishFailedOptions = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
    error: string | number;
};

export type NotificationsMessagesImagePublishFailedNoErrorOptions = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
};

export type NotificationsMessagesIntegrationConnectivityFailureOptions = TranslateOptions & {
    platformName: string | number;
};

export type NotificationsMessagesIntegrationConfigurationMisconfiguredOptions = TranslateOptions & {
    platformName: string | number;
};

export type NotificationsMessagesLocationMapGeneratedOptions = TranslateOptions & {
    locationName: string | number;
};

export type NotificationsMessagesLocationMapGenerationFailedOptions = TranslateOptions & {
    locationName: string | number;
};

export type NotificationsMessagesScheduledPostsNoNotifiableDevicesOptions = TranslateOptions & {
    platform: string | number;
};

export type NotificationsMessagesTestOptions = TranslateOptions & {
    username: string | number;
};

export type NotificationsMessagesVideoPublishFailedOptions = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
    error: string | number;
};

export type NotificationsMessagesVideoPublishedExternallyOptions = TranslateOptions & {
    platformName: string | number;
};

export type NotificationsMessagesVideoPublishedExternallyV2Options = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
};

export type NotificationsMessagesVideoScheduledExternallyOptions = TranslateOptions & {
    platformName: string | number;
};

export type NotificationsMessagesVideoScheduledExternallyV2Options = TranslateOptions & {
    platformName: string | number;
    locationName: string | number;
};

export type NotificationsSendNotificationWizardComposeEmailEditorButtonsHeadingNumOptions = TranslateOptions & {
    num: string | number;
};

export type NotificationsSendNotificationWizardComposeEmailInputLabelsFromAddressSwitchDefaultOptions = TranslateOptions & {
    defaultEmail: string | number;
};

export type NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationOptions = TranslateOptions & {
    clientCountText: string | number;
};

export type NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationsOptions = TranslateOptions & {
    clientCountText: string | number;
};

export type NotificationsSendNotificationWizardPickLocationsCurrentlySelectedOptions = TranslateOptions & {
    num: string | number;
};

export type NotificationsSendNotificationWizardPickLocationsLabelsTotalRecipientsOptions = TranslateOptions & {
    totalRecipients: string | number;
};

export type NotificationsSubjectsCustomAgencyMessageOptions = TranslateOptions & {
    subject: string | number;
};

export type OverviewConfirmPlannerEventsOptions = TranslateOptions & {
    action: string | number;
    length: string | number;
};

export type OverviewDeletingTitleOptions = TranslateOptions & {
    title: string | number;
};

export type OverviewDueByOptions = TranslateOptions & {
    date: string | number;
};

export type OverviewFilteredAmountOptions = TranslateOptions & {
    lengthOne: string | number;
    lengthTwo: string | number;
};

export type OverviewLoadedLocationsOptions = TranslateOptions & {
    numLoaded: string | number;
    numLocations: string | number;
};

export type OverviewSavingForTitleOptions = TranslateOptions & {
    title: string | number;
};

export type PaymentsEmailsAmountDueOptions = TranslateOptions & {
    amountDue: string | number;
};

export type PaymentsEmailsAttemptedPaymentDateOptions = TranslateOptions & {
    attemptedPaymentDate: string | number;
};

export type PaymentsEmailsDueDateOptions = TranslateOptions & {
    dueDate: string | number;
};

export type PaymentsEmailsFailedSubjectLineOptions = TranslateOptions & {
    locationName: string | number;
};

export type PaymentsEmailsInvoiceDescriptionOptions = TranslateOptions & {
    invoiceDescription: string | number;
};

export type PaymentsEmailsInvoiceNumberOptions = TranslateOptions & {
    invoiceNumber: string | number;
};

export type PaymentsEmailsPaymentFailedForLocationOptions = TranslateOptions & {
    locationName: string | number;
};

export type PaymentsEmailsReportFailedSubjectLineOptions = TranslateOptions & {
    numFailedLocations: string | number;
};

export type PaymentsEmailsReportFailedSubjectLinePluralOptions = TranslateOptions & {
    numFailedLocations: string | number;
};

export type PaymentsEmailsReportPaymentFailedForLocationsOptions = TranslateOptions & {
    numFailedLocations: string | number;
};

export type PaymentsEmailsReportPaymentFailedForLocationsPluralOptions = TranslateOptions & {
    numFailedLocations: string | number;
};

export type PaymentsEmailsReportPaymentFailureReasonOptions = TranslateOptions & {
    issue: string | number;
};

export type PaymentsEmailsRetryWeWillAttemptToChargeAgainOptions = TranslateOptions & {
    nextDate: string | number;
};

export type PaymentsEmailsRolloverWeWillAddOutstandingAmountToNextPaymentOptions = TranslateOptions & {
    nextDate: string | number;
};

export type PaymentsEmailsSubscriptionAmountOptions = TranslateOptions & {
    subscriptionAmount: string | number;
};

export type PaymentsSignUpAgencyWelcomesYouOptions = TranslateOptions & {
    agencyName: string | number;
};

export type PaymentsSignUpAmountPerMonthOptions = TranslateOptions & {
    amount: string | number;
};

export type PaymentsSignUpFirstBillingDateIsOptions = TranslateOptions & {
    firstBillingDate: string | number;
};

export type PaymentsStripeEmailsAuthRequestUserRequestedYouToAuthOptions = TranslateOptions & {
    firstName: string | number;
    lastName: string | number;
    agency: string | number;
};

export type PlanActivitiesChannelsChannelForActivityOptions = TranslateOptions & {
    activity: string | number;
};

export type PlanAgencyToBuildSpecificOptions = TranslateOptions & {
    agencyName: string | number;
};

export type PlanAgencyToBuildTooltipOptions = TranslateOptions & {
    agencyName: string | number;
};

export type PlanCampaignsActionsArchiveMessageOptions = TranslateOptions & {
     title : string | number;
};

export type PlanCampaignsActionsUnarchiveMessageOptions = TranslateOptions & {
     title : string | number;
};

export type PlanCampaignsCampaignRenamedToOptions = TranslateOptions & {
     newName : string | number;
};

export type PlanCampaignsCampaignsListNumDaysOptions = TranslateOptions & {
    num: string | number;
};

export type PlanCampaignsCreatedNewCampaignOptions = TranslateOptions & {
    title: string | number;
};

export type PlanCampaignsDeploysDeployCampaignToLocationOptions = TranslateOptions & {
     location : string | number;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmEventsPerLocationOptions = TranslateOptions & {
    num: string | number;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientOptions = TranslateOptions & {
    num: string | number;
    client: string | number;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientSingularOptions = TranslateOptions & {
    num: string | number;
    client: string | number;
};

export type PlanCampaignsDeploysDeploymentHistoryStatusScheduledHelpOptions = TranslateOptions & {
     startDate : string | number;
};

export type PlanEventConfirmDeleteOptions = TranslateOptions & {
    plannerTitle: string | number;
};

export type PlanEventDateOfMonthExampleOptions = TranslateOptions & {
    dateInMonth: string | number;
};

export type PlanEventDateOfMonthInYearExampleOptions = TranslateOptions & {
    dateInMonth: string | number;
};

export type PlanEventDateOfWeekExampleOptions = TranslateOptions & {
    weekInMonth: string | number;
    dayOfWeek: string | number;
};

export type PlanEventDateOfWeekInYearExampleOptions = TranslateOptions & {
    weekInMonth: string | number;
    dayOfWeek: string | number;
};

export type PlanEventDeletionAlertOptions = TranslateOptions & {
    platformLabel: string | number;
};

export type PlanEventInstructionsToManagerOptions = TranslateOptions & {
    manager: string | number;
};

export type PlanEventRequiredInfoOptions = TranslateOptions & {
    days: string | number;
};

export type PlanEventSupportNoteOptions = TranslateOptions & {
    supportedDateThreshold: string | number;
};

export type PlanEventSupportRequestedOptions = TranslateOptions & {
    manager: string | number;
};

export type PlanMultipleLocationsSavingForTitleOptions = TranslateOptions & {
    title: string | number;
};

export type PlanNotifyPlannerCreatedOptions = TranslateOptions & {
    planner: string | number;
};

export type PlanNotifyPlannerCreatedPartialOptions = TranslateOptions & {
    planner: string | number;
};

export type PlanNotifyPlannerUpdatedOptions = TranslateOptions & {
    planner: string | number;
};

export type ProfileMinimumImageDimensionRequirementOptions = TranslateOptions & {
    width: string | number;
    height: string | number;
};

export type ReportAllMonetaryFiguresAreInCurrencyOptions = TranslateOptions & {
     currencyCode : string | number;
};

export type ReportConversionsPlatformNotConfiguredForLocationOptions = TranslateOptions & {
    location: string | number;
    platform: string | number;
};

export type ReportEmailCampaignsClicksOptions = TranslateOptions & {
    clicks: string | number;
};

export type ReportEmailCampaignsErrorCouldNotBeRetrievedOptions = TranslateOptions & {
    count: number;
};

export type ReportEmailCampaignsNumberRecipientsOptions = TranslateOptions & {
    recipients: string | number;
};

export type ReportEmailCampaignsOpensOptions = TranslateOptions & {
    opens: string | number;
};

export type ReportEmailCampaignsRecipientsOptions = TranslateOptions & {
    recipients: string | number;
};

export type ReportEmailCampaignsSendingOnOptions = TranslateOptions & {
    date: string | number;
};

export type ReportEmailCampaignsSentToOptions = TranslateOptions & {
    date: string | number;
};

export type ReportFacebookAudienceInsightsOnlineFollowersHelpDaysOptions = TranslateOptions & {
    timezone: string | number;
};

export type ReportFacebookAudienceInsightsOnlineFollowersHelpHoursOptions = TranslateOptions & {
    timezone: string | number;
};

export type ReportFacebookLikesReportPeriodAgoOptions = TranslateOptions & {
    period: string | number;
};

export type ReportGeneratedReportPrintFooterOptions = TranslateOptions & {
     formattedDate : string | number;
};

export type ReportGoogleAdsAdNameTooltipNumDescriptionOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdsAdNameTooltipNumDescriptionPluralOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdsAdNameTooltipNumHeadlineOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdsAdNameTooltipNumHeadlinePluralOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdsAdNameTooltipNumUrlOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdsAdNameTooltipNumUrlPluralOptions = TranslateOptions & {
    count: number;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestExtraStepsMayBeRequiredOptions = TranslateOptions & {
     recommendedSpendPerDay : string | number;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestIncreaseMyGoogleAdwordsBudgetOptions = TranslateOptions & {
     adjustedSpendPerDay : string | number;
     location : string | number;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestUserHasRequestedAnAdjustmentToAdwordsSpendOptions = TranslateOptions & {
     firstName : string | number;
     lastName : string | number;
};

export type ReportGoogleMyBusinessRecentPostsPostClicksOptions = TranslateOptions & {
     clicks : string | number;
};

export type ReportGoogleMyBusinessRecentPostsPostViewsOptions = TranslateOptions & {
     views : string | number;
};

export type ReportGoogleMyBusinessTopQuestionsAnswersOptions = TranslateOptions & {
     answers : string | number;
};

export type ReportGoogleMyBusinessTopQuestionsQuestionsOptions = TranslateOptions & {
     questions : string | number;
};

export type ReportGoogleMyBusinessTopQuestionsUpvotesOptions = TranslateOptions & {
     upvotes : string | number;
};

export type ReportGoogleMyBusinessTopReviewsRepliedAtOptions = TranslateOptions & {
     formattedDateString : string | number;
};

export type ReportGoogleMyBusinessTopReviewsReviewsOptions = TranslateOptions & {
     reviews : string | number;
};

export type ReportInstagramAudienceInsightsOnlineFollowersHelpDaysOptions = TranslateOptions & {
    timezone: string | number;
};

export type ReportInstagramAudienceInsightsOnlineFollowersHelpHoursOptions = TranslateOptions & {
    timezone: string | number;
};

export type ReportMoreRowsOptions = TranslateOptions & {
    count: number;
};

export type ReportMoreRowsPluralOptions = TranslateOptions & {
    count: number;
};

export type ReportNotConnectedPart1Options = TranslateOptions & {
    platform: string | number;
    location: string | number;
};

export type ReportNotConnectedPart2Options = TranslateOptions & {
    platform: string | number;
};

export type ReportPaidImpressionsOptions = TranslateOptions & {
    amount: string | number;
};

export type ReportPaidUniqueViewsOptions = TranslateOptions & {
    amount: string | number;
};

export type ReportReportLoadedLocationsOptions = TranslateOptions & {
    channelName: string | number;
    numLoaded: string | number;
    count: number;
};

export type ReportReportLoadedLocationsPluralOptions = TranslateOptions & {
    channelName: string | number;
    numLoaded: string | number;
    count: number;
};

export type ReportShowTopNOptions = TranslateOptions & {
    count: number;
};

export type ReportTemplateUseByLocationOptions = TranslateOptions & {
    formattedDateRange: string | number;
};

export type ReportTemplateUsesOptions = TranslateOptions & {
    count: number;
};

export type ReportTemplateUsesPluralOptions = TranslateOptions & {
    count: number;
};

export type ReportTotalImpressionsOptions = TranslateOptions & {
    amount: string | number;
};

export type ReportTotalReachVsTotalPaidOptions = TranslateOptions & {
    amount: string | number;
    paidAmount: string | number;
};

export type ReportTotalUniqueViewsOptions = TranslateOptions & {
    amount: string | number;
};

export type RequestsAlreadyPaidDifferenceOptions = TranslateOptions & {
    difference: string | number;
};

export type RequestsEmailsAddedNewSpecialRequestOptions = TranslateOptions & {
    id: string | number;
    title: string | number;
};

export type RequestsEmailsAddedRequestIsDueByOptions = TranslateOptions & {
    dueByDate: string | number;
};

export type RequestsEmailsCommentAddedSpecialRequestHasBeenUpdatedOptions = TranslateOptions & {
    id: string | number;
    title: string | number;
};

export type RequestsEmailsCommentAddedSubjectLineOptions = TranslateOptions & {
    id: string | number;
    title: string | number;
};

export type RequestsPaymentOptions = TranslateOptions & {
    amount: string | number;
};

export type RequestsPaymentOverpaidOptions = TranslateOptions & {
    amount: string | number;
};

export type RequestsPreviousQuoteDifferenceOptions = TranslateOptions & {
    difference: string | number;
};

export type ScheduleEmailsFailedToNotifyContentOptions = TranslateOptions & {
    platform: string | number;
};

export type ScheduleEmailsFailedToNotifyHeading1Options = TranslateOptions & {
    platform: string | number;
};

export type ScheduleEmailsFailedToNotifySubjectLineOptions = TranslateOptions & {
    platform: string | number;
};

export type ScheduleEmailsNoDevicesContent1Options = TranslateOptions & {
    platform: string | number;
};

export type SchedulePageDialogsDeleteOptionForMultipleOptions = TranslateOptions & {
    location: string | number;
    num: string | number;
};

export type SchedulePageDialogsDeleteOptionForSingleOptions = TranslateOptions & {
    location: string | number;
};

export type SchedulePageDialogsEditCaptionContactingPlatformOptions = TranslateOptions & {
    platform: string | number;
};

export type SchedulePageDialogsEditCaptionOptionForMultipleOptions = TranslateOptions & {
    location: string | number;
    num: string | number;
};

export type SchedulePageDialogsEditCaptionOptionForSingleOptions = TranslateOptions & {
    location: string | number;
};

export type SchedulePageDialogsRescheduleDeletedOptions = TranslateOptions & {
    platform: string | number;
};

export type SchedulePageDialogsRescheduleOptionForMultipleOptions = TranslateOptions & {
    location: string | number;
    num: string | number;
};

export type SchedulePageDialogsRescheduleOptionForSingleOptions = TranslateOptions & {
    location: string | number;
};

export type SchedulePageTableNoScheduledPostsFoundForPlatformOptions = TranslateOptions & {
    platform: string | number;
};

export type SchedulePostsPostDetailsSmsOptions = TranslateOptions & {
    platform: string | number;
    postUrl: string | number;
};

export type SchedulePostsPostImmediatelyOptions = TranslateOptions & {
    platform: string | number;
    location: string | number;
};

export type SchedulePostsPostScheduledForOptions = TranslateOptions & {
    platform: string | number;
    scheduledTime: string | number;
    location: string | number;
};

export type SchedulePostsSmsDownloadMessageOptions = TranslateOptions & {
    platform: string | number;
    downloadLink: string | number;
};

export type SchedulePushNotificationsTimeToPostOptions = TranslateOptions & {
    platform: string | number;
};

export type ShoppingCartCheckoutAddressOptions = TranslateOptions & {
    shippingLineOne: string | number;
    shippingLineTwo: string | number;
    shippingLineThree: string | number;
};

export type ShoppingCartCheckoutLocationsOptions = TranslateOptions & {
    quantity: string | number;
};

export type ShoppingCartCheckoutPayAmountOptions = TranslateOptions & {
    amount: string | number;
};

export type ShoppingCartCheckoutQuantityOptions = TranslateOptions & {
    quantity: string | number;
};

export type ShoppingCartEmailsDateOptions = TranslateOptions & {
    dateTime: string | number;
};

export type ShoppingCartEmailsOrderNumberOptions = TranslateOptions & {
    orderNumber: string | number;
};

export type ShoppingCartEmailsPrintOrderForProviderAgencyOptions = TranslateOptions & {
    agency: string | number;
};

export type ShoppingCartEmailsPrintOrderForProviderClientOptions = TranslateOptions & {
    client: string | number;
};

export type ShoppingCartEmailsPrintOrderForProviderContactEmailOptions = TranslateOptions & {
    email: string | number;
};

export type ShoppingCartEmailsPrintOrderForProviderOrderReceivedOptions = TranslateOptions & {
    client: string | number;
    firstName: string | number;
    lastName: string | number;
};

export type ShoppingCartEmailsPrintOrderForProviderSubjectLineOptions = TranslateOptions & {
    client: string | number;
    firstName: string | number;
    lastName: string | number;
    orderNumber: string | number;
};

export type ShoppingCartEmailsPrintOrderForUserOrderReceivedOptions = TranslateOptions & {
    orderNumber: string | number;
    businessName: string | number;
};

export type ShoppingCartEmailsPrintOrderForUserPrintProviderOptions = TranslateOptions & {
    businessName: string | number;
};

export type ShoppingCartEmailsPrintOrderForUserPrintProviderEmailOptions = TranslateOptions & {
    email: string | number;
};

export type ShoppingCartEmailsPrintOrderForUserSubjectLineOptions = TranslateOptions & {
    orderNumber: string | number;
    businessName: string | number;
};

export type StatsEmailsAccessTokenErrorAccessErrorForOptions = TranslateOptions & {
    serviceName: string | number;
    targetName: string | number;
};

export type StatsEmailsAccessTokenErrorAuthorizeServiceOptions = TranslateOptions & {
    serviceName: string | number;
};

export type StatsEmailsAccessTokenErrorIfAccessToIsNoLongerRequiredOptions = TranslateOptions & {
    serviceName: string | number;
};

export type StatsEmailsAccessTokenErrorSubjectLineOptions = TranslateOptions & {
    serviceName: string | number;
    targetName: string | number;
};

export type StatsEmailsAccessTokenErrorTryLoggingInAndReAuthorizingOptions = TranslateOptions & {
    serviceName: string | number;
    targetName: string | number;
};

export type StatsEmailsAccessTokenErrorWeHadAProblemTryingToAccessOptions = TranslateOptions & {
    serviceName: string | number;
};

export type UserBulkDeleteModalHasErrorsMessageOptions = TranslateOptions & {
     errorCount : string | number;
};

export type UserBulkDeleteModalMessagePluralOptions = TranslateOptions & {
    count: number;
};

export type UserBulkResetPasswordsModalConfirmResendInviteOptions = TranslateOptions & {
     userCount : string | number;
};

export type UserBulkResetPasswordsModalConfirmSendPasswordResetOptions = TranslateOptions & {
     userCount : string | number;
};

export type UserBulkResetPasswordsModalFetchUserErrorMessageOptions = TranslateOptions & {
     errorCount : string | number;
};

export type UserBulkResetPasswordsModalUsersWithoutAcceptedInviteMessageOptions = TranslateOptions & {
     userCount : string | number;
};

export type UserBulkUpdateLocationsModalAddLocationsCountTextOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateLocationsModalConfirmTextOptions = TranslateOptions & {
     userCount : string | number;
};

export type UserBulkUpdateLocationsModalHasErrorsMessageOptions = TranslateOptions & {
     errorCount : string | number;
};

export type UserBulkUpdateLocationsModalRemoveLocationsCountTextOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalAddRolesCountTextOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalAddRolesCountTextPluralOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalConfirmTextOptions = TranslateOptions & {
     userCount : string | number;
};

export type UserBulkUpdateRolesModalExistingTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalHasErrorsMessageOptions = TranslateOptions & {
     errorCount : string | number;
};

export type UserBulkUpdateRolesModalNewTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalRemoveRolesCountTextOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalRemoveRolesCountTextPluralOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalRemovedTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserBulkUpdateRolesModalSelectedRolesListTitleOptions = TranslateOptions & {
    count: number;
};

export type UserUsersLocationsBoxExistingLocationsTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserUsersLocationsBoxNewLocationsTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserUsersLocationsBoxRemovedLocationsTitleOptions = TranslateOptions & {
     count : string | number;
};

export type UserUsersLocationsBoxRightTitleOptions = TranslateOptions & {
     count : string | number;
};

export type NoParamsKeys =
    "ACCOUNT.ACCOUNT_ALREADY_EXISTS" |
    "ACCOUNT.CREATE_ACCOUNT" |
    "ACCOUNT.DETAILS.ACCOUNT_DETAILS_UPDATED" |
    "ACCOUNT.DETAILS.ADDRESS_LINE_ONE" |
    "ACCOUNT.DETAILS.ADDRESS_LINE_THREE" |
    "ACCOUNT.DETAILS.ADDRESS_LINE_TWO" |
    "ACCOUNT.DETAILS.ATTENTION_TO" |
    "ACCOUNT.DETAILS.BILLING_DETAILS" |
    "ACCOUNT.DETAILS.COMPANY_NAME" |
    "ACCOUNT.DETAILS.CONTACT_DETAILS" |
    "ACCOUNT.DETAILS.COUNTRY" |
    "ACCOUNT.DETAILS.DISPLAY_ADDRESS" |
    "ACCOUNT.DETAILS.FAILED_TO_UPDATE_ACCOUNT_DETAILS" |
    "ACCOUNT.DETAILS.LOCATION_DETAILS" |
    "ACCOUNT.DETAILS.LOCATION_DETAILS_SAVED" |
    "ACCOUNT.DETAILS.LOCATION_EMAIL" |
    "ACCOUNT.DETAILS.LOCATION_LOGO" |
    "ACCOUNT.DETAILS.LOCATION_PHONE_NUMBER" |
    "ACCOUNT.DETAILS.NOTES" |
    "ACCOUNT.DETAILS.PHONE" |
    "ACCOUNT.DETAILS.POSTCODE" |
    "ACCOUNT.DETAILS.PREFERRED_MEETING_TIMES" |
    "ACCOUNT.DETAILS.SAME_AS_CONTACT_DETAILS" |
    "ACCOUNT.DETAILS.SHIPPING_ADDRESS" |
    "ACCOUNT.DETAILS.SQUARE_ASPECT_RATIO_REQUIRED" |
    "ACCOUNT.DETAILS.STATE" |
    "ACCOUNT.DETAILS.SUBURB" |
    "ACCOUNT.DETAILS.WEBSITE_URL" |
    "ACCOUNT.LOCATION_DETAILS.CREATE_MAP_LOCATION" |
    "ACCOUNT.LOCATION_DETAILS.GET_LOCATION_DETAILS" |
    "ACCOUNT.LOCATION_DETAILS.REMOVE_LOCATION_MAP" |
    "ACCOUNT.LOCATION_DETAILS.SHIPPING_DETAILS_UPDATED" |
    "ACCOUNT.LOCATION_DETAILS.START_MAP_PAYMENT" |
    "ACCOUNT.LOCATION_DETAILS.UPDATE_LOCATION_DETAILS" |
    "ACCOUNT.LOCATION_DETAILS.UPDATE_SHIPPING_DETAILS" |
    "ACCOUNT.MAP.CONFIRM_PAYMENT_DETAILS" |
    "ACCOUNT.MAP.CREATE_NEW_MAP" |
    "ACCOUNT.MAP.EDIT_MAP" |
    "ACCOUNT.MAP.GET_MAP_SERVICE_COST" |
    "ACCOUNT.MAP.MAP_GENERATION_FAILED" |
    "ACCOUNT.MAP.MAP_GENERATION_INPROGRESS" |
    "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_1" |
    "ACCOUNT.MAP.PAYMENT_INFORMATION.PART_2" |
    "ACCOUNT.MAP.PROBLEM_RETRIEVING_COST" |
    "ACCOUNT.MAP.SEARCH_FOR_ADDRESS" |
    "ACCOUNT.NOTIFY_UNAUTHENTICATED" |
    "ACCOUNT.NOTIFY_UNAUTHORIZED" |
    "ADMIN.BANNER.BANNER_MESSAGE" |
    "ADMIN.BANNER.BANNER_NOTIFICATION" |
    "ADMIN.BANNER.CREATE_BANNER_NOTIFICATION" |
    "ADMIN.BANNER.DELETE_CURRENT_BANNER_NOTIFICATION" |
    "ADMIN.BANNER.DISMISSABLE" |
    "ADMIN.BANNER.GET_CURRENT_BANNER_NOTIFICATION" |
    "ADMIN.BANNER.NOTIFICATION_TYPE" |
    "ADMIN.BANNER.NOTIFY_CREATED" |
    "ADMIN.BANNER.NOTIFY_DELETED" |
    "ADMIN.BANNER.TIP" |
    "ADMIN.BRANDS.ASSIGN" |
    "ADMIN.BRANDS.ASSIGN_BRAND" |
    "ADMIN.BRANDS.ASSIGN_CLIENTS" |
    "ADMIN.BRANDS.BRAND" |
    "ADMIN.BRANDS.BRAND_COLOR" |
    "ADMIN.BRANDS.BRAND_NAME" |
    "ADMIN.BRANDS.BRANDS" |
    "ADMIN.BRANDS.CANNOT_ASSIGN_CLIENT_IF" |
    "ADMIN.BRANDS.FILTER_BRANDS" |
    "ADMIN.BRANDS.FILTER_CLIENTS" |
    "ADMIN.BRANDS.NEW_BRAND" |
    "ADMIN.BRANDS.PLEASE_ENTER_NAME_COLOR_LOGO" |
    "ADMIN.BRANDS.UPDATE_BRAND" |
    "ADMIN.BRANDS.UPLOAD_LOGO" |
    "ADMIN.BRANDS.YOU_CAN_ASSIGN_CLIENTS_FROM" |
    "ADMIN.CLUBREADY_CONNECT.ACTION" |
    "ADMIN.CLUBREADY_CONNECT.CHAIN_ID_CONFIGURATION_TITLE" |
    "ADMIN.CLUBREADY_CONNECT.CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT" |
    "ADMIN.CLUBREADY_CONNECT.CLIENT_TITLE" |
    "ADMIN.CLUBREADY_CONNECT.FILTER_CLIENTS" |
    "ADMIN.CLUBREADY_CONNECT.NO_INTEGRATION_FOUND_FOR_CLIENT" |
    "ADMIN.EXTERNAL_AUTH_APPS.API_KEY" |
    "ADMIN.EXTERNAL_AUTH_APPS.APP_NAME" |
    "ADMIN.EXTERNAL_AUTH_APPS.CONNECTIONS" |
    "ADMIN.EXTERNAL_AUTH_APPS.CONTACT_EMAIL" |
    "ADMIN.EXTERNAL_AUTH_APPS.CREATE_AUTH_APP" |
    "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP" |
    "ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP_DISCLAIMER" |
    "ADMIN.EXTERNAL_AUTH_APPS.DELETE_CONNECTION" |
    "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.DS_USER" |
    "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.EXTERNAL_USER_IDENTIFIER" |
    "ADMIN.EXTERNAL_AUTH_APPS.DETAILS.NO_APP_CONNECTIONS" |
    "ADMIN.EXTERNAL_AUTH_APPS.SECRET" |
    "ADMIN.EXTERNAL_AUTH_APPS.SECRET_EDIT_WARNING" |
    "ADMIN.EXTERNAL_AUTH_APPS.SECRET_TOOLTIP" |
    "ADMIN.EXTERNAL_AUTH_APPS.TITLE" |
    "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT" |
    "ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT_TOOLTIP" |
    "ADMIN.EXTERNAL_AUTH_APPS.UPDATE_AUTH_APP" |
    "ADMIN.MAINTENANCE.DATE" |
    "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME" |
    "ADMIN.MAINTENANCE.EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO" |
    "ADMIN.MAINTENANCE.MAINTENANCE_WINDOW" |
    "ADMIN.MAINTENANCE.MINUTES" |
    "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_REMOVED" |
    "ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_UPDATED" |
    "ADMIN.MAINTENANCE.REMOVE_MAINTENANCE_CONFIRM" |
    "ADMIN.MAINTENANCE.START_DATE_IS_REQUIRED" |
    "ADMIN.MAINTENANCE.START_DATE_MUST_BE_IN_THE_FUTURE" |
    "ADMIN.MAINTENANCE.START_TIME_MUST_BE_IN_THE_FUTURE" |
    "ADMIN.MAPS_REPORT.AMOUNT_PAID" |
    "ADMIN.MAPS_REPORT.CLIENT_NAME" |
    "ADMIN.MAPS_REPORT.HEADING" |
    "ADMIN.MAPS_REPORT.LOCATION_NAME" |
    "ADMIN.MAPS_REPORT.PURCHASED_DATE" |
    "ADMIN.NAV.AGENCIES" |
    "ADMIN.NAV.AUTHENTICATION_APPS" |
    "ADMIN.NAV.BANNER_NOTIFICATION" |
    "ADMIN.NAV.BRANDS" |
    "ADMIN.NAV.CALENDAR_ITEMS" |
    "ADMIN.NAV.CLUBREADY_CONNECT" |
    "ADMIN.NAV.MAPS_REPORT" |
    "ADMIN.NAV.PAYABLE_SERVICES" |
    "ADMIN.NAV.PLATFORMS" |
    "ADMIN.NAV.SERVICING" |
    "ADMIN.NAV.SITE_MAINTENANCE" |
    "ADMIN.NAV.SUBSCRIPTIONS" |
    "ADMIN.NAV.TASKS" |
    "ADMIN.NAV.TEMPLATE_PREVIEWS" |
    "ADMIN.NOTIFY_GENERATE_LOCATION_MAP_STARTED" |
    "ADMIN.NOTIFY_PURGE_SESSIONS_STARTED" |
    "ADMIN.NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED" |
    "ADMIN.NOTIFY_THUMBNAIL_GENERATION_STARTED" |
    "ADMIN.PAYABLE_SERVICE.COST_MUST_BE_POSITIVE" |
    "ADMIN.PAYABLE_SERVICE.CREATE_SERVICE_COST" |
    "ADMIN.PAYABLE_SERVICE.DELETE_SERVICE_COST" |
    "ADMIN.PAYABLE_SERVICE.NOTIFY_SERVICE_COSTS_UPDATED" |
    "ADMIN.PAYABLE_SERVICE.UPDATE_SERVICE_COST" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TITLE" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.SUBTITLE" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.UPDATED_AT" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.CONTENT" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.RETRY_NOW" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_FAILED" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_SUCCESSFUL" |
    "ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TITLE" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.SUBTITLE" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.FAILED_AT" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.CONTENT" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE" |
    "ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE" |
    "ADMIN.SUBSCRIPTIONS.CLIENT_SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION_UPDATED" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.CAN_BE_USED_TO_CANCEL" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.DATE_GAP" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.END_DATE_IS_EXCLUSIVE" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.FUTURE" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE_SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.LEAVE_IT_BLANK" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.LEGEND" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION_RECURRING" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.NEXT" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.NO_RECURRING_PAYMENTS" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.NOTIFY_RECURRING_PAYMENT_DELETED" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT_SCHEDULE" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.SAVE_RECURRING_PAYMENT" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.SUBSCRIPTION_UPDATED" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.THE_NEXT_DATE_IS_AFTER" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TEMP_DISCOUNT" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TO_SKIP_PAYMENT" |
    "ADMIN.SUBSCRIPTIONS.LOCATION.UPDATE_SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.NO_CLIENTS" |
    "ADMIN.SUBSCRIPTIONS.NO_LOCATIONS" |
    "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_DELETED" |
    "ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_SAVED" |
    "ADMIN.SUBSCRIPTIONS.NOTIFY_SUBSCRIPTION_UPDATED" |
    "ADMIN.SUBSCRIPTIONS.SUBSCRIPTION" |
    "ADMIN.SUBSCRIPTIONS.UPDATE_DEFAULT_SUBSCRIPTION" |
    "ADMIN.USERS.ADD_NEW_USER" |
    "AGENCIES.ADD_NEW_AGENCY" |
    "AGENCIES.AGENCY.DELETE_AGENCY" |
    "AGENCIES.AGENCY.EDIT_AGENCY" |
    "AGENCIES.AGENCY.WHITELABEL_LOGO" |
    "AGENCIES.AGENCY_CREATED" |
    "AGENCIES.AGENCY_NAME" |
    "AGENCIES.AGENCY_NAME_REQUIRED" |
    "AGENCIES.AGENCY_UPDATED" |
    "AGENCIES.USER.ADD_AGENCY_USER" |
    "AGENCIES.USER.ADMIN" |
    "AGENCIES.USER.EDIT_AGENCY_USER" |
    "AGENCIES.USER.EDIT_USER" |
    "AGENCIES.USER.NO_USERS_ASSIGNED" |
    "AGENCIES.USER.USER_UPDATED_SUCCESS_MESSAGE" |
    "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_BUTTON_LABEL" |
    "AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_MESSAGE" |
    "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED" |
    "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED_ERROR" |
    "AGENCY.CLIENT.ACTIVITIES.ACTIVITY_NAME_MUST_BE_UNIQUE" |
    "AGENCY.CLIENT.ACTIVITIES.ADD_ACTIVITY" |
    "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL" |
    "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM" |
    "AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL_ERROR" |
    "AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM_ERROR" |
    "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME" |
    "AGENCY.CLIENT.ACTIVITIES.PLATFORM_NAME" |
    "AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME_MUST_BE_UNIQUE" |
    "AGENCY.CLIENT.ACTIVITIES.CHANNEL_TYPE" |
    "AGENCY.CLIENT.ACTIVITIES.PLATFORM_TYPE" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_DESCRIPTION" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_ERROR" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_SUCCESS" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_DESCRIPTION" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_PLATFORM_DESCRIPTION" |
    "AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_ERROR" |
    "AGENCY.CLIENT.ACTIVITIES.LINKED_PLATFORM_OPTIONAL" |
    "AGENCY.CLIENT.ACTIVITIES.REFRESH_DATA" |
    "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_ACTIVITIES" |
    "AGENCY.CLIENT.ACTIVITIES.RETRIEVE_BUILDING_PLATFORMS" |
    "AGENCY.CLIENT.ACTIVITIES.SAVE_NEW_CHANNEL" |
    "AGENCY.CLIENT.ACTIVITIES.UPDATE_ACTIVITY_ORDER" |
    "AGENCY.CLIENT.BRAND_COLORS" |
    "AGENCY.CLIENT.BRAND_COLOURS.ADD_NEW_BRAND_COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.CREATE_NEW_BRAND_COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.DELETE_BRAND_COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.DELETED_BRAND_COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_COLOUR" |
    "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_ORDER" |
    "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR_ORDER" |
    "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.EDIT_CATEGORY" |
    "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT" |
    "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.NEW_CATEGORY" |
    "AGENCY.CLIENT.CONVERSION_AMOUNT" |
    "AGENCY.CLIENT.CONVERSION_AMOUNT_UPDATED" |
    "AGENCY.CLIENT.CONVERSION_WORTH" |
    "AGENCY.CLIENT.FILTER_CLIENTS" |
    "AGENCY.CLIENT.LINKS.ADD_NEW_LINK" |
    "AGENCY.CLIENT.LINKS.CREATE_NEW_LINK" |
    "AGENCY.CLIENT.LINKS.DELETE_LINK" |
    "AGENCY.CLIENT.LINKS.GET_LINKS" |
    "AGENCY.CLIENT.LINKS.LINK_PATTERN_REQUIREMENT" |
    "AGENCY.CLIENT.LINKS.TITLE" |
    "AGENCY.CLIENT.LINKS.UPDATE_ORDER" |
    "AGENCY.CLIENT.LINKS.URL" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_ADDED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_NAME" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_REMOVED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.ADD_NEW_ACTIVITY" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.CHANNELS" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_ADDED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_DELETED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_ADDED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_DELETED" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.DELETE_CHANNEL" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.MIGRATE" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.REPLACE_ALL" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.PLATFORM_LINK" |
    "AGENCY.CLIENT.LOCATION.ACTIVITIES.TYPE" |
    "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_BILLING_DETAILS_UPDATE_REQUEST" |
    "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_REQUEST" |
    "AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SIGNATORYS_EMAIL_ADDRESS" |
    "AGENCY.CLIENT.LOCATION.CATEGORIES.NOTIFY_UPDATED" |
    "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.ACTIONS" |
    "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.EDIT_FEATURED_TEMPLATE_SET" |
    "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.END_DATE" |
    "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.NEW_FEATURED_TEMPLATE_SET" |
    "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.START_DATE" |
    "AGENCY.CLIENT.LOCATION.FONTS.BOLD" |
    "AGENCY.CLIENT.LOCATION.FONTS.BY_CHOOSING_A_FONT" |
    "AGENCY.CLIENT.LOCATION.FONTS.CHOOSE_FONT" |
    "AGENCY.CLIENT.LOCATION.FONTS.CONDENSED" |
    "AGENCY.CLIENT.LOCATION.FONTS.CUSTOM" |
    "AGENCY.CLIENT.LOCATION.FONTS.DO_YOU_HAVE_PERMISSION" |
    "AGENCY.CLIENT.LOCATION.FONTS.EXPANDED" |
    "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_CONDENSED" |
    "AGENCY.CLIENT.LOCATION.FONTS.EXTRA_EXPANDED" |
    "AGENCY.CLIENT.LOCATION.FONTS.FONT_FAMILY" |
    "AGENCY.CLIENT.LOCATION.FONTS.FONTS_SAVED" |
    "AGENCY.CLIENT.LOCATION.FONTS.I_CONFIRM_I_HAVE_PERMISSION" |
    "AGENCY.CLIENT.LOCATION.FONTS.ITALIC" |
    "AGENCY.CLIENT.LOCATION.FONTS.LOCAL_FILE" |
    "AGENCY.CLIENT.LOCATION.FONTS.NO_FONTS" |
    "AGENCY.CLIENT.LOCATION.FONTS.NORMAL" |
    "AGENCY.CLIENT.LOCATION.FONTS.OBLIQUE" |
    "AGENCY.CLIENT.LOCATION.FONTS.SELECT_FONT" |
    "AGENCY.CLIENT.LOCATION.FONTS.SEMI_CONDENSED" |
    "AGENCY.CLIENT.LOCATION.FONTS.SEMI_EXPANDED" |
    "AGENCY.CLIENT.LOCATION.FONTS.STRETCH" |
    "AGENCY.CLIENT.LOCATION.FONTS.STYLE" |
    "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_CONDENSED" |
    "AGENCY.CLIENT.LOCATION.FONTS.ULTRA_EXPANDED" |
    "AGENCY.CLIENT.LOCATION.FONTS.WEIGHT" |
    "AGENCY.CLIENT.LOCATION.FONTS.YOU_HAVE_CONFIRMED" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SECTION" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.COULD_NOT_SAVE_LEARN_MENU" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.LEARN_MENU_SAVED" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.NEW_SUB_SECTION" |
    "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS" |
    "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DISPLAY_NAME_TOO_LONG" |
    "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.LOCATION_DETAILS" |
    "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.SUPPORTED_PLANNER_LIMIT" |
    "AGENCY.CLIENT.LOCATION.MANAGE.ADD_LOCATION" |
    "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_DESCRIPTION" |
    "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.ERROR_UPDATING_LOCATION" |
    "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_CLIENT_ID" |
    "AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_LOCATION_OR_ACCESS_FORBIDDEN" |
    "AGENCY.CLIENT.LOCATION.MANAGE.FILTER_LOCATIONS" |
    "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_NAME" |
    "AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_UPDATE_SUCCESS" |
    "AGENCY.CLIENT.LOCATION.MANAGE.PROPERTIES" |
    "AGENCY.CLIENT.LOCATION.MANAGE.PUBLIC_DETAILS" |
    "AGENCY.CLIENT.LOCATION.NAV.ACTIVITIES" |
    "AGENCY.CLIENT.LOCATION.NAV.AGENCY" |
    "AGENCY.CLIENT.LOCATION.NAV.BRAND_COLOURS" |
    "AGENCY.CLIENT.LOCATION.NAV.BUILDER_TEMPLATE_CATEGORIES" |
    "AGENCY.CLIENT.LOCATION.NAV.CLIENTS" |
    "AGENCY.CLIENT.LOCATION.NAV.FEATURED_TEMPLATE_SETS" |
    "AGENCY.CLIENT.LOCATION.NAV.FONTS" |
    "AGENCY.CLIENT.LOCATION.NAV.LEARN_MENU" |
    "AGENCY.CLIENT.LOCATION.NAV.LINKS" |
    "AGENCY.CLIENT.LOCATION.NAV.LOCATION_CATEGORIES" |
    "AGENCY.CLIENT.LOCATION.NAV.LOCATIONS" |
    "AGENCY.CLIENT.LOCATION.NAV.PLATFORMS" |
    "AGENCY.CLIENT.LOCATION.NAV.USERS" |
    "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETE_ERROR" |
    "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATE_ERROR" |
    "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATED" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.ADD_NEW_FIELD_GROUP" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_GROUP" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.FIELD_LABEL" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.GROUP_NAME" |
    "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.NEW_FIELD" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_HELP_TEXT" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_LABEL" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_NO_MATCHES" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_PLACEHOLDER" |
    "AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_SELECTED" |
    "AGENCY.CLIENT.LOCATION.USERS.ASSIGN_USER_TO_LOCATIONS" |
    "AGENCY.CLIENT.LOCATION.USERS.CURRENTLY_SELECTED" |
    "AGENCY.CLIENT.LOCATION.USERS.FAILED_TO_ADD_EXISTING_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.FILTER_FIRST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.FILTER_LAST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.FILTER_USERNAME" |
    "AGENCY.CLIENT.LOCATION.USERS.FIRST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.LAST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.LOCATIONS_UPDATED" |
    "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_ASSIGNED_TO_COMPANY" |
    "AGENCY.CLIENT.LOCATION.USERS.NO_USERS_FOUND" |
    "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.DELETE_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_FROM_LOCATION" |
    "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_MESSAGE" |
    "AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_TITLE" |
    "AGENCY.CLIENT.LOCATION.USERS.ROLES" |
    "AGENCY.CLIENT.LOCATION.USERS.SELECT_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST_TOOLTIP" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER_TOOLTIP" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CLIENTS" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CONNECT_TO_ACCESS" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_CLIENT_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_USER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EMAIL" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.FIRST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.LAST_NAME" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.MARKETING_UPDATES" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.NOTIFICATIONS" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PASSWORD" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER_TOOLTIP" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER_TOOLTIP" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ROLES" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER_TOOLTIP" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTS" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.TIMEZONE" |
    "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.UPDATE" |
    "AGENCY.CLIENT.LOCATION.USERS.USERNAME_EMAIL" |
    "AGENCY.CLIENT.LOCATION.USERS.USERS" |
    "AGENCY.CLIENT.LOCATION.USERS.USERS_EXISTING_LOCATIONS" |
    "AGENCY.CLIENT.LOCATION.USERS.YOUR_INVITE_HAS_BEEN_SENT" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_REGION_OR_GROUP" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_TO_GROUP" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_COLLECTION_PLACEHOLDER" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_COLLECTIONS" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_TEMPLATE_CATEGORIES" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.MISSING_COLLECTIONS_OR_CATEGORIES" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.GROUP" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.COLLECTIONS" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.NAME" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.TYPE" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_CATEGORIES" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_GROUP" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_REGION" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.NOTIFY_ENTER_LABEL_FOR_CATEGORY" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.RADIO_DISABLED_MESSAGE" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.REGION" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.SELECTED_LOCATIONS" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.GROUP_MESSAGE" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS" |
    "AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.REGION_MESSAGE" |
    "AGENCY.CLIENT.LOCATIONS.ADD_NEW_LOCATION" |
    "AGENCY.CLIENT.LOCATIONS.COUNTRY" |
    "AGENCY.CLIENT.LOCATIONS.COUNTRY_UPDATED" |
    "AGENCY.CLIENT.LOCATIONS.CURRENCY" |
    "AGENCY.CLIENT.LOCATIONS.CURRENCY_UPDATED" |
    "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT" |
    "AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED" |
    "AGENCY.CLIENT.LOCATIONS.DELETE_PERMANENTLY" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.ACTIVATE_YOUR_ENHANCED_PACKAGE" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BELOW_TO_UPDATE_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BUTTON_TO_COMPLETE_SIGN_UP" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.DEFAULT_EMAIL_SUBJECT" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.SIGN_UP" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.THESE_DETAILS_ALLOW_SPECIFIC_SERVICES" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WE_REQUIRE_CONFIRMATION_OF_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOU_NEED_TO_FILL_OUT_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOURE_INVITED" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.NEW_LOCATION_SIGNED_UP" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.VISIT_DIGITAL_STACK" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.CLICK_TO_UPDATE_BILLING_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.REQUEST_TO_UPDATE_BILLING_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.UPDATE_YOUR_BILLING_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS" |
    "AGENCY.CLIENT.LOCATIONS.ERROR_DELETING_CLIENT" |
    "AGENCY.CLIENT.LOCATIONS.HEADERS.YOUR_BRANDS" |
    "AGENCY.CLIENT.LOCATIONS.INVITATION_SENT" |
    "AGENCY.CLIENT.LOCATIONS.INVITE" |
    "AGENCY.CLIENT.LOCATIONS.LOCATION" |
    "AGENCY.CLIENT.LOCATIONS.LOCATION_ADDED" |
    "AGENCY.CLIENT.LOCATIONS.LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP" |
    "AGENCY.CLIENT.LOCATIONS.LOCATIONS" |
    "AGENCY.CLIENT.LOCATIONS.NO_LOCATION_GROUPS" |
    "AGENCY.CLIENT.LOCATIONS.REQUEST_UPDATE_BILLING_DETAILS_SENT" |
    "AGENCY.CLIENT.LOCATIONS.RESEND" |
    "AGENCY.CLIENT.LOCATIONS.SIGNED_UP" |
    "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_ACTIVE" |
    "AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_AMOUNT" |
    "AGENCY.CLIENT.LOCATIONS.TIMEZONE" |
    "AGENCY.CLIENT.LOCATIONS.UPDATE_BILLING_DETAILS" |
    "AGENCY.CLIENT.NOTIFICATION_EMAIL_ADDRESSES_UPDATED" |
    "AGENCY.CLIENT.NUMBER_OF_LOCATIONS" |
    "AGENCY.CLIENT.PLATFORMS.ALL" |
    "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS" |
    "AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES" |
    "AGENCY.CLIENT.PLATFORMS.CONFIGURE" |
    "AGENCY.CLIENT.PLATFORMS.DISABLE_PLATFORM" |
    "AGENCY.CLIENT.PLATFORMS.ENABLE_PLATFORM" |
    "AGENCY.CLIENT.PLATFORMS.ENABLED" |
    "AGENCY.CLIENT.PLATFORMS.FETCH_CLIENT_PLATFORMS" |
    "AGENCY.CLIENT.PLATFORMS.FILTER_BY_STATUS" |
    "AGENCY.CLIENT.PLATFORMS.FILTER_PLATFORMS" |
    "AGENCY.CLIENT.PLATFORMS.PLATFORM" |
    "AGENCY.CLIENT.PLATFORMS.REQUIRED" |
    "AGENCY.CLIENT.UPDATE_CONVERSION_DETAILS" |
    "AGENCY.CLIENT.UPDATE_NOTIFICATION_EMAIL_ADDRESSES" |
    "AGENCY.CLIENT.USERS.SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES" |
    "AGENCY.CLIENT.USERS.TITLE" |
    "AGENCY.CLIENTS.ADD_CLIENT.CHANNEL_LABEL" |
    "AGENCY.CLIENTS.ADD_CLIENT.CLIENT_ADDED" |
    "AGENCY.CLIENTS.ADD_CLIENT.GENERAL" |
    "AGENCY.CLIENTS.ADD_CLIENT.SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL" |
    "AGENCY.CLIENTS.ADD_CLIENT.SELF_SERVICE" |
    "AGENCY.CLIENTS.ADD_CLIENT.SUPPORTED" |
    "AGENCY.CLIENTS.ADD_NEW_CLIENT" |
    "AGENCY.CLIENTS.CLIENT_NAME" |
    "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.CLIENT_ACTIONS" |
    "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_DESCRIPTION" |
    "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.ENTER_NEW_NAME" |
    "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.RENAME" |
    "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.ACTIONS" |
    "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.AVG_BUILDS" |
    "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.NUM_LOCATIONS" |
    "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.PERCENTAGE_CONNECTED" |
    "AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.TITLE" |
    "AGENCY.CLIENTS.YOU_HAVE_NOT_ADDED_ANY" |
    "AGENCY.CONTACT_DETAILS.ADWORDS_MARKETING" |
    "AGENCY.CONTACT_DETAILS.AGENCY_CONTACT_DETAILS" |
    "AGENCY.CONTACT_DETAILS.CONTACT_DETAILS" |
    "AGENCY.CONTACT_DETAILS.SPECIAL_REQUEST_DISCLAIMER" |
    "AGENCY.CONTACT_DETAILS.UPDATE_CONTACTS" |
    "AGENCY.HASHTAG_SETS.ACTIONS.ADD_HASHTAG_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_CREATE_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_DELETE_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_UPDATE_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.CREATED_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.DELETED_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.UPDATED_SET" |
    "AGENCY.HASHTAG_SETS.ACTIONS.UPDATE_HASHTAG_SET" |
    "AGENCY.HASHTAG_SETS.DIALOG.MINIMUM_ONE" |
    "AGENCY.HASHTAG_SETS.DIALOG.REQUIRED_FOR_ALL_POSTS" |
    "AGENCY.HASHTAG_SETS.DIALOG.START_BY_TYPING_YOUR_HASHTAGS" |
    "AGENCY.HASHTAG_SETS.HASHTAG_SETS" |
    "AGENCY.HASHTAG_SETS.HASHTAGS" |
    "AGENCY.HASHTAG_SETS.TABLE_HEADERS.DESCRIPTION" |
    "AGENCY.HASHTAG_SETS.TABLE_HEADERS.NUMBER_HASHTAGS" |
    "AGENCY.HASHTAG_SETS.TABLE_HEADERS.TITLE" |
    "AGENCY.NOTIFICATIONS.AGENCY_EMAIL_NOTIFICATIONS" |
    "AGENCY.NOTIFICATIONS.AGENCY_NOTIFICATIONS" |
    "AGENCY.NOTIFICATIONS.CLICK_RATE" |
    "AGENCY.NOTIFICATIONS.CLICKS" |
    "AGENCY.NOTIFICATIONS.EMAIL_ADDRESS" |
    "AGENCY.NOTIFICATIONS.FAILED_TO_LOAD" |
    "AGENCY.NOTIFICATIONS.HELP_TEXT.CLICKS" |
    "AGENCY.NOTIFICATIONS.HELP_TEXT.SENT" |
    "AGENCY.NOTIFICATIONS.NEW_COMMENTS" |
    "AGENCY.NOTIFICATIONS.NEW_SPECIAL_REQUESTS" |
    "AGENCY.NOTIFICATIONS.NO_LINK_PROVIDED" |
    "AGENCY.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND" |
    "AGENCY.NOTIFICATIONS.NOTIFICATIONS_WILL_BE_SENT" |
    "AGENCY.NOTIFICATIONS.OPEN_LINK" |
    "AGENCY.NOTIFICATIONS.SEND_CONFIRM.TITLE" |
    "AGENCY.NOTIFICATIONS.SEND_NOTIFICATION" |
    "AGENCY.NOTIFICATIONS.SENDING_INFO.MOBILE" |
    "AGENCY.NOTIFICATIONS.SENDING_INFO.TITLE" |
    "AGENCY.NOTIFICATIONS.SENDING_INFO.WEBSITE" |
    "AGENCY.NOTIFICATIONS.SENT" |
    "AGENCY.NOTIFICATIONS.SENT_NOTIFICATIONS" |
    "AGENCY.NOTIFICATIONS.SUBJECT" |
    "AGENCY.PRINT_SKU_GROUPS.AGENCY_PRINT_PRODUCTS" |
    "AGENCY.PRINT_SKU_GROUPS.ATTACHED_PROVIDERS" |
    "AGENCY.PRINT_SKU_GROUPS.DEFAULT_CURRENCY" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ADD_NEW_PRINT_PROVIDER" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ATTACH_TO_SKU_GROUP" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.NO_AVAILABLE_CLIENTS" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PAYMENT_AUTH" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ADDED" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ATTACHED" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_DETACHED" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.SEND_AUTH_REQUEST" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDERS" |
    "AGENCY.PRINT_SKU_GROUPS.PRINT_SKU_GROUPS" |
    "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.ADD_NEW_QUANTITY_OPTION" |
    "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_ALREADY_EXISTS" |
    "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_OPTION_ADDED" |
    "AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTIONS" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.ADD_NEW_SKU" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.DELETE_SKU" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.EXCLUSIVE" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.FORMATS_APPLIED_TO" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.LINEAR_PRICING" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.SKU" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_ADDED" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETED" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_GROUP_MISSING" |
    "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_UPDATED" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ADD_NEW_SKU_GROUP" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP_TITLE" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ORDER_INFORMATION" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_GATEWAY" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_URL" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_ADDED" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETED" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DETAILS" |
    "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_UPDATED" |
    "AGENCY.PRINT_SKU_GROUPS.SKUS" |
    "AGENCY.SEND_REPORTS.ACTIONS.OPEN_REPORT" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.CLICKED" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.READ" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_LABEL" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_PLACEHOLDER" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_LABEL" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_PLACEHOLDER" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.SENT" |
    "AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.NO_RECIPIENTS_FOUND" |
    "AGENCY.SEND_REPORTS.REPORT.CLICKED_TITLE" |
    "AGENCY.SEND_REPORTS.REPORT.READ_TITLE" |
    "AGENCY.SEND_REPORTS.REPORT.SENT_TITLE" |
    "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_1" |
    "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_3" |
    "AGENCY.SEND_REPORTS.REPORT.SENT_TO_USERS_FILTERED_BY_TITLES" |
    "AGENCY.SEND_REPORTS.REPORT.TYPE_EMAIL_TOOLTIP" |
    "AGENCY.SEND_REPORTS.REPORT.TYPE_IN_APP_TOOLTIP" |
    "AGENCY.SEND_REPORTS.TITLE" |
    "AGENCY.USERS.CLIENT_USERS" |
    "AGENCY.USERS.INTERACTION_DELETE_USER" |
    "AGENCY.USERS.INTERACTION_GET_CLIENT_USERS" |
    "AGENCY.USERS.ONLY_SHOW_ORPHANS" |
    "APPS.ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR" |
    "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.MESSAGE" |
    "APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.TITLE" |
    "APPS.ADWORDS_CUSTOMER" |
    "APPS.ANALYTICS_PROFILE" |
    "APPS.AUTHORISE" |
    "APPS.AUTHORIZED_ACCOUNT" |
    "APPS.BUSINESS" |
    "APPS.CHECK_ACCESS_TO_GOOGLE_ADWORDS" |
    "APPS.CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION" |
    "APPS.COMPANY" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.HEADING" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.MESSAGE" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.SUBHEADING" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.HEADING" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.MESSAGE" |
    "APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.SUBHEADING" |
    "APPS.CONNECT_TO_NEW_ACCOUNT" |
    "APPS.DEAUTHORISE" |
    "APPS.DISCONNECT_ACCOUNT" |
    "APPS.EDIT_CONFIGURATION" |
    "APPS.ERRORS.INVALID_CONFIGURATION.EXPLAIN_ISSUE" |
    "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.ERRORS.MISSING_CONFIGURATION.EXPLAIN_ISSUE" |
    "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.ERRORS.MISSING_PERMISSIONS.EXPLAIN_ISSUE" |
    "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE" |
    "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.EXPLAIN_ISSUE" |
    "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.ERRORS.FACEBOOK_INVALID_SESSION.EXPLAIN_ISSUE" |
    "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.EXPLAIN_ISSUE" |
    "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CAN_CONFIGURE" |
    "APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CANT_CONFIGURE" |
    "APPS.FACEBOOK.PAGE_ID_AND_NAME_REQUIRED" |
    "APPS.FACEBOOK.PAGE_UPDATED" |
    "APPS.FACEBOOK_MARKETING.ACCOUNT_NAME" |
    "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_CLEARED" |
    "APPS.FACEBOOK_MARKETING.AD_ACCOUNT_SET" |
    "APPS.FACEBOOK_MARKETING.CHECK_AUTHORISATION" |
    "APPS.FACEBOOK_MARKETING.CHECK_CONFIG_ACCESS" |
    "APPS.FACEBOOK_MARKETING.FACEBOOK_AD_ACCOUNT" |
    "APPS.FACEBOOK_MARKETING.RETRIEVE_AD_ACCOUNTS" |
    "APPS.FACEBOOK_MARKETING.RETRIEVE_CONFIG" |
    "APPS.FACEBOOK_MARKETING.TITLE" |
    "APPS.FACEBOOK_MARKETING.UPDATE_AD_ACCOUNT" |
    "APPS.FACEBOOK_PAGE" |
    "APPS.FACEBOOK_PAGE_HELP" |
    "APPS.FACEBOOK_PAGE_NOT_AVAILABLE" |
    "APPS.FITWARE" |
    "APPS.FITWARE_CLUB" |
    "APPS.FITWARE_NOTE" |
    "APPS.FOUR51.COMPANY" |
    "APPS.FOUR51.COMPANY_UPDATED" |
    "APPS.FOUR51.CREDENTIALS_DELETED" |
    "APPS.FOUR51.CREDENTIALS_UPDATED" |
    "APPS.FOUR51.DELETE_CREDENTIALS_WARNING" |
    "APPS.FOUR51.INVALID_NEW_CREDENTIALS" |
    "APPS.FOUR51.SSO_KEY" |
    "APPS.FOUR51.STORE" |
    "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME" |
    "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE" |
    "APPS.GOOGLE_ADWORDS.CUSTOMER" |
    "APPS.GOOGLE_ADWORDS.MULTIPLE_CAMPAIGNS_FOUND" |
    "APPS.GOOGLE_ADWORDS.NO_CAMPAIGNS_FOUND" |
    "APPS.GOOGLE_ADWORDS_CAMPAIGN_NAME" |
    "APPS.GOOGLE_ADWORDS_CUSTOMER_CLEARED" |
    "APPS.GOOGLE_ADWORDS_CUSTOMER_SET" |
    "APPS.GOOGLE_ANALYTICS.PAGE_PATH" |
    "APPS.GOOGLE_ANALYTICS_PAGE_PATH" |
    "APPS.GOOGLE_MY_BUSINESS.ACCOUNT_NAME" |
    "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_ACCOUNT_NAMES" |
    "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE" |
    "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_LOCATION_NAMES" |
    "APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.UPDATING_CONFIG" |
    "APPS.GOOGLE_MY_BUSINESS.CONFIG_UPDATED" |
    "APPS.GOOGLE_MY_BUSINESS.LOCATION_NAME" |
    "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION" |
    "APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_TITLE" |
    "APPS.GOOGLE_MY_BUSINESS.NO_ADDRESS" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.DISABLED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.DISCONNECTED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.LOCAL_POST_API_DISABLED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.NEEDS_REVERIFICATION" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_PUBLISHED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.NOT_VERIFIED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_REVIEW" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_VERIFICATION" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.SUSPENDED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.TEMPORARILY_ENABLED" |
    "APPS.GOOGLE_MY_BUSINESS.STATES.VERIFIED" |
    "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED" |
    "APPS.INSTAGRAM.ACCOUNT_NOT_LISTED_EXPLANATION" |
    "APPS.INSTAGRAM.CONFIG_UPDATED_SUCCESS_MESSAGE" |
    "APPS.INSTAGRAM.CONNECTED_ACCOUNT" |
    "APPS.INSTAGRAM.FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS" |
    "APPS.INSTAGRAM.FETCHING_CAN_CONFIGURE" |
    "APPS.INSTAGRAM.UPDATE_CONFIG" |
    "APPS.LINK_TO_GOOGLE_ADWORDS" |
    "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE" |
    "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_PAGE_NAMES" |
    "APPS.LINKEDIN.ASYNC_DESCRIPTIONS.UPDATING_CONFIG" |
    "APPS.LINKEDIN.CONFIG_UPDATED" |
    "APPS.LINKEDIN.PAGE_NAME" |
    "APPS.LINKEDIN.PAGE_NOT_LISTED" |
    "APPS.LINKEDIN.PAGE_NOT_LISTED_EXPLANATION" |
    "APPS.MANUAL_ENTRY" |
    "APPS.NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME" |
    "APPS.NO_FACEBOOK_PAGE_ACCESS_HEADING" |
    "APPS.PAGE_ID" |
    "APPS.PAGE_NAME" |
    "APPS.PLEASE_SELECT_AN_ADWORDS_CUSTOMER" |
    "APPS.PRINT_PROVIDER" |
    "APPS.PROPERTY_ID" |
    "APPS.REFRESH_MATCHING_CAMPAIGNS" |
    "APPS.THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT" |
    "APPS.UPDATE_GOOGLE_ADWORDS_CUSTOMER" |
    "APPS.UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME" |
    "ASSET_LIBRARY.AUTOMATICALLY_EXPIRE_THESE_ASSETS" |
    "ASSET_LIBRARY.BIN" |
    "ASSET_LIBRARY.BIN_ASSETS" |
    "ASSET_LIBRARY.CHOOSE_COLLECTION" |
    "ASSET_LIBRARY.CHOOSE_COLLECTION_REQUEST" |
    "ASSET_LIBRARY.COPY_ASSET_URL" |
    "ASSET_LIBRARY.CREATE_FOLDER_MODAL_TITLE" |
    "ASSET_LIBRARY.DELETE_COLLECTION_NOTE" |
    "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_ALERT" |
    "ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_INFO" |
    "ASSET_LIBRARY.EDIT_FOLDER" |
    "ASSET_LIBRARY.EXPIRED_ASSETS" |
    "ASSET_LIBRARY.EXPLAIN" |
    "ASSET_LIBRARY.HIDE_BIN" |
    "ASSET_LIBRARY.LIST" |
    "ASSET_LIBRARY.NEW_FOLDER" |
    "ASSET_LIBRARY.NO_ASSETS_IN_FOLDER" |
    "ASSET_LIBRARY.NO_COLLECTIONS_FOUND" |
    "ASSET_LIBRARY.PLEASE_SELECT_COLLECTION" |
    "ASSET_LIBRARY.REMOVE_EXPIRATION_DATE" |
    "ASSET_LIBRARY.RESTORE" |
    "ASSET_LIBRARY.SEARCH_COLLECTIONS" |
    "ASSET_LIBRARY.SECURITY_WARNING" |
    "ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION" |
    "ASSET_LIBRARY.SELECTED_CLIENTS" |
    "ASSET_LIBRARY.SELECTED_LOCATIONS" |
    "ASSET_LIBRARY.SHARED_WITH" |
    "ASSET_LIBRARY.SHOW_BIN" |
    "ASSET_LIBRARY.THUMBNAIL" |
    "ASSET_LIBRARY.UNABLE_TO_LOAD" |
    "ASSET_LIBRARY.UPLOAD_ASSET" |
    "BUILD.ACTUAL" |
    "BUILD.ADDRESS_NOT_SET" |
    "BUILD.AGENCY_FILTERS.HIDE_MOBILE" |
    "BUILD.AGENCY_FILTERS.HIDE_PUBLISHED" |
    "BUILD.AGENCY_FILTERS.HIDE_UNPUBLISHED" |
    "BUILD.AGENCY_FILTERS.IS_MULTI_IMAGE" |
    "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS" |
    "BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS_BUTTON" |
    "BUILD.AGENCY_FILTERS.ONLY_MOBILE" |
    "BUILD.AGENCY_FILTERS.TITLE" |
    "BUILD.ALL_CLIENTS" |
    "BUILD.ALL_EDITABLE_ELEMENTS" |
    "BUILD.ALL_FORMATS" |
    "BUILD.ANIMATION.ADD_FRAME_AFTER" |
    "BUILD.ANIMATION.ADD_FRAME_BEFORE" |
    "BUILD.ANIMATION.ANIMATION" |
    "BUILD.ANIMATION.CONFIRM_DELETE_FRAME" |
    "BUILD.ANIMATION.DELETE_FRAME" |
    "BUILD.ANIMATION.DURATION" |
    "BUILD.ANIMATION.PLAY" |
    "BUILD.ANIMATION.STOP" |
    "BUILD.ANIMATION.TOGGLE_ANIMATION_CONFIRM" |
    "BUILD.AT_LEAST_ONE_FORMAT_REQUIRED" |
    "BUILD.BACK_TO_GALLERY" |
    "BUILD.BACKGROUND" |
    "BUILD.BLEND_MODE.COLOR" |
    "BUILD.BLEND_MODE.DIFFERENCE" |
    "BUILD.BLEND_MODE.HARD_LIGHT" |
    "BUILD.BLEND_MODE.HUE" |
    "BUILD.BLEND_MODE.MULTIPLY" |
    "BUILD.BLEND_MODE.NORMAL" |
    "BUILD.BLEND_MODE.OVERLAY" |
    "BUILD.BLEND_MODE.SATURATION" |
    "BUILD.BLEND_MODE.SCREEN" |
    "BUILD.BLEND_MODE.SOFT_LIGHT" |
    "BUILD.BUILDER_MODE.ADVANCED" |
    "BUILD.BUILDER_MODE.SIMPLE" |
    "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.TITLE" |
    "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.AFFECTED_LOCATIONS" |
    "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.DELETE_LOCATION_DRAFTS" |
    "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.KEEP_LOCATION_DRAFTS" |
    "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.TITLE" |
    "BUILD.CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR" |
    "BUILD.CHANNEL_DATA" |
    "BUILD.CMYK_COLOR_DISCLAIMER" |
    "BUILD.COLOR_PICKER.BLACK" |
    "BUILD.COLOR_PICKER.BLUE" |
    "BUILD.COLOR_PICKER.CMYK" |
    "BUILD.COLOR_PICKER.CMYK_HEADER" |
    "BUILD.COLOR_PICKER.CYAN" |
    "BUILD.COLOR_PICKER.GREEN" |
    "BUILD.COLOR_PICKER.HSL" |
    "BUILD.COLOR_PICKER.HUE" |
    "BUILD.COLOR_PICKER.LUM" |
    "BUILD.COLOR_PICKER.MAGENTA" |
    "BUILD.COLOR_PICKER.NAME" |
    "BUILD.COLOR_PICKER.OPACITY" |
    "BUILD.COLOR_PICKER.RED" |
    "BUILD.COLOR_PICKER.RGB" |
    "BUILD.COLOR_PICKER.RGB_HEADER" |
    "BUILD.COLOR_PICKER.SAT" |
    "BUILD.COLOR_PICKER.YELLOW" |
    "BUILD.COMPLETE" |
    "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE" |
    "BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE" |
    "BUILD.CUSTOM_IMAGE_REQUIRED" |
    "BUILD.CUSTOM_TEXT_REQUIRED" |
    "BUILD.DELETE_CONFIRMATION" |
    "BUILD.DELETE_TEMPLATE" |
    "BUILD.DESKTOP_VIEW" |
    "BUILD.DIMENSIONS" |
    "BUILD.DUPLICATE" |
    "BUILD.DUPLICATE_LAYER" |
    "BUILD.EDITABLE_ELEMENTS" |
    "BUILD.ELLIPSE" |
    "BUILD.EMAIL.AUTHORIZE_ON_APPS_PAGE" |
    "BUILD.EMAIL.BLACK_TEXT_EDITOR_BACKGROUND" |
    "BUILD.EMAIL.CANT_ADD_IMAGE_ELEMENT" |
    "BUILD.EMAIL.DEFAULT_INSTRUCTIONS" |
    "BUILD.EMAIL.EDIT_SOURCE" |
    "BUILD.EMAIL.EDIT_SOURCE_WARNING" |
    "BUILD.EMAIL.EMAIL_BUILDER" |
    "BUILD.EMAIL.EMAIL_PREVIEW" |
    "BUILD.EMAIL.FAILED_TO_PARSE_HTML" |
    "BUILD.EMAIL.FAILED_TO_PROCESS_ZIP_FILE" |
    "BUILD.EMAIL.FAILED_TO_READ_ZIP_FILE" |
    "BUILD.EMAIL.FAILED_TO_VALIDATE_ZIP_FILE" |
    "BUILD.EMAIL.IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING" |
    "BUILD.EMAIL.IMAGE_TIMEOUT" |
    "BUILD.EMAIL.LOCATION_NOT_AUTHORIZED" |
    "BUILD.EMAIL.MAIL_MERGE" |
    "BUILD.EMAIL.PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE" |
    "BUILD.EMAIL.SELECT_ZIP_FILE" |
    "BUILD.EMAIL.UPDATE_PLANNER_STATUS" |
    "BUILD.EMAIL.UPLOAD_ONLY_ONE_PREVIEW" |
    "BUILD.EMAIL.UPLOAD_ONLY_ONE_ZIP_FILE" |
    "BUILD.EMAIL.VISIBILITY" |
    "BUILD.EMAIL.VISIBLE" |
    "BUILD.EMAIL.ZIP_FILE" |
    "BUILD.EMAIL.ZIP_VALIDATION.HTML_MISSING" |
    "BUILD.EMAIL.ZIP_VALIDATION.HTML_MULTIPLE" |
    "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MISSING" |
    "BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MULTIPLE" |
    "BUILD.ERROR.FAILED_TO_CREATE_TAG" |
    "BUILD.ERROR.FAILED_TO_DELETE_TEMPLATE" |
    "BUILD.ERROR.FAILED_TO_GET_CLIENTS" |
    "BUILD.ERROR.FAILED_TO_GET_LOCATION" |
    "BUILD.ERROR.FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS" |
    "BUILD.ERROR.FAILED_TO_RETRIEVE_TEMPLATE" |
    "BUILD.ERROR.FAILED_TO_SAVE_TEMPLATE" |
    "BUILD.ERROR.FAILED_TO_UPLOAD_IMAGES" |
    "BUILD.ERROR.FAILED_TO_UPLOAD_THUMBNAIL" |
    "BUILD.FEATURED_TEMPLATE_SETS" |
    "BUILD.FETCHING_BUILDER_TEMPLATE_INFO" |
    "BUILD.FIRST_COMMENT" |
    "BUILD.FIT" |
    "BUILD.FONTS.ADD_FONT" |
    "BUILD.FONTS.CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT" |
    "BUILD.FONTS.CONTEXT_ACTIONS" |
    "BUILD.FONTS.CREATE_FONT_INSTRUCTIONS" |
    "BUILD.FONTS.ENTER_NEW_FONT_FAMILY" |
    "BUILD.FONTS.ERROR_LOADING_FONTS" |
    "BUILD.FONTS.ERRORS.COULD_NOT_DELETE_FONT" |
    "BUILD.FONTS.ERRORS.ERROR_RENAMING" |
    "BUILD.FONTS.ERRORS.ISSUE_UPLOADING_FONT" |
    "BUILD.FONTS.FILTER_FONTS" |
    "BUILD.FONTS.FONT_ACTIONS" |
    "BUILD.FONTS.FONT_DELETED" |
    "BUILD.FONTS.FONT_FAMILY" |
    "BUILD.FONTS.FONT_TYPE" |
    "BUILD.FONTS.FONT_UPLOADED" |
    "BUILD.FONTS.FONTS_MISSING" |
    "BUILD.FONTS.PLEASE_CONTACT_AGENCY_TO_FIX" |
    "BUILD.FONTS.RENAMED_FONT" |
    "BUILD.FONTS.SOME_FONTS_COULD_NOT_BE_LOADED" |
    "BUILD.FONTS.TEMPLATE_USES_MISSING_FONTS" |
    "BUILD.FOUR51.NO_ACCESS_MODAL_MESSAGE" |
    "BUILD.FOUR51.NO_ACCESS_MODAL_TITLE" |
    "BUILD.GALLERY" |
    "BUILD.HIDE_DETAILS" |
    "BUILD.IMAGE.UNSUPPORTED_FORMAT" |
    "BUILD.IMAGE_CHOOSER.CONFIRM_ACKNOWLEDGED" |
    "BUILD.IMAGE_CHOOSER.CONFIRM_PERMISSION" |
    "BUILD.IMAGE_CHOOSER.IMAGE_SOURCE" |
    "BUILD.IMAGE_CHOOSER.LOCAL_FILE" |
    "BUILD.IMAGE_CHOOSER.LOCATION_LOGO" |
    "BUILD.IMAGE_CHOOSER.MAX_UPLOAD_ERROR" |
    "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER" |
    "BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER_STRONG" |
    "BUILD.IMAGE_CHOOSER.PERMISSION_ERROR" |
    "BUILD.IMAGE_CHOOSER.SELECT_IMAGE" |
    "BUILD.IMAGE_CHOOSER.SELECT_IMAGE_FROM_YOUR_LIBRARY" |
    "BUILD.IMAGE_CHOOSER.SUGGESTED_COLLECTION" |
    "BUILD.IMAGE_CHOOSER.UPLOAD_IMAGE_FROM_YOUR_DEVICE" |
    "BUILD.IMAGE_CHOOSER.UPLOADED_ASSET_IMAGE" |
    "BUILD.IMAGE_CHOOSER.UPLOADED_PLANNER_IMAGE" |
    "BUILD.IMAGE_CROPPER.CLEAR" |
    "BUILD.IMAGE_CROPPER.CROP_IMAGE" |
    "BUILD.IMAGE_CROPPER.ROTATE" |
    "BUILD.IMAGE_CROPPER_PROMPT_MESSAGE" |
    "BUILD.IMAGE_FORMAT_NAME.JPG_LIMITED_FILE_SIZE" |
    "BUILD.IMAGE_MUST_BE_EDITABLE" |
    "BUILD.IMAGE_RESOLUTION_PICKER.CONFIRM_DPI" |
    "BUILD.IMAGE_RESOLUTION_PICKER.DPI" |
    "BUILD.IMAGE_RESOLUTION_PICKER.DPI_IS_REQUIRED" |
    "BUILD.IMAGE_RESOLUTION_PICKER.IMAGE_RESOLUTION" |
    "BUILD.IMAGE_SELECTED" |
    "BUILD.KEYBOARD_SHORTCUTS_REFERENCE" |
    "BUILD.KEYWORD_SEARCH" |
    "BUILD.LANDSCAPE" |
    "BUILD.LAYERS" |
    "BUILD.LEAVE_PAGE_PROMPT.CONFIRM" |
    "BUILD.LEAVE_PAGE_PROMPT.TITLE" |
    "BUILD.LOCATION_DETAILS_MISSING_MESSAGE" |
    "BUILD.LOCATION_DRAFT.CONFIRM_DELETE" |
    "BUILD.LOCATION_DRAFT.CONFIRM_DELETE_TITLE" |
    "BUILD.LOCATION_DRAFT.CREATED_LOCATION_DRAFT" |
    "BUILD.LOCATION_DRAFT.ENTER_NAME_FOR_NEW_TEMPLATE_REVISION" |
    "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_REVISION" |
    "BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_TEMPLATE_REVISION" |
    "BUILD.LOCATION_DRAFT.PLEASE_CONFIRM_LOCATION_REVISION_SAVE" |
    "BUILD.LOCATION_DRAFT.SAVE_AS_A_NEW_REVISION" |
    "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION" |
    "BUILD.LOCATION_DRAFT.TEMPLATE_HAS_DRAFT_TOOLTIP" |
    "BUILD.LOCATION_DRAFT.UPDATED_AT" |
    "BUILD.LOCATION_DRAFT.UPDATED_LOCATION_DRAFT" |
    "BUILD.LOCATION_EMAIL_NOT_SET" |
    "BUILD.LOOP_FOREVER" |
    "BUILD.LOOPING" |
    "BUILD.LOWERCASE" |
    "BUILD.MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP" |
    "BUILD.MAP.PIN" |
    "BUILD.MAXIMUM_FILE_SIZE_KB" |
    "BUILD.MEMBER_ENGAGER.ASSIGN_TO_MULTIPLE_LOCATIONS" |
    "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAIL" |
    "BUILD.MEMBER_ENGAGER.AUTOMATED_EMAILS" |
    "BUILD.MEMBER_ENGAGER.DIRECT_EMAIL_TITLE" |
    "BUILD.MEMBER_ENGAGER.EDIT_CONTENT" |
    "BUILD.MEMBER_ENGAGER.EDIT_SUBJECT" |
    "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAIL" |
    "BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAILS" |
    "BUILD.MEMBER_ENGAGER.FIND_NEW_TEMPLATE" |
    "BUILD.MEMBER_ENGAGER.NO_DIRECT_EMAIL_TEMPLATES_FOUND" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAIL" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_1" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_2" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_SCHEDULED_EMAIL_API_ERROR" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.NO_SCHEDULED_EMAILS" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.PREVIEW" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_ALREADY_DELETED" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_DELETED" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_NOT_FOUND" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.LISTS" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SCHEDULED" |
    "BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SUBJECT" |
    "BUILD.MEMBER_ENGAGER.TITLE" |
    "BUILD.METRICS.EM" |
    "BUILD.METRICS.POINTS" |
    "BUILD.METRICS.POINTS_SHORT" |
    "BUILD.MILLISECONDS_SHORT" |
    "BUILD.MOBILE_APP_TEMPLATE" |
    "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.ANIMATION_PRESENT" |
    "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.MAP_LAYER_PRESENT" |
    "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_BUILDER_TEMPLATE_FORMAT" |
    "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_DOCUMENT_FORMAT" |
    "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_EDITABLE_FIELDS" |
    "BUILD.MOBILE_INFO" |
    "BUILD.MOBILE_VIEW" |
    "BUILD.MOVE_DOWN" |
    "BUILD.MOVE_UP" |
    "BUILD.MULTI_IMAGE.MULTI_IMAGE" |
    "BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE" |
    "BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION" |
    "BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE" |
    "BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE" |
    "BUILD.MUST_VIEW_ALL_FRAMES" |
    "BUILD.MUST_VIEW_ALL_IMAGES" |
    "BUILD.MUST_VIEW_ALL_PAGES" |
    "BUILD.NEW_TEMPLATE" |
    "BUILD.NEW_TEMPLATE_EMAIL" |
    "BUILD.NEW_TEMPLATE_IMAGE" |
    "BUILD.NEW_TEMPLATE_PRINT" |
    "BUILD.NEW_TEMPLATE_VIDEO" |
    "BUILD.NO_CONTENT" |
    "BUILD.NOTIFY_TEXT_PLACEHOLDER_EXISTS" |
    "BUILD.OPTIMIZING_IMAGE" |
    "BUILD.ORIGINAL_TEMPLATE" |
    "BUILD.OVERLAYS.IMAGE_LAYER" |
    "BUILD.OVERLAYS.MAP_LAYER" |
    "BUILD.OVERLAYS.VIDEO_LAYER" |
    "BUILD.PHONE_NUMBER_NOT_SET" |
    "BUILD.PLACEHOLDER" |
    "BUILD.PLACEHOLDERS" |
    "BUILD.PLANNER_DETAILS" |
    "BUILD.PLATFORM" |
    "BUILD.PORTRAIT" |
    "BUILD.POSITION_X" |
    "BUILD.POSITION_Y" |
    "BUILD.PREVIEW_IMAGE" |
    "BUILD.PRINT.ADD_PAGE_AFTER" |
    "BUILD.PRINT.ADD_PAGE_BEFORE" |
    "BUILD.PRINT.BLEED" |
    "BUILD.PRINT.CONFIRM_DELETE_PAGE" |
    "BUILD.PRINT.DELETE_PAGE" |
    "BUILD.PRINT.PAGE_NUMBER" |
    "BUILD.PRINT.SELECT_AT_LEAST_ONE_FORMAT" |
    "BUILD.PRINT.WHICH_PAGE_TO_COPY_LAYER_TO" |
    "BUILD.PROPERTIES" |
    "BUILD.PUBLISH.ALREADY_SCHEDULED" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.CAMPAIGN_NAME" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.CONFIRMATION_EMAIL_ADDRESS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_EMAIL" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_NAME" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.LISTS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_SEGMENTS_FOUND" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.NOTIFY_PUBLISH_SUCCESS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SEND" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SKIP" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.PUBLISH_TO_CAMPAIGN_MONITOR" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.RECIPIENTS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.REPLY_TO" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.SAVE_DRAFT" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEGMENTS" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.SEND" |
    "BUILD.PUBLISH.CAMPAIGN_MONITOR.SUBJECT" |
    "BUILD.PUBLISH.CLUB_READY.ACTIVE" |
    "BUILD.PUBLISH.CLUB_READY.ACTIVE_MEMBERS" |
    "BUILD.PUBLISH.CLUB_READY.ADDED_AT_ANY_TIME" |
    "BUILD.PUBLISH.CLUB_READY.ADDED_BETWEEN" |
    "BUILD.PUBLISH.CLUB_READY.AFTER" |
    "BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS" |
    "BUILD.PUBLISH.CLUB_READY.ALL_INACTIVE_MEMBERS" |
    "BUILD.PUBLISH.CLUB_READY.AT_LEAST_ONE_LIST_MUST_BE_SELECTED" |
    "BUILD.PUBLISH.CLUB_READY.BEFORE" |
    "BUILD.PUBLISH.CLUB_READY.CLUB" |
    "BUILD.PUBLISH.CLUB_READY.COOLED_OFF_PROSPECTS" |
    "BUILD.PUBLISH.CLUB_READY.CUSTOM" |
    "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_PLACEHOLDER" |
    "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES" |
    "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING" |
    "BUILD.PUBLISH.CLUB_READY.DISABLED_PUBLISH_HELP_TEXT" |
    "BUILD.PUBLISH.CLUB_READY.DUPLICATE_EMAILS" |
    "BUILD.PUBLISH.CLUB_READY.EMAIL_LIST_MUST_HAVE_VALUES" |
    "BUILD.PUBLISH.CLUB_READY.EMAIL_SUBJECT_AND_SCHEDULE" |
    "BUILD.PUBLISH.CLUB_READY.EXPORT_INFO" |
    "BUILD.PUBLISH.CLUB_READY.EXPORT_TITLE" |
    "BUILD.PUBLISH.CLUB_READY.FILTERED" |
    "BUILD.PUBLISH.CLUB_READY.I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT" |
    "BUILD.PUBLISH.CLUB_READY.INACTIVE" |
    "BUILD.PUBLISH.CLUB_READY.INACTIVE_MEMBERS" |
    "BUILD.PUBLISH.CLUB_READY.INVALID" |
    "BUILD.PUBLISH.CLUB_READY.MEMBER_LIST_NOTICE" |
    "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS" |
    "BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION" |
    "BUILD.PUBLISH.CLUB_READY.NOT_INTERESTED" |
    "BUILD.PUBLISH.CLUB_READY.ONE_OR_MORE_LISTS_DISABLED_MESSAGE" |
    "BUILD.PUBLISH.CLUB_READY.OPTOUT" |
    "BUILD.PUBLISH.CLUB_READY.PASTE_EMAIL_ADDRESSES_BELOW" |
    "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_FAILED" |
    "BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_SENT" |
    "BUILD.PUBLISH.CLUB_READY.PROSPECTS" |
    "BUILD.PUBLISH.CLUB_READY.PROSPECTS_PAST_30_DAYS" |
    "BUILD.PUBLISH.CLUB_READY.PUBLISH_DELAY_WARNING_MESSAGE" |
    "BUILD.PUBLISH.CLUB_READY.REFETCH_VERIFY" |
    "BUILD.PUBLISH.CLUB_READY.SELECT_YOUR_CLUB_READY_LISTS" |
    "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_SUMMARY" |
    "BUILD.PUBLISH.CLUB_READY.SELECTED_MEMBERS_AND_OR_PROSPECTS" |
    "BUILD.PUBLISH.CLUB_READY.SEND_A_TEST_EMAIL" |
    "BUILD.PUBLISH.CLUB_READY.SEND_TO" |
    "BUILD.PUBLISH.CLUB_READY.SEND_TO_CLUB_READY_LIST" |
    "BUILD.PUBLISH.CLUB_READY.SEND_TO_INFO" |
    "BUILD.PUBLISH.CLUB_READY.SENDER" |
    "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_TOOLTIP" |
    "BUILD.PUBLISH.CLUB_READY.SENDER_VERIFIED_TOOLTIP" |
    "BUILD.PUBLISH.CLUB_READY.SUBJECT" |
    "BUILD.PUBLISH.CLUB_READY.SUPPRESSED_LIST_INFO" |
    "BUILD.PUBLISH.CLUB_READY.TOTAL" |
    "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION" |
    "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION" |
    "BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION" |
    "BUILD.PUBLISH.CLUB_READY.WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL" |
    "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER" |
    "BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE" |
    "BUILD.PUBLISH.CONGRATULATIONS" |
    "BUILD.PUBLISH.CURRENTLY_SELECTED" |
    "BUILD.PUBLISH.DOWNLOAD_TO_YOUR_COMPUTER" |
    "BUILD.PUBLISH.EXPORT_OPTIONS" |
    "BUILD.PUBLISH.FACEBOOK.ACCESS_CHECK_FAILURE" |
    "BUILD.PUBLISH.FACEBOOK.CAPTION" |
    "BUILD.PUBLISH.FACEBOOK.CAPTION_HELP_TEXT" |
    "BUILD.PUBLISH.FACEBOOK.FACEBOOK_PAGE" |
    "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_CAPTION" |
    "BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_FIRST_COMMENT" |
    "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_DETAILS" |
    "BUILD.PUBLISH.FACEBOOK.HEADERS.POST_SCHEDULE" |
    "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN" |
    "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" |
    "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" |
    "BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.HASHTAGS" |
    "BUILD.PUBLISH.FACEBOOK.PUBLISH_TO_FACEBOOK" |
    "BUILD.PUBLISH.FACEBOOK.PUBLISH_VIDEO_TO_FACEBOOK" |
    "BUILD.PUBLISH.FACEBOOK.SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE" |
    "BUILD.PUBLISH.FACEBOOK.SUGGESTED_CAPTION" |
    "BUILD.PUBLISH.FETCH_FILE_SIZE_OPTIONS" |
    "BUILD.PUBLISH.FINAL_CONFIRMATION" |
    "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD" |
    "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY" |
    "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT" |
    "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_DESCRIPTION" |
    "BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_TITLE" |
    "BUILD.PUBLISH.FITWARE.CONFIRM_DECLARATION" |
    "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_HELP_TEXT" |
    "BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_LABEL" |
    "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL" |
    "BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL_HELP_TEXT" |
    "BUILD.PUBLISH.FITWARE.MEMBER_LISTS" |
    "BUILD.PUBLISH.FITWARE.MEMBER_LISTS_FAILED_TO_LOAD" |
    "BUILD.PUBLISH.FITWARE.NO_MEMBER_LISTS_FOUND" |
    "BUILD.PUBLISH.FITWARE.PLATFORMS_HEADING" |
    "BUILD.PUBLISH.FITWARE.PREVIEW" |
    "BUILD.PUBLISH.FITWARE.PREVIEW_EMAIL_ADDRESS" |
    "BUILD.PUBLISH.FITWARE.PREVIEW_SEND" |
    "BUILD.PUBLISH.FITWARE.PREVIEW_SKIP" |
    "BUILD.PUBLISH.FITWARE.PUBLISH_TO_FITWARE" |
    "BUILD.PUBLISH.FITWARE.RETURN_TO_MEMBER_ENGAGER" |
    "BUILD.PUBLISH.FITWARE.SCHEDULED_TIME" |
    "BUILD.PUBLISH.FITWARE.SEND" |
    "BUILD.PUBLISH.FITWARE.SENDER" |
    "BUILD.PUBLISH.FITWARE.SENDER_plural" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.AUTOMATED_EMAIL_CATEGORY" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.MEMBER_LISTS" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.PUBLISHING" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.SCHEDULED_TIME" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.SEND_PREVIEW" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUBJECT" |
    "BUILD.PUBLISH.FITWARE.STEP_TITLES.SUMMARY" |
    "BUILD.PUBLISH.FITWARE.SUBJECT" |
    "BUILD.PUBLISH.GO_BACK_CONFIRM_MESSAGE" |
    "BUILD.PUBLISH.GO_BACK_CONFIRM_TITLE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.ACCESS_CHECK_FAILURE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUSINESS_LOCATION" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_LINK" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.BOOK" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.CALL" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.LEARN_MORE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.ORDER" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SHOP" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SIGN_UP" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CALL_TO_ACTION" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_DESCRIPTION" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_TITLE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_CODE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_DESCRIPTION" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_LINK" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_TITLE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_BODY" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPE" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.EVENT" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.OFFER" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.PRODUCT" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.STANDARD" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.PUBLISH_TO_GOOGLE_MY_BUSINESS" |
    "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.TERMS_AND_CONDITIONS" |
    "BUILD.PUBLISH.HASHTAGS.CLIENT_HASHTAGS" |
    "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_LENGTH" |
    "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_SET" |
    "BUILD.PUBLISH.HASHTAGS.HASHTAG_SET_ALREADY_ADDED" |
    "BUILD.PUBLISH.HASHTAGS.LOCATION_HASHTAGS" |
    "BUILD.PUBLISH.HASHTAGS.NO_HASHTAG_SETS" |
    "BUILD.PUBLISH.HASHTAGS.USE_HASHTAG_SETS" |
    "BUILD.PUBLISH.IMAGE_FORMAT" |
    "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS" |
    "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER" |
    "BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_HELP" |
    "BUILD.PUBLISH.INSTAGRAM.ACCESS_CHECK_FAILURE" |
    "BUILD.PUBLISH.INSTAGRAM.APP_NOT_INSTALLED" |
    "BUILD.PUBLISH.INSTAGRAM.APP_NOTIFICATIONS_DISABLED" |
    "BUILD.PUBLISH.INSTAGRAM.APP_SETUP_PROPERLY" |
    "BUILD.PUBLISH.INSTAGRAM.APP_USER_REQUIRED" |
    "BUILD.PUBLISH.INSTAGRAM.AS_THE_FIRST_COMMENT_ON_THE_POST" |
    "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_STORY_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_VIDEO_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.ASSIGN_USER_TO_POST" |
    "BUILD.PUBLISH.INSTAGRAM.AT_THE_BOTTOM_ON_THE_POST_CAPTION" |
    "BUILD.PUBLISH.INSTAGRAM.CAPTION" |
    "BUILD.PUBLISH.INSTAGRAM.CAPTION_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.ENTER_VALID_MOBILE_NUMBER" |
    "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_CAPTION" |
    "BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_FIRST_COMMENT" |
    "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_DETAILS" |
    "BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_SCHEDULE" |
    "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN" |
    "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" |
    "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" |
    "BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.HASHTAGS" |
    "BUILD.PUBLISH.INSTAGRAM.INSTAGRAM_PAGE" |
    "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_HEIGHT_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_WIDTH_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.MISSING_PERMISSIONS_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER" |
    "BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER_INFO" |
    "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_FOR_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_SCHEDULE" |
    "BUILD.PUBLISH.INSTAGRAM.POSTS_FROM_MOBILE_HINT" |
    "BUILD.PUBLISH.INSTAGRAM.PUBLISH_VIDEO_TO_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.PUBLISH_IMAGE_TO_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.PUBLISH_STORY_TO_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIDEO_VIA_API" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_IMAGE_VIA_API" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_STORY_VIA_API" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM_STORY" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_NOTIFICATION_FOR_INSTAGRAM" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIA_MOBILE_APP" |
    "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE" |
    "BUILD.PUBLISH.INSTAGRAM.SEARCH_FOR_USER" |
    "BUILD.PUBLISH.INSTAGRAM.SELECT_RELEVANT_COUNTRY_CODE" |
    "BUILD.PUBLISH.INSTAGRAM.SEND_POST_DETAILS" |
    "BUILD.PUBLISH.INSTAGRAM.SEND_SMS_AS_WELL" |
    "BUILD.PUBLISH.INSTAGRAM.STORY_MULTI_IMAGE_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.STORY_VIDEO_DURATION_HELP_TEXT" |
    "BUILD.PUBLISH.INSTAGRAM.SUGGESTED_CAPTION" |
    "BUILD.PUBLISH.INSTAGRAM.VIDEO_DURATION_HELP_TEXT" |
    "BUILD.PUBLISH.LINKEDIN.ACCESS_CHECK_FAILURE" |
    "BUILD.PUBLISH.LINKEDIN.CAPTION" |
    "BUILD.PUBLISH.LINKEDIN.CAPTION_HELP_TEXT" |
    "BUILD.PUBLISH.LINKEDIN.LINKEDIN_PAGE" |
    "BUILD.PUBLISH.LINKEDIN.PUBLISH_TO_LINKEDIN" |
    "BUILD.PUBLISH.LOCAL.PUBLISH_VIDEO_TO_LOCAL" |
    "BUILD.PUBLISH.MAILCHIMP.CAMPAIGN_NAME" |
    "BUILD.PUBLISH.MAILCHIMP.CONFIRMATION_EMAIL_ADDRESS" |
    "BUILD.PUBLISH.MAILCHIMP.FROM_EMAIL" |
    "BUILD.PUBLISH.MAILCHIMP.FROM_NAME" |
    "BUILD.PUBLISH.MAILCHIMP.LISTS" |
    "BUILD.PUBLISH.MAILCHIMP.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS" |
    "BUILD.PUBLISH.MAILCHIMP.NO_SEGMENTS_FOUND" |
    "BUILD.PUBLISH.MAILCHIMP.PREVIEW" |
    "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SEND" |
    "BUILD.PUBLISH.MAILCHIMP.PREVIEW_SKIP" |
    "BUILD.PUBLISH.MAILCHIMP.PUBLISH_TO_MAILCHIMP" |
    "BUILD.PUBLISH.MAILCHIMP.RECIPIENT" |
    "BUILD.PUBLISH.MAILCHIMP.REPLY_TO" |
    "BUILD.PUBLISH.MAILCHIMP.SAVE_DRAFT" |
    "BUILD.PUBLISH.MAILCHIMP.SCHEDULING_UNAVAILABLE" |
    "BUILD.PUBLISH.MAILCHIMP.SEGMENTS" |
    "BUILD.PUBLISH.MAILCHIMP.SEND" |
    "BUILD.PUBLISH.MAILCHIMP.SUBJECT" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.CURRENTLY_PUBLISHING" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_1" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_2" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_3" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHING_TO_THESE_LOCATIONS" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.REFRESH_LOCATIONS" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_PUBLISH" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.TOTAL_PUBLISHING_PROGRESS" |
    "BUILD.PUBLISH.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_VIDEO" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_IMAGE" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_CAPTION" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_FIRST_COMMENT" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_DETAILS" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_SCHEDULE" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.HASHTAGS" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM" |
    "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM" |
    "BUILD.PUBLISH.NO_PLATFORM_SELECTED" |
    "BUILD.PUBLISH.NO_PLATFORMS_AVAILABLE" |
    "BUILD.PUBLISH.NO_THANKS" |
    "BUILD.PUBLISH.NO_THANKS_IM_DONE" |
    "BUILD.PUBLISH.ONCE_AUTHORIZED_HELP" |
    "BUILD.PUBLISH.ORIGINAL_SIZE" |
    "BUILD.PUBLISH.PRINT.ARTWORK_REVIEW_SUGGESTED" |
    "BUILD.PUBLISH.PRINT.BEGIN_PAYMENT" |
    "BUILD.PUBLISH.PRINT.CAN_ONLY_SEND_TO_PRINT_PROVIDER" |
    "BUILD.PUBLISH.PRINT.CONFIRM_ARTWORK_REVIEW" |
    "BUILD.PUBLISH.PRINT.HOLD_UP" |
    "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE" |
    "BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION" |
    "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER" |
    "BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER_FOR_SKU" |
    "BUILD.PUBLISH.PRINT.PAYMENT" |
    "BUILD.PUBLISH.PRINT.PAYMENT_DUE" |
    "BUILD.PUBLISH.PRINT.PRINT_PROVIDER" |
    "BUILD.PUBLISH.PRINT.PRINT_REQUEST_DETAILS" |
    "BUILD.PUBLISH.PRINT.REPLY_EMAIL" |
    "BUILD.PUBLISH.PRINT.REPLY_EMAIL_SUBHEADING" |
    "BUILD.PUBLISH.PRINT.REQUEST_DETAILS_IS_MISSING_DATA" |
    "BUILD.PUBLISH.PRINT.REVIEW_ARTWORK_BEFORE_SENDING" |
    "BUILD.PUBLISH.PRINT.REVIEW_CONFIRMATION" |
    "BUILD.PUBLISH.PRINT.REVIEW_DOCUMENT" |
    "BUILD.PUBLISH.PRINT.SAVE_AS_LOCATION_PRINT_PROVIDER" |
    "BUILD.PUBLISH.PRINT.SELECT_PRINT_PROVIDER" |
    "BUILD.PUBLISH.PRINT.SEND_AND_COMPLETE_PAYMENT" |
    "BUILD.PUBLISH.PRINT.SEND_ORDER" |
    "BUILD.PUBLISH.PRINT.SEND_TO_PRINT_PROVIDER" |
    "BUILD.PUBLISH.PRINT.SENDING_ARTWORK" |
    "BUILD.PUBLISH.PRINT.SUCCESSFULLY_SENT" |
    "BUILD.PUBLISH.PRINT.YOUR_PRINT_PROVIDER" |
    "BUILD.PUBLISH.PUBLISH" |
    "BUILD.PUBLISH.PUBLISH_IMMEDIATELY" |
    "BUILD.PUBLISH.PUBLISH_VIDEO_ACTION" |
    "BUILD.PUBLISH.PUBLISHED" |
    "BUILD.PUBLISH.PUBLISHED_TO_SOME_LOCATIONS" |
    "BUILD.PUBLISH.PUBLISHING_FAILED" |
    "BUILD.PUBLISH.REFRESH_PLATFORMS" |
    "BUILD.PUBLISH.RELATIVE_TO_LOCATION" |
    "BUILD.PUBLISH.RESCHEDULE.NEW_TIME" |
    "BUILD.PUBLISH.RESCHEDULE.RESCHEDULE_ITEM" |
    "BUILD.PUBLISH.SCHEDULE_FOR_LATER" |
    "BUILD.PUBLISH.SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE" |
    "BUILD.PUBLISH.SCHEDULED_POST_TIME_PICKER_WARNING" |
    "BUILD.PUBLISH.SEND_IMMEDIATELY" |
    "BUILD.PUBLISH.TERMS_AND_CONDITIONS_HELP_TEXT" |
    "BUILD.PUBLISH.TWITTER.ACCESS_CHECK_FAILURE" |
    "BUILD.PUBLISH.TWITTER.CANNOT_STOP_SCHEDULED_POST" |
    "BUILD.PUBLISH.TWITTER.PUBLISH_TO_TWITTER" |
    "BUILD.PUBLISH.TWITTER.TWEET" |
    "BUILD.PUBLISH.UPLOADING" |
    "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM" |
    "BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN" |
    "BUILD.PUBLISH.YES_PLEASE" |
    "BUILD.PUBLISH.YES_PLEASE_BUT_DIFFERENT_TEMPLATE" |
    "BUILD.PUBLISH.YES_PLEASE_BUT_LATER" |
    "BUILD.PUBLISH_TO_MULTIPLE_LOCATIONS" |
    "BUILD.PUBLISHING_FAILED" |
    "BUILD.RECENTLY_ADDED" |
    "BUILD.RECTANGLE" |
    "BUILD.REPETITIONS" |
    "BUILD.REQUEST_SUPPORT" |
    "BUILD.RETURN_TO_BUILDER" |
    "BUILD.SAVING_TEMPLATE" |
    "BUILD.SCHEDULED_TIME" |
    "BUILD.SELECT_PREVIEW_IMAGE" |
    "BUILD.SEPARATE_TAGS_WITH_SPACES" |
    "BUILD.SHOW_DETAILS" |
    "BUILD.SHOW_OLD_EMAIL_TEMPLATES" |
    "BUILD.SUMMARY_HIDDEN_MESSAGE" |
    "BUILD.TEMPLATE" |
    "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED" |
    "BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED_TOOLTIP" |
    "BUILD.TEMPLATE_ADMIN.COPY_ERROR" |
    "BUILD.TEMPLATE_ADMIN.COPY_NO_CLIENTS" |
    "BUILD.TEMPLATE_ADMIN.COPY_TO" |
    "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE" |
    "BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE_SUCCESS" |
    "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE" |
    "BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE_SUCCESS" |
    "BUILD.TEMPLATE_ADMIN.EDIT_ATTRIBUTES" |
    "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES" |
    "BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP" |
    "BUILD.TEMPLATE_ADMIN.MANAGE_BUILDABLE_TEMPLATE" |
    "BUILD.TEMPLATE_ADMIN.TEMPLATE_UPDATED" |
    "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED" |
    "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS" |
    "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED" |
    "BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS" |
    "BUILD.TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT" |
    "BUILD.TEMPLATE_DELETED" |
    "BUILD.TEMPLATE_GALLERY" |
    "BUILD.TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED" |
    "BUILD.TEMPLATE_SAVED" |
    "BUILD.TEXT_ALIGNMENT_HORIZONTAL.CENTER" |
    "BUILD.TEXT_ALIGNMENT_HORIZONTAL.JUSTIFY" |
    "BUILD.TEXT_ALIGNMENT_HORIZONTAL.LEFT" |
    "BUILD.TEXT_ALIGNMENT_HORIZONTAL.RIGHT" |
    "BUILD.TEXT_ALIGNMENT_VERTICAL.BOTTOM" |
    "BUILD.TEXT_ALIGNMENT_VERTICAL.CENTER" |
    "BUILD.TEXT_ALIGNMENT_VERTICAL.TOP" |
    "BUILD.TEXT_CLIPPING" |
    "BUILD.TEXT_FORMATTING_WORKAROUND" |
    "BUILD.TEXT_LINE_HEIGHT_FIX" |
    "BUILD.TEXT_MUST_BE_EDITABLE" |
    "BUILD.TIME_UNITS_AGO.DAY_AGO" |
    "BUILD.TIME_UNITS_AGO.DAY_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.HOUR_AGO" |
    "BUILD.TIME_UNITS_AGO.HOUR_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.MINUTE_AGO" |
    "BUILD.TIME_UNITS_AGO.MINUTE_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.MONTH_AGO" |
    "BUILD.TIME_UNITS_AGO.MONTH_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.SECOND_AGO" |
    "BUILD.TIME_UNITS_AGO.SECOND_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.WEEK_AGO" |
    "BUILD.TIME_UNITS_AGO.WEEK_AGO_plural" |
    "BUILD.TIME_UNITS_AGO.YEAR_AGO" |
    "BUILD.TIME_UNITS_AGO.YEAR_AGO_plural" |
    "BUILD.TOGGLE_UNPUBLISHED" |
    "BUILD.TRANSFORM" |
    "BUILD.UNPUBLISHED_INFO" |
    "BUILD.UNPUBLISHED_TEMPLATE" |
    "BUILD.UNPUBLISHED_TEMPLATE_PUBLISH_WARNING" |
    "BUILD.UPDATE_TEMPLATE" |
    "BUILD.UPPERCASE" |
    "BUILD.VIDEO.CHECKING_ACCESS" |
    "BUILD.VIDEO.DOWNLOAD_VIDEO" |
    "BUILD.VIDEO.FAILED_TO_PUBLISH_VIDEO" |
    "BUILD.VIDEO.FINALIZING_VIDEO" |
    "BUILD.VIDEO.NETWORK_ERROR" |
    "BUILD.VIDEO.NO_VIDEO_LAYERS" |
    "BUILD.VIDEO.NO_VIDEO_UPLOADED" |
    "BUILD.VIDEO.PLEASE_WAIT" |
    "BUILD.VIDEO.PREPARING_VIDEO" |
    "BUILD.VIDEO.PROCESSING_VIDEO" |
    "BUILD.VIDEO.PROCESSING_TIME_DISCLAIMER" |
    "BUILD.VIDEO.PUBLISHING_FAILED_MESSAGE" |
    "BUILD.VIDEO.READY_TO_DOWNLOAD" |
    "BUILD.VIDEO.REMOVE_AUDIO" |
    "BUILD.VIDEO.RENDERING_VIDEO" |
    "BUILD.VIDEO.RETY_WITHOUT_AUDIO" |
    "BUILD.VIDEO.UNSUPPORTED_FORMAT" |
    "BUILD.VIDEO.UPLOADING" |
    "BUILD.VIDEO.VIDEO_IS_READY" |
    "BUILD.VIDEO.VIDEO_IS_READY_TO_DOWNLOAD" |
    "BUILD.VIDEO_CHOOSER.CONFIRM_ACKNOWLEDGED" |
    "BUILD.VIDEO_CHOOSER.CONFIRM_PERMISSION" |
    "BUILD.VIDEO_CHOOSER.LOCAL_FILE" |
    "BUILD.VIDEO_CHOOSER.MAX_UPLOAD_ERROR" |
    "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER" |
    "BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER_STRONG" |
    "BUILD.VIDEO_CHOOSER.PERMISSION_ERROR" |
    "BUILD.VIDEO_CHOOSER.SELECT_VIDEO" |
    "BUILD.VIDEO_CHOOSER.SELECT_VIDEO_FROM_YOUR_LIBRARY" |
    "BUILD.VIDEO_CHOOSER.SUGGESTED_COLLECTION" |
    "BUILD.VIDEO_CHOOSER.UPLOAD_VIDEO_FROM_YOUR_DEVICE" |
    "BUILD.VIDEO_CHOOSER.UPLOADED_ASSET_VIDEO" |
    "BUILD.VIDEO_CHOOSER.UPLOADED_PLANNER_VIDEO" |
    "BUILD.VIDEO_CHOOSER.VIDEO_SOURCE" |
    "BUILD.WEBSITE_URL_NOT_SET" |
    "BUILD.YOU_ARE_CURRENTLY_BUILDING" |
    "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE" |
    "BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural" |
    "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT" |
    "BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.BUILT_ITEMS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.FACEBOOK_ADS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GOOGLE_ADS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GROUPS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LEADS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LOCATION" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.REGION" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.LABEL_FILTER_LOCATIONS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_GROUPS" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_LOCATIONS_FOUND" |
    "CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_REGION" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ADD_TEMPLATE_CATEGORY" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEMPLATE_CATEGORY" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEXT" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.EDIT_TEMPLATE_CATEGORY" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.CREATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.EMPTY_CATEGORY_LABEL" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.END_DATE_BEFORE_START_DATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_END_DATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_START_DATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.MODIFY" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.END_DATE_OPTIONAL" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.START_DATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.LABEL" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.CREATE" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.MODIFY" |
    "CLIENT.CLIENT_TEMPLATE_CATEGORIES.TITLE" |
    "CLIENT.CLIENT_USERS_LOCATION.ADD_USER" |
    "CLIENT.CLIENT_USERS_LOCATION.ASSIGN_USER_TO_LOCATIONS" |
    "CLIENT.CLIENT_USERS_LOCATION.BUTTONS.SEND_INVITE" |
    "CLIENT.CLIENT_USERS_LOCATION.CREATE_NEW_USER" |
    "CLIENT.CLIENT_USERS_LOCATION.DELETE_ORPHANED_USER" |
    "CLIENT.CLIENT_USERS_LOCATION.FILTER_USER_PLACEHOLDER" |
    "CLIENT.CLIENT_USERS_LOCATION.INVALID_EMAIL_HELPER_TEXT" |
    "CLIENT.CLIENT_USERS_LOCATION.INVITE_NEW_USER" |
    "CLIENT.CLIENT_USERS_LOCATION.INVITE_USER" |
    "CLIENT.CLIENT_USERS_LOCATION.LABELS.EMAIL_ADDRESS" |
    "CLIENT.CLIENT_USERS_LOCATION.LABELS.GIVE_ACCESS_TO" |
    "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_DETAILS" |
    "CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_ROLES" |
    "CLIENT.CLIENT_USERS_LOCATION.LOCATION_ACCESS" |
    "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USER_FOUND" |
    "CLIENT.CLIENT_USERS_LOCATION.MATCHING_USERS_FOUND" |
    "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.EMAIL_ADDRESS" |
    "CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.SELECT_ROLES" |
    "CLIENT.CLIENT_USERS_LOCATION.UPDATE_LOCATIONS" |
    "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.DELETE" |
    "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESEND_USER_INVITES" |
    "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESET_PASSWORD" |
    "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_LOCATIONS" |
    "CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_ROLES" |
    "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_PRIMARY" |
    "CLIENT.CLIENT_USERS_TABLE.MOBILE_TOOLTIP" |
    "CLIENT.CLIENT_USERS_TABLE.TITLE" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.EMAIL_ADDRESS" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.FIRST_NAME" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GENERAL_DETAILS" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GUIDED_TOUR" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LAST_NAME" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LOCATIONS_ACCESS" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.PREFERENCES" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.TITLE" |
    "CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.USER_ROLES" |
    "CLIENT.ENGAGEMENT_HELP_TEXT.ACTIVITY" |
    "CLIENT.ENGAGEMENT_HELP_TEXT.BUILT_ITEMS" |
    "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.DATA_NOT_IMPACTED_BY_DATE_SELECTION" |
    "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.REQUIRED_CONNECTIONS_EXPLANATION" |
    "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.TOTAL_CONNECTIONS_EXPLANATION" |
    "CLIENT.ERROR_STYLE_GUIDE_DELETE" |
    "CLIENT.ERROR_STYLE_GUIDE_REPLACE" |
    "CLIENT.ERROR_STYLE_GUIDE_UPLOAD" |
    "CLIENT.ERRORS.NO_CLIENT_ID" |
    "CLIENT.ERRORS.NO_CLIENT_SELECTED" |
    "CLIENT.ERRORS.NO_DATE_RANGE" |
    "CLIENT.ERRORS.UNEXPECTED_ERROR" |
    "CLIENT.LOCATION_ACTIVITY.HEADERS.ACTIVITY" |
    "CLIENT.LOCATION_ACTIVITY.HEADERS.BUILT_ITEMS" |
    "CLIENT.LOCATION_ACTIVITY.HEADERS.CONNECTIONS" |
    "CLIENT.LOCATION_ACTIVITY.HEADERS.MOST_ENGAGED_LOCATIONS" |
    "CLIENT.LOCATION_ACTIVITY.LABEL_BUILT_ITEMS_CUMULATIVE" |
    "CLIENT.LOCATION_ACTIVITY.LOCATIONS_ACTIVE" |
    "CLIENT.LOCATION_ACTIVITY.LOCATIONS_USING_MOBILE_APP" |
    "CLIENT.LOCATION_ACTIVITY.REQUIRED_PLATFORMS_CONNECTED" |
    "CLIENT.LOCATION_ACTIVITY.SORT_BUILT_ITEMS" |
    "CLIENT.LOCATION_ACTIVITY.SORT_LOCATION" |
    "CLIENT.LOCATION_ACTIVITY.SORT_TITLE" |
    "CLIENT.LOCATION_ACTIVITY.TEMPLATES_BUILT" |
    "CLIENT.LOCATION_ACTIVITY.TOTAL_PLATFORMS_CONNECTED" |
    "CLIENT.OVERVIEW.ERRORS.FAIL_TO_LOAD" |
    "CLIENT.OVERVIEW.HEADERS.TEMPLATE_CATEGORIES" |
    "CLIENT.OVERVIEW.HEADERS.TEMPLATES_BUILT" |
    "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.TITLE" |
    "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BODY" |
    "CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BUTTON" |
    "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.DIGITAL" |
    "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.EMAIL" |
    "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.PRINT" |
    "CLIENT.OVERVIEW.TEMPLATES_BUILT_BY_LOCATION_CATEGORY" |
    "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.AVERAGE_BUILT_ITEMS_PER_LOCATION" |
    "CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.ERRORS.FAIL_TO_LOAD" |
    "CLIENT.REGION_ACTIVITY.FILTER_NAME" |
    "CLIENT.REGION_ACTIVITY.HEADERS.BUILT_ITEMS" |
    "CLIENT.STYLE_GUIDE_PAGE_TITLE" |
    "CLIENT.SUCCESS_STYLE_GUIDE_DELETE" |
    "CLIENT.SUCCESS_STYLE_GUIDE_REPLACE" |
    "CLIENT.SUCCESS_STYLE_GUIDE_UPLOAD" |
    "COMMON.ACTIONS" |
    "COMMON.ACTIVE" |
    "COMMON.ADD" |
    "COMMON.ADD_NEW_TAG" |
    "COMMON.ADD_TAG" |
    "COMMON.ADDRESS" |
    "COMMON.ADMIN" |
    "COMMON.AFTER" |
    "COMMON.AGENCIES" |
    "COMMON.AGENCY" |
    "COMMON.ALL" |
    "COMMON.ALL_ASSETS" |
    "COMMON.ALL_LOCATIONS" |
    "COMMON.AMOUNT" |
    "COMMON.AND" |
    "COMMON.ANYBODY" |
    "COMMON.APPS" |
    "COMMON.ARE_YOU_SURE" |
    "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET" |
    "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION" |
    "COMMON.ASSET_COLLECTION" |
    "COMMON.ASSET_LIBRARY" |
    "COMMON.ASSIGNED_TO" |
    "COMMON.ATTACH" |
    "COMMON.ATTACH_FILE" |
    "COMMON.ATTACHMENTS" |
    "COMMON.BACK" |
    "COMMON.BETA" |
    "COMMON.BROWSE" |
    "COMMON.BUILD" |
    "COMMON.BUILT" |
    "COMMON.BUSINESS_NAME" |
    "COMMON.CANCEL" |
    "COMMON.CANCELLED_WHILE_IN_QUEUE" |
    "COMMON.CANCELLED_WHILE_PROCESSING" |
    "COMMON.CANNOT_FIND_ASSET" |
    "COMMON.CATEGORIES" |
    "COMMON.CATEGORY" |
    "COMMON.CHANGE" |
    "COMMON.CHANGES_SAVED" |
    "COMMON.CHANNEL" |
    "COMMON.CHANNELS" |
    "COMMON.CHECK_CONNECTION" |
    "COMMON.CLEAR" |
    "COMMON.CLIENT" |
    "COMMON.CLIENT_USED_MAX_COLLECTIONS" |
    "COMMON.CLIENTS" |
    "COMMON.CLOSE" |
    "COMMON.COLLECTION" |
    "COMMON.COLOUR" |
    "COMMON.COLUMNS" |
    "COMMON.COPY" |
    "COMMON.COMMENTS.ADD_COMMENT" |
    "COMMON.COMMENTS.ARE_YOU_SURE_DELETE_COMMENT" |
    "COMMON.COMMENTS.CANNOT_DELETE_COMMENTS" |
    "COMMON.COMMENTS.COMMENT" |
    "COMMON.COMMENTS.COMMENTS" |
    "COMMON.COMMENTS.COMMENTS_HEADING_DEFAULT" |
    "COMMON.COMMENTS.DELETE_COMMENT" |
    "COMMON.COMMENTS.ENTER_COMMENT" |
    "COMMON.COMMENTS.UNKNOWN_PARENT" |
    "COMMON.COMPANIES.LT_NETWORK" |
    "COMMON.CONFIRM" |
    "COMMON.CONFIRMATION" |
    "COMMON.CONNECT_PAGE.CONNECT_PAGE" |
    "COMMON.CONNECT_PAGE.FILTER.ACCOUNT_NAME" |
    "COMMON.CONNECT_PAGE.FILTER.CLEAR_LOCATION_ID" |
    "COMMON.CONNECT_PAGE.FILTER.CLIENT" |
    "COMMON.CONNECT_PAGE.FILTER.LOCATION" |
    "COMMON.CONNECT_PAGE.FILTER.PAGE_NAME" |
    "COMMON.CONNECT_PAGE.FILTER.STATUS" |
    "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECT" |
    "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECTED" |
    "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.ERROR" |
    "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.EXPIRED" |
    "COMMON.CONNECT_PAGE.STATUS_DROPDOWN.INCOMPLETE" |
    "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_MAPPING" |
    "COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_NAME" |
    "COMMON.CONNECTION_ISSUES" |
    "COMMON.CONTINUE" |
    "COMMON.COPIED_TO_CLIPBOARD_FAILED" |
    "COMMON.COSTS" |
    "COMMON.COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT" |
    "COMMON.COUNTRIES.AUSTRALIA" |
    "COMMON.COUNTRIES.AUSTRIA" |
    "COMMON.COUNTRIES.BELGIUM" |
    "COMMON.COUNTRIES.CANADA" |
    "COMMON.COUNTRIES.CZECHIA" |
    "COMMON.COUNTRIES.DENMARK" |
    "COMMON.COUNTRIES.DOMINICAN_REPUBLIC" |
    "COMMON.COUNTRIES.EGYPT" |
    "COMMON.COUNTRIES.FINLAND" |
    "COMMON.COUNTRIES.FRANCE" |
    "COMMON.COUNTRIES.GEORGIA" |
    "COMMON.COUNTRIES.GERMANY" |
    "COMMON.COUNTRIES.HONG_KONG" |
    "COMMON.COUNTRIES.HUNGARY" |
    "COMMON.COUNTRIES.INDIA" |
    "COMMON.COUNTRIES.INDONESIA" |
    "COMMON.COUNTRIES.IRELAND" |
    "COMMON.COUNTRIES.ITALY" |
    "COMMON.COUNTRIES.JAPAN" |
    "COMMON.COUNTRIES.LATVIA" |
    "COMMON.COUNTRIES.LITHUANIA" |
    "COMMON.COUNTRIES.MALAYSIA" |
    "COMMON.COUNTRIES.MAURITIUS" |
    "COMMON.COUNTRIES.MEXICO" |
    "COMMON.COUNTRIES.MYANMAR" |
    "COMMON.COUNTRIES.NETHERLANDS" |
    "COMMON.COUNTRIES.NEW_ZEALAND" |
    "COMMON.COUNTRIES.NORWAY" |
    "COMMON.COUNTRIES.PERU" |
    "COMMON.COUNTRIES.PHILIPPINES" |
    "COMMON.COUNTRIES.PORTUGAL" |
    "COMMON.COUNTRIES.SAUDI_ARABIA" |
    "COMMON.COUNTRIES.SINGAPORE" |
    "COMMON.COUNTRIES.SOUTH_AFRICA" |
    "COMMON.COUNTRIES.SOUTH_KOREA" |
    "COMMON.COUNTRIES.SPAIN" |
    "COMMON.COUNTRIES.SWEDEN" |
    "COMMON.COUNTRIES.SWITZERLAND" |
    "COMMON.COUNTRIES.TAIWAN" |
    "COMMON.COUNTRIES.THAILAND" |
    "COMMON.COUNTRIES.TURKEY" |
    "COMMON.COUNTRIES.UNITED_ARAB_EMIRATES" |
    "COMMON.COUNTRIES.UNITED_KINGDOM" |
    "COMMON.COUNTRIES.UNITED_STATES_OF_AMERICA" |
    "COMMON.COUNTRIES.VIETNAM" |
    "COMMON.COUNTRY" |
    "COMMON.CREATE" |
    "COMMON.CREATED" |
    "COMMON.CREATED_AT" |
    "COMMON.CURRENCY" |
    "COMMON.CUSTOMIZE" |
    "COMMON.DATE" |
    "COMMON.DATE_ADDED" |
    "COMMON.DAY" |
    "COMMON.DAYS" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.FRIDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.MONDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.SATURDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.SUNDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.THURSDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.TUESDAY" |
    "COMMON.DAYS_OF_THE_WEEK_LONG.WEDNESDAY" |
    "COMMON.DELETE" |
    "COMMON.DELETE_ASSET" |
    "COMMON.DELETE_CHECKED_TAGS" |
    "COMMON.DELETE_CHECKED_TAGS_CONFIRM" |
    "COMMON.DELETE_PERMANENTLY" |
    "COMMON.DELETED" |
    "COMMON.DESCRIPTION" |
    "COMMON.DESELECT_ALL" |
    "COMMON.DESKTOP" |
    "COMMON.DETACH" |
    "COMMON.DETAILS" |
    "COMMON.DISABLE" |
    "COMMON.DISABLED" |
    "COMMON.DISMISS" |
    "COMMON.DISPLAY_NAME" |
    "COMMON.DONE" |
    "COMMON.DOWNLOAD" |
    "COMMON.EDIT" |
    "COMMON.EDIT_ASSET" |
    "COMMON.EDIT_ASSETS" |
    "COMMON.EDIT_COLLECTION" |
    "COMMON.EMAIL" |
    "COMMON.EMAIL_ADDRESS" |
    "COMMON.ENABLE" |
    "COMMON.ENABLED" |
    "COMMON.END_DATE" |
    "COMMON.ENTER_NEW_NAME" |
    "COMMON.ERROR" |
    "COMMON.EXAMPLE" |
    "COMMON.EXCEEDED_SIZE_LIMIT_COLLECTION" |
    "COMMON.EXPIRE_ON_DATE" |
    "COMMON.EXPIRED" |
    "COMMON.EXPIRY" |
    "COMMON.FAILED_TO_LOAD_IMAGE" |
    "COMMON.FAILED_TO_RETRIEVE_LOCATIONS" |
    "COMMON.FETCH_DATA" |
    "COMMON.FILE" |
    "COMMON.FILE_SIZE" |
    "COMMON.FILE_UPLOADED" |
    "COMMON.FILES" |
    "COMMON.FILTER" |
    "COMMON.FILTER_COLLECTIONS" |
    "COMMON.FILTERS" |
    "COMMON.FINISH" |
    "COMMON.FIRST_NAME" |
    "COMMON.FORMAT" |
    "COMMON.FORMATS" |
    "COMMON.FROM" |
    "COMMON.FULL_SCREEN" |
    "COMMON.GMT" |
    "COMMON.GOOGLE_ADS_DISCLAIMER" |
    "COMMON.GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA" |
    "COMMON.GROUPS" |
    "COMMON.HEIGHT" |
    "COMMON.HIDE" |
    "COMMON.IMAGE" |
    "COMMON.INFO" |
    "COMMON.INSTRUCTIONS" |
    "COMMON.INVITE" |
    "COMMON.ITEM" |
    "COMMON.LABEL" |
    "COMMON.LAST_ACTIVITY" |
    "COMMON.LAST_MONTH" |
    "COMMON.LAST_NAME" |
    "COMMON.LAST_UPDATED" |
    "COMMON.LEARN_MORE" |
    "COMMON.LEAVE_PAGE_CONFIRMATION" |
    "COMMON.LEAVE_PAGE_CONFIRMATION_LONG" |
    "COMMON.LEAVE_PAGE_PROMPT.CONFIRM" |
    "COMMON.LEAVE_PAGE_PROMPT.TITLE" |
    "COMMON.LEGEND" |
    "COMMON.LESS" |
    "COMMON.LINK" |
    "COMMON.LOAD_MORE" |
    "COMMON.LOADING" |
    "COMMON.LOCALE" |
    "COMMON.LOCALE_REQUIRED" |
    "COMMON.LOCATION" |
    "COMMON.LOCATION_USED_MAX_COLLECTIONS" |
    "COMMON.LOCATIONS" |
    "COMMON.LOGIN" |
    "COMMON.MANAGER" |
    "COMMON.MAP" |
    "COMMON.MARKETING" |
    "COMMON.MESSAGE" |
    "COMMON.MOBILE" |
    "COMMON.MORE" |
    "COMMON.MORE_CHARS_FOR_SEARCH" |
    "COMMON.MOST" |
    "COMMON.MOVE_TO_FOLDER" |
    "COMMON.NAME" |
    "COMMON.NEVER" |
    "COMMON.NEW" |
    "COMMON.NEW_COLLECTION" |
    "COMMON.NEXT" |
    "COMMON.NEXT_AMOUNT" |
    "COMMON.NEXT_DATE" |
    "COMMON.NO" |
    "COMMON.NO_ASSET_COLLECTIONS_FOUND" |
    "COMMON.NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR" |
    "COMMON.NO_ASSETS_FOUND" |
    "COMMON.NO_MATCHING_COLLECTIONS_FOUND" |
    "COMMON.NO_RESULTS" |
    "COMMON.NO_THANKS" |
    "COMMON.NOBODY" |
    "COMMON.NONE" |
    "COMMON.NOT_LOGGED_IN" |
    "COMMON.NOT_SEEING_WHAT_EXPECTED" |
    "COMMON.NOTE" |
    "COMMON.NOTHING_FOUND" |
    "COMMON.NOTIFICATION" |
    "COMMON.NOTIFICATIONS" |
    "COMMON.OK" |
    "COMMON.ON" |
    "COMMON.OP_ADD_ASSET" |
    "COMMON.OP_CREATE_COLLECTION" |
    "COMMON.OP_DELETE_ASSETS" |
    "COMMON.OP_DELETE_COLLECTION" |
    "COMMON.OP_EDIT_ASSETS" |
    "COMMON.OP_EDIT_COLLECTION" |
    "COMMON.OP_GET_ASSETS" |
    "COMMON.OP_GET_COLLECTION" |
    "COMMON.OP_GET_COLLECTIONS" |
    "COMMON.OP_GET_LOCATIONS" |
    "COMMON.OP_GET_NUM_COLLECTIONS" |
    "COMMON.OP_GET_PERMISSIONS" |
    "COMMON.OPEN" |
    "COMMON.OPEN_CALENDAR" |
    "COMMON.OPEN_YOUR_FILE" |
    "COMMON.OPTIONAL" |
    "COMMON.OPTIONS" |
    "COMMON.OR" |
    "COMMON.OTHER" |
    "COMMON.OUT_OF_RANGE" |
    "COMMON.PASSWORD" |
    "COMMON.PAY" |
    "COMMON.PER_PAGE" |
    "COMMON.PHONE_NUMBER" |
    "COMMON.PLANNED" |
    "COMMON.PLATFORM" |
    "COMMON.PLATFORMS" |
    "COMMON.PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION" |
    "COMMON.PREVIEW" |
    "COMMON.PREVIOUS" |
    "COMMON.PRICE" |
    "COMMON.PRIMARY" |
    "COMMON.PRINT" |
    "COMMON.PRIVATE" |
    "COMMON.PROCESSING" |
    "COMMON.PRODUCTS.CAMPAIGN_MONITOR" |
    "COMMON.PRODUCTS.CLUBREADY" |
    "COMMON.PRODUCTS.DIGITAL_STACK" |
    "COMMON.PRODUCTS.FACEBOOK" |
    "COMMON.PRODUCTS.FACEBOOK_ADS" |
    "COMMON.PRODUCTS.FACEBOOK_AND_INSTAGRAM_ADS" |
    "COMMON.PRODUCTS.FITWARE" |
    "COMMON.PRODUCTS.FOUR51" |
    "COMMON.PRODUCTS.GLOFOX" |
    "COMMON.PRODUCTS.GOOGLE" |
    "COMMON.PRODUCTS.GOOGLE_ADWORDS" |
    "COMMON.PRODUCTS.GOOGLE_ANALYTICS" |
    "COMMON.PRODUCTS.GOOGLE_MY_BUSINESS" |
    "COMMON.PRODUCTS.INSTAGRAM" |
    "COMMON.PRODUCTS.INSTAGRAM_VIA_FACEBOOK" |
    "COMMON.PRODUCTS.LINKEDIN" |
    "COMMON.PRODUCTS.MAILCHIMP" |
    "COMMON.PRODUCTS.SENDGRID" |
    "COMMON.PRODUCTS.TWITTER" |
    "COMMON.PUBLIC" |
    "COMMON.QUANTITY" |
    "COMMON.REFRESH" |
    "COMMON.REGION" |
    "COMMON.RELOAD" |
    "COMMON.REMOVE" |
    "COMMON.RENAME" |
    "COMMON.REPLACE_PDF" |
    "COMMON.REQUIRED" |
    "COMMON.REQUIRED_FIELD_HELP" |
    "COMMON.REQUIRED_FIELD_MESSAGE" |
    "COMMON.RETRY" |
    "COMMON.REVIEW" |
    "COMMON.ROLE" |
    "COMMON.SAVE" |
    "COMMON.SAVE_NEW" |
    "COMMON.SCHEDULE" |
    "COMMON.SCHEDULED" |
    "COMMON.SEARCH" |
    "COMMON.SEARCH_ASSETS" |
    "COMMON.SEARCH_COLLECTIONS" |
    "COMMON.SEARCH_EVERYTHING" |
    "COMMON.SEARCH_RESULTS" |
    "COMMON.SELECT_A_CLIENT" |
    "COMMON.SELECT_ALL" |
    "COMMON.SELECT_AN_OPTION" |
    "COMMON.SELECT_START_AND_END_DATES" |
    "COMMON.SELECTED" |
    "COMMON.SELECTED_CLIENTS" |
    "COMMON.SEND" |
    "COMMON.SEND_QUOTE" |
    "COMMON.SENDING" |
    "COMMON.SETTINGS" |
    "COMMON.SHIPPING" |
    "COMMON.SHIPPING_FEE" |
    "COMMON.SHOW_ALL" |
    "COMMON.SHOW_LESS" |
    "COMMON.SKIP" |
    "COMMON.SOME_ASSETS" |
    "COMMON.SORT" |
    "COMMON.SORT_BY" |
    "COMMON.SORT_DIRECTION_TIP_ASC" |
    "COMMON.SORT_DIRECTION_TIP_DESC" |
    "COMMON.START_DATE" |
    "COMMON.STATUS" |
    "COMMON.SUBJECT" |
    "COMMON.SUBMIT" |
    "COMMON.TAG" |
    "COMMON.TAGS" |
    "COMMON.TEMPLATE_CATEGORY" |
    "COMMON.TERMS_AND_CONDITIONS" |
    "COMMON.TERMS_AND_CONDITIONS_WITH_SYMBOL" |
    "COMMON.TEXT" |
    "COMMON.THIS_DOCUMENT_CANNOT_BE_PREVIEWED" |
    "COMMON.THIS_MONTH" |
    "COMMON.TIME_PERIOD.AFTERNOON" |
    "COMMON.TIME_PERIOD.MORNING" |
    "COMMON.TIMEZONE" |
    "COMMON.TITLE" |
    "COMMON.JOB_TITLE" |
    "COMMON.TITLES.DR" |
    "COMMON.TITLES.MISS" |
    "COMMON.TITLES.MR" |
    "COMMON.TITLES.MRS" |
    "COMMON.TITLES.MS" |
    "COMMON.TITLES.PROF" |
    "COMMON.TITLES.SIR" |
    "COMMON.TODAY" |
    "COMMON.TOGGLE_NAVIGATION" |
    "COMMON.TOMORROW" |
    "COMMON.TOOLTIPS.SELECT_ALL" |
    "COMMON.TOTAL" |
    "COMMON.TYPE" |
    "COMMON.UNITS.INCHES" |
    "COMMON.UNITS.MILLIMETERS" |
    "COMMON.UNKNOWN" |
    "COMMON.UNPUBLISHED" |
    "COMMON.UPDATE" |
    "COMMON.UPDATING" |
    "COMMON.UPLOAD" |
    "COMMON.UPLOAD_A_FILE" |
    "COMMON.UPLOAD_A_LOGO" |
    "COMMON.UPLOAD_A_PDF" |
    "COMMON.UPLOAD_DELETE_CONFIRM" |
    "COMMON.UPLOAD_FILES" |
    "COMMON.URL" |
    "COMMON.USE_DISPLAY_NAME" |
    "COMMON.USER" |
    "COMMON.USERNAME" |
    "COMMON.USERS" |
    "COMMON.VALIDATION.INVALID_DATE" |
    "COMMON.VALIDATION.INVALID_EMAIL" |
    "COMMON.VALIDATION.MUST_CONFIRM_DETAILS_TO_CONTINUE" |
    "COMMON.VALIDATION.REQUIRED" |
    "COMMON.VIDEO" |
    "COMMON.VIEW" |
    "COMMON.VIEW_MORE" |
    "COMMON.VISIBLE_TO_WHICH" |
    "COMMON.WEB" |
    "COMMON.WIDTH" |
    "COMMON.YEP" |
    "COMMON.YES" |
    "COMMON.YESTERDAY" |
    "COMMON.YOU_CURRENTLY_HAVE_NO_COLLECTIONS" |
    "COMMON.YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS" |
    "COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ACTIVITIES" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY_BRANDS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND_REPORTS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS_PLATFORMS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.DASHBOARD" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_LOCATION_ACTIVITY" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_OVERVIEW" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_REGION_GROUP_ACTIVITY" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_TEMPLATE_USE" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.LEARN_MENU" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_HASHTAG_SETS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LEARN_MENU" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LOCATIONS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_REGIONS_GROUPS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_USERS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ROADMAP" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_COLORS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_FONTS" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_STYLE_GUIDE" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATES" |
    "DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATE_CATEGORIES" |
    "DASHBOARD.BUILT_POSTS" |
    "DASHBOARD.DUE_TODAY" |
    "DASHBOARD.DUE_TOMORROW" |
    "DASHBOARD.FAILED_TO_SET_YOUR_LOCATION" |
    "DASHBOARD.FETCH_DASHBOARD_DETAILS" |
    "DASHBOARD.FETCH_LATEST_WEBINAR" |
    "DASHBOARD.FETCH_UPCOMING_EVENTS" |
    "DASHBOARD.HERO_MESSAGE" |
    "DASHBOARD.HOW_ARE_YOU_TRACKING" |
    "DASHBOARD.LATEST_WEBINAR.AGENCY_ADVICE_FOR_SHOWING_WEBINAR" |
    "DASHBOARD.LATEST_WEBINAR.MORE_WEBINARS" |
    "DASHBOARD.LATEST_WEBINAR.WEBINAR" |
    "DASHBOARD.LEARN_MORE" |
    "DASHBOARD.LOCATION" |
    "DASHBOARD.NO_UPCOMING_EVENTS" |
    "DASHBOARD.PERFORMANCE_SUMMARY.AVERAGE_SHORT" |
    "DASHBOARD.PERFORMANCE_SUMMARY.DIFFERENCE" |
    "DASHBOARD.PERFORMANCE_SUMMARY.FETCH_PERFORMANCE_METRICS" |
    "DASHBOARD.PERFORMANCE_SUMMARY.FULL_PERFORMANCE_REPORT" |
    "DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSION_VALUE" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSIONS" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_CLICKS" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_REACH" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.INSTAGRAM_FOLLOWERS" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.SPEND" |
    "DASHBOARD.PERFORMANCE_SUMMARY.METRICS.TWITTER_LIKES" |
    "DASHBOARD.PERFORMANCE_SUMMARY.SERVICE_NOT_AUTHORISED" |
    "DASHBOARD.READY_TO_BUILD_THESE" |
    "DASHBOARD.SUGGESTED_TEMPLATES.AGENCY_ADVICE_FOR_FEATURING_TEMPLATES" |
    "DASHBOARD.SUGGESTED_TEMPLATES.BUILD_AND_SCHEDULE_GALLERY" |
    "DASHBOARD.SUGGESTED_TEMPLATES.FETCH_SUGGESTED_TEMPLATES" |
    "DASHBOARD.SUGGESTED_TEMPLATES.SUGGESTED_TEMPLATES" |
    "DASHBOARD.UPCOMING_EVENTS.PLAN_CALENDAR" |
    "DASHBOARD.UPCOMING_EVENTS.UPCOMING" |
    "DASHBOARD.UPCOMING_GENERAL_EVENTS" |
    "DASHBOARD.WATCH_VIDEO" |
    "DASHBOARD.WELCOME_PAGE.DID_YOU_KNOW" |
    "DASHBOARD.WELCOME_PAGE.WELCOME_BACK" |
    "DASHBOARD.WELCOME_PAGE.WHATS_NEW" |
    "EMAIL.AUTOMATED_EMAIL_DO_NOT_REPLY" |
    "EMAIL.IF_YOU_WISH_TO_UNSUBSCRIBE" |
    "EMAIL.INVITE_EMAIL.BUTTON_TEXT" |
    "EMAIL.INVITE_EMAIL.DOWNLOAD_THE_APP" |
    "EMAIL.INVITE_EMAIL.IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU" |
    "EMAIL.INVITE_EMAIL.INSTRUCTIONS" |
    "EMAIL.INVITE_EMAIL.SUBJECT" |
    "EMAIL.INVITE_EMAIL.WELCOME" |
    "EMAIL.INVITE_EMAIL.WHERE_TO_GET_HELP" |
    "EMAIL.LINK_WILL_EXPIRE_HOUR" |
    "EMAIL.LOG_IN_TO_CHANGE_PROFILE_SETTINGS" |
    "EMAIL.LOG_IN_TO_RESPOND" |
    "EMAIL.LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS" |
    "EMAIL.SEND_TO_PRINT.DOWNLOAD_ARTWORK" |
    "EMAIL.SEND_TO_PRINT.INSTRUCTIONS" |
    "EMAIL.SEND_TO_PRINT.ORDER_NUMBER" |
    "EMAIL.SEND_TO_PRINT.PRINT_PROVIDER_DETAILS" |
    "EMAIL.SEND_TO_PRINT.QUANTITY" |
    "EMAIL.SEND_TO_PRINT.SKU" |
    "EMAIL.SEND_TO_PRINT.SKUNAME" |
    "ERRORS.ASSET_LIBRARY.ASSETS.FETCH_FAILED" |
    "ERRORS.ASSET_LIBRARY.COLLECTIONS.FETCH_FAILED" |
    "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_FINALISED" |
    "ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_RECEIVED" |
    "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CHANGE_COLLECTION_TYPE" |
    "ERRORS.BAD_REQUEST_ERRORS.CANNOT_CREATE_PRIVATE_COMMENT" |
    "ERRORS.BAD_REQUEST_ERRORS.CANNOT_LINK_ACCESS_TOKEN" |
    "ERRORS.BAD_REQUEST_ERRORS.CANNOT_OVERRIDE_CUSTOM_FONT_FILE" |
    "ERRORS.BAD_REQUEST_ERRORS.CLIENT_DOES_NOT_EXIST" |
    "ERRORS.BAD_REQUEST_ERRORS.CLIENT_IDS_DO_NOT_MATCH" |
    "ERRORS.BAD_REQUEST_ERRORS.END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT" |
    "ERRORS.BAD_REQUEST_ERRORS.FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA" |
    "ERRORS.BAD_REQUEST_ERRORS.FILE_NAME_CANNOT_START_WITH_PIPE" |
    "ERRORS.BAD_REQUEST_ERRORS.INVALID_DOCUMENT" |
    "ERRORS.BAD_REQUEST_ERRORS.INVALID_ID" |
    "ERRORS.BAD_REQUEST_ERRORS.INVALID_SESSION" |
    "ERRORS.BAD_REQUEST_ERRORS.INVALID_URL_TO_SIGN" |
    "ERRORS.BAD_REQUEST_ERRORS.LOCATION_ALREADY_SIGNED_UP" |
    "ERRORS.BAD_REQUEST_ERRORS.LOCATION_SUBSCRIPTION_EXPIRED" |
    "ERRORS.BAD_REQUEST_ERRORS.OPERATION_RESTRICTED_TO_SELF" |
    "ERRORS.BAD_REQUEST_ERRORS.PAYMENT_ALREADY_FINALISED" |
    "ERRORS.BAD_REQUEST_ERRORS.PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE" |
    "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_CANNOT_BE_DELETED" |
    "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING" |
    "ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED" |
    "ERRORS.BAD_REQUEST_ERRORS.REPORT_SUMMARY_ID_INVALID" |
    "ERRORS.BAD_REQUEST_ERRORS.REQUEST_RETURNED_NO_RESPONSE_DATA" |
    "ERRORS.BAD_REQUEST_ERRORS.SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE" |
    "ERRORS.BAD_REQUEST_ERRORS.SEND_TO_FOUR51_MISSING_DATA" |
    "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS" |
    "ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_NO_PRICING_DATA" |
    "ERRORS.BAD_REQUEST_ERRORS.SPECIAL_REQUEST_INVALID_DATE" |
    "ERRORS.BAD_REQUEST_ERRORS.USER_BELONGS_TO_MULTIPLE_AGENCIES" |
    "ERRORS.BAD_REQUEST_ERRORS.USER_NOT_FOUND" |
    "ERRORS.BAD_REQUEST_ERRORS.VIDEO_ID_NOT_FOUND" |
    "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR_ORDER" |
    "ERRORS.BRAND.LOCATION_CATEGORIES.CATEGORY_LABEL_REQUIRED" |
    "ERRORS.BRAND.NO_CLIENT_SELECTED" |
    "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD_EMPTY_RESPONSE" |
    "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_ERROR" |
    "ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_UNRECOGNISED_RESPONSE" |
    "ERRORS.FACEBOOK_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED" |
    "ERRORS.FACEBOOK_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" |
    "ERRORS.FACEBOOK_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" |
    "ERRORS.FACEBOOK_MARKETING_ERRORS.PERMISSIONS_NOT_GRANTED" |
    "ERRORS.FITWARE_MEMBER_ENGAGER.UNRECOGNISED_RESPONSE" |
    "ERRORS.FORBIDDEN_ERRORS.ACCESS_FORBIDDEN" |
    "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_CLIENT" |
    "ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_LOCATION" |
    "ERRORS.FORBIDDEN_ERRORS.NO_PERMISSION_TO_VIEW_CLIENT" |
    "ERRORS.FORBIDDEN_ERRORS.TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT" |
    "ERRORS.FOUR51.INVALID_QUANTITY" |
    "ERRORS.FOUR51.INVALID_USERNAME_OR_PASSWORD" |
    "ERRORS.FOUR51.UNRECOGNISED_RESPONSE" |
    "ERRORS.GENERATE_MAP_ERRORS.FAILED" |
    "ERRORS.GENERATE_MAP_ERRORS.MAP_ALREADY_EXISTS" |
    "ERRORS.GENERATE_MAP_ERRORS.NO_MAP_FOR_LOCATION" |
    "ERRORS.GENERATE_MAP_ERRORS.PAYMENT_FAILED" |
    "ERRORS.GENERIC" |
    "ERRORS.GOOGLE_ADS.PERMISSIONS" |
    "ERRORS.GOOGLE_ADS.PERMISSIONS_LOCATION_REPORT" |
    "ERRORS.GOOGLE_ADS.UNKNOWN" |
    "ERRORS.GOOGLE_ANALYTICS.PERMISSIONS" |
    "ERRORS.GOOGLE_ANALYTICS.DATA_PARSE_ERROR" |
    "ERRORS.GOOGLE_ANALYTICS.DATA_RESPONSE_ERROR" |
    "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_POST" |
    "ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_RETRIEVE_LOCATION_NAME" |
    "ERRORS.GOOGLE_MY_BUSINESS.SERVICE_NOT_CONFIGURED" |
    "ERRORS.GOOGLE_OAUTH_ERRORS.INVALID_GRANT" |
    "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMIT_NOT_FOUND" |
    "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED" |
    "ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED_CONTINUE_POSTING" |
    "ERRORS.INSTAGRAM_ERRORS.FAILED_TO_POST" |
    "ERRORS.INSTAGRAM_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED" |
    "ERRORS.INSTAGRAM_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" |
    "ERRORS.INSTAGRAM_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION" |
    "ERRORS.INVALID_INPUT_ERRORS.BASE64_STRING_MISSING_MIME_TYPE" |
    "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_PAYMENT_TRANSACTIONS" |
    "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS" |
    "ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TRANSACTIONS" |
    "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_PAYMENT_TRANSACTIONS" |
    "ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_TRANSACTIONS" |
    "ERRORS.INVALID_INPUT_ERRORS.FILE_TOO_LARGE" |
    "ERRORS.INVALID_INPUT_ERRORS.INVALID_URL" |
    "ERRORS.INVALID_INPUT_ERRORS.MISSING_FILE" |
    "ERRORS.INVALID_INPUT_ERRORS.REPOSITORY_HAS_NULL_MODEL" |
    "ERRORS.INVALID_INPUT_ERRORS.UPLOAD_ID_MISSING" |
    "ERRORS.INVALID_INPUT_ERRORS.ZERO_WIDTH_OR_HEIGHT_VIDEO" |
    "ERRORS.LINKEDIN.FAILED_TO_POST" |
    "ERRORS.LINKEDIN.INVALID_GRANT" |
    "ERRORS.LINKEDIN.SERVICE_NOT_CONFIGURED" |
    "ERRORS.LOCATION_DRAFT.CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE" |
    "ERRORS.LOCATION_DRAFT.FAILED_TO_SAVE" |
    "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_INVALID" |
    "ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_MISSING" |
    "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_KEYS_MISMATCH" |
    "ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_REFERENCE_NOT_FOUND" |
    "ERRORS.LOGIN_TOKEN_ERRORS.USER_NOT_FOUND" |
    "ERRORS.LOGIN_TOKEN_ERRORS.USERNAME_NOT_SPECIFIED" |
    "ERRORS.MISSING_VALUE_ERRORS.GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID" |
    "ERRORS.MULTIPLE_ERRORS" |
    "ERRORS.NO_NETWORK_CONNECTION_ERROR" |
    "ERRORS.NO_STATS_DATA_ERRORS.GOOGLE_ADWORDS_ZERO_VALUES" |
    "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_DATE_RANGE" |
    "ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_GIVEN_PERIOD" |
    "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND" |
    "ERRORS.NOT_FOUND_ERRORS.GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN" |
    "ERRORS.NOT_FOUND_ERRORS.NO_MATCHING_EMAIL" |
    "ERRORS.NOT_FOUND_ERRORS.RESOURCE_NOT_FOUND" |
    "ERRORS.NOT_FOUND_ERRORS.USER_DOES_NOT_BELONG_TO_ANY_AGENCIES" |
    "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND" |
    "ERRORS.OAUTH_ERRORS.AUTHORISATION_DENIED" |
    "ERRORS.OAUTH_ERRORS.CALLBACK_CONFIRMATION_FAILED" |
    "ERRORS.OAUTH_ERRORS.NO_OAUTH_TOKEN" |
    "ERRORS.OAUTH_ERRORS.TOKEN_DOES_NOT_MATCH" |
    "ERRORS.PARSING_ERRORS.FOUR51_AUTH_TOKEN" |
    "ERRORS.PARSING_ERRORS.PARSING_ERROR" |
    "ERRORS.PUBLISH.ERRORS.GENERIC_ERROR_MESSAGE" |
    "ERRORS.PUBLISH.ERRORS.INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET" |
    "ERRORS.PUBLISH.ERRORS.INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT" |
    "ERRORS.PUBLISH.ERRORS.INSTAGRAM_SUSPECTED_SPAM" |
    "ERRORS.PUBLISH.ERRORS.INSTAGRAM_TAG_COUNT_REACHED" |
    "ERRORS.PUBLISH.ERRORS.NOT_SHOWN_MISSING_FROM_LIST" |
    "ERRORS.PUBLISH.INVALID_LOCATION_NODE_ID" |
    "ERRORS.PUBLISH.ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID" |
    "ERRORS.PUBLISH.SCHEDULING_STATUS_ERRORS.UNKNOWN" |
    "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_INVALID" |
    "ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_NOT_SPECIFIED" |
    "ERRORS.REQUEST_TOKEN_ERRORS.ISSUER_NOT_SPECIFIED" |
    "ERRORS.REQUEST_TOKEN_ERRORS.TOKEN_INVALID" |
    "ERRORS.SCHEDULING.DELETE.TOO_CLOSE_TO_SCHEDULED_TIME" |
    "ERRORS.SCHEDULING.DELETE.UNKNOWN" |
    "ERRORS.SCHEDULING.RESCHEDULE.TOO_CLOSE_TO_SCHEDULED_TIME" |
    "ERRORS.SCHEDULING.RESCHEDULE.UNKNOWN" |
    "ERRORS.SENDGRID.COULD_NOT_FIND_UNSUB_GROUP" |
    "ERRORS.SENDGRID.DELETE_EMAIL_ERROR" |
    "ERRORS.SENDGRID.RESCHEDULE_EMAIL_ERROR" |
    "ERRORS.SENDGRID.SINGLE_SEND_FAILED" |
    "ERRORS.SENDGRID.SINGLE_SEND_FAILED_NO_ID" |
    "ERRORS.SENDGRID.WAIT_30_MINS" |
    "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN" |
    "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_PAGE_TOKEN_NOT_RETURNED" |
    "ERRORS.SERVICE_AUTHENTICATION_ERRORS.FAILED_TO_AUTHORISE" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.CLIENT_MISSING_FITWARE_BUSINESS" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FACEBOOK_PAGE_NOT_CONFIGURED" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_CLIENT_CONFIG_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MEMBER_ENGAGER_CLUB_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MISSING_DATA" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_CREDENTIALS_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_NOT_CONNECTED" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_PAGE_PATH_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_VIEW_ID_MISSING" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FACEBOOK_PAGE_ID" |
    "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_INSTAGRAM_PAGE_ID" |
    "ERRORS.SERVICE_DISABLED_FOR_CLIENT" |
    "ERRORS.SERVICE_RATE_LIMIT_ERROR" |
    "ERRORS.STRIPE.UNRECOGNISED_RESPONSE" |
    "ERRORS.TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION" |
    "ERRORS.UNAUTHORIZED_ERRORS.PLEASE_LOGIN" |
    "ERRORS.UNAUTHORIZED_ERRORS.RESOURCE" |
    "ERRORS.UNEXPECTED_ERROR" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.BANNER_NOTIFICATION_ALREADY_EXISTS" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.CONTROLLER_MISSING_VALIDATION" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.MONTHLY_RECURRING_EVENTS_ONLY" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS" |
    "ERRORS.UNSUPPORTED_OPERATION_ERRORS.SOCKET_SERVER_ALREADY_READY" |
    "ERRORS.VIDEO_IMPORT.NETWORK_ERROR" |
    "ERRORS.VIDEO_IMPORT.UNKNOWN_ERROR" |
    "ERRORS.VIDEO_IMPORT.UNSUPPORTED_FILE_TYPE" |
    "ERRORS.VIDEO_IMPORT.UNSUPPORTED_VIDEO_TYPE" |
    "ERRORS.VIDEO_PREVIEW_UNSUPPORTED" |
    "FOOTER.PRIVACY_POLICY" |
    "FOOTER.TERMS_AND_CONDITIONS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.TITLE" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.TITLE" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.TITLE" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.DESCRIPTION" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.MULTIPLE_LAYERS_SELECTED" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_MAC" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_WINDOWS" |
    "HELP.BUILDER_KEYBOARD_SHORTCUTS.TITLE" |
    "HELP.COMMON.WHAT_CAN_I_DO" |
    "HELP.COMMON.WHAT_DOES_THIS_MEAN" |
    "HELP.COMMON.WHY_AM_I_SEEING_THIS" |
    "HELP.HELP" |
    "HELP.NO_ASSIGNED_LOCATIONS.CANT_USE_DIGITAL_STACK" |
    "HELP.NO_ASSIGNED_LOCATIONS.CONTACT_YOUR_AGENCY" |
    "HELP.NO_ASSIGNED_LOCATIONS.DONT_HAVE_LOCATIONS_ASSIGNED" |
    "HELP.NO_ASSIGNED_LOCATIONS.TITLE" |
    "INTEGRATION.AUTH.API_KEY.API_KEY" |
    "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED" |
    "INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED_EXPLAIN" |
    "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY_EXPLAIN" |
    "INTEGRATION.CLIENT.CLUB_READY.CHAIN_ID" |
    "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID" |
    "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_EXPLAIN" |
    "INTEGRATION.CLIENT.CLUB_READY.MULTIPLE_CHAIN_EXPLAIN" |
    "INTEGRATION.CLIENT.NOTIFIER.ISSUE_WITH_ACCOUNT" |
    "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_1" |
    "INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_2" |
    "INTEGRATION.CLIENT.STATUS_TIP.DISABLE" |
    "INTEGRATION.CLIENT.STATUS_TIP.EDIT" |
    "INTEGRATION.CLIENT.STATUS_TIP.ENABLE" |
    "INTEGRATION.EDIT_ACCOUNT_CONFIGURATION" |
    "INTEGRATION.ERRORS.GENERIC_ENABLE_ERROR" |
    "INTEGRATION.FITWARE.NOTIFY_BUSINESS_CLEARED" |
    "INTEGRATION.FITWARE.NOTIFY_BUSINESS_SET" |
    "INTEGRATION.FITWARE.NOTIFY_CLUB_UPDATED" |
    "INTEGRATION.INTEGRATIONS" |
    "INTEGRATION.LOCATION.CLUB_READY.CLUB_ID" |
    "INTEGRATION.LOCATION.CLUB_READY.CLUB_READY_CONFIGURATION" |
    "INTEGRATION.LOCATION.CLUB_READY.CONFIGURE_SUCCESS" |
    "INTEGRATION.LOCATION.CLUB_READY.ENTER_CLUB_ID" |
    "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.EXPLAIN" |
    "INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.RESOLVE" |
    "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.PROMPT_TEXT" |
    "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.SIGN_IN_TEXT" |
    "INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.TITLE" |
    "INTRO.ACCOUNT.COMPLETE.HEADING" |
    "INTRO.ACCOUNT.COMPLETE.SUBHEADING" |
    "INTRO.ACCOUNT.COMPLETE.TIP" |
    "INTRO.ACCOUNT.PAGE.ONE.DONE_LABEL" |
    "INTRO.ACCOUNT.PAGE.ONE.STEP.ONE" |
    "INTRO.ACCOUNT.PAGE.TWO.DONE_LABEL" |
    "INTRO.ACCOUNT.PAGE.TWO.STEP.ONE" |
    "INTRO.ACCOUNT.TITLE" |
    "INTRO.ALREADY_KNOW_HOW_THIS_WORKS" |
    "INTRO.APPS.COMPLETE.HEADING" |
    "INTRO.APPS.COMPLETE.SUBHEADING" |
    "INTRO.APPS.COMPLETE.TIP" |
    "INTRO.APPS.PAGE.ONE.DONE_LABEL" |
    "INTRO.APPS.PAGE.ONE.STEP.ONE" |
    "INTRO.APPS.PAGE.TWO.DONE_LABEL" |
    "INTRO.APPS.PAGE.TWO.STEP.ONE" |
    "INTRO.APPS.PAGE.TWO.STEP.TWO" |
    "INTRO.APPS.TITLE" |
    "INTRO.BUILD.COMPLETE.HEADING" |
    "INTRO.BUILD.COMPLETE.SUBHEADING" |
    "INTRO.BUILD.COMPLETE.TIP" |
    "INTRO.BUILD.PAGE.FIVE.DONE_LABEL" |
    "INTRO.BUILD.PAGE.FIVE.STEP.ONE" |
    "INTRO.BUILD.PAGE.FIVE.STEP.THREE" |
    "INTRO.BUILD.PAGE.FIVE.STEP.TWO" |
    "INTRO.BUILD.PAGE.FOUR.DONE_LABEL" |
    "INTRO.BUILD.PAGE.FOUR.STEP.ONE" |
    "INTRO.BUILD.PAGE.FOUR.STEP.THREE" |
    "INTRO.BUILD.PAGE.FOUR.STEP.TWO" |
    "INTRO.BUILD.PAGE.ONE.DONE_LABEL" |
    "INTRO.BUILD.PAGE.ONE.STEP.ONE" |
    "INTRO.BUILD.PAGE.ONE.STEP.TWO" |
    "INTRO.BUILD.PAGE.THREE.DONE_LABEL" |
    "INTRO.BUILD.PAGE.THREE.STEP.ONE" |
    "INTRO.BUILD.PAGE.TWO.DONE_LABEL" |
    "INTRO.BUILD.PAGE.TWO.STEP.ONE" |
    "INTRO.BUILD.PAGE.TWO.STEP.TWO" |
    "INTRO.BUILD.TITLE" |
    "INTRO.CANCEL_TOUR_MESSAGE" |
    "INTRO.CANCEL_TOUR_TITLE" |
    "INTRO.COMPLETE_THE_TOUR" |
    "INTRO.COMPLETE_THESE_ITEMS_LATER" |
    "INTRO.COMPLETED_ALL_THE_ITEMS" |
    "INTRO.CONGRATULATIONS" |
    "INTRO.DONE_LABEL" |
    "INTRO.EXAMPLE_PLANNER_TITLE" |
    "INTRO.EXAMPLE_TEMPLATE_TITLE" |
    "INTRO.FIND_OUT_WHAT" |
    "INTRO.HELP_US_MAKE" |
    "INTRO.IM_READY" |
    "INTRO.IT_LOOKS_LIKE_YOURE_NEW" |
    "INTRO.LEARN.COMPLETE.HEADING" |
    "INTRO.LEARN.COMPLETE.SUBHEADING" |
    "INTRO.LEARN.COMPLETE.TIP" |
    "INTRO.LEARN.PAGE.ONE.DONE_LABEL" |
    "INTRO.LEARN.PAGE.ONE.STEP.ONE" |
    "INTRO.LEARN.PAGE.TWO.DONE_LABEL" |
    "INTRO.LEARN.PAGE.TWO.STEP.ONE" |
    "INTRO.LEARN.PAGE.TWO.STEP.TWO" |
    "INTRO.LEARN.TITLE" |
    "INTRO.LET_ME_DO_IT_SOME_MORE" |
    "INTRO.LETS_CONTINUE" |
    "INTRO.MOST_PEOPLE_ARE_SURPRISED" |
    "INTRO.NOTIFY_POSTPONE_TOUR" |
    "INTRO.NOTIFY_STOP_TOUR" |
    "INTRO.OK_THAT_MAKES_SENSE" |
    "INTRO.PLAN.COMPLETE.HEADING" |
    "INTRO.PLAN.COMPLETE.SUBHEADING" |
    "INTRO.PLAN.COMPLETE.TIP" |
    "INTRO.PLAN.PAGE.ONE.DONE_LABEL" |
    "INTRO.PLAN.PAGE.ONE.STEP.ONE" |
    "INTRO.PLAN.PAGE.THREE.DONE_LABEL" |
    "INTRO.PLAN.PAGE.THREE.STEP.FIVE" |
    "INTRO.PLAN.PAGE.THREE.STEP.FOUR" |
    "INTRO.PLAN.PAGE.THREE.STEP.ONE" |
    "INTRO.PLAN.PAGE.THREE.STEP.SEVEN" |
    "INTRO.PLAN.PAGE.THREE.STEP.SIX" |
    "INTRO.PLAN.PAGE.THREE.STEP.THREE" |
    "INTRO.PLAN.PAGE.THREE.STEP.TWO" |
    "INTRO.PLAN.PAGE.TWO.DONE_LABEL" |
    "INTRO.PLAN.PAGE.TWO.STEP.EIGHT" |
    "INTRO.PLAN.PAGE.TWO.STEP.FIVE" |
    "INTRO.PLAN.PAGE.TWO.STEP.FOUR" |
    "INTRO.PLAN.PAGE.TWO.STEP.ONE" |
    "INTRO.PLAN.PAGE.TWO.STEP.SEVEN" |
    "INTRO.PLAN.PAGE.TWO.STEP.SIX" |
    "INTRO.PLAN.PAGE.TWO.STEP.THREE" |
    "INTRO.PLAN.PAGE.TWO.STEP.TWO" |
    "INTRO.PLAN.TITLE" |
    "INTRO.PLEASE_ACCEPT_THIS" |
    "INTRO.QUICK_TIP" |
    "INTRO.REPORT.COMPLETE.HEADING" |
    "INTRO.REPORT.COMPLETE.SUBHEADING" |
    "INTRO.REPORT.COMPLETE.TIP" |
    "INTRO.REPORT.PAGE.ONE.DONE_LABEL" |
    "INTRO.REPORT.PAGE.ONE.STEP.ONE" |
    "INTRO.REPORT.PAGE.TWO.DONE_LABEL" |
    "INTRO.REPORT.PAGE.TWO.STEP.FOUR" |
    "INTRO.REPORT.PAGE.TWO.STEP.ONE" |
    "INTRO.REPORT.PAGE.TWO.STEP.THREE" |
    "INTRO.REPORT.PAGE.TWO.STEP.TWO" |
    "INTRO.REPORT.TITLE" |
    "INTRO.RESET_ALL" |
    "INTRO.SHOW_ME" |
    "INTRO.SHOW_ME_COMPLETED" |
    "INTRO.SKIP_LABEL" |
    "INTRO.TICK_OFF_THE_ITEMS_BELOW" |
    "INTRO.VIDEO.TITLE" |
    "INTRO.YOURE_READY_FOR_THE_STACK" |
    "INTRO.YOUVE_GOT_THROUGH_THEM_ALL" |
    "LEARN.ADD_NEW_ITEM" |
    "LEARN.ADD_NEW_LEARN_ITEM" |
    "LEARN.APPLICATION_WIDE" |
    "LEARN.EDIT_ITEM" |
    "LEARN.EDIT_LEARN_ITEM" |
    "LEARN.EMAIL.VIEW_LEARN_ARTICLE" |
    "LEARN.HELPFUL" |
    "LEARN.LOADING" |
    "LEARN.MAX_UPLOAD_ERROR" |
    "LEARN.NO_ARTICLES" |
    "LEARN.NO_LEARN_AVAILABLE" |
    "LEARN.RECENT_ARTICLES" |
    "LEARN.RETRIEVE_ALL_LEARN_ARTICLES" |
    "LEARN.RETRIEVE_MORE_LEARN_ARTICLES" |
    "LEARN.TAG_NAME" |
    "LEARN.THANKS_FEEDBACK" |
    "LEARN.THUMBNAIL.CREATE_VIDEO_THUMBNAIL" |
    "LEARN.THUMBNAIL.GENERATE_FROM_VIDEO" |
    "LEARN.THUMBNAIL.SLIDER_HELP" |
    "LEARN.THUMBNAIL.UPLOAD_CUSTOM" |
    "LEARN.THUMBNAIL.UPLOAD_NEW_THUMBNAIL" |
    "LEARN.TRY_THIS_DELETED" |
    "LOGIN.EMAIL.INVITE.CLICK_BUTTON_TO_LOG_IN" |
    "LOGIN.EMAIL.INVITE.LOG_INTO_DIGITAL_STACK" |
    "LOGIN.EMAIL.INVITE.YOU_HAVE_BEEN_INVITED" |
    "LOGIN.EMAIL.RESET_PASSWORD.IF_YOU_DID_NOT_REQUEST_THIS" |
    "LOGIN.EMAIL.RESET_PASSWORD.PASSWORD_RESET_INSTRUCTIONS" |
    "LOGIN.EMAIL.RESET_PASSWORD.RESET_MY_PASSWORD" |
    "LOGIN.EMAIL.RESET_PASSWORD.SOMEONE_REQUESTED_TO_RESET_PASSWORD" |
    "LOGIN.EMAIL.RESET_PASSWORD.TO_RESET_CLICK_LINK" |
    "LOGIN.EMAIL.WELCOME_TO_DIGITAL_STACK" |
    "LOGIN.ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS" |
    "LOGIN.FORGOT_PASSWORD" |
    "LOGIN.FORGOTTEN_PASSWORD" |
    "LOGIN.INVALID_EMAIL_ADDRESS" |
    "LOGIN.LOGIN" |
    "LOGIN.LOGIN_CONFIRM_IDENTITY" |
    "LOGIN.LOGIN_TO_LINK_ACCOUNTS" |
    "LOGIN.PASSWORD" |
    "LOGIN.PASSWORD_AGAIN" |
    "LOGIN.PASSWORD_RESET_FAILED" |
    "LOGIN.PASSWORD_RESET_INSTRUCTIONS" |
    "LOGIN.PASSWORD_RESET_INSTRUCTIONS_SENT" |
    "LOGIN.PASSWORD_RESET_PLEASE_LOGIN" |
    "LOGIN.PASSWORDS_DONT_MATCH" |
    "LOGIN.PROBLEM_WITH_INVITE_LINK" |
    "LOGIN.PROBLEM_WITH_LINK" |
    "LOGIN.REQUEST_PASSWORD_RESET" |
    "LOGIN.RESET_PASSWORD" |
    "LOGIN.SEND_PASSWORD_RESET" |
    "LOGIN.SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL.BODY" |
    "LOGIN.SIGNED_OUT" |
    "LOGIN.USERNAME" |
    "LOGIN.USERNAME_PASSWORD_INCORRECT_ERROR" |
    "LOGIN.WELCOME_TO_DIGITAL_STACK" |
    "LOGIN.YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY" |
    "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.NO_ACTIVITIES_PLANNED" |
    "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WEEKLY_MARKETING_UPDATE" |
    "MENU.ACCOUNT" |
    "MENU.ADMIN" |
    "MENU.AGENCIES" |
    "MENU.AGENCY" |
    "MENU.ASSETS" |
    "MENU.BRAND" |
    "MENU.BRANDS" |
    "MENU.BRAND_SETTINGS" |
    "MENU.BUILD" |
    "MENU.CALENDAR" |
    "MENU.CALENDAR_ACTIVITIES" |
    "MENU.CLIENTS" |
    "MENU.CLOSE_NAVIGATION" |
    "MENU.COLORS" |
    "MENU.COMMUNICATE" |
    "MENU.CONNECT" |
    "MENU.CONNECTIONS" |
    "MENU.FONTS" |
    "MENU.HASHTAG_SETS" |
    "MENU.HELP" |
    "MENU.INTEGRATIONS" |
    "MENU.LEARN" |
    "MENU.LEARN_MENU" |
    "MENU.LOCATION" |
    "MENU.LOCATIONS" |
    "MENU.LOCATION_ACTIVITY" |
    "MENU.LOCATION_DETAILS" |
    "MENU.LOCATION_USERS" |
    "MENU.MAIN_NAVIGATION" |
    "MENU.MARK_ALL_AS_READ" |
    "MENU.MORE" |
    "MENU.NOTIFICATIONS" |
    "MENU.NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ" |
    "MENU.OPEN_NAVIGATION" |
    "MENU.OVERVIEW" |
    "MENU.PAYMENTS" |
    "MENU.PERFORMANCE" |
    "MENU.PLAN" |
    "MENU.PLATFORMS" |
    "MENU.PROFILE" |
    "MENU.REGIONS_GROUPS" |
    "MENU.REGION_GROUP_ACTIVITY" |
    "MENU.REPORT" |
    "MENU.REPORTING" |
    "MENU.REQUESTS" |
    "MENU.ROADMAP" |
    "MENU.SCHEDULED" |
    "MENU.SEND" |
    "MENU.SIGN_OUT" |
    "MENU.SPECIAL_REQUESTS" |
    "MENU.STYLES" |
    "MENU.STYLE_GUIDE" |
    "MENU.TEMPLATES" |
    "MENU.TEMPLATE_CATEGORIES" |
    "MENU.TEMPLATE_USE" |
    "MENU.VIEW_ALL_NOTIFICATIONS" |
    "MENU.YOU_HAVE_NO_UNREAD_NOTIFICATIONS" |
    "NOTIFICATIONS.BADGER.MARK_ALL_AS_READ" |
    "NOTIFICATIONS.BADGER.NO_UNREAD_NOTIFICATIONS" |
    "NOTIFICATIONS.BADGER.VIEW_ALL" |
    "NOTIFICATIONS.CALL_TO_ACTION_BUTTON_LABELS.OPEN_LINK" |
    "NOTIFICATIONS.LIST.NO_NOTIFICATIONS" |
    "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_READY_FOR_DOWNLOAD" |
    "NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_TIME_TO_SCHEDULE" |
    "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_LOCALLY" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.EMAIL_NOTIFICATION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.NOTIFICATION_TYPE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.PUSH_NOTIFICATION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LABEL" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LINK" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_CENTER" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_LEFT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_RIGHT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BOLD" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BULLETED_LIST" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.IMAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ITALICS" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.NUMBERED_LIST" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EMAIL_CONTENT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.BANNER_IMAGE_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LABEL_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LINK_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_EMAIL_ADDRESS_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_NAME_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SUBJECT_REQUIRED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_IMAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_LOGO" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_NONE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_SAVED" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_CONTENT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_EXISTING" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NEW" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NONE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_CUSTOM" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_EMAIL_ADDRESS" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_NAME" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.LOGO" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_BANNER_SELECT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_FOOTER_SELECT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION_NAME" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION_NAME" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_BANNER_SECTION_NAME" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_FOOTER_SECTION_NAME" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_AGENCY_NOTE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_BRAND_NOTE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.LINK" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.OPTIONAL" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.SUBJECT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.NOTIFICATION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.OPEN_LINK" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.CONFIRM_COPY" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_ONE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_TWO" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.IMMEDIATELY" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.NOTIFICATION_TYPE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.TOTAL_RECIPIENTS" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.USER_FILTER" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_NOTIFICATION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_TEST_EMAIL" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_PREVIEW_MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_DESCRIPTION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_PREVIEW_MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_DESCRIPTION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_MESSAGE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.SEND_ANOTHER" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.EMAIL" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.PUSH" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.DESCRIPTION" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.ERRORS.TITLE_FILTER_INVALID_ENTRIES" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.HEADERS.FILTER_BY_TITLE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_BY_TITLES" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_ALL_USERS" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_FILTER_BY_TITLE" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.HEADING_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.STEPPER_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.HEADING_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.STEPPER_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.HEADING_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.STEPPER_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.HEADING_TEXT" |
    "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.STEPPER_TEXT" |
    "OVERVIEW.ALL_EVENTS" |
    "OVERVIEW.BULK_ACTIONS" |
    "OVERVIEW.DELETE_ALL_PLANNER_EVENTS" |
    "OVERVIEW.DELETE_RECURRING_EVENT" |
    "OVERVIEW.DELETED_PLANNER_EVENTS" |
    "OVERVIEW.DELETED_SOME_PLANNER_EVENTS" |
    "OVERVIEW.DELETING_PLANNER_EVENTS" |
    "OVERVIEW.DELETING_THESE_PLANNER_EVENTS" |
    "OVERVIEW.DONE" |
    "OVERVIEW.FAILED_DELETE_PLANNER_EVENTS" |
    "OVERVIEW.FILTER.CHANNELS" |
    "OVERVIEW.FILTER.CLIENT" |
    "OVERVIEW.FILTER.ITEM" |
    "OVERVIEW.FILTER.LOCATION" |
    "OVERVIEW.FILTER.STATUS" |
    "OVERVIEW.FUTURE_EVENTS" |
    "OVERVIEW.LOCATION_EVENTS_FAILED_PUBLISH" |
    "OVERVIEW.LOCATION_EVENTS_FAILED_SAVE" |
    "OVERVIEW.MAX_SPEND" |
    "OVERVIEW.NO_CONTENT" |
    "OVERVIEW.SAVING_PLANNER_EVENT" |
    "OVERVIEW.SELECTED_PLANNER_EVENTS" |
    "OVERVIEW.SOME_PLANNER_SERIES" |
    "OVERVIEW.THIS_EVENT" |
    "PAYMENTS.ASK_AGENCY_TO_SEND_ANOTHER" |
    "PAYMENTS.AUTHORITY_CONFIRMATION" |
    "PAYMENTS.BUSINESS_NAME" |
    "PAYMENTS.COULD_NOT_FIND_INVITATION" |
    "PAYMENTS.CUSTOMER_DETAILS" |
    "PAYMENTS.EMAIL_ADDRESS" |
    "PAYMENTS.EMAILS.FAILED_TO_TAKE_PAYMENT" |
    "PAYMENTS.EMAILS.IF_YOU_NEED_TO_UPDATE_CREDIT_CARD" |
    "PAYMENTS.EMAILS.REPORT.FAILED_TO_TAKE_PAYMENTS" |
    "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES" |
    "PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES_NOTE" |
    "PAYMENTS.EMAILS.YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION" |
    "PAYMENTS.FINALISING_PAYMENT" |
    "PAYMENTS.GO_BACK" |
    "PAYMENTS.INVOICE_DESCRIPTION" |
    "PAYMENTS.INVOICE_NUMBER" |
    "PAYMENTS.MASTERCARD" |
    "PAYMENTS.NO_PAYMENT" |
    "PAYMENTS.NO_PAYMENT_INFORMATION" |
    "PAYMENTS.PAY_NOW" |
    "PAYMENTS.PAYMENT_AMOUNT" |
    "PAYMENTS.PAYMENT_CURRENCY" |
    "PAYMENTS.PAYMENT_FAILED" |
    "PAYMENTS.PAYMENT_SUCCESSFUL" |
    "PAYMENTS.PHONE_NUMBER" |
    "PAYMENTS.PLEASE_CONFIRM" |
    "PAYMENTS.RECEIPT_NUMBER" |
    "PAYMENTS.REDIRECT_CONTINUE" |
    "PAYMENTS.REDIRECT_NOTE" |
    "PAYMENTS.REDIRECTING" |
    "PAYMENTS.SIGN_UP.FINALISING_SIGN_UP" |
    "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE" |
    "PAYMENTS.SIGN_UP.I_AGREE_TO_THE" |
    "PAYMENTS.SIGN_UP.SIGN_UP" |
    "PAYMENTS.SIGN_UP.SIGN_UP_FAILED" |
    "PAYMENTS.SIGN_UP.SIGN_UP_SUCCESSFUL" |
    "PAYMENTS.SIGN_UP.YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD" |
    "PAYMENTS.STARTING" |
    "PAYMENTS.STRIPE.AUTH_REQUEST.AUTHORISE_YOUR_ACCOUNT" |
    "PAYMENTS.STRIPE.AUTH_REQUEST.BY_AUTHORISING" |
    "PAYMENTS.STRIPE.AUTH_REQUEST.CLICK_BUTTON_BELOW" |
    "PAYMENTS.STRIPE.AUTH_REQUEST.EXPIRED" |
    "PAYMENTS.STRIPE.AUTH_REQUEST.REQUEST_INVALID" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.ACCESS_DENIED" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.ERROR" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.FAILED" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_SOMETHING_WENT_WRONG" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_YOU_DENIED_ACCESS" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.SUCCESS" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.UNKNOWN_ERROR" |
    "PAYMENTS.STRIPE.AUTH_RESPONSE.YOUR_STRIPE_ACCOUNT_IS_CONNECTED" |
    "PAYMENTS.STRIPE.CREATE_STRIPE_CHARGE" |
    "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.AUTH_MY_ACCOUNT" |
    "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.SUBJECT_LINE" |
    "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.TO_AUTH_CLICK_LINK" |
    "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_REQUEST" |
    "PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_URL" |
    "PAYMENTS.STRIPE.FETCH_STRIPE_PUBLISHABLE_KEY" |
    "PAYMENTS.STRIPE.SUBMIT_AUTH_CODE_TO_STRIPE" |
    "PAYMENTS.THANK_YOU" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.BILLING_DETAILS_UPDATED" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.FINALISING_CHANGES" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.LOADING_BILLING_DETAILS" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_FAILED" |
    "PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_SUCCESSFUL" |
    "PAYMENTS.VISA" |
    "PAYMENTS.WE_ONLY_ACCEPT" |
    "PAYMENTS.YOUR_BUSINESS" |
    "PLAN.ACTIVITIES.ACTIONS.ADD_ACTIVITY" |
    "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.GENERAL" |
    "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SELF_SERVICE" |
    "PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SUPPORTED" |
    "PLAN.AGENCY_TO_BUILD" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.ADD_TEMPLATE" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.ASSOCIATE_TEMPLATE_OR_CATEGORY" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.INVALID_SINGLE_TEMPLATE_EXPLANATION" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.PASTE_A_TEMPLATE_URL" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_COLLECTION" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_TEMPLATE_CATEGORY" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.SINGLE_TEMPLATE" |
    "PLAN.ASSOCIATED_BUILDER_RESOURCES.TEMPLATE_URL" |
    "PLAN.BUILD_AND_SCHEDULE" |
    "PLAN.BUILD_AND_SCHEDULE_TOOLTIP" |
    "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_THIS_CAMPAIGN" |
    "PLAN.CAMPAIGNS.ACTIONS.DEPLOY_THIS_CAMPAIGN" |
    "PLAN.CAMPAIGNS.ACTIONS.RENAME_CAMPAIGN" |
    "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_THIS_CAMPAIGN" |
    "PLAN.CAMPAIGNS.ADD_ITEM" |
    "PLAN.CAMPAIGNS.ADD_NEW_CAMPAIGN" |
    "PLAN.CAMPAIGNS.CAMPAIGN_NAME_FILTER_LABEL" |
    "PLAN.CAMPAIGNS.CAMPAIGN_NOT_FOUND" |
    "PLAN.CAMPAIGNS.CAMPAIGNS" |
    "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.DURATION" |
    "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.NAME" |
    "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.TOTAL_ITEMS" |
    "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NO_CAMPAIGNS_FOUND" |
    "PLAN.CAMPAIGNS.DEPLOYS.ADJUST_EVENT_DATES_TITLE" |
    "PLAN.CAMPAIGNS.DEPLOYS.CAMPAIGN_DEPLOYED" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_ADJUST_DETAIL" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_REMOVE_DETAIL" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.CONFIRM_COPY" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.DEPLOYMENT_EXPLANATION_COPY" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.END_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.HEADER" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.PLEASE_CONFIRM" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DEPLOYMENT" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP_DETAIL" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP_DETAIL" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.ADJUST_DATES" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.PICK_LOCATIONS" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.REVIEW" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.SET_STARTING_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_TO" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.CAMPAIGN_NOT_FOUND" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.LOCATION_PLACEHOLDER" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_LABEL" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_PLACEHOLDER" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.CREATE_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.LOCATION" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.START_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.STATUS" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.NO_DEPLOYMENTS" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE_HELP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED_HELP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED_HELP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT_HELP" |
    "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED" |
    "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.DEPLOYMENT_FAILED" |
    "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_EVENT" |
    "PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_LOCATION" |
    "PLAN.CAMPAIGNS.DEPLOYS.PICK_LOCATIONS" |
    "PLAN.CAMPAIGNS.DEPLOYS.SELECT_STARTING_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.STARTING_DATE" |
    "PLAN.CAMPAIGNS.DEPLOYS.SUCCESSFUL_DEPLOY_COPY" |
    "PLAN.CAMPAIGNS.ERRORS.UPLOAD_FAILED" |
    "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.ACTIONS" |
    "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.CHANNEL" |
    "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.DAY" |
    "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.INSTRUCTIONS_DESCRIPTION" |
    "PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.TITLE" |
    "PLAN.CAMPAIGNS.IS_ARCHIVED" |
    "PLAN.CAMPAIGNS.OVERVIEW" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.ARE_YOU_SURE_DELETE_PLANNER_EVENT" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_CREATING_PLANNER_EVENT" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_DELETING_PLANNER_EVENT" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_UPDATING_PLANNER_EVENT" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.NEW_PLANNER_EVENT" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_CREATED" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_DELETED" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_NOT_FOUND" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_UPDATED" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENTS" |
    "PLAN.CAMPAIGNS.PLANNER_EVENTS.READY_TO_ACTION" |
    "PLAN.CAMPAIGNS.RETURN_TO_CAMPAIGNS_PAGE" |
    "PLAN.CONTENT_REQUIRED" |
    "PLAN.CONTENT_REQUIRED_TOOLTIP" |
    "PLAN.DANGEROUS_DATE_HEADING" |
    "PLAN.DANGEROUS_DATE_NOTE" |
    "PLAN.EVENT.ACTIVITY" |
    "PLAN.EVENT.ADD_REMOVE_LOCATIONS" |
    "PLAN.EVENT.ADD_TO_PLANNER" |
    "PLAN.EVENT.ADDITIONAL_LOCATIONS" |
    "PLAN.EVENT.BACK_TO_CALENDAR" |
    "PLAN.EVENT.BUILD_NOW" |
    "PLAN.EVENT.DAILY" |
    "PLAN.EVENT.DATE_SUBMITTED" |
    "PLAN.EVENT.DATE_UPDATED" |
    "PLAN.EVENT.DELETE_PLANNER_EVENT" |
    "PLAN.EVENT.DELETE_RECURRING" |
    "PLAN.EVENT.EDIT_PLANNER" |
    "PLAN.EVENT.ENDS" |
    "PLAN.EVENT.EVENT_SERIES" |
    "PLAN.EVENT.EVENT_SERIES_CHOOSE_ALL" |
    "PLAN.EVENT.EVENT_SERIES_CHOOSE_CURRENT" |
    "PLAN.EVENT.EVENT_SERIES_CHOOSE_FUTURE" |
    "PLAN.EVENT.EVENT_SERIES_OPTIONS_DELETE" |
    "PLAN.EVENT.EVENT_SERIES_OPTIONS_UPDATE" |
    "PLAN.EVENT.FAILED_TO_CREATE_UPDATE_PLANNER" |
    "PLAN.EVENT.FAILED_TO_DELETE_PLANNER" |
    "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER" |
    "PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER_INFO" |
    "PLAN.EVENT.FIFTH" |
    "PLAN.EVENT.FIRST" |
    "PLAN.EVENT.FORTNIGHTLY" |
    "PLAN.EVENT.FOURTH" |
    "PLAN.EVENT.FRIDAY" |
    "PLAN.EVENT.MONDAY" |
    "PLAN.EVENT.NO_ARTWORK" |
    "PLAN.EVENT.OCCURRENCES" |
    "PLAN.EVENT.OLD_ACTIVITIES" |
    "PLAN.EVENT.PLANNER_EVENT_DELETED" |
    "PLAN.EVENT.PLEASE_DELETE_ITEM_VIA" |
    "PLAN.EVENT.READY_TO_ACTION" |
    "PLAN.EVENT.RECURRING_EVENT_QUESTION" |
    "PLAN.EVENT.REPEAT_BY" |
    "PLAN.EVENT.SATURDAY" |
    "PLAN.EVENT.SAVE_BUILD_LATER" |
    "PLAN.EVENT.SAVE_BUILD_NOW" |
    "PLAN.EVENT.SAVE_MORE_CONTENT_REQUIRED" |
    "PLAN.EVENT.SCHEDULED_PAGE" |
    "PLAN.EVENT.SECOND" |
    "PLAN.EVENT.SELF_SERVICE" |
    "PLAN.EVENT.STARTS_ON" |
    "PLAN.EVENT.SUBMITTED_BY" |
    "PLAN.EVENT.SUNDAY" |
    "PLAN.EVENT.SUPPORT_ACTION_ONE" |
    "PLAN.EVENT.SUPPORT_ACTION_THREE" |
    "PLAN.EVENT.SUPPORT_ACTION_TWO" |
    "PLAN.EVENT.SUPPORT_ACTIONS" |
    "PLAN.EVENT.SUPPORT_HEADING" |
    "PLAN.EVENT.SUPPORT_OVERPLANNED" |
    "PLAN.EVENT.TEMPLATE_CATEGORY_EXPIRED" |
    "PLAN.EVENT.THIRD" |
    "PLAN.EVENT.THURSDAY" |
    "PLAN.EVENT.TUESDAY" |
    "PLAN.EVENT.UPDATE_RECURRING" |
    "PLAN.EVENT.UPDATED_BY" |
    "PLAN.EVENT.WEDNESDAY" |
    "PLAN.EVENT.WEEKLY" |
    "PLAN.GENERAL_ITEM" |
    "PLAN.GENERAL_ITEM_TOOLTIP" |
    "PLAN.INTRO_DUMMY_ACTIVITY" |
    "PLAN.INTRO_DUMMY_CHANNEL" |
    "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_THESE_LOCATIONS" |
    "PLAN.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_SAVE" |
    "PLAN.MULTIPLE_LOCATIONS.TOTAL_SAVING_PROGRESS" |
    "PLAN.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS" |
    "PLAN.NEXT_MONTH" |
    "PLAN.NEXT_WEEK" |
    "PLAN.NOTIFY_PLANNER_CREATE_ERROR" |
    "PLAN.NOTIFY_PLANNER_EVENT_DELETED" |
    "PLAN.PAST_DATE_CANT_PLAN" |
    "PLAN.PAST_DATE_HEADING" |
    "PLAN.PAST_DATE_RECURRING" |
    "PLAN.PLAN" |
    "PLAN.PLANNER" |
    "PLAN.PREVIOUS_MONTH" |
    "PLAN.PREVIOUS_WEEK" |
    "PLAN.READY_TO_BUILD" |
    "PLAN.READY_TO_BUILD_TOOLTIP" |
    "PLAN.SAVING_PLANNER_EVENT" |
    "PLAN.SPECIAL_REQUEST" |
    "PLAN.UPDATE_RECURRING_DATE" |
    "PLAN.VIEW_BY_MONTH" |
    "PLAN.VIEW_BY_WEEK" |
    "PROFILE.CHANGE_IMAGE" |
    "PROFILE.CHANGE_PROFILE_PICTURE" |
    "PROFILE.CONFIRM_REMOVE_PROFILE_PICTURE" |
    "PROFILE.EMAIL" |
    "PROFILE.EMAIL_REQUIRED" |
    "PROFILE.FIRST_NAME" |
    "PROFILE.FIRST_NAME_REQUIRED" |
    "PROFILE.INVITE_SENT" |
    "PROFILE.LAST_NAME" |
    "PROFILE.LAST_NAME_REQUIRED" |
    "PROFILE.MARKETING_UPDATES" |
    "PROFILE.NOTIFICATIONS" |
    "PROFILE.PASSWORD" |
    "PROFILE.PROFILE" |
    "PROFILE.PROFILE_PICTURE" |
    "PROFILE.REMOVE_IMAGE" |
    "PROFILE.RESEND_INVITE" |
    "PROFILE.SENDING_INVITE" |
    "PROFILE.SPECIAL_REQUESTS" |
    "PROFILE.TIMEZONE" |
    "PROFILE.UNITS" |
    "PROFILE.UNSUPPORTED_IMAGE_FORMAT" |
    "PROFILE.USER_ACCOUNT_UPDATED" |
    "PROFILE.USER_LOCALE_CHANGED_PAGE_WILL_RELOAD" |
    "PROFILE.USER_PROFILE" |
    "REPORT.AD_NAME" |
    "REPORT.ADD_REMOVE_LOCATIONS" |
    "REPORT.ADJUST_SPEND" |
    "REPORT.ADJUSTED_DAILY_BUDGET" |
    "REPORT.ADVERTISING" |
    "REPORT.AVERAGE_POSITION" |
    "REPORT.BOUNCED" |
    "REPORT.BRAND_AWARENESS" |
    "REPORT.BRAND_AWARENESS_BY_AD" |
    "REPORT.BRAND_AWARENESS_BY_KEYWORD" |
    "REPORT.BUDGET" |
    "REPORT.BY_AD" |
    "REPORT.BY_KEYWORD" |
    "REPORT.CAMPAIGN" |
    "REPORT.CAMPAIGN_MONITOR.TITLE" |
    "REPORT.CANT_REPORT_MORE_THAN_THREE_MONTHS" |
    "REPORT.CLICK_RATE" |
    "REPORT.CLICK_THROUGH_RATE" |
    "REPORT.CLICK_THROUGH_RATE_HINT" |
    "REPORT.CLICKED" |
    "REPORT.CLICKS" |
    "REPORT.CLIENT_OR_LOCATION" |
    "REPORT.COLLAPSE_POSTS" |
    "REPORT.COLLAPSE_ROWS" |
    "REPORT.CONFIRM_DELETE_REPORT_SUMMARY" |
    "REPORT.CONSUMED" |
    "REPORT.CONSUMPTION" |
    "REPORT.CONVERSION_VALUE" |
    "REPORT.CONVERSION_VALUE_HINT" |
    "REPORT.CONVERSIONS" |
    "REPORT.CONVERSIONS_BY_AD" |
    "REPORT.CONVERSIONS_BY_KEYWORD" |
    "REPORT.COST_PER_CLICK" |
    "REPORT.COST_PER_CONVERSION" |
    "REPORT.COST_PER_LEAD" |
    "REPORT.COST_PER_UNIQUE_CLICK" |
    "REPORT.CURRENCY" |
    "REPORT.CURRENT_SPEND" |
    "REPORT.DEVICE_SELECTION" |
    "REPORT.DEVICE_SELECTION_HINT" |
    "REPORT.DEVICES.DESKTOP" |
    "REPORT.DEVICES.MOBILE" |
    "REPORT.DEVICES.TABLET" |
    "REPORT.DEVICES.UNKNOWN" |
    "REPORT.EMAIL_CAMPAIGNS.BOUNCES" |
    "REPORT.EMAIL_CAMPAIGNS.BUTTONS.DOWNLOAD_CSV" |
    "REPORT.EMAIL_CAMPAIGNS.BUTTONS.EXPORT_CSV" |
    "REPORT.EMAIL_CAMPAIGNS.CLICK_RATE" |
    "REPORT.EMAIL_CAMPAIGNS.DELIVERED" |
    "REPORT.EMAIL_CAMPAIGNS.ERROR_EXPORTING_CSV" |
    "REPORT.EMAIL_CAMPAIGNS.EXPORTING_PLEASE_WAIT" |
    "REPORT.EMAIL_CAMPAIGNS.HTML_PREVIEW_DIALOG_TITLE" |
    "REPORT.EMAIL_CAMPAIGNS.INVALID_EMAILS" |
    "REPORT.EMAIL_CAMPAIGNS.NOT_CONNECTED" |
    "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_ERROR" |
    "REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_SUCCESS" |
    "REPORT.EMAIL_CAMPAIGNS.OPEN_RATE" |
    "REPORT.EMAIL_CAMPAIGNS.PLEASE_SELECT_EMAIL_PLATFORM" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.CLICKED_LINK" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.DELIVERED" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.MARKED_AS_SPAM" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.NO_RECIPIENTS_FOUND" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.OPENED" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_LABEL" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_PLACEHOLDER" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_LABEL" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_PLACEHOLDER" |
    "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.UNSUBSCRIBED" |
    "REPORT.EMAIL_CAMPAIGNS.SPAM_REPORTS" |
    "REPORT.END_DATE" |
    "REPORT.END_DATE_BEFORE_START_DATE" |
    "REPORT.ENGAGED_USERS" |
    "REPORT.ENGAGEMENT" |
    "REPORT.ENGAGEMENT_CLICKS" |
    "REPORT.ENGAGEMENT_REACH" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_ALL" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_MEN" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.DAYS" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_MEN" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_OTHER" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_WOMEN" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.HOURS" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TITLE" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS_HELP" |
    "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_POST_TIMES" |
    "REPORT.FACEBOOK.INCORRECT_DATA_POPOVER_TEXT" |
    "REPORT.FACEBOOK.LIKES_REPORT.NEW_PAGE_LIKES" |
    "REPORT.FACEBOOK.LIKES_REPORT.NEW_POSTS" |
    "REPORT.FACEBOOK.LIKES_REPORT.NOW" |
    "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES" |
    "REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES_GROWTH" |
    "REPORT.FACEBOOK.LIKES_REPORT.TITLE" |
    "REPORT.FACEBOOK.LIKES_REPORT.TOTAL_PAGE_LIKES" |
    "REPORT.FACEBOOK.NOT_CONNECTED" |
    "REPORT.FACEBOOK.POSTS_REPORT.ENGAGEMENT" |
    "REPORT.FACEBOOK.POSTS_REPORT.TIME" |
    "REPORT.FACEBOOK.POSTS_REPORT.TITLE" |
    "REPORT.FACEBOOK.POSTS_REPORT.VIEW_MORE" |
    "REPORT.FACEBOOK.POSTS_REPORT.VIEW_POST" |
    "REPORT.FACEBOOK_ADVERTISING" |
    "REPORT.FACEBOOK_TOP_POSTS" |
    "REPORT.FITWARE_MEMBER_ENGAGER.BOUNCES" |
    "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.TITLE" |
    "REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.MESSAGE" |
    "REPORT.FITWARE_MEMBER_ENGAGER.LOCATION_EMAIL" |
    "REPORT.FITWARE_MEMBER_ENGAGER.OPENS" |
    "REPORT.FITWARE_MEMBER_ENGAGER.SPAM_REPORTS" |
    "REPORT.FITWARE_MEMBER_ENGAGER.TITLE" |
    "REPORT.FITWARE_MEMBER_ENGAGER.UNSUBSCRIBES" |
    "REPORT.FOLLOWERS_FROM" |
    "REPORT.FOLLOWERS_GROWTH" |
    "REPORT.FOLLOWERS_TO" |
    "REPORT.FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY" |
    "REPORT.GENERAL_EVENTS" |
    "REPORT.GENERAL_TEMPLATE_TYPES.ALL" |
    "REPORT.GENERAL_TEMPLATE_TYPES.DIGITAL" |
    "REPORT.GENERAL_TEMPLATE_TYPES.EMAIL" |
    "REPORT.GENERAL_TEMPLATE_TYPES.PRINT" |
    "REPORT.GENERATING_REPORT" |
    "REPORT.GO" |
    "REPORT.GOOGLE_ADS.COLUMNS.AD_NAME" |
    "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC" |
    "REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS" |
    "REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.COST" |
    "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION" |
    "REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.COST_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY" |
    "REPORT.GOOGLE_ADS.COLUMNS.CURRENCY_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS" |
    "REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE" |
    "REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS" |
    "REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS_TOOLTIP" |
    "REPORT.GOOGLE_ADS.COLUMNS.KEYWORD" |
    "REPORT.GOOGLE_ADS.KEYWORD_BROAD_MATCH_TOOLTIP" |
    "REPORT.GOOGLE_ADS.KEYWORD_EXACT_MATCH_TOOLTIP" |
    "REPORT.GOOGLE_ADS.KEYWORD_PHRASE_MATCH_TOOLTIP" |
    "REPORT.GOOGLE_ADS.KEYWORD_UNKNOWN_MATCH_TOOLTIP" |
    "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.ADDITIONAL_NOTES" |
    "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.FAILED_TO_REQUEST_SPEND_ADJUSTMENT" |
    "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_HAS_BEEN_SENT" |
    "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_TO_ADJUST_SPEND" |
    "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.SEND_REQUEST" |
    "REPORT.GOOGLE_MY_BUSINESS.CONFIRM_DELETE_MESSAGE" |
    "REPORT.GOOGLE_MY_BUSINESS.CUSTOMER_FEEDBACK.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.DIRECTIONS_REPORT.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.METRICS_NO_LONGER_AVALIABLE_BANNER" |
    "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_1" |
    "REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_2" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.MERCHANT_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.OTHERS_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.MERCHANT_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.OTHERS_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.VIEW_POST" |
    "REPORT.GOOGLE_MY_BUSINESS.REPLY" |
    "REPORT.GOOGLE_MY_BUSINESS.REPLY_LENGTH_ERROR" |
    "REPORT.GOOGLE_MY_BUSINESS.REPLYING_PUBLICLY" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_DESCRIPTION" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_DESCRIPTION" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_DESCRIPTION" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_30" |
    "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_7" |
    "REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_90" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANONYMOUS_AUTHOR_NAME" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWER_LIST_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.ANONYMOUS_REVIEWER_NAME" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.SUB_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REPLY" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REVIEW" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_CHART_LABEL" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_CHART_LABEL" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.TITLE" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_CHART_LABEL" |
    "REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_TITLE" |
    "REPORT.GROWTH" |
    "REPORT.HIDE_SUMMARY" |
    "REPORT.IMPRESSIONS" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_ALL" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_MEN" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.DAYS" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.HOURS" |
    "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS" |
    "REPORT.INSTAGRAM.BUSINESS_ACCOUNT_REPORT.FOLLOWERS_CHART_LABEL" |
    "REPORT.INSTAGRAM.NOT_CONNECTED_PART_1" |
    "REPORT.INSTAGRAM.NOT_CONNECTED_PART_2" |
    "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_1" |
    "REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_2" |
    "REPORT.INSTAGRAM.POSTS_REPORT.CURRENT_POSTS" |
    "REPORT.INSTAGRAM.POSTS_REPORT.TITLE" |
    "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_MORE" |
    "REPORT.INSTAGRAM.POSTS_REPORT.VIEW_POST" |
    "REPORT.INSTAGRAM.STORIES_REPORT.ACTIVE_STORIES" |
    "REPORT.INSTAGRAM.STORIES_REPORT.NO_ACTIVE_STORIES_MESSAGE" |
    "REPORT.INSTAGRAM.STORIES_REPORT.NO_PAST_STORIES_MESSAGE" |
    "REPORT.INSTAGRAM.STORIES_REPORT.PAST_STORIES" |
    "REPORT.INSTAGRAM.STORIES_REPORT.TITLE" |
    "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_MORE" |
    "REPORT.INSTAGRAM.STORIES_REPORT.VIEW_POST" |
    "REPORT.INVALID_END_DATE" |
    "REPORT.INVALID_START_DATE" |
    "REPORT.KEYWORD" |
    "REPORT.LAST_LOGIN" |
    "REPORT.LEADS" |
    "REPORT.LIKES_COMMENTS_SHARES" |
    "REPORT.LIMITED" |
    "REPORT.LOCATION" |
    "REPORT.LOCATION_AD" |
    "REPORT.LOCATION_CONVERSION_TYPE_AD" |
    "REPORT.LOCATION_CONVERSION_TYPE_KEYWORD" |
    "REPORT.LOCATION_KEYWORD" |
    "REPORT.LOGIN_DATE" |
    "REPORT.MAILCHIMP.TITLE" |
    "REPORT.MAXIMUM_SPEND" |
    "REPORT.MAXIMUM_SPEND_HINT" |
    "REPORT.MOST_USED_ACTIVITIES" |
    "REPORT.MULTIPLE_LOCATION_REPORT" |
    "REPORT.NEW_FOLLOWERS" |
    "REPORT.NEW_LIKES" |
    "REPORT.NEW_POSTS" |
    "REPORT.NEW_REPORT_SUMMARY" |
    "REPORT.NEW_VISITORS" |
    "REPORT.NO_ADWORD_STATS_FOUND" |
    "REPORT.NO_CAMPAIGNS_FOUND" |
    "REPORT.NO_UNREACHED_MARKET_FOR_PERIOD" |
    "REPORT.NO_VISITORS_FOUND" |
    "REPORT.NOT_ENOUGH_DATA" |
    "REPORT.NUMBER_OF_TEMPLATES_BUILT" |
    "REPORT.ORGANIC" |
    "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_CHECK_BACK_SOON" |
    "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_TOOLTIP" |
    "REPORT.OVERVIEW.EMAIL_CAMPAIGNS.TITLE" |
    "REPORT.OVERVIEW.FACEBOOK.TITLE" |
    "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT" |
    "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_HINT" |
    "REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_RATE" |
    "REPORT.PAID" |
    "REPORT.PAID_VIEWS_DEPRECATION" |
    "REPORT.PEOPLE_REACHED" |
    "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_GALLERY" |
    "REPORT.PLANNED_VS_ADHOC.BUILT_FROM_PLANNER" |
    "REPORT.PLANNED_VS_ADHOC.PLANNED_VS_ADHOC" |
    "REPORT.PLANNING_AND_EXECUTION" |
    "REPORT.PLATFORM" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.DOWNLOAD_CSV" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.EXPORT_CSV" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.ERROR_EXPORTING_CSV" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.EXPORTING_PLEASE_WAIT" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_ERROR" |
    "REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_SUCCESS" |
    "REPORT.POPULAR_CATEGORIES.BY_PLATFORM" |
    "REPORT.POPULAR_CATEGORIES.CATEGORY" |
    "REPORT.POPULAR_CATEGORIES.ORDER_IN_GALLERY" |
    "REPORT.POPULAR_CATEGORIES.TEMPLATE_CATEGORY_POPULARITY" |
    "REPORT.POPULAR_CATEGORIES.TIMES_USED" |
    "REPORT.POPULAR_CATEGORIES.TOTAL_USES" |
    "REPORT.POSITIVE_FEEDBACK" |
    "REPORT.POTENTIAL_ROI" |
    "REPORT.POTENTIAL_ROI_HINT" |
    "REPORT.PRINT_THIS_PAGE" |
    "REPORT.REACH" |
    "REPORT.REACHED" |
    "REPORT.RECIPIENTS" |
    "REPORT.RECOMMENDATIONS" |
    "REPORT.RECOMMENDED_SPEND" |
    "REPORT.RECOMMENDED_SPEND_HINT" |
    "REPORT.REPORT_SUMMARY" |
    "REPORT.REPORT_SUMMARY_TEXT.DELETED" |
    "REPORT.REPORT_SUMMARY_TEXT.INVALID_DATE_RANGE" |
    "REPORT.REPORT_SUMMARY_TEXT.SAVED" |
    "REPORT.REPORTS" |
    "REPORT.REPORTS_ARCHIVED" |
    "REPORT.REQUEST_SPEND_ADJUSTMENT" |
    "REPORT.RETURN_ON_INVESTMENT" |
    "REPORT.RETURN_ON_INVESTMENT_HINT" |
    "REPORT.RETURNING_VISITORS" |
    "REPORT.ROI" |
    "REPORT.ROI_HINT" |
    "REPORT.ROI_PERCENT" |
    "REPORT.SALES" |
    "REPORT.SCHEDULED_DATE" |
    "REPORT.SELECT_AT_LEAST_ONE_LOCATION" |
    "REPORT.SELECTED_LOCATIONS" |
    "REPORT.SELF_SERVICE_EVENTS" |
    "REPORT.SELF_SERVICE_OR_GENERAL_EVENTS" |
    "REPORT.SENT_DATE" |
    "REPORT.SHOW_ALL_ROWS" |
    "REPORT.SHOW_SUMMARY" |
    "REPORT.SPECIAL_REQUESTS" |
    "REPORT.SPEND" |
    "REPORT.START_DATE" |
    "REPORT.START_DATE_BEFORE_TODAY" |
    "REPORT.STATUS" |
    "REPORT.SUMMARY" |
    "REPORT.SUPPORTED_EVENTS" |
    "REPORT.TEMPLATE_USAGE" |
    "REPORT.TEMPLATES_BUILT_BY_TIME" |
    "REPORT.TOTAL" |
    "REPORT.TOTAL_CLOSE_RATIO" |
    "REPORT.TOTAL_CONVERSION_WORTH" |
    "REPORT.TOTAL_CONVERSIONS" |
    "REPORT.TOTAL_EVENTS" |
    "REPORT.TOTAL_LEADS" |
    "REPORT.TOTAL_POSTS" |
    "REPORT.TOTAL_SALES" |
    "REPORT.TOTAL_SPEND" |
    "REPORT.TOTAL_VISITORS" |
    "REPORT.TOUR_CLOSE_RATIO" |
    "REPORT.TOUR_SALE" |
    "REPORT.TOUR_SHOW_UPS" |
    "REPORT.TYPES.EMAIL_CAMPAIGNS.NAME" |
    "REPORT.TYPES.EMAIL_CAMPAIGNS.TITLE" |
    "REPORT.TYPES.FACEBOOK.NAME" |
    "REPORT.TYPES.FACEBOOK.TITLE" |
    "REPORT.TYPES.GOOGLE_MY_BUSINESS.NAME" |
    "REPORT.TYPES.GOOGLE_MY_BUSINESS.TITLE" |
    "REPORT.TYPES.INSTAGRAM.NAME" |
    "REPORT.TYPES.INSTAGRAM.TITLE" |
    "REPORT.TYPES.OVERVIEW.NAME" |
    "REPORT.TYPES.OVERVIEW.TITLE" |
    "REPORT.TYPES.PAID_MEDIA.NAME" |
    "REPORT.TYPES.PAID_MEDIA.TITLE" |
    "REPORT.TYPES.TITLE" |
    "REPORT.UNIQUE_CLICKS" |
    "REPORT.UNIQUE_OPENED" |
    "REPORT.UNREACHED_MARKET" |
    "REPORT.UNREACHED_MARKET_HINT" |
    "REPORT.VALUE_PER_CONVERSION" |
    "REPORT.VISITORS" |
    "REPORT.WAIT_FOR_LOCATIONS" |
    "REPORT.WALK_IN_CLOSE_RATIO" |
    "REPORT.WALK_IN_SALE" |
    "REPORT.WALK_IN_TOTAL" |
    "REPORT.WEBSITE" |
    "REQUESTS.AMENDMENTS_REQUESTED" |
    "REQUESTS.AWAITING_APPROVAL" |
    "REQUESTS.AWAITING_HEAD_OFFICE_APPROVAL" |
    "REQUESTS.BEGIN_PAYMENT" |
    "REQUESTS.BRIEF" |
    "REQUESTS.CLICK_TO_LOAD_CLOSED_REQUESTS" |
    "REQUESTS.CLIENT_LOCATION" |
    "REQUESTS.CLOSED" |
    "REQUESTS.DATE_REQUESTED_BY" |
    "REQUESTS.DATE_REQUIRED_BY" |
    "REQUESTS.DATE_SUBMITTED" |
    "REQUESTS.DELIVERABLES" |
    "REQUESTS.EMAILS.VIEW_SPECIAL_REQUEST" |
    "REQUESTS.ESCALATED" |
    "REQUESTS.FAILED_TO_GET_SPECIAL_REQUEST" |
    "REQUESTS.FAILED_TO_GET_SPECIAL_REQUESTS" |
    "REQUESTS.FILTER.CLIENT" |
    "REQUESTS.FILTER.DATE" |
    "REQUESTS.FILTER.STATUS" |
    "REQUESTS.FILTER.TITLE" |
    "REQUESTS.ID" |
    "REQUESTS.IN_PROGRESS" |
    "REQUESTS.INVALID_DATE_REQUIRED_BY" |
    "REQUESTS.LOAD_MANAGERS_FAILED" |
    "REQUESTS.MORE_INFO_REQUIRED" |
    "REQUESTS.NEW_REQUEST" |
    "REQUESTS.PAYMENT_REQUIRED" |
    "REQUESTS.PLEASE_ENTER_DELIVERABLES" |
    "REQUESTS.QUOTE" |
    "REQUESTS.QUOTE_APPROVED" |
    "REQUESTS.QUOTE_REJECTED" |
    "REQUESTS.QUOTE_SENT" |
    "REQUESTS.QUOTED" |
    "REQUESTS.REQUEST_SAVED" |
    "REQUESTS.RETRIEVE_SPECIAL_REQUEST" |
    "REQUESTS.SAVE_SPECIAL_REQUEST" |
    "REQUESTS.SELECTED_DELIVERABLES" |
    "REQUESTS.SEND_QUOTE" |
    "REQUESTS.STATUS" |
    "REQUESTS.SUBMITTED" |
    "REQUESTS.UPDATED" |
    "ROADMAP.LATER.HEADING" |
    "ROADMAP.LATER.ITEMS.ITEM_1" |
    "ROADMAP.LATER.ITEMS.ITEM_2" |
    "ROADMAP.LATER.ITEMS.ITEM_3" |
    "ROADMAP.LATER.ITEMS.ITEM_4" |
    "ROADMAP.LATER.ITEMS.ITEM_5" |
    "ROADMAP.NEXT.HEADING" |
    "ROADMAP.NEXT.ITEMS.ITEM_1" |
    "ROADMAP.NEXT.ITEMS.ITEM_2" |
    "ROADMAP.NEXT.ITEMS.ITEM_3" |
    "ROADMAP.NEXT.ITEMS.ITEM_4" |
    "ROADMAP.NEXT.ITEMS.ITEM_5" |
    "ROADMAP.NEXT.ITEMS.ITEM_6" |
    "ROADMAP.NEXT.ITEMS.ITEM_7" |
    "ROADMAP.NEXT.ITEMS.ITEM_8" |
    "ROADMAP.NOW.HEADING" |
    "ROADMAP.NOW.ITEMS.ITEM_1" |
    "ROADMAP.NOW.ITEMS.ITEM_2" |
    "ROADMAP.NOW.ITEMS.ITEM_3" |
    "ROADMAP.NOW.ITEMS.ITEM_4" |
    "ROADMAP.NOW.ITEMS.ITEM_5" |
    "ROADMAP.NOW.ITEMS.ITEM_6" |
    "ROADMAP.NOW.ITEMS.ITEM_7" |
    "ROADMAP.NOW.ITEMS.ITEM_8" |
    "ROADMAP.RECENTLY_DELIVERED.HEADING" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_1" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_2" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_3" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_4" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_5" |
    "ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_6" |
    "SCHEDULE.EMAILS.DOWNLOAD_THE_APP" |
    "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_2" |
    "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_3" |
    "SCHEDULE.EMAILS.NO_DEVICES.HEADING_1" |
    "SCHEDULE.EMAILS.NO_DEVICES.SUBJECT_LINE" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.CONFIRM" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_LEGACY" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_SCHEDULING" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.FAILED_TO_DELETE" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.SUCCESSFULLY_DELETED_POST" |
    "SCHEDULE.PAGE.DIALOGS.DELETE.TITLE" |
    "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.FAILED_TO_EDIT" |
    "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.SUCCESSFULLY_EDITED_CAPTION" |
    "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.TITLE" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.CONFIRM" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_LEGACY" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_SCHEDULING" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.FAILED_TO_RESCHEDULE" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.SUCCESSFULLY_RESCHEDULED_POST" |
    "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.TITLE" |
    "SCHEDULE.PAGE.HEADER_TITLE" |
    "SCHEDULE.PAGE.RESCHEDULE" |
    "SCHEDULE.PAGE.TABLE.HEADERS.ACTION" |
    "SCHEDULE.PAGE.TABLE.HEADERS.CAPTION" |
    "SCHEDULE.PAGE.TABLE.HEADERS.LOCATIONS" |
    "SCHEDULE.PAGE.TABLE.HEADERS.POST" |
    "SCHEDULE.PAGE.TABLE.HEADERS.TIME" |
    "SCHEDULE.PAGE.TABLE.LOAD_NEWER_POSTS" |
    "SCHEDULE.PAGE.TABLE.LOAD_OLDER_POSTS" |
    "SCHEDULE.POSTS.CAPTION" |
    "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD" |
    "SCHEDULE.POSTS.COPIED_TO_CLIPBOARD_FAILED" |
    "SCHEDULE.POSTS.COPY_CAPTION" |
    "SCHEDULE.POSTS.DOWNLOAD_IMAGE" |
    "SCHEDULE.POSTS.GET_SCHEDULED_DETAILS" |
    "SCHEDULE.POSTS.UNABLE_TO_FIND_POST" |
    "SCHEDULE.POSTS.UNABLE_TO_FIND_POST_HEADING" |
    "SCHEDULE.SCHEDULED_WITH_MOBILE_APP" |
    "SHOPPING_CART.ADD_TO_CART" |
    "SHOPPING_CART.CHECKOUT.CARD_DETAILS" |
    "SHOPPING_CART.CHECKOUT.CHECKOUT" |
    "SHOPPING_CART.CHECKOUT.COMPLETE_PAYMENT" |
    "SHOPPING_CART.CHECKOUT.DELETE_ITEM" |
    "SHOPPING_CART.CHECKOUT.DELETE_ITEM_CONFIRMATION" |
    "SHOPPING_CART.CHECKOUT.INC_TAX" |
    "SHOPPING_CART.CHECKOUT.PAYMENT_PENDING" |
    "SHOPPING_CART.CHECKOUT.PAYMENT_SUCCESSFUL" |
    "SHOPPING_CART.CHECKOUT.PRINT_ORDER" |
    "SHOPPING_CART.CHECKOUT.PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY" |
    "SHOPPING_CART.CHECKOUT.PURCHASE_COMPLETE" |
    "SHOPPING_CART.CHECKOUT.SHIPPING" |
    "SHOPPING_CART.CHECKOUT.SHIPPING_DETAILS_INVALID" |
    "SHOPPING_CART.CHECKOUT.UPDATE_ITEM_QUANTITY" |
    "SHOPPING_CART.CHECKOUT.VIEW_RECEIPT" |
    "SHOPPING_CART.CHECKOUT.YOUR_RECEIPT_CAN_BE_VIEWED_BELOW" |
    "SHOPPING_CART.CHECKOUT_NOW" |
    "SHOPPING_CART.CHECKOUT_YOUR_PRINT_ITEMS" |
    "SHOPPING_CART.FETCH_ITEM_COUNT" |
    "SHOPPING_CART.FETCH_ORDERS" |
    "SHOPPING_CART.PRINT_REQUEST_ADDED_TO_CART" |
    "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_NOT_RESOLVED_CONTACT_SUPPORT" |
    "TERMS.HEADING" |
    "TERMS.SECTION_01.DESCRIPTION" |
    "TERMS.SECTION_01.HEADING" |
    "TERMS.SECTION_01.PART_A" |
    "TERMS.SECTION_01.PART_B" |
    "TERMS.SECTION_02.DESCRIPTION" |
    "TERMS.SECTION_02.HEADING" |
    "TERMS.SECTION_03.DESCRIPTION" |
    "TERMS.SECTION_03.HEADING" |
    "TERMS.SECTION_04.HEADING" |
    "TERMS.SECTION_04.PART_01" |
    "TERMS.SECTION_04.PART_02" |
    "TERMS.SECTION_05.HEADING" |
    "TERMS.SECTION_05.PART_01.HEADING" |
    "TERMS.SECTION_05.PART_01.PART_A" |
    "TERMS.SECTION_05.PART_01.PART_B" |
    "TERMS.SECTION_05.PART_01.PART_C" |
    "TERMS.SECTION_05.PART_01.PART_D" |
    "TERMS.SECTION_06.HEADING" |
    "TERMS.SECTION_06.PART_01.HEADING" |
    "TERMS.SECTION_06.PART_01.PART_A" |
    "TERMS.SECTION_06.PART_01.PART_B" |
    "TERMS.SECTION_06.PART_01.PART_C" |
    "TERMS.SECTION_06.PART_01.PART_D" |
    "TERMS.SECTION_06.PART_01.PART_E" |
    "TERMS.SECTION_06.PART_01.PART_F" |
    "TERMS.SECTION_06.PART_01.PART_G" |
    "TERMS.SECTION_06.PART_02.HEADING" |
    "TERMS.SECTION_07.HEADING" |
    "TERMS.SECTION_07.PART_01.HEADING" |
    "TERMS.SECTION_07.PART_01.PART_A" |
    "TERMS.SECTION_07.PART_01.PART_B" |
    "TERMS.SECTION_07.PART_02.HEADING" |
    "TERMS.SECTION_07.PART_03.HEADING" |
    "TERMS.SECTION_07.PART_04.HEADING" |
    "TERMS.SECTION_07.PART_04.PART_A" |
    "TERMS.SECTION_07.PART_04.PART_B" |
    "TERMS.SECTION_07.PART_05.HEADING" |
    "TERMS.SECTION_08.DESCRIPTION" |
    "TERMS.SECTION_08.HEADING" |
    "TERMS.SECTION_08.PART_A" |
    "TERMS.SECTION_08.PART_B" |
    "TERMS.SECTION_09.HEADING" |
    "TERMS.SECTION_09.PART_01" |
    "TERMS.SECTION_09.PART_02" |
    "TERMS.SECTION_10.HEADING" |
    "TERMS.SECTION_10.PART_A.HEADING" |
    "TERMS.SECTION_10.PART_A.PART_01" |
    "TERMS.SECTION_10.PART_A.PART_02" |
    "TERMS.SECTION_10.PART_A.PART_03" |
    "TERMS.SECTION_10.PART_A.PART_04" |
    "TERMS.SECTION_10.PART_A.PART_05" |
    "TERMS.SECTION_10.PART_B.HEADING" |
    "TERMS.SECTION_10.PART_B.PART_01" |
    "TERMS.SECTION_10.PART_B.PART_02" |
    "TERMS.SECTION_10.PART_B.PART_03" |
    "TERMS.SECTION_10.PART_B.PART_04" |
    "TERMS.SECTION_11.HEADING" |
    "TERMS.SECTION_11.PART_A.HEADING" |
    "TERMS.SECTION_11.PART_A.PART_01" |
    "TERMS.SECTION_11.PART_A.PART_02" |
    "TERMS.SECTION_11.PART_A.PART_03" |
    "TERMS.SECTION_11.PART_A.PART_04" |
    "TERMS.SECTION_11.PART_A.PART_05" |
    "TERMS.SECTION_11.PART_A.PART_06" |
    "TERMS.SECTION_11.PART_B.HEADING" |
    "TERMS.SECTION_12.HEADING" |
    "TERMS.SECTION_12.PART_01.HEADING" |
    "TERMS.SECTION_12.PART_01.PART_A" |
    "TERMS.SECTION_12.PART_01.PART_B" |
    "TERMS.SECTION_12.PART_02" |
    "TERMS.SECTION_12.PART_03" |
    "TERMS.SECTION_13.HEADING" |
    "TERMS.SECTION_13.PART_01" |
    "TERMS.SECTION_13.PART_02" |
    "TERMS.SECTION_14.DESCRIPTION" |
    "TERMS.SECTION_14.HEADING" |
    "TERMS.SECTION_15.HEADING" |
    "TERMS.SECTION_15.PART_01" |
    "TERMS.SECTION_15.PART_02.HEADING" |
    "TERMS.SECTION_15.PART_02.PART_A" |
    "TERMS.SECTION_15.PART_02.PART_B.HEADING" |
    "TERMS.SECTION_15.PART_02.PART_B.PART_01" |
    "TERMS.SECTION_15.PART_02.PART_B.PART_02" |
    "TERMS.SECTION_15.PART_02.PART_C" |
    "TERMS.SECTION_16.DESCRIPTION" |
    "TERMS.SECTION_16.HEADING" |
    "TERMS.SECTION_16.PART_01.HEADING" |
    "TERMS.SECTION_16.PART_01.PART_A" |
    "TERMS.SECTION_16.PART_01.PART_B" |
    "TERMS.SECTION_16.PART_01.PART_C" |
    "TERMS.SECTION_16.PART_01.PART_D.HEADING" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_01" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_02" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_03" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_04" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_05" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_06" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_07" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_08" |
    "TERMS.SECTION_16.PART_01.PART_D.PART_09" |
    "TERMS.SECTION_17.HEADING" |
    "TERMS.SECTION_17.PART_01.HEADING" |
    "TERMS.SECTION_17.PART_01.PART_A" |
    "TERMS.SECTION_17.PART_01.PART_B" |
    "TERMS.SECTION_17.PART_01.PART_C" |
    "TERMS.SECTION_17.PART_01.PART_D" |
    "TERMS.SECTION_17.PART_01.PART_E" |
    "TERMS.SECTION_17.PART_02.HEADING" |
    "TERMS.SECTION_17.PART_02.PART_A" |
    "TERMS.SECTION_17.PART_02.PART_B" |
    "TERMS.SECTION_17.PART_02.PART_C" |
    "TERMS.SECTION_17.PART_02.PART_D" |
    "TERMS.SECTION_17.PART_03.HEADING" |
    "TERMS.SECTION_17.PART_03.PART_A" |
    "TERMS.SECTION_17.PART_03.PART_B" |
    "TERMS.SECTION_18.DESCRIPTION" |
    "TERMS.SECTION_18.HEADING" |
    "TERMS.SECTION_19.HEADING" |
    "TERMS.SECTION_19.PART_A" |
    "TERMS.SECTION_19.PART_B" |
    "TERMS.SECTION_19.PART_C" |
    "TERMS.SECTION_19.PART_D" |
    "TERMS.SECTION_19.PART_E" |
    "TERMS.SECTION_19.PART_F" |
    "TERMS.SECTION_19.PART_G" |
    "TERMS.SECTION_19.PART_H" |
    "TIMEZONES.ADAK" |
    "TIMEZONES.ADELAIDE" |
    "TIMEZONES.ALMATY" |
    "TIMEZONES.AMMAN" |
    "TIMEZONES.ANCHORAGE" |
    "TIMEZONES.APIA" |
    "TIMEZONES.ARAGUAINA" |
    "TIMEZONES.ASTRAKHAN" |
    "TIMEZONES.ASUNCION" |
    "TIMEZONES.AUCKLAND" |
    "TIMEZONES.AZORES" |
    "TIMEZONES.BAGHDAD" |
    "TIMEZONES.BAHIA" |
    "TIMEZONES.BAKU" |
    "TIMEZONES.BANGKOK" |
    "TIMEZONES.BARNAUL" |
    "TIMEZONES.BEIRUT" |
    "TIMEZONES.BERLIN" |
    "TIMEZONES.BOGOTA" |
    "TIMEZONES.BOUGAINVILLE" |
    "TIMEZONES.BRISBANE" |
    "TIMEZONES.BUCHAREST" |
    "TIMEZONES.BUDAPEST" |
    "TIMEZONES.BUENOS_AIRES" |
    "TIMEZONES.CAIRO" |
    "TIMEZONES.CALCUTTA" |
    "TIMEZONES.CANCUN" |
    "TIMEZONES.CAPE_VERDE" |
    "TIMEZONES.CARACAS" |
    "TIMEZONES.CASABLANCA" |
    "TIMEZONES.CAYENNE" |
    "TIMEZONES.CHATHAM" |
    "TIMEZONES.CHICAGO" |
    "TIMEZONES.CHIHUAHUA" |
    "TIMEZONES.CHISINAU" |
    "TIMEZONES.CHITA" |
    "TIMEZONES.COLOMBO" |
    "TIMEZONES.CUIABA" |
    "TIMEZONES.DAMASCUS" |
    "TIMEZONES.DARWIN" |
    "TIMEZONES.DENVER" |
    "TIMEZONES.DHAKA" |
    "TIMEZONES.DUBAI" |
    "TIMEZONES.EASTER" |
    "TIMEZONES.EDMONTON" |
    "TIMEZONES.ENDERBURY" |
    "TIMEZONES.EUCLA" |
    "TIMEZONES.FIJI" |
    "TIMEZONES.GAMBIER" |
    "TIMEZONES.GODTHAB" |
    "TIMEZONES.GRAND_TURK" |
    "TIMEZONES.GUADALCANAL" |
    "TIMEZONES.GUATEMALA" |
    "TIMEZONES.HALIFAX" |
    "TIMEZONES.HAVANA" |
    "TIMEZONES.HEBRON" |
    "TIMEZONES.HO_CHI_MINH" |
    "TIMEZONES.HOBART" |
    "TIMEZONES.HONOLULU" |
    "TIMEZONES.HOVD" |
    "TIMEZONES.INDIANAPOLIS" |
    "TIMEZONES.IRKUTSK" |
    "TIMEZONES.ISTANBUL" |
    "TIMEZONES.JERUSALEM" |
    "TIMEZONES.JOHANNESBURG" |
    "TIMEZONES.JUBA" |
    "TIMEZONES.KABUL" |
    "TIMEZONES.KALININGRAD" |
    "TIMEZONES.KAMCHATKA" |
    "TIMEZONES.KARACHI" |
    "TIMEZONES.KATMANDU" |
    "TIMEZONES.KHARTOUM" |
    "TIMEZONES.KIEV" |
    "TIMEZONES.KIRITIMATI" |
    "TIMEZONES.KRASNOYARSK" |
    "TIMEZONES.KUALA_LUMPUR" |
    "TIMEZONES.LA_PAZ" |
    "TIMEZONES.LAGOS" |
    "TIMEZONES.LONDON" |
    "TIMEZONES.LORD_HOWE" |
    "TIMEZONES.LOS_ANGELES" |
    "TIMEZONES.MAGADAN" |
    "TIMEZONES.MANILA" |
    "TIMEZONES.MARQUESAS" |
    "TIMEZONES.MAURITIUS" |
    "TIMEZONES.MELBOURNE" |
    "TIMEZONES.MEXICO_CITY" |
    "TIMEZONES.MINSK" |
    "TIMEZONES.MIQUELON" |
    "TIMEZONES.MONTEVIDEO" |
    "TIMEZONES.MOSCOW" |
    "TIMEZONES.NAIROBI" |
    "TIMEZONES.NEW_YORK" |
    "TIMEZONES.NEWFOUNDLAND" |
    "TIMEZONES.NORFOLK" |
    "TIMEZONES.NORONHA" |
    "TIMEZONES.NOVOSIBIRSK" |
    "TIMEZONES.OMSK" |
    "TIMEZONES.PAGO_PAGO" |
    "TIMEZONES.PARIS" |
    "TIMEZONES.PERTH" |
    "TIMEZONES.PHOENIX" |
    "TIMEZONES.PITCAIRN" |
    "TIMEZONES.PORT_AU_PRINCE" |
    "TIMEZONES.PORT_MORESBY" |
    "TIMEZONES.PUNTA_ARENAS" |
    "TIMEZONES.PYONGYANG" |
    "TIMEZONES.QYZYLORDA" |
    "TIMEZONES.RANGOON" |
    "TIMEZONES.REGINA" |
    "TIMEZONES.REYKJAVIK" |
    "TIMEZONES.RIYADH" |
    "TIMEZONES.SAKHALIN" |
    "TIMEZONES.SAMARA" |
    "TIMEZONES.SANTIAGO" |
    "TIMEZONES.SAO_PAULO" |
    "TIMEZONES.SAO_TOME" |
    "TIMEZONES.SARATOV" |
    "TIMEZONES.SEOUL" |
    "TIMEZONES.SHANGHAI" |
    "TIMEZONES.SINGAPORE" |
    "TIMEZONES.SREDNEKOLYMSK" |
    "TIMEZONES.ST_JOHNS" |
    "TIMEZONES.SYDNEY" |
    "TIMEZONES.TAIPEI" |
    "TIMEZONES.TARAWA" |
    "TIMEZONES.TASHKENT" |
    "TIMEZONES.TBILISI" |
    "TIMEZONES.TEHRAN" |
    "TIMEZONES.TIJUANA" |
    "TIMEZONES.TOKYO" |
    "TIMEZONES.TOMSK" |
    "TIMEZONES.TONGATAPU" |
    "TIMEZONES.TORONTO" |
    "TIMEZONES.TRIPOLI" |
    "TIMEZONES.ULAANBAATAR" |
    "TIMEZONES.VANCOUVER" |
    "TIMEZONES.VLADIVOSTOK" |
    "TIMEZONES.VOLGOGRAD" |
    "TIMEZONES.WARSAW" |
    "TIMEZONES.WHITEHORSE" |
    "TIMEZONES.WINDHOEK" |
    "TIMEZONES.WINNIPEG" |
    "TIMEZONES.YAKUTSK" |
    "TIMEZONES.YEKATERINBURG" |
    "TIMEZONES.YEREVAN" |
    "USER.BULK_DELETE_MODAL.CONFIRM_TEXT" |
    "USER.BULK_DELETE_MODAL.MESSAGE" |
    "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON" |
    "USER.BULK_DELETE_MODAL.SUBMIT_BUTTON_plural" |
    "USER.BULK_DELETE_MODAL.TITLE" |
    "USER.BULK_DELETE_MODAL.TITLE_plural" |
    "USER.BULK_DELETE_MODAL.TOASTS.ERROR" |
    "USER.BULK_DELETE_MODAL.TOASTS.SUCCESS" |
    "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_BOTH" |
    "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_PASSWORD_RESETS" |
    "USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_USER_INVITES" |
    "USER.BULK_RESET_PASSWORDS_MODAL.DESCRIPTION" |
    "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_PARTIAL_ERROR" |
    "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_BOTH_SUCCESS" |
    "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_PASSWORD_RESETS_SUCCESS" |
    "USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_USER_INVITES_SUCCESS" |
    "USER.BULK_RESET_PASSWORDS_MODAL.RESEND_USER_INVITES_TITLE" |
    "USER.BULK_RESET_PASSWORDS_MODAL.TITLE" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TOOLTIP" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TITLE" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.MESSAGE" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TOOLTIP" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.SUBMIT_BUTTON" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.TITLE" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.ERROR" |
    "USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.SUCCESS" |
    "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP" |
    "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP_plural" |
    "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TITLE" |
    "USER.BULK_UPDATE_ROLES_MODAL.MESSAGE" |
    "USER.BULK_UPDATE_ROLES_MODAL.NEW_ROLE_TOOLTIP" |
    "USER.BULK_UPDATE_ROLES_MODAL.PARTIAL_EXISTING_ROLE_TOOLTIP" |
    "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP" |
    "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP_plural" |
    "USER.BULK_UPDATE_ROLES_MODAL.ROLE_LIST_TITLE" |
    "USER.BULK_UPDATE_ROLES_MODAL.SUBMIT_BUTTON" |
    "USER.BULK_UPDATE_ROLES_MODAL.TITLE" |
    "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.ERROR" |
    "USER.BULK_UPDATE_ROLES_MODAL.TOASTS.SUCCESS" |
    "USER.EDIT_USER_DETAILS.ADD_NOTIFICATIONS" |
    "USER.EDIT_USER_DETAILS.ADD_ROLE" |
    "USER.EDIT_USER_DETAILS.CONFIRM_DELETE_USER" |
    "USER.EDIT_USER_DETAILS.HEADERS.ASSIGNED_LOCATIONS" |
    "USER.EDIT_USER_DETAILS.HEADERS.GUIDED_TOUR" |
    "USER.EDIT_USER_DETAILS.HEADERS.NOTIFICATIONS" |
    "USER.EDIT_USER_DETAILS.HEADERS.ROLES" |
    "USER.EDIT_USER_DETAILS.HEADERS.USER_DETAILS" |
    "USER.EDIT_USER_DETAILS.NOTIFY_DELETE_USER_SUCCESS" |
    "USER.EDIT_USER_DETAILS.NOTIFY_SEND_PASSWORD_RESET_SUCCESS" |
    "USER.EDIT_USER_DETAILS.NOTIFY_UPDATE_USER_DETAILS_SUCCESS" |
    "USER.EDIT_USER_DETAILS.SAVE_ASSIGNED_LOCATIONS" |
    "USER.EDIT_USER_DETAILS.SAVE_USER_DETAILS" |
    "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.DELETE_USER" |
    "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.PLACEHOLDER" |
    "USER.EDIT_USER_DETAILS.SELECT_OPTIONS.SEND_PASSWORD_RESET_EMAIL";

export type TranslatableTextNoParams = {
    key: NoParamsKeys;
    keyId: NoParamsKeys;
    options?: TranslateOptions;
};

export type AccountDetailsImageMustBeSquareAndAtLeastMinimumSizeTranslatableText = {
    key: "ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE";
    keyId: "ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE";
    options: AccountDetailsImageMustBeSquareAndAtLeastMinimumSizeOptions;
};

export type AccountDetailsMinimumImageDimensionRequirementTranslatableText = {
    key: "ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT";
    keyId: "ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT";
    options: AccountDetailsMinimumImageDimensionRequirementOptions;
};

export type AccountMapCreateNewMapForTranslatableText = {
    key: "ACCOUNT.MAP.CREATE_NEW_MAP_FOR";
    keyId: "ACCOUNT.MAP.CREATE_NEW_MAP_FOR";
    options: AccountMapCreateNewMapForOptions;
};

export type AccountMapUnsupportedCurrencyTranslatableText = {
    key: "ACCOUNT.MAP.UNSUPPORTED_CURRENCY";
    keyId: "ACCOUNT.MAP.UNSUPPORTED_CURRENCY";
    options: AccountMapUnsupportedCurrencyOptions;
};

export type AdminBrandsAssignClientsToTranslatableText = {
    key: "ADMIN.BRANDS.ASSIGN_CLIENTS_TO";
    keyId: "ADMIN.BRANDS.ASSIGN_CLIENTS_TO";
    options: AdminBrandsAssignClientsToOptions;
};

export type AdminBrandsCheckClientsToAssignToTranslatableText = {
    key: "ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO";
    keyId: "ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO";
    options: AdminBrandsCheckClientsToAssignToOptions;
};

export type AdminBrandsThisWillPermanentlyDeleteTranslatableText = {
    key: "ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE";
    keyId: "ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE";
    options: AdminBrandsThisWillPermanentlyDeleteOptions;
};

export type AdminExternalAuthAppsConfirmDeleteTranslatableText = {
    key: "ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE";
    keyId: "ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE";
    options: AdminExternalAuthAppsConfirmDeleteOptions;
};

export type AdminMaintenanceStartTimeTranslatableText = {
    key: "ADMIN.MAINTENANCE.START_TIME";
    keyId: "ADMIN.MAINTENANCE.START_TIME";
    options: AdminMaintenanceStartTimeOptions;
};

export type AdminPayableServiceConfirmDeleteCostTranslatableText = {
    key: "ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST";
    keyId: "ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST";
    options: AdminPayableServiceConfirmDeleteCostOptions;
};

export type AdminPayableServiceCostInvalidPrecisionTranslatableText = {
    key: "ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION";
    keyId: "ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION";
    options: AdminPayableServiceCostInvalidPrecisionOptions;
};

export type AdminSubscriptionsDefaultSubForTranslatableText = {
    key: "ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR";
    keyId: "ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR";
    options: AdminSubscriptionsDefaultSubForOptions;
};

export type AdminSubscriptionsDeleteRecurringConfirmTranslatableText = {
    key: "ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM";
    keyId: "ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM";
    options: AdminSubscriptionsDeleteRecurringConfirmOptions;
};

export type AdminSubscriptionsLocationInitialSubscriptionForTranslatableText = {
    key: "ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR";
    keyId: "ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR";
    options: AdminSubscriptionsLocationInitialSubscriptionForOptions;
};

export type AgenciesAgencyConfirmDeleteTranslatableText = {
    key: "AGENCIES.AGENCY.CONFIRM_DELETE";
    keyId: "AGENCIES.AGENCY.CONFIRM_DELETE";
    options: AgenciesAgencyConfirmDeleteOptions;
};

export type AgenciesAgencyDeletedConfirmationMessageTranslatableText = {
    key: "AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE";
    keyId: "AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE";
    options: AgenciesAgencyDeletedConfirmationMessageOptions;
};

export type AgenciesUserAddNewUserToTranslatableText = {
    key: "AGENCIES.USER.ADD_NEW_USER_TO";
    keyId: "AGENCIES.USER.ADD_NEW_USER_TO";
    options: AgenciesUserAddNewUserToOptions;
};

export type AgenciesUserRemoveUserTranslatableText = {
    key: "AGENCIES.USER.REMOVE_USER";
    keyId: "AGENCIES.USER.REMOVE_USER";
    options: AgenciesUserRemoveUserOptions;
};

export type AgenciesUserUserAddedSuccessMessageTranslatableText = {
    key: "AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE";
    keyId: "AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE";
    options: AgenciesUserUserAddedSuccessMessageOptions;
};

export type AgenciesUserUserRemovedSuccessMessageTranslatableText = {
    key: "AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE";
    keyId: "AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE";
    options: AgenciesUserUserRemovedSuccessMessageOptions;
};

export type AgencyClientBrandColoursCreatedBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR";
    options: AgencyClientBrandColoursCreatedBrandColourOptions;
};

export type AgencyClientBrandColoursDeleteConfirmationTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION";
    options: AgencyClientBrandColoursDeleteConfirmationOptions;
};

export type AgencyClientBrandColoursSuccessfullyAddedBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR";
    options: AgencyClientBrandColoursSuccessfullyAddedBrandColourOptions;
};

export type AgencyClientBrandColoursSuccessfullyRenamedBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR";
    options: AgencyClientBrandColoursSuccessfullyRenamedBrandColourOptions;
};

export type AgencyClientBrandColoursSuccessfullyUpdatedBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR";
    options: AgencyClientBrandColoursSuccessfullyUpdatedBrandColourOptions;
};

export type AgencyClientBrandColoursUpdateBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR";
    options: AgencyClientBrandColoursUpdateBrandColourOptions;
};

export type AgencyClientBrandColoursUpdatedBrandColourTranslatableText = {
    key: "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR";
    keyId: "AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR";
    options: AgencyClientBrandColoursUpdatedBrandColourOptions;
};

export type AgencyClientBuilderTemplateCategoriesConfirmDeleteTranslatableText = {
    key: "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE";
    keyId: "AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE";
    options: AgencyClientBuilderTemplateCategoriesConfirmDeleteOptions;
};

export type AgencyClientLinksDeleteConfirmationTranslatableText = {
    key: "AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION";
    keyId: "AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION";
    options: AgencyClientLinksDeleteConfirmationOptions;
};

export type AgencyClientLocationActivitiesDeleteActivityTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY";
    keyId: "AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY";
    options: AgencyClientLocationActivitiesDeleteActivityOptions;
};

export type AgencyClientLocationActivitiesMigrateChannelConfirmClickDeleteChannelTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL";
    keyId: "AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL";
    options: AgencyClientLocationActivitiesMigrateChannelConfirmClickDeleteChannelOptions;
};

export type AgencyClientLocationFeaturedTemplateSetsDeleteTemplateTagTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG";
    keyId: "AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG";
    options: AgencyClientLocationFeaturedTemplateSetsDeleteTemplateTagOptions;
};

export type AgencyClientLocationLearnMenuAddSubSectionToSectionTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION";
    keyId: "AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION";
    options: AgencyClientLocationLearnMenuAddSubSectionToSectionOptions;
};

export type AgencyClientLocationLearnMenuDeleteSectionTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION";
    keyId: "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION";
    options: AgencyClientLocationLearnMenuDeleteSectionOptions;
};

export type AgencyClientLocationLearnMenuDeleteSubSectionTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION";
    keyId: "AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION";
    options: AgencyClientLocationLearnMenuDeleteSubSectionOptions;
};

export type AgencyClientLocationLearnMenuSubSectionsForTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR";
    keyId: "AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR";
    options: AgencyClientLocationLearnMenuSubSectionsForOptions;
};

export type AgencyClientLocationLocationDetailsDeleteConfirmationTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION";
    keyId: "AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION";
    options: AgencyClientLocationLocationDetailsDeleteConfirmationOptions;
};

export type AgencyClientLocationManageCreatedLocationErrorTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR";
    options: AgencyClientLocationManageCreatedLocationErrorOptions;
};

export type AgencyClientLocationManageCreatedLocationSuccessTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS";
    options: AgencyClientLocationManageCreatedLocationSuccessOptions;
};

export type AgencyClientLocationManageDeleteLocationErrorTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR";
    options: AgencyClientLocationManageDeleteLocationErrorOptions;
};

export type AgencyClientLocationManageDeleteLocationLabelTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL";
    options: AgencyClientLocationManageDeleteLocationLabelOptions;
};

export type AgencyClientLocationManageDeleteLocationSuccessTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS";
    options: AgencyClientLocationManageDeleteLocationSuccessOptions;
};

export type AgencyClientLocationManageEditDetailsTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS";
    options: AgencyClientLocationManageEditDetailsOptions;
};

export type AgencyClientLocationManageNoFieldValueTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE";
    keyId: "AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE";
    options: AgencyClientLocationManageNoFieldValueOptions;
};

export type AgencyClientLocationNotifyLocationDeletedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED";
    keyId: "AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED";
    options: AgencyClientLocationNotifyLocationDeletedOptions;
};

export type AgencyClientLocationSummaryFieldsDeleteFieldConfirmTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM";
    keyId: "AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM";
    options: AgencyClientLocationSummaryFieldsDeleteFieldConfirmOptions;
};

export type AgencyClientLocationUsersAddNewUserToTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO";
    options: AgencyClientLocationUsersAddNewUserToOptions;
};

export type AgencyClientLocationUsersDeleteConfirmationTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION";
    options: AgencyClientLocationUsersDeleteConfirmationOptions;
};

export type AgencyClientLocationUsersDeleteUserTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.DELETE_USER";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.DELETE_USER";
    options: AgencyClientLocationUsersDeleteUserOptions;
};

export type AgencyClientLocationUsersUserAddedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.USER_ADDED";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.USER_ADDED";
    options: AgencyClientLocationUsersUserAddedOptions;
};

export type AgencyClientLocationUsersUserEditUserDeletedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED";
    options: AgencyClientLocationUsersUserEditUserDeletedOptions;
};

export type AgencyClientLocationUsersUserEditUserUpdatedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED";
    options: AgencyClientLocationUsersUserEditUserUpdatedOptions;
};

export type AgencyClientLocationUsersUserRemovedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED";
    keyId: "AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED";
    options: AgencyClientLocationUsersUserRemovedOptions;
};

export type AgencyClientLocationCategoriesDeleteConfirmationTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION";
    options: AgencyClientLocationCategoriesDeleteConfirmationOptions;
};

export type AgencyClientLocationCategoriesDeleteGroupTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP";
    options: AgencyClientLocationCategoriesDeleteGroupOptions;
};

export type AgencyClientLocationCategoriesDeleteLocationCategoryConfirmTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM";
    options: AgencyClientLocationCategoriesDeleteLocationCategoryConfirmOptions;
};

export type AgencyClientLocationCategoriesDeletedLocationCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY";
    options: AgencyClientLocationCategoriesDeletedLocationCategoryOptions;
};

export type AgencyClientLocationCategoriesNewOptionTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION";
    options: AgencyClientLocationCategoriesNewOptionOptions;
};

export type AgencyClientLocationCategoriesOptionAddedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED";
    options: AgencyClientLocationCategoriesOptionAddedOptions;
};

export type AgencyClientLocationCategoriesOptionDeletedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED";
    options: AgencyClientLocationCategoriesOptionDeletedOptions;
};

export type AgencyClientLocationCategoriesPartiallyAddedLocationCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY";
    options: AgencyClientLocationCategoriesPartiallyAddedLocationCategoryOptions;
};

export type AgencyClientLocationCategoriesPartiallyEditedLocationCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY";
    options: AgencyClientLocationCategoriesPartiallyEditedLocationCategoryOptions;
};

export type AgencyClientLocationCategoriesSuccessfullyAddedLocationCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY";
    options: AgencyClientLocationCategoriesSuccessfullyAddedLocationCategoryOptions;
};

export type AgencyClientLocationCategoriesSuccessfullyEditedLocationCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY";
    options: AgencyClientLocationCategoriesSuccessfullyEditedLocationCategoryOptions;
};

export type AgencyClientLocationCategoriesUpdatedLocationsForCategoryTranslatableText = {
    key: "AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY";
    keyId: "AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY";
    options: AgencyClientLocationCategoriesUpdatedLocationsForCategoryOptions;
};

export type AgencyClientLocationsDeleteClientTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT";
    keyId: "AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT";
    options: AgencyClientLocationsDeleteClientOptions;
};

export type AgencyClientLocationsEmailsSignUpAgencyInvitedYouTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU";
    keyId: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU";
    options: AgencyClientLocationsEmailsSignUpAgencyInvitedYouOptions;
};

export type AgencyClientLocationsEmailsSignUpWelcomeToDigitalStackTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK";
    keyId: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK";
    options: AgencyClientLocationsEmailsSignUpWelcomeToDigitalStackOptions;
};

export type AgencyClientLocationsEmailsSignedUpLocationSignedUpTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP";
    keyId: "AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP";
    options: AgencyClientLocationsEmailsSignedUpLocationSignedUpOptions;
};

export type AgencyClientLocationsEmailsUpdateBillingDetailsSubjectLineTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE";
    keyId: "AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE";
    options: AgencyClientLocationsEmailsUpdateBillingDetailsSubjectLineOptions;
};

export type AgencyClientLocationsNoLocationsAssignedTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED";
    keyId: "AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED";
    options: AgencyClientLocationsNoLocationsAssignedOptions;
};

export type AgencyClientLocationsPermanentlyDeletedClientTranslatableText = {
    key: "AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT";
    keyId: "AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT";
    options: AgencyClientLocationsPermanentlyDeletedClientOptions;
};

export type AgencyClientPlatformsConfirmRemovePlatformTranslatableText = {
    key: "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM";
    keyId: "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM";
    options: AgencyClientPlatformsConfirmRemovePlatformOptions;
};

export type AgencyClientPlatformsConfirmRemovePlatformTitleTranslatableText = {
    key: "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE";
    keyId: "AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE";
    options: AgencyClientPlatformsConfirmRemovePlatformTitleOptions;
};

export type AgencyClientUsersCountSelectedTranslatableText = {
    key: "AGENCY.CLIENT.USERS.COUNT_SELECTED";
    keyId: "AGENCY.CLIENT.USERS.COUNT_SELECTED";
    options: AgencyClientUsersCountSelectedOptions;
};

export type AgencyClientUsersSortDirectionTipTranslatableText = {
    key: "AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP";
    keyId: "AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP";
    options: AgencyClientUsersSortDirectionTipOptions;
};

export type AgencyClientsAddClientNewChannelTranslatableText = {
    key: "AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL";
    keyId: "AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL";
    options: AgencyClientsAddClientNewChannelOptions;
};

export type AgencyClientsClientTableActionsDeleteClientLabelTranslatableText = {
    key: "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL";
    keyId: "AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL";
    options: AgencyClientsClientTableActionsDeleteClientLabelOptions;
};

export type AgencyNotificationsSendConfirmMessageTranslatableText = {
    key: "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE";
    keyId: "AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE";
    options: AgencyNotificationsSendConfirmMessageOptions;
};

export type AgencyNotificationsSentByTranslatableText = {
    key: "AGENCY.NOTIFICATIONS.SENT_BY";
    keyId: "AGENCY.NOTIFICATIONS.SENT_BY";
    options: AgencyNotificationsSentByOptions;
};

export type AgencyPrintSkuGroupsPrintProviderAuthRequestConfirmationTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION";
    keyId: "AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION";
    options: AgencyPrintSkuGroupsPrintProviderAuthRequestConfirmationOptions;
};

export type AgencyPrintSkuGroupsSkuCreateSkuTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU";
    options: AgencyPrintSkuGroupsSkuCreateSkuOptions;
};

export type AgencyPrintSkuGroupsSkuEditSkuTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU";
    options: AgencyPrintSkuGroupsSkuEditSkuOptions;
};

export type AgencyPrintSkuGroupsSkuSkuDeleteConfirmationTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION";
    options: AgencyPrintSkuGroupsSkuSkuDeleteConfirmationOptions;
};

export type AgencyPrintSkuGroupsSkuGroupsDeleteSkuGroupTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP";
    options: AgencyPrintSkuGroupsSkuGroupsDeleteSkuGroupOptions;
};

export type AgencyPrintSkuGroupsSkuGroupsEditSkuGroupTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP";
    options: AgencyPrintSkuGroupsSkuGroupsEditSkuGroupOptions;
};

export type AgencyPrintSkuGroupsSkuGroupsSkuGroupDeleteConfirmationTranslatableText = {
    key: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION";
    keyId: "AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION";
    options: AgencyPrintSkuGroupsSkuGroupsSkuGroupDeleteConfirmationOptions;
};

export type AgencySendReportsReportClickedSubtitleTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE";
    keyId: "AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE";
    options: AgencySendReportsReportClickedSubtitleOptions;
};

export type AgencySendReportsReportReadSubtitleTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE";
    keyId: "AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE";
    options: AgencySendReportsReportReadSubtitleOptions;
};

export type AgencySendReportsReportSentFromTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.SENT_FROM";
    keyId: "AGENCY.SEND_REPORTS.REPORT.SENT_FROM";
    options: AgencySendReportsReportSentFromOptions;
};

export type AgencySendReportsReportSentSubtitleTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE";
    keyId: "AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE";
    options: AgencySendReportsReportSentSubtitleOptions;
};

export type AgencySendReportsReportSentToPart2TranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2";
    keyId: "AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2";
    options: AgencySendReportsReportSentToPart2Options;
};

export type AgencySendReportsReportSubtitleNotSentTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT";
    keyId: "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT";
    options: AgencySendReportsReportSubtitleNotSentOptions;
};

export type AgencySendReportsReportSubtitleSentByTranslatableText = {
    key: "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY";
    keyId: "AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY";
    options: AgencySendReportsReportSubtitleSentByOptions;
};

export type AppsCampaignsFoundInAdwordsThatMatchNameTranslatableText = {
    key: "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME";
    keyId: "APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME";
    options: AppsCampaignsFoundInAdwordsThatMatchNameOptions;
};

export type AppsConnectToAccountTranslatableText = {
    key: "APPS.CONNECT_TO_ACCOUNT";
    keyId: "APPS.CONNECT_TO_ACCOUNT";
    options: AppsConnectToAccountOptions;
};

export type AppsConnectingViaAccountTranslatableText = {
    key: "APPS.CONNECTING_VIA_ACCOUNT";
    keyId: "APPS.CONNECTING_VIA_ACCOUNT";
    options: AppsConnectingViaAccountOptions;
};

export type AppsCustomerIdTranslatableText = {
    key: "APPS.CUSTOMER_ID";
    keyId: "APPS.CUSTOMER_ID";
    options: AppsCustomerIdOptions;
};

export type AppsDisconnectFromAccountTranslatableText = {
    key: "APPS.DISCONNECT_FROM_ACCOUNT";
    keyId: "APPS.DISCONNECT_FROM_ACCOUNT";
    options: AppsDisconnectFromAccountOptions;
};

export type AppsErrorsDebugMessageWrapTranslatableText = {
    key: "APPS.ERRORS.DEBUG_MESSAGE_WRAP";
    keyId: "APPS.ERRORS.DEBUG_MESSAGE_WRAP";
    options: AppsErrorsDebugMessageWrapOptions;
};

export type AppsErrorsWeveEncounteredIssuesTranslatableText = {
    key: "APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES";
    keyId: "APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES";
    options: AppsErrorsWeveEncounteredIssuesOptions;
};

export type AppsFetchServiceConfigTranslatableText = {
    key: "APPS.FETCH_SERVICE_CONFIG";
    keyId: "APPS.FETCH_SERVICE_CONFIG";
    options: AppsFetchServiceConfigOptions;
};

export type AppsGoogleAdwordsCampaignNameMatchesCountContinueTranslatableText = {
    key: "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE";
    keyId: "APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE";
    options: AppsGoogleAdwordsCampaignNameMatchesCountContinueOptions;
};

export type AppsInstagramConnectedAccountInfoTranslatableText = {
    key: "APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO";
    keyId: "APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO";
    options: AppsInstagramConnectedAccountInfoOptions;
};

export type AppsPrintProviderSkuGroupAttachedTranslatableText = {
    key: "APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED";
    keyId: "APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED";
    options: AppsPrintProviderSkuGroupAttachedOptions;
};

export type AssetLibraryCollectionLimitReachedTranslatableText = {
    key: "ASSET_LIBRARY.COLLECTION_LIMIT_REACHED";
    keyId: "ASSET_LIBRARY.COLLECTION_LIMIT_REACHED";
    options: AssetLibraryCollectionLimitReachedOptions;
};

export type AssetLibraryMoveAssetsToFolderTranslatableText = {
    key: "ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER";
    keyId: "ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER";
    options: AssetLibraryMoveAssetsToFolderOptions;
};

export type AssetLibraryMovingAssetsTranslatableText = {
    key: "ASSET_LIBRARY.MOVING_ASSETS";
    keyId: "ASSET_LIBRARY.MOVING_ASSETS";
    options: AssetLibraryMovingAssetsOptions;
};

export type AssetLibrarySavingAssetsTranslatableText = {
    key: "ASSET_LIBRARY.SAVING_ASSETS";
    keyId: "ASSET_LIBRARY.SAVING_ASSETS";
    options: AssetLibrarySavingAssetsOptions;
};

export type AssetLibraryUploadingAssetsTranslatableText = {
    key: "ASSET_LIBRARY.UPLOADING_ASSETS";
    keyId: "ASSET_LIBRARY.UPLOADING_ASSETS";
    options: AssetLibraryUploadingAssetsOptions;
};

export type BuildAnimationFrameNumberOfCountTranslatableText = {
    key: "BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT";
    keyId: "BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT";
    options: BuildAnimationFrameNumberOfCountOptions;
};

export type BuildBuilderTemplateDeleteConfirmationModalConfirmationMessageTranslatableText = {
    key: "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE";
    keyId: "BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE";
    options: BuildBuilderTemplateDeleteConfirmationModalConfirmationMessageOptions;
};

export type BuildBuilderTemplateUpdateConfirmationModalConfirmationMessageTranslatableText = {
    key: "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE";
    keyId: "BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE";
    options: BuildBuilderTemplateUpdateConfirmationModalConfirmationMessageOptions;
};

export type BuildConfirmDeleteAllChannelDataTranslatableText = {
    key: "BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA";
    keyId: "BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA";
    options: BuildConfirmDeleteAllChannelDataOptions;
};

export type BuildEmailNoCampaginMonitorSetupForLocationTranslatableText = {
    key: "BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION";
    keyId: "BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION";
    options: BuildEmailNoCampaginMonitorSetupForLocationOptions;
};

export type BuildEmailZipValidationImageMissingTranslatableText = {
    key: "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING";
    keyId: "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING";
    options: BuildEmailZipValidationImageMissingOptions;
};

export type BuildEmailZipValidationImageUnreferencedTranslatableText = {
    key: "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED";
    keyId: "BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED";
    options: BuildEmailZipValidationImageUnreferencedOptions;
};

export type BuildErrorDimensionsForPngInPrintTemplatesLimitedTranslatableText = {
    key: "BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED";
    keyId: "BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED";
    options: BuildErrorDimensionsForPngInPrintTemplatesLimitedOptions;
};

export type BuildFontsAddFontForClientTranslatableText = {
    key: "BUILD.FONTS.ADD_FONT_FOR_CLIENT";
    keyId: "BUILD.FONTS.ADD_FONT_FOR_CLIENT";
    options: BuildFontsAddFontForClientOptions;
};

export type BuildFontsAreYouSureDeleteFamilyTranslatableText = {
    key: "BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY";
    keyId: "BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY";
    options: BuildFontsAreYouSureDeleteFamilyOptions;
};

export type BuildFontsDeleteFontFamilyTranslatableText = {
    key: "BUILD.FONTS.DELETE_FONT_FAMILY";
    keyId: "BUILD.FONTS.DELETE_FONT_FAMILY";
    options: BuildFontsDeleteFontFamilyOptions;
};

export type BuildFormatsSelectedTranslatableText = {
    key: "BUILD.FORMATS_SELECTED";
    keyId: "BUILD.FORMATS_SELECTED";
    options: BuildFormatsSelectedOptions;
};

export type BuildLocationDraftAreYouSureYouWantToOverrideTemplateRevisionWithTitleTranslatableText = {
    key: "BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE";
    keyId: "BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE";
    options: BuildLocationDraftAreYouSureYouWantToOverrideTemplateRevisionWithTitleOptions;
};

export type BuildLocationDraftSaveLocationRevisionWithTitleTranslatableText = {
    key: "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE";
    keyId: "BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE";
    options: BuildLocationDraftSaveLocationRevisionWithTitleOptions;
};

export type BuildLocationDraftSaveOverCurrentRevisionWithTitleTranslatableText = {
    key: "BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE";
    keyId: "BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE";
    options: BuildLocationDraftSaveOverCurrentRevisionWithTitleOptions;
};

export type BuildLocationLogoNotSetTranslatableText = {
    key: "BUILD.LOCATION_LOGO_NOT_SET";
    keyId: "BUILD.LOCATION_LOGO_NOT_SET";
    options: BuildLocationLogoNotSetOptions;
};

export type BuildLocationMapNotCreatedTranslatableText = {
    key: "BUILD.LOCATION_MAP_NOT_CREATED";
    keyId: "BUILD.LOCATION_MAP_NOT_CREATED";
    options: BuildLocationMapNotCreatedOptions;
};

export type BuildMobileAppTemplateValidationNotMobileCompatibleTranslatableText = {
    key: "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE";
    keyId: "BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE";
    options: BuildMobileAppTemplateValidationNotMobileCompatibleOptions;
};

export type BuildMultiImageMuliImageCounterTooltipTranslatableText = {
    key: "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP";
    keyId: "BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP";
    options: BuildMultiImageMuliImageCounterTooltipOptions;
};

export type BuildPrintExtraInfoTranslatableText = {
    key: "BUILD.PRINT.EXTRA_INFO";
    keyId: "BUILD.PRINT.EXTRA_INFO";
    options: BuildPrintExtraInfoOptions;
};

export type BuildPrintPageNumberOfCountTranslatableText = {
    key: "BUILD.PRINT.PAGE_NUMBER_OF_COUNT";
    keyId: "BUILD.PRINT.PAGE_NUMBER_OF_COUNT";
    options: BuildPrintPageNumberOfCountOptions;
};

export type BuildPrintPleaseEnterPageNumberBetweenTranslatableText = {
    key: "BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN";
    keyId: "BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN";
    options: BuildPrintPleaseEnterPageNumberBetweenOptions;
};

export type BuildPublishClubReadyCustomListDescriptionWarningTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING";
    keyId: "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING";
    options: BuildPublishClubReadyCustomListDescriptionWarningOptions;
};

export type BuildPublishClubReadyCustomListMatchesTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES";
    keyId: "BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES";
    options: BuildPublishClubReadyCustomListMatchesOptions;
};

export type BuildPublishClubReadyMatchedOutOfTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF";
    keyId: "BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF";
    options: BuildPublishClubReadyMatchedOutOfOptions;
};

export type BuildPublishClubReadyMoreClubCountTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT";
    keyId: "BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT";
    options: BuildPublishClubReadyMoreClubCountOptions;
};

export type BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO";
    keyId: "BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO";
    options: BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToOptions;
};

export type BuildPublishClubReadySenderNotVerifiedMessageTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE";
    keyId: "BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE";
    options: BuildPublishClubReadySenderNotVerifiedMessageOptions;
};

export type BuildPublishClubReadyWarnPublishTooLargeTranslatableText = {
    key: "BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE";
    keyId: "BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE";
    options: BuildPublishClubReadyWarnPublishTooLargeOptions;
};

export type BuildPublishFacebookPageListRemainingTranslatableText = {
    key: "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING";
    keyId: "BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING";
    options: BuildPublishFacebookPageListRemainingOptions;
};

export type BuildPublishFacebookPagesCountTranslatableText = {
    key: "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT";
    keyId: "BUILD.PUBLISH.FACEBOOK.PAGES_COUNT";
    options: BuildPublishFacebookPagesCountOptions;
};

export type BuildPublishGoogleMyBusinessCharacterLimitReachedTranslatableText = {
    key: "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED";
    keyId: "BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED";
    options: BuildPublishGoogleMyBusinessCharacterLimitReachedOptions;
};

export type BuildPublishHashtagsErrorLimitHashtagCountTranslatableText = {
    key: "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT";
    keyId: "BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT";
    options: BuildPublishHashtagsErrorLimitHashtagCountOptions;
};

export type BuildPublishHashtagsHashtagCharacterCountTranslatableText = {
    key: "BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT";
    keyId: "BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT";
    options: BuildPublishHashtagsHashtagCharacterCountOptions;
};

export type BuildPublishHashtagsHashtagTagCountTranslatableText = {
    key: "BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT";
    keyId: "BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT";
    options: BuildPublishHashtagsHashtagTagCountOptions;
};

export type BuildPublishInstagramExceededMaxImageCountHelpTextTranslatableText = {
    key: "BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT";
    keyId: "BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT";
    options: BuildPublishInstagramExceededMaxImageCountHelpTextOptions;
};

export type BuildPublishInstagramPostsWillExpireTranslatableText = {
    key: "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE";
    keyId: "BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE";
    options: BuildPublishInstagramPostsWillExpireOptions;
};

export type BuildPublishInstagramScheduledPostMustBeAtLeastMinsInFutureTranslatableText = {
    key: "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE";
    keyId: "BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE";
    options: BuildPublishInstagramScheduledPostMustBeAtLeastMinsInFutureOptions;
};

export type BuildPublishMultipleLocationsNoAccessHelpTranslatableText = {
    key: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP";
    keyId: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP";
    options: BuildPublishMultipleLocationsNoAccessHelpOptions;
};

export type BuildPublishMultipleLocationsPublishedVideosSuccessfullyTranslatableText = {
    key: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY";
    keyId: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY";
    options: BuildPublishMultipleLocationsPublishedVideosSuccessfullyOptions;
};

export type BuildPublishMultipleLocationsScheduledVideosSuccessfullyTranslatableText = {
    key: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY";
    keyId: "BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY";
    options: BuildPublishMultipleLocationsScheduledVideosSuccessfullyOptions;
};

export type BuildPublishMultiplePlatformsPublishedToPlatformTranslatableText = {
    key: "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM";
    keyId: "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM";
    options: BuildPublishMultiplePlatformsPublishedToPlatformOptions;
};

export type BuildPublishMultiplePlatformsPublishingToPlatformTranslatableText = {
    key: "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM";
    keyId: "BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM";
    options: BuildPublishMultiplePlatformsPublishingToPlatformOptions;
};

export type BuildPublishNoAccessHelpTranslatableText = {
    key: "BUILD.PUBLISH.NO_ACCESS_HELP";
    keyId: "BUILD.PUBLISH.NO_ACCESS_HELP";
    options: BuildPublishNoAccessHelpOptions;
};

export type BuildPublishPublishedSuccessfullyTranslatableText = {
    key: "BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY";
    keyId: "BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY";
    options: BuildPublishPublishedSuccessfullyOptions;
};

export type BuildPublishSavedSuccessfullyTranslatableText = {
    key: "BUILD.PUBLISH.SAVED_SUCCESSFULLY";
    keyId: "BUILD.PUBLISH.SAVED_SUCCESSFULLY";
    options: BuildPublishSavedSuccessfullyOptions;
};

export type BuildPublishScheduledSuccessfullyTranslatableText = {
    key: "BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY";
    keyId: "BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY";
    options: BuildPublishScheduledSuccessfullyOptions;
};

export type BuildPublishTwitterCannotPublishMultiImageHelpTextTranslatableText = {
    key: "BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT";
    keyId: "BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT";
    options: BuildPublishTwitterCannotPublishMultiImageHelpTextOptions;
};

export type BuildPublishWillReceiveNotificationTranslatableText = {
    key: "BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION";
    keyId: "BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION";
    options: BuildPublishWillReceiveNotificationOptions;
};

export type BuildPublishWillReceiveScheduledNotificationTranslatableText = {
    key: "BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION";
    keyId: "BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION";
    options: BuildPublishWillReceiveScheduledNotificationOptions;
};

export type BuildPublishWillRecieveSmsDetailsTranslatableText = {
    key: "BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS";
    keyId: "BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS";
    options: BuildPublishWillRecieveSmsDetailsOptions;
};

export type BuildPublishWillRecieveSmsReminderTranslatableText = {
    key: "BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER";
    keyId: "BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER";
    options: BuildPublishWillRecieveSmsReminderOptions;
};

export type BuildResourcesLoadedTranslatableText = {
    key: "BUILD.RESOURCES_LOADED";
    keyId: "BUILD.RESOURCES_LOADED";
    options: BuildResourcesLoadedOptions;
};

export type BuildTemplateAdminCopySuccessTranslatableText = {
    key: "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS";
    keyId: "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS";
    options: BuildTemplateAdminCopySuccessOptions;
};

export type BuildTemplateAdminCopySuccessExtendedTranslatableText = {
    key: "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED";
    keyId: "BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED";
    options: BuildTemplateAdminCopySuccessExtendedOptions;
};

export type ClientClientUsersLocationModalTitleTranslatableText = {
    key: "CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE";
    keyId: "CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE";
    options: ClientClientUsersLocationModalTitleOptions;
};

export type ClientClientUsersTableButtonBulkActionsSecondaryTranslatableText = {
    key: "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY";
    keyId: "CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY";
    options: ClientClientUsersTableButtonBulkActionsSecondaryOptions;
};

export type ClientEngagementHelpTextConnectionsCurrentlyRequiredPlatformsTranslatableText = {
    key: "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS";
    keyId: "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS";
    options: ClientEngagementHelpTextConnectionsCurrentlyRequiredPlatformsOptions;
};

export type ClientEngagementHelpTextConnectionsHowToSetRequiredPlatformsTranslatableText = {
    key: "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS";
    keyId: "CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS";
    options: ClientEngagementHelpTextConnectionsHowToSetRequiredPlatformsOptions;
};

export type ClientLocationActivityBuiltItemsCountTranslatableText = {
    key: "CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT";
    keyId: "CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT";
    options: ClientLocationActivityBuiltItemsCountOptions;
};

export type ClientOverviewTemplateCategoriesAssetsUsedTranslatableText = {
    key: "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED";
    keyId: "CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED";
    options: ClientOverviewTemplateCategoriesAssetsUsedOptions;
};

export type CommonAndXOtherLocationsTranslatableText = {
    key: "COMMON.AND_X_OTHER_LOCATIONS";
    keyId: "COMMON.AND_X_OTHER_LOCATIONS";
    options: CommonAndXOtherLocationsOptions;
};

export type CommonAreYouSureYouWantToDeleteNumAssetsTranslatableText = {
    key: "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS";
    keyId: "COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS";
    options: CommonAreYouSureYouWantToDeleteNumAssetsOptions;
};

export type CommonClientWithLocationTranslatableText = {
    key: "COMMON.CLIENT_WITH_LOCATION";
    keyId: "COMMON.CLIENT_WITH_LOCATION";
    options: CommonClientWithLocationOptions;
};

export type CommonConfirmModalInputTranslatableText = {
    key: "COMMON.CONFIRM_MODAL_INPUT";
    keyId: "COMMON.CONFIRM_MODAL_INPUT";
    options: CommonConfirmModalInputOptions;
};

export type CommonCopiedToClipboardTranslatableText = {
    key: "COMMON.COPIED_TO_CLIPBOARD";
    keyId: "COMMON.COPIED_TO_CLIPBOARD";
    options: CommonCopiedToClipboardOptions;
};

export type CommonCurrentLocationUsedMaxCollectionsTranslatableText = {
    key: "COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS";
    keyId: "COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS";
    options: CommonCurrentLocationUsedMaxCollectionsOptions;
};

export type CommonCurrentlySelectedCountTranslatableText = {
    key: "COMMON.CURRENTLY_SELECTED_COUNT";
    keyId: "COMMON.CURRENTLY_SELECTED_COUNT";
    options: CommonCurrentlySelectedCountOptions;
};

export type CommonDeleteSomethingTranslatableText = {
    key: "COMMON.DELETE_SOMETHING";
    keyId: "COMMON.DELETE_SOMETHING";
    options: CommonDeleteSomethingOptions;
};

export type CommonEditMultipleAssetsTranslatableText = {
    key: "COMMON.EDIT_MULTIPLE_ASSETS";
    keyId: "COMMON.EDIT_MULTIPLE_ASSETS";
    options: CommonEditMultipleAssetsOptions;
};

export type CommonFailedToTranslatableText = {
    key: "COMMON.FAILED_TO";
    keyId: "COMMON.FAILED_TO";
    options: CommonFailedToOptions;
};

export type CommonMustBeXOrMoreTranslatableText = {
    key: "COMMON.MUST_BE_X_OR_MORE";
    keyId: "COMMON.MUST_BE_X_OR_MORE";
    options: CommonMustBeXOrMoreOptions;
};

export type CommonNumOfTotalTranslatableText = {
    key: "COMMON.NUM_OF_TOTAL";
    keyId: "COMMON.NUM_OF_TOTAL";
    options: CommonNumOfTotalOptions;
};

export type CommonProgressModalStatusMessageTranslatableText = {
    key: "COMMON.PROGRESS_MODAL.STATUS_MESSAGE";
    keyId: "COMMON.PROGRESS_MODAL.STATUS_MESSAGE";
    options: CommonProgressModalStatusMessageOptions;
};

export type CommonRenameSomethingTranslatableText = {
    key: "COMMON.RENAME_SOMETHING";
    keyId: "COMMON.RENAME_SOMETHING";
    options: CommonRenameSomethingOptions;
};

export type CommonSearchWithinTranslatableText = {
    key: "COMMON.SEARCH_WITHIN";
    keyId: "COMMON.SEARCH_WITHIN";
    options: CommonSearchWithinOptions;
};

export type CommonSortDirectionTipTranslatableText = {
    key: "COMMON.SORT_DIRECTION_TIP";
    keyId: "COMMON.SORT_DIRECTION_TIP";
    options: CommonSortDirectionTipOptions;
};

export type CommonStepNOfCountTranslatableText = {
    key: "COMMON.STEP_N_OF_COUNT";
    keyId: "COMMON.STEP_N_OF_COUNT";
    options: CommonStepNOfCountOptions;
};

export type CommonUnsupportedImageFileTypeTranslatableText = {
    key: "COMMON.UNSUPPORTED_IMAGE_FILE_TYPE";
    keyId: "COMMON.UNSUPPORTED_IMAGE_FILE_TYPE";
    options: CommonUnsupportedImageFileTypeOptions;
};

export type CommonValidationStringTooLongTranslatableText = {
    key: "COMMON.VALIDATION.STRING_TOO_LONG";
    keyId: "COMMON.VALIDATION.STRING_TOO_LONG";
    options: CommonValidationStringTooLongOptions;
};

export type DashboardDueInNDaysTranslatableText = {
    key: "DASHBOARD.DUE_IN_N_DAYS";
    keyId: "DASHBOARD.DUE_IN_N_DAYS";
    options: DashboardDueInNDaysOptions;
};

export type DashboardDueInNWeeksTranslatableText = {
    key: "DASHBOARD.DUE_IN_N_WEEKS";
    keyId: "DASHBOARD.DUE_IN_N_WEEKS";
    options: DashboardDueInNWeeksOptions;
};

export type DashboardInNWeeksTranslatableText = {
    key: "DASHBOARD.IN_N_WEEKS";
    keyId: "DASHBOARD.IN_N_WEEKS";
    options: DashboardInNWeeksOptions;
};

export type DashboardPerformanceSummaryConnectAppsToSeePerformanceTranslatableText = {
    key: "DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE";
    keyId: "DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE";
    options: DashboardPerformanceSummaryConnectAppsToSeePerformanceOptions;
};

export type DashboardPerformanceSummaryFailedToGetPerformanceMetricTranslatableText = {
    key: "DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC";
    keyId: "DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC";
    options: DashboardPerformanceSummaryFailedToGetPerformanceMetricOptions;
};

export type DashboardPerformanceSummaryPerformanceHeadingTranslatableText = {
    key: "DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING";
    keyId: "DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING";
    options: DashboardPerformanceSummaryPerformanceHeadingOptions;
};

export type DashboardWelcomeMessageTranslatableText = {
    key: "DASHBOARD.WELCOME_MESSAGE";
    keyId: "DASHBOARD.WELCOME_MESSAGE";
    options: DashboardWelcomeMessageOptions;
};

export type DashboardWelcomePageNumCountriesTranslatableText = {
    key: "DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES";
    keyId: "DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES";
    options: DashboardWelcomePageNumCountriesOptions;
};

export type DashboardWelcomePageNumLocationsTranslatableText = {
    key: "DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS";
    keyId: "DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS";
    options: DashboardWelcomePageNumLocationsOptions;
};

export type EmailLinkWillExpireTranslatableText = {
    key: "EMAIL.LINK_WILL_EXPIRE";
    keyId: "EMAIL.LINK_WILL_EXPIRE";
    options: EmailLinkWillExpireOptions;
};

export type EmailSendToPrintArtworkHasBeenSentToTranslatableText = {
    key: "EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO";
    keyId: "EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO";
    options: EmailSendToPrintArtworkHasBeenSentToOptions;
};

export type EmailSendToPrintProviderWillBeInTouchTranslatableText = {
    key: "EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH";
    keyId: "EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH";
    options: EmailSendToPrintProviderWillBeInTouchOptions;
};

export type EmailSendToPrintSubjectTranslatableText = {
    key: "EMAIL.SEND_TO_PRINT.SUBJECT";
    keyId: "EMAIL.SEND_TO_PRINT.SUBJECT";
    options: EmailSendToPrintSubjectOptions;
};

export type EmailSendToPrintSubjectOrderNumberTranslatableText = {
    key: "EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER";
    keyId: "EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER";
    options: EmailSendToPrintSubjectOrderNumberOptions;
};

export type EmailSendToPrintUserInvoiceSubjectTranslatableText = {
    key: "EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT";
    keyId: "EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT";
    options: EmailSendToPrintUserInvoiceSubjectOptions;
};

export type ErrorsBadRequestErrorsPlannerActionDateBelowThresholdTranslatableText = {
    key: "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD";
    keyId: "ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD";
    options: ErrorsBadRequestErrorsPlannerActionDateBelowThresholdOptions;
};

export type ErrorsBadRequestErrorsValidationErrorTranslatableText = {
    key: "ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR";
    keyId: "ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR";
    options: ErrorsBadRequestErrorsValidationErrorOptions;
};

export type ErrorsBrandBrandColoursErrorAddingBrandColourTranslatableText = {
    key: "ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR";
    keyId: "ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR";
    options: ErrorsBrandBrandColoursErrorAddingBrandColourOptions;
};

export type ErrorsBrandBrandColoursErrorDeletingBrandColourTranslatableText = {
    key: "ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR";
    keyId: "ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR";
    options: ErrorsBrandBrandColoursErrorDeletingBrandColourOptions;
};

export type ErrorsBrandBrandColoursErrorRenamingBrandColourTranslatableText = {
    key: "ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR";
    keyId: "ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR";
    options: ErrorsBrandBrandColoursErrorRenamingBrandColourOptions;
};

export type ErrorsBrandBrandColoursErrorUpdatingBrandColourTranslatableText = {
    key: "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR";
    keyId: "ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR";
    options: ErrorsBrandBrandColoursErrorUpdatingBrandColourOptions;
};

export type ErrorsBrandLocationCategoriesErrorAddingLocationCategoryTranslatableText = {
    key: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY";
    keyId: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY";
    options: ErrorsBrandLocationCategoriesErrorAddingLocationCategoryOptions;
};

export type ErrorsBrandLocationCategoriesErrorDeletingLocationCategoryTranslatableText = {
    key: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY";
    keyId: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY";
    options: ErrorsBrandLocationCategoriesErrorDeletingLocationCategoryOptions;
};

export type ErrorsBrandLocationCategoriesErrorRenamingLocationCategoryTranslatableText = {
    key: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY";
    keyId: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY";
    options: ErrorsBrandLocationCategoriesErrorRenamingLocationCategoryOptions;
};

export type ErrorsBrandLocationCategoriesErrorUpdatingLocationsForCategoryTranslatableText = {
    key: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY";
    keyId: "ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY";
    options: ErrorsBrandLocationCategoriesErrorUpdatingLocationsForCategoryOptions;
};

export type ErrorsExceptionIdTranslatableText = {
    key: "ERRORS.EXCEPTION_ID";
    keyId: "ERRORS.EXCEPTION_ID";
    options: ErrorsExceptionIdOptions;
};

export type ErrorsExternalServiceErrorsAcrCloudTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD";
    options: ErrorsExternalServiceErrorsAcrCloudOptions;
};

export type ErrorsExternalServiceErrorsEmailFailureTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE";
    options: ErrorsExternalServiceErrorsEmailFailureOptions;
};

export type ErrorsExternalServiceErrorsEwayErrorTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR";
    options: ErrorsExternalServiceErrorsEwayErrorOptions;
};

export type ErrorsExternalServiceErrorsPassthroughTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH";
    options: ErrorsExternalServiceErrorsPassthroughOptions;
};

export type ErrorsExternalServiceErrorsTwitterErrorTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR";
    options: ErrorsExternalServiceErrorsTwitterErrorOptions;
};

export type ErrorsExternalServiceErrorsTwitterUnknownErrorTranslatableText = {
    key: "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR";
    keyId: "ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR";
    options: ErrorsExternalServiceErrorsTwitterUnknownErrorOptions;
};

export type ErrorsFacebookErrorsUntranslatedErrorMessageTranslatableText = {
    key: "ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE";
    keyId: "ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE";
    options: ErrorsFacebookErrorsUntranslatedErrorMessageOptions;
};

export type ErrorsFinaliseBillingDetailsUpdateErrorTranslatableText = {
    key: "ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR";
    keyId: "ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR";
    options: ErrorsFinaliseBillingDetailsUpdateErrorOptions;
};

export type ErrorsFitwareMemberEngagerUntranslatedErrorMessageTranslatableText = {
    key: "ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE";
    keyId: "ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE";
    options: ErrorsFitwareMemberEngagerUntranslatedErrorMessageOptions;
};

export type ErrorsFour51ProductMisconfiguredTranslatableText = {
    key: "ERRORS.FOUR51.PRODUCT_MISCONFIGURED";
    keyId: "ERRORS.FOUR51.PRODUCT_MISCONFIGURED";
    options: ErrorsFour51ProductMisconfiguredOptions;
};

export type ErrorsFour51UntranslatedErrorMessageTranslatableText = {
    key: "ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE";
    keyId: "ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE";
    options: ErrorsFour51UntranslatedErrorMessageOptions;
};

export type ErrorsInstagramErrorsUntranslatedErrorMessageTranslatableText = {
    key: "ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE";
    keyId: "ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE";
    options: ErrorsInstagramErrorsUntranslatedErrorMessageOptions;
};

export type ErrorsInvalidInputErrorsColourTranslatableText = {
    key: "ERRORS.INVALID_INPUT_ERRORS.COLOUR";
    keyId: "ERRORS.INVALID_INPUT_ERRORS.COLOUR";
    options: ErrorsInvalidInputErrorsColourOptions;
};

export type ErrorsInvalidInputErrorsFacebookPageIdMigrationTranslatableText = {
    key: "ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION";
    keyId: "ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION";
    options: ErrorsInvalidInputErrorsFacebookPageIdMigrationOptions;
};

export type ErrorsInvalidInputErrorsGraphqlInputTranslatableText = {
    key: "ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT";
    keyId: "ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT";
    options: ErrorsInvalidInputErrorsGraphqlInputOptions;
};

export type ErrorsMissingValueErrorsFacebookAdSetMissingEndDateTranslatableText = {
    key: "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE";
    keyId: "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE";
    options: ErrorsMissingValueErrorsFacebookAdSetMissingEndDateOptions;
};

export type ErrorsMissingValueErrorsFacebookAdSetMissingStartDateTranslatableText = {
    key: "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE";
    keyId: "ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE";
    options: ErrorsMissingValueErrorsFacebookAdSetMissingStartDateOptions;
};

export type ErrorsMissingValueErrorsReplacementValueForLocalResourceTranslatableText = {
    key: "ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE";
    keyId: "ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE";
    options: ErrorsMissingValueErrorsReplacementValueForLocalResourceOptions;
};

export type ErrorsNotFoundErrorsAgencyLocaleNotFoundWithIdTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID";
    keyId: "ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID";
    options: ErrorsNotFoundErrorsAgencyLocaleNotFoundWithIdOptions;
};

export type ErrorsNotFoundErrorsEntityNotFoundWithIdTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID";
    keyId: "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID";
    options: ErrorsNotFoundErrorsEntityNotFoundWithIdOptions;
};

export type ErrorsNotFoundErrorsEntityNotFoundWithTokenTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN";
    keyId: "ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN";
    options: ErrorsNotFoundErrorsEntityNotFoundWithTokenOptions;
};

export type ErrorsNotFoundErrorsEntityToDeleteNotFoundTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND";
    keyId: "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND";
    options: ErrorsNotFoundErrorsEntityToDeleteNotFoundOptions;
};

export type ErrorsNotFoundErrorsEntityToUpdateNotFoundTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND";
    keyId: "ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND";
    options: ErrorsNotFoundErrorsEntityToUpdateNotFoundOptions;
};

export type ErrorsNotFoundErrorsNoFacebookAccessTokenForLocationTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION";
    keyId: "ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION";
    options: ErrorsNotFoundErrorsNoFacebookAccessTokenForLocationOptions;
};

export type ErrorsNotFoundErrorsUserNotFoundWithIdTranslatableText = {
    key: "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID";
    keyId: "ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID";
    options: ErrorsNotFoundErrorsUserNotFoundWithIdOptions;
};

export type ErrorsOauthErrorsUnknownGrantTypeTranslatableText = {
    key: "ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE";
    keyId: "ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE";
    options: ErrorsOauthErrorsUnknownGrantTypeOptions;
};

export type ErrorsPublishErrorsAccessTokenHasExpiredTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED";
    keyId: "ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED";
    options: ErrorsPublishErrorsAccessTokenHasExpiredOptions;
};

export type ErrorsPublishErrorsDuplicatePostsDetectedTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED";
    keyId: "ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED";
    options: ErrorsPublishErrorsDuplicatePostsDetectedOptions;
};

export type ErrorsPublishErrorsFailedToPublishToLocationTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION";
    keyId: "ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION";
    options: ErrorsPublishErrorsFailedToPublishToLocationOptions;
};

export type ErrorsPublishErrorsPermissionsNotGrantedTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED";
    keyId: "ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED";
    options: ErrorsPublishErrorsPermissionsNotGrantedOptions;
};

export type ErrorsPublishErrorsServiceInvalidAspectRatioTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO";
    keyId: "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO";
    options: ErrorsPublishErrorsServiceInvalidAspectRatioOptions;
};

export type ErrorsPublishErrorsServiceInvalidScheduleDateTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE";
    keyId: "ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE";
    options: ErrorsPublishErrorsServiceInvalidScheduleDateOptions;
};

export type ErrorsPublishErrorsServiceMaximumCaptionLengthExceededTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED";
    keyId: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED";
    options: ErrorsPublishErrorsServiceMaximumCaptionLengthExceededOptions;
};

export type ErrorsPublishErrorsServiceMaximumMediaSizeExceededTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED";
    keyId: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED";
    options: ErrorsPublishErrorsServiceMaximumMediaSizeExceededOptions;
};

export type ErrorsPublishErrorsServiceMaximumPublishCountReachedTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED";
    keyId: "ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED";
    options: ErrorsPublishErrorsServiceMaximumPublishCountReachedOptions;
};

export type ErrorsPublishErrorsUnsupportedFileFormatTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT";
    keyId: "ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT";
    options: ErrorsPublishErrorsUnsupportedFileFormatOptions;
};

export type ErrorsPublishErrorsUserCredentialsChangedTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED";
    keyId: "ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED";
    options: ErrorsPublishErrorsUserCredentialsChangedOptions;
};

export type ErrorsPublishErrorsUserInterventionRequiredTranslatableText = {
    key: "ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED";
    keyId: "ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED";
    options: ErrorsPublishErrorsUserInterventionRequiredOptions;
};

export type ErrorsServiceAccessErrorsAccessExpiredOrForbiddenWithDetailsTranslatableText = {
    key: "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS";
    keyId: "ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS";
    options: ErrorsServiceAccessErrorsAccessExpiredOrForbiddenWithDetailsOptions;
};

export type ErrorsServiceAccessErrorsFacebookAccountCannotAccessPageTranslatableText = {
    key: "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE";
    keyId: "ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE";
    options: ErrorsServiceAccessErrorsFacebookAccountCannotAccessPageOptions;
};

export type ErrorsServiceConfigurationErrorsLocationMissingFitwareClubNumberTranslatableText = {
    key: "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER";
    keyId: "ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER";
    options: ErrorsServiceConfigurationErrorsLocationMissingFitwareClubNumberOptions;
};

export type ErrorsServiceConfigurationErrorsServiceNotConfiguredTranslatableText = {
    key: "ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED";
    keyId: "ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED";
    options: ErrorsServiceConfigurationErrorsServiceNotConfiguredOptions;
};

export type ErrorsServiceCredentialsMissingErrorsNoAuthenticationForServiceTranslatableText = {
    key: "ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE";
    keyId: "ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE";
    options: ErrorsServiceCredentialsMissingErrorsNoAuthenticationForServiceOptions;
};

export type ErrorsStripeUntranslatedErrorMessageTranslatableText = {
    key: "ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE";
    keyId: "ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE";
    options: ErrorsStripeUntranslatedErrorMessageOptions;
};

export type ErrorsUnexpectedInputErrorsFacebookPageMigrationIdsNotFoundTranslatableText = {
    key: "ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND";
    keyId: "ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND";
    options: ErrorsUnexpectedInputErrorsFacebookPageMigrationIdsNotFoundOptions;
};

export type ErrorsUnsupportedCurrencyTranslatableText = {
    key: "ERRORS.UNSUPPORTED_CURRENCY";
    keyId: "ERRORS.UNSUPPORTED_CURRENCY";
    options: ErrorsUnsupportedCurrencyOptions;
};

export type ErrorsUnsupportedOperationErrorsAccessTokenCannotDetermineAffectedTargetNameTranslatableText = {
    key: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME";
    keyId: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME";
    options: ErrorsUnsupportedOperationErrorsAccessTokenCannotDetermineAffectedTargetNameOptions;
};

export type ErrorsUnsupportedOperationErrorsImageFormatConversionTranslatableText = {
    key: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION";
    keyId: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION";
    options: ErrorsUnsupportedOperationErrorsImageFormatConversionOptions;
};

export type ErrorsUnsupportedOperationErrorsPlannerOperationNotSupportedTranslatableText = {
    key: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED";
    keyId: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED";
    options: ErrorsUnsupportedOperationErrorsPlannerOperationNotSupportedOptions;
};

export type ErrorsUnsupportedOperationErrorsUnsupportedWindowsTimezoneTranslatableText = {
    key: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE";
    keyId: "ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE";
    options: ErrorsUnsupportedOperationErrorsUnsupportedWindowsTimezoneOptions;
};

export type IntegrationAuthApiKeyPreviousKeyTranslatableText = {
    key: "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY";
    keyId: "INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY";
    options: IntegrationAuthApiKeyPreviousKeyOptions;
};

export type IntegrationClientClubReadyEnterChainIdWithClientTitleTranslatableText = {
    key: "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE";
    keyId: "INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE";
    options: IntegrationClientClubReadyEnterChainIdWithClientTitleOptions;
};

export type IntegrationConfigureIntegrationTranslatableText = {
    key: "INTEGRATION.CONFIGURE_INTEGRATION";
    keyId: "INTEGRATION.CONFIGURE_INTEGRATION";
    options: IntegrationConfigureIntegrationOptions;
};

export type IntegrationDisableForTranslatableText = {
    key: "INTEGRATION.DISABLE_FOR";
    keyId: "INTEGRATION.DISABLE_FOR";
    options: IntegrationDisableForOptions;
};

export type IntegrationDisabledIntegrationTranslatableText = {
    key: "INTEGRATION.DISABLED_INTEGRATION";
    keyId: "INTEGRATION.DISABLED_INTEGRATION";
    options: IntegrationDisabledIntegrationOptions;
};

export type IntegrationEnableForTranslatableText = {
    key: "INTEGRATION.ENABLE_FOR";
    keyId: "INTEGRATION.ENABLE_FOR";
    options: IntegrationEnableForOptions;
};

export type IntegrationEnabledIntegrationTranslatableText = {
    key: "INTEGRATION.ENABLED_INTEGRATION";
    keyId: "INTEGRATION.ENABLED_INTEGRATION";
    options: IntegrationEnabledIntegrationOptions;
};

export type IntegrationIntegrationConfigurationTranslatableText = {
    key: "INTEGRATION.INTEGRATION_CONFIGURATION";
    keyId: "INTEGRATION.INTEGRATION_CONFIGURATION";
    options: IntegrationIntegrationConfigurationOptions;
};

export type IntegrationNotifyAccessCheckFailedTranslatableText = {
    key: "INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED";
    keyId: "INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED";
    options: IntegrationNotifyAccessCheckFailedOptions;
};

export type IntegrationNotifyCouldNotAuthorizeServiceTranslatableText = {
    key: "INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE";
    keyId: "INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE";
    options: IntegrationNotifyCouldNotAuthorizeServiceOptions;
};

export type IntegrationNotifyCouldNotDeauthorizeServiceTranslatableText = {
    key: "INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE";
    keyId: "INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE";
    options: IntegrationNotifyCouldNotDeauthorizeServiceOptions;
};

export type IntegrationNotifyServiceDeauthorizedTranslatableText = {
    key: "INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED";
    keyId: "INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED";
    options: IntegrationNotifyServiceDeauthorizedOptions;
};

export type IntegrationSetupIntegrationsForTranslatableText = {
    key: "INTEGRATION.SETUP_INTEGRATIONS_FOR";
    keyId: "INTEGRATION.SETUP_INTEGRATIONS_FOR";
    options: IntegrationSetupIntegrationsForOptions;
};

export type IntroWelcomeToDigitalStackTranslatableText = {
    key: "INTRO.WELCOME_TO_DIGITAL_STACK";
    keyId: "INTRO.WELCOME_TO_DIGITAL_STACK";
    options: IntroWelcomeToDigitalStackOptions;
};

export type LearnDeleteConfirmTranslatableText = {
    key: "LEARN.DELETE_CONFIRM";
    keyId: "LEARN.DELETE_CONFIRM";
    options: LearnDeleteConfirmOptions;
};

export type LearnEmailCommentAddedToLearnArticleTranslatableText = {
    key: "LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE";
    keyId: "LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE";
    options: LearnEmailCommentAddedToLearnArticleOptions;
};

export type LearnNotifyLearnCreatedTranslatableText = {
    key: "LEARN.NOTIFY_LEARN_CREATED";
    keyId: "LEARN.NOTIFY_LEARN_CREATED";
    options: LearnNotifyLearnCreatedOptions;
};

export type LearnNotifyLearnUpdatedTranslatableText = {
    key: "LEARN.NOTIFY_LEARN_UPDATED";
    keyId: "LEARN.NOTIFY_LEARN_UPDATED";
    options: LearnNotifyLearnUpdatedOptions;
};

export type LoginPasswordTooShortTranslatableText = {
    key: "LOGIN.PASSWORD_TOO_SHORT";
    keyId: "LOGIN.PASSWORD_TOO_SHORT";
    options: LoginPasswordTooShortOptions;
};

export type LoginSignedInAsTranslatableText = {
    key: "LOGIN.SIGNED_IN_AS";
    keyId: "LOGIN.SIGNED_IN_AS";
    options: LoginSignedInAsOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateCompleteMyMonthPlannerTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER";
    options: MarketingEmailsWeeklyMarketingUpdateCompleteMyMonthPlannerOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT";
    options: MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED";
    options: MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW";
    options: MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowMultipleLocationsTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS";
    options: MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowMultipleLocationsOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateGetOnTopOfYourPlanningForMonthTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH";
    options: MarketingEmailsWeeklyMarketingUpdateGetOnTopOfYourPlanningForMonthOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateLocationForMonthTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH";
    options: MarketingEmailsWeeklyMarketingUpdateLocationForMonthOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateViewMyMonthPlannerTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER";
    options: MarketingEmailsWeeklyMarketingUpdateViewMyMonthPlannerOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateWhatsOnThisWeekAtLocationTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION";
    options: MarketingEmailsWeeklyMarketingUpdateWhatsOnThisWeekAtLocationOptions;
};

export type MarketingEmailsWeeklyMarketingUpdateYourWeeklyUpdateTranslatableText = {
    key: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE";
    keyId: "MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE";
    options: MarketingEmailsWeeklyMarketingUpdateYourWeeklyUpdateOptions;
};

export type NotificationsMessagesCustomAgencyMessageTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE";
    keyId: "NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE";
    options: NotificationsMessagesCustomAgencyMessageOptions;
};

export type NotificationsMessagesEmailScheduleFailedTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED";
    keyId: "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED";
    options: NotificationsMessagesEmailScheduleFailedOptions;
};

export type NotificationsMessagesEmailScheduledTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED";
    keyId: "NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED";
    options: NotificationsMessagesEmailScheduledOptions;
};

export type NotificationsMessagesImagePublishFailedTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED";
    keyId: "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED";
    options: NotificationsMessagesImagePublishFailedOptions;
};

export type NotificationsMessagesImagePublishFailedNoErrorTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR";
    keyId: "NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR";
    options: NotificationsMessagesImagePublishFailedNoErrorOptions;
};

export type NotificationsMessagesIntegrationConnectivityFailureTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE";
    keyId: "NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE";
    options: NotificationsMessagesIntegrationConnectivityFailureOptions;
};

export type NotificationsMessagesIntegrationConfigurationMisconfiguredTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED";
    keyId: "NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED";
    options: NotificationsMessagesIntegrationConfigurationMisconfiguredOptions;
};

export type NotificationsMessagesLocationMapGeneratedTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED";
    keyId: "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED";
    options: NotificationsMessagesLocationMapGeneratedOptions;
};

export type NotificationsMessagesLocationMapGenerationFailedTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED";
    keyId: "NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED";
    options: NotificationsMessagesLocationMapGenerationFailedOptions;
};

export type NotificationsMessagesScheduledPostsNoNotifiableDevicesTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES";
    keyId: "NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES";
    options: NotificationsMessagesScheduledPostsNoNotifiableDevicesOptions;
};

export type NotificationsMessagesTestTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.TEST";
    keyId: "NOTIFICATIONS.MESSAGES.TEST";
    options: NotificationsMessagesTestOptions;
};

export type NotificationsMessagesVideoPublishFailedTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED";
    keyId: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED";
    options: NotificationsMessagesVideoPublishFailedOptions;
};

export type NotificationsMessagesVideoPublishedExternallyTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY";
    keyId: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY";
    options: NotificationsMessagesVideoPublishedExternallyOptions;
};

export type NotificationsMessagesVideoPublishedExternallyV2TranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2";
    keyId: "NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2";
    options: NotificationsMessagesVideoPublishedExternallyV2Options;
};

export type NotificationsMessagesVideoScheduledExternallyTranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY";
    keyId: "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY";
    options: NotificationsMessagesVideoScheduledExternallyOptions;
};

export type NotificationsMessagesVideoScheduledExternallyV2TranslatableText = {
    key: "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2";
    keyId: "NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2";
    options: NotificationsMessagesVideoScheduledExternallyV2Options;
};

export type NotificationsSendNotificationWizardComposeEmailEditorButtonsHeadingNumTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM";
    options: NotificationsSendNotificationWizardComposeEmailEditorButtonsHeadingNumOptions;
};

export type NotificationsSendNotificationWizardComposeEmailInputLabelsFromAddressSwitchDefaultTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT";
    options: NotificationsSendNotificationWizardComposeEmailInputLabelsFromAddressSwitchDefaultOptions;
};

export type NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION";
    options: NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationOptions;
};

export type NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationsTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS";
    options: NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationsOptions;
};

export type NotificationsSendNotificationWizardPickLocationsCurrentlySelectedTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED";
    options: NotificationsSendNotificationWizardPickLocationsCurrentlySelectedOptions;
};

export type NotificationsSendNotificationWizardPickLocationsLabelsTotalRecipientsTranslatableText = {
    key: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS";
    keyId: "NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS";
    options: NotificationsSendNotificationWizardPickLocationsLabelsTotalRecipientsOptions;
};

export type NotificationsSubjectsCustomAgencyMessageTranslatableText = {
    key: "NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE";
    keyId: "NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE";
    options: NotificationsSubjectsCustomAgencyMessageOptions;
};

export type OverviewConfirmPlannerEventsTranslatableText = {
    key: "OVERVIEW.CONFIRM_PLANNER_EVENTS";
    keyId: "OVERVIEW.CONFIRM_PLANNER_EVENTS";
    options: OverviewConfirmPlannerEventsOptions;
};

export type OverviewDeletingTitleTranslatableText = {
    key: "OVERVIEW.DELETING_TITLE";
    keyId: "OVERVIEW.DELETING_TITLE";
    options: OverviewDeletingTitleOptions;
};

export type OverviewDueByTranslatableText = {
    key: "OVERVIEW.DUE_BY";
    keyId: "OVERVIEW.DUE_BY";
    options: OverviewDueByOptions;
};

export type OverviewFilteredAmountTranslatableText = {
    key: "OVERVIEW.FILTERED_AMOUNT";
    keyId: "OVERVIEW.FILTERED_AMOUNT";
    options: OverviewFilteredAmountOptions;
};

export type OverviewLoadedLocationsTranslatableText = {
    key: "OVERVIEW.LOADED_LOCATIONS";
    keyId: "OVERVIEW.LOADED_LOCATIONS";
    options: OverviewLoadedLocationsOptions;
};

export type OverviewSavingForTitleTranslatableText = {
    key: "OVERVIEW.SAVING_FOR_TITLE";
    keyId: "OVERVIEW.SAVING_FOR_TITLE";
    options: OverviewSavingForTitleOptions;
};

export type PaymentsEmailsAmountDueTranslatableText = {
    key: "PAYMENTS.EMAILS.AMOUNT_DUE";
    keyId: "PAYMENTS.EMAILS.AMOUNT_DUE";
    options: PaymentsEmailsAmountDueOptions;
};

export type PaymentsEmailsAttemptedPaymentDateTranslatableText = {
    key: "PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE";
    keyId: "PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE";
    options: PaymentsEmailsAttemptedPaymentDateOptions;
};

export type PaymentsEmailsDueDateTranslatableText = {
    key: "PAYMENTS.EMAILS.DUE_DATE";
    keyId: "PAYMENTS.EMAILS.DUE_DATE";
    options: PaymentsEmailsDueDateOptions;
};

export type PaymentsEmailsFailedSubjectLineTranslatableText = {
    key: "PAYMENTS.EMAILS.FAILED_SUBJECT_LINE";
    keyId: "PAYMENTS.EMAILS.FAILED_SUBJECT_LINE";
    options: PaymentsEmailsFailedSubjectLineOptions;
};

export type PaymentsEmailsInvoiceDescriptionTranslatableText = {
    key: "PAYMENTS.EMAILS.INVOICE_DESCRIPTION";
    keyId: "PAYMENTS.EMAILS.INVOICE_DESCRIPTION";
    options: PaymentsEmailsInvoiceDescriptionOptions;
};

export type PaymentsEmailsInvoiceNumberTranslatableText = {
    key: "PAYMENTS.EMAILS.INVOICE_NUMBER";
    keyId: "PAYMENTS.EMAILS.INVOICE_NUMBER";
    options: PaymentsEmailsInvoiceNumberOptions;
};

export type PaymentsEmailsPaymentFailedForLocationTranslatableText = {
    key: "PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION";
    keyId: "PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION";
    options: PaymentsEmailsPaymentFailedForLocationOptions;
};

export type PaymentsEmailsReportFailedSubjectLineTranslatableText = {
    key: "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE";
    keyId: "PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE";
    options: PaymentsEmailsReportFailedSubjectLineOptions;
};

export type PaymentsEmailsReportPaymentFailedForLocationsTranslatableText = {
    key: "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS";
    keyId: "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS";
    options: PaymentsEmailsReportPaymentFailedForLocationsOptions;
};

export type PaymentsEmailsReportPaymentFailureReasonTranslatableText = {
    key: "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON";
    keyId: "PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON";
    options: PaymentsEmailsReportPaymentFailureReasonOptions;
};

export type PaymentsEmailsRetryWeWillAttemptToChargeAgainTranslatableText = {
    key: "PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN";
    keyId: "PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN";
    options: PaymentsEmailsRetryWeWillAttemptToChargeAgainOptions;
};

export type PaymentsEmailsRolloverWeWillAddOutstandingAmountToNextPaymentTranslatableText = {
    key: "PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT";
    keyId: "PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT";
    options: PaymentsEmailsRolloverWeWillAddOutstandingAmountToNextPaymentOptions;
};

export type PaymentsEmailsSubscriptionAmountTranslatableText = {
    key: "PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT";
    keyId: "PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT";
    options: PaymentsEmailsSubscriptionAmountOptions;
};

export type PaymentsSignUpAgencyWelcomesYouTranslatableText = {
    key: "PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU";
    keyId: "PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU";
    options: PaymentsSignUpAgencyWelcomesYouOptions;
};

export type PaymentsSignUpAmountPerMonthTranslatableText = {
    key: "PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH";
    keyId: "PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH";
    options: PaymentsSignUpAmountPerMonthOptions;
};

export type PaymentsSignUpFirstBillingDateIsTranslatableText = {
    key: "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS";
    keyId: "PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS";
    options: PaymentsSignUpFirstBillingDateIsOptions;
};

export type PaymentsStripeEmailsAuthRequestUserRequestedYouToAuthTranslatableText = {
    key: "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH";
    keyId: "PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH";
    options: PaymentsStripeEmailsAuthRequestUserRequestedYouToAuthOptions;
};

export type PlanActivitiesChannelsChannelForActivityTranslatableText = {
    key: "PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY";
    keyId: "PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY";
    options: PlanActivitiesChannelsChannelForActivityOptions;
};

export type PlanAgencyToBuildSpecificTranslatableText = {
    key: "PLAN.AGENCY_TO_BUILD_SPECIFIC";
    keyId: "PLAN.AGENCY_TO_BUILD_SPECIFIC";
    options: PlanAgencyToBuildSpecificOptions;
};

export type PlanAgencyToBuildTooltipTranslatableText = {
    key: "PLAN.AGENCY_TO_BUILD_TOOLTIP";
    keyId: "PLAN.AGENCY_TO_BUILD_TOOLTIP";
    options: PlanAgencyToBuildTooltipOptions;
};

export type PlanCampaignsActionsArchiveMessageTranslatableText = {
    key: "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE";
    keyId: "PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE";
    options: PlanCampaignsActionsArchiveMessageOptions;
};

export type PlanCampaignsActionsUnarchiveMessageTranslatableText = {
    key: "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE";
    keyId: "PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE";
    options: PlanCampaignsActionsUnarchiveMessageOptions;
};

export type PlanCampaignsCampaignRenamedToTranslatableText = {
    key: "PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO";
    keyId: "PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO";
    options: PlanCampaignsCampaignRenamedToOptions;
};

export type PlanCampaignsCampaignsListNumDaysTranslatableText = {
    key: "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS";
    keyId: "PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS";
    options: PlanCampaignsCampaignsListNumDaysOptions;
};

export type PlanCampaignsCreatedNewCampaignTranslatableText = {
    key: "PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN";
    keyId: "PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN";
    options: PlanCampaignsCreatedNewCampaignOptions;
};

export type PlanCampaignsDeploysDeployCampaignToLocationTranslatableText = {
    key: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION";
    keyId: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION";
    options: PlanCampaignsDeploysDeployCampaignToLocationOptions;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmEventsPerLocationTranslatableText = {
    key: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION";
    keyId: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION";
    options: PlanCampaignsDeploysDeployFormCopyConfirmEventsPerLocationOptions;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientTranslatableText = {
    key: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT";
    keyId: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT";
    options: PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientOptions;
};

export type PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientSingularTranslatableText = {
    key: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR";
    keyId: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR";
    options: PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientSingularOptions;
};

export type PlanCampaignsDeploysDeploymentHistoryStatusScheduledHelpTranslatableText = {
    key: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP";
    keyId: "PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP";
    options: PlanCampaignsDeploysDeploymentHistoryStatusScheduledHelpOptions;
};

export type PlanEventConfirmDeleteTranslatableText = {
    key: "PLAN.EVENT.CONFIRM_DELETE";
    keyId: "PLAN.EVENT.CONFIRM_DELETE";
    options: PlanEventConfirmDeleteOptions;
};

export type PlanEventDateOfMonthExampleTranslatableText = {
    key: "PLAN.EVENT.DATE_OF_MONTH_EXAMPLE";
    keyId: "PLAN.EVENT.DATE_OF_MONTH_EXAMPLE";
    options: PlanEventDateOfMonthExampleOptions;
};

export type PlanEventDateOfMonthInYearExampleTranslatableText = {
    key: "PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE";
    keyId: "PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE";
    options: PlanEventDateOfMonthInYearExampleOptions;
};

export type PlanEventDateOfWeekExampleTranslatableText = {
    key: "PLAN.EVENT.DATE_OF_WEEK_EXAMPLE";
    keyId: "PLAN.EVENT.DATE_OF_WEEK_EXAMPLE";
    options: PlanEventDateOfWeekExampleOptions;
};

export type PlanEventDateOfWeekInYearExampleTranslatableText = {
    key: "PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE";
    keyId: "PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE";
    options: PlanEventDateOfWeekInYearExampleOptions;
};

export type PlanEventDeletionAlertTranslatableText = {
    key: "PLAN.EVENT.DELETION_ALERT";
    keyId: "PLAN.EVENT.DELETION_ALERT";
    options: PlanEventDeletionAlertOptions;
};

export type PlanEventInstructionsToManagerTranslatableText = {
    key: "PLAN.EVENT.INSTRUCTIONS_TO_MANAGER";
    keyId: "PLAN.EVENT.INSTRUCTIONS_TO_MANAGER";
    options: PlanEventInstructionsToManagerOptions;
};

export type PlanEventRequiredInfoTranslatableText = {
    key: "PLAN.EVENT.REQUIRED_INFO";
    keyId: "PLAN.EVENT.REQUIRED_INFO";
    options: PlanEventRequiredInfoOptions;
};

export type PlanEventSupportNoteTranslatableText = {
    key: "PLAN.EVENT.SUPPORT_NOTE";
    keyId: "PLAN.EVENT.SUPPORT_NOTE";
    options: PlanEventSupportNoteOptions;
};

export type PlanEventSupportRequestedTranslatableText = {
    key: "PLAN.EVENT.SUPPORT_REQUESTED";
    keyId: "PLAN.EVENT.SUPPORT_REQUESTED";
    options: PlanEventSupportRequestedOptions;
};

export type PlanMultipleLocationsSavingForTitleTranslatableText = {
    key: "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE";
    keyId: "PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE";
    options: PlanMultipleLocationsSavingForTitleOptions;
};

export type PlanNotifyPlannerCreatedTranslatableText = {
    key: "PLAN.NOTIFY_PLANNER_CREATED";
    keyId: "PLAN.NOTIFY_PLANNER_CREATED";
    options: PlanNotifyPlannerCreatedOptions;
};

export type PlanNotifyPlannerCreatedPartialTranslatableText = {
    key: "PLAN.NOTIFY_PLANNER_CREATED_PARTIAL";
    keyId: "PLAN.NOTIFY_PLANNER_CREATED_PARTIAL";
    options: PlanNotifyPlannerCreatedPartialOptions;
};

export type PlanNotifyPlannerUpdatedTranslatableText = {
    key: "PLAN.NOTIFY_PLANNER_UPDATED";
    keyId: "PLAN.NOTIFY_PLANNER_UPDATED";
    options: PlanNotifyPlannerUpdatedOptions;
};

export type ProfileMinimumImageDimensionRequirementTranslatableText = {
    key: "PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT";
    keyId: "PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT";
    options: ProfileMinimumImageDimensionRequirementOptions;
};

export type ReportAllMonetaryFiguresAreInCurrencyTranslatableText = {
    key: "REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY";
    keyId: "REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY";
    options: ReportAllMonetaryFiguresAreInCurrencyOptions;
};

export type ReportConversionsPlatformNotConfiguredForLocationTranslatableText = {
    key: "REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION";
    keyId: "REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION";
    options: ReportConversionsPlatformNotConfiguredForLocationOptions;
};

export type ReportEmailCampaignsClicksTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.CLICKS";
    keyId: "REPORT.EMAIL_CAMPAIGNS.CLICKS";
    options: ReportEmailCampaignsClicksOptions;
};

export type ReportEmailCampaignsErrorCouldNotBeRetrievedTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED";
    keyId: "REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED";
    options: ReportEmailCampaignsErrorCouldNotBeRetrievedOptions;
};

export type ReportEmailCampaignsNumberRecipientsTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS";
    keyId: "REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS";
    options: ReportEmailCampaignsNumberRecipientsOptions;
};

export type ReportEmailCampaignsOpensTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.OPENS";
    keyId: "REPORT.EMAIL_CAMPAIGNS.OPENS";
    options: ReportEmailCampaignsOpensOptions;
};

export type ReportEmailCampaignsRecipientsTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS";
    keyId: "REPORT.EMAIL_CAMPAIGNS.RECIPIENTS";
    options: ReportEmailCampaignsRecipientsOptions;
};

export type ReportEmailCampaignsSendingOnTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.SENDING_ON";
    keyId: "REPORT.EMAIL_CAMPAIGNS.SENDING_ON";
    options: ReportEmailCampaignsSendingOnOptions;
};

export type ReportEmailCampaignsSentToTranslatableText = {
    key: "REPORT.EMAIL_CAMPAIGNS.SENT_TO";
    keyId: "REPORT.EMAIL_CAMPAIGNS.SENT_TO";
    options: ReportEmailCampaignsSentToOptions;
};

export type ReportFacebookAudienceInsightsOnlineFollowersHelpDaysTranslatableText = {
    key: "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS";
    keyId: "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS";
    options: ReportFacebookAudienceInsightsOnlineFollowersHelpDaysOptions;
};

export type ReportFacebookAudienceInsightsOnlineFollowersHelpHoursTranslatableText = {
    key: "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS";
    keyId: "REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS";
    options: ReportFacebookAudienceInsightsOnlineFollowersHelpHoursOptions;
};

export type ReportFacebookLikesReportPeriodAgoTranslatableText = {
    key: "REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO";
    keyId: "REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO";
    options: ReportFacebookLikesReportPeriodAgoOptions;
};

export type ReportGeneratedReportPrintFooterTranslatableText = {
    key: "REPORT.GENERATED_REPORT_PRINT_FOOTER";
    keyId: "REPORT.GENERATED_REPORT_PRINT_FOOTER";
    options: ReportGeneratedReportPrintFooterOptions;
};

export type ReportGoogleAdsAdNameTooltipNumDescriptionTranslatableText = {
    key: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION";
    keyId: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION";
    options: ReportGoogleAdsAdNameTooltipNumDescriptionOptions;
};

export type ReportGoogleAdsAdNameTooltipNumHeadlineTranslatableText = {
    key: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE";
    keyId: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE";
    options: ReportGoogleAdsAdNameTooltipNumHeadlineOptions;
};

export type ReportGoogleAdsAdNameTooltipNumUrlTranslatableText = {
    key: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL";
    keyId: "REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL";
    options: ReportGoogleAdsAdNameTooltipNumUrlOptions;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestExtraStepsMayBeRequiredTranslatableText = {
    key: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED";
    keyId: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED";
    options: ReportGoogleAdwordsSpendAdjustmentRequestExtraStepsMayBeRequiredOptions;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestIncreaseMyGoogleAdwordsBudgetTranslatableText = {
    key: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET";
    keyId: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET";
    options: ReportGoogleAdwordsSpendAdjustmentRequestIncreaseMyGoogleAdwordsBudgetOptions;
};

export type ReportGoogleAdwordsSpendAdjustmentRequestUserHasRequestedAnAdjustmentToAdwordsSpendTranslatableText = {
    key: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND";
    keyId: "REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND";
    options: ReportGoogleAdwordsSpendAdjustmentRequestUserHasRequestedAnAdjustmentToAdwordsSpendOptions;
};

export type ReportGoogleMyBusinessRecentPostsPostClicksTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS";
    options: ReportGoogleMyBusinessRecentPostsPostClicksOptions;
};

export type ReportGoogleMyBusinessRecentPostsPostViewsTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS";
    options: ReportGoogleMyBusinessRecentPostsPostViewsOptions;
};

export type ReportGoogleMyBusinessTopQuestionsAnswersTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS";
    options: ReportGoogleMyBusinessTopQuestionsAnswersOptions;
};

export type ReportGoogleMyBusinessTopQuestionsQuestionsTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS";
    options: ReportGoogleMyBusinessTopQuestionsQuestionsOptions;
};

export type ReportGoogleMyBusinessTopQuestionsUpvotesTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES";
    options: ReportGoogleMyBusinessTopQuestionsUpvotesOptions;
};

export type ReportGoogleMyBusinessTopReviewsRepliedAtTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT";
    options: ReportGoogleMyBusinessTopReviewsRepliedAtOptions;
};

export type ReportGoogleMyBusinessTopReviewsReviewsTranslatableText = {
    key: "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS";
    keyId: "REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS";
    options: ReportGoogleMyBusinessTopReviewsReviewsOptions;
};

export type ReportInstagramAudienceInsightsOnlineFollowersHelpDaysTranslatableText = {
    key: "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS";
    keyId: "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS";
    options: ReportInstagramAudienceInsightsOnlineFollowersHelpDaysOptions;
};

export type ReportInstagramAudienceInsightsOnlineFollowersHelpHoursTranslatableText = {
    key: "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS";
    keyId: "REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS";
    options: ReportInstagramAudienceInsightsOnlineFollowersHelpHoursOptions;
};

export type ReportMoreRowsTranslatableText = {
    key: "REPORT.MORE_ROWS";
    keyId: "REPORT.MORE_ROWS";
    options: ReportMoreRowsOptions;
};

export type ReportNotConnectedPart1TranslatableText = {
    key: "REPORT.NOT_CONNECTED_PART_1";
    keyId: "REPORT.NOT_CONNECTED_PART_1";
    options: ReportNotConnectedPart1Options;
};

export type ReportNotConnectedPart2TranslatableText = {
    key: "REPORT.NOT_CONNECTED_PART_2";
    keyId: "REPORT.NOT_CONNECTED_PART_2";
    options: ReportNotConnectedPart2Options;
};

export type ReportPaidImpressionsTranslatableText = {
    key: "REPORT.PAID_IMPRESSIONS";
    keyId: "REPORT.PAID_IMPRESSIONS";
    options: ReportPaidImpressionsOptions;
};

export type ReportPaidUniqueViewsTranslatableText = {
    key: "REPORT.PAID_UNIQUE_VIEWS";
    keyId: "REPORT.PAID_UNIQUE_VIEWS";
    options: ReportPaidUniqueViewsOptions;
};

export type ReportReportLoadedLocationsTranslatableText = {
    key: "REPORT.REPORT_LOADED_LOCATIONS";
    keyId: "REPORT.REPORT_LOADED_LOCATIONS";
    options: ReportReportLoadedLocationsOptions;
};

export type ReportShowTopNTranslatableText = {
    key: "REPORT.SHOW_TOP_N";
    keyId: "REPORT.SHOW_TOP_N";
    options: ReportShowTopNOptions;
};

export type ReportTemplateUseByLocationTranslatableText = {
    key: "REPORT.TEMPLATE_USE_BY_LOCATION";
    keyId: "REPORT.TEMPLATE_USE_BY_LOCATION";
    options: ReportTemplateUseByLocationOptions;
};

export type ReportTemplateUsesTranslatableText = {
    key: "REPORT.TEMPLATE_USES";
    keyId: "REPORT.TEMPLATE_USES";
    options: ReportTemplateUsesOptions;
};

export type ReportTotalImpressionsTranslatableText = {
    key: "REPORT.TOTAL_IMPRESSIONS";
    keyId: "REPORT.TOTAL_IMPRESSIONS";
    options: ReportTotalImpressionsOptions;
};

export type ReportTotalReachVsTotalPaidTranslatableText = {
    key: "REPORT.TOTAL_REACH_VS_TOTAL_PAID";
    keyId: "REPORT.TOTAL_REACH_VS_TOTAL_PAID";
    options: ReportTotalReachVsTotalPaidOptions;
};

export type ReportTotalUniqueViewsTranslatableText = {
    key: "REPORT.TOTAL_UNIQUE_VIEWS";
    keyId: "REPORT.TOTAL_UNIQUE_VIEWS";
    options: ReportTotalUniqueViewsOptions;
};

export type RequestsAlreadyPaidDifferenceTranslatableText = {
    key: "REQUESTS.ALREADY_PAID_DIFFERENCE";
    keyId: "REQUESTS.ALREADY_PAID_DIFFERENCE";
    options: RequestsAlreadyPaidDifferenceOptions;
};

export type RequestsEmailsAddedNewSpecialRequestTranslatableText = {
    key: "REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST";
    keyId: "REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST";
    options: RequestsEmailsAddedNewSpecialRequestOptions;
};

export type RequestsEmailsAddedRequestIsDueByTranslatableText = {
    key: "REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY";
    keyId: "REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY";
    options: RequestsEmailsAddedRequestIsDueByOptions;
};

export type RequestsEmailsCommentAddedSpecialRequestHasBeenUpdatedTranslatableText = {
    key: "REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED";
    keyId: "REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED";
    options: RequestsEmailsCommentAddedSpecialRequestHasBeenUpdatedOptions;
};

export type RequestsEmailsCommentAddedSubjectLineTranslatableText = {
    key: "REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE";
    keyId: "REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE";
    options: RequestsEmailsCommentAddedSubjectLineOptions;
};

export type RequestsPaymentTranslatableText = {
    key: "REQUESTS.PAYMENT";
    keyId: "REQUESTS.PAYMENT";
    options: RequestsPaymentOptions;
};

export type RequestsPaymentOverpaidTranslatableText = {
    key: "REQUESTS.PAYMENT_OVERPAID";
    keyId: "REQUESTS.PAYMENT_OVERPAID";
    options: RequestsPaymentOverpaidOptions;
};

export type RequestsPreviousQuoteDifferenceTranslatableText = {
    key: "REQUESTS.PREVIOUS_QUOTE_DIFFERENCE";
    keyId: "REQUESTS.PREVIOUS_QUOTE_DIFFERENCE";
    options: RequestsPreviousQuoteDifferenceOptions;
};

export type ScheduleEmailsFailedToNotifyContentTranslatableText = {
    key: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT";
    keyId: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT";
    options: ScheduleEmailsFailedToNotifyContentOptions;
};

export type ScheduleEmailsFailedToNotifyHeading1TranslatableText = {
    key: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1";
    keyId: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1";
    options: ScheduleEmailsFailedToNotifyHeading1Options;
};

export type ScheduleEmailsFailedToNotifySubjectLineTranslatableText = {
    key: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE";
    keyId: "SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE";
    options: ScheduleEmailsFailedToNotifySubjectLineOptions;
};

export type ScheduleEmailsNoDevicesContent1TranslatableText = {
    key: "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1";
    keyId: "SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1";
    options: ScheduleEmailsNoDevicesContent1Options;
};

export type SchedulePageDialogsDeleteOptionForMultipleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE";
    options: SchedulePageDialogsDeleteOptionForMultipleOptions;
};

export type SchedulePageDialogsDeleteOptionForSingleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE";
    options: SchedulePageDialogsDeleteOptionForSingleOptions;
};

export type SchedulePageDialogsEditCaptionContactingPlatformTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM";
    keyId: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM";
    options: SchedulePageDialogsEditCaptionContactingPlatformOptions;
};

export type SchedulePageDialogsEditCaptionOptionForMultipleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE";
    options: SchedulePageDialogsEditCaptionOptionForMultipleOptions;
};

export type SchedulePageDialogsEditCaptionOptionForSingleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE";
    options: SchedulePageDialogsEditCaptionOptionForSingleOptions;
};

export type SchedulePageDialogsRescheduleDeletedTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED";
    keyId: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED";
    options: SchedulePageDialogsRescheduleDeletedOptions;
};

export type SchedulePageDialogsRescheduleOptionForMultipleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE";
    options: SchedulePageDialogsRescheduleOptionForMultipleOptions;
};

export type SchedulePageDialogsRescheduleOptionForSingleTranslatableText = {
    key: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE";
    keyId: "SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE";
    options: SchedulePageDialogsRescheduleOptionForSingleOptions;
};

export type SchedulePageTableNoScheduledPostsFoundForPlatformTranslatableText = {
    key: "SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM";
    keyId: "SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM";
    options: SchedulePageTableNoScheduledPostsFoundForPlatformOptions;
};

export type SchedulePostsPostDetailsSmsTranslatableText = {
    key: "SCHEDULE.POSTS.POST_DETAILS_SMS";
    keyId: "SCHEDULE.POSTS.POST_DETAILS_SMS";
    options: SchedulePostsPostDetailsSmsOptions;
};

export type SchedulePostsPostImmediatelyTranslatableText = {
    key: "SCHEDULE.POSTS.POST_IMMEDIATELY";
    keyId: "SCHEDULE.POSTS.POST_IMMEDIATELY";
    options: SchedulePostsPostImmediatelyOptions;
};

export type SchedulePostsPostScheduledForTranslatableText = {
    key: "SCHEDULE.POSTS.POST_SCHEDULED_FOR";
    keyId: "SCHEDULE.POSTS.POST_SCHEDULED_FOR";
    options: SchedulePostsPostScheduledForOptions;
};

export type SchedulePostsSmsDownloadMessageTranslatableText = {
    key: "SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE";
    keyId: "SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE";
    options: SchedulePostsSmsDownloadMessageOptions;
};

export type SchedulePushNotificationsTimeToPostTranslatableText = {
    key: "SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST";
    keyId: "SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST";
    options: SchedulePushNotificationsTimeToPostOptions;
};

export type ShoppingCartCheckoutAddressTranslatableText = {
    key: "SHOPPING_CART.CHECKOUT.ADDRESS";
    keyId: "SHOPPING_CART.CHECKOUT.ADDRESS";
    options: ShoppingCartCheckoutAddressOptions;
};

export type ShoppingCartCheckoutLocationsTranslatableText = {
    key: "SHOPPING_CART.CHECKOUT.LOCATIONS";
    keyId: "SHOPPING_CART.CHECKOUT.LOCATIONS";
    options: ShoppingCartCheckoutLocationsOptions;
};

export type ShoppingCartCheckoutPayAmountTranslatableText = {
    key: "SHOPPING_CART.CHECKOUT.PAY_AMOUNT";
    keyId: "SHOPPING_CART.CHECKOUT.PAY_AMOUNT";
    options: ShoppingCartCheckoutPayAmountOptions;
};

export type ShoppingCartCheckoutQuantityTranslatableText = {
    key: "SHOPPING_CART.CHECKOUT.QUANTITY";
    keyId: "SHOPPING_CART.CHECKOUT.QUANTITY";
    options: ShoppingCartCheckoutQuantityOptions;
};

export type ShoppingCartEmailsDateTranslatableText = {
    key: "SHOPPING_CART.EMAILS.DATE";
    keyId: "SHOPPING_CART.EMAILS.DATE";
    options: ShoppingCartEmailsDateOptions;
};

export type ShoppingCartEmailsOrderNumberTranslatableText = {
    key: "SHOPPING_CART.EMAILS.ORDER_NUMBER";
    keyId: "SHOPPING_CART.EMAILS.ORDER_NUMBER";
    options: ShoppingCartEmailsOrderNumberOptions;
};

export type ShoppingCartEmailsPrintOrderForProviderAgencyTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY";
    options: ShoppingCartEmailsPrintOrderForProviderAgencyOptions;
};

export type ShoppingCartEmailsPrintOrderForProviderClientTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT";
    options: ShoppingCartEmailsPrintOrderForProviderClientOptions;
};

export type ShoppingCartEmailsPrintOrderForProviderContactEmailTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL";
    options: ShoppingCartEmailsPrintOrderForProviderContactEmailOptions;
};

export type ShoppingCartEmailsPrintOrderForProviderOrderReceivedTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED";
    options: ShoppingCartEmailsPrintOrderForProviderOrderReceivedOptions;
};

export type ShoppingCartEmailsPrintOrderForProviderSubjectLineTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE";
    options: ShoppingCartEmailsPrintOrderForProviderSubjectLineOptions;
};

export type ShoppingCartEmailsPrintOrderForUserOrderReceivedTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED";
    options: ShoppingCartEmailsPrintOrderForUserOrderReceivedOptions;
};

export type ShoppingCartEmailsPrintOrderForUserPrintProviderTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER";
    options: ShoppingCartEmailsPrintOrderForUserPrintProviderOptions;
};

export type ShoppingCartEmailsPrintOrderForUserPrintProviderEmailTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL";
    options: ShoppingCartEmailsPrintOrderForUserPrintProviderEmailOptions;
};

export type ShoppingCartEmailsPrintOrderForUserSubjectLineTranslatableText = {
    key: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE";
    keyId: "SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE";
    options: ShoppingCartEmailsPrintOrderForUserSubjectLineOptions;
};

export type StatsEmailsAccessTokenErrorAccessErrorForTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR";
    options: StatsEmailsAccessTokenErrorAccessErrorForOptions;
};

export type StatsEmailsAccessTokenErrorAuthorizeServiceTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE";
    options: StatsEmailsAccessTokenErrorAuthorizeServiceOptions;
};

export type StatsEmailsAccessTokenErrorIfAccessToIsNoLongerRequiredTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED";
    options: StatsEmailsAccessTokenErrorIfAccessToIsNoLongerRequiredOptions;
};

export type StatsEmailsAccessTokenErrorSubjectLineTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE";
    options: StatsEmailsAccessTokenErrorSubjectLineOptions;
};

export type StatsEmailsAccessTokenErrorTryLoggingInAndReAuthorizingTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING";
    options: StatsEmailsAccessTokenErrorTryLoggingInAndReAuthorizingOptions;
};

export type StatsEmailsAccessTokenErrorWeHadAProblemTryingToAccessTranslatableText = {
    key: "STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS";
    keyId: "STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS";
    options: StatsEmailsAccessTokenErrorWeHadAProblemTryingToAccessOptions;
};

export type UserBulkDeleteModalHasErrorsMessageTranslatableText = {
    key: "USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE";
    keyId: "USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE";
    options: UserBulkDeleteModalHasErrorsMessageOptions;
};

export type UserBulkResetPasswordsModalConfirmResendInviteTranslatableText = {
    key: "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE";
    keyId: "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE";
    options: UserBulkResetPasswordsModalConfirmResendInviteOptions;
};

export type UserBulkResetPasswordsModalConfirmSendPasswordResetTranslatableText = {
    key: "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET";
    keyId: "USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET";
    options: UserBulkResetPasswordsModalConfirmSendPasswordResetOptions;
};

export type UserBulkResetPasswordsModalFetchUserErrorMessageTranslatableText = {
    key: "USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE";
    keyId: "USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE";
    options: UserBulkResetPasswordsModalFetchUserErrorMessageOptions;
};

export type UserBulkResetPasswordsModalUsersWithoutAcceptedInviteMessageTranslatableText = {
    key: "USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE";
    keyId: "USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE";
    options: UserBulkResetPasswordsModalUsersWithoutAcceptedInviteMessageOptions;
};

export type UserBulkUpdateLocationsModalAddLocationsCountTextTranslatableText = {
    key: "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT";
    keyId: "USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT";
    options: UserBulkUpdateLocationsModalAddLocationsCountTextOptions;
};

export type UserBulkUpdateLocationsModalConfirmTextTranslatableText = {
    key: "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT";
    keyId: "USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT";
    options: UserBulkUpdateLocationsModalConfirmTextOptions;
};

export type UserBulkUpdateLocationsModalHasErrorsMessageTranslatableText = {
    key: "USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE";
    keyId: "USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE";
    options: UserBulkUpdateLocationsModalHasErrorsMessageOptions;
};

export type UserBulkUpdateLocationsModalRemoveLocationsCountTextTranslatableText = {
    key: "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT";
    keyId: "USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT";
    options: UserBulkUpdateLocationsModalRemoveLocationsCountTextOptions;
};

export type UserBulkUpdateRolesModalAddRolesCountTextTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT";
    options: UserBulkUpdateRolesModalAddRolesCountTextOptions;
};

export type UserBulkUpdateRolesModalConfirmTextTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT";
    options: UserBulkUpdateRolesModalConfirmTextOptions;
};

export type UserBulkUpdateRolesModalExistingTitleTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE";
    options: UserBulkUpdateRolesModalExistingTitleOptions;
};

export type UserBulkUpdateRolesModalHasErrorsMessageTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE";
    options: UserBulkUpdateRolesModalHasErrorsMessageOptions;
};

export type UserBulkUpdateRolesModalNewTitleTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE";
    options: UserBulkUpdateRolesModalNewTitleOptions;
};

export type UserBulkUpdateRolesModalRemoveRolesCountTextTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT";
    options: UserBulkUpdateRolesModalRemoveRolesCountTextOptions;
};

export type UserBulkUpdateRolesModalRemovedTitleTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE";
    options: UserBulkUpdateRolesModalRemovedTitleOptions;
};

export type UserBulkUpdateRolesModalSelectedRolesListTitleTranslatableText = {
    key: "USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE";
    keyId: "USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE";
    options: UserBulkUpdateRolesModalSelectedRolesListTitleOptions;
};

export type UserUsersLocationsBoxExistingLocationsTitleTranslatableText = {
    key: "USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE";
    keyId: "USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE";
    options: UserUsersLocationsBoxExistingLocationsTitleOptions;
};

export type UserUsersLocationsBoxNewLocationsTitleTranslatableText = {
    key: "USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE";
    keyId: "USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE";
    options: UserUsersLocationsBoxNewLocationsTitleOptions;
};

export type UserUsersLocationsBoxRemovedLocationsTitleTranslatableText = {
    key: "USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE";
    keyId: "USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE";
    options: UserUsersLocationsBoxRemovedLocationsTitleOptions;
};

export type UserUsersLocationsBoxRightTitleTranslatableText = {
    key: "USER.USERS_LOCATIONS_BOX.RIGHT_TITLE";
    keyId: "USER.USERS_LOCATIONS_BOX.RIGHT_TITLE";
    options: UserUsersLocationsBoxRightTitleOptions;
};

export type TranslatableTextWithParams =
    AccountDetailsImageMustBeSquareAndAtLeastMinimumSizeTranslatableText |
    AccountDetailsMinimumImageDimensionRequirementTranslatableText |
    AccountMapCreateNewMapForTranslatableText |
    AccountMapUnsupportedCurrencyTranslatableText |
    AdminBrandsAssignClientsToTranslatableText |
    AdminBrandsCheckClientsToAssignToTranslatableText |
    AdminBrandsThisWillPermanentlyDeleteTranslatableText |
    AdminExternalAuthAppsConfirmDeleteTranslatableText |
    AdminMaintenanceStartTimeTranslatableText |
    AdminPayableServiceConfirmDeleteCostTranslatableText |
    AdminPayableServiceCostInvalidPrecisionTranslatableText |
    AdminSubscriptionsDefaultSubForTranslatableText |
    AdminSubscriptionsDeleteRecurringConfirmTranslatableText |
    AdminSubscriptionsLocationInitialSubscriptionForTranslatableText |
    AgenciesAgencyConfirmDeleteTranslatableText |
    AgenciesAgencyDeletedConfirmationMessageTranslatableText |
    AgenciesUserAddNewUserToTranslatableText |
    AgenciesUserRemoveUserTranslatableText |
    AgenciesUserUserAddedSuccessMessageTranslatableText |
    AgenciesUserUserRemovedSuccessMessageTranslatableText |
    AgencyClientBrandColoursCreatedBrandColourTranslatableText |
    AgencyClientBrandColoursDeleteConfirmationTranslatableText |
    AgencyClientBrandColoursSuccessfullyAddedBrandColourTranslatableText |
    AgencyClientBrandColoursSuccessfullyRenamedBrandColourTranslatableText |
    AgencyClientBrandColoursSuccessfullyUpdatedBrandColourTranslatableText |
    AgencyClientBrandColoursUpdateBrandColourTranslatableText |
    AgencyClientBrandColoursUpdatedBrandColourTranslatableText |
    AgencyClientBuilderTemplateCategoriesConfirmDeleteTranslatableText |
    AgencyClientLinksDeleteConfirmationTranslatableText |
    AgencyClientLocationActivitiesDeleteActivityTranslatableText |
    AgencyClientLocationActivitiesMigrateChannelConfirmClickDeleteChannelTranslatableText |
    AgencyClientLocationFeaturedTemplateSetsDeleteTemplateTagTranslatableText |
    AgencyClientLocationLearnMenuAddSubSectionToSectionTranslatableText |
    AgencyClientLocationLearnMenuDeleteSectionTranslatableText |
    AgencyClientLocationLearnMenuDeleteSubSectionTranslatableText |
    AgencyClientLocationLearnMenuSubSectionsForTranslatableText |
    AgencyClientLocationLocationDetailsDeleteConfirmationTranslatableText |
    AgencyClientLocationManageCreatedLocationErrorTranslatableText |
    AgencyClientLocationManageCreatedLocationSuccessTranslatableText |
    AgencyClientLocationManageDeleteLocationErrorTranslatableText |
    AgencyClientLocationManageDeleteLocationLabelTranslatableText |
    AgencyClientLocationManageDeleteLocationSuccessTranslatableText |
    AgencyClientLocationManageEditDetailsTranslatableText |
    AgencyClientLocationManageNoFieldValueTranslatableText |
    AgencyClientLocationNotifyLocationDeletedTranslatableText |
    AgencyClientLocationSummaryFieldsDeleteFieldConfirmTranslatableText |
    AgencyClientLocationUsersAddNewUserToTranslatableText |
    AgencyClientLocationUsersDeleteConfirmationTranslatableText |
    AgencyClientLocationUsersDeleteUserTranslatableText |
    AgencyClientLocationUsersUserAddedTranslatableText |
    AgencyClientLocationUsersUserEditUserDeletedTranslatableText |
    AgencyClientLocationUsersUserEditUserUpdatedTranslatableText |
    AgencyClientLocationUsersUserRemovedTranslatableText |
    AgencyClientLocationCategoriesDeleteConfirmationTranslatableText |
    AgencyClientLocationCategoriesDeleteGroupTranslatableText |
    AgencyClientLocationCategoriesDeleteLocationCategoryConfirmTranslatableText |
    AgencyClientLocationCategoriesDeletedLocationCategoryTranslatableText |
    AgencyClientLocationCategoriesNewOptionTranslatableText |
    AgencyClientLocationCategoriesOptionAddedTranslatableText |
    AgencyClientLocationCategoriesOptionDeletedTranslatableText |
    AgencyClientLocationCategoriesPartiallyAddedLocationCategoryTranslatableText |
    AgencyClientLocationCategoriesPartiallyEditedLocationCategoryTranslatableText |
    AgencyClientLocationCategoriesSuccessfullyAddedLocationCategoryTranslatableText |
    AgencyClientLocationCategoriesSuccessfullyEditedLocationCategoryTranslatableText |
    AgencyClientLocationCategoriesUpdatedLocationsForCategoryTranslatableText |
    AgencyClientLocationsDeleteClientTranslatableText |
    AgencyClientLocationsEmailsSignUpAgencyInvitedYouTranslatableText |
    AgencyClientLocationsEmailsSignUpWelcomeToDigitalStackTranslatableText |
    AgencyClientLocationsEmailsSignedUpLocationSignedUpTranslatableText |
    AgencyClientLocationsEmailsUpdateBillingDetailsSubjectLineTranslatableText |
    AgencyClientLocationsNoLocationsAssignedTranslatableText |
    AgencyClientLocationsPermanentlyDeletedClientTranslatableText |
    AgencyClientPlatformsConfirmRemovePlatformTranslatableText |
    AgencyClientPlatformsConfirmRemovePlatformTitleTranslatableText |
    AgencyClientUsersCountSelectedTranslatableText |
    AgencyClientUsersSortDirectionTipTranslatableText |
    AgencyClientsAddClientNewChannelTranslatableText |
    AgencyClientsClientTableActionsDeleteClientLabelTranslatableText |
    AgencyNotificationsSendConfirmMessageTranslatableText |
    AgencyNotificationsSentByTranslatableText |
    AgencyPrintSkuGroupsPrintProviderAuthRequestConfirmationTranslatableText |
    AgencyPrintSkuGroupsSkuCreateSkuTranslatableText |
    AgencyPrintSkuGroupsSkuEditSkuTranslatableText |
    AgencyPrintSkuGroupsSkuSkuDeleteConfirmationTranslatableText |
    AgencyPrintSkuGroupsSkuGroupsDeleteSkuGroupTranslatableText |
    AgencyPrintSkuGroupsSkuGroupsEditSkuGroupTranslatableText |
    AgencyPrintSkuGroupsSkuGroupsSkuGroupDeleteConfirmationTranslatableText |
    AgencySendReportsReportClickedSubtitleTranslatableText |
    AgencySendReportsReportReadSubtitleTranslatableText |
    AgencySendReportsReportSentFromTranslatableText |
    AgencySendReportsReportSentSubtitleTranslatableText |
    AgencySendReportsReportSentToPart2TranslatableText |
    AgencySendReportsReportSubtitleNotSentTranslatableText |
    AgencySendReportsReportSubtitleSentByTranslatableText |
    AppsCampaignsFoundInAdwordsThatMatchNameTranslatableText |
    AppsConnectToAccountTranslatableText |
    AppsConnectingViaAccountTranslatableText |
    AppsCustomerIdTranslatableText |
    AppsDisconnectFromAccountTranslatableText |
    AppsErrorsDebugMessageWrapTranslatableText |
    AppsErrorsWeveEncounteredIssuesTranslatableText |
    AppsFetchServiceConfigTranslatableText |
    AppsGoogleAdwordsCampaignNameMatchesCountContinueTranslatableText |
    AppsInstagramConnectedAccountInfoTranslatableText |
    AppsPrintProviderSkuGroupAttachedTranslatableText |
    AssetLibraryCollectionLimitReachedTranslatableText |
    AssetLibraryMoveAssetsToFolderTranslatableText |
    AssetLibraryMovingAssetsTranslatableText |
    AssetLibrarySavingAssetsTranslatableText |
    AssetLibraryUploadingAssetsTranslatableText |
    BuildAnimationFrameNumberOfCountTranslatableText |
    BuildBuilderTemplateDeleteConfirmationModalConfirmationMessageTranslatableText |
    BuildBuilderTemplateUpdateConfirmationModalConfirmationMessageTranslatableText |
    BuildConfirmDeleteAllChannelDataTranslatableText |
    BuildEmailNoCampaginMonitorSetupForLocationTranslatableText |
    BuildEmailZipValidationImageMissingTranslatableText |
    BuildEmailZipValidationImageUnreferencedTranslatableText |
    BuildErrorDimensionsForPngInPrintTemplatesLimitedTranslatableText |
    BuildFontsAddFontForClientTranslatableText |
    BuildFontsAreYouSureDeleteFamilyTranslatableText |
    BuildFontsDeleteFontFamilyTranslatableText |
    BuildFormatsSelectedTranslatableText |
    BuildLocationDraftAreYouSureYouWantToOverrideTemplateRevisionWithTitleTranslatableText |
    BuildLocationDraftSaveLocationRevisionWithTitleTranslatableText |
    BuildLocationDraftSaveOverCurrentRevisionWithTitleTranslatableText |
    BuildLocationLogoNotSetTranslatableText |
    BuildLocationMapNotCreatedTranslatableText |
    BuildMobileAppTemplateValidationNotMobileCompatibleTranslatableText |
    BuildMultiImageMuliImageCounterTooltipTranslatableText |
    BuildPrintExtraInfoTranslatableText |
    BuildPrintPageNumberOfCountTranslatableText |
    BuildPrintPleaseEnterPageNumberBetweenTranslatableText |
    BuildPublishClubReadyCustomListDescriptionWarningTranslatableText |
    BuildPublishClubReadyCustomListMatchesTranslatableText |
    BuildPublishClubReadyMatchedOutOfTranslatableText |
    BuildPublishClubReadyMoreClubCountTranslatableText |
    BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToTranslatableText |
    BuildPublishClubReadySenderNotVerifiedMessageTranslatableText |
    BuildPublishClubReadyWarnPublishTooLargeTranslatableText |
    BuildPublishFacebookPageListRemainingTranslatableText |
    BuildPublishFacebookPagesCountTranslatableText |
    BuildPublishGoogleMyBusinessCharacterLimitReachedTranslatableText |
    BuildPublishHashtagsErrorLimitHashtagCountTranslatableText |
    BuildPublishHashtagsHashtagCharacterCountTranslatableText |
    BuildPublishHashtagsHashtagTagCountTranslatableText |
    BuildPublishInstagramExceededMaxImageCountHelpTextTranslatableText |
    BuildPublishInstagramPostsWillExpireTranslatableText |
    BuildPublishInstagramScheduledPostMustBeAtLeastMinsInFutureTranslatableText |
    BuildPublishMultipleLocationsNoAccessHelpTranslatableText |
    BuildPublishMultipleLocationsPublishedVideosSuccessfullyTranslatableText |
    BuildPublishMultipleLocationsScheduledVideosSuccessfullyTranslatableText |
    BuildPublishMultiplePlatformsPublishedToPlatformTranslatableText |
    BuildPublishMultiplePlatformsPublishingToPlatformTranslatableText |
    BuildPublishNoAccessHelpTranslatableText |
    BuildPublishPublishedSuccessfullyTranslatableText |
    BuildPublishSavedSuccessfullyTranslatableText |
    BuildPublishScheduledSuccessfullyTranslatableText |
    BuildPublishTwitterCannotPublishMultiImageHelpTextTranslatableText |
    BuildPublishWillReceiveNotificationTranslatableText |
    BuildPublishWillReceiveScheduledNotificationTranslatableText |
    BuildPublishWillRecieveSmsDetailsTranslatableText |
    BuildPublishWillRecieveSmsReminderTranslatableText |
    BuildResourcesLoadedTranslatableText |
    BuildTemplateAdminCopySuccessTranslatableText |
    BuildTemplateAdminCopySuccessExtendedTranslatableText |
    ClientClientUsersLocationModalTitleTranslatableText |
    ClientClientUsersTableButtonBulkActionsSecondaryTranslatableText |
    ClientEngagementHelpTextConnectionsCurrentlyRequiredPlatformsTranslatableText |
    ClientEngagementHelpTextConnectionsHowToSetRequiredPlatformsTranslatableText |
    ClientLocationActivityBuiltItemsCountTranslatableText |
    ClientOverviewTemplateCategoriesAssetsUsedTranslatableText |
    CommonAndXOtherLocationsTranslatableText |
    CommonAreYouSureYouWantToDeleteNumAssetsTranslatableText |
    CommonClientWithLocationTranslatableText |
    CommonConfirmModalInputTranslatableText |
    CommonCopiedToClipboardTranslatableText |
    CommonCurrentLocationUsedMaxCollectionsTranslatableText |
    CommonCurrentlySelectedCountTranslatableText |
    CommonDeleteSomethingTranslatableText |
    CommonEditMultipleAssetsTranslatableText |
    CommonFailedToTranslatableText |
    CommonMustBeXOrMoreTranslatableText |
    CommonNumOfTotalTranslatableText |
    CommonProgressModalStatusMessageTranslatableText |
    CommonRenameSomethingTranslatableText |
    CommonSearchWithinTranslatableText |
    CommonSortDirectionTipTranslatableText |
    CommonStepNOfCountTranslatableText |
    CommonUnsupportedImageFileTypeTranslatableText |
    CommonValidationStringTooLongTranslatableText |
    DashboardDueInNDaysTranslatableText |
    DashboardDueInNWeeksTranslatableText |
    DashboardInNWeeksTranslatableText |
    DashboardPerformanceSummaryConnectAppsToSeePerformanceTranslatableText |
    DashboardPerformanceSummaryFailedToGetPerformanceMetricTranslatableText |
    DashboardPerformanceSummaryPerformanceHeadingTranslatableText |
    DashboardWelcomeMessageTranslatableText |
    DashboardWelcomePageNumCountriesTranslatableText |
    DashboardWelcomePageNumLocationsTranslatableText |
    EmailLinkWillExpireTranslatableText |
    EmailSendToPrintArtworkHasBeenSentToTranslatableText |
    EmailSendToPrintProviderWillBeInTouchTranslatableText |
    EmailSendToPrintSubjectTranslatableText |
    EmailSendToPrintSubjectOrderNumberTranslatableText |
    EmailSendToPrintUserInvoiceSubjectTranslatableText |
    ErrorsBadRequestErrorsPlannerActionDateBelowThresholdTranslatableText |
    ErrorsBadRequestErrorsValidationErrorTranslatableText |
    ErrorsBrandBrandColoursErrorAddingBrandColourTranslatableText |
    ErrorsBrandBrandColoursErrorDeletingBrandColourTranslatableText |
    ErrorsBrandBrandColoursErrorRenamingBrandColourTranslatableText |
    ErrorsBrandBrandColoursErrorUpdatingBrandColourTranslatableText |
    ErrorsBrandLocationCategoriesErrorAddingLocationCategoryTranslatableText |
    ErrorsBrandLocationCategoriesErrorDeletingLocationCategoryTranslatableText |
    ErrorsBrandLocationCategoriesErrorRenamingLocationCategoryTranslatableText |
    ErrorsBrandLocationCategoriesErrorUpdatingLocationsForCategoryTranslatableText |
    ErrorsExceptionIdTranslatableText |
    ErrorsExternalServiceErrorsAcrCloudTranslatableText |
    ErrorsExternalServiceErrorsEmailFailureTranslatableText |
    ErrorsExternalServiceErrorsEwayErrorTranslatableText |
    ErrorsExternalServiceErrorsPassthroughTranslatableText |
    ErrorsExternalServiceErrorsTwitterErrorTranslatableText |
    ErrorsExternalServiceErrorsTwitterUnknownErrorTranslatableText |
    ErrorsFacebookErrorsUntranslatedErrorMessageTranslatableText |
    ErrorsFinaliseBillingDetailsUpdateErrorTranslatableText |
    ErrorsFitwareMemberEngagerUntranslatedErrorMessageTranslatableText |
    ErrorsFour51ProductMisconfiguredTranslatableText |
    ErrorsFour51UntranslatedErrorMessageTranslatableText |
    ErrorsInstagramErrorsUntranslatedErrorMessageTranslatableText |
    ErrorsInvalidInputErrorsColourTranslatableText |
    ErrorsInvalidInputErrorsFacebookPageIdMigrationTranslatableText |
    ErrorsInvalidInputErrorsGraphqlInputTranslatableText |
    ErrorsMissingValueErrorsFacebookAdSetMissingEndDateTranslatableText |
    ErrorsMissingValueErrorsFacebookAdSetMissingStartDateTranslatableText |
    ErrorsMissingValueErrorsReplacementValueForLocalResourceTranslatableText |
    ErrorsNotFoundErrorsAgencyLocaleNotFoundWithIdTranslatableText |
    ErrorsNotFoundErrorsEntityNotFoundWithIdTranslatableText |
    ErrorsNotFoundErrorsEntityNotFoundWithTokenTranslatableText |
    ErrorsNotFoundErrorsEntityToDeleteNotFoundTranslatableText |
    ErrorsNotFoundErrorsEntityToUpdateNotFoundTranslatableText |
    ErrorsNotFoundErrorsNoFacebookAccessTokenForLocationTranslatableText |
    ErrorsNotFoundErrorsUserNotFoundWithIdTranslatableText |
    ErrorsOauthErrorsUnknownGrantTypeTranslatableText |
    ErrorsPublishErrorsAccessTokenHasExpiredTranslatableText |
    ErrorsPublishErrorsDuplicatePostsDetectedTranslatableText |
    ErrorsPublishErrorsFailedToPublishToLocationTranslatableText |
    ErrorsPublishErrorsPermissionsNotGrantedTranslatableText |
    ErrorsPublishErrorsServiceInvalidAspectRatioTranslatableText |
    ErrorsPublishErrorsServiceInvalidScheduleDateTranslatableText |
    ErrorsPublishErrorsServiceMaximumCaptionLengthExceededTranslatableText |
    ErrorsPublishErrorsServiceMaximumMediaSizeExceededTranslatableText |
    ErrorsPublishErrorsServiceMaximumPublishCountReachedTranslatableText |
    ErrorsPublishErrorsUnsupportedFileFormatTranslatableText |
    ErrorsPublishErrorsUserCredentialsChangedTranslatableText |
    ErrorsPublishErrorsUserInterventionRequiredTranslatableText |
    ErrorsServiceAccessErrorsAccessExpiredOrForbiddenWithDetailsTranslatableText |
    ErrorsServiceAccessErrorsFacebookAccountCannotAccessPageTranslatableText |
    ErrorsServiceConfigurationErrorsLocationMissingFitwareClubNumberTranslatableText |
    ErrorsServiceConfigurationErrorsServiceNotConfiguredTranslatableText |
    ErrorsServiceCredentialsMissingErrorsNoAuthenticationForServiceTranslatableText |
    ErrorsStripeUntranslatedErrorMessageTranslatableText |
    ErrorsUnexpectedInputErrorsFacebookPageMigrationIdsNotFoundTranslatableText |
    ErrorsUnsupportedCurrencyTranslatableText |
    ErrorsUnsupportedOperationErrorsAccessTokenCannotDetermineAffectedTargetNameTranslatableText |
    ErrorsUnsupportedOperationErrorsImageFormatConversionTranslatableText |
    ErrorsUnsupportedOperationErrorsPlannerOperationNotSupportedTranslatableText |
    ErrorsUnsupportedOperationErrorsUnsupportedWindowsTimezoneTranslatableText |
    IntegrationAuthApiKeyPreviousKeyTranslatableText |
    IntegrationClientClubReadyEnterChainIdWithClientTitleTranslatableText |
    IntegrationConfigureIntegrationTranslatableText |
    IntegrationDisableForTranslatableText |
    IntegrationDisabledIntegrationTranslatableText |
    IntegrationEnableForTranslatableText |
    IntegrationEnabledIntegrationTranslatableText |
    IntegrationIntegrationConfigurationTranslatableText |
    IntegrationNotifyAccessCheckFailedTranslatableText |
    IntegrationNotifyCouldNotAuthorizeServiceTranslatableText |
    IntegrationNotifyCouldNotDeauthorizeServiceTranslatableText |
    IntegrationNotifyServiceDeauthorizedTranslatableText |
    IntegrationSetupIntegrationsForTranslatableText |
    IntroWelcomeToDigitalStackTranslatableText |
    LearnDeleteConfirmTranslatableText |
    LearnEmailCommentAddedToLearnArticleTranslatableText |
    LearnNotifyLearnCreatedTranslatableText |
    LearnNotifyLearnUpdatedTranslatableText |
    LoginPasswordTooShortTranslatableText |
    LoginSignedInAsTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateCompleteMyMonthPlannerTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowMultipleLocationsTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateGetOnTopOfYourPlanningForMonthTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateLocationForMonthTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateViewMyMonthPlannerTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateWhatsOnThisWeekAtLocationTranslatableText |
    MarketingEmailsWeeklyMarketingUpdateYourWeeklyUpdateTranslatableText |
    NotificationsMessagesCustomAgencyMessageTranslatableText |
    NotificationsMessagesEmailScheduleFailedTranslatableText |
    NotificationsMessagesEmailScheduledTranslatableText |
    NotificationsMessagesImagePublishFailedTranslatableText |
    NotificationsMessagesImagePublishFailedNoErrorTranslatableText |
    NotificationsMessagesIntegrationConnectivityFailureTranslatableText |
    NotificationsMessagesIntegrationConfigurationMisconfiguredTranslatableText |
    NotificationsMessagesLocationMapGeneratedTranslatableText |
    NotificationsMessagesLocationMapGenerationFailedTranslatableText |
    NotificationsMessagesScheduledPostsNoNotifiableDevicesTranslatableText |
    NotificationsMessagesTestTranslatableText |
    NotificationsMessagesVideoPublishFailedTranslatableText |
    NotificationsMessagesVideoPublishedExternallyTranslatableText |
    NotificationsMessagesVideoPublishedExternallyV2TranslatableText |
    NotificationsMessagesVideoScheduledExternallyTranslatableText |
    NotificationsMessagesVideoScheduledExternallyV2TranslatableText |
    NotificationsSendNotificationWizardComposeEmailEditorButtonsHeadingNumTranslatableText |
    NotificationsSendNotificationWizardComposeEmailInputLabelsFromAddressSwitchDefaultTranslatableText |
    NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationTranslatableText |
    NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationsTranslatableText |
    NotificationsSendNotificationWizardPickLocationsCurrentlySelectedTranslatableText |
    NotificationsSendNotificationWizardPickLocationsLabelsTotalRecipientsTranslatableText |
    NotificationsSubjectsCustomAgencyMessageTranslatableText |
    OverviewConfirmPlannerEventsTranslatableText |
    OverviewDeletingTitleTranslatableText |
    OverviewDueByTranslatableText |
    OverviewFilteredAmountTranslatableText |
    OverviewLoadedLocationsTranslatableText |
    OverviewSavingForTitleTranslatableText |
    PaymentsEmailsAmountDueTranslatableText |
    PaymentsEmailsAttemptedPaymentDateTranslatableText |
    PaymentsEmailsDueDateTranslatableText |
    PaymentsEmailsFailedSubjectLineTranslatableText |
    PaymentsEmailsInvoiceDescriptionTranslatableText |
    PaymentsEmailsInvoiceNumberTranslatableText |
    PaymentsEmailsPaymentFailedForLocationTranslatableText |
    PaymentsEmailsReportFailedSubjectLineTranslatableText |
    PaymentsEmailsReportPaymentFailedForLocationsTranslatableText |
    PaymentsEmailsReportPaymentFailureReasonTranslatableText |
    PaymentsEmailsRetryWeWillAttemptToChargeAgainTranslatableText |
    PaymentsEmailsRolloverWeWillAddOutstandingAmountToNextPaymentTranslatableText |
    PaymentsEmailsSubscriptionAmountTranslatableText |
    PaymentsSignUpAgencyWelcomesYouTranslatableText |
    PaymentsSignUpAmountPerMonthTranslatableText |
    PaymentsSignUpFirstBillingDateIsTranslatableText |
    PaymentsStripeEmailsAuthRequestUserRequestedYouToAuthTranslatableText |
    PlanActivitiesChannelsChannelForActivityTranslatableText |
    PlanAgencyToBuildSpecificTranslatableText |
    PlanAgencyToBuildTooltipTranslatableText |
    PlanCampaignsActionsArchiveMessageTranslatableText |
    PlanCampaignsActionsUnarchiveMessageTranslatableText |
    PlanCampaignsCampaignRenamedToTranslatableText |
    PlanCampaignsCampaignsListNumDaysTranslatableText |
    PlanCampaignsCreatedNewCampaignTranslatableText |
    PlanCampaignsDeploysDeployCampaignToLocationTranslatableText |
    PlanCampaignsDeploysDeployFormCopyConfirmEventsPerLocationTranslatableText |
    PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientTranslatableText |
    PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientSingularTranslatableText |
    PlanCampaignsDeploysDeploymentHistoryStatusScheduledHelpTranslatableText |
    PlanEventConfirmDeleteTranslatableText |
    PlanEventDateOfMonthExampleTranslatableText |
    PlanEventDateOfMonthInYearExampleTranslatableText |
    PlanEventDateOfWeekExampleTranslatableText |
    PlanEventDateOfWeekInYearExampleTranslatableText |
    PlanEventDeletionAlertTranslatableText |
    PlanEventInstructionsToManagerTranslatableText |
    PlanEventRequiredInfoTranslatableText |
    PlanEventSupportNoteTranslatableText |
    PlanEventSupportRequestedTranslatableText |
    PlanMultipleLocationsSavingForTitleTranslatableText |
    PlanNotifyPlannerCreatedTranslatableText |
    PlanNotifyPlannerCreatedPartialTranslatableText |
    PlanNotifyPlannerUpdatedTranslatableText |
    ProfileMinimumImageDimensionRequirementTranslatableText |
    ReportAllMonetaryFiguresAreInCurrencyTranslatableText |
    ReportConversionsPlatformNotConfiguredForLocationTranslatableText |
    ReportEmailCampaignsClicksTranslatableText |
    ReportEmailCampaignsErrorCouldNotBeRetrievedTranslatableText |
    ReportEmailCampaignsNumberRecipientsTranslatableText |
    ReportEmailCampaignsOpensTranslatableText |
    ReportEmailCampaignsRecipientsTranslatableText |
    ReportEmailCampaignsSendingOnTranslatableText |
    ReportEmailCampaignsSentToTranslatableText |
    ReportFacebookAudienceInsightsOnlineFollowersHelpDaysTranslatableText |
    ReportFacebookAudienceInsightsOnlineFollowersHelpHoursTranslatableText |
    ReportFacebookLikesReportPeriodAgoTranslatableText |
    ReportGeneratedReportPrintFooterTranslatableText |
    ReportGoogleAdsAdNameTooltipNumDescriptionTranslatableText |
    ReportGoogleAdsAdNameTooltipNumHeadlineTranslatableText |
    ReportGoogleAdsAdNameTooltipNumUrlTranslatableText |
    ReportGoogleAdwordsSpendAdjustmentRequestExtraStepsMayBeRequiredTranslatableText |
    ReportGoogleAdwordsSpendAdjustmentRequestIncreaseMyGoogleAdwordsBudgetTranslatableText |
    ReportGoogleAdwordsSpendAdjustmentRequestUserHasRequestedAnAdjustmentToAdwordsSpendTranslatableText |
    ReportGoogleMyBusinessRecentPostsPostClicksTranslatableText |
    ReportGoogleMyBusinessRecentPostsPostViewsTranslatableText |
    ReportGoogleMyBusinessTopQuestionsAnswersTranslatableText |
    ReportGoogleMyBusinessTopQuestionsQuestionsTranslatableText |
    ReportGoogleMyBusinessTopQuestionsUpvotesTranslatableText |
    ReportGoogleMyBusinessTopReviewsRepliedAtTranslatableText |
    ReportGoogleMyBusinessTopReviewsReviewsTranslatableText |
    ReportInstagramAudienceInsightsOnlineFollowersHelpDaysTranslatableText |
    ReportInstagramAudienceInsightsOnlineFollowersHelpHoursTranslatableText |
    ReportMoreRowsTranslatableText |
    ReportNotConnectedPart1TranslatableText |
    ReportNotConnectedPart2TranslatableText |
    ReportPaidImpressionsTranslatableText |
    ReportPaidUniqueViewsTranslatableText |
    ReportReportLoadedLocationsTranslatableText |
    ReportShowTopNTranslatableText |
    ReportTemplateUseByLocationTranslatableText |
    ReportTemplateUsesTranslatableText |
    ReportTotalImpressionsTranslatableText |
    ReportTotalReachVsTotalPaidTranslatableText |
    ReportTotalUniqueViewsTranslatableText |
    RequestsAlreadyPaidDifferenceTranslatableText |
    RequestsEmailsAddedNewSpecialRequestTranslatableText |
    RequestsEmailsAddedRequestIsDueByTranslatableText |
    RequestsEmailsCommentAddedSpecialRequestHasBeenUpdatedTranslatableText |
    RequestsEmailsCommentAddedSubjectLineTranslatableText |
    RequestsPaymentTranslatableText |
    RequestsPaymentOverpaidTranslatableText |
    RequestsPreviousQuoteDifferenceTranslatableText |
    ScheduleEmailsFailedToNotifyContentTranslatableText |
    ScheduleEmailsFailedToNotifyHeading1TranslatableText |
    ScheduleEmailsFailedToNotifySubjectLineTranslatableText |
    ScheduleEmailsNoDevicesContent1TranslatableText |
    SchedulePageDialogsDeleteOptionForMultipleTranslatableText |
    SchedulePageDialogsDeleteOptionForSingleTranslatableText |
    SchedulePageDialogsEditCaptionContactingPlatformTranslatableText |
    SchedulePageDialogsEditCaptionOptionForMultipleTranslatableText |
    SchedulePageDialogsEditCaptionOptionForSingleTranslatableText |
    SchedulePageDialogsRescheduleDeletedTranslatableText |
    SchedulePageDialogsRescheduleOptionForMultipleTranslatableText |
    SchedulePageDialogsRescheduleOptionForSingleTranslatableText |
    SchedulePageTableNoScheduledPostsFoundForPlatformTranslatableText |
    SchedulePostsPostDetailsSmsTranslatableText |
    SchedulePostsPostImmediatelyTranslatableText |
    SchedulePostsPostScheduledForTranslatableText |
    SchedulePostsSmsDownloadMessageTranslatableText |
    SchedulePushNotificationsTimeToPostTranslatableText |
    ShoppingCartCheckoutAddressTranslatableText |
    ShoppingCartCheckoutLocationsTranslatableText |
    ShoppingCartCheckoutPayAmountTranslatableText |
    ShoppingCartCheckoutQuantityTranslatableText |
    ShoppingCartEmailsDateTranslatableText |
    ShoppingCartEmailsOrderNumberTranslatableText |
    ShoppingCartEmailsPrintOrderForProviderAgencyTranslatableText |
    ShoppingCartEmailsPrintOrderForProviderClientTranslatableText |
    ShoppingCartEmailsPrintOrderForProviderContactEmailTranslatableText |
    ShoppingCartEmailsPrintOrderForProviderOrderReceivedTranslatableText |
    ShoppingCartEmailsPrintOrderForProviderSubjectLineTranslatableText |
    ShoppingCartEmailsPrintOrderForUserOrderReceivedTranslatableText |
    ShoppingCartEmailsPrintOrderForUserPrintProviderTranslatableText |
    ShoppingCartEmailsPrintOrderForUserPrintProviderEmailTranslatableText |
    ShoppingCartEmailsPrintOrderForUserSubjectLineTranslatableText |
    StatsEmailsAccessTokenErrorAccessErrorForTranslatableText |
    StatsEmailsAccessTokenErrorAuthorizeServiceTranslatableText |
    StatsEmailsAccessTokenErrorIfAccessToIsNoLongerRequiredTranslatableText |
    StatsEmailsAccessTokenErrorSubjectLineTranslatableText |
    StatsEmailsAccessTokenErrorTryLoggingInAndReAuthorizingTranslatableText |
    StatsEmailsAccessTokenErrorWeHadAProblemTryingToAccessTranslatableText |
    UserBulkDeleteModalHasErrorsMessageTranslatableText |
    UserBulkResetPasswordsModalConfirmResendInviteTranslatableText |
    UserBulkResetPasswordsModalConfirmSendPasswordResetTranslatableText |
    UserBulkResetPasswordsModalFetchUserErrorMessageTranslatableText |
    UserBulkResetPasswordsModalUsersWithoutAcceptedInviteMessageTranslatableText |
    UserBulkUpdateLocationsModalAddLocationsCountTextTranslatableText |
    UserBulkUpdateLocationsModalConfirmTextTranslatableText |
    UserBulkUpdateLocationsModalHasErrorsMessageTranslatableText |
    UserBulkUpdateLocationsModalRemoveLocationsCountTextTranslatableText |
    UserBulkUpdateRolesModalAddRolesCountTextTranslatableText |
    UserBulkUpdateRolesModalConfirmTextTranslatableText |
    UserBulkUpdateRolesModalExistingTitleTranslatableText |
    UserBulkUpdateRolesModalHasErrorsMessageTranslatableText |
    UserBulkUpdateRolesModalNewTitleTranslatableText |
    UserBulkUpdateRolesModalRemoveRolesCountTextTranslatableText |
    UserBulkUpdateRolesModalRemovedTitleTranslatableText |
    UserBulkUpdateRolesModalSelectedRolesListTitleTranslatableText |
    UserUsersLocationsBoxExistingLocationsTitleTranslatableText |
    UserUsersLocationsBoxNewLocationsTitleTranslatableText |
    UserUsersLocationsBoxRemovedLocationsTitleTranslatableText |
    UserUsersLocationsBoxRightTitleTranslatableText;

export type TranslatableText = 
    | Pick<TranslatableTextNoParams, 'key' | 'options'>
    | Pick<TranslatableTextWithParams, 'key' | 'options'>;

export interface TextTranslators extends TranslateFunction {
    account: {
        accountAlreadyExists: TextTranslator<TranslateOptions>;
        createAccount: TextTranslator<TranslateOptions>;
        details: {
            accountDetailsUpdated: TextTranslator<TranslateOptions>;
            addressLineOne: TextTranslator<TranslateOptions>;
            addressLineThree: TextTranslator<TranslateOptions>;
            addressLineTwo: TextTranslator<TranslateOptions>;
            attentionTo: TextTranslator<TranslateOptions>;
            billingDetails: TextTranslator<TranslateOptions>;
            companyName: TextTranslator<TranslateOptions>;
            contactDetails: TextTranslator<TranslateOptions>;
            country: TextTranslator<TranslateOptions>;
            displayAddress: TextTranslator<TranslateOptions>;
            failedToUpdateAccountDetails: TextTranslator<TranslateOptions>;
            imageMustBeSquareAndAtLeastMinimumSize: TextTranslator<AccountDetailsImageMustBeSquareAndAtLeastMinimumSizeOptions>;
            locationDetails: TextTranslator<TranslateOptions>;
            locationDetailsSaved: TextTranslator<TranslateOptions>;
            locationEmail: TextTranslator<TranslateOptions>;
            locationLogo: TextTranslator<TranslateOptions>;
            locationPhoneNumber: TextTranslator<TranslateOptions>;
            minimumImageDimensionRequirement: TextTranslator<AccountDetailsMinimumImageDimensionRequirementOptions>;
            notes: TextTranslator<TranslateOptions>;
            phone: TextTranslator<TranslateOptions>;
            postcode: TextTranslator<TranslateOptions>;
            preferredMeetingTimes: TextTranslator<TranslateOptions>;
            sameAsContactDetails: TextTranslator<TranslateOptions>;
            shippingAddress: TextTranslator<TranslateOptions>;
            squareAspectRatioRequired: TextTranslator<TranslateOptions>;
            state: TextTranslator<TranslateOptions>;
            suburb: TextTranslator<TranslateOptions>;
            websiteUrl: TextTranslator<TranslateOptions>;
        };
        locationDetails: {
            createMapLocation: TextTranslator<TranslateOptions>;
            getLocationDetails: TextTranslator<TranslateOptions>;
            removeLocationMap: TextTranslator<TranslateOptions>;
            shippingDetailsUpdated: TextTranslator<TranslateOptions>;
            startMapPayment: TextTranslator<TranslateOptions>;
            updateLocationDetails: TextTranslator<TranslateOptions>;
            updateShippingDetails: TextTranslator<TranslateOptions>;
        };
        map: {
            confirmPaymentDetails: TextTranslator<TranslateOptions>;
            createNewMap: TextTranslator<TranslateOptions>;
            createNewMapFor: TextTranslator<AccountMapCreateNewMapForOptions>;
            editMap: TextTranslator<TranslateOptions>;
            getMapServiceCost: TextTranslator<TranslateOptions>;
            mapGenerationFailed: TextTranslator<TranslateOptions>;
            mapGenerationInprogress: TextTranslator<TranslateOptions>;
            paymentInformation: {
                part1: TextTranslator<TranslateOptions>;
                part2: TextTranslator<TranslateOptions>;
            };
            problemRetrievingCost: TextTranslator<TranslateOptions>;
            searchForAddress: TextTranslator<TranslateOptions>;
            unsupportedCurrency: TextTranslator<AccountMapUnsupportedCurrencyOptions>;
        };
        notifyUnauthenticated: TextTranslator<TranslateOptions>;
        notifyUnauthorized: TextTranslator<TranslateOptions>;
    };
    admin: {
        banner: {
            bannerMessage: TextTranslator<TranslateOptions>;
            bannerNotification: TextTranslator<TranslateOptions>;
            createBannerNotification: TextTranslator<TranslateOptions>;
            deleteCurrentBannerNotification: TextTranslator<TranslateOptions>;
            dismissable: TextTranslator<TranslateOptions>;
            getCurrentBannerNotification: TextTranslator<TranslateOptions>;
            notificationType: TextTranslator<TranslateOptions>;
            notifyCreated: TextTranslator<TranslateOptions>;
            notifyDeleted: TextTranslator<TranslateOptions>;
            tip: TextTranslator<TranslateOptions>;
        };
        brands: {
            assign: TextTranslator<TranslateOptions>;
            assignBrand: TextTranslator<TranslateOptions>;
            assignClients: TextTranslator<TranslateOptions>;
            assignClientsTo: TextTranslator<AdminBrandsAssignClientsToOptions>;
            brand: TextTranslator<TranslateOptions>;
            brandColor: TextTranslator<TranslateOptions>;
            brandName: TextTranslator<TranslateOptions>;
            brands: TextTranslator<TranslateOptions>;
            cannotAssignClientIf: TextTranslator<TranslateOptions>;
            checkClientsToAssignTo: TextTranslator<AdminBrandsCheckClientsToAssignToOptions>;
            filterBrands: TextTranslator<TranslateOptions>;
            filterClients: TextTranslator<TranslateOptions>;
            newBrand: TextTranslator<TranslateOptions>;
            pleaseEnterNameColorLogo: TextTranslator<TranslateOptions>;
            thisWillPermanentlyDelete: TextTranslator<AdminBrandsThisWillPermanentlyDeleteOptions>;
            updateBrand: TextTranslator<TranslateOptions>;
            uploadLogo: TextTranslator<TranslateOptions>;
            youCanAssignClientsFrom: TextTranslator<TranslateOptions>;
        };
        clubreadyConnect: {
            action: TextTranslator<TranslateOptions>;
            chainIdConfigurationTitle: TextTranslator<TranslateOptions>;
            clubreadyDisabledForClientHelpText: TextTranslator<TranslateOptions>;
            clientTitle: TextTranslator<TranslateOptions>;
            filterClients: TextTranslator<TranslateOptions>;
            noIntegrationFoundForClient: TextTranslator<TranslateOptions>;
        };
        externalAuthApps: {
            apiKey: TextTranslator<TranslateOptions>;
            appName: TextTranslator<TranslateOptions>;
            confirmDelete: TextTranslator<AdminExternalAuthAppsConfirmDeleteOptions>;
            connections: TextTranslator<TranslateOptions>;
            contactEmail: TextTranslator<TranslateOptions>;
            createAuthApp: TextTranslator<TranslateOptions>;
            deleteApp: TextTranslator<TranslateOptions>;
            deleteAppDisclaimer: TextTranslator<TranslateOptions>;
            deleteConnection: TextTranslator<TranslateOptions>;
            details: {
                dsUser: TextTranslator<TranslateOptions>;
                externalUserIdentifier: TextTranslator<TranslateOptions>;
                noAppConnections: TextTranslator<TranslateOptions>;
            };
            secret: TextTranslator<TranslateOptions>;
            secretEditWarning: TextTranslator<TranslateOptions>;
            secretTooltip: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            tokenEndpoint: TextTranslator<TranslateOptions>;
            tokenEndpointTooltip: TextTranslator<TranslateOptions>;
            updateAuthApp: TextTranslator<TranslateOptions>;
        };
        maintenance: {
            date: TextTranslator<TranslateOptions>;
            expectedDowntime: TextTranslator<TranslateOptions>;
            expectedDowntimeMustBeAtLeastZero: TextTranslator<TranslateOptions>;
            maintenanceWindow: TextTranslator<TranslateOptions>;
            minutes: TextTranslator<TranslateOptions>;
            notifyMaintenanceRemoved: TextTranslator<TranslateOptions>;
            notifyMaintenanceUpdated: TextTranslator<TranslateOptions>;
            removeMaintenanceConfirm: TextTranslator<TranslateOptions>;
            startDateIsRequired: TextTranslator<TranslateOptions>;
            startDateMustBeInTheFuture: TextTranslator<TranslateOptions>;
            startTime: TextTranslator<AdminMaintenanceStartTimeOptions>;
            startTimeMustBeInTheFuture: TextTranslator<TranslateOptions>;
        };
        mapsReport: {
            amountPaid: TextTranslator<TranslateOptions>;
            clientName: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
            locationName: TextTranslator<TranslateOptions>;
            purchasedDate: TextTranslator<TranslateOptions>;
        };
        nav: {
            agencies: TextTranslator<TranslateOptions>;
            authenticationApps: TextTranslator<TranslateOptions>;
            bannerNotification: TextTranslator<TranslateOptions>;
            brands: TextTranslator<TranslateOptions>;
            calendarItems: TextTranslator<TranslateOptions>;
            clubreadyConnect: TextTranslator<TranslateOptions>;
            mapsReport: TextTranslator<TranslateOptions>;
            payableServices: TextTranslator<TranslateOptions>;
            platforms: TextTranslator<TranslateOptions>;
            servicing: TextTranslator<TranslateOptions>;
            siteMaintenance: TextTranslator<TranslateOptions>;
            subscriptions: TextTranslator<TranslateOptions>;
            tasks: TextTranslator<TranslateOptions>;
            templatePreviews: TextTranslator<TranslateOptions>;
        };
        notifyGenerateLocationMapStarted: TextTranslator<TranslateOptions>;
        notifyPurgeSessionsStarted: TextTranslator<TranslateOptions>;
        notifyTestInAppNotificationsStarted: TextTranslator<TranslateOptions>;
        notifyThumbnailGenerationStarted: TextTranslator<TranslateOptions>;
        payableService: {
            confirmDeleteCost: TextTranslator<AdminPayableServiceConfirmDeleteCostOptions>;
            costInvalidPrecision: TextTranslator<AdminPayableServiceCostInvalidPrecisionOptions>;
            costMustBePositive: TextTranslator<TranslateOptions>;
            createServiceCost: TextTranslator<TranslateOptions>;
            deleteServiceCost: TextTranslator<TranslateOptions>;
            notifyServiceCostsUpdated: TextTranslator<TranslateOptions>;
            updateServiceCost: TextTranslator<TranslateOptions>;
        };
        servicing: {
            blockedPublishes: {
                title: TextTranslator<TranslateOptions>;
                subtitle: TextTranslator<TranslateOptions>;
                table: {
                    headers: {
                        updatedAt: TextTranslator<TranslateOptions>;
                        scheduledFor: TextTranslator<TranslateOptions>;
                        content: TextTranslator<TranslateOptions>;
                    };
                    contentLabels: {
                        subject: TextTranslator<TranslateOptions>;
                        emailHtml: TextTranslator<TranslateOptions>;
                        recipients: TextTranslator<TranslateOptions>;
                        template: TextTranslator<TranslateOptions>;
                    };
                    actions: {
                        retryNow: TextTranslator<TranslateOptions>;
                        markFailed: TextTranslator<TranslateOptions>;
                        markSuccessful: TextTranslator<TranslateOptions>;
                    };
                    notFoundMessage: TextTranslator<TranslateOptions>;
                };
            };
            failedPublishes: {
                title: TextTranslator<TranslateOptions>;
                subtitle: TextTranslator<TranslateOptions>;
                table: {
                    headers: {
                        failedAt: TextTranslator<TranslateOptions>;
                        scheduledFor: TextTranslator<TranslateOptions>;
                        content: TextTranslator<TranslateOptions>;
                    };
                    contentLabels: {
                        subject: TextTranslator<TranslateOptions>;
                        emailHtml: TextTranslator<TranslateOptions>;
                        recipients: TextTranslator<TranslateOptions>;
                        template: TextTranslator<TranslateOptions>;
                    };
                    notFoundMessage: TextTranslator<TranslateOptions>;
                };
            };
        };
        subscriptions: {
            clientSubscription: TextTranslator<TranslateOptions>;
            defaultSubFor: TextTranslator<AdminSubscriptionsDefaultSubForOptions>;
            defaultSubscription: TextTranslator<TranslateOptions>;
            defaultSubscriptionUpdated: TextTranslator<TranslateOptions>;
            deleteRecurringConfirm: TextTranslator<AdminSubscriptionsDeleteRecurringConfirmOptions>;
            location: {
                canBeUsedToCancel: TextTranslator<TranslateOptions>;
                dateGap: TextTranslator<TranslateOptions>;
                endDateIsExclusive: TextTranslator<TranslateOptions>;
                future: TextTranslator<TranslateOptions>;
                inactive: TextTranslator<TranslateOptions>;
                inactiveSubscription: TextTranslator<TranslateOptions>;
                initialSubscriptionFor: TextTranslator<AdminSubscriptionsLocationInitialSubscriptionForOptions>;
                leaveItBlank: TextTranslator<TranslateOptions>;
                legend: TextTranslator<TranslateOptions>;
                locationSubscription: TextTranslator<TranslateOptions>;
                locationSubscriptionRecurring: TextTranslator<TranslateOptions>;
                next: TextTranslator<TranslateOptions>;
                noRecurringPayments: TextTranslator<TranslateOptions>;
                notifyRecurringPaymentDeleted: TextTranslator<TranslateOptions>;
                recurringPayment: TextTranslator<TranslateOptions>;
                recurringPaymentSchedule: TextTranslator<TranslateOptions>;
                saveRecurringPayment: TextTranslator<TranslateOptions>;
                subscriptionUpdated: TextTranslator<TranslateOptions>;
                theNextDateIsAfter: TextTranslator<TranslateOptions>;
                thisCanBeUsedTempDiscount: TextTranslator<TranslateOptions>;
                thisCanBeUsedToSkipPayment: TextTranslator<TranslateOptions>;
                updateSubscription: TextTranslator<TranslateOptions>;
            };
            noClients: TextTranslator<TranslateOptions>;
            noLocations: TextTranslator<TranslateOptions>;
            notifyRecurringPaymentDeleted: TextTranslator<TranslateOptions>;
            notifyRecurringPaymentSaved: TextTranslator<TranslateOptions>;
            notifySubscriptionUpdated: TextTranslator<TranslateOptions>;
            subscription: TextTranslator<TranslateOptions>;
            updateDefaultSubscription: TextTranslator<TranslateOptions>;
        };
        users: {
            addNewUser: TextTranslator<TranslateOptions>;
        };
    };
    agencies: {
        addNewAgency: TextTranslator<TranslateOptions>;
        agency: {
            confirmDelete: TextTranslator<AgenciesAgencyConfirmDeleteOptions>;
            deleteAgency: TextTranslator<TranslateOptions>;
            deletedConfirmationMessage: TextTranslator<AgenciesAgencyDeletedConfirmationMessageOptions>;
            editAgency: TextTranslator<TranslateOptions>;
            whitelabelLogo: TextTranslator<TranslateOptions>;
        };
        agencyCreated: TextTranslator<TranslateOptions>;
        agencyName: TextTranslator<TranslateOptions>;
        agencyNameRequired: TextTranslator<TranslateOptions>;
        agencyUpdated: TextTranslator<TranslateOptions>;
        user: {
            addAgencyUser: TextTranslator<TranslateOptions>;
            addNewUserTo: TextTranslator<AgenciesUserAddNewUserToOptions>;
            admin: TextTranslator<TranslateOptions>;
            editAgencyUser: TextTranslator<TranslateOptions>;
            editUser: TextTranslator<TranslateOptions>;
            noUsersAssigned: TextTranslator<TranslateOptions>;
            removeUser: TextTranslator<AgenciesUserRemoveUserOptions>;
            userAddedSuccessMessage: TextTranslator<AgenciesUserUserAddedSuccessMessageOptions>;
            userRemovedSuccessMessage: TextTranslator<AgenciesUserUserRemovedSuccessMessageOptions>;
            userUpdatedSuccessMessage: TextTranslator<TranslateOptions>;
        };
    };
    agency: {
        assignToAgencyManager: {
            warningButtonLabel: TextTranslator<TranslateOptions>;
            warningMessage: TextTranslator<TranslateOptions>;
        };
        client: {
            activities: {
                activityAdded: TextTranslator<TranslateOptions>;
                activityAddedError: TextTranslator<TranslateOptions>;
                activityNameMustBeUnique: TextTranslator<TranslateOptions>;
                addActivity: TextTranslator<TranslateOptions>;
                addChannel: TextTranslator<TranslateOptions>;
                addPlatform: TextTranslator<TranslateOptions>;
                addChannelError: TextTranslator<TranslateOptions>;
                addPlatformError: TextTranslator<TranslateOptions>;
                channelName: TextTranslator<TranslateOptions>;
                platformName: TextTranslator<TranslateOptions>;
                channelNameMustBeUnique: TextTranslator<TranslateOptions>;
                channelType: TextTranslator<TranslateOptions>;
                platformType: TextTranslator<TranslateOptions>;
                deleteActivity: TextTranslator<TranslateOptions>;
                deleteActivityDescription: TextTranslator<TranslateOptions>;
                deleteActivityError: TextTranslator<TranslateOptions>;
                deleteActivitySuccess: TextTranslator<TranslateOptions>;
                deleteChannel: TextTranslator<TranslateOptions>;
                deleteChannelDescription: TextTranslator<TranslateOptions>;
                deletePlatformDescription: TextTranslator<TranslateOptions>;
                deleteChannelError: TextTranslator<TranslateOptions>;
                linkedPlatformOptional: TextTranslator<TranslateOptions>;
                refreshData: TextTranslator<TranslateOptions>;
                retrieveActivities: TextTranslator<TranslateOptions>;
                retrieveBuildingPlatforms: TextTranslator<TranslateOptions>;
                saveNewChannel: TextTranslator<TranslateOptions>;
                updateActivityOrder: TextTranslator<TranslateOptions>;
            };
            brandColors: TextTranslator<TranslateOptions>;
            brandColours: {
                addNewBrandColour: TextTranslator<TranslateOptions>;
                colour: TextTranslator<TranslateOptions>;
                createNewBrandColour: TextTranslator<TranslateOptions>;
                createdBrandColour: TextTranslator<AgencyClientBrandColoursCreatedBrandColourOptions>;
                deleteBrandColour: TextTranslator<TranslateOptions>;
                deleteConfirmation: TextTranslator<AgencyClientBrandColoursDeleteConfirmationOptions>;
                deletedBrandColour: TextTranslator<TranslateOptions>;
                successfullyAddedBrandColour: TextTranslator<AgencyClientBrandColoursSuccessfullyAddedBrandColourOptions>;
                successfullyRenamedBrandColour: TextTranslator<AgencyClientBrandColoursSuccessfullyRenamedBrandColourOptions>;
                successfullyUpdatedBrandColour: TextTranslator<AgencyClientBrandColoursSuccessfullyUpdatedBrandColourOptions>;
                updateBrandColour: TextTranslator<AgencyClientBrandColoursUpdateBrandColourOptions>;
                updateColour: TextTranslator<TranslateOptions>;
                updateOrder: TextTranslator<TranslateOptions>;
                updatedBrandColour: TextTranslator<AgencyClientBrandColoursUpdatedBrandColourOptions>;
                updatedBrandColourOrder: TextTranslator<TranslateOptions>;
            };
            builderTemplateCategories: {
                confirmDelete: TextTranslator<AgencyClientBuilderTemplateCategoriesConfirmDeleteOptions>;
                editCategory: TextTranslator<TranslateOptions>;
                endDateMustBeAfterStartDateOrAbsent: TextTranslator<TranslateOptions>;
                newCategory: TextTranslator<TranslateOptions>;
            };
            conversionAmount: TextTranslator<TranslateOptions>;
            conversionAmountUpdated: TextTranslator<TranslateOptions>;
            conversionWorth: TextTranslator<TranslateOptions>;
            filterClients: TextTranslator<TranslateOptions>;
            links: {
                addNewLink: TextTranslator<TranslateOptions>;
                createNewLink: TextTranslator<TranslateOptions>;
                deleteConfirmation: TextTranslator<AgencyClientLinksDeleteConfirmationOptions>;
                deleteLink: TextTranslator<TranslateOptions>;
                getLinks: TextTranslator<TranslateOptions>;
                linkPatternRequirement: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                updateOrder: TextTranslator<TranslateOptions>;
                url: TextTranslator<TranslateOptions>;
            };
            location: {
                activities: {
                    activityAdded: TextTranslator<TranslateOptions>;
                    activityName: TextTranslator<TranslateOptions>;
                    activityRemoved: TextTranslator<TranslateOptions>;
                    addNewActivity: TextTranslator<TranslateOptions>;
                    channels: TextTranslator<TranslateOptions>;
                    deleteActivity: TextTranslator<AgencyClientLocationActivitiesDeleteActivityOptions>;
                    migratePlatform: {
                        platformAdded: TextTranslator<TranslateOptions>;
                        platformDeleted: TextTranslator<TranslateOptions>;
                    };
                    migrateChannel: {
                        channel: TextTranslator<TranslateOptions>;
                        channelAdded: TextTranslator<TranslateOptions>;
                        channelDeleted: TextTranslator<TranslateOptions>;
                        confirmClickDeleteChannel: TextTranslator<AgencyClientLocationActivitiesMigrateChannelConfirmClickDeleteChannelOptions>;
                        deleteChannel: TextTranslator<TranslateOptions>;
                        migrate: TextTranslator<TranslateOptions>;
                        replaceAll: TextTranslator<TranslateOptions>;
                    };
                    platformLink: TextTranslator<TranslateOptions>;
                    type: TextTranslator<TranslateOptions>;
                };
                billingUpdate: {
                    sendBillingDetailsUpdateRequest: TextTranslator<TranslateOptions>;
                    sendRequest: TextTranslator<TranslateOptions>;
                    signatorysEmailAddress: TextTranslator<TranslateOptions>;
                };
                categories: {
                    notifyUpdated: TextTranslator<TranslateOptions>;
                };
                featuredTemplateSets: {
                    actions: TextTranslator<TranslateOptions>;
                    deleteTemplateTag: TextTranslator<AgencyClientLocationFeaturedTemplateSetsDeleteTemplateTagOptions>;
                    editFeaturedTemplateSet: TextTranslator<TranslateOptions>;
                    endDate: TextTranslator<TranslateOptions>;
                    newFeaturedTemplateSet: TextTranslator<TranslateOptions>;
                    startDate: TextTranslator<TranslateOptions>;
                };
                fonts: {
                    bold: TextTranslator<TranslateOptions>;
                    byChoosingAFont: TextTranslator<TranslateOptions>;
                    chooseFont: TextTranslator<TranslateOptions>;
                    condensed: TextTranslator<TranslateOptions>;
                    custom: TextTranslator<TranslateOptions>;
                    doYouHavePermission: TextTranslator<TranslateOptions>;
                    expanded: TextTranslator<TranslateOptions>;
                    extraCondensed: TextTranslator<TranslateOptions>;
                    extraExpanded: TextTranslator<TranslateOptions>;
                    fontFamily: TextTranslator<TranslateOptions>;
                    fontsSaved: TextTranslator<TranslateOptions>;
                    iConfirmIHavePermission: TextTranslator<TranslateOptions>;
                    italic: TextTranslator<TranslateOptions>;
                    localFile: TextTranslator<TranslateOptions>;
                    noFonts: TextTranslator<TranslateOptions>;
                    normal: TextTranslator<TranslateOptions>;
                    oblique: TextTranslator<TranslateOptions>;
                    selectFont: TextTranslator<TranslateOptions>;
                    semiCondensed: TextTranslator<TranslateOptions>;
                    semiExpanded: TextTranslator<TranslateOptions>;
                    stretch: TextTranslator<TranslateOptions>;
                    style: TextTranslator<TranslateOptions>;
                    ultraCondensed: TextTranslator<TranslateOptions>;
                    ultraExpanded: TextTranslator<TranslateOptions>;
                    weight: TextTranslator<TranslateOptions>;
                    youHaveConfirmed: TextTranslator<TranslateOptions>;
                };
                learnMenu: {
                    addSection: TextTranslator<TranslateOptions>;
                    addSubSection: TextTranslator<TranslateOptions>;
                    addSubSectionToSection: TextTranslator<AgencyClientLocationLearnMenuAddSubSectionToSectionOptions>;
                    couldNotSaveLearnMenu: TextTranslator<TranslateOptions>;
                    deleteSection: TextTranslator<AgencyClientLocationLearnMenuDeleteSectionOptions>;
                    deleteSubSection: TextTranslator<AgencyClientLocationLearnMenuDeleteSubSectionOptions>;
                    learnMenuSaved: TextTranslator<TranslateOptions>;
                    newSubSection: TextTranslator<TranslateOptions>;
                    subSections: TextTranslator<TranslateOptions>;
                    subSectionsFor: TextTranslator<AgencyClientLocationLearnMenuSubSectionsForOptions>;
                };
                locationDetails: {
                    deleteConfirmation: TextTranslator<AgencyClientLocationLocationDetailsDeleteConfirmationOptions>;
                    displayNameTooLong: TextTranslator<TranslateOptions>;
                    locationDetails: TextTranslator<TranslateOptions>;
                    supportedPlannerLimit: TextTranslator<TranslateOptions>;
                };
                manage: {
                    addLocation: TextTranslator<TranslateOptions>;
                    createdLocationError: TextTranslator<AgencyClientLocationManageCreatedLocationErrorOptions>;
                    createdLocationSuccess: TextTranslator<AgencyClientLocationManageCreatedLocationSuccessOptions>;
                    deleteLocationDescription: TextTranslator<TranslateOptions>;
                    deleteLocationError: TextTranslator<AgencyClientLocationManageDeleteLocationErrorOptions>;
                    deleteLocationLabel: TextTranslator<AgencyClientLocationManageDeleteLocationLabelOptions>;
                    deleteLocationSuccess: TextTranslator<AgencyClientLocationManageDeleteLocationSuccessOptions>;
                    editDetails: TextTranslator<AgencyClientLocationManageEditDetailsOptions>;
                    errors: {
                        errorUpdatingLocation: TextTranslator<TranslateOptions>;
                        noClientId: TextTranslator<TranslateOptions>;
                        noLocationOrAccessForbidden: TextTranslator<TranslateOptions>;
                    };
                    filterLocations: TextTranslator<TranslateOptions>;
                    locationName: TextTranslator<TranslateOptions>;
                    locationUpdateSuccess: TextTranslator<TranslateOptions>;
                    noFieldValue: TextTranslator<AgencyClientLocationManageNoFieldValueOptions>;
                    properties: TextTranslator<TranslateOptions>;
                    publicDetails: TextTranslator<TranslateOptions>;
                };
                nav: {
                    activities: TextTranslator<TranslateOptions>;
                    agency: TextTranslator<TranslateOptions>;
                    brandColours: TextTranslator<TranslateOptions>;
                    builderTemplateCategories: TextTranslator<TranslateOptions>;
                    clients: TextTranslator<TranslateOptions>;
                    featuredTemplateSets: TextTranslator<TranslateOptions>;
                    fonts: TextTranslator<TranslateOptions>;
                    learnMenu: TextTranslator<TranslateOptions>;
                    links: TextTranslator<TranslateOptions>;
                    locationCategories: TextTranslator<TranslateOptions>;
                    locations: TextTranslator<TranslateOptions>;
                    platforms: TextTranslator<TranslateOptions>;
                    users: TextTranslator<TranslateOptions>;
                };
                notifyLocationDeleteError: TextTranslator<TranslateOptions>;
                notifyLocationDeleted: TextTranslator<AgencyClientLocationNotifyLocationDeletedOptions>;
                notifyLocationUpdateError: TextTranslator<TranslateOptions>;
                notifyLocationUpdated: TextTranslator<TranslateOptions>;
                summaryFields: {
                    addNewFieldGroup: TextTranslator<TranslateOptions>;
                    deleteField: TextTranslator<TranslateOptions>;
                    deleteFieldConfirm: TextTranslator<AgencyClientLocationSummaryFieldsDeleteFieldConfirmOptions>;
                    deleteGroup: TextTranslator<TranslateOptions>;
                    fieldLabel: TextTranslator<TranslateOptions>;
                    groupName: TextTranslator<TranslateOptions>;
                    newField: TextTranslator<TranslateOptions>;
                };
                users: {
                    addExistingUser: TextTranslator<TranslateOptions>;
                    addExistingUserHelpText: TextTranslator<TranslateOptions>;
                    addExistingUserLabel: TextTranslator<TranslateOptions>;
                    addExistingUserNoMatches: TextTranslator<TranslateOptions>;
                    addExistingUserPlaceholder: TextTranslator<TranslateOptions>;
                    addExistingUserSelected: TextTranslator<TranslateOptions>;
                    addNewUserTo: TextTranslator<AgencyClientLocationUsersAddNewUserToOptions>;
                    assignUserToLocations: TextTranslator<TranslateOptions>;
                    currentlySelected: TextTranslator<TranslateOptions>;
                    deleteConfirmation: TextTranslator<AgencyClientLocationUsersDeleteConfirmationOptions>;
                    deleteUser: TextTranslator<AgencyClientLocationUsersDeleteUserOptions>;
                    failedToAddExistingUser: TextTranslator<TranslateOptions>;
                    filterFirstName: TextTranslator<TranslateOptions>;
                    filterLastName: TextTranslator<TranslateOptions>;
                    filterUsername: TextTranslator<TranslateOptions>;
                    firstName: TextTranslator<TranslateOptions>;
                    lastName: TextTranslator<TranslateOptions>;
                    locationsUpdated: TextTranslator<TranslateOptions>;
                    noUsersAssignedToCompany: TextTranslator<TranslateOptions>;
                    noUsersFound: TextTranslator<TranslateOptions>;
                    removeUserModal: {
                        deleteUser: TextTranslator<TranslateOptions>;
                        removeFromLocation: TextTranslator<TranslateOptions>;
                        removeOrDeleteUserMessage: TextTranslator<TranslateOptions>;
                        removeOrDeleteUserTitle: TextTranslator<TranslateOptions>;
                    };
                    roles: TextTranslator<TranslateOptions>;
                    selectUser: TextTranslator<TranslateOptions>;
                    userAdded: TextTranslator<AgencyClientLocationUsersUserAddedOptions>;
                    userEdit: {
                        analyst: TextTranslator<TranslateOptions>;
                        analystTooltip: TextTranslator<TranslateOptions>;
                        builder: TextTranslator<TranslateOptions>;
                        builderTooltip: TextTranslator<TranslateOptions>;
                        clients: TextTranslator<TranslateOptions>;
                        connectToAccess: TextTranslator<TranslateOptions>;
                        editClientUser: TextTranslator<TranslateOptions>;
                        editUser: TextTranslator<TranslateOptions>;
                        email: TextTranslator<TranslateOptions>;
                        firstName: TextTranslator<TranslateOptions>;
                        lastName: TextTranslator<TranslateOptions>;
                        marketingUpdates: TextTranslator<TranslateOptions>;
                        notifications: TextTranslator<TranslateOptions>;
                        password: TextTranslator<TranslateOptions>;
                        planner: TextTranslator<TranslateOptions>;
                        plannerTooltip: TextTranslator<TranslateOptions>;
                        publisher: TextTranslator<TranslateOptions>;
                        publisherTooltip: TextTranslator<TranslateOptions>;
                        roles: TextTranslator<TranslateOptions>;
                        specialRequester: TextTranslator<TranslateOptions>;
                        specialRequesterTooltip: TextTranslator<TranslateOptions>;
                        specialRequests: TextTranslator<TranslateOptions>;
                        timezone: TextTranslator<TranslateOptions>;
                        update: TextTranslator<TranslateOptions>;
                        userDeleted: TextTranslator<AgencyClientLocationUsersUserEditUserDeletedOptions>;
                        userUpdated: TextTranslator<AgencyClientLocationUsersUserEditUserUpdatedOptions>;
                    };
                    userRemoved: TextTranslator<AgencyClientLocationUsersUserRemovedOptions>;
                    usernameEmail: TextTranslator<TranslateOptions>;
                    users: TextTranslator<TranslateOptions>;
                    usersExistingLocations: TextTranslator<TranslateOptions>;
                    yourInviteHasBeenSent: TextTranslator<TranslateOptions>;
                };
            };
            locationCategories: {
                addRegionOrGroup: TextTranslator<TranslateOptions>;
                addToGroup: TextTranslator<TranslateOptions>;
                associateCollectionPlaceholder: TextTranslator<TranslateOptions>;
                associateTemplateCategoryPlaceholder: TextTranslator<TranslateOptions>;
                deleteConfirmation: TextTranslator<AgencyClientLocationCategoriesDeleteConfirmationOptions>;
                deleteGroup: TextTranslator<AgencyClientLocationCategoriesDeleteGroupOptions>;
                deleteLocationCategoryConfirm: TextTranslator<AgencyClientLocationCategoriesDeleteLocationCategoryConfirmOptions>;
                deletedLocationCategory: TextTranslator<AgencyClientLocationCategoriesDeletedLocationCategoryOptions>;
                errors: {
                    failedAssociateCollections: TextTranslator<TranslateOptions>;
                    failedAssociateTemplateCategories: TextTranslator<TranslateOptions>;
                    missingCollectionsOrCategories: TextTranslator<TranslateOptions>;
                };
                followingLocationsAlreadyAssociatedWithRegion: TextTranslator<TranslateOptions>;
                group: TextTranslator<TranslateOptions>;
                labels: {
                    collections: TextTranslator<TranslateOptions>;
                    linkTemplateCategoriesAndCollections: TextTranslator<TranslateOptions>;
                    name: TextTranslator<TranslateOptions>;
                    type: TextTranslator<TranslateOptions>;
                };
                locationCategories: TextTranslator<TranslateOptions>;
                locationGroup: TextTranslator<TranslateOptions>;
                locationRegion: TextTranslator<TranslateOptions>;
                newOption: TextTranslator<AgencyClientLocationCategoriesNewOptionOptions>;
                notifyEnterLabelForCategory: TextTranslator<TranslateOptions>;
                optionAdded: TextTranslator<AgencyClientLocationCategoriesOptionAddedOptions>;
                optionDeleted: TextTranslator<AgencyClientLocationCategoriesOptionDeletedOptions>;
                partiallyAddedLocationCategory: TextTranslator<AgencyClientLocationCategoriesPartiallyAddedLocationCategoryOptions>;
                partiallyEditedLocationCategory: TextTranslator<AgencyClientLocationCategoriesPartiallyEditedLocationCategoryOptions>;
                radioDisabledMessage: TextTranslator<TranslateOptions>;
                region: TextTranslator<TranslateOptions>;
                selectedLocations: TextTranslator<TranslateOptions>;
                successfullyAddedLocationCategory: TextTranslator<AgencyClientLocationCategoriesSuccessfullyAddedLocationCategoryOptions>;
                successfullyEditedLocationCategory: TextTranslator<AgencyClientLocationCategoriesSuccessfullyEditedLocationCategoryOptions>;
                tooltips: {
                    groupMessage: TextTranslator<TranslateOptions>;
                    linkTemplateCategoriesAndCollections: TextTranslator<TranslateOptions>;
                    regionMessage: TextTranslator<TranslateOptions>;
                };
                updatedLocationsForCategory: TextTranslator<AgencyClientLocationCategoriesUpdatedLocationsForCategoryOptions>;
            };
            locations: {
                addNewLocation: TextTranslator<TranslateOptions>;
                country: TextTranslator<TranslateOptions>;
                countryUpdated: TextTranslator<TranslateOptions>;
                currency: TextTranslator<TranslateOptions>;
                currencyUpdated: TextTranslator<TranslateOptions>;
                defaultSupportedPlannerLimit: TextTranslator<TranslateOptions>;
                defaultSupportedPlannerLimitUpdated: TextTranslator<TranslateOptions>;
                deleteClient: TextTranslator<AgencyClientLocationsDeleteClientOptions>;
                deletePermanently: TextTranslator<TranslateOptions>;
                emails: {
                    signUp: {
                        activateYourEnhancedPackage: TextTranslator<TranslateOptions>;
                        agencyInvitedYou: TextTranslator<AgencyClientLocationsEmailsSignUpAgencyInvitedYouOptions>;
                        clickBelowToUpdateDetails: TextTranslator<TranslateOptions>;
                        clickButtonToCompleteSignUp: TextTranslator<TranslateOptions>;
                        defaultEmailSubject: TextTranslator<TranslateOptions>;
                        inclusionsChangedToOfferBetterValue: TextTranslator<TranslateOptions>;
                        signUp: TextTranslator<TranslateOptions>;
                        theseDetailsAllowSpecificServices: TextTranslator<TranslateOptions>;
                        weRequireConfirmationOfDetails: TextTranslator<TranslateOptions>;
                        welcomeToDigitalStack: TextTranslator<AgencyClientLocationsEmailsSignUpWelcomeToDigitalStackOptions>;
                        youNeedToFillOutDetails: TextTranslator<TranslateOptions>;
                        youreInvited: TextTranslator<TranslateOptions>;
                    };
                    signedUp: {
                        locationSignedUp: TextTranslator<AgencyClientLocationsEmailsSignedUpLocationSignedUpOptions>;
                        newLocationSignedUp: TextTranslator<TranslateOptions>;
                        visitDigitalStack: TextTranslator<TranslateOptions>;
                    };
                    updateBillingDetails: {
                        clickToUpdateBillingDetails: TextTranslator<TranslateOptions>;
                        requestToUpdateBillingDetails: TextTranslator<TranslateOptions>;
                        subjectLine: TextTranslator<AgencyClientLocationsEmailsUpdateBillingDetailsSubjectLineOptions>;
                        updateYourBillingDetails: TextTranslator<TranslateOptions>;
                        weRequireYouToUpdateBillingDetails: TextTranslator<TranslateOptions>;
                    };
                };
                errorDeletingClient: TextTranslator<TranslateOptions>;
                headers: {
                    yourBrands: TextTranslator<TranslateOptions>;
                };
                invitationSent: TextTranslator<TranslateOptions>;
                invite: TextTranslator<TranslateOptions>;
                location: TextTranslator<TranslateOptions>;
                locationAdded: TextTranslator<TranslateOptions>;
                locationGroupsNoCategoriesTooltip: TextTranslator<TranslateOptions>;
                locations: TextTranslator<TranslateOptions>;
                noLocationGroups: TextTranslator<TranslateOptions>;
                noLocationsAssigned: TextTranslator<AgencyClientLocationsNoLocationsAssignedOptions>;
                permanentlyDeletedClient: TextTranslator<AgencyClientLocationsPermanentlyDeletedClientOptions>;
                requestUpdateBillingDetailsSent: TextTranslator<TranslateOptions>;
                resend: TextTranslator<TranslateOptions>;
                signedUp: TextTranslator<TranslateOptions>;
                subscriptionActive: TextTranslator<TranslateOptions>;
                subscriptionAmount: TextTranslator<TranslateOptions>;
                timezone: TextTranslator<TranslateOptions>;
                updateBillingDetails: TextTranslator<TranslateOptions>;
            };
            notificationEmailAddressesUpdated: TextTranslator<TranslateOptions>;
            numberOfLocations: TextTranslator<TranslateOptions>;
            platforms: {
                all: TextTranslator<TranslateOptions>;
                cannotRemovePlatformLinkedChannels: TextTranslator<TranslateOptions>;
                cannotRemovePlatformLinkedTemplates: TextTranslator<TranslateOptions>;
                configure: TextTranslator<TranslateOptions>;
                confirmRemovePlatform: TextTranslator<AgencyClientPlatformsConfirmRemovePlatformOptions>;
                confirmRemovePlatformTitle: TextTranslator<AgencyClientPlatformsConfirmRemovePlatformTitleOptions>;
                disablePlatform: TextTranslator<TranslateOptions>;
                enablePlatform: TextTranslator<TranslateOptions>;
                enabled: TextTranslator<TranslateOptions>;
                fetchClientPlatforms: TextTranslator<TranslateOptions>;
                filterByStatus: TextTranslator<TranslateOptions>;
                filterPlatforms: TextTranslator<TranslateOptions>;
                platform: TextTranslator<TranslateOptions>;
                required: TextTranslator<TranslateOptions>;
            };
            updateConversionDetails: TextTranslator<TranslateOptions>;
            updateNotificationEmailAddresses: TextTranslator<TranslateOptions>;
            users: {
                countSelected: TextTranslator<AgencyClientUsersCountSelectedOptions>;
                searchForUsersOrEmailAddresses: TextTranslator<TranslateOptions>;
                sortDirectionTip: TextTranslator<AgencyClientUsersSortDirectionTipOptions>;
                title: TextTranslator<TranslateOptions>;
            };
        };
        clients: {
            addClient: {
                channelLabel: TextTranslator<TranslateOptions>;
                clientAdded: TextTranslator<TranslateOptions>;
                general: TextTranslator<TranslateOptions>;
                newChannel: TextTranslator<AgencyClientsAddClientNewChannelOptions>;
                selectAPlatformToLinkThisChannelToOptional: TextTranslator<TranslateOptions>;
                selfService: TextTranslator<TranslateOptions>;
                supported: TextTranslator<TranslateOptions>;
            };
            addNewClient: TextTranslator<TranslateOptions>;
            clientName: TextTranslator<TranslateOptions>;
            clientTable: {
                actions: {
                    clientActions: TextTranslator<TranslateOptions>;
                    deleteClientDescription: TextTranslator<TranslateOptions>;
                    deleteClientLabel: TextTranslator<AgencyClientsClientTableActionsDeleteClientLabelOptions>;
                    enterNewName: TextTranslator<TranslateOptions>;
                    rename: TextTranslator<TranslateOptions>;
                };
                headers: {
                    actions: TextTranslator<TranslateOptions>;
                    avgBuilds: TextTranslator<TranslateOptions>;
                    numLocations: TextTranslator<TranslateOptions>;
                    percentageConnected: TextTranslator<TranslateOptions>;
                    title: TextTranslator<TranslateOptions>;
                };
            };
            youHaveNotAddedAny: TextTranslator<TranslateOptions>;
        };
        contactDetails: {
            adwordsMarketing: TextTranslator<TranslateOptions>;
            agencyContactDetails: TextTranslator<TranslateOptions>;
            contactDetails: TextTranslator<TranslateOptions>;
            specialRequestDisclaimer: TextTranslator<TranslateOptions>;
            updateContacts: TextTranslator<TranslateOptions>;
        };
        hashtagSets: {
            actions: {
                addHashtagSet: TextTranslator<TranslateOptions>;
                messages: {
                    couldNotCreateSet: TextTranslator<TranslateOptions>;
                    couldNotDeleteSet: TextTranslator<TranslateOptions>;
                    couldNotUpdateSet: TextTranslator<TranslateOptions>;
                    createdSet: TextTranslator<TranslateOptions>;
                    deletedSet: TextTranslator<TranslateOptions>;
                    updatedSet: TextTranslator<TranslateOptions>;
                };
                updateHashtagSet: TextTranslator<TranslateOptions>;
            };
            dialog: {
                minimumOne: TextTranslator<TranslateOptions>;
                requiredForAllPosts: TextTranslator<TranslateOptions>;
                startByTypingYourHashtags: TextTranslator<TranslateOptions>;
            };
            hashtagSets: TextTranslator<TranslateOptions>;
            hashtags: TextTranslator<TranslateOptions>;
            tableHeaders: {
                description: TextTranslator<TranslateOptions>;
                numberHashtags: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
        };
        notifications: {
            agencyEmailNotifications: TextTranslator<TranslateOptions>;
            agencyNotifications: TextTranslator<TranslateOptions>;
            clickRate: TextTranslator<TranslateOptions>;
            clicks: TextTranslator<TranslateOptions>;
            emailAddress: TextTranslator<TranslateOptions>;
            failedToLoad: TextTranslator<TranslateOptions>;
            helpText: {
                clicks: TextTranslator<TranslateOptions>;
                sent: TextTranslator<TranslateOptions>;
            };
            newComments: TextTranslator<TranslateOptions>;
            newSpecialRequests: TextTranslator<TranslateOptions>;
            noLinkProvided: TextTranslator<TranslateOptions>;
            noNotificationsFound: TextTranslator<TranslateOptions>;
            notificationsWillBeSent: TextTranslator<TranslateOptions>;
            openLink: TextTranslator<TranslateOptions>;
            sendConfirm: {
                message: TextTranslator<AgencyNotificationsSendConfirmMessageOptions>;
                messagePlural: TextTranslator<AgencyNotificationsSendConfirmMessagePluralOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            sendNotification: TextTranslator<TranslateOptions>;
            sendingInfo: {
                mobile: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                website: TextTranslator<TranslateOptions>;
            };
            sent: TextTranslator<TranslateOptions>;
            sentBy: TextTranslator<AgencyNotificationsSentByOptions>;
            sentNotifications: TextTranslator<TranslateOptions>;
            subject: TextTranslator<TranslateOptions>;
        };
        printSkuGroups: {
            agencyPrintProducts: TextTranslator<TranslateOptions>;
            attachedProviders: TextTranslator<TranslateOptions>;
            defaultCurrency: TextTranslator<TranslateOptions>;
            printProvider: {
                addNewPrintProvider: TextTranslator<TranslateOptions>;
                attachToSkuGroup: TextTranslator<TranslateOptions>;
                authRequestConfirmation: TextTranslator<AgencyPrintSkuGroupsPrintProviderAuthRequestConfirmationOptions>;
                noAvailableClients: TextTranslator<TranslateOptions>;
                paymentAuth: TextTranslator<TranslateOptions>;
                printProviderAdded: TextTranslator<TranslateOptions>;
                printProviderAttached: TextTranslator<TranslateOptions>;
                printProviderDetached: TextTranslator<TranslateOptions>;
                sendAuthRequest: TextTranslator<TranslateOptions>;
            };
            printProviders: TextTranslator<TranslateOptions>;
            printSkuGroups: TextTranslator<TranslateOptions>;
            quantityOption: {
                addNewQuantityOption: TextTranslator<TranslateOptions>;
                quantityAlreadyExists: TextTranslator<TranslateOptions>;
                quantityOptionAdded: TextTranslator<TranslateOptions>;
            };
            quantityOptions: TextTranslator<TranslateOptions>;
            sku: {
                addNewSku: TextTranslator<TranslateOptions>;
                createSku: TextTranslator<AgencyPrintSkuGroupsSkuCreateSkuOptions>;
                deleteSku: TextTranslator<TranslateOptions>;
                editSku: TextTranslator<AgencyPrintSkuGroupsSkuEditSkuOptions>;
                exclusive: TextTranslator<TranslateOptions>;
                formatsAppliedTo: TextTranslator<TranslateOptions>;
                linearPricing: TextTranslator<TranslateOptions>;
                sku: TextTranslator<TranslateOptions>;
                skuAdded: TextTranslator<TranslateOptions>;
                skuDeleteConfirmation: TextTranslator<AgencyPrintSkuGroupsSkuSkuDeleteConfirmationOptions>;
                skuDeleted: TextTranslator<TranslateOptions>;
                skuGroupMissing: TextTranslator<TranslateOptions>;
                skuUpdated: TextTranslator<TranslateOptions>;
            };
            skuGroups: {
                addNewSkuGroup: TextTranslator<TranslateOptions>;
                deleteSkuGroup: TextTranslator<AgencyPrintSkuGroupsSkuGroupsDeleteSkuGroupOptions>;
                editSkuGroup: TextTranslator<AgencyPrintSkuGroupsSkuGroupsEditSkuGroupOptions>;
                editSkuGroupTitle: TextTranslator<TranslateOptions>;
                orderInformation: TextTranslator<TranslateOptions>;
                paymentGateway: TextTranslator<TranslateOptions>;
                paymentUrl: TextTranslator<TranslateOptions>;
                skuGroup: TextTranslator<TranslateOptions>;
                skuGroupAdded: TextTranslator<TranslateOptions>;
                skuGroupDeleteConfirmation: TextTranslator<AgencyPrintSkuGroupsSkuGroupsSkuGroupDeleteConfirmationOptions>;
                skuGroupDeleted: TextTranslator<TranslateOptions>;
                skuGroupDetails: TextTranslator<TranslateOptions>;
                skuGroupUpdated: TextTranslator<TranslateOptions>;
            };
            skus: TextTranslator<TranslateOptions>;
        };
        sendReports: {
            actions: {
                openReport: TextTranslator<TranslateOptions>;
            };
            agencyUserReportTable: {
                headers: {
                    clicked: TextTranslator<TranslateOptions>;
                    read: TextTranslator<TranslateOptions>;
                    recipientEmail: TextTranslator<TranslateOptions>;
                    recipientEmailFilterLabel: TextTranslator<TranslateOptions>;
                    recipientEmailFilterPlaceholder: TextTranslator<TranslateOptions>;
                    recipientName: TextTranslator<TranslateOptions>;
                    recipientNameFilterLabel: TextTranslator<TranslateOptions>;
                    recipientNameFilterPlaceholder: TextTranslator<TranslateOptions>;
                    sent: TextTranslator<TranslateOptions>;
                };
                noRecipientsFound: TextTranslator<TranslateOptions>;
            };
            report: {
                clickedSubtitle: TextTranslator<AgencySendReportsReportClickedSubtitleOptions>;
                clickedTitle: TextTranslator<TranslateOptions>;
                readSubtitle: TextTranslator<AgencySendReportsReportReadSubtitleOptions>;
                readTitle: TextTranslator<TranslateOptions>;
                sentFrom: TextTranslator<AgencySendReportsReportSentFromOptions>;
                sentSubtitle: TextTranslator<AgencySendReportsReportSentSubtitleOptions>;
                sentTitle: TextTranslator<TranslateOptions>;
                sentToPart1: TextTranslator<TranslateOptions>;
                sentToPart2: TextTranslator<AgencySendReportsReportSentToPart2Options>;
                sentToPart2Plural: TextTranslator<AgencySendReportsReportSentToPart2PluralOptions>;
                sentToPart3: TextTranslator<TranslateOptions>;
                sentToUsersFilteredByTitles: TextTranslator<TranslateOptions>;
                subtitleNotSent: TextTranslator<AgencySendReportsReportSubtitleNotSentOptions>;
                subtitleSentBy: TextTranslator<AgencySendReportsReportSubtitleSentByOptions>;
                typeEmailTooltip: TextTranslator<TranslateOptions>;
                typeInAppTooltip: TextTranslator<TranslateOptions>;
            };
            title: TextTranslator<TranslateOptions>;
        };
        users: {
            clientUsers: TextTranslator<TranslateOptions>;
            interactionDeleteUser: TextTranslator<TranslateOptions>;
            interactionGetClientUsers: TextTranslator<TranslateOptions>;
            onlyShowOrphans: TextTranslator<TranslateOptions>;
        };
    };
    apps: {
        accessTokenConfigNotFoundOrPermissionError: TextTranslator<TranslateOptions>;
        accountSuccessfullyConnected: {
            message: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        adwordsCustomer: TextTranslator<TranslateOptions>;
        analyticsProfile: TextTranslator<TranslateOptions>;
        authorise: TextTranslator<TranslateOptions>;
        authorizedAccount: TextTranslator<TranslateOptions>;
        business: TextTranslator<TranslateOptions>;
        campaignsFoundInAdwordsThatMatchName: TextTranslator<AppsCampaignsFoundInAdwordsThatMatchNameOptions>;
        campaignsFoundInAdwordsThatMatchNamePlural: TextTranslator<AppsCampaignsFoundInAdwordsThatMatchNamePluralOptions>;
        checkAccessToGoogleAdwords: TextTranslator<TranslateOptions>;
        checkMatchedCampaignsRelateToLocation: TextTranslator<TranslateOptions>;
        company: TextTranslator<TranslateOptions>;
        connectToAccessWelcomeMessage: {
            clubPilates: {
                heading: TextTranslator<TranslateOptions>;
                message: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
            };
            default: {
                heading: TextTranslator<TranslateOptions>;
                message: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
            };
        };
        connectToAccount: TextTranslator<AppsConnectToAccountOptions>;
        connectToNewAccount: TextTranslator<TranslateOptions>;
        connectingViaAccount: TextTranslator<AppsConnectingViaAccountOptions>;
        customerId: TextTranslator<AppsCustomerIdOptions>;
        deauthorise: TextTranslator<TranslateOptions>;
        disconnectAccount: TextTranslator<TranslateOptions>;
        disconnectFromAccount: TextTranslator<AppsDisconnectFromAccountOptions>;
        editConfiguration: TextTranslator<TranslateOptions>;
        errors: {
            debugMessageWrap: TextTranslator<AppsErrorsDebugMessageWrapOptions>;
            invalidConfiguration: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
            };
            missingConfiguration: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
            };
            missingPermissions: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigureAlternate: TextTranslator<TranslateOptions>;
            };
            facebookPasswordChanged: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
            };
            facebookInvalidSession: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
            };
            facebookAccessTokenIssue: {
                explainIssue: TextTranslator<TranslateOptions>;
                provideResolutionCanConfigure: TextTranslator<TranslateOptions>;
                provideResolutionCantConfigure: TextTranslator<TranslateOptions>;
            };
            weveEncounteredIssues: TextTranslator<AppsErrorsWeveEncounteredIssuesOptions>;
        };
        facebook: {
            pageIdAndNameRequired: TextTranslator<TranslateOptions>;
            pageUpdated: TextTranslator<TranslateOptions>;
        };
        facebookMarketing: {
            accountName: TextTranslator<TranslateOptions>;
            adAccountCleared: TextTranslator<TranslateOptions>;
            adAccountSet: TextTranslator<TranslateOptions>;
            checkAuthorisation: TextTranslator<TranslateOptions>;
            checkConfigAccess: TextTranslator<TranslateOptions>;
            facebookAdAccount: TextTranslator<TranslateOptions>;
            retrieveAdAccounts: TextTranslator<TranslateOptions>;
            retrieveConfig: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            updateAdAccount: TextTranslator<TranslateOptions>;
        };
        facebookPage: TextTranslator<TranslateOptions>;
        facebookPageHelp: TextTranslator<TranslateOptions>;
        facebookPageNotAvailable: TextTranslator<TranslateOptions>;
        fetchServiceConfig: TextTranslator<AppsFetchServiceConfigOptions>;
        fitware: TextTranslator<TranslateOptions>;
        fitwareClub: TextTranslator<TranslateOptions>;
        fitwareNote: TextTranslator<TranslateOptions>;
        four51: {
            company: TextTranslator<TranslateOptions>;
            companyUpdated: TextTranslator<TranslateOptions>;
            credentialsDeleted: TextTranslator<TranslateOptions>;
            credentialsUpdated: TextTranslator<TranslateOptions>;
            deleteCredentialsWarning: TextTranslator<TranslateOptions>;
            invalidNewCredentials: TextTranslator<TranslateOptions>;
            ssoKey: TextTranslator<TranslateOptions>;
            store: TextTranslator<TranslateOptions>;
        };
        googleAdwords: {
            campaignName: TextTranslator<TranslateOptions>;
            campaignNameDoesntMatchContinue: TextTranslator<TranslateOptions>;
            campaignNameMatchesCountContinue: TextTranslator<AppsGoogleAdwordsCampaignNameMatchesCountContinueOptions>;
            customer: TextTranslator<TranslateOptions>;
            multipleCampaignsFound: TextTranslator<TranslateOptions>;
            noCampaignsFound: TextTranslator<TranslateOptions>;
        };
        googleAdwordsCampaignName: TextTranslator<TranslateOptions>;
        googleAdwordsCustomerCleared: TextTranslator<TranslateOptions>;
        googleAdwordsCustomerSet: TextTranslator<TranslateOptions>;
        googleAnalytics: {
            pagePath: TextTranslator<TranslateOptions>;
        };
        googleAnalyticsPagePath: TextTranslator<TranslateOptions>;
        googleMyBusiness: {
            accountName: TextTranslator<TranslateOptions>;
            asyncDescriptions: {
                fetchingAccountNames: TextTranslator<TranslateOptions>;
                fetchingCanConfigure: TextTranslator<TranslateOptions>;
                fetchingLocationNames: TextTranslator<TranslateOptions>;
                updatingConfig: TextTranslator<TranslateOptions>;
            };
            configUpdated: TextTranslator<TranslateOptions>;
            locationName: TextTranslator<TranslateOptions>;
            locationNotEnabledHelpTextExplanation: TextTranslator<TranslateOptions>;
            locationNotEnabledHelpTextTitle: TextTranslator<TranslateOptions>;
            noAddress: TextTranslator<TranslateOptions>;
            states: {
                disabled: TextTranslator<TranslateOptions>;
                disconnected: TextTranslator<TranslateOptions>;
                localPostApiDisabled: TextTranslator<TranslateOptions>;
                needsReverification: TextTranslator<TranslateOptions>;
                notPublished: TextTranslator<TranslateOptions>;
                notVerified: TextTranslator<TranslateOptions>;
                pendingReview: TextTranslator<TranslateOptions>;
                pendingVerification: TextTranslator<TranslateOptions>;
                suspended: TextTranslator<TranslateOptions>;
                temporarilyEnabled: TextTranslator<TranslateOptions>;
                verified: TextTranslator<TranslateOptions>;
            };
        };
        instagram: {
            accountNotListed: TextTranslator<TranslateOptions>;
            accountNotListedExplanation: TextTranslator<TranslateOptions>;
            configUpdatedSuccessMessage: TextTranslator<TranslateOptions>;
            connectedAccount: TextTranslator<TranslateOptions>;
            connectedAccountInfo: TextTranslator<AppsInstagramConnectedAccountInfoOptions>;
            fetchAvailableInstagramAccounts: TextTranslator<TranslateOptions>;
            fetchingCanConfigure: TextTranslator<TranslateOptions>;
            updateConfig: TextTranslator<TranslateOptions>;
        };
        linkToGoogleAdwords: TextTranslator<TranslateOptions>;
        linkedin: {
            asyncDescriptions: {
                fetchingCanConfigure: TextTranslator<TranslateOptions>;
                fetchingPageNames: TextTranslator<TranslateOptions>;
                updatingConfig: TextTranslator<TranslateOptions>;
            };
            configUpdated: TextTranslator<TranslateOptions>;
            pageName: TextTranslator<TranslateOptions>;
            pageNotListed: TextTranslator<TranslateOptions>;
            pageNotListedExplanation: TextTranslator<TranslateOptions>;
        };
        manualEntry: TextTranslator<TranslateOptions>;
        noCampaignsFoundInAdwordsThatMatchName: TextTranslator<TranslateOptions>;
        noFacebookPageAccessHeading: TextTranslator<TranslateOptions>;
        pageId: TextTranslator<TranslateOptions>;
        pageName: TextTranslator<TranslateOptions>;
        pleaseSelectAnAdwordsCustomer: TextTranslator<TranslateOptions>;
        printProvider: TextTranslator<TranslateOptions>;
        printProviderSkuGroupAttached: TextTranslator<AppsPrintProviderSkuGroupAttachedOptions>;
        propertyId: TextTranslator<TranslateOptions>;
        refreshMatchingCampaigns: TextTranslator<TranslateOptions>;
        thisWillMatchCampaignsWithNameContainingText: TextTranslator<TranslateOptions>;
        updateGoogleAdwordsCustomer: TextTranslator<TranslateOptions>;
        updatedGoogleAdwordsCampaignName: TextTranslator<TranslateOptions>;
    };
    assetLibrary: {
        automaticallyExpireTheseAssets: TextTranslator<TranslateOptions>;
        bin: TextTranslator<TranslateOptions>;
        binAssets: TextTranslator<TranslateOptions>;
        chooseCollection: TextTranslator<TranslateOptions>;
        chooseCollectionRequest: TextTranslator<TranslateOptions>;
        collectionLimitReached: TextTranslator<AssetLibraryCollectionLimitReachedOptions>;
        copyAssetUrl: TextTranslator<TranslateOptions>;
        createFolderModalTitle: TextTranslator<TranslateOptions>;
        deleteCollectionNote: TextTranslator<TranslateOptions>;
        differentExpiryDateAlert: TextTranslator<TranslateOptions>;
        differentExpiryDateInfo: TextTranslator<TranslateOptions>;
        editFolder: TextTranslator<TranslateOptions>;
        expiredAssets: TextTranslator<TranslateOptions>;
        explain: TextTranslator<TranslateOptions>;
        hideBin: TextTranslator<TranslateOptions>;
        list: TextTranslator<TranslateOptions>;
        moveAssetsToFolder: TextTranslator<AssetLibraryMoveAssetsToFolderOptions>;
        movingAssets: TextTranslator<AssetLibraryMovingAssetsOptions>;
        newFolder: TextTranslator<TranslateOptions>;
        noAssetsInFolder: TextTranslator<TranslateOptions>;
        noCollectionsFound: TextTranslator<TranslateOptions>;
        pleaseSelectCollection: TextTranslator<TranslateOptions>;
        removeExpirationDate: TextTranslator<TranslateOptions>;
        restore: TextTranslator<TranslateOptions>;
        savingAssets: TextTranslator<AssetLibrarySavingAssetsOptions>;
        searchCollections: TextTranslator<TranslateOptions>;
        securityWarning: TextTranslator<TranslateOptions>;
        securityWarningDescription: TextTranslator<TranslateOptions>;
        selectedClients: TextTranslator<TranslateOptions>;
        selectedLocations: TextTranslator<TranslateOptions>;
        sharedWith: TextTranslator<TranslateOptions>;
        showBin: TextTranslator<TranslateOptions>;
        thumbnail: TextTranslator<TranslateOptions>;
        unableToLoad: TextTranslator<TranslateOptions>;
        uploadAsset: TextTranslator<TranslateOptions>;
        uploadingAssets: TextTranslator<AssetLibraryUploadingAssetsOptions>;
    };
    build: {
        actual: TextTranslator<TranslateOptions>;
        addressNotSet: TextTranslator<TranslateOptions>;
        agencyFilters: {
            hideMobile: TextTranslator<TranslateOptions>;
            hidePublished: TextTranslator<TranslateOptions>;
            hideUnpublished: TextTranslator<TranslateOptions>;
            isMultiImage: TextTranslator<TranslateOptions>;
            onlyLocationDrafts: TextTranslator<TranslateOptions>;
            onlyLocationDraftsButton: TextTranslator<TranslateOptions>;
            onlyMobile: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        allClients: TextTranslator<TranslateOptions>;
        allEditableElements: TextTranslator<TranslateOptions>;
        allFormats: TextTranslator<TranslateOptions>;
        animation: {
            addFrameAfter: TextTranslator<TranslateOptions>;
            addFrameBefore: TextTranslator<TranslateOptions>;
            animation: TextTranslator<TranslateOptions>;
            confirmDeleteFrame: TextTranslator<TranslateOptions>;
            deleteFrame: TextTranslator<TranslateOptions>;
            duration: TextTranslator<TranslateOptions>;
            frameNumberOfCount: TextTranslator<BuildAnimationFrameNumberOfCountOptions>;
            play: TextTranslator<TranslateOptions>;
            stop: TextTranslator<TranslateOptions>;
            toggleAnimationConfirm: TextTranslator<TranslateOptions>;
        };
        atLeastOneFormatRequired: TextTranslator<TranslateOptions>;
        backToGallery: TextTranslator<TranslateOptions>;
        background: TextTranslator<TranslateOptions>;
        blendMode: {
            color: TextTranslator<TranslateOptions>;
            difference: TextTranslator<TranslateOptions>;
            hardLight: TextTranslator<TranslateOptions>;
            hue: TextTranslator<TranslateOptions>;
            multiply: TextTranslator<TranslateOptions>;
            normal: TextTranslator<TranslateOptions>;
            overlay: TextTranslator<TranslateOptions>;
            saturation: TextTranslator<TranslateOptions>;
            screen: TextTranslator<TranslateOptions>;
            softLight: TextTranslator<TranslateOptions>;
        };
        builderMode: {
            advanced: TextTranslator<TranslateOptions>;
            simple: TextTranslator<TranslateOptions>;
        };
        builderTemplateDeleteConfirmationModal: {
            confirmationMessage: TextTranslator<BuildBuilderTemplateDeleteConfirmationModalConfirmationMessageOptions>;
            confirmationMessagePlural: TextTranslator<BuildBuilderTemplateDeleteConfirmationModalConfirmationMessagePluralOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        builderTemplateUpdateConfirmationModal: {
            affectedLocations: TextTranslator<TranslateOptions>;
            confirmationMessage: TextTranslator<BuildBuilderTemplateUpdateConfirmationModalConfirmationMessageOptions>;
            confirmationMessagePlural: TextTranslator<BuildBuilderTemplateUpdateConfirmationModalConfirmationMessagePluralOptions>;
            deleteLocationDrafts: TextTranslator<TranslateOptions>;
            keepLocationDrafts: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        cantFindWhatYouAreLookingFor: TextTranslator<TranslateOptions>;
        channelData: TextTranslator<TranslateOptions>;
        cmykColorDisclaimer: TextTranslator<TranslateOptions>;
        colorPicker: {
            black: TextTranslator<TranslateOptions>;
            blue: TextTranslator<TranslateOptions>;
            cmyk: TextTranslator<TranslateOptions>;
            cmykHeader: TextTranslator<TranslateOptions>;
            cyan: TextTranslator<TranslateOptions>;
            green: TextTranslator<TranslateOptions>;
            hsl: TextTranslator<TranslateOptions>;
            hue: TextTranslator<TranslateOptions>;
            lum: TextTranslator<TranslateOptions>;
            magenta: TextTranslator<TranslateOptions>;
            name: TextTranslator<TranslateOptions>;
            opacity: TextTranslator<TranslateOptions>;
            red: TextTranslator<TranslateOptions>;
            rgb: TextTranslator<TranslateOptions>;
            rgbHeader: TextTranslator<TranslateOptions>;
            sat: TextTranslator<TranslateOptions>;
            yellow: TextTranslator<TranslateOptions>;
        };
        complete: TextTranslator<TranslateOptions>;
        confirmBuilderTemplateUpdate: TextTranslator<TranslateOptions>;
        confirmBuilderTemplateUpdateMessage: TextTranslator<TranslateOptions>;
        confirmDeleteAllChannelData: TextTranslator<BuildConfirmDeleteAllChannelDataOptions>;
        customImageRequired: TextTranslator<TranslateOptions>;
        customTextRequired: TextTranslator<TranslateOptions>;
        deleteConfirmation: TextTranslator<TranslateOptions>;
        deleteTemplate: TextTranslator<TranslateOptions>;
        desktopView: TextTranslator<TranslateOptions>;
        dimensions: TextTranslator<TranslateOptions>;
        duplicate: TextTranslator<TranslateOptions>;
        duplicateLayer: TextTranslator<TranslateOptions>;
        editableElements: TextTranslator<TranslateOptions>;
        ellipse: TextTranslator<TranslateOptions>;
        email: {
            authorizeOnAppsPage: TextTranslator<TranslateOptions>;
            blackTextEditorBackground: TextTranslator<TranslateOptions>;
            cantAddImageElement: TextTranslator<TranslateOptions>;
            defaultInstructions: TextTranslator<TranslateOptions>;
            editSource: TextTranslator<TranslateOptions>;
            editSourceWarning: TextTranslator<TranslateOptions>;
            emailBuilder: TextTranslator<TranslateOptions>;
            emailPreview: TextTranslator<TranslateOptions>;
            failedToParseHtml: TextTranslator<TranslateOptions>;
            failedToProcessZipFile: TextTranslator<TranslateOptions>;
            failedToReadZipFile: TextTranslator<TranslateOptions>;
            failedToValidateZipFile: TextTranslator<TranslateOptions>;
            imageExceedsRecommendedSizeWarning: TextTranslator<TranslateOptions>;
            imageTimeout: TextTranslator<TranslateOptions>;
            locationNotAuthorized: TextTranslator<TranslateOptions>;
            mailMerge: TextTranslator<TranslateOptions>;
            noCampaginMonitorSetupForLocation: TextTranslator<BuildEmailNoCampaginMonitorSetupForLocationOptions>;
            pleaseAddressIssuesWithZipFile: TextTranslator<TranslateOptions>;
            selectZipFile: TextTranslator<TranslateOptions>;
            updatePlannerStatus: TextTranslator<TranslateOptions>;
            uploadOnlyOnePreview: TextTranslator<TranslateOptions>;
            uploadOnlyOneZipFile: TextTranslator<TranslateOptions>;
            visibility: TextTranslator<TranslateOptions>;
            visible: TextTranslator<TranslateOptions>;
            zipFile: TextTranslator<TranslateOptions>;
            zipValidation: {
                htmlMissing: TextTranslator<TranslateOptions>;
                htmlMultiple: TextTranslator<TranslateOptions>;
                imageMissing: TextTranslator<BuildEmailZipValidationImageMissingOptions>;
                imageUnreferenced: TextTranslator<BuildEmailZipValidationImageUnreferencedOptions>;
                previewImageMissing: TextTranslator<TranslateOptions>;
                previewImageMultiple: TextTranslator<TranslateOptions>;
            };
        };
        error: {
            dimensionsForPngInPrintTemplatesLimited: TextTranslator<BuildErrorDimensionsForPngInPrintTemplatesLimitedOptions>;
            failedToCreateTag: TextTranslator<TranslateOptions>;
            failedToDeleteTemplate: TextTranslator<TranslateOptions>;
            failedToGetClients: TextTranslator<TranslateOptions>;
            failedToGetLocation: TextTranslator<TranslateOptions>;
            failedToRetrieveBuilderTemplateFormats: TextTranslator<TranslateOptions>;
            failedToRetrieveTemplate: TextTranslator<TranslateOptions>;
            failedToSaveTemplate: TextTranslator<TranslateOptions>;
            failedToUploadImages: TextTranslator<TranslateOptions>;
            failedToUploadThumbnail: TextTranslator<TranslateOptions>;
        };
        featuredTemplateSets: TextTranslator<TranslateOptions>;
        fetchingBuilderTemplateInfo: TextTranslator<TranslateOptions>;
        firstComment: TextTranslator<TranslateOptions>;
        fit: TextTranslator<TranslateOptions>;
        fonts: {
            addFont: TextTranslator<TranslateOptions>;
            addFontForClient: TextTranslator<BuildFontsAddFontForClientOptions>;
            areYouSureDeleteFamily: TextTranslator<BuildFontsAreYouSureDeleteFamilyOptions>;
            checkYouAreViewingCorrectClient: TextTranslator<TranslateOptions>;
            contextActions: TextTranslator<TranslateOptions>;
            createFontInstructions: TextTranslator<TranslateOptions>;
            deleteFontFamily: TextTranslator<BuildFontsDeleteFontFamilyOptions>;
            enterNewFontFamily: TextTranslator<TranslateOptions>;
            errorLoadingFonts: TextTranslator<TranslateOptions>;
            errors: {
                couldNotDeleteFont: TextTranslator<TranslateOptions>;
                errorRenaming: TextTranslator<TranslateOptions>;
                issueUploadingFont: TextTranslator<TranslateOptions>;
            };
            filterFonts: TextTranslator<TranslateOptions>;
            fontActions: TextTranslator<TranslateOptions>;
            fontDeleted: TextTranslator<TranslateOptions>;
            fontFamily: TextTranslator<TranslateOptions>;
            fontType: TextTranslator<TranslateOptions>;
            fontUploaded: TextTranslator<TranslateOptions>;
            fontsMissing: TextTranslator<TranslateOptions>;
            pleaseContactAgencyToFix: TextTranslator<TranslateOptions>;
            renamedFont: TextTranslator<TranslateOptions>;
            someFontsCouldNotBeLoaded: TextTranslator<TranslateOptions>;
            templateUsesMissingFonts: TextTranslator<TranslateOptions>;
        };
        formatsSelected: TextTranslator<BuildFormatsSelectedOptions>;
        formatsSelectedPlural: TextTranslator<BuildFormatsSelectedPluralOptions>;
        four51: {
            noAccessModalMessage: TextTranslator<TranslateOptions>;
            noAccessModalTitle: TextTranslator<TranslateOptions>;
        };
        gallery: TextTranslator<TranslateOptions>;
        hideDetails: TextTranslator<TranslateOptions>;
        image: {
            unsupportedFormat: TextTranslator<TranslateOptions>;
        };
        imageChooser: {
            confirmAcknowledged: TextTranslator<TranslateOptions>;
            confirmPermission: TextTranslator<TranslateOptions>;
            imageSource: TextTranslator<TranslateOptions>;
            localFile: TextTranslator<TranslateOptions>;
            locationLogo: TextTranslator<TranslateOptions>;
            maxUploadError: TextTranslator<TranslateOptions>;
            permissionDisclaimer: TextTranslator<TranslateOptions>;
            permissionDisclaimerStrong: TextTranslator<TranslateOptions>;
            permissionError: TextTranslator<TranslateOptions>;
            selectImage: TextTranslator<TranslateOptions>;
            selectImageFromYourLibrary: TextTranslator<TranslateOptions>;
            suggestedCollection: TextTranslator<TranslateOptions>;
            uploadImageFromYourDevice: TextTranslator<TranslateOptions>;
            uploadedAssetImage: TextTranslator<TranslateOptions>;
            uploadedPlannerImage: TextTranslator<TranslateOptions>;
        };
        imageCropper: {
            clear: TextTranslator<TranslateOptions>;
            cropImage: TextTranslator<TranslateOptions>;
            rotate: TextTranslator<TranslateOptions>;
        };
        imageCropperPromptMessage: TextTranslator<TranslateOptions>;
        imageFormatName: {
            jpgLimitedFileSize: TextTranslator<TranslateOptions>;
        };
        imageMustBeEditable: TextTranslator<TranslateOptions>;
        imageResolutionPicker: {
            confirmDpi: TextTranslator<TranslateOptions>;
            dpi: TextTranslator<TranslateOptions>;
            dpiIsRequired: TextTranslator<TranslateOptions>;
            imageResolution: TextTranslator<TranslateOptions>;
        };
        imageSelected: TextTranslator<TranslateOptions>;
        keyboardShortcutsReference: TextTranslator<TranslateOptions>;
        keywordSearch: TextTranslator<TranslateOptions>;
        landscape: TextTranslator<TranslateOptions>;
        layers: TextTranslator<TranslateOptions>;
        leavePagePrompt: {
            confirm: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        locationDetailsMissingMessage: TextTranslator<TranslateOptions>;
        locationDraft: {
            areYouSureYouWantToOverrideTemplateRevisionWithTitle: TextTranslator<BuildLocationDraftAreYouSureYouWantToOverrideTemplateRevisionWithTitleOptions>;
            confirmDelete: TextTranslator<TranslateOptions>;
            confirmDeleteTitle: TextTranslator<TranslateOptions>;
            createdLocationDraft: TextTranslator<TranslateOptions>;
            enterNameForNewTemplateRevision: TextTranslator<TranslateOptions>;
            loadAPreviousRevision: TextTranslator<TranslateOptions>;
            loadAPreviousTemplateRevision: TextTranslator<TranslateOptions>;
            pleaseConfirmLocationRevisionSave: TextTranslator<TranslateOptions>;
            saveAsANewRevision: TextTranslator<TranslateOptions>;
            saveLocationRevision: TextTranslator<TranslateOptions>;
            saveLocationRevisionWithTitle: TextTranslator<BuildLocationDraftSaveLocationRevisionWithTitleOptions>;
            saveOverCurrentRevisionWithTitle: TextTranslator<BuildLocationDraftSaveOverCurrentRevisionWithTitleOptions>;
            templateHasDraftTooltip: TextTranslator<TranslateOptions>;
            updatedAt: TextTranslator<TranslateOptions>;
            updatedLocationDraft: TextTranslator<TranslateOptions>;
        };
        locationEmailNotSet: TextTranslator<TranslateOptions>;
        locationLogoNotSet: TextTranslator<BuildLocationLogoNotSetOptions>;
        locationMapNotCreated: TextTranslator<BuildLocationMapNotCreatedOptions>;
        loopForever: TextTranslator<TranslateOptions>;
        looping: TextTranslator<TranslateOptions>;
        lowercase: TextTranslator<TranslateOptions>;
        makeTemplateOnlyAvailableForMobileApp: TextTranslator<TranslateOptions>;
        map: {
            pin: TextTranslator<TranslateOptions>;
        };
        maximumFileSizeKb: TextTranslator<TranslateOptions>;
        memberEngager: {
            assignToMultipleLocations: TextTranslator<TranslateOptions>;
            automatedEmail: TextTranslator<TranslateOptions>;
            automatedEmails: TextTranslator<TranslateOptions>;
            directEmailTitle: TextTranslator<TranslateOptions>;
            editContent: TextTranslator<TranslateOptions>;
            editSubject: TextTranslator<TranslateOptions>;
            failedToLoadAutomatedEmail: TextTranslator<TranslateOptions>;
            failedToLoadAutomatedEmails: TextTranslator<TranslateOptions>;
            findNewTemplate: TextTranslator<TranslateOptions>;
            noDirectEmailTemplatesFound: TextTranslator<TranslateOptions>;
            scheduledEmail: TextTranslator<TranslateOptions>;
            scheduledEmails: TextTranslator<TranslateOptions>;
            scheduledEmailsWell: {
                deleteMessageLine1: TextTranslator<TranslateOptions>;
                deleteMessageLine2: TextTranslator<TranslateOptions>;
                deleteScheduledEmailApiError: TextTranslator<TranslateOptions>;
                noScheduledEmails: TextTranslator<TranslateOptions>;
                preview: TextTranslator<TranslateOptions>;
                scheduledEmailAlreadyDeleted: TextTranslator<TranslateOptions>;
                scheduledEmailDeleted: TextTranslator<TranslateOptions>;
                scheduledEmailNotFound: TextTranslator<TranslateOptions>;
                table: {
                    lists: TextTranslator<TranslateOptions>;
                    scheduled: TextTranslator<TranslateOptions>;
                    subject: TextTranslator<TranslateOptions>;
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        metrics: {
            em: TextTranslator<TranslateOptions>;
            points: TextTranslator<TranslateOptions>;
            pointsShort: TextTranslator<TranslateOptions>;
        };
        millisecondsShort: TextTranslator<TranslateOptions>;
        mobileAppTemplate: TextTranslator<TranslateOptions>;
        mobileAppTemplateValidation: {
            animationPresent: TextTranslator<TranslateOptions>;
            mapLayerPresent: TextTranslator<TranslateOptions>;
            notMobileCompatible: TextTranslator<BuildMobileAppTemplateValidationNotMobileCompatibleOptions>;
            unsupportedBuilderTemplateFormat: TextTranslator<TranslateOptions>;
            unsupportedDocumentFormat: TextTranslator<TranslateOptions>;
            unsupportedEditableFields: TextTranslator<TranslateOptions>;
        };
        mobileInfo: TextTranslator<TranslateOptions>;
        mobileView: TextTranslator<TranslateOptions>;
        moveDown: TextTranslator<TranslateOptions>;
        moveUp: TextTranslator<TranslateOptions>;
        multiImage: {
            muliImageCounterTooltip: TextTranslator<BuildMultiImageMuliImageCounterTooltipOptions>;
            muliImageCounterTooltipPlural: TextTranslator<BuildMultiImageMuliImageCounterTooltipPluralOptions>;
            multiImage: TextTranslator<TranslateOptions>;
            multiImageTemplate: TextTranslator<TranslateOptions>;
            notifierExplanation: TextTranslator<TranslateOptions>;
            removeImage: {
                message: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
        };
        mustViewAllFrames: TextTranslator<TranslateOptions>;
        mustViewAllImages: TextTranslator<TranslateOptions>;
        mustViewAllPages: TextTranslator<TranslateOptions>;
        newTemplate: TextTranslator<TranslateOptions>;
        newTemplateEmail: TextTranslator<TranslateOptions>;
        newTemplateImage: TextTranslator<TranslateOptions>;
        newTemplatePrint: TextTranslator<TranslateOptions>;
        newTemplateVideo: TextTranslator<TranslateOptions>;
        noContent: TextTranslator<TranslateOptions>;
        notifyTextPlaceholderExists: TextTranslator<TranslateOptions>;
        optimizingImage: TextTranslator<TranslateOptions>;
        originalTemplate: TextTranslator<TranslateOptions>;
        overlays: {
            imageLayer: TextTranslator<TranslateOptions>;
            mapLayer: TextTranslator<TranslateOptions>;
            videoLayer: TextTranslator<TranslateOptions>;
        };
        phoneNumberNotSet: TextTranslator<TranslateOptions>;
        placeholder: TextTranslator<TranslateOptions>;
        placeholders: TextTranslator<TranslateOptions>;
        plannerDetails: TextTranslator<TranslateOptions>;
        platform: TextTranslator<TranslateOptions>;
        portrait: TextTranslator<TranslateOptions>;
        positionX: TextTranslator<TranslateOptions>;
        positionY: TextTranslator<TranslateOptions>;
        previewImage: TextTranslator<TranslateOptions>;
        print: {
            addPageAfter: TextTranslator<TranslateOptions>;
            addPageBefore: TextTranslator<TranslateOptions>;
            bleed: TextTranslator<TranslateOptions>;
            confirmDeletePage: TextTranslator<TranslateOptions>;
            deletePage: TextTranslator<TranslateOptions>;
            extraInfo: TextTranslator<BuildPrintExtraInfoOptions>;
            pageNumber: TextTranslator<TranslateOptions>;
            pageNumberOfCount: TextTranslator<BuildPrintPageNumberOfCountOptions>;
            pleaseEnterPageNumberBetween: TextTranslator<BuildPrintPleaseEnterPageNumberBetweenOptions>;
            selectAtLeastOneFormat: TextTranslator<TranslateOptions>;
            whichPageToCopyLayerTo: TextTranslator<TranslateOptions>;
        };
        properties: TextTranslator<TranslateOptions>;
        publish: {
            alreadyScheduled: TextTranslator<TranslateOptions>;
            campaignMonitor: {
                campaignName: TextTranslator<TranslateOptions>;
                confirmationEmailAddress: TextTranslator<TranslateOptions>;
                fromEmail: TextTranslator<TranslateOptions>;
                fromName: TextTranslator<TranslateOptions>;
                inCampaignMonitorAccountsTimezone: TextTranslator<TranslateOptions>;
                lists: TextTranslator<TranslateOptions>;
                noListsFoundSetUpYourMailingLists: TextTranslator<TranslateOptions>;
                noSegmentsFound: TextTranslator<TranslateOptions>;
                notifyPublishSuccess: TextTranslator<TranslateOptions>;
                preview: TextTranslator<TranslateOptions>;
                previewSend: TextTranslator<TranslateOptions>;
                previewSkip: TextTranslator<TranslateOptions>;
                publishToCampaignMonitor: TextTranslator<TranslateOptions>;
                recipients: TextTranslator<TranslateOptions>;
                replyTo: TextTranslator<TranslateOptions>;
                saveDraft: TextTranslator<TranslateOptions>;
                segments: TextTranslator<TranslateOptions>;
                send: TextTranslator<TranslateOptions>;
                subject: TextTranslator<TranslateOptions>;
            };
            clubReady: {
                active: TextTranslator<TranslateOptions>;
                activeMembers: TextTranslator<TranslateOptions>;
                addedAtAnyTime: TextTranslator<TranslateOptions>;
                addedBetween: TextTranslator<TranslateOptions>;
                after: TextTranslator<TranslateOptions>;
                allActiveMembers: TextTranslator<TranslateOptions>;
                allInactiveMembers: TextTranslator<TranslateOptions>;
                atLeastOneListMustBeSelected: TextTranslator<TranslateOptions>;
                before: TextTranslator<TranslateOptions>;
                club: TextTranslator<TranslateOptions>;
                cooledOffProspects: TextTranslator<TranslateOptions>;
                custom: TextTranslator<TranslateOptions>;
                customListDescriptionPlaceholder: TextTranslator<TranslateOptions>;
                customListDescriptionWarning: TextTranslator<BuildPublishClubReadyCustomListDescriptionWarningOptions>;
                customListMatches: TextTranslator<BuildPublishClubReadyCustomListMatchesOptions>;
                customListOfEmailAddresses: TextTranslator<TranslateOptions>;
                customListOfEmailAddressesWarning: TextTranslator<TranslateOptions>;
                disabledPublishHelpText: TextTranslator<TranslateOptions>;
                duplicateEmails: TextTranslator<TranslateOptions>;
                emailListMustHaveValues: TextTranslator<TranslateOptions>;
                emailSubjectAndSchedule: TextTranslator<TranslateOptions>;
                exportInfo: TextTranslator<TranslateOptions>;
                exportTitle: TextTranslator<TranslateOptions>;
                filtered: TextTranslator<TranslateOptions>;
                iConfirmThatTheAboveDetailsAreCorrect: TextTranslator<TranslateOptions>;
                inactive: TextTranslator<TranslateOptions>;
                inactiveMembers: TextTranslator<TranslateOptions>;
                invalid: TextTranslator<TranslateOptions>;
                matchedOutOf: TextTranslator<BuildPublishClubReadyMatchedOutOfOptions>;
                memberListNotice: TextTranslator<TranslateOptions>;
                moreClubCount: TextTranslator<BuildPublishClubReadyMoreClubCountOptions>;
                moreClubCountPlural: TextTranslator<BuildPublishClubReadyMoreClubCountPluralOptions>;
                noSenderInfoForOneOrMoreLocations: TextTranslator<TranslateOptions>;
                noSenderInfoHasBeenSetForLocation: TextTranslator<TranslateOptions>;
                notInterested: TextTranslator<TranslateOptions>;
                oneOrMoreListsDisabledMessage: TextTranslator<TranslateOptions>;
                optout: TextTranslator<TranslateOptions>;
                pasteEmailAddressesBelow: TextTranslator<TranslateOptions>;
                previewEmailFailed: TextTranslator<TranslateOptions>;
                previewEmailSent: TextTranslator<TranslateOptions>;
                prospects: TextTranslator<TranslateOptions>;
                prospectsPast30Days: TextTranslator<TranslateOptions>;
                publishDelayWarningMessage: TextTranslator<TranslateOptions>;
                refetchVerify: TextTranslator<TranslateOptions>;
                selectYourClubReadyLists: TextTranslator<TranslateOptions>;
                selectedListsDoesNotContainEnoughUsersToSendTo: TextTranslator<BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToOptions>;
                selectedListsDoesNotContainEnoughUsersToSendToPlural: TextTranslator<BuildPublishClubReadySelectedListsDoesNotContainEnoughUsersToSendToPluralOptions>;
                selectedListsSummary: TextTranslator<TranslateOptions>;
                selectedMembersAndOrProspects: TextTranslator<TranslateOptions>;
                sendATestEmail: TextTranslator<TranslateOptions>;
                sendTo: TextTranslator<TranslateOptions>;
                sendToClubReadyList: TextTranslator<TranslateOptions>;
                sendToInfo: TextTranslator<TranslateOptions>;
                sender: TextTranslator<TranslateOptions>;
                senderNotVerifiedMessage: TextTranslator<BuildPublishClubReadySenderNotVerifiedMessageOptions>;
                senderNotVerifiedTooltip: TextTranslator<TranslateOptions>;
                senderVerifiedTooltip: TextTranslator<TranslateOptions>;
                subject: TextTranslator<TranslateOptions>;
                suppressedListInfo: TextTranslator<TranslateOptions>;
                total: TextTranslator<TranslateOptions>;
                validDateRequiredActivityAfterOption: TextTranslator<TranslateOptions>;
                validDateRequiredActivityBeforeOption: TextTranslator<TranslateOptions>;
                validDateRequiredActivityBetweenOption: TextTranslator<TranslateOptions>;
                whenWouldYouLikeToSendThisEmail: TextTranslator<TranslateOptions>;
                warnPublishTooLarge: TextTranslator<BuildPublishClubReadyWarnPublishTooLargeOptions>;
                withActivityAfter: TextTranslator<TranslateOptions>;
                withActivityBefore: TextTranslator<TranslateOptions>;
            };
            congratulations: TextTranslator<TranslateOptions>;
            currentlySelected: TextTranslator<TranslateOptions>;
            downloadToYourComputer: TextTranslator<TranslateOptions>;
            exportOptions: TextTranslator<TranslateOptions>;
            facebook: {
                accessCheckFailure: TextTranslator<TranslateOptions>;
                caption: TextTranslator<TranslateOptions>;
                captionHelpText: TextTranslator<TranslateOptions>;
                facebookPage: TextTranslator<TranslateOptions>;
                hashtagsHelpTextCaption: TextTranslator<TranslateOptions>;
                hashtagsHelpTextFirstComment: TextTranslator<TranslateOptions>;
                headers: {
                    postDetails: TextTranslator<TranslateOptions>;
                    postSchedule: TextTranslator<TranslateOptions>;
                };
                inputLabels: {
                    displayHashtagsIn: TextTranslator<TranslateOptions>;
                    displayHashtagsInCaption: TextTranslator<TranslateOptions>;
                    displayHashtagsInFirstComment: TextTranslator<TranslateOptions>;
                    hashtags: TextTranslator<TranslateOptions>;
                };
                pageListRemaining: TextTranslator<BuildPublishFacebookPageListRemainingOptions>;
                pageListRemainingPlural: TextTranslator<BuildPublishFacebookPageListRemainingPluralOptions>;
                pagesCount: TextTranslator<BuildPublishFacebookPagesCountOptions>;
                pagesCountPlural: TextTranslator<BuildPublishFacebookPagesCountPluralOptions>;
                publishToFacebook: TextTranslator<TranslateOptions>;
                publishVideoToFacebook: TextTranslator<TranslateOptions>;
                scheduledFacebookPostMustBeNoMoreThan28DaysInFuture: TextTranslator<TranslateOptions>;
                suggestedCaption: TextTranslator<TranslateOptions>;
            };
            fetchFileSizeOptions: TextTranslator<TranslateOptions>;
            finalConfirmation: TextTranslator<TranslateOptions>;
            fitware: {
                automatedEmailCategoriesFailedToLoad: TextTranslator<TranslateOptions>;
                automatedEmailCategory: TextTranslator<TranslateOptions>;
                automatedEmailCategoryMissingInSomeLocationsHelpText: TextTranslator<TranslateOptions>;
                automatedEmailUpdatedDescription: TextTranslator<TranslateOptions>;
                automatedEmailUpdatedTitle: TextTranslator<TranslateOptions>;
                confirmDeclaration: TextTranslator<TranslateOptions>;
                directEmailPlatformHelpText: TextTranslator<TranslateOptions>;
                directEmailPlatformLabel: TextTranslator<TranslateOptions>;
                fitwareAutomatedEmail: TextTranslator<TranslateOptions>;
                fitwareAutomatedEmailHelpText: TextTranslator<TranslateOptions>;
                memberLists: TextTranslator<TranslateOptions>;
                memberListsFailedToLoad: TextTranslator<TranslateOptions>;
                noMemberListsFound: TextTranslator<TranslateOptions>;
                platformsHeading: TextTranslator<TranslateOptions>;
                preview: TextTranslator<TranslateOptions>;
                previewEmailAddress: TextTranslator<TranslateOptions>;
                previewSend: TextTranslator<TranslateOptions>;
                previewSkip: TextTranslator<TranslateOptions>;
                publishToFitware: TextTranslator<TranslateOptions>;
                returnToMemberEngager: TextTranslator<TranslateOptions>;
                scheduledTime: TextTranslator<TranslateOptions>;
                send: TextTranslator<TranslateOptions>;
                sender: TextTranslator<TranslateOptions>;
                senderPlural: TextTranslator<TranslateOptions>;
                stepTitles: {
                    automatedEmailCategory: TextTranslator<TranslateOptions>;
                    memberLists: TextTranslator<TranslateOptions>;
                    publishing: TextTranslator<TranslateOptions>;
                    scheduledTime: TextTranslator<TranslateOptions>;
                    sendPreview: TextTranslator<TranslateOptions>;
                    subject: TextTranslator<TranslateOptions>;
                    summary: TextTranslator<TranslateOptions>;
                };
                subject: TextTranslator<TranslateOptions>;
            };
            goBackConfirmMessage: TextTranslator<TranslateOptions>;
            goBackConfirmTitle: TextTranslator<TranslateOptions>;
            googleMyBusiness: {
                accessCheckFailure: TextTranslator<TranslateOptions>;
                businessLocation: TextTranslator<TranslateOptions>;
                buttonLink: TextTranslator<TranslateOptions>;
                buttonType: TextTranslator<TranslateOptions>;
                buttonTypes: {
                    book: TextTranslator<TranslateOptions>;
                    call: TextTranslator<TranslateOptions>;
                    learnMore: TextTranslator<TranslateOptions>;
                    order: TextTranslator<TranslateOptions>;
                    shop: TextTranslator<TranslateOptions>;
                    signUp: TextTranslator<TranslateOptions>;
                };
                callToAction: TextTranslator<TranslateOptions>;
                cannotStartEventBeforeScheduledTime: TextTranslator<TranslateOptions>;
                cannotStartOfferBeforeScheduledTime: TextTranslator<TranslateOptions>;
                characterLimitReached: TextTranslator<BuildPublishGoogleMyBusinessCharacterLimitReachedOptions>;
                eventDescription: TextTranslator<TranslateOptions>;
                eventTitle: TextTranslator<TranslateOptions>;
                offerCode: TextTranslator<TranslateOptions>;
                offerDescription: TextTranslator<TranslateOptions>;
                offerLink: TextTranslator<TranslateOptions>;
                offerTitle: TextTranslator<TranslateOptions>;
                postBody: TextTranslator<TranslateOptions>;
                postType: TextTranslator<TranslateOptions>;
                postTypes: {
                    event: TextTranslator<TranslateOptions>;
                    offer: TextTranslator<TranslateOptions>;
                    product: TextTranslator<TranslateOptions>;
                    standard: TextTranslator<TranslateOptions>;
                };
                publishToGoogleMyBusiness: TextTranslator<TranslateOptions>;
                termsAndConditions: TextTranslator<TranslateOptions>;
            };
            hashtags: {
                clientHashtags: TextTranslator<TranslateOptions>;
                errorLimitHashtagCount: TextTranslator<BuildPublishHashtagsErrorLimitHashtagCountOptions>;
                errorLimitHashtagCountPlural: TextTranslator<BuildPublishHashtagsErrorLimitHashtagCountPluralOptions>;
                errorLimitHashtagLength: TextTranslator<TranslateOptions>;
                errorLimitHashtagSet: TextTranslator<TranslateOptions>;
                hashtagCharacterCount: TextTranslator<BuildPublishHashtagsHashtagCharacterCountOptions>;
                hashtagSetAlreadyAdded: TextTranslator<TranslateOptions>;
                hashtagTagCount: TextTranslator<BuildPublishHashtagsHashtagTagCountOptions>;
                locationHashtags: TextTranslator<TranslateOptions>;
                noHashtagSets: TextTranslator<TranslateOptions>;
                useHashtagSets: TextTranslator<TranslateOptions>;
            };
            imageFormat: TextTranslator<TranslateOptions>;
            includeBleedAndTrimMarks: TextTranslator<TranslateOptions>;
            includeBleedAndTrimMarksDisclaimer: TextTranslator<TranslateOptions>;
            includeBleedAndTrimMarksHelp: TextTranslator<TranslateOptions>;
            instagram: {
                accessCheckFailure: TextTranslator<TranslateOptions>;
                appNotInstalled: TextTranslator<TranslateOptions>;
                appNotificationsDisabled: TextTranslator<TranslateOptions>;
                appSetupProperly: TextTranslator<TranslateOptions>;
                appUserRequired: TextTranslator<TranslateOptions>;
                asTheFirstCommentOnThePost: TextTranslator<TranslateOptions>;
                aspectRatioHelpText: TextTranslator<TranslateOptions>;
                aspectRatioStoryHelpText: TextTranslator<TranslateOptions>;
                aspectRatioVideoHelpText: TextTranslator<TranslateOptions>;
                assignUserToPost: TextTranslator<TranslateOptions>;
                atTheBottomOnThePostCaption: TextTranslator<TranslateOptions>;
                caption: TextTranslator<TranslateOptions>;
                captionHelpText: TextTranslator<TranslateOptions>;
                enterValidMobileNumber: TextTranslator<TranslateOptions>;
                exceededMaxImageCountHelpText: TextTranslator<BuildPublishInstagramExceededMaxImageCountHelpTextOptions>;
                hashtagsHelpTextCaption: TextTranslator<TranslateOptions>;
                hashtagsHelpTextFirstComment: TextTranslator<TranslateOptions>;
                headers: {
                    postDetails: TextTranslator<TranslateOptions>;
                    postSchedule: TextTranslator<TranslateOptions>;
                };
                inputLabels: {
                    displayHashtagsIn: TextTranslator<TranslateOptions>;
                    displayHashtagsInCaption: TextTranslator<TranslateOptions>;
                    displayHashtagsInFirstComment: TextTranslator<TranslateOptions>;
                    hashtags: TextTranslator<TranslateOptions>;
                };
                instagramPage: TextTranslator<TranslateOptions>;
                invalidDimensionsHeightHelpText: TextTranslator<TranslateOptions>;
                invalidDimensionsWidthHelpText: TextTranslator<TranslateOptions>;
                missingPermissionsHelpText: TextTranslator<TranslateOptions>;
                mobileNumber: TextTranslator<TranslateOptions>;
                mobileNumberInfo: TextTranslator<TranslateOptions>;
                notificationForInstagram: TextTranslator<TranslateOptions>;
                notificationSchedule: TextTranslator<TranslateOptions>;
                postsFromMobileHint: TextTranslator<TranslateOptions>;
                postsWillExpire: TextTranslator<BuildPublishInstagramPostsWillExpireOptions>;
                postsWillExpirePlural: TextTranslator<BuildPublishInstagramPostsWillExpirePluralOptions>;
                publishVideoToInstagram: TextTranslator<TranslateOptions>;
                publishImageToInstagram: TextTranslator<TranslateOptions>;
                publishStoryToInstagram: TextTranslator<TranslateOptions>;
                scheduleVideoViaApi: TextTranslator<TranslateOptions>;
                scheduleImageViaApi: TextTranslator<TranslateOptions>;
                scheduleStoryViaApi: TextTranslator<TranslateOptions>;
                scheduleForInstagram: TextTranslator<TranslateOptions>;
                scheduleForInstagramStory: TextTranslator<TranslateOptions>;
                scheduleNotificationForInstagram: TextTranslator<TranslateOptions>;
                scheduleViaMobileApp: TextTranslator<TranslateOptions>;
                scheduledInstagramPostMustBeNoMoreThan75DaysInFuture: TextTranslator<TranslateOptions>;
                scheduledPostMustBeAtLeastMinsInFuture: TextTranslator<BuildPublishInstagramScheduledPostMustBeAtLeastMinsInFutureOptions>;
                searchForUser: TextTranslator<TranslateOptions>;
                selectRelevantCountryCode: TextTranslator<TranslateOptions>;
                sendPostDetails: TextTranslator<TranslateOptions>;
                sendSmsAsWell: TextTranslator<TranslateOptions>;
                storyMultiImageHelpText: TextTranslator<TranslateOptions>;
                storyVideoDurationHelpText: TextTranslator<TranslateOptions>;
                suggestedCaption: TextTranslator<TranslateOptions>;
                videoDurationHelpText: TextTranslator<TranslateOptions>;
            };
            linkedin: {
                accessCheckFailure: TextTranslator<TranslateOptions>;
                caption: TextTranslator<TranslateOptions>;
                captionHelpText: TextTranslator<TranslateOptions>;
                linkedinPage: TextTranslator<TranslateOptions>;
                publishToLinkedin: TextTranslator<TranslateOptions>;
            };
            local: {
                publishVideoToLocal: TextTranslator<TranslateOptions>;
            };
            mailchimp: {
                campaignName: TextTranslator<TranslateOptions>;
                confirmationEmailAddress: TextTranslator<TranslateOptions>;
                fromEmail: TextTranslator<TranslateOptions>;
                fromName: TextTranslator<TranslateOptions>;
                lists: TextTranslator<TranslateOptions>;
                noListsFoundSetUpYourMailingLists: TextTranslator<TranslateOptions>;
                noSegmentsFound: TextTranslator<TranslateOptions>;
                preview: TextTranslator<TranslateOptions>;
                previewSend: TextTranslator<TranslateOptions>;
                previewSkip: TextTranslator<TranslateOptions>;
                publishToMailchimp: TextTranslator<TranslateOptions>;
                recipient: TextTranslator<TranslateOptions>;
                replyTo: TextTranslator<TranslateOptions>;
                saveDraft: TextTranslator<TranslateOptions>;
                schedulingUnavailable: TextTranslator<TranslateOptions>;
                segments: TextTranslator<TranslateOptions>;
                send: TextTranslator<TranslateOptions>;
                subject: TextTranslator<TranslateOptions>;
            };
            multipleLocations: {
                currentlyPublishing: TextTranslator<TranslateOptions>;
                editUndoAlertMessage: {
                    part1: TextTranslator<TranslateOptions>;
                    part2: TextTranslator<TranslateOptions>;
                    part3: TextTranslator<TranslateOptions>;
                };
                noAccessHelp: TextTranslator<BuildPublishMultipleLocationsNoAccessHelpOptions>;
                publishedVideosSuccessfully: TextTranslator<BuildPublishMultipleLocationsPublishedVideosSuccessfullyOptions>;
                publishingToTheseLocations: TextTranslator<TranslateOptions>;
                refreshLocations: TextTranslator<TranslateOptions>;
                scheduledVideosSuccessfully: TextTranslator<BuildPublishMultipleLocationsScheduledVideosSuccessfullyOptions>;
                someLocationsFailedToPublish: TextTranslator<TranslateOptions>;
                totalPublishingProgress: TextTranslator<TranslateOptions>;
                wouldYouLikeToRetryForFailedLocations: TextTranslator<TranslateOptions>;
            };
            multiplePlatforms: {
                facebookAndInstagramVideo: TextTranslator<TranslateOptions>;
                facebookAndInstagramImage: TextTranslator<TranslateOptions>;
                hashtagsHelpTextCaption: TextTranslator<TranslateOptions>;
                hashtagsHelpTextFirstComment: TextTranslator<TranslateOptions>;
                headers: {
                    postDetails: TextTranslator<TranslateOptions>;
                    postSchedule: TextTranslator<TranslateOptions>;
                };
                inputLabels: {
                    displayHashtagsIn: TextTranslator<TranslateOptions>;
                    displayHashtagsInCaption: TextTranslator<TranslateOptions>;
                    displayHashtagsInFirstComment: TextTranslator<TranslateOptions>;
                    hashtags: TextTranslator<TranslateOptions>;
                };
                publishVideoToFacebookAndInstagram: TextTranslator<TranslateOptions>;
                publishImageToFacebookAndInstagram: TextTranslator<TranslateOptions>;
                publishedToPlatform: TextTranslator<BuildPublishMultiplePlatformsPublishedToPlatformOptions>;
                publishingToPlatform: TextTranslator<BuildPublishMultiplePlatformsPublishingToPlatformOptions>;
            };
            noAccessHelp: TextTranslator<BuildPublishNoAccessHelpOptions>;
            noPlatformSelected: TextTranslator<TranslateOptions>;
            noPlatformsAvailable: TextTranslator<TranslateOptions>;
            noThanks: TextTranslator<TranslateOptions>;
            noThanksImDone: TextTranslator<TranslateOptions>;
            onceAuthorizedHelp: TextTranslator<TranslateOptions>;
            originalSize: TextTranslator<TranslateOptions>;
            print: {
                artworkReviewSuggested: TextTranslator<TranslateOptions>;
                beginPayment: TextTranslator<TranslateOptions>;
                canOnlySendToPrintProvider: TextTranslator<TranslateOptions>;
                confirmArtworkReview: TextTranslator<TranslateOptions>;
                holdUp: TextTranslator<TranslateOptions>;
                includesFallbackFontMessage: TextTranslator<TranslateOptions>;
                includesFallbackFontMessageSolution: TextTranslator<TranslateOptions>;
                instructionsPlaceholder: TextTranslator<TranslateOptions>;
                instructionsPlaceholderForSku: TextTranslator<TranslateOptions>;
                payment: TextTranslator<TranslateOptions>;
                paymentDue: TextTranslator<TranslateOptions>;
                printProvider: TextTranslator<TranslateOptions>;
                printRequestDetails: TextTranslator<TranslateOptions>;
                replyEmail: TextTranslator<TranslateOptions>;
                replyEmailSubheading: TextTranslator<TranslateOptions>;
                requestDetailsIsMissingData: TextTranslator<TranslateOptions>;
                reviewArtworkBeforeSending: TextTranslator<TranslateOptions>;
                reviewConfirmation: TextTranslator<TranslateOptions>;
                reviewDocument: TextTranslator<TranslateOptions>;
                saveAsLocationPrintProvider: TextTranslator<TranslateOptions>;
                selectPrintProvider: TextTranslator<TranslateOptions>;
                sendAndCompletePayment: TextTranslator<TranslateOptions>;
                sendOrder: TextTranslator<TranslateOptions>;
                sendToPrintProvider: TextTranslator<TranslateOptions>;
                sendingArtwork: TextTranslator<TranslateOptions>;
                successfullySent: TextTranslator<TranslateOptions>;
                yourPrintProvider: TextTranslator<TranslateOptions>;
            };
            publish: TextTranslator<TranslateOptions>;
            publishImmediately: TextTranslator<TranslateOptions>;
            publishVideoAction: TextTranslator<TranslateOptions>;
            published: TextTranslator<TranslateOptions>;
            publishedSuccessfully: TextTranslator<BuildPublishPublishedSuccessfullyOptions>;
            publishedToSomeLocations: TextTranslator<TranslateOptions>;
            publishingFailed: TextTranslator<TranslateOptions>;
            refreshPlatforms: TextTranslator<TranslateOptions>;
            relativeToLocation: TextTranslator<TranslateOptions>;
            reschedule: {
                newTime: TextTranslator<TranslateOptions>;
                rescheduleItem: TextTranslator<TranslateOptions>;
            };
            savedSuccessfully: TextTranslator<BuildPublishSavedSuccessfullyOptions>;
            scheduleForLater: TextTranslator<TranslateOptions>;
            scheduledPostMustBeAtLeast10MinsInFuture: TextTranslator<TranslateOptions>;
            scheduledPostTimePickerWarning: TextTranslator<TranslateOptions>;
            scheduledSuccessfully: TextTranslator<BuildPublishScheduledSuccessfullyOptions>;
            sendImmediately: TextTranslator<TranslateOptions>;
            termsAndConditionsHelpText: TextTranslator<TranslateOptions>;
            twitter: {
                accessCheckFailure: TextTranslator<TranslateOptions>;
                cannotPublishMultiImageHelpText: TextTranslator<BuildPublishTwitterCannotPublishMultiImageHelpTextOptions>;
                cannotStopScheduledPost: TextTranslator<TranslateOptions>;
                publishToTwitter: TextTranslator<TranslateOptions>;
                tweet: TextTranslator<TranslateOptions>;
            };
            uploading: TextTranslator<TranslateOptions>;
            willReceiveNotification: TextTranslator<BuildPublishWillReceiveNotificationOptions>;
            willReceiveScheduledNotification: TextTranslator<BuildPublishWillReceiveScheduledNotificationOptions>;
            willRecieveSmsDetails: TextTranslator<BuildPublishWillRecieveSmsDetailsOptions>;
            willRecieveSmsReminder: TextTranslator<BuildPublishWillRecieveSmsReminderOptions>;
            wouldYouLikeToSchedulePostOnAnotherPlatform: TextTranslator<TranslateOptions>;
            wouldYouLikeToScheduleThisPostAgain: TextTranslator<TranslateOptions>;
            yesPlease: TextTranslator<TranslateOptions>;
            yesPleaseButDifferentTemplate: TextTranslator<TranslateOptions>;
            yesPleaseButLater: TextTranslator<TranslateOptions>;
        };
        publishToMultipleLocations: TextTranslator<TranslateOptions>;
        publishingFailed: TextTranslator<TranslateOptions>;
        recentlyAdded: TextTranslator<TranslateOptions>;
        rectangle: TextTranslator<TranslateOptions>;
        repetitions: TextTranslator<TranslateOptions>;
        requestSupport: TextTranslator<TranslateOptions>;
        resourcesLoaded: TextTranslator<BuildResourcesLoadedOptions>;
        resourcesLoadedPlural: TextTranslator<BuildResourcesLoadedPluralOptions>;
        returnToBuilder: TextTranslator<TranslateOptions>;
        savingTemplate: TextTranslator<TranslateOptions>;
        scheduledTime: TextTranslator<TranslateOptions>;
        selectPreviewImage: TextTranslator<TranslateOptions>;
        separateTagsWithSpaces: TextTranslator<TranslateOptions>;
        showDetails: TextTranslator<TranslateOptions>;
        showOldEmailTemplates: TextTranslator<TranslateOptions>;
        summaryHiddenMessage: TextTranslator<TranslateOptions>;
        template: TextTranslator<TranslateOptions>;
        templateAdmin: {
            copyAsUnpublished: TextTranslator<TranslateOptions>;
            copyAsUnpublishedTooltip: TextTranslator<TranslateOptions>;
            copyError: TextTranslator<TranslateOptions>;
            copyNoClients: TextTranslator<TranslateOptions>;
            copySuccess: TextTranslator<BuildTemplateAdminCopySuccessOptions>;
            copySuccessExtended: TextTranslator<BuildTemplateAdminCopySuccessExtendedOptions>;
            copyTo: TextTranslator<TranslateOptions>;
            deleteTemplate: TextTranslator<TranslateOptions>;
            deleteTemplateSuccess: TextTranslator<TranslateOptions>;
            duplicateTemplate: TextTranslator<TranslateOptions>;
            duplicateTemplateSuccess: TextTranslator<TranslateOptions>;
            editAttributes: TextTranslator<TranslateOptions>;
            includeAssignedCategories: TextTranslator<TranslateOptions>;
            includeAssignedCategoriesTooltip: TextTranslator<TranslateOptions>;
            manageBuildableTemplate: TextTranslator<TranslateOptions>;
            templateUpdated: TextTranslator<TranslateOptions>;
            toggleTemplateStatusPublished: TextTranslator<TranslateOptions>;
            toggleTemplateStatusPublishedSuccess: TextTranslator<TranslateOptions>;
            toggleTemplateStatusUnpublished: TextTranslator<TranslateOptions>;
            toggleTemplateStatusUnpublishedSuccess: TextTranslator<TranslateOptions>;
        };
        templateCouldNotBeExportedUnderTheFileSizeLimit: TextTranslator<TranslateOptions>;
        templateDeleted: TextTranslator<TranslateOptions>;
        templateGallery: TextTranslator<TranslateOptions>;
        templateNotFoundOrUnauthorized: TextTranslator<TranslateOptions>;
        templateSaved: TextTranslator<TranslateOptions>;
        textAlignmentHorizontal: {
            center: TextTranslator<TranslateOptions>;
            justify: TextTranslator<TranslateOptions>;
            left: TextTranslator<TranslateOptions>;
            right: TextTranslator<TranslateOptions>;
        };
        textAlignmentVertical: {
            bottom: TextTranslator<TranslateOptions>;
            center: TextTranslator<TranslateOptions>;
            top: TextTranslator<TranslateOptions>;
        };
        textClipping: TextTranslator<TranslateOptions>;
        textFormattingWorkaround: TextTranslator<TranslateOptions>;
        textLineHeightFix: TextTranslator<TranslateOptions>;
        textMustBeEditable: TextTranslator<TranslateOptions>;
        timeUnitsAgo: {
            dayAgo: TextTranslator<TranslateOptions>;
            dayAgoPlural: TextTranslator<TranslateOptions>;
            hourAgo: TextTranslator<TranslateOptions>;
            hourAgoPlural: TextTranslator<TranslateOptions>;
            minuteAgo: TextTranslator<TranslateOptions>;
            minuteAgoPlural: TextTranslator<TranslateOptions>;
            monthAgo: TextTranslator<TranslateOptions>;
            monthAgoPlural: TextTranslator<TranslateOptions>;
            secondAgo: TextTranslator<TranslateOptions>;
            secondAgoPlural: TextTranslator<TranslateOptions>;
            weekAgo: TextTranslator<TranslateOptions>;
            weekAgoPlural: TextTranslator<TranslateOptions>;
            yearAgo: TextTranslator<TranslateOptions>;
            yearAgoPlural: TextTranslator<TranslateOptions>;
        };
        toggleUnpublished: TextTranslator<TranslateOptions>;
        transform: TextTranslator<TranslateOptions>;
        unpublishedInfo: TextTranslator<TranslateOptions>;
        unpublishedTemplate: TextTranslator<TranslateOptions>;
        unpublishedTemplatePublishWarning: TextTranslator<TranslateOptions>;
        updateTemplate: TextTranslator<TranslateOptions>;
        uppercase: TextTranslator<TranslateOptions>;
        video: {
            checkingAccess: TextTranslator<TranslateOptions>;
            downloadVideo: TextTranslator<TranslateOptions>;
            failedToPublishVideo: TextTranslator<TranslateOptions>;
            finalizingVideo: TextTranslator<TranslateOptions>;
            networkError: TextTranslator<TranslateOptions>;
            noVideoLayers: TextTranslator<TranslateOptions>;
            noVideoUploaded: TextTranslator<TranslateOptions>;
            pleaseWait: TextTranslator<TranslateOptions>;
            preparingVideo: TextTranslator<TranslateOptions>;
            processingVideo: TextTranslator<TranslateOptions>;
            processingTimeDisclaimer: TextTranslator<TranslateOptions>;
            publishingFailedMessage: TextTranslator<TranslateOptions>;
            readyToDownload: TextTranslator<TranslateOptions>;
            removeAudio: TextTranslator<TranslateOptions>;
            renderingVideo: TextTranslator<TranslateOptions>;
            retyWithoutAudio: TextTranslator<TranslateOptions>;
            unsupportedFormat: TextTranslator<TranslateOptions>;
            uploading: TextTranslator<TranslateOptions>;
            videoIsReady: TextTranslator<TranslateOptions>;
            videoIsReadyToDownload: TextTranslator<TranslateOptions>;
        };
        videoChooser: {
            confirmAcknowledged: TextTranslator<TranslateOptions>;
            confirmPermission: TextTranslator<TranslateOptions>;
            localFile: TextTranslator<TranslateOptions>;
            maxUploadError: TextTranslator<TranslateOptions>;
            permissionDisclaimer: TextTranslator<TranslateOptions>;
            permissionDisclaimerStrong: TextTranslator<TranslateOptions>;
            permissionError: TextTranslator<TranslateOptions>;
            selectVideo: TextTranslator<TranslateOptions>;
            selectVideoFromYourLibrary: TextTranslator<TranslateOptions>;
            suggestedCollection: TextTranslator<TranslateOptions>;
            uploadVideoFromYourDevice: TextTranslator<TranslateOptions>;
            uploadedAssetVideo: TextTranslator<TranslateOptions>;
            uploadedPlannerVideo: TextTranslator<TranslateOptions>;
            videoSource: TextTranslator<TranslateOptions>;
        };
        websiteUrlNotSet: TextTranslator<TranslateOptions>;
        youAreCurrentlyBuilding: TextTranslator<TranslateOptions>;
        youHaveNItemsToBuildAndSchedule: TextTranslator<TranslateOptions>;
        youHaveNItemsToBuildAndSchedulePlural: TextTranslator<TranslateOptions>;
        youHaveNItemsToCheckout: TextTranslator<TranslateOptions>;
        youHaveNItemsToCheckoutPlural: TextTranslator<TranslateOptions>;
    };
    client: {
        clientLocationEngagementTable: {
            headers: {
                builtItems: TextTranslator<TranslateOptions>;
                facebookAds: TextTranslator<TranslateOptions>;
                googleAds: TextTranslator<TranslateOptions>;
                groups: TextTranslator<TranslateOptions>;
                leads: TextTranslator<TranslateOptions>;
                location: TextTranslator<TranslateOptions>;
                region: TextTranslator<TranslateOptions>;
            };
            labelFilterLocations: TextTranslator<TranslateOptions>;
            noGroups: TextTranslator<TranslateOptions>;
            noLocationsFound: TextTranslator<TranslateOptions>;
            noRegion: TextTranslator<TranslateOptions>;
        };
        clientTemplateCategories: {
            addTemplateCategory: TextTranslator<TranslateOptions>;
            deleteTemplateCategory: TextTranslator<TranslateOptions>;
            deleteText: TextTranslator<TranslateOptions>;
            editTemplateCategory: TextTranslator<TranslateOptions>;
            error: {
                create: TextTranslator<TranslateOptions>;
                emptyCategoryLabel: TextTranslator<TranslateOptions>;
                endDateBeforeStartDate: TextTranslator<TranslateOptions>;
                invalidEndDate: TextTranslator<TranslateOptions>;
                invalidStartDate: TextTranslator<TranslateOptions>;
                modify: TextTranslator<TranslateOptions>;
            };
            formLabels: {
                endDateOptional: TextTranslator<TranslateOptions>;
                startDate: TextTranslator<TranslateOptions>;
            };
            label: TextTranslator<TranslateOptions>;
            success: {
                create: TextTranslator<TranslateOptions>;
                modify: TextTranslator<TranslateOptions>;
            };
            title: TextTranslator<TranslateOptions>;
        };
        clientUsersLocation: {
            addUser: TextTranslator<TranslateOptions>;
            assignUserToLocations: TextTranslator<TranslateOptions>;
            buttons: {
                sendInvite: TextTranslator<TranslateOptions>;
            };
            createNewUser: TextTranslator<TranslateOptions>;
            deleteOrphanedUser: TextTranslator<TranslateOptions>;
            filterUserPlaceholder: TextTranslator<TranslateOptions>;
            invalidEmailHelperText: TextTranslator<TranslateOptions>;
            inviteNewUser: TextTranslator<TranslateOptions>;
            inviteUser: TextTranslator<TranslateOptions>;
            labels: {
                emailAddress: TextTranslator<TranslateOptions>;
                giveAccessTo: TextTranslator<TranslateOptions>;
                userDetails: TextTranslator<TranslateOptions>;
                userRoles: TextTranslator<TranslateOptions>;
            };
            locationAccess: TextTranslator<TranslateOptions>;
            matchingUserFound: TextTranslator<TranslateOptions>;
            matchingUsersFound: TextTranslator<TranslateOptions>;
            modalTitle: TextTranslator<ClientClientUsersLocationModalTitleOptions>;
            placeholders: {
                emailAddress: TextTranslator<TranslateOptions>;
                selectRoles: TextTranslator<TranslateOptions>;
            };
            updateLocations: TextTranslator<TranslateOptions>;
        };
        clientUsersTable: {
            bulkActions: {
                delete: TextTranslator<TranslateOptions>;
                resendUserInvites: TextTranslator<TranslateOptions>;
                resetPassword: TextTranslator<TranslateOptions>;
                updateLocations: TextTranslator<TranslateOptions>;
                updateRoles: TextTranslator<TranslateOptions>;
            };
            buttonBulkActionsPrimary: TextTranslator<TranslateOptions>;
            buttonBulkActionsSecondary: TextTranslator<ClientClientUsersTableButtonBulkActionsSecondaryOptions>;
            mobileTooltip: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        editClientUserModal: {
            labels: {
                emailAddress: TextTranslator<TranslateOptions>;
                firstName: TextTranslator<TranslateOptions>;
                generalDetails: TextTranslator<TranslateOptions>;
                guidedTour: TextTranslator<TranslateOptions>;
                lastName: TextTranslator<TranslateOptions>;
                locationsAccess: TextTranslator<TranslateOptions>;
                preferences: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                userRoles: TextTranslator<TranslateOptions>;
            };
        };
        engagementHelpText: {
            activity: TextTranslator<TranslateOptions>;
            builtItems: TextTranslator<TranslateOptions>;
            connections: {
                currentlyRequiredPlatforms: TextTranslator<ClientEngagementHelpTextConnectionsCurrentlyRequiredPlatformsOptions>;
                dataNotImpactedByDateSelection: TextTranslator<TranslateOptions>;
                howToSetRequiredPlatforms: TextTranslator<ClientEngagementHelpTextConnectionsHowToSetRequiredPlatformsOptions>;
                requiredConnectionsExplanation: TextTranslator<TranslateOptions>;
                totalConnectionsExplanation: TextTranslator<TranslateOptions>;
            };
        };
        errorStyleGuideDelete: TextTranslator<TranslateOptions>;
        errorStyleGuideReplace: TextTranslator<TranslateOptions>;
        errorStyleGuideUpload: TextTranslator<TranslateOptions>;
        errors: {
            noClientId: TextTranslator<TranslateOptions>;
            noClientSelected: TextTranslator<TranslateOptions>;
            noDateRange: TextTranslator<TranslateOptions>;
            unexpectedError: TextTranslator<TranslateOptions>;
        };
        locationActivity: {
            builtItemsCount: TextTranslator<ClientLocationActivityBuiltItemsCountOptions>;
            headers: {
                activity: TextTranslator<TranslateOptions>;
                builtItems: TextTranslator<TranslateOptions>;
                connections: TextTranslator<TranslateOptions>;
                mostEngagedLocations: TextTranslator<TranslateOptions>;
            };
            labelBuiltItemsCumulative: TextTranslator<TranslateOptions>;
            locationsActive: TextTranslator<TranslateOptions>;
            locationsUsingMobileApp: TextTranslator<TranslateOptions>;
            requiredPlatformsConnected: TextTranslator<TranslateOptions>;
            sortBuiltItems: TextTranslator<TranslateOptions>;
            sortLocation: TextTranslator<TranslateOptions>;
            sortTitle: TextTranslator<TranslateOptions>;
            templatesBuilt: TextTranslator<TranslateOptions>;
            totalPlatformsConnected: TextTranslator<TranslateOptions>;
        };
        overview: {
            errors: {
                failToLoad: TextTranslator<TranslateOptions>;
            };
            headers: {
                templateCategories: TextTranslator<TranslateOptions>;
                templatesBuilt: TextTranslator<TranslateOptions>;
            };
            socialTemplateReporting: {
                title: TextTranslator<TranslateOptions>;
                body: TextTranslator<TranslateOptions>;
                button: TextTranslator<TranslateOptions>;
            };
            templateCategories: {
                assetsUsed: TextTranslator<ClientOverviewTemplateCategoriesAssetsUsedOptions>;
                assetsUsedPlural: TextTranslator<ClientOverviewTemplateCategoriesAssetsUsedPluralOptions>;
                digital: TextTranslator<TranslateOptions>;
                email: TextTranslator<TranslateOptions>;
                print: TextTranslator<TranslateOptions>;
            };
            templatesBuiltByLocationCategory: TextTranslator<TranslateOptions>;
        };
        regionActivity: {
            categoriesTable: {
                averageBuiltItemsPerLocation: TextTranslator<TranslateOptions>;
                errors: {
                    failToLoad: TextTranslator<TranslateOptions>;
                };
            };
            filterName: TextTranslator<TranslateOptions>;
            headers: {
                builtItems: TextTranslator<TranslateOptions>;
            };
        };
        styleGuidePageTitle: TextTranslator<TranslateOptions>;
        successStyleGuideDelete: TextTranslator<TranslateOptions>;
        successStyleGuideReplace: TextTranslator<TranslateOptions>;
        successStyleGuideUpload: TextTranslator<TranslateOptions>;
    };
    common: {
        actions: TextTranslator<TranslateOptions>;
        active: TextTranslator<TranslateOptions>;
        add: TextTranslator<TranslateOptions>;
        addNewTag: TextTranslator<TranslateOptions>;
        addTag: TextTranslator<TranslateOptions>;
        address: TextTranslator<TranslateOptions>;
        admin: TextTranslator<TranslateOptions>;
        after: TextTranslator<TranslateOptions>;
        agencies: TextTranslator<TranslateOptions>;
        agency: TextTranslator<TranslateOptions>;
        all: TextTranslator<TranslateOptions>;
        allAssets: TextTranslator<TranslateOptions>;
        allLocations: TextTranslator<TranslateOptions>;
        amount: TextTranslator<TranslateOptions>;
        and: TextTranslator<TranslateOptions>;
        andXOtherLocations: TextTranslator<CommonAndXOtherLocationsOptions>;
        andXOtherLocationsPlural: TextTranslator<CommonAndXOtherLocationsPluralOptions>;
        anybody: TextTranslator<TranslateOptions>;
        apps: TextTranslator<TranslateOptions>;
        areYouSure: TextTranslator<TranslateOptions>;
        areYouSureYouWantToDeleteNumAssets: TextTranslator<CommonAreYouSureYouWantToDeleteNumAssetsOptions>;
        areYouSureYouWantToDeleteThisAsset: TextTranslator<TranslateOptions>;
        areYouSureYouWantToDeleteThisCollection: TextTranslator<TranslateOptions>;
        assetCollection: TextTranslator<TranslateOptions>;
        assetLibrary: TextTranslator<TranslateOptions>;
        assignedTo: TextTranslator<TranslateOptions>;
        attach: TextTranslator<TranslateOptions>;
        attachFile: TextTranslator<TranslateOptions>;
        attachments: TextTranslator<TranslateOptions>;
        back: TextTranslator<TranslateOptions>;
        beta: TextTranslator<TranslateOptions>;
        browse: TextTranslator<TranslateOptions>;
        build: TextTranslator<TranslateOptions>;
        built: TextTranslator<TranslateOptions>;
        businessName: TextTranslator<TranslateOptions>;
        cancel: TextTranslator<TranslateOptions>;
        cancelledWhileInQueue: TextTranslator<TranslateOptions>;
        cancelledWhileProcessing: TextTranslator<TranslateOptions>;
        cannotFindAsset: TextTranslator<TranslateOptions>;
        categories: TextTranslator<TranslateOptions>;
        category: TextTranslator<TranslateOptions>;
        change: TextTranslator<TranslateOptions>;
        changesSaved: TextTranslator<TranslateOptions>;
        channel: TextTranslator<TranslateOptions>;
        channels: TextTranslator<TranslateOptions>;
        checkConnection: TextTranslator<TranslateOptions>;
        clear: TextTranslator<TranslateOptions>;
        client: TextTranslator<TranslateOptions>;
        clientUsedMaxCollections: TextTranslator<TranslateOptions>;
        clientWithLocation: TextTranslator<CommonClientWithLocationOptions>;
        clients: TextTranslator<TranslateOptions>;
        close: TextTranslator<TranslateOptions>;
        collection: TextTranslator<TranslateOptions>;
        colour: TextTranslator<TranslateOptions>;
        columns: TextTranslator<TranslateOptions>;
        copy: TextTranslator<TranslateOptions>;
        comments: {
            addComment: TextTranslator<TranslateOptions>;
            areYouSureDeleteComment: TextTranslator<TranslateOptions>;
            cannotDeleteComments: TextTranslator<TranslateOptions>;
            comment: TextTranslator<TranslateOptions>;
            comments: TextTranslator<TranslateOptions>;
            commentsHeadingDefault: TextTranslator<TranslateOptions>;
            deleteComment: TextTranslator<TranslateOptions>;
            enterComment: TextTranslator<TranslateOptions>;
            unknownParent: TextTranslator<TranslateOptions>;
        };
        companies: {
            ltNetwork: TextTranslator<TranslateOptions>;
        };
        confirm: TextTranslator<TranslateOptions>;
        confirmModalInput: TextTranslator<CommonConfirmModalInputOptions>;
        confirmation: TextTranslator<TranslateOptions>;
        connectPage: {
            connectPage: TextTranslator<TranslateOptions>;
            filter: {
                accountName: TextTranslator<TranslateOptions>;
                clearLocationId: TextTranslator<TranslateOptions>;
                client: TextTranslator<TranslateOptions>;
                location: TextTranslator<TranslateOptions>;
                pageName: TextTranslator<TranslateOptions>;
                status: TextTranslator<TranslateOptions>;
            };
            statusDropdown: {
                connect: TextTranslator<TranslateOptions>;
                connected: TextTranslator<TranslateOptions>;
                error: TextTranslator<TranslateOptions>;
                expired: TextTranslator<TranslateOptions>;
                incomplete: TextTranslator<TranslateOptions>;
            };
            tableHeaders: {
                accountMapping: TextTranslator<TranslateOptions>;
                accountName: TextTranslator<TranslateOptions>;
            };
        };
        connectionIssues: TextTranslator<TranslateOptions>;
        continue: TextTranslator<TranslateOptions>;
        copiedToClipboard: TextTranslator<CommonCopiedToClipboardOptions>;
        copiedToClipboardFailed: TextTranslator<TranslateOptions>;
        costs: TextTranslator<TranslateOptions>;
        couldNotDetermineBootstrapBreakpoint: TextTranslator<TranslateOptions>;
        countries: {
            australia: TextTranslator<TranslateOptions>;
            austria: TextTranslator<TranslateOptions>;
            belgium: TextTranslator<TranslateOptions>;
            canada: TextTranslator<TranslateOptions>;
            czechia: TextTranslator<TranslateOptions>;
            denmark: TextTranslator<TranslateOptions>;
            dominicanRepublic: TextTranslator<TranslateOptions>;
            egypt: TextTranslator<TranslateOptions>;
            finland: TextTranslator<TranslateOptions>;
            france: TextTranslator<TranslateOptions>;
            georgia: TextTranslator<TranslateOptions>;
            germany: TextTranslator<TranslateOptions>;
            hongKong: TextTranslator<TranslateOptions>;
            hungary: TextTranslator<TranslateOptions>;
            india: TextTranslator<TranslateOptions>;
            indonesia: TextTranslator<TranslateOptions>;
            ireland: TextTranslator<TranslateOptions>;
            italy: TextTranslator<TranslateOptions>;
            japan: TextTranslator<TranslateOptions>;
            latvia: TextTranslator<TranslateOptions>;
            lithuania: TextTranslator<TranslateOptions>;
            malaysia: TextTranslator<TranslateOptions>;
            mauritius: TextTranslator<TranslateOptions>;
            mexico: TextTranslator<TranslateOptions>;
            myanmar: TextTranslator<TranslateOptions>;
            netherlands: TextTranslator<TranslateOptions>;
            newZealand: TextTranslator<TranslateOptions>;
            norway: TextTranslator<TranslateOptions>;
            peru: TextTranslator<TranslateOptions>;
            philippines: TextTranslator<TranslateOptions>;
            portugal: TextTranslator<TranslateOptions>;
            saudiArabia: TextTranslator<TranslateOptions>;
            singapore: TextTranslator<TranslateOptions>;
            southAfrica: TextTranslator<TranslateOptions>;
            southKorea: TextTranslator<TranslateOptions>;
            spain: TextTranslator<TranslateOptions>;
            sweden: TextTranslator<TranslateOptions>;
            switzerland: TextTranslator<TranslateOptions>;
            taiwan: TextTranslator<TranslateOptions>;
            thailand: TextTranslator<TranslateOptions>;
            turkey: TextTranslator<TranslateOptions>;
            unitedArabEmirates: TextTranslator<TranslateOptions>;
            unitedKingdom: TextTranslator<TranslateOptions>;
            unitedStatesOfAmerica: TextTranslator<TranslateOptions>;
            vietnam: TextTranslator<TranslateOptions>;
        };
        country: TextTranslator<TranslateOptions>;
        create: TextTranslator<TranslateOptions>;
        created: TextTranslator<TranslateOptions>;
        createdAt: TextTranslator<TranslateOptions>;
        currency: TextTranslator<TranslateOptions>;
        currentLocationUsedMaxCollections: TextTranslator<CommonCurrentLocationUsedMaxCollectionsOptions>;
        currentlySelectedCount: TextTranslator<CommonCurrentlySelectedCountOptions>;
        customize: TextTranslator<TranslateOptions>;
        date: TextTranslator<TranslateOptions>;
        dateAdded: TextTranslator<TranslateOptions>;
        day: TextTranslator<TranslateOptions>;
        days: TextTranslator<TranslateOptions>;
        daysOfTheWeekLong: {
            friday: TextTranslator<TranslateOptions>;
            monday: TextTranslator<TranslateOptions>;
            saturday: TextTranslator<TranslateOptions>;
            sunday: TextTranslator<TranslateOptions>;
            thursday: TextTranslator<TranslateOptions>;
            tuesday: TextTranslator<TranslateOptions>;
            wednesday: TextTranslator<TranslateOptions>;
        };
        delete: TextTranslator<TranslateOptions>;
        deleteAsset: TextTranslator<TranslateOptions>;
        deleteCheckedTags: TextTranslator<TranslateOptions>;
        deleteCheckedTagsConfirm: TextTranslator<TranslateOptions>;
        deletePermanently: TextTranslator<TranslateOptions>;
        deleteSomething: TextTranslator<CommonDeleteSomethingOptions>;
        deleted: TextTranslator<TranslateOptions>;
        description: TextTranslator<TranslateOptions>;
        deselectAll: TextTranslator<TranslateOptions>;
        desktop: TextTranslator<TranslateOptions>;
        detach: TextTranslator<TranslateOptions>;
        details: TextTranslator<TranslateOptions>;
        disable: TextTranslator<TranslateOptions>;
        disabled: TextTranslator<TranslateOptions>;
        dismiss: TextTranslator<TranslateOptions>;
        displayName: TextTranslator<TranslateOptions>;
        done: TextTranslator<TranslateOptions>;
        download: TextTranslator<TranslateOptions>;
        edit: TextTranslator<TranslateOptions>;
        editAsset: TextTranslator<TranslateOptions>;
        editAssets: TextTranslator<TranslateOptions>;
        editCollection: TextTranslator<TranslateOptions>;
        editMultipleAssets: TextTranslator<CommonEditMultipleAssetsOptions>;
        email: TextTranslator<TranslateOptions>;
        emailAddress: TextTranslator<TranslateOptions>;
        enable: TextTranslator<TranslateOptions>;
        enabled: TextTranslator<TranslateOptions>;
        endDate: TextTranslator<TranslateOptions>;
        enterNewName: TextTranslator<TranslateOptions>;
        error: TextTranslator<TranslateOptions>;
        example: TextTranslator<TranslateOptions>;
        exceededSizeLimitCollection: TextTranslator<TranslateOptions>;
        expireOnDate: TextTranslator<TranslateOptions>;
        expired: TextTranslator<TranslateOptions>;
        expiry: TextTranslator<TranslateOptions>;
        failedTo: TextTranslator<CommonFailedToOptions>;
        failedToLoadImage: TextTranslator<TranslateOptions>;
        failedToRetrieveLocations: TextTranslator<TranslateOptions>;
        fetchData: TextTranslator<TranslateOptions>;
        file: TextTranslator<TranslateOptions>;
        fileSize: TextTranslator<TranslateOptions>;
        fileUploaded: TextTranslator<TranslateOptions>;
        files: TextTranslator<TranslateOptions>;
        filter: TextTranslator<TranslateOptions>;
        filterCollections: TextTranslator<TranslateOptions>;
        filters: TextTranslator<TranslateOptions>;
        finish: TextTranslator<TranslateOptions>;
        firstName: TextTranslator<TranslateOptions>;
        format: TextTranslator<TranslateOptions>;
        formats: TextTranslator<TranslateOptions>;
        from: TextTranslator<TranslateOptions>;
        fullScreen: TextTranslator<TranslateOptions>;
        gmt: TextTranslator<TranslateOptions>;
        googleAdsDisclaimer: TextTranslator<TranslateOptions>;
        googleAdsDisclaimerConversionData: TextTranslator<TranslateOptions>;
        groups: TextTranslator<TranslateOptions>;
        height: TextTranslator<TranslateOptions>;
        hide: TextTranslator<TranslateOptions>;
        image: TextTranslator<TranslateOptions>;
        info: TextTranslator<TranslateOptions>;
        instructions: TextTranslator<TranslateOptions>;
        invite: TextTranslator<TranslateOptions>;
        item: TextTranslator<TranslateOptions>;
        label: TextTranslator<TranslateOptions>;
        lastActivity: TextTranslator<TranslateOptions>;
        lastMonth: TextTranslator<TranslateOptions>;
        lastName: TextTranslator<TranslateOptions>;
        lastUpdated: TextTranslator<TranslateOptions>;
        learnMore: TextTranslator<TranslateOptions>;
        leavePageConfirmation: TextTranslator<TranslateOptions>;
        leavePageConfirmationLong: TextTranslator<TranslateOptions>;
        leavePagePrompt: {
            confirm: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        legend: TextTranslator<TranslateOptions>;
        less: TextTranslator<TranslateOptions>;
        link: TextTranslator<TranslateOptions>;
        loadMore: TextTranslator<TranslateOptions>;
        loading: TextTranslator<TranslateOptions>;
        locale: TextTranslator<TranslateOptions>;
        localeRequired: TextTranslator<TranslateOptions>;
        location: TextTranslator<TranslateOptions>;
        locationUsedMaxCollections: TextTranslator<TranslateOptions>;
        locations: TextTranslator<TranslateOptions>;
        login: TextTranslator<TranslateOptions>;
        manager: TextTranslator<TranslateOptions>;
        map: TextTranslator<TranslateOptions>;
        marketing: TextTranslator<TranslateOptions>;
        message: TextTranslator<TranslateOptions>;
        mobile: TextTranslator<TranslateOptions>;
        more: TextTranslator<TranslateOptions>;
        moreCharsForSearch: TextTranslator<TranslateOptions>;
        most: TextTranslator<TranslateOptions>;
        moveToFolder: TextTranslator<TranslateOptions>;
        mustBeXOrMore: TextTranslator<CommonMustBeXOrMoreOptions>;
        name: TextTranslator<TranslateOptions>;
        never: TextTranslator<TranslateOptions>;
        new: TextTranslator<TranslateOptions>;
        newCollection: TextTranslator<TranslateOptions>;
        next: TextTranslator<TranslateOptions>;
        nextAmount: TextTranslator<TranslateOptions>;
        nextDate: TextTranslator<TranslateOptions>;
        no: TextTranslator<TranslateOptions>;
        noAssetCollectionsFound: TextTranslator<TranslateOptions>;
        noAssetsAreCurrentlyAvaliableFor: TextTranslator<TranslateOptions>;
        noAssetsFound: TextTranslator<TranslateOptions>;
        noMatchingCollectionsFound: TextTranslator<TranslateOptions>;
        noResults: TextTranslator<TranslateOptions>;
        noThanks: TextTranslator<TranslateOptions>;
        nobody: TextTranslator<TranslateOptions>;
        none: TextTranslator<TranslateOptions>;
        notLoggedIn: TextTranslator<TranslateOptions>;
        notSeeingWhatExpected: TextTranslator<TranslateOptions>;
        note: TextTranslator<TranslateOptions>;
        nothingFound: TextTranslator<TranslateOptions>;
        notification: TextTranslator<TranslateOptions>;
        notifications: TextTranslator<TranslateOptions>;
        numOfTotal: TextTranslator<CommonNumOfTotalOptions>;
        ok: TextTranslator<TranslateOptions>;
        on: TextTranslator<TranslateOptions>;
        opAddAsset: TextTranslator<TranslateOptions>;
        opCreateCollection: TextTranslator<TranslateOptions>;
        opDeleteAssets: TextTranslator<TranslateOptions>;
        opDeleteCollection: TextTranslator<TranslateOptions>;
        opEditAssets: TextTranslator<TranslateOptions>;
        opEditCollection: TextTranslator<TranslateOptions>;
        opGetAssets: TextTranslator<TranslateOptions>;
        opGetCollection: TextTranslator<TranslateOptions>;
        opGetCollections: TextTranslator<TranslateOptions>;
        opGetLocations: TextTranslator<TranslateOptions>;
        opGetNumCollections: TextTranslator<TranslateOptions>;
        opGetPermissions: TextTranslator<TranslateOptions>;
        open: TextTranslator<TranslateOptions>;
        openCalendar: TextTranslator<TranslateOptions>;
        openYourFile: TextTranslator<TranslateOptions>;
        optional: TextTranslator<TranslateOptions>;
        options: TextTranslator<TranslateOptions>;
        or: TextTranslator<TranslateOptions>;
        other: TextTranslator<TranslateOptions>;
        outOfRange: TextTranslator<TranslateOptions>;
        password: TextTranslator<TranslateOptions>;
        pay: TextTranslator<TranslateOptions>;
        perPage: TextTranslator<TranslateOptions>;
        phoneNumber: TextTranslator<TranslateOptions>;
        planned: TextTranslator<TranslateOptions>;
        platform: TextTranslator<TranslateOptions>;
        platforms: TextTranslator<TranslateOptions>;
        pleaseContactYourAgencyForFurtherInformation: TextTranslator<TranslateOptions>;
        preview: TextTranslator<TranslateOptions>;
        previous: TextTranslator<TranslateOptions>;
        price: TextTranslator<TranslateOptions>;
        primary: TextTranslator<TranslateOptions>;
        print: TextTranslator<TranslateOptions>;
        private: TextTranslator<TranslateOptions>;
        processing: TextTranslator<TranslateOptions>;
        products: {
            campaignMonitor: TextTranslator<TranslateOptions>;
            clubready: TextTranslator<TranslateOptions>;
            digitalStack: TextTranslator<TranslateOptions>;
            facebook: TextTranslator<TranslateOptions>;
            facebookAds: TextTranslator<TranslateOptions>;
            facebookAndInstagramAds: TextTranslator<TranslateOptions>;
            fitware: TextTranslator<TranslateOptions>;
            four51: TextTranslator<TranslateOptions>;
            glofox: TextTranslator<TranslateOptions>;
            google: TextTranslator<TranslateOptions>;
            googleAdwords: TextTranslator<TranslateOptions>;
            googleAnalytics: TextTranslator<TranslateOptions>;
            googleMyBusiness: TextTranslator<TranslateOptions>;
            instagram: TextTranslator<TranslateOptions>;
            instagramViaFacebook: TextTranslator<TranslateOptions>;
            linkedin: TextTranslator<TranslateOptions>;
            mailchimp: TextTranslator<TranslateOptions>;
            sendgrid: TextTranslator<TranslateOptions>;
            twitter: TextTranslator<TranslateOptions>;
        };
        progressModal: {
            statusMessage: TextTranslator<CommonProgressModalStatusMessageOptions>;
        };
        public: TextTranslator<TranslateOptions>;
        quantity: TextTranslator<TranslateOptions>;
        refresh: TextTranslator<TranslateOptions>;
        region: TextTranslator<TranslateOptions>;
        reload: TextTranslator<TranslateOptions>;
        remove: TextTranslator<TranslateOptions>;
        rename: TextTranslator<TranslateOptions>;
        renameSomething: TextTranslator<CommonRenameSomethingOptions>;
        replacePdf: TextTranslator<TranslateOptions>;
        required: TextTranslator<TranslateOptions>;
        requiredFieldHelp: TextTranslator<TranslateOptions>;
        requiredFieldMessage: TextTranslator<TranslateOptions>;
        retry: TextTranslator<TranslateOptions>;
        review: TextTranslator<TranslateOptions>;
        role: TextTranslator<TranslateOptions>;
        save: TextTranslator<TranslateOptions>;
        saveNew: TextTranslator<TranslateOptions>;
        schedule: TextTranslator<TranslateOptions>;
        scheduled: TextTranslator<TranslateOptions>;
        search: TextTranslator<TranslateOptions>;
        searchAssets: TextTranslator<TranslateOptions>;
        searchCollections: TextTranslator<TranslateOptions>;
        searchEverything: TextTranslator<TranslateOptions>;
        searchResults: TextTranslator<TranslateOptions>;
        searchWithin: TextTranslator<CommonSearchWithinOptions>;
        selectAClient: TextTranslator<TranslateOptions>;
        selectAll: TextTranslator<TranslateOptions>;
        selectAnOption: TextTranslator<TranslateOptions>;
        selectStartAndEndDates: TextTranslator<TranslateOptions>;
        selected: TextTranslator<TranslateOptions>;
        selectedClients: TextTranslator<TranslateOptions>;
        send: TextTranslator<TranslateOptions>;
        sendQuote: TextTranslator<TranslateOptions>;
        sending: TextTranslator<TranslateOptions>;
        settings: TextTranslator<TranslateOptions>;
        shipping: TextTranslator<TranslateOptions>;
        shippingFee: TextTranslator<TranslateOptions>;
        showAll: TextTranslator<TranslateOptions>;
        showLess: TextTranslator<TranslateOptions>;
        skip: TextTranslator<TranslateOptions>;
        someAssets: TextTranslator<TranslateOptions>;
        sort: TextTranslator<TranslateOptions>;
        sortBy: TextTranslator<TranslateOptions>;
        sortDirectionTip: TextTranslator<CommonSortDirectionTipOptions>;
        sortDirectionTipAsc: TextTranslator<TranslateOptions>;
        sortDirectionTipDesc: TextTranslator<TranslateOptions>;
        startDate: TextTranslator<TranslateOptions>;
        status: TextTranslator<TranslateOptions>;
        stepNOfCount: TextTranslator<CommonStepNOfCountOptions>;
        subject: TextTranslator<TranslateOptions>;
        submit: TextTranslator<TranslateOptions>;
        tag: TextTranslator<TranslateOptions>;
        tags: TextTranslator<TranslateOptions>;
        templateCategory: TextTranslator<TranslateOptions>;
        termsAndConditions: TextTranslator<TranslateOptions>;
        termsAndConditionsWithSymbol: TextTranslator<TranslateOptions>;
        text: TextTranslator<TranslateOptions>;
        thisDocumentCannotBePreviewed: TextTranslator<TranslateOptions>;
        thisMonth: TextTranslator<TranslateOptions>;
        timePeriod: {
            afternoon: TextTranslator<TranslateOptions>;
            morning: TextTranslator<TranslateOptions>;
        };
        timezone: TextTranslator<TranslateOptions>;
        title: TextTranslator<TranslateOptions>;
        jobTitle: TextTranslator<TranslateOptions>;
        titles: {
            dr: TextTranslator<TranslateOptions>;
            miss: TextTranslator<TranslateOptions>;
            mr: TextTranslator<TranslateOptions>;
            mrs: TextTranslator<TranslateOptions>;
            ms: TextTranslator<TranslateOptions>;
            prof: TextTranslator<TranslateOptions>;
            sir: TextTranslator<TranslateOptions>;
        };
        today: TextTranslator<TranslateOptions>;
        toggleNavigation: TextTranslator<TranslateOptions>;
        tomorrow: TextTranslator<TranslateOptions>;
        tooltips: {
            selectAll: TextTranslator<TranslateOptions>;
        };
        total: TextTranslator<TranslateOptions>;
        type: TextTranslator<TranslateOptions>;
        units: {
            inches: TextTranslator<TranslateOptions>;
            millimeters: TextTranslator<TranslateOptions>;
        };
        unknown: TextTranslator<TranslateOptions>;
        unpublished: TextTranslator<TranslateOptions>;
        unsupportedImageFileType: TextTranslator<CommonUnsupportedImageFileTypeOptions>;
        update: TextTranslator<TranslateOptions>;
        updating: TextTranslator<TranslateOptions>;
        upload: TextTranslator<TranslateOptions>;
        uploadAFile: TextTranslator<TranslateOptions>;
        uploadALogo: TextTranslator<TranslateOptions>;
        uploadAPdf: TextTranslator<TranslateOptions>;
        uploadDeleteConfirm: TextTranslator<TranslateOptions>;
        uploadFiles: TextTranslator<TranslateOptions>;
        url: TextTranslator<TranslateOptions>;
        useDisplayName: TextTranslator<TranslateOptions>;
        user: TextTranslator<TranslateOptions>;
        username: TextTranslator<TranslateOptions>;
        users: TextTranslator<TranslateOptions>;
        validation: {
            invalidDate: TextTranslator<TranslateOptions>;
            invalidEmail: TextTranslator<TranslateOptions>;
            mustConfirmDetailsToContinue: TextTranslator<TranslateOptions>;
            required: TextTranslator<TranslateOptions>;
            stringTooLong: TextTranslator<CommonValidationStringTooLongOptions>;
        };
        video: TextTranslator<TranslateOptions>;
        view: TextTranslator<TranslateOptions>;
        viewMore: TextTranslator<TranslateOptions>;
        visibleToWhich: TextTranslator<TranslateOptions>;
        web: TextTranslator<TranslateOptions>;
        width: TextTranslator<TranslateOptions>;
        yep: TextTranslator<TranslateOptions>;
        yes: TextTranslator<TranslateOptions>;
        yesterday: TextTranslator<TranslateOptions>;
        youCurrentlyHaveNoCollections: TextTranslator<TranslateOptions>;
        yourBrowserDoesNotSupportEmbeddedVideos: TextTranslator<TranslateOptions>;
    };
    components: {
        toggleCollapseCheckbox: TextTranslator<TranslateOptions>;
    };
    dashboard: {
        brandsDashboard: {
            menuItems: {
                activities: TextTranslator<TranslateOptions>;
                agency: TextTranslator<TranslateOptions>;
                agencyBrands: TextTranslator<TranslateOptions>;
                communicate: TextTranslator<TranslateOptions>;
                communicateSend: TextTranslator<TranslateOptions>;
                communicateSendReports: TextTranslator<TranslateOptions>;
                connections: TextTranslator<TranslateOptions>;
                connectionsPlatforms: TextTranslator<TranslateOptions>;
                dashboard: TextTranslator<TranslateOptions>;
                engagement: TextTranslator<TranslateOptions>;
                engagementLocationActivity: TextTranslator<TranslateOptions>;
                engagementOverview: TextTranslator<TranslateOptions>;
                engagementRegionGroupActivity: TextTranslator<TranslateOptions>;
                engagementTemplateUse: TextTranslator<TranslateOptions>;
                learnMenu: TextTranslator<TranslateOptions>;
                manage: TextTranslator<TranslateOptions>;
                manageHashtagSets: TextTranslator<TranslateOptions>;
                manageLearnMenu: TextTranslator<TranslateOptions>;
                manageLocations: TextTranslator<TranslateOptions>;
                manageRegionsGroups: TextTranslator<TranslateOptions>;
                manageUsers: TextTranslator<TranslateOptions>;
                roadmap: TextTranslator<TranslateOptions>;
                style: TextTranslator<TranslateOptions>;
                styleColors: TextTranslator<TranslateOptions>;
                styleFonts: TextTranslator<TranslateOptions>;
                styleStyleGuide: TextTranslator<TranslateOptions>;
                templates: TextTranslator<TranslateOptions>;
                templateCategories: TextTranslator<TranslateOptions>;
            };
        };
        builtPosts: TextTranslator<TranslateOptions>;
        dueInNDays: TextTranslator<DashboardDueInNDaysOptions>;
        dueInNDaysPlural: TextTranslator<DashboardDueInNDaysPluralOptions>;
        dueInNWeeks: TextTranslator<DashboardDueInNWeeksOptions>;
        dueInNWeeksPlural: TextTranslator<DashboardDueInNWeeksPluralOptions>;
        dueToday: TextTranslator<TranslateOptions>;
        dueTomorrow: TextTranslator<TranslateOptions>;
        failedToSetYourLocation: TextTranslator<TranslateOptions>;
        fetchDashboardDetails: TextTranslator<TranslateOptions>;
        fetchLatestWebinar: TextTranslator<TranslateOptions>;
        fetchUpcomingEvents: TextTranslator<TranslateOptions>;
        heroMessage: TextTranslator<TranslateOptions>;
        howAreYouTracking: TextTranslator<TranslateOptions>;
        inNWeeks: TextTranslator<DashboardInNWeeksOptions>;
        inNWeeksPlural: TextTranslator<DashboardInNWeeksPluralOptions>;
        latestWebinar: {
            agencyAdviceForShowingWebinar: TextTranslator<TranslateOptions>;
            moreWebinars: TextTranslator<TranslateOptions>;
            webinar: TextTranslator<TranslateOptions>;
        };
        learnMore: TextTranslator<TranslateOptions>;
        location: TextTranslator<TranslateOptions>;
        noUpcomingEvents: TextTranslator<TranslateOptions>;
        performanceSummary: {
            averageShort: TextTranslator<TranslateOptions>;
            connectAppsToSeePerformance: TextTranslator<DashboardPerformanceSummaryConnectAppsToSeePerformanceOptions>;
            difference: TextTranslator<TranslateOptions>;
            failedToGetPerformanceMetric: TextTranslator<DashboardPerformanceSummaryFailedToGetPerformanceMetricOptions>;
            fetchPerformanceMetrics: TextTranslator<TranslateOptions>;
            fullPerformanceReport: TextTranslator<TranslateOptions>;
            insufficientDataRecorded: TextTranslator<TranslateOptions>;
            insufficientDataRecordedPlural: TextTranslator<DashboardPerformanceSummaryInsufficientDataRecordedPluralOptions>;
            metrics: {
                adwordsConversionValue: TextTranslator<TranslateOptions>;
                adwordsConversions: TextTranslator<TranslateOptions>;
                facebookEngagementClicks: TextTranslator<TranslateOptions>;
                facebookEngagementReach: TextTranslator<TranslateOptions>;
                instagramFollowers: TextTranslator<TranslateOptions>;
                spend: TextTranslator<TranslateOptions>;
                twitterLikes: TextTranslator<TranslateOptions>;
            };
            performanceHeading: TextTranslator<DashboardPerformanceSummaryPerformanceHeadingOptions>;
            serviceNotAuthorised: TextTranslator<TranslateOptions>;
        };
        readyToBuildThese: TextTranslator<TranslateOptions>;
        suggestedTemplates: {
            agencyAdviceForFeaturingTemplates: TextTranslator<TranslateOptions>;
            buildAndScheduleGallery: TextTranslator<TranslateOptions>;
            fetchSuggestedTemplates: TextTranslator<TranslateOptions>;
            suggestedTemplates: TextTranslator<TranslateOptions>;
        };
        upcomingEvents: {
            planCalendar: TextTranslator<TranslateOptions>;
            upcoming: TextTranslator<TranslateOptions>;
        };
        upcomingGeneralEvents: TextTranslator<TranslateOptions>;
        watchVideo: TextTranslator<TranslateOptions>;
        welcomeMessage: TextTranslator<DashboardWelcomeMessageOptions>;
        welcomePage: {
            didYouKnow: TextTranslator<TranslateOptions>;
            numCountries: TextTranslator<DashboardWelcomePageNumCountriesOptions>;
            numLocations: TextTranslator<DashboardWelcomePageNumLocationsOptions>;
            welcomeBack: TextTranslator<TranslateOptions>;
            whatsNew: TextTranslator<TranslateOptions>;
        };
    };
    email: {
        automatedEmailDoNotReply: TextTranslator<TranslateOptions>;
        ifYouWishToUnsubscribe: TextTranslator<TranslateOptions>;
        inviteEmail: {
            buttonText: TextTranslator<TranslateOptions>;
            downloadTheApp: TextTranslator<TranslateOptions>;
            ifThisEmailShouldNotHaveBeenSentToYou: TextTranslator<TranslateOptions>;
            instructions: TextTranslator<TranslateOptions>;
            subject: TextTranslator<TranslateOptions>;
            welcome: TextTranslator<TranslateOptions>;
            whereToGetHelp: TextTranslator<TranslateOptions>;
        };
        linkWillExpire: TextTranslator<EmailLinkWillExpireOptions>;
        linkWillExpireHour: TextTranslator<TranslateOptions>;
        linkWillExpireHourPlural: TextTranslator<EmailLinkWillExpireHourPluralOptions>;
        linkWillExpirePlural: TextTranslator<EmailLinkWillExpirePluralOptions>;
        logInToChangeProfileSettings: TextTranslator<TranslateOptions>;
        logInToRespond: TextTranslator<TranslateOptions>;
        logInToRespondOrViewAttachments: TextTranslator<TranslateOptions>;
        sendToPrint: {
            artworkHasBeenSentTo: TextTranslator<EmailSendToPrintArtworkHasBeenSentToOptions>;
            downloadArtwork: TextTranslator<TranslateOptions>;
            instructions: TextTranslator<TranslateOptions>;
            orderNumber: TextTranslator<TranslateOptions>;
            printProviderDetails: TextTranslator<TranslateOptions>;
            providerWillBeInTouch: TextTranslator<EmailSendToPrintProviderWillBeInTouchOptions>;
            quantity: TextTranslator<TranslateOptions>;
            sku: TextTranslator<TranslateOptions>;
            skuname: TextTranslator<TranslateOptions>;
            subject: TextTranslator<EmailSendToPrintSubjectOptions>;
            subjectOrderNumber: TextTranslator<EmailSendToPrintSubjectOrderNumberOptions>;
            userInvoiceSubject: TextTranslator<EmailSendToPrintUserInvoiceSubjectOptions>;
        };
    };
    errors: {
        assetLibrary: {
            assets: {
                fetchFailed: TextTranslator<TranslateOptions>;
            };
            collections: {
                fetchFailed: TextTranslator<TranslateOptions>;
            };
        };
        badRequestErrors: {
            billingDetailsUpdateAlreadyFinalised: TextTranslator<TranslateOptions>;
            billingDetailsUpdateAlreadyReceived: TextTranslator<TranslateOptions>;
            cannotChangeCollectionType: TextTranslator<TranslateOptions>;
            cannotCreatePrivateComment: TextTranslator<TranslateOptions>;
            cannotLinkAccessToken: TextTranslator<TranslateOptions>;
            cannotOverrideCustomFontFile: TextTranslator<TranslateOptions>;
            clientDoesNotExist: TextTranslator<TranslateOptions>;
            clientIdsDoNotMatch: TextTranslator<TranslateOptions>;
            endDateMustBeBeforeStartDateOrAbsent: TextTranslator<TranslateOptions>;
            facebookMarketingAdAccountInvalidCriteria: TextTranslator<TranslateOptions>;
            fileNameCannotStartWithPipe: TextTranslator<TranslateOptions>;
            invalidDocument: TextTranslator<TranslateOptions>;
            invalidId: TextTranslator<TranslateOptions>;
            invalidSession: TextTranslator<TranslateOptions>;
            invalidUrlToSign: TextTranslator<TranslateOptions>;
            locationAlreadySignedUp: TextTranslator<TranslateOptions>;
            locationSubscriptionExpired: TextTranslator<TranslateOptions>;
            operationRestrictedToSelf: TextTranslator<TranslateOptions>;
            paymentAlreadyFinalised: TextTranslator<TranslateOptions>;
            plannerActionDateBelowThreshold: TextTranslator<ErrorsBadRequestErrorsPlannerActionDateBelowThresholdOptions>;
            plannerActionDateBelowThresholdPlural: TextTranslator<ErrorsBadRequestErrorsPlannerActionDateBelowThresholdPluralOptions>;
            plannerCannotSpecifyAllOrFuture: TextTranslator<TranslateOptions>;
            recurringPaymentCannotBeDeleted: TextTranslator<TranslateOptions>;
            recurringPaymentDatesOverlapWithExisting: TextTranslator<TranslateOptions>;
            recurringPaymentLastCannotBeDeleted: TextTranslator<TranslateOptions>;
            reportSummaryIdInvalid: TextTranslator<TranslateOptions>;
            requestReturnedNoResponseData: TextTranslator<TranslateOptions>;
            scheduledDateCannotBeMoreThanOneYearInTheFuture: TextTranslator<TranslateOptions>;
            sendToFour51MissingData: TextTranslator<TranslateOptions>;
            skuHasBothPriceAndQuantityOptions: TextTranslator<TranslateOptions>;
            skuHasNoPricingData: TextTranslator<TranslateOptions>;
            specialRequestInvalidDate: TextTranslator<TranslateOptions>;
            userBelongsToMultipleAgencies: TextTranslator<TranslateOptions>;
            userNotFound: TextTranslator<TranslateOptions>;
            validationError: TextTranslator<ErrorsBadRequestErrorsValidationErrorOptions>;
            videoIdNotFound: TextTranslator<TranslateOptions>;
        };
        brand: {
            brandColours: {
                errorAddingBrandColour: TextTranslator<ErrorsBrandBrandColoursErrorAddingBrandColourOptions>;
                errorDeletingBrandColour: TextTranslator<ErrorsBrandBrandColoursErrorDeletingBrandColourOptions>;
                errorRenamingBrandColour: TextTranslator<ErrorsBrandBrandColoursErrorRenamingBrandColourOptions>;
                errorUpdatingBrandColour: TextTranslator<ErrorsBrandBrandColoursErrorUpdatingBrandColourOptions>;
                errorUpdatingBrandColourOrder: TextTranslator<TranslateOptions>;
            };
            locationCategories: {
                categoryLabelRequired: TextTranslator<TranslateOptions>;
                errorAddingLocationCategory: TextTranslator<ErrorsBrandLocationCategoriesErrorAddingLocationCategoryOptions>;
                errorDeletingLocationCategory: TextTranslator<ErrorsBrandLocationCategoriesErrorDeletingLocationCategoryOptions>;
                errorRenamingLocationCategory: TextTranslator<ErrorsBrandLocationCategoriesErrorRenamingLocationCategoryOptions>;
                errorUpdatingLocationsForCategory: TextTranslator<ErrorsBrandLocationCategoriesErrorUpdatingLocationsForCategoryOptions>;
            };
            noClientSelected: TextTranslator<TranslateOptions>;
        };
        exceptionId: TextTranslator<ErrorsExceptionIdOptions>;
        externalServiceErrors: {
            acrCloud: TextTranslator<ErrorsExternalServiceErrorsAcrCloudOptions>;
            acrCloudEmptyResponse: TextTranslator<TranslateOptions>;
            emailFailure: TextTranslator<ErrorsExternalServiceErrorsEmailFailureOptions>;
            ewayError: TextTranslator<ErrorsExternalServiceErrorsEwayErrorOptions>;
            fitwareError: TextTranslator<TranslateOptions>;
            fitwareUnrecognisedResponse: TextTranslator<TranslateOptions>;
            passthrough: TextTranslator<ErrorsExternalServiceErrorsPassthroughOptions>;
            twitterError: TextTranslator<ErrorsExternalServiceErrorsTwitterErrorOptions>;
            twitterUnknownError: TextTranslator<ErrorsExternalServiceErrorsTwitterUnknownErrorOptions>;
        };
        facebookErrors: {
            maxCharacterLimitForCaptionReached: TextTranslator<TranslateOptions>;
            missingFirstCommentHashtagsPermission: TextTranslator<TranslateOptions>;
            someLocationsAreMissingFirstCommentHashtagsPermission: TextTranslator<TranslateOptions>;
            untranslatedErrorMessage: TextTranslator<ErrorsFacebookErrorsUntranslatedErrorMessageOptions>;
        };
        facebookMarketingErrors: {
            permissionsNotGranted: TextTranslator<TranslateOptions>;
        };
        finaliseBillingDetailsUpdateError: TextTranslator<ErrorsFinaliseBillingDetailsUpdateErrorOptions>;
        fitwareMemberEngager: {
            unrecognisedResponse: TextTranslator<TranslateOptions>;
            untranslatedErrorMessage: TextTranslator<ErrorsFitwareMemberEngagerUntranslatedErrorMessageOptions>;
        };
        forbiddenErrors: {
            accessForbidden: TextTranslator<TranslateOptions>;
            cannotAccessClient: TextTranslator<TranslateOptions>;
            cannotAccessLocation: TextTranslator<TranslateOptions>;
            noPermissionToViewClient: TextTranslator<TranslateOptions>;
            tryThisMustBeAssignedToAClient: TextTranslator<TranslateOptions>;
        };
        four51: {
            invalidQuantity: TextTranslator<TranslateOptions>;
            invalidUsernameOrPassword: TextTranslator<TranslateOptions>;
            productMisconfigured: TextTranslator<ErrorsFour51ProductMisconfiguredOptions>;
            unrecognisedResponse: TextTranslator<TranslateOptions>;
            untranslatedErrorMessage: TextTranslator<ErrorsFour51UntranslatedErrorMessageOptions>;
        };
        generateMapErrors: {
            failed: TextTranslator<TranslateOptions>;
            mapAlreadyExists: TextTranslator<TranslateOptions>;
            noMapForLocation: TextTranslator<TranslateOptions>;
            paymentFailed: TextTranslator<TranslateOptions>;
        };
        generic: TextTranslator<TranslateOptions>;
        googleAds: {
            permissions: TextTranslator<TranslateOptions>;
            permissionsLocationReport: TextTranslator<TranslateOptions>;
            unknown: TextTranslator<TranslateOptions>;
        };
        googleAnalytics: {
            permissions: TextTranslator<TranslateOptions>;
            dataParseError: TextTranslator<TranslateOptions>;
            dataResponseError: TextTranslator<TranslateOptions>;
        };
        googleMyBusiness: {
            failedToPost: TextTranslator<TranslateOptions>;
            failedToRetrieveLocationName: TextTranslator<TranslateOptions>;
            serviceNotConfigured: TextTranslator<TranslateOptions>;
        };
        googleOauthErrors: {
            invalidGrant: TextTranslator<TranslateOptions>;
        };
        instagramErrors: {
            apiRateLimitNotFound: TextTranslator<TranslateOptions>;
            apiRateLimited: TextTranslator<TranslateOptions>;
            apiRateLimitedContinuePosting: TextTranslator<TranslateOptions>;
            failedToPost: TextTranslator<TranslateOptions>;
            maxCharacterLimitForCaptionReached: TextTranslator<TranslateOptions>;
            missingFirstCommentHashtagsPermission: TextTranslator<TranslateOptions>;
            someLocationsAreMissingFirstCommentHashtagsPermission: TextTranslator<TranslateOptions>;
            untranslatedErrorMessage: TextTranslator<ErrorsInstagramErrorsUntranslatedErrorMessageOptions>;
        };
        invalidInputErrors: {
            base64StringMissingMimeType: TextTranslator<TranslateOptions>;
            colour: TextTranslator<ErrorsInvalidInputErrorsColourOptions>;
            ewayMultiplePaymentTransactions: TextTranslator<TranslateOptions>;
            ewayMultipleTokenisationTransactions: TextTranslator<TranslateOptions>;
            ewayMultipleTransactions: TextTranslator<TranslateOptions>;
            ewayZeroPaymentTransactions: TextTranslator<TranslateOptions>;
            ewayZeroTransactions: TextTranslator<TranslateOptions>;
            facebookPageIdMigration: TextTranslator<ErrorsInvalidInputErrorsFacebookPageIdMigrationOptions>;
            fileTooLarge: TextTranslator<TranslateOptions>;
            graphqlInput: TextTranslator<ErrorsInvalidInputErrorsGraphqlInputOptions>;
            invalidUrl: TextTranslator<TranslateOptions>;
            missingFile: TextTranslator<TranslateOptions>;
            repositoryHasNullModel: TextTranslator<TranslateOptions>;
            uploadIdMissing: TextTranslator<TranslateOptions>;
            zeroWidthOrHeightVideo: TextTranslator<TranslateOptions>;
        };
        linkedin: {
            failedToPost: TextTranslator<TranslateOptions>;
            invalidGrant: TextTranslator<TranslateOptions>;
            serviceNotConfigured: TextTranslator<TranslateOptions>;
        };
        locationDraft: {
            cannotSaveLocationRevisionWithoutATitle: TextTranslator<TranslateOptions>;
            failedToSave: TextTranslator<TranslateOptions>;
        };
        loginTokenErrors: {
            apiKeyInvalid: TextTranslator<TranslateOptions>;
            apiKeyMissing: TextTranslator<TranslateOptions>;
            tokenKeysMismatch: TextTranslator<TranslateOptions>;
            tokenReferenceNotFound: TextTranslator<TranslateOptions>;
            userNotFound: TextTranslator<TranslateOptions>;
            usernameNotSpecified: TextTranslator<TranslateOptions>;
        };
        missingValueErrors: {
            facebookAdSetMissingEndDate: TextTranslator<ErrorsMissingValueErrorsFacebookAdSetMissingEndDateOptions>;
            facebookAdSetMissingStartDate: TextTranslator<ErrorsMissingValueErrorsFacebookAdSetMissingStartDateOptions>;
            gatherStatsErrorHandlerMissingLocationId: TextTranslator<TranslateOptions>;
            replacementValueForLocalResource: TextTranslator<ErrorsMissingValueErrorsReplacementValueForLocalResourceOptions>;
        };
        multipleErrors: TextTranslator<TranslateOptions>;
        noNetworkConnectionError: TextTranslator<TranslateOptions>;
        noStatsDataErrors: {
            googleAdwordsZeroValues: TextTranslator<TranslateOptions>;
            noStatsForDateRange: TextTranslator<TranslateOptions>;
            noStatsForGivenPeriod: TextTranslator<TranslateOptions>;
        };
        notFoundErrors: {
            agencyLocaleNotFoundWithId: TextTranslator<ErrorsNotFoundErrorsAgencyLocaleNotFoundWithIdOptions>;
            entityNotFound: TextTranslator<TranslateOptions>;
            entityNotFoundWithId: TextTranslator<ErrorsNotFoundErrorsEntityNotFoundWithIdOptions>;
            entityNotFoundWithToken: TextTranslator<ErrorsNotFoundErrorsEntityNotFoundWithTokenOptions>;
            entityToDeleteNotFound: TextTranslator<ErrorsNotFoundErrorsEntityToDeleteNotFoundOptions>;
            entityToUpdateNotFound: TextTranslator<ErrorsNotFoundErrorsEntityToUpdateNotFoundOptions>;
            googleAdwordsGetReportDefinitionNoAccessToken: TextTranslator<TranslateOptions>;
            noFacebookAccessTokenForLocation: TextTranslator<ErrorsNotFoundErrorsNoFacebookAccessTokenForLocationOptions>;
            noMatchingEmail: TextTranslator<TranslateOptions>;
            resourceNotFound: TextTranslator<TranslateOptions>;
            userDoesNotBelongToAnyAgencies: TextTranslator<TranslateOptions>;
            userNotFound: TextTranslator<TranslateOptions>;
            userNotFoundWithId: TextTranslator<ErrorsNotFoundErrorsUserNotFoundWithIdOptions>;
        };
        oauthErrors: {
            authorisationDenied: TextTranslator<TranslateOptions>;
            callbackConfirmationFailed: TextTranslator<TranslateOptions>;
            noOauthToken: TextTranslator<TranslateOptions>;
            tokenDoesNotMatch: TextTranslator<TranslateOptions>;
            unknownGrantType: TextTranslator<ErrorsOauthErrorsUnknownGrantTypeOptions>;
        };
        parsingErrors: {
            four51AuthToken: TextTranslator<TranslateOptions>;
            parsingError: TextTranslator<TranslateOptions>;
        };
        publish: {
            errors: {
                accessTokenHasExpired: TextTranslator<ErrorsPublishErrorsAccessTokenHasExpiredOptions>;
                duplicatePostsDetected: TextTranslator<ErrorsPublishErrorsDuplicatePostsDetectedOptions>;
                failedToPublishToLocation: TextTranslator<ErrorsPublishErrorsFailedToPublishToLocationOptions>;
                genericErrorMessage: TextTranslator<TranslateOptions>;
                instagramCarouselPostRequirementsNotMet: TextTranslator<TranslateOptions>;
                instagramMediaDownloadTimeout: TextTranslator<TranslateOptions>;
                instagramSuspectedSpam: TextTranslator<TranslateOptions>;
                instagramTagCountReached: TextTranslator<TranslateOptions>;
                notShownMissingFromList: TextTranslator<TranslateOptions>;
                permissionsNotGranted: TextTranslator<ErrorsPublishErrorsPermissionsNotGrantedOptions>;
                serviceInvalidAspectRatio: TextTranslator<ErrorsPublishErrorsServiceInvalidAspectRatioOptions>;
                serviceInvalidScheduleDate: TextTranslator<ErrorsPublishErrorsServiceInvalidScheduleDateOptions>;
                serviceMaximumCaptionLengthExceeded: TextTranslator<ErrorsPublishErrorsServiceMaximumCaptionLengthExceededOptions>;
                serviceMaximumMediaSizeExceeded: TextTranslator<ErrorsPublishErrorsServiceMaximumMediaSizeExceededOptions>;
                serviceMaximumPublishCountReached: TextTranslator<ErrorsPublishErrorsServiceMaximumPublishCountReachedOptions>;
                unsupportedFileFormat: TextTranslator<ErrorsPublishErrorsUnsupportedFileFormatOptions>;
                userCredentialsChanged: TextTranslator<ErrorsPublishErrorsUserCredentialsChangedOptions>;
                userInterventionRequired: TextTranslator<ErrorsPublishErrorsUserInterventionRequiredOptions>;
            };
            invalidLocationNodeId: TextTranslator<TranslateOptions>;
            oneOrMoreArtifactIdsAreInvalid: TextTranslator<TranslateOptions>;
            schedulingStatusErrors: {
                unknown: TextTranslator<TranslateOptions>;
            };
        };
        requestTokenErrors: {
            apiKeyInvalid: TextTranslator<TranslateOptions>;
            apiKeyNotSpecified: TextTranslator<TranslateOptions>;
            issuerNotSpecified: TextTranslator<TranslateOptions>;
            tokenInvalid: TextTranslator<TranslateOptions>;
        };
        scheduling: {
            delete: {
                tooCloseToScheduledTime: TextTranslator<TranslateOptions>;
                unknown: TextTranslator<TranslateOptions>;
            };
            reschedule: {
                tooCloseToScheduledTime: TextTranslator<TranslateOptions>;
                unknown: TextTranslator<TranslateOptions>;
            };
        };
        sendgrid: {
            couldNotFindUnsubGroup: TextTranslator<TranslateOptions>;
            deleteEmailError: TextTranslator<TranslateOptions>;
            rescheduleEmailError: TextTranslator<TranslateOptions>;
            singleSendFailed: TextTranslator<TranslateOptions>;
            singleSendFailedNoId: TextTranslator<TranslateOptions>;
            wait30Mins: TextTranslator<TranslateOptions>;
        };
        serviceAccessErrors: {
            accessExpiredOrForbidden: TextTranslator<TranslateOptions>;
            accessExpiredOrForbiddenWithDetails: TextTranslator<ErrorsServiceAccessErrorsAccessExpiredOrForbiddenWithDetailsOptions>;
            facebookAccountCannotAccessPage: TextTranslator<ErrorsServiceAccessErrorsFacebookAccountCannotAccessPageOptions>;
            facebookPageTokenNotReturned: TextTranslator<TranslateOptions>;
        };
        serviceAuthenticationErrors: {
            failedToAuthorise: TextTranslator<TranslateOptions>;
        };
        serviceConfigurationErrors: {
            clientMissingFitwareBusiness: TextTranslator<TranslateOptions>;
            facebookPageNotConfigured: TextTranslator<TranslateOptions>;
            fitwareClientConfigMissing: TextTranslator<TranslateOptions>;
            fitwareMemberEngagerClubMissing: TextTranslator<TranslateOptions>;
            fitwareMissingData: TextTranslator<TranslateOptions>;
            four51CredentialsMissing: TextTranslator<TranslateOptions>;
            four51StoreCompanyOrSsoKeyMissing: TextTranslator<TranslateOptions>;
            googleAdwordsCampaignNameNotConfigured: TextTranslator<TranslateOptions>;
            googleAdwordsCustomerNotConfigured: TextTranslator<TranslateOptions>;
            googleAdwordsNotConnected: TextTranslator<TranslateOptions>;
            googleAnalyticsPagePathMissing: TextTranslator<TranslateOptions>;
            googleAnalyticsViewIdMissing: TextTranslator<TranslateOptions>;
            locationMissingFacebookPageId: TextTranslator<TranslateOptions>;
            locationMissingFitwareClubNumber: TextTranslator<ErrorsServiceConfigurationErrorsLocationMissingFitwareClubNumberOptions>;
            locationMissingInstagramPageId: TextTranslator<TranslateOptions>;
            serviceNotConfigured: TextTranslator<ErrorsServiceConfigurationErrorsServiceNotConfiguredOptions>;
        };
        serviceCredentialsMissingErrors: {
            noAuthenticationForService: TextTranslator<ErrorsServiceCredentialsMissingErrorsNoAuthenticationForServiceOptions>;
        };
        serviceDisabledForClient: TextTranslator<TranslateOptions>;
        serviceRateLimitError: TextTranslator<TranslateOptions>;
        stripe: {
            unrecognisedResponse: TextTranslator<TranslateOptions>;
            untranslatedErrorMessage: TextTranslator<ErrorsStripeUntranslatedErrorMessageOptions>;
        };
        templateCannotBeDownloadedNoPermission: TextTranslator<TranslateOptions>;
        unauthorizedErrors: {
            pleaseLogin: TextTranslator<TranslateOptions>;
            resource: TextTranslator<TranslateOptions>;
        };
        unexpectedError: TextTranslator<TranslateOptions>;
        unexpectedInputErrors: {
            facebookPageMigrationIdsNotFound: TextTranslator<ErrorsUnexpectedInputErrorsFacebookPageMigrationIdsNotFoundOptions>;
        };
        unsupportedCurrency: TextTranslator<ErrorsUnsupportedCurrencyOptions>;
        unsupportedOperationErrors: {
            accessTokenCannotDetermineAffectedTargetName: TextTranslator<ErrorsUnsupportedOperationErrorsAccessTokenCannotDetermineAffectedTargetNameOptions>;
            assignedLocationMapperGivenMultipleLocations: TextTranslator<TranslateOptions>;
            bannerNotificationAlreadyExists: TextTranslator<TranslateOptions>;
            controllerMissingValidation: TextTranslator<TranslateOptions>;
            facebookApiClientInstanitatedWithoutAFacebookPageId: TextTranslator<TranslateOptions>;
            facebookMarketingApiClientInstanitatedWithoutAFacebookPageId: TextTranslator<TranslateOptions>;
            imageFormatConversion: TextTranslator<ErrorsUnsupportedOperationErrorsImageFormatConversionOptions>;
            monthlyRecurringEventsOnly: TextTranslator<TranslateOptions>;
            plannerOperationNotSupported: TextTranslator<ErrorsUnsupportedOperationErrorsPlannerOperationNotSupportedOptions>;
            printProviderSkuMissingQuantityOptions: TextTranslator<TranslateOptions>;
            socketServerAlreadyReady: TextTranslator<TranslateOptions>;
            unsupportedWindowsTimezone: TextTranslator<ErrorsUnsupportedOperationErrorsUnsupportedWindowsTimezoneOptions>;
        };
        videoImport: {
            networkError: TextTranslator<TranslateOptions>;
            unknownError: TextTranslator<TranslateOptions>;
            unsupportedFileType: TextTranslator<TranslateOptions>;
            unsupportedVideoType: TextTranslator<TranslateOptions>;
        };
        videoPreviewUnsupported: TextTranslator<TranslateOptions>;
    };
    footer: {
        privacyPolicy: TextTranslator<TranslateOptions>;
        termsAndConditions: TextTranslator<TranslateOptions>;
    };
    help: {
        builderKeyboardShortcuts: {
            alignment: {
                multipleCenterHorizontal: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                multipleCenterVertical: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                multipleLeftRight: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                multipleTopBottom: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                singleCenterHorizontal: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                singleCenterVertical: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                singleLeftRight: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                singleTopBottom: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                title: TextTranslator<TranslateOptions>;
            };
            general: {
                delete: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                duplicate: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                multiSelect: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                redo: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                title: TextTranslator<TranslateOptions>;
                undo: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
            };
            movement: {
                arrowLeftRight: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                arrowLeftRightModifier: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                arrowUpDown: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                arrowUpDownModifier: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                horizontalLock: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
                title: TextTranslator<TranslateOptions>;
                verticalLock: {
                    description: TextTranslator<TranslateOptions>;
                    mac: TextTranslator<TranslateOptions>;
                    windows: TextTranslator<TranslateOptions>;
                };
            };
            multipleLayersSelected: TextTranslator<TranslateOptions>;
            shortcutMac: TextTranslator<TranslateOptions>;
            shortcutWindows: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        common: {
            whatCanIDo: TextTranslator<TranslateOptions>;
            whatDoesThisMean: TextTranslator<TranslateOptions>;
            whyAmISeeingThis: TextTranslator<TranslateOptions>;
        };
        help: TextTranslator<TranslateOptions>;
        noAssignedLocations: {
            cantUseDigitalStack: TextTranslator<TranslateOptions>;
            contactYourAgency: TextTranslator<TranslateOptions>;
            dontHaveLocationsAssigned: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
    };
    integration: {
        auth: {
            apiKey: {
                apiKey: TextTranslator<TranslateOptions>;
                apiKeyRequired: TextTranslator<TranslateOptions>;
                apiKeyRequiredExplain: TextTranslator<TranslateOptions>;
                previousKey: TextTranslator<IntegrationAuthApiKeyPreviousKeyOptions>;
                previousKeyExplain: TextTranslator<TranslateOptions>;
            };
        };
        client: {
            clubReady: {
                chainId: TextTranslator<TranslateOptions>;
                enterChainId: TextTranslator<TranslateOptions>;
                enterChainIdWithClientTitle: TextTranslator<IntegrationClientClubReadyEnterChainIdWithClientTitleOptions>;
                enterChainIdExplain: TextTranslator<TranslateOptions>;
                multipleChainExplain: TextTranslator<TranslateOptions>;
            };
            notifier: {
                issueWithAccount: TextTranslator<TranslateOptions>;
                resolution1: TextTranslator<TranslateOptions>;
                resolution2: TextTranslator<TranslateOptions>;
            };
            statusTip: {
                disable: TextTranslator<TranslateOptions>;
                edit: TextTranslator<TranslateOptions>;
                enable: TextTranslator<TranslateOptions>;
            };
        };
        configureIntegration: TextTranslator<IntegrationConfigureIntegrationOptions>;
        disableFor: TextTranslator<IntegrationDisableForOptions>;
        disabledIntegration: TextTranslator<IntegrationDisabledIntegrationOptions>;
        editAccountConfiguration: TextTranslator<TranslateOptions>;
        enableFor: TextTranslator<IntegrationEnableForOptions>;
        enabledIntegration: TextTranslator<IntegrationEnabledIntegrationOptions>;
        errors: {
            genericEnableError: TextTranslator<TranslateOptions>;
        };
        fitware: {
            notifyBusinessCleared: TextTranslator<TranslateOptions>;
            notifyBusinessSet: TextTranslator<TranslateOptions>;
            notifyClubUpdated: TextTranslator<TranslateOptions>;
        };
        integrationConfiguration: TextTranslator<IntegrationIntegrationConfigurationOptions>;
        integrations: TextTranslator<TranslateOptions>;
        location: {
            clubReady: {
                clubId: TextTranslator<TranslateOptions>;
                clubReadyConfiguration: TextTranslator<TranslateOptions>;
                configureSuccess: TextTranslator<TranslateOptions>;
                enterClubId: TextTranslator<TranslateOptions>;
            };
            noIntegrationsToConfigure: {
                explain: TextTranslator<TranslateOptions>;
                resolve: TextTranslator<TranslateOptions>;
            };
        };
        notifyAccessCheckFailed: TextTranslator<IntegrationNotifyAccessCheckFailedOptions>;
        notifyCouldNotAuthorizeService: TextTranslator<IntegrationNotifyCouldNotAuthorizeServiceOptions>;
        notifyCouldNotDeauthorizeService: TextTranslator<IntegrationNotifyCouldNotDeauthorizeServiceOptions>;
        notifyServiceDeauthorized: TextTranslator<IntegrationNotifyServiceDeauthorizedOptions>;
        promptConnectToGoogleAdsDialog: {
            promptText: TextTranslator<TranslateOptions>;
            signInText: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        setupIntegrationsFor: TextTranslator<IntegrationSetupIntegrationsForOptions>;
    };
    intro: {
        account: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        alreadyKnowHowThisWorks: TextTranslator<TranslateOptions>;
        apps: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        build: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                five: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        three: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
                four: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        three: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
                three: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        cancelTourMessage: TextTranslator<TranslateOptions>;
        cancelTourTitle: TextTranslator<TranslateOptions>;
        completeTheTour: TextTranslator<TranslateOptions>;
        completeTheseItemsLater: TextTranslator<TranslateOptions>;
        completedAllTheItems: TextTranslator<TranslateOptions>;
        congratulations: TextTranslator<TranslateOptions>;
        doneLabel: TextTranslator<TranslateOptions>;
        examplePlannerTitle: TextTranslator<TranslateOptions>;
        exampleTemplateTitle: TextTranslator<TranslateOptions>;
        findOutWhat: TextTranslator<TranslateOptions>;
        helpUsMake: TextTranslator<TranslateOptions>;
        imReady: TextTranslator<TranslateOptions>;
        itLooksLikeYoureNew: TextTranslator<TranslateOptions>;
        learn: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        letMeDoItSomeMore: TextTranslator<TranslateOptions>;
        letsContinue: TextTranslator<TranslateOptions>;
        mostPeopleAreSurprised: TextTranslator<TranslateOptions>;
        notifyPostponeTour: TextTranslator<TranslateOptions>;
        notifyStopTour: TextTranslator<TranslateOptions>;
        okThatMakesSense: TextTranslator<TranslateOptions>;
        plan: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                three: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        five: TextTranslator<TranslateOptions>;
                        four: TextTranslator<TranslateOptions>;
                        one: TextTranslator<TranslateOptions>;
                        seven: TextTranslator<TranslateOptions>;
                        six: TextTranslator<TranslateOptions>;
                        three: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        eight: TextTranslator<TranslateOptions>;
                        five: TextTranslator<TranslateOptions>;
                        four: TextTranslator<TranslateOptions>;
                        one: TextTranslator<TranslateOptions>;
                        seven: TextTranslator<TranslateOptions>;
                        six: TextTranslator<TranslateOptions>;
                        three: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        pleaseAcceptThis: TextTranslator<TranslateOptions>;
        quickTip: TextTranslator<TranslateOptions>;
        report: {
            complete: {
                heading: TextTranslator<TranslateOptions>;
                subheading: TextTranslator<TranslateOptions>;
                tip: TextTranslator<TranslateOptions>;
            };
            page: {
                one: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        one: TextTranslator<TranslateOptions>;
                    };
                };
                two: {
                    doneLabel: TextTranslator<TranslateOptions>;
                    step: {
                        four: TextTranslator<TranslateOptions>;
                        one: TextTranslator<TranslateOptions>;
                        three: TextTranslator<TranslateOptions>;
                        two: TextTranslator<TranslateOptions>;
                    };
                };
            };
            title: TextTranslator<TranslateOptions>;
        };
        resetAll: TextTranslator<TranslateOptions>;
        showMe: TextTranslator<TranslateOptions>;
        showMeCompleted: TextTranslator<TranslateOptions>;
        skipLabel: TextTranslator<TranslateOptions>;
        tickOffTheItemsBelow: TextTranslator<TranslateOptions>;
        video: {
            title: TextTranslator<TranslateOptions>;
        };
        welcomeToDigitalStack: TextTranslator<IntroWelcomeToDigitalStackOptions>;
        youreReadyForTheStack: TextTranslator<TranslateOptions>;
        youveGotThroughThemAll: TextTranslator<TranslateOptions>;
    };
    learn: {
        addNewItem: TextTranslator<TranslateOptions>;
        addNewLearnItem: TextTranslator<TranslateOptions>;
        applicationWide: TextTranslator<TranslateOptions>;
        deleteConfirm: TextTranslator<LearnDeleteConfirmOptions>;
        editItem: TextTranslator<TranslateOptions>;
        editLearnItem: TextTranslator<TranslateOptions>;
        email: {
            commentAddedToLearnArticle: TextTranslator<LearnEmailCommentAddedToLearnArticleOptions>;
            viewLearnArticle: TextTranslator<TranslateOptions>;
        };
        helpful: TextTranslator<TranslateOptions>;
        loading: TextTranslator<TranslateOptions>;
        maxUploadError: TextTranslator<TranslateOptions>;
        noArticles: TextTranslator<TranslateOptions>;
        noLearnAvailable: TextTranslator<TranslateOptions>;
        notifyLearnCreated: TextTranslator<LearnNotifyLearnCreatedOptions>;
        notifyLearnUpdated: TextTranslator<LearnNotifyLearnUpdatedOptions>;
        recentArticles: TextTranslator<TranslateOptions>;
        retrieveAllLearnArticles: TextTranslator<TranslateOptions>;
        retrieveMoreLearnArticles: TextTranslator<TranslateOptions>;
        tagName: TextTranslator<TranslateOptions>;
        thanksFeedback: TextTranslator<TranslateOptions>;
        thumbnail: {
            createVideoThumbnail: TextTranslator<TranslateOptions>;
            generateFromVideo: TextTranslator<TranslateOptions>;
            sliderHelp: TextTranslator<TranslateOptions>;
            uploadCustom: TextTranslator<TranslateOptions>;
            uploadNewThumbnail: TextTranslator<TranslateOptions>;
        };
        tryThisDeleted: TextTranslator<TranslateOptions>;
    };
    login: {
        email: {
            invite: {
                clickButtonToLogIn: TextTranslator<TranslateOptions>;
                logIntoDigitalStack: TextTranslator<TranslateOptions>;
                youHaveBeenInvited: TextTranslator<TranslateOptions>;
            };
            resetPassword: {
                ifYouDidNotRequestThis: TextTranslator<TranslateOptions>;
                passwordResetInstructions: TextTranslator<TranslateOptions>;
                resetMyPassword: TextTranslator<TranslateOptions>;
                someoneRequestedToResetPassword: TextTranslator<TranslateOptions>;
                toResetClickLink: TextTranslator<TranslateOptions>;
            };
            welcomeToDigitalStack: TextTranslator<TranslateOptions>;
        };
        errorSendingPasswordResetInstructions: TextTranslator<TranslateOptions>;
        forgotPassword: TextTranslator<TranslateOptions>;
        forgottenPassword: TextTranslator<TranslateOptions>;
        invalidEmailAddress: TextTranslator<TranslateOptions>;
        login: TextTranslator<TranslateOptions>;
        loginConfirmIdentity: TextTranslator<TranslateOptions>;
        loginToLinkAccounts: TextTranslator<TranslateOptions>;
        password: TextTranslator<TranslateOptions>;
        passwordAgain: TextTranslator<TranslateOptions>;
        passwordResetFailed: TextTranslator<TranslateOptions>;
        passwordResetInstructions: TextTranslator<TranslateOptions>;
        passwordResetInstructionsSent: TextTranslator<TranslateOptions>;
        passwordResetPleaseLogin: TextTranslator<TranslateOptions>;
        passwordTooShort: TextTranslator<LoginPasswordTooShortOptions>;
        passwordTooShortPlural: TextTranslator<LoginPasswordTooShortPluralOptions>;
        passwordsDontMatch: TextTranslator<TranslateOptions>;
        problemWithInviteLink: TextTranslator<TranslateOptions>;
        problemWithLink: TextTranslator<TranslateOptions>;
        requestPasswordReset: TextTranslator<TranslateOptions>;
        resetPassword: TextTranslator<TranslateOptions>;
        sendPasswordReset: TextTranslator<TranslateOptions>;
        sendPasswordResetEmailConfirmationModal: {
            body: TextTranslator<TranslateOptions>;
        };
        signedInAs: TextTranslator<LoginSignedInAsOptions>;
        signedOut: TextTranslator<TranslateOptions>;
        username: TextTranslator<TranslateOptions>;
        usernamePasswordIncorrectError: TextTranslator<TranslateOptions>;
        welcomeToDigitalStack: TextTranslator<TranslateOptions>;
        youWillReceivePasswordResetInstructionsShortly: TextTranslator<TranslateOptions>;
    };
    marketing: {
        emails: {
            weeklyMarketingUpdate: {
                completeMyMonthPlanner: TextTranslator<MarketingEmailsWeeklyMarketingUpdateCompleteMyMonthPlannerOptions>;
                countActivitiesAwaitingContent: TextTranslator<MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentOptions>;
                countActivitiesAwaitingContentPlural: TextTranslator<MarketingEmailsWeeklyMarketingUpdateCountActivitiesAwaitingContentPluralOptions>;
                countActivitiesPlanned: TextTranslator<MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedOptions>;
                countActivitiesPlannedPlural: TextTranslator<MarketingEmailsWeeklyMarketingUpdateCountActivitiesPlannedPluralOptions>;
                findYourUpdateBelow: TextTranslator<MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowOptions>;
                findYourUpdateBelowMultipleLocations: TextTranslator<MarketingEmailsWeeklyMarketingUpdateFindYourUpdateBelowMultipleLocationsOptions>;
                getOnTopOfYourPlanningForMonth: TextTranslator<MarketingEmailsWeeklyMarketingUpdateGetOnTopOfYourPlanningForMonthOptions>;
                locationForMonth: TextTranslator<MarketingEmailsWeeklyMarketingUpdateLocationForMonthOptions>;
                noActivitiesPlanned: TextTranslator<TranslateOptions>;
                viewMyMonthPlanner: TextTranslator<MarketingEmailsWeeklyMarketingUpdateViewMyMonthPlannerOptions>;
                weeklyMarketingUpdate: TextTranslator<TranslateOptions>;
                whatsOnThisWeekAtLocation: TextTranslator<MarketingEmailsWeeklyMarketingUpdateWhatsOnThisWeekAtLocationOptions>;
                yourWeeklyUpdate: TextTranslator<MarketingEmailsWeeklyMarketingUpdateYourWeeklyUpdateOptions>;
            };
        };
    };
    menu: {
        account: TextTranslator<TranslateOptions>;
        admin: TextTranslator<TranslateOptions>;
        agencies: TextTranslator<TranslateOptions>;
        agency: TextTranslator<TranslateOptions>;
        assets: TextTranslator<TranslateOptions>;
        brand: TextTranslator<TranslateOptions>;
        brands: TextTranslator<TranslateOptions>;
        brandSettings: TextTranslator<TranslateOptions>;
        build: TextTranslator<TranslateOptions>;
        calendar: TextTranslator<TranslateOptions>;
        calendarActivities: TextTranslator<TranslateOptions>;
        clients: TextTranslator<TranslateOptions>;
        closeNavigation: TextTranslator<TranslateOptions>;
        colors: TextTranslator<TranslateOptions>;
        communicate: TextTranslator<TranslateOptions>;
        connect: TextTranslator<TranslateOptions>;
        connections: TextTranslator<TranslateOptions>;
        fonts: TextTranslator<TranslateOptions>;
        hashtagSets: TextTranslator<TranslateOptions>;
        help: TextTranslator<TranslateOptions>;
        integrations: TextTranslator<TranslateOptions>;
        learn: TextTranslator<TranslateOptions>;
        learnMenu: TextTranslator<TranslateOptions>;
        location: TextTranslator<TranslateOptions>;
        locations: TextTranslator<TranslateOptions>;
        locationActivity: TextTranslator<TranslateOptions>;
        locationDetails: TextTranslator<TranslateOptions>;
        locationUsers: TextTranslator<TranslateOptions>;
        mainNavigation: TextTranslator<TranslateOptions>;
        markAllAsRead: TextTranslator<TranslateOptions>;
        more: TextTranslator<TranslateOptions>;
        notifications: TextTranslator<TranslateOptions>;
        notificationCouldNotBeMarkedAsRead: TextTranslator<TranslateOptions>;
        openNavigation: TextTranslator<TranslateOptions>;
        overview: TextTranslator<TranslateOptions>;
        payments: TextTranslator<TranslateOptions>;
        performance: TextTranslator<TranslateOptions>;
        plan: TextTranslator<TranslateOptions>;
        platforms: TextTranslator<TranslateOptions>;
        profile: TextTranslator<TranslateOptions>;
        regionsGroups: TextTranslator<TranslateOptions>;
        regionGroupActivity: TextTranslator<TranslateOptions>;
        report: TextTranslator<TranslateOptions>;
        reporting: TextTranslator<TranslateOptions>;
        requests: TextTranslator<TranslateOptions>;
        roadmap: TextTranslator<TranslateOptions>;
        scheduled: TextTranslator<TranslateOptions>;
        send: TextTranslator<TranslateOptions>;
        signOut: TextTranslator<TranslateOptions>;
        specialRequests: TextTranslator<TranslateOptions>;
        styles: TextTranslator<TranslateOptions>;
        styleGuide: TextTranslator<TranslateOptions>;
        templates: TextTranslator<TranslateOptions>;
        templateCategories: TextTranslator<TranslateOptions>;
        templateUse: TextTranslator<TranslateOptions>;
        viewAllNotifications: TextTranslator<TranslateOptions>;
        youHaveNoUnreadNotifications: TextTranslator<TranslateOptions>;
    };
    notifications: {
        badger: {
            markAllAsRead: TextTranslator<TranslateOptions>;
            noUnreadNotifications: TextTranslator<TranslateOptions>;
            viewAll: TextTranslator<TranslateOptions>;
        };
        callToActionButtonLabels: {
            openLink: TextTranslator<TranslateOptions>;
        };
        list: {
            noNotifications: TextTranslator<TranslateOptions>;
        };
        messages: {
            customAgencyMessage: TextTranslator<NotificationsMessagesCustomAgencyMessageOptions>;
            emailScheduleFailed: TextTranslator<NotificationsMessagesEmailScheduleFailedOptions>;
            emailScheduled: TextTranslator<NotificationsMessagesEmailScheduledOptions>;
            imagePublishFailed: TextTranslator<NotificationsMessagesImagePublishFailedOptions>;
            imagePublishFailedNoError: TextTranslator<NotificationsMessagesImagePublishFailedNoErrorOptions>;
            integrationConnectivityFailure: TextTranslator<NotificationsMessagesIntegrationConnectivityFailureOptions>;
            integrationConfigurationMisconfigured: TextTranslator<NotificationsMessagesIntegrationConfigurationMisconfiguredOptions>;
            locationMapGenerated: TextTranslator<NotificationsMessagesLocationMapGeneratedOptions>;
            locationMapGenerationFailed: TextTranslator<NotificationsMessagesLocationMapGenerationFailedOptions>;
            mediaTemplateReadyForDownload: TextTranslator<TranslateOptions>;
            mediaTemplateTimeToSchedule: TextTranslator<TranslateOptions>;
            scheduledPosts: {
                noNotifiableDevices: TextTranslator<NotificationsMessagesScheduledPostsNoNotifiableDevicesOptions>;
            };
            test: TextTranslator<NotificationsMessagesTestOptions>;
            videoPublishFailed: TextTranslator<NotificationsMessagesVideoPublishFailedOptions>;
            videoPublishedExternally: TextTranslator<NotificationsMessagesVideoPublishedExternallyOptions>;
            videoPublishedExternallyV2: TextTranslator<NotificationsMessagesVideoPublishedExternallyV2Options>;
            videoPublishedLocally: TextTranslator<TranslateOptions>;
            videoScheduledExternally: TextTranslator<NotificationsMessagesVideoScheduledExternallyOptions>;
            videoScheduledExternallyV2: TextTranslator<NotificationsMessagesVideoScheduledExternallyV2Options>;
        };
        sendNotificationWizard: {
            common: {
                emailNotification: TextTranslator<TranslateOptions>;
                notificationType: TextTranslator<TranslateOptions>;
                pushNotification: TextTranslator<TranslateOptions>;
            };
            compose: {
                email: {
                    ctaButton: {
                        label: TextTranslator<TranslateOptions>;
                        link: TextTranslator<TranslateOptions>;
                    };
                    editorButtons: {
                        alignCenter: TextTranslator<TranslateOptions>;
                        alignLeft: TextTranslator<TranslateOptions>;
                        alignRight: TextTranslator<TranslateOptions>;
                        bold: TextTranslator<TranslateOptions>;
                        bulletedList: TextTranslator<TranslateOptions>;
                        headingNum: TextTranslator<NotificationsSendNotificationWizardComposeEmailEditorButtonsHeadingNumOptions>;
                        image: TextTranslator<TranslateOptions>;
                        italics: TextTranslator<TranslateOptions>;
                        numberedList: TextTranslator<TranslateOptions>;
                    };
                    emailContent: TextTranslator<TranslateOptions>;
                    errors: {
                        bannerImageRequired: TextTranslator<TranslateOptions>;
                        ctaLabelRequired: TextTranslator<TranslateOptions>;
                        ctaLinkRequired: TextTranslator<TranslateOptions>;
                        fromEmailAddressRequired: TextTranslator<TranslateOptions>;
                        fromNameRequired: TextTranslator<TranslateOptions>;
                        shouldSaveBannerSectionNameRequired: TextTranslator<TranslateOptions>;
                        shouldSaveFooterSectionNameRequired: TextTranslator<TranslateOptions>;
                        subjectRequired: TextTranslator<TranslateOptions>;
                    };
                    inputLabels: {
                        bannerImageSwitch: TextTranslator<TranslateOptions>;
                        bannerImageSwitchImage: TextTranslator<TranslateOptions>;
                        bannerImageSwitchLogo: TextTranslator<TranslateOptions>;
                        bannerImageSwitchNone: TextTranslator<TranslateOptions>;
                        bannerImageSwitchSaved: TextTranslator<TranslateOptions>;
                        footerContent: TextTranslator<TranslateOptions>;
                        footerSwitch: TextTranslator<TranslateOptions>;
                        footerSwitchExisting: TextTranslator<TranslateOptions>;
                        footerSwitchNew: TextTranslator<TranslateOptions>;
                        footerSwitchNone: TextTranslator<TranslateOptions>;
                        fromAddress: TextTranslator<TranslateOptions>;
                        fromAddressSwitchCustom: TextTranslator<TranslateOptions>;
                        fromAddressSwitchDefault: TextTranslator<NotificationsSendNotificationWizardComposeEmailInputLabelsFromAddressSwitchDefaultOptions>;
                        fromEmailAddress: TextTranslator<TranslateOptions>;
                        fromName: TextTranslator<TranslateOptions>;
                        logo: TextTranslator<TranslateOptions>;
                        savedEmailPartBannerSelect: TextTranslator<TranslateOptions>;
                        savedEmailPartFooterSelect: TextTranslator<TranslateOptions>;
                        shouldSaveBannerSection: TextTranslator<TranslateOptions>;
                        shouldSaveBannerSectionName: TextTranslator<TranslateOptions>;
                        shouldSaveFooterSection: TextTranslator<TranslateOptions>;
                        shouldSaveFooterSectionName: TextTranslator<TranslateOptions>;
                    };
                    placeholders: {
                        shouldSaveBannerSectionName: TextTranslator<TranslateOptions>;
                        shouldSaveFooterSectionName: TextTranslator<TranslateOptions>;
                    };
                    sectionSaveAgencyNote: TextTranslator<TranslateOptions>;
                    sectionSaveBrandNote: TextTranslator<TranslateOptions>;
                };
                push: {
                    inputLabels: {
                        link: TextTranslator<TranslateOptions>;
                        message: TextTranslator<TranslateOptions>;
                        optional: TextTranslator<TranslateOptions>;
                        subject: TextTranslator<TranslateOptions>;
                    };
                    preview: {
                        notification: TextTranslator<TranslateOptions>;
                        openLink: TextTranslator<TranslateOptions>;
                    };
                };
            };
            confirmForm: {
                confirmCopy: TextTranslator<TranslateOptions>;
                description: {
                    lineOne: TextTranslator<TranslateOptions>;
                    lineTwo: TextTranslator<TranslateOptions>;
                };
                formLabels: {
                    clientCountTextLocation: TextTranslator<NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationOptions>;
                    clientCountTextLocations: TextTranslator<NotificationsSendNotificationWizardConfirmFormFormLabelsClientCountTextLocationsOptions>;
                    immediately: TextTranslator<TranslateOptions>;
                    notificationType: TextTranslator<TranslateOptions>;
                    totalRecipients: TextTranslator<TranslateOptions>;
                    userFilter: TextTranslator<TranslateOptions>;
                };
                sendNotification: TextTranslator<TranslateOptions>;
                sendTestEmail: TextTranslator<TranslateOptions>;
            };
            notificationError: {
                emailMessage: TextTranslator<TranslateOptions>;
                emailPreviewMessage: TextTranslator<TranslateOptions>;
            };
            notificationSuccess: {
                emailDescription: TextTranslator<TranslateOptions>;
                emailMessage: TextTranslator<TranslateOptions>;
                emailPreviewMessage: TextTranslator<TranslateOptions>;
                pushDescription: TextTranslator<TranslateOptions>;
                pushMessage: TextTranslator<TranslateOptions>;
                sendAnother: TextTranslator<TranslateOptions>;
            };
            notificationTypeSelector: {
                buttons: {
                    email: TextTranslator<TranslateOptions>;
                    push: TextTranslator<TranslateOptions>;
                };
            };
            pickLocations: {
                currentlySelected: TextTranslator<NotificationsSendNotificationWizardPickLocationsCurrentlySelectedOptions>;
                description: TextTranslator<TranslateOptions>;
                errors: {
                    titleFilterInvalidEntries: TextTranslator<TranslateOptions>;
                };
                headers: {
                    filterByTitle: TextTranslator<TranslateOptions>;
                };
                labels: {
                    filterByTitles: TextTranslator<TranslateOptions>;
                    filterSwitchAllUsers: TextTranslator<TranslateOptions>;
                    filterSwitchFilterByTitle: TextTranslator<TranslateOptions>;
                    totalRecipients: TextTranslator<NotificationsSendNotificationWizardPickLocationsLabelsTotalRecipientsOptions>;
                };
            };
            steps: {
                compose: {
                    headingText: TextTranslator<TranslateOptions>;
                    stepperText: TextTranslator<TranslateOptions>;
                };
                notificationType: {
                    headingText: TextTranslator<TranslateOptions>;
                    stepperText: TextTranslator<TranslateOptions>;
                };
                review: {
                    headingText: TextTranslator<TranslateOptions>;
                    stepperText: TextTranslator<TranslateOptions>;
                };
                selectLocations: {
                    headingText: TextTranslator<TranslateOptions>;
                    stepperText: TextTranslator<TranslateOptions>;
                };
            };
        };
        subjects: {
            customAgencyMessage: TextTranslator<NotificationsSubjectsCustomAgencyMessageOptions>;
        };
    };
    overview: {
        allEvents: TextTranslator<TranslateOptions>;
        bulkActions: TextTranslator<TranslateOptions>;
        confirmPlannerEvents: TextTranslator<OverviewConfirmPlannerEventsOptions>;
        deleteAllPlannerEvents: TextTranslator<TranslateOptions>;
        deleteRecurringEvent: TextTranslator<TranslateOptions>;
        deletedPlannerEvents: TextTranslator<TranslateOptions>;
        deletedSomePlannerEvents: TextTranslator<TranslateOptions>;
        deletingPlannerEvents: TextTranslator<TranslateOptions>;
        deletingThesePlannerEvents: TextTranslator<TranslateOptions>;
        deletingTitle: TextTranslator<OverviewDeletingTitleOptions>;
        done: TextTranslator<TranslateOptions>;
        dueBy: TextTranslator<OverviewDueByOptions>;
        failedDeletePlannerEvents: TextTranslator<TranslateOptions>;
        filter: {
            channels: TextTranslator<TranslateOptions>;
            client: TextTranslator<TranslateOptions>;
            item: TextTranslator<TranslateOptions>;
            location: TextTranslator<TranslateOptions>;
            status: TextTranslator<TranslateOptions>;
        };
        filteredAmount: TextTranslator<OverviewFilteredAmountOptions>;
        futureEvents: TextTranslator<TranslateOptions>;
        loadedLocations: TextTranslator<OverviewLoadedLocationsOptions>;
        locationEventsFailedPublish: TextTranslator<TranslateOptions>;
        locationEventsFailedSave: TextTranslator<TranslateOptions>;
        maxSpend: TextTranslator<TranslateOptions>;
        noContent: TextTranslator<TranslateOptions>;
        savingForTitle: TextTranslator<OverviewSavingForTitleOptions>;
        savingPlannerEvent: TextTranslator<TranslateOptions>;
        selectedPlannerEvents: TextTranslator<TranslateOptions>;
        somePlannerSeries: TextTranslator<TranslateOptions>;
        thisEvent: TextTranslator<TranslateOptions>;
    };
    payments: {
        askAgencyToSendAnother: TextTranslator<TranslateOptions>;
        authorityConfirmation: TextTranslator<TranslateOptions>;
        businessName: TextTranslator<TranslateOptions>;
        couldNotFindInvitation: TextTranslator<TranslateOptions>;
        customerDetails: TextTranslator<TranslateOptions>;
        emailAddress: TextTranslator<TranslateOptions>;
        emails: {
            amountDue: TextTranslator<PaymentsEmailsAmountDueOptions>;
            attemptedPaymentDate: TextTranslator<PaymentsEmailsAttemptedPaymentDateOptions>;
            dueDate: TextTranslator<PaymentsEmailsDueDateOptions>;
            failedSubjectLine: TextTranslator<PaymentsEmailsFailedSubjectLineOptions>;
            failedToTakePayment: TextTranslator<TranslateOptions>;
            ifYouNeedToUpdateCreditCard: TextTranslator<TranslateOptions>;
            invoiceDescription: TextTranslator<PaymentsEmailsInvoiceDescriptionOptions>;
            invoiceNumber: TextTranslator<PaymentsEmailsInvoiceNumberOptions>;
            paymentFailedForLocation: TextTranslator<PaymentsEmailsPaymentFailedForLocationOptions>;
            report: {
                failedSubjectLine: TextTranslator<PaymentsEmailsReportFailedSubjectLineOptions>;
                failedSubjectLinePlural: TextTranslator<PaymentsEmailsReportFailedSubjectLinePluralOptions>;
                failedToTakePayments: TextTranslator<TranslateOptions>;
                paymentFailedForLocations: TextTranslator<PaymentsEmailsReportPaymentFailedForLocationsOptions>;
                paymentFailedForLocationsPlural: TextTranslator<PaymentsEmailsReportPaymentFailedForLocationsPluralOptions>;
                paymentFailureReason: TextTranslator<PaymentsEmailsReportPaymentFailureReasonOptions>;
                technicalIssues: TextTranslator<TranslateOptions>;
                technicalIssuesNote: TextTranslator<TranslateOptions>;
            };
            retry: {
                weWillAttemptToChargeAgain: TextTranslator<PaymentsEmailsRetryWeWillAttemptToChargeAgainOptions>;
            };
            rollover: {
                weWillAddOutstandingAmountToNextPayment: TextTranslator<PaymentsEmailsRolloverWeWillAddOutstandingAmountToNextPaymentOptions>;
            };
            subscriptionAmount: TextTranslator<PaymentsEmailsSubscriptionAmountOptions>;
            youMayNeedToContactYourFinancialInstitution: TextTranslator<TranslateOptions>;
        };
        finalisingPayment: TextTranslator<TranslateOptions>;
        goBack: TextTranslator<TranslateOptions>;
        invoiceDescription: TextTranslator<TranslateOptions>;
        invoiceNumber: TextTranslator<TranslateOptions>;
        mastercard: TextTranslator<TranslateOptions>;
        noPayment: TextTranslator<TranslateOptions>;
        noPaymentInformation: TextTranslator<TranslateOptions>;
        payNow: TextTranslator<TranslateOptions>;
        paymentAmount: TextTranslator<TranslateOptions>;
        paymentCurrency: TextTranslator<TranslateOptions>;
        paymentFailed: TextTranslator<TranslateOptions>;
        paymentSuccessful: TextTranslator<TranslateOptions>;
        phoneNumber: TextTranslator<TranslateOptions>;
        pleaseConfirm: TextTranslator<TranslateOptions>;
        receiptNumber: TextTranslator<TranslateOptions>;
        redirectContinue: TextTranslator<TranslateOptions>;
        redirectNote: TextTranslator<TranslateOptions>;
        redirecting: TextTranslator<TranslateOptions>;
        signUp: {
            agencyWelcomesYou: TextTranslator<PaymentsSignUpAgencyWelcomesYouOptions>;
            amountPerMonth: TextTranslator<PaymentsSignUpAmountPerMonthOptions>;
            finalisingSignUp: TextTranslator<TranslateOptions>;
            firstBillingDate: TextTranslator<TranslateOptions>;
            firstBillingDateIs: TextTranslator<PaymentsSignUpFirstBillingDateIsOptions>;
            iAgreeToThe: TextTranslator<TranslateOptions>;
            signUp: TextTranslator<TranslateOptions>;
            signUpFailed: TextTranslator<TranslateOptions>;
            signUpSuccessful: TextTranslator<TranslateOptions>;
            youWillBePromptedForCreditCard: TextTranslator<TranslateOptions>;
        };
        starting: TextTranslator<TranslateOptions>;
        stripe: {
            authRequest: {
                authoriseYourAccount: TextTranslator<TranslateOptions>;
                byAuthorising: TextTranslator<TranslateOptions>;
                clickButtonBelow: TextTranslator<TranslateOptions>;
                expired: TextTranslator<TranslateOptions>;
                requestInvalid: TextTranslator<TranslateOptions>;
            };
            authResponse: {
                accessDenied: TextTranslator<TranslateOptions>;
                error: TextTranslator<TranslateOptions>;
                failed: TextTranslator<TranslateOptions>;
                looksLikeSomethingWentWrong: TextTranslator<TranslateOptions>;
                looksLikeYouDeniedAccess: TextTranslator<TranslateOptions>;
                success: TextTranslator<TranslateOptions>;
                unknownError: TextTranslator<TranslateOptions>;
                yourStripeAccountIsConnected: TextTranslator<TranslateOptions>;
            };
            createStripeCharge: TextTranslator<TranslateOptions>;
            emails: {
                authRequest: {
                    authMyAccount: TextTranslator<TranslateOptions>;
                    subjectLine: TextTranslator<TranslateOptions>;
                    toAuthClickLink: TextTranslator<TranslateOptions>;
                    userRequestedYouToAuth: TextTranslator<PaymentsStripeEmailsAuthRequestUserRequestedYouToAuthOptions>;
                };
            };
            fetchStripeAuthRequest: TextTranslator<TranslateOptions>;
            fetchStripeAuthUrl: TextTranslator<TranslateOptions>;
            fetchStripePublishableKey: TextTranslator<TranslateOptions>;
            submitAuthCodeToStripe: TextTranslator<TranslateOptions>;
        };
        thankYou: TextTranslator<TranslateOptions>;
        updateBillingDetails: {
            billingDetailsUpdated: TextTranslator<TranslateOptions>;
            finalisingChanges: TextTranslator<TranslateOptions>;
            loadingBillingDetails: TextTranslator<TranslateOptions>;
            updateBillingDetails: TextTranslator<TranslateOptions>;
            updateBillingDetailsInDigitalStack: TextTranslator<TranslateOptions>;
            updateFailed: TextTranslator<TranslateOptions>;
            updateSuccessful: TextTranslator<TranslateOptions>;
        };
        visa: TextTranslator<TranslateOptions>;
        weOnlyAccept: TextTranslator<TranslateOptions>;
        yourBusiness: TextTranslator<TranslateOptions>;
    };
    plan: {
        activities: {
            actions: {
                addActivity: TextTranslator<TranslateOptions>;
            };
            channels: {
                channelForActivity: TextTranslator<PlanActivitiesChannelsChannelForActivityOptions>;
                channelType: {
                    general: TextTranslator<TranslateOptions>;
                    selfService: TextTranslator<TranslateOptions>;
                    supported: TextTranslator<TranslateOptions>;
                };
            };
        };
        agencyToBuild: TextTranslator<TranslateOptions>;
        agencyToBuildSpecific: TextTranslator<PlanAgencyToBuildSpecificOptions>;
        agencyToBuildTooltip: TextTranslator<PlanAgencyToBuildTooltipOptions>;
        associatedBuilderResources: {
            addTemplate: TextTranslator<TranslateOptions>;
            associateTemplateOrCategory: TextTranslator<TranslateOptions>;
            invalidSingleTemplateExplanation: TextTranslator<TranslateOptions>;
            pasteATemplateUrl: TextTranslator<TranslateOptions>;
            selectACollection: TextTranslator<TranslateOptions>;
            selectATemplateCategory: TextTranslator<TranslateOptions>;
            singleTemplate: TextTranslator<TranslateOptions>;
            templateUrl: TextTranslator<TranslateOptions>;
        };
        buildAndSchedule: TextTranslator<TranslateOptions>;
        buildAndScheduleTooltip: TextTranslator<TranslateOptions>;
        campaigns: {
            actions: {
                archiveMessage: TextTranslator<PlanCampaignsActionsArchiveMessageOptions>;
                archiveThisCampaign: TextTranslator<TranslateOptions>;
                deployThisCampaign: TextTranslator<TranslateOptions>;
                renameCampaign: TextTranslator<TranslateOptions>;
                unarchiveMessage: TextTranslator<PlanCampaignsActionsUnarchiveMessageOptions>;
                unarchiveThisCampaign: TextTranslator<TranslateOptions>;
            };
            addItem: TextTranslator<TranslateOptions>;
            addNewCampaign: TextTranslator<TranslateOptions>;
            campaignNameFilterLabel: TextTranslator<TranslateOptions>;
            campaignNotFound: TextTranslator<TranslateOptions>;
            campaignRenamedTo: TextTranslator<PlanCampaignsCampaignRenamedToOptions>;
            campaigns: TextTranslator<TranslateOptions>;
            campaignsList: {
                headers: {
                    duration: TextTranslator<TranslateOptions>;
                    name: TextTranslator<TranslateOptions>;
                    totalItems: TextTranslator<TranslateOptions>;
                };
                noCampaignsFound: TextTranslator<TranslateOptions>;
                numDays: TextTranslator<PlanCampaignsCampaignsListNumDaysOptions>;
            };
            createdNewCampaign: TextTranslator<PlanCampaignsCreatedNewCampaignOptions>;
            deploys: {
                adjustEventDatesTitle: TextTranslator<TranslateOptions>;
                campaignDeployed: TextTranslator<TranslateOptions>;
                deploy: TextTranslator<TranslateOptions>;
                deployCampaign: TextTranslator<TranslateOptions>;
                deployCampaignToLocation: TextTranslator<PlanCampaignsDeploysDeployCampaignToLocationOptions>;
                deployFormCopy: {
                    adjustDates: {
                        explainStep: TextTranslator<TranslateOptions>;
                        explainStepAdjustDetail: TextTranslator<TranslateOptions>;
                        explainStepRemoveDetail: TextTranslator<TranslateOptions>;
                    };
                    confirm: {
                        confirmCopy: TextTranslator<TranslateOptions>;
                        deploymentExplanationCopy: TextTranslator<TranslateOptions>;
                        endDate: TextTranslator<TranslateOptions>;
                        events: TextTranslator<TranslateOptions>;
                        eventsPerLocation: TextTranslator<PlanCampaignsDeploysDeployFormCopyConfirmEventsPerLocationOptions>;
                        header: TextTranslator<TranslateOptions>;
                        locations: TextTranslator<TranslateOptions>;
                        locationsWithClient: TextTranslator<PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientOptions>;
                        locationsWithClientSingular: TextTranslator<PlanCampaignsDeploysDeployFormCopyConfirmLocationsWithClientSingularOptions>;
                        pleaseConfirm: TextTranslator<TranslateOptions>;
                        startDate: TextTranslator<TranslateOptions>;
                        startDeployment: TextTranslator<TranslateOptions>;
                    };
                    pickLocations: {
                        explainStep: TextTranslator<TranslateOptions>;
                        explainStepDetail: TextTranslator<TranslateOptions>;
                    };
                    startingDate: {
                        explainStep: TextTranslator<TranslateOptions>;
                        explainStepDetail: TextTranslator<TranslateOptions>;
                    };
                    steps: {
                        adjustDates: TextTranslator<TranslateOptions>;
                        pickLocations: TextTranslator<TranslateOptions>;
                        review: TextTranslator<TranslateOptions>;
                        setStartingDate: TextTranslator<TranslateOptions>;
                    };
                };
                deployTo: TextTranslator<TranslateOptions>;
                deploymentHistory: TextTranslator<TranslateOptions>;
                deploymentHistoryList: {
                    campaignNotFound: TextTranslator<TranslateOptions>;
                    filters: {
                        locationPlaceholder: TextTranslator<TranslateOptions>;
                        statusLabel: TextTranslator<TranslateOptions>;
                        statusPlaceholder: TextTranslator<TranslateOptions>;
                    };
                    headers: {
                        createDate: TextTranslator<TranslateOptions>;
                        location: TextTranslator<TranslateOptions>;
                        startDate: TextTranslator<TranslateOptions>;
                        status: TextTranslator<TranslateOptions>;
                    };
                    noDeployments: TextTranslator<TranslateOptions>;
                };
                deploymentHistoryStatus: {
                    active: TextTranslator<TranslateOptions>;
                    activeHelp: TextTranslator<TranslateOptions>;
                    completed: TextTranslator<TranslateOptions>;
                    completedHelp: TextTranslator<TranslateOptions>;
                    failed: TextTranslator<TranslateOptions>;
                    failedHelp: TextTranslator<TranslateOptions>;
                    rollingout: TextTranslator<TranslateOptions>;
                    rollingoutHelp: TextTranslator<TranslateOptions>;
                    scheduled: TextTranslator<TranslateOptions>;
                    scheduledHelp: TextTranslator<PlanCampaignsDeploysDeploymentHistoryStatusScheduledHelpOptions>;
                };
                errors: {
                    deploymentFailed: TextTranslator<TranslateOptions>;
                    mustIncludeOneEvent: TextTranslator<TranslateOptions>;
                    mustIncludeOneLocation: TextTranslator<TranslateOptions>;
                };
                pickLocations: TextTranslator<TranslateOptions>;
                selectStartingDate: TextTranslator<TranslateOptions>;
                startingDate: TextTranslator<TranslateOptions>;
                successfulDeployCopy: TextTranslator<TranslateOptions>;
            };
            errors: {
                uploadFailed: TextTranslator<TranslateOptions>;
            };
            eventsList: {
                headers: {
                    actions: TextTranslator<TranslateOptions>;
                    channel: TextTranslator<TranslateOptions>;
                    day: TextTranslator<TranslateOptions>;
                    instructionsDescription: TextTranslator<TranslateOptions>;
                    title: TextTranslator<TranslateOptions>;
                };
            };
            isArchived: TextTranslator<TranslateOptions>;
            overview: TextTranslator<TranslateOptions>;
            plannerEvents: {
                areYouSureDeletePlannerEvent: TextTranslator<TranslateOptions>;
                errors: {
                    issueCreatingPlannerEvent: TextTranslator<TranslateOptions>;
                    issueDeletingPlannerEvent: TextTranslator<TranslateOptions>;
                    issueUpdatingPlannerEvent: TextTranslator<TranslateOptions>;
                };
                newPlannerEvent: TextTranslator<TranslateOptions>;
                plannerEventCreated: TextTranslator<TranslateOptions>;
                plannerEventDeleted: TextTranslator<TranslateOptions>;
                plannerEventNotFound: TextTranslator<TranslateOptions>;
                plannerEventUpdated: TextTranslator<TranslateOptions>;
                plannerEvents: TextTranslator<TranslateOptions>;
                readyToAction: TextTranslator<TranslateOptions>;
            };
            returnToCampaignsPage: TextTranslator<TranslateOptions>;
        };
        contentRequired: TextTranslator<TranslateOptions>;
        contentRequiredTooltip: TextTranslator<TranslateOptions>;
        dangerousDateHeading: TextTranslator<TranslateOptions>;
        dangerousDateNote: TextTranslator<TranslateOptions>;
        event: {
            activity: TextTranslator<TranslateOptions>;
            addRemoveLocations: TextTranslator<TranslateOptions>;
            addToPlanner: TextTranslator<TranslateOptions>;
            additionalLocations: TextTranslator<TranslateOptions>;
            backToCalendar: TextTranslator<TranslateOptions>;
            buildNow: TextTranslator<TranslateOptions>;
            confirmDelete: TextTranslator<PlanEventConfirmDeleteOptions>;
            daily: TextTranslator<TranslateOptions>;
            dateOfMonthExample: TextTranslator<PlanEventDateOfMonthExampleOptions>;
            dateOfMonthInYearExample: TextTranslator<PlanEventDateOfMonthInYearExampleOptions>;
            dateOfWeekExample: TextTranslator<PlanEventDateOfWeekExampleOptions>;
            dateOfWeekInYearExample: TextTranslator<PlanEventDateOfWeekInYearExampleOptions>;
            dateSubmitted: TextTranslator<TranslateOptions>;
            dateUpdated: TextTranslator<TranslateOptions>;
            deletePlannerEvent: TextTranslator<TranslateOptions>;
            deleteRecurring: TextTranslator<TranslateOptions>;
            deletionAlert: TextTranslator<PlanEventDeletionAlertOptions>;
            editPlanner: TextTranslator<TranslateOptions>;
            ends: TextTranslator<TranslateOptions>;
            eventSeries: TextTranslator<TranslateOptions>;
            eventSeriesChooseAll: TextTranslator<TranslateOptions>;
            eventSeriesChooseCurrent: TextTranslator<TranslateOptions>;
            eventSeriesChooseFuture: TextTranslator<TranslateOptions>;
            eventSeriesOptionsDelete: TextTranslator<TranslateOptions>;
            eventSeriesOptionsUpdate: TextTranslator<TranslateOptions>;
            failedToCreateUpdatePlanner: TextTranslator<TranslateOptions>;
            failedToDeletePlanner: TextTranslator<TranslateOptions>;
            failedToRetrievePlanner: TextTranslator<TranslateOptions>;
            failedToRetrievePlannerInfo: TextTranslator<TranslateOptions>;
            fifth: TextTranslator<TranslateOptions>;
            first: TextTranslator<TranslateOptions>;
            fortnightly: TextTranslator<TranslateOptions>;
            fourth: TextTranslator<TranslateOptions>;
            friday: TextTranslator<TranslateOptions>;
            instructionsToManager: TextTranslator<PlanEventInstructionsToManagerOptions>;
            monday: TextTranslator<TranslateOptions>;
            noArtwork: TextTranslator<TranslateOptions>;
            occurrences: TextTranslator<TranslateOptions>;
            oldActivities: TextTranslator<TranslateOptions>;
            plannerEventDeleted: TextTranslator<TranslateOptions>;
            pleaseDeleteItemVia: TextTranslator<TranslateOptions>;
            readyToAction: TextTranslator<TranslateOptions>;
            recurringEventQuestion: TextTranslator<TranslateOptions>;
            repeatBy: TextTranslator<TranslateOptions>;
            requiredInfo: TextTranslator<PlanEventRequiredInfoOptions>;
            saturday: TextTranslator<TranslateOptions>;
            saveBuildLater: TextTranslator<TranslateOptions>;
            saveBuildNow: TextTranslator<TranslateOptions>;
            saveMoreContentRequired: TextTranslator<TranslateOptions>;
            scheduledPage: TextTranslator<TranslateOptions>;
            second: TextTranslator<TranslateOptions>;
            selfService: TextTranslator<TranslateOptions>;
            startsOn: TextTranslator<TranslateOptions>;
            submittedBy: TextTranslator<TranslateOptions>;
            sunday: TextTranslator<TranslateOptions>;
            supportActionOne: TextTranslator<TranslateOptions>;
            supportActionThree: TextTranslator<TranslateOptions>;
            supportActionTwo: TextTranslator<TranslateOptions>;
            supportActions: TextTranslator<TranslateOptions>;
            supportHeading: TextTranslator<TranslateOptions>;
            supportNote: TextTranslator<PlanEventSupportNoteOptions>;
            supportOverplanned: TextTranslator<TranslateOptions>;
            supportRequested: TextTranslator<PlanEventSupportRequestedOptions>;
            templateCategoryExpired: TextTranslator<TranslateOptions>;
            third: TextTranslator<TranslateOptions>;
            thursday: TextTranslator<TranslateOptions>;
            tuesday: TextTranslator<TranslateOptions>;
            updateRecurring: TextTranslator<TranslateOptions>;
            updatedBy: TextTranslator<TranslateOptions>;
            wednesday: TextTranslator<TranslateOptions>;
            weekly: TextTranslator<TranslateOptions>;
        };
        generalItem: TextTranslator<TranslateOptions>;
        generalItemTooltip: TextTranslator<TranslateOptions>;
        introDummyActivity: TextTranslator<TranslateOptions>;
        introDummyChannel: TextTranslator<TranslateOptions>;
        multipleLocations: {
            savingForTheseLocations: TextTranslator<TranslateOptions>;
            savingForTitle: TextTranslator<PlanMultipleLocationsSavingForTitleOptions>;
            someLocationsFailedToSave: TextTranslator<TranslateOptions>;
            totalSavingProgress: TextTranslator<TranslateOptions>;
            wouldYouLikeToRetryForFailedLocations: TextTranslator<TranslateOptions>;
        };
        nextMonth: TextTranslator<TranslateOptions>;
        nextWeek: TextTranslator<TranslateOptions>;
        notifyPlannerCreateError: TextTranslator<TranslateOptions>;
        notifyPlannerCreated: TextTranslator<PlanNotifyPlannerCreatedOptions>;
        notifyPlannerCreatedPartial: TextTranslator<PlanNotifyPlannerCreatedPartialOptions>;
        notifyPlannerEventDeleted: TextTranslator<TranslateOptions>;
        notifyPlannerUpdated: TextTranslator<PlanNotifyPlannerUpdatedOptions>;
        pastDateCantPlan: TextTranslator<TranslateOptions>;
        pastDateHeading: TextTranslator<TranslateOptions>;
        pastDateRecurring: TextTranslator<TranslateOptions>;
        plan: TextTranslator<TranslateOptions>;
        planner: TextTranslator<TranslateOptions>;
        previousMonth: TextTranslator<TranslateOptions>;
        previousWeek: TextTranslator<TranslateOptions>;
        readyToBuild: TextTranslator<TranslateOptions>;
        readyToBuildTooltip: TextTranslator<TranslateOptions>;
        savingPlannerEvent: TextTranslator<TranslateOptions>;
        specialRequest: TextTranslator<TranslateOptions>;
        updateRecurringDate: TextTranslator<TranslateOptions>;
        viewByMonth: TextTranslator<TranslateOptions>;
        viewByWeek: TextTranslator<TranslateOptions>;
    };
    profile: {
        changeImage: TextTranslator<TranslateOptions>;
        changeProfilePicture: TextTranslator<TranslateOptions>;
        confirmRemoveProfilePicture: TextTranslator<TranslateOptions>;
        email: TextTranslator<TranslateOptions>;
        emailRequired: TextTranslator<TranslateOptions>;
        firstName: TextTranslator<TranslateOptions>;
        firstNameRequired: TextTranslator<TranslateOptions>;
        inviteSent: TextTranslator<TranslateOptions>;
        lastName: TextTranslator<TranslateOptions>;
        lastNameRequired: TextTranslator<TranslateOptions>;
        marketingUpdates: TextTranslator<TranslateOptions>;
        minimumImageDimensionRequirement: TextTranslator<ProfileMinimumImageDimensionRequirementOptions>;
        notifications: TextTranslator<TranslateOptions>;
        password: TextTranslator<TranslateOptions>;
        profile: TextTranslator<TranslateOptions>;
        profilePicture: TextTranslator<TranslateOptions>;
        removeImage: TextTranslator<TranslateOptions>;
        resendInvite: TextTranslator<TranslateOptions>;
        sendingInvite: TextTranslator<TranslateOptions>;
        specialRequests: TextTranslator<TranslateOptions>;
        timezone: TextTranslator<TranslateOptions>;
        units: TextTranslator<TranslateOptions>;
        unsupportedImageFormat: TextTranslator<TranslateOptions>;
        userAccountUpdated: TextTranslator<TranslateOptions>;
        userLocaleChangedPageWillReload: TextTranslator<TranslateOptions>;
        userProfile: TextTranslator<TranslateOptions>;
    };
    report: {
        adName: TextTranslator<TranslateOptions>;
        addRemoveLocations: TextTranslator<TranslateOptions>;
        adjustSpend: TextTranslator<TranslateOptions>;
        adjustedDailyBudget: TextTranslator<TranslateOptions>;
        advertising: TextTranslator<TranslateOptions>;
        allMonetaryFiguresAreInCurrency: TextTranslator<ReportAllMonetaryFiguresAreInCurrencyOptions>;
        averagePosition: TextTranslator<TranslateOptions>;
        bounced: TextTranslator<TranslateOptions>;
        brandAwareness: TextTranslator<TranslateOptions>;
        brandAwarenessByAd: TextTranslator<TranslateOptions>;
        brandAwarenessByKeyword: TextTranslator<TranslateOptions>;
        budget: TextTranslator<TranslateOptions>;
        byAd: TextTranslator<TranslateOptions>;
        byKeyword: TextTranslator<TranslateOptions>;
        campaign: TextTranslator<TranslateOptions>;
        campaignMonitor: {
            title: TextTranslator<TranslateOptions>;
        };
        cantReportMoreThanThreeMonths: TextTranslator<TranslateOptions>;
        clickRate: TextTranslator<TranslateOptions>;
        clickThroughRate: TextTranslator<TranslateOptions>;
        clickThroughRateHint: TextTranslator<TranslateOptions>;
        clicked: TextTranslator<TranslateOptions>;
        clicks: TextTranslator<TranslateOptions>;
        clientOrLocation: TextTranslator<TranslateOptions>;
        collapsePosts: TextTranslator<TranslateOptions>;
        collapseRows: TextTranslator<TranslateOptions>;
        confirmDeleteReportSummary: TextTranslator<TranslateOptions>;
        consumed: TextTranslator<TranslateOptions>;
        consumption: TextTranslator<TranslateOptions>;
        conversionValue: TextTranslator<TranslateOptions>;
        conversionValueHint: TextTranslator<TranslateOptions>;
        conversions: TextTranslator<TranslateOptions>;
        conversionsByAd: TextTranslator<TranslateOptions>;
        conversionsByKeyword: TextTranslator<TranslateOptions>;
        conversionsPlatformNotConfiguredForLocation: TextTranslator<ReportConversionsPlatformNotConfiguredForLocationOptions>;
        costPerClick: TextTranslator<TranslateOptions>;
        costPerConversion: TextTranslator<TranslateOptions>;
        costPerLead: TextTranslator<TranslateOptions>;
        costPerUniqueClick: TextTranslator<TranslateOptions>;
        currency: TextTranslator<TranslateOptions>;
        currentSpend: TextTranslator<TranslateOptions>;
        deviceSelection: TextTranslator<TranslateOptions>;
        deviceSelectionHint: TextTranslator<TranslateOptions>;
        devices: {
            desktop: TextTranslator<TranslateOptions>;
            mobile: TextTranslator<TranslateOptions>;
            tablet: TextTranslator<TranslateOptions>;
            unknown: TextTranslator<TranslateOptions>;
        };
        emailCampaigns: {
            bounces: TextTranslator<TranslateOptions>;
            buttons: {
                downloadCsv: TextTranslator<TranslateOptions>;
                exportCsv: TextTranslator<TranslateOptions>;
            };
            clickRate: TextTranslator<TranslateOptions>;
            clicks: TextTranslator<ReportEmailCampaignsClicksOptions>;
            delivered: TextTranslator<TranslateOptions>;
            errorCouldNotBeRetrieved: TextTranslator<ReportEmailCampaignsErrorCouldNotBeRetrievedOptions>;
            errorExportingCsv: TextTranslator<TranslateOptions>;
            exportingPleaseWait: TextTranslator<TranslateOptions>;
            htmlPreviewDialogTitle: TextTranslator<TranslateOptions>;
            invalidEmails: TextTranslator<TranslateOptions>;
            notConnected: TextTranslator<TranslateOptions>;
            notifications: {
                exportingError: TextTranslator<TranslateOptions>;
                exportingSuccess: TextTranslator<TranslateOptions>;
            };
            numberRecipients: TextTranslator<ReportEmailCampaignsNumberRecipientsOptions>;
            openRate: TextTranslator<TranslateOptions>;
            opens: TextTranslator<ReportEmailCampaignsOpensOptions>;
            pleaseSelectEmailPlatform: TextTranslator<TranslateOptions>;
            recipients: TextTranslator<ReportEmailCampaignsRecipientsOptions>;
            recipientsTable: {
                clickedLink: TextTranslator<TranslateOptions>;
                delivered: TextTranslator<TranslateOptions>;
                markedAsSpam: TextTranslator<TranslateOptions>;
                noRecipientsFound: TextTranslator<TranslateOptions>;
                opened: TextTranslator<TranslateOptions>;
                recipientEmail: TextTranslator<TranslateOptions>;
                recipientEmailFilterLabel: TextTranslator<TranslateOptions>;
                recipientEmailFilterPlaceholder: TextTranslator<TranslateOptions>;
                recipientName: TextTranslator<TranslateOptions>;
                recipientNameFilterLabel: TextTranslator<TranslateOptions>;
                recipientNameFilterPlaceholder: TextTranslator<TranslateOptions>;
                unsubscribed: TextTranslator<TranslateOptions>;
            };
            sendingOn: TextTranslator<ReportEmailCampaignsSendingOnOptions>;
            sentTo: TextTranslator<ReportEmailCampaignsSentToOptions>;
            spamReports: TextTranslator<TranslateOptions>;
        };
        endDate: TextTranslator<TranslateOptions>;
        endDateBeforeStartDate: TextTranslator<TranslateOptions>;
        engagedUsers: TextTranslator<TranslateOptions>;
        engagement: TextTranslator<TranslateOptions>;
        engagementClicks: TextTranslator<TranslateOptions>;
        engagementReach: TextTranslator<TranslateOptions>;
        facebook: {
            audienceInsights: {
                ageRange: TextTranslator<TranslateOptions>;
                ageRangeAll: TextTranslator<TranslateOptions>;
                ageRangeMen: TextTranslator<TranslateOptions>;
                ageRangeOther: TextTranslator<TranslateOptions>;
                ageRangeWomen: TextTranslator<TranslateOptions>;
                days: TextTranslator<TranslateOptions>;
                gender: TextTranslator<TranslateOptions>;
                genderMen: TextTranslator<TranslateOptions>;
                genderOther: TextTranslator<TranslateOptions>;
                genderWomen: TextTranslator<TranslateOptions>;
                hours: TextTranslator<TranslateOptions>;
                onlineFollowers: TextTranslator<TranslateOptions>;
                onlineFollowersHelpDays: TextTranslator<ReportFacebookAudienceInsightsOnlineFollowersHelpDaysOptions>;
                onlineFollowersHelpHours: TextTranslator<ReportFacebookAudienceInsightsOnlineFollowersHelpHoursOptions>;
                title: TextTranslator<TranslateOptions>;
                topLocations: TextTranslator<TranslateOptions>;
                topLocationsHelp: TextTranslator<TranslateOptions>;
                topPostTimes: TextTranslator<TranslateOptions>;
            };
            incorrectDataPopoverText: TextTranslator<TranslateOptions>;
            likesReport: {
                newPageLikes: TextTranslator<TranslateOptions>;
                newPosts: TextTranslator<TranslateOptions>;
                now: TextTranslator<TranslateOptions>;
                pageLikes: TextTranslator<TranslateOptions>;
                pageLikesGrowth: TextTranslator<TranslateOptions>;
                periodAgo: TextTranslator<ReportFacebookLikesReportPeriodAgoOptions>;
                title: TextTranslator<TranslateOptions>;
                totalPageLikes: TextTranslator<TranslateOptions>;
            };
            notConnected: TextTranslator<TranslateOptions>;
            postsReport: {
                engagement: TextTranslator<TranslateOptions>;
                time: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                viewMore: TextTranslator<TranslateOptions>;
                viewPost: TextTranslator<TranslateOptions>;
            };
        };
        facebookAdvertising: TextTranslator<TranslateOptions>;
        facebookTopPosts: TextTranslator<TranslateOptions>;
        fitwareMemberEngager: {
            bounces: TextTranslator<TranslateOptions>;
            reportLimitations: {
                title: TextTranslator<TranslateOptions>;
                message: TextTranslator<TranslateOptions>;
            };
            locationEmail: TextTranslator<TranslateOptions>;
            opens: TextTranslator<TranslateOptions>;
            spamReports: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            unsubscribes: TextTranslator<TranslateOptions>;
        };
        followersFrom: TextTranslator<TranslateOptions>;
        followersGrowth: TextTranslator<TranslateOptions>;
        followersTo: TextTranslator<TranslateOptions>;
        followingRequestWillBeSentToAgency: TextTranslator<TranslateOptions>;
        generalEvents: TextTranslator<TranslateOptions>;
        generalTemplateTypes: {
            all: TextTranslator<TranslateOptions>;
            digital: TextTranslator<TranslateOptions>;
            email: TextTranslator<TranslateOptions>;
            print: TextTranslator<TranslateOptions>;
        };
        generatedReportPrintFooter: TextTranslator<ReportGeneratedReportPrintFooterOptions>;
        generatingReport: TextTranslator<TranslateOptions>;
        go: TextTranslator<TranslateOptions>;
        googleAds: {
            adNameTooltipNumDescription: TextTranslator<ReportGoogleAdsAdNameTooltipNumDescriptionOptions>;
            adNameTooltipNumDescriptionPlural: TextTranslator<ReportGoogleAdsAdNameTooltipNumDescriptionPluralOptions>;
            adNameTooltipNumHeadline: TextTranslator<ReportGoogleAdsAdNameTooltipNumHeadlineOptions>;
            adNameTooltipNumHeadlinePlural: TextTranslator<ReportGoogleAdsAdNameTooltipNumHeadlinePluralOptions>;
            adNameTooltipNumUrl: TextTranslator<ReportGoogleAdsAdNameTooltipNumUrlOptions>;
            adNameTooltipNumUrlPlural: TextTranslator<ReportGoogleAdsAdNameTooltipNumUrlPluralOptions>;
            columns: {
                adName: TextTranslator<TranslateOptions>;
                averageCpc: TextTranslator<TranslateOptions>;
                averageCpcTooltip: TextTranslator<TranslateOptions>;
                conversions: TextTranslator<TranslateOptions>;
                conversionsTooltip: TextTranslator<TranslateOptions>;
                cost: TextTranslator<TranslateOptions>;
                costPerConversion: TextTranslator<TranslateOptions>;
                costPerConversionTooltip: TextTranslator<TranslateOptions>;
                costTooltip: TextTranslator<TranslateOptions>;
                currency: TextTranslator<TranslateOptions>;
                currencyTooltip: TextTranslator<TranslateOptions>;
                impressions: TextTranslator<TranslateOptions>;
                impressionsTooltip: TextTranslator<TranslateOptions>;
                interactionRate: TextTranslator<TranslateOptions>;
                interactionRateTooltip: TextTranslator<TranslateOptions>;
                interactions: TextTranslator<TranslateOptions>;
                interactionsTooltip: TextTranslator<TranslateOptions>;
                keyword: TextTranslator<TranslateOptions>;
            };
            keywordBroadMatchTooltip: TextTranslator<TranslateOptions>;
            keywordExactMatchTooltip: TextTranslator<TranslateOptions>;
            keywordPhraseMatchTooltip: TextTranslator<TranslateOptions>;
            keywordUnknownMatchTooltip: TextTranslator<TranslateOptions>;
        };
        googleAdwordsSpendAdjustmentRequest: {
            additionalNotes: TextTranslator<TranslateOptions>;
            extraStepsMayBeRequired: TextTranslator<ReportGoogleAdwordsSpendAdjustmentRequestExtraStepsMayBeRequiredOptions>;
            failedToRequestSpendAdjustment: TextTranslator<TranslateOptions>;
            increaseMyGoogleAdwordsBudget: TextTranslator<ReportGoogleAdwordsSpendAdjustmentRequestIncreaseMyGoogleAdwordsBudgetOptions>;
            requestHasBeenSent: TextTranslator<TranslateOptions>;
            requestToAdjustSpend: TextTranslator<TranslateOptions>;
            sendRequest: TextTranslator<TranslateOptions>;
            userHasRequestedAnAdjustmentToAdwordsSpend: TextTranslator<ReportGoogleAdwordsSpendAdjustmentRequestUserHasRequestedAnAdjustmentToAdwordsSpendOptions>;
        };
        googleMyBusiness: {
            confirmDeleteMessage: TextTranslator<TranslateOptions>;
            customerFeedback: {
                title: TextTranslator<TranslateOptions>;
            };
            directionsReport: {
                title: TextTranslator<TranslateOptions>;
            };
            metricsNoLongerAvaliableBanner: TextTranslator<TranslateOptions>;
            notConnectedPart1: TextTranslator<TranslateOptions>;
            notConnectedPart2: TextTranslator<TranslateOptions>;
            photoQuantityReport: {
                merchantTitle: TextTranslator<TranslateOptions>;
                othersTitle: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            photoViewsReport: {
                merchantTitle: TextTranslator<TranslateOptions>;
                othersTitle: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            recentPosts: {
                postClicks: TextTranslator<ReportGoogleMyBusinessRecentPostsPostClicksOptions>;
                postViews: TextTranslator<ReportGoogleMyBusinessRecentPostsPostViewsOptions>;
                title: TextTranslator<TranslateOptions>;
                viewPost: TextTranslator<TranslateOptions>;
            };
            reply: TextTranslator<TranslateOptions>;
            replyLengthError: TextTranslator<TranslateOptions>;
            replyingPublicly: TextTranslator<TranslateOptions>;
            searchReport: {
                brandedDescription: TextTranslator<TranslateOptions>;
                brandedTitle: TextTranslator<TranslateOptions>;
                directDescription: TextTranslator<TranslateOptions>;
                directTitle: TextTranslator<TranslateOptions>;
                discoveryDescription: TextTranslator<TranslateOptions>;
                discoveryTitle: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            toolbar: {
                days30: TextTranslator<TranslateOptions>;
                days7: TextTranslator<TranslateOptions>;
                days90: TextTranslator<TranslateOptions>;
            };
            topQuestions: {
                anonymousAuthorName: TextTranslator<TranslateOptions>;
                answerListTitle: TextTranslator<TranslateOptions>;
                answers: TextTranslator<ReportGoogleMyBusinessTopQuestionsAnswersOptions>;
                questions: TextTranslator<ReportGoogleMyBusinessTopQuestionsQuestionsOptions>;
                title: TextTranslator<TranslateOptions>;
                upvotes: TextTranslator<ReportGoogleMyBusinessTopQuestionsUpvotesOptions>;
            };
            topReviews: {
                anonymousReviewerName: TextTranslator<TranslateOptions>;
                repliedAt: TextTranslator<ReportGoogleMyBusinessTopReviewsRepliedAtOptions>;
                reviews: TextTranslator<ReportGoogleMyBusinessTopReviewsReviewsOptions>;
                subTitle: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            viewFullReply: TextTranslator<TranslateOptions>;
            viewFullReview: TextTranslator<TranslateOptions>;
            viewReport: {
                callsChartLabel: TextTranslator<TranslateOptions>;
                callsTitle: TextTranslator<TranslateOptions>;
                directionsChartLabel: TextTranslator<TranslateOptions>;
                directionsTitle: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                websitesChartLabel: TextTranslator<TranslateOptions>;
                websitesTitle: TextTranslator<TranslateOptions>;
            };
        };
        growth: TextTranslator<TranslateOptions>;
        hideSummary: TextTranslator<TranslateOptions>;
        impressions: TextTranslator<TranslateOptions>;
        instagram: {
            audienceInsights: {
                ageRangeAll: TextTranslator<TranslateOptions>;
                ageRangeMen: TextTranslator<TranslateOptions>;
                ageRangeOther: TextTranslator<TranslateOptions>;
                ageRangeWomen: TextTranslator<TranslateOptions>;
                days: TextTranslator<TranslateOptions>;
                hours: TextTranslator<TranslateOptions>;
                onlineFollowers: TextTranslator<TranslateOptions>;
                onlineFollowersHelpDays: TextTranslator<ReportInstagramAudienceInsightsOnlineFollowersHelpDaysOptions>;
                onlineFollowersHelpHours: TextTranslator<ReportInstagramAudienceInsightsOnlineFollowersHelpHoursOptions>;
            };
            businessAccountReport: {
                followersChartLabel: TextTranslator<TranslateOptions>;
            };
            notConnectedPart1: TextTranslator<TranslateOptions>;
            notConnectedPart2: TextTranslator<TranslateOptions>;
            notConnectedScopesPart1: TextTranslator<TranslateOptions>;
            notConnectedScopesPart2: TextTranslator<TranslateOptions>;
            postsReport: {
                currentPosts: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                viewMore: TextTranslator<TranslateOptions>;
                viewPost: TextTranslator<TranslateOptions>;
            };
            storiesReport: {
                activeStories: TextTranslator<TranslateOptions>;
                noActiveStoriesMessage: TextTranslator<TranslateOptions>;
                noPastStoriesMessage: TextTranslator<TranslateOptions>;
                pastStories: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
                viewMore: TextTranslator<TranslateOptions>;
                viewPost: TextTranslator<TranslateOptions>;
            };
        };
        invalidEndDate: TextTranslator<TranslateOptions>;
        invalidStartDate: TextTranslator<TranslateOptions>;
        keyword: TextTranslator<TranslateOptions>;
        lastLogin: TextTranslator<TranslateOptions>;
        leads: TextTranslator<TranslateOptions>;
        likesCommentsShares: TextTranslator<TranslateOptions>;
        limited: TextTranslator<TranslateOptions>;
        location: TextTranslator<TranslateOptions>;
        locationAd: TextTranslator<TranslateOptions>;
        locationConversionTypeAd: TextTranslator<TranslateOptions>;
        locationConversionTypeKeyword: TextTranslator<TranslateOptions>;
        locationKeyword: TextTranslator<TranslateOptions>;
        loginDate: TextTranslator<TranslateOptions>;
        mailchimp: {
            title: TextTranslator<TranslateOptions>;
        };
        maximumSpend: TextTranslator<TranslateOptions>;
        maximumSpendHint: TextTranslator<TranslateOptions>;
        moreRows: TextTranslator<ReportMoreRowsOptions>;
        moreRowsPlural: TextTranslator<ReportMoreRowsPluralOptions>;
        mostUsedActivities: TextTranslator<TranslateOptions>;
        multipleLocationReport: TextTranslator<TranslateOptions>;
        newFollowers: TextTranslator<TranslateOptions>;
        newLikes: TextTranslator<TranslateOptions>;
        newPosts: TextTranslator<TranslateOptions>;
        newReportSummary: TextTranslator<TranslateOptions>;
        newVisitors: TextTranslator<TranslateOptions>;
        noAdwordStatsFound: TextTranslator<TranslateOptions>;
        noCampaignsFound: TextTranslator<TranslateOptions>;
        noUnreachedMarketForPeriod: TextTranslator<TranslateOptions>;
        noVisitorsFound: TextTranslator<TranslateOptions>;
        notConnectedPart1: TextTranslator<ReportNotConnectedPart1Options>;
        notConnectedPart2: TextTranslator<ReportNotConnectedPart2Options>;
        notEnoughData: TextTranslator<TranslateOptions>;
        numberOfTemplatesBuilt: TextTranslator<TranslateOptions>;
        organic: TextTranslator<TranslateOptions>;
        overview: {
            emailCampaigns: {
                campaignMonitorCheckBackSoon: TextTranslator<TranslateOptions>;
                campaignMonitorTooltip: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            facebook: {
                title: TextTranslator<TranslateOptions>;
                engagement: TextTranslator<TranslateOptions>;
                engagementHint: TextTranslator<TranslateOptions>;
                engagementRate: TextTranslator<TranslateOptions>;
            };
        };
        paid: TextTranslator<TranslateOptions>;
        paidImpressions: TextTranslator<ReportPaidImpressionsOptions>;
        paidUniqueViews: TextTranslator<ReportPaidUniqueViewsOptions>;
        paidViewsDeprecation: TextTranslator<TranslateOptions>;
        peopleReached: TextTranslator<TranslateOptions>;
        plannedVsAdhoc: {
            builtFromGallery: TextTranslator<TranslateOptions>;
            builtFromPlanner: TextTranslator<TranslateOptions>;
            plannedVsAdhoc: TextTranslator<TranslateOptions>;
        };
        planningAndExecution: TextTranslator<TranslateOptions>;
        platform: TextTranslator<TranslateOptions>;
        popularBuilderTemplateDetails: {
            buttons: {
                downloadCsv: TextTranslator<TranslateOptions>;
                exportCsv: TextTranslator<TranslateOptions>;
            };
            errorExportingCsv: TextTranslator<TranslateOptions>;
            exportingPleaseWait: TextTranslator<TranslateOptions>;
            notifications: {
                exportingError: TextTranslator<TranslateOptions>;
                exportingSuccess: TextTranslator<TranslateOptions>;
            };
        };
        popularCategories: {
            byPlatform: TextTranslator<TranslateOptions>;
            category: TextTranslator<TranslateOptions>;
            orderInGallery: TextTranslator<TranslateOptions>;
            templateCategoryPopularity: TextTranslator<TranslateOptions>;
            timesUsed: TextTranslator<TranslateOptions>;
            totalUses: TextTranslator<TranslateOptions>;
        };
        positiveFeedback: TextTranslator<TranslateOptions>;
        potentialRoi: TextTranslator<TranslateOptions>;
        potentialRoiHint: TextTranslator<TranslateOptions>;
        printThisPage: TextTranslator<TranslateOptions>;
        reach: TextTranslator<TranslateOptions>;
        reached: TextTranslator<TranslateOptions>;
        recipients: TextTranslator<TranslateOptions>;
        recommendations: TextTranslator<TranslateOptions>;
        recommendedSpend: TextTranslator<TranslateOptions>;
        recommendedSpendHint: TextTranslator<TranslateOptions>;
        reportLoadedLocations: TextTranslator<ReportReportLoadedLocationsOptions>;
        reportLoadedLocationsPlural: TextTranslator<ReportReportLoadedLocationsPluralOptions>;
        reportSummary: TextTranslator<TranslateOptions>;
        reportSummaryText: {
            deleted: TextTranslator<TranslateOptions>;
            invalidDateRange: TextTranslator<TranslateOptions>;
            saved: TextTranslator<TranslateOptions>;
        };
        reports: TextTranslator<TranslateOptions>;
        reportsArchived: TextTranslator<TranslateOptions>;
        requestSpendAdjustment: TextTranslator<TranslateOptions>;
        returnOnInvestment: TextTranslator<TranslateOptions>;
        returnOnInvestmentHint: TextTranslator<TranslateOptions>;
        returningVisitors: TextTranslator<TranslateOptions>;
        roi: TextTranslator<TranslateOptions>;
        roiHint: TextTranslator<TranslateOptions>;
        roiPercent: TextTranslator<TranslateOptions>;
        sales: TextTranslator<TranslateOptions>;
        scheduledDate: TextTranslator<TranslateOptions>;
        selectAtLeastOneLocation: TextTranslator<TranslateOptions>;
        selectedLocations: TextTranslator<TranslateOptions>;
        selfServiceEvents: TextTranslator<TranslateOptions>;
        selfServiceOrGeneralEvents: TextTranslator<TranslateOptions>;
        sentDate: TextTranslator<TranslateOptions>;
        showAllRows: TextTranslator<TranslateOptions>;
        showSummary: TextTranslator<TranslateOptions>;
        showTopN: TextTranslator<ReportShowTopNOptions>;
        specialRequests: TextTranslator<TranslateOptions>;
        spend: TextTranslator<TranslateOptions>;
        startDate: TextTranslator<TranslateOptions>;
        startDateBeforeToday: TextTranslator<TranslateOptions>;
        status: TextTranslator<TranslateOptions>;
        summary: TextTranslator<TranslateOptions>;
        supportedEvents: TextTranslator<TranslateOptions>;
        templateUsage: TextTranslator<TranslateOptions>;
        templateUseByLocation: TextTranslator<ReportTemplateUseByLocationOptions>;
        templateUses: TextTranslator<ReportTemplateUsesOptions>;
        templateUsesPlural: TextTranslator<ReportTemplateUsesPluralOptions>;
        templatesBuiltByTime: TextTranslator<TranslateOptions>;
        total: TextTranslator<TranslateOptions>;
        totalCloseRatio: TextTranslator<TranslateOptions>;
        totalConversionWorth: TextTranslator<TranslateOptions>;
        totalConversions: TextTranslator<TranslateOptions>;
        totalEvents: TextTranslator<TranslateOptions>;
        totalImpressions: TextTranslator<ReportTotalImpressionsOptions>;
        totalLeads: TextTranslator<TranslateOptions>;
        totalPosts: TextTranslator<TranslateOptions>;
        totalReachVsTotalPaid: TextTranslator<ReportTotalReachVsTotalPaidOptions>;
        totalSales: TextTranslator<TranslateOptions>;
        totalSpend: TextTranslator<TranslateOptions>;
        totalUniqueViews: TextTranslator<ReportTotalUniqueViewsOptions>;
        totalVisitors: TextTranslator<TranslateOptions>;
        tourCloseRatio: TextTranslator<TranslateOptions>;
        tourSale: TextTranslator<TranslateOptions>;
        tourShowUps: TextTranslator<TranslateOptions>;
        types: {
            emailCampaigns: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            facebook: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            googleMyBusiness: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            instagram: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            overview: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            paidMedia: {
                name: TextTranslator<TranslateOptions>;
                title: TextTranslator<TranslateOptions>;
            };
            title: TextTranslator<TranslateOptions>;
        };
        uniqueClicks: TextTranslator<TranslateOptions>;
        uniqueOpened: TextTranslator<TranslateOptions>;
        unreachedMarket: TextTranslator<TranslateOptions>;
        unreachedMarketHint: TextTranslator<TranslateOptions>;
        valuePerConversion: TextTranslator<TranslateOptions>;
        visitors: TextTranslator<TranslateOptions>;
        waitForLocations: TextTranslator<TranslateOptions>;
        walkInCloseRatio: TextTranslator<TranslateOptions>;
        walkInSale: TextTranslator<TranslateOptions>;
        walkInTotal: TextTranslator<TranslateOptions>;
        website: TextTranslator<TranslateOptions>;
    };
    requests: {
        alreadyPaidDifference: TextTranslator<RequestsAlreadyPaidDifferenceOptions>;
        amendmentsRequested: TextTranslator<TranslateOptions>;
        awaitingApproval: TextTranslator<TranslateOptions>;
        awaitingHeadOfficeApproval: TextTranslator<TranslateOptions>;
        beginPayment: TextTranslator<TranslateOptions>;
        brief: TextTranslator<TranslateOptions>;
        clickToLoadClosedRequests: TextTranslator<TranslateOptions>;
        clientLocation: TextTranslator<TranslateOptions>;
        closed: TextTranslator<TranslateOptions>;
        dateRequestedBy: TextTranslator<TranslateOptions>;
        dateRequiredBy: TextTranslator<TranslateOptions>;
        dateSubmitted: TextTranslator<TranslateOptions>;
        deliverables: TextTranslator<TranslateOptions>;
        emails: {
            added: {
                newSpecialRequest: TextTranslator<RequestsEmailsAddedNewSpecialRequestOptions>;
                requestIsDueBy: TextTranslator<RequestsEmailsAddedRequestIsDueByOptions>;
            };
            commentAdded: {
                specialRequestHasBeenUpdated: TextTranslator<RequestsEmailsCommentAddedSpecialRequestHasBeenUpdatedOptions>;
                subjectLine: TextTranslator<RequestsEmailsCommentAddedSubjectLineOptions>;
            };
            viewSpecialRequest: TextTranslator<TranslateOptions>;
        };
        escalated: TextTranslator<TranslateOptions>;
        failedToGetSpecialRequest: TextTranslator<TranslateOptions>;
        failedToGetSpecialRequests: TextTranslator<TranslateOptions>;
        filter: {
            client: TextTranslator<TranslateOptions>;
            date: TextTranslator<TranslateOptions>;
            status: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
        };
        id: TextTranslator<TranslateOptions>;
        inProgress: TextTranslator<TranslateOptions>;
        invalidDateRequiredBy: TextTranslator<TranslateOptions>;
        loadManagersFailed: TextTranslator<TranslateOptions>;
        moreInfoRequired: TextTranslator<TranslateOptions>;
        newRequest: TextTranslator<TranslateOptions>;
        payment: TextTranslator<RequestsPaymentOptions>;
        paymentOverpaid: TextTranslator<RequestsPaymentOverpaidOptions>;
        paymentRequired: TextTranslator<TranslateOptions>;
        pleaseEnterDeliverables: TextTranslator<TranslateOptions>;
        previousQuoteDifference: TextTranslator<RequestsPreviousQuoteDifferenceOptions>;
        quote: TextTranslator<TranslateOptions>;
        quoteApproved: TextTranslator<TranslateOptions>;
        quoteRejected: TextTranslator<TranslateOptions>;
        quoteSent: TextTranslator<TranslateOptions>;
        quoted: TextTranslator<TranslateOptions>;
        requestSaved: TextTranslator<TranslateOptions>;
        retrieveSpecialRequest: TextTranslator<TranslateOptions>;
        saveSpecialRequest: TextTranslator<TranslateOptions>;
        selectedDeliverables: TextTranslator<TranslateOptions>;
        sendQuote: TextTranslator<TranslateOptions>;
        status: TextTranslator<TranslateOptions>;
        submitted: TextTranslator<TranslateOptions>;
        updated: TextTranslator<TranslateOptions>;
    };
    roadmap: {
        later: {
            heading: TextTranslator<TranslateOptions>;
            items: {
                item1: TextTranslator<TranslateOptions>;
                item2: TextTranslator<TranslateOptions>;
                item3: TextTranslator<TranslateOptions>;
                item4: TextTranslator<TranslateOptions>;
                item5: TextTranslator<TranslateOptions>;
            };
        };
        next: {
            heading: TextTranslator<TranslateOptions>;
            items: {
                item1: TextTranslator<TranslateOptions>;
                item2: TextTranslator<TranslateOptions>;
                item3: TextTranslator<TranslateOptions>;
                item4: TextTranslator<TranslateOptions>;
                item5: TextTranslator<TranslateOptions>;
                item6: TextTranslator<TranslateOptions>;
                item7: TextTranslator<TranslateOptions>;
                item8: TextTranslator<TranslateOptions>;
            };
        };
        now: {
            heading: TextTranslator<TranslateOptions>;
            items: {
                item1: TextTranslator<TranslateOptions>;
                item2: TextTranslator<TranslateOptions>;
                item3: TextTranslator<TranslateOptions>;
                item4: TextTranslator<TranslateOptions>;
                item5: TextTranslator<TranslateOptions>;
                item6: TextTranslator<TranslateOptions>;
                item7: TextTranslator<TranslateOptions>;
                item8: TextTranslator<TranslateOptions>;
            };
        };
        recentlyDelivered: {
            heading: TextTranslator<TranslateOptions>;
            items: {
                item1: TextTranslator<TranslateOptions>;
                item2: TextTranslator<TranslateOptions>;
                item3: TextTranslator<TranslateOptions>;
                item4: TextTranslator<TranslateOptions>;
                item5: TextTranslator<TranslateOptions>;
                item6: TextTranslator<TranslateOptions>;
            };
        };
    };
    schedule: {
        emails: {
            downloadTheApp: TextTranslator<TranslateOptions>;
            failedToNotify: {
                content: TextTranslator<ScheduleEmailsFailedToNotifyContentOptions>;
                heading1: TextTranslator<ScheduleEmailsFailedToNotifyHeading1Options>;
                subjectLine: TextTranslator<ScheduleEmailsFailedToNotifySubjectLineOptions>;
            };
            noDevices: {
                content1: TextTranslator<ScheduleEmailsNoDevicesContent1Options>;
                content2: TextTranslator<TranslateOptions>;
                content3: TextTranslator<TranslateOptions>;
                heading1: TextTranslator<TranslateOptions>;
                subjectLine: TextTranslator<TranslateOptions>;
            };
        };
        page: {
            dialogs: {
                delete: {
                    confirm: TextTranslator<TranslateOptions>;
                    disabledLegacy: TextTranslator<TranslateOptions>;
                    disabledScheduling: TextTranslator<TranslateOptions>;
                    failedToDelete: TextTranslator<TranslateOptions>;
                    optionForMultiple: TextTranslator<SchedulePageDialogsDeleteOptionForMultipleOptions>;
                    optionForSingle: TextTranslator<SchedulePageDialogsDeleteOptionForSingleOptions>;
                    successfullyDeletedPost: TextTranslator<TranslateOptions>;
                    title: TextTranslator<TranslateOptions>;
                };
                editCaption: {
                    contactingPlatform: TextTranslator<SchedulePageDialogsEditCaptionContactingPlatformOptions>;
                    failedToEdit: TextTranslator<TranslateOptions>;
                    optionForMultiple: TextTranslator<SchedulePageDialogsEditCaptionOptionForMultipleOptions>;
                    optionForSingle: TextTranslator<SchedulePageDialogsEditCaptionOptionForSingleOptions>;
                    successfullyEditedCaption: TextTranslator<TranslateOptions>;
                    title: TextTranslator<TranslateOptions>;
                };
                reschedule: {
                    confirm: TextTranslator<TranslateOptions>;
                    deleted: TextTranslator<SchedulePageDialogsRescheduleDeletedOptions>;
                    disabledLegacy: TextTranslator<TranslateOptions>;
                    disabledScheduling: TextTranslator<TranslateOptions>;
                    failedToReschedule: TextTranslator<TranslateOptions>;
                    optionForMultiple: TextTranslator<SchedulePageDialogsRescheduleOptionForMultipleOptions>;
                    optionForSingle: TextTranslator<SchedulePageDialogsRescheduleOptionForSingleOptions>;
                    successfullyRescheduledPost: TextTranslator<TranslateOptions>;
                    title: TextTranslator<TranslateOptions>;
                };
            };
            headerTitle: TextTranslator<TranslateOptions>;
            reschedule: TextTranslator<TranslateOptions>;
            table: {
                headers: {
                    action: TextTranslator<TranslateOptions>;
                    caption: TextTranslator<TranslateOptions>;
                    locations: TextTranslator<TranslateOptions>;
                    post: TextTranslator<TranslateOptions>;
                    time: TextTranslator<TranslateOptions>;
                };
                loadNewerPosts: TextTranslator<TranslateOptions>;
                loadOlderPosts: TextTranslator<TranslateOptions>;
                noScheduledPostsFoundForPlatform: TextTranslator<SchedulePageTableNoScheduledPostsFoundForPlatformOptions>;
            };
        };
        posts: {
            caption: TextTranslator<TranslateOptions>;
            copiedToClipboard: TextTranslator<TranslateOptions>;
            copiedToClipboardFailed: TextTranslator<TranslateOptions>;
            copyCaption: TextTranslator<TranslateOptions>;
            downloadImage: TextTranslator<TranslateOptions>;
            getScheduledDetails: TextTranslator<TranslateOptions>;
            postDetailsSms: TextTranslator<SchedulePostsPostDetailsSmsOptions>;
            postImmediately: TextTranslator<SchedulePostsPostImmediatelyOptions>;
            postScheduledFor: TextTranslator<SchedulePostsPostScheduledForOptions>;
            smsDownloadMessage: TextTranslator<SchedulePostsSmsDownloadMessageOptions>;
            unableToFindPost: TextTranslator<TranslateOptions>;
            unableToFindPostHeading: TextTranslator<TranslateOptions>;
        };
        pushNotifications: {
            timeToPost: TextTranslator<SchedulePushNotificationsTimeToPostOptions>;
        };
        scheduledWithMobileApp: TextTranslator<TranslateOptions>;
    };
    shoppingCart: {
        addToCart: TextTranslator<TranslateOptions>;
        checkout: {
            address: TextTranslator<ShoppingCartCheckoutAddressOptions>;
            cardDetails: TextTranslator<TranslateOptions>;
            checkout: TextTranslator<TranslateOptions>;
            completePayment: TextTranslator<TranslateOptions>;
            deleteItem: TextTranslator<TranslateOptions>;
            deleteItemConfirmation: TextTranslator<TranslateOptions>;
            incTax: TextTranslator<TranslateOptions>;
            locations: TextTranslator<ShoppingCartCheckoutLocationsOptions>;
            payAmount: TextTranslator<ShoppingCartCheckoutPayAmountOptions>;
            paymentPending: TextTranslator<TranslateOptions>;
            paymentSuccessful: TextTranslator<TranslateOptions>;
            printOrder: TextTranslator<TranslateOptions>;
            printProviderNotConfiguredProperly: TextTranslator<TranslateOptions>;
            purchaseComplete: TextTranslator<TranslateOptions>;
            quantity: TextTranslator<ShoppingCartCheckoutQuantityOptions>;
            shipping: TextTranslator<TranslateOptions>;
            shippingDetailsInvalid: TextTranslator<TranslateOptions>;
            updateItemQuantity: TextTranslator<TranslateOptions>;
            viewReceipt: TextTranslator<TranslateOptions>;
            yourReceiptCanBeViewedBelow: TextTranslator<TranslateOptions>;
        };
        checkoutNow: TextTranslator<TranslateOptions>;
        checkoutYourPrintItems: TextTranslator<TranslateOptions>;
        emails: {
            date: TextTranslator<ShoppingCartEmailsDateOptions>;
            orderNumber: TextTranslator<ShoppingCartEmailsOrderNumberOptions>;
            printOrderForProvider: {
                agency: TextTranslator<ShoppingCartEmailsPrintOrderForProviderAgencyOptions>;
                client: TextTranslator<ShoppingCartEmailsPrintOrderForProviderClientOptions>;
                contactEmail: TextTranslator<ShoppingCartEmailsPrintOrderForProviderContactEmailOptions>;
                orderReceived: TextTranslator<ShoppingCartEmailsPrintOrderForProviderOrderReceivedOptions>;
                subjectLine: TextTranslator<ShoppingCartEmailsPrintOrderForProviderSubjectLineOptions>;
            };
            printOrderForUser: {
                orderReceived: TextTranslator<ShoppingCartEmailsPrintOrderForUserOrderReceivedOptions>;
                printProvider: TextTranslator<ShoppingCartEmailsPrintOrderForUserPrintProviderOptions>;
                printProviderEmail: TextTranslator<ShoppingCartEmailsPrintOrderForUserPrintProviderEmailOptions>;
                subjectLine: TextTranslator<ShoppingCartEmailsPrintOrderForUserSubjectLineOptions>;
            };
        };
        fetchItemCount: TextTranslator<TranslateOptions>;
        fetchOrders: TextTranslator<TranslateOptions>;
        printRequestAddedToCart: TextTranslator<TranslateOptions>;
    };
    stats: {
        emails: {
            accessTokenError: {
                accessErrorFor: TextTranslator<StatsEmailsAccessTokenErrorAccessErrorForOptions>;
                authorizeService: TextTranslator<StatsEmailsAccessTokenErrorAuthorizeServiceOptions>;
                ifAccessToIsNoLongerRequired: TextTranslator<StatsEmailsAccessTokenErrorIfAccessToIsNoLongerRequiredOptions>;
                ifNotResolvedContactSupport: TextTranslator<TranslateOptions>;
                subjectLine: TextTranslator<StatsEmailsAccessTokenErrorSubjectLineOptions>;
                tryLoggingInAndReAuthorizing: TextTranslator<StatsEmailsAccessTokenErrorTryLoggingInAndReAuthorizingOptions>;
                weHadAProblemTryingToAccess: TextTranslator<StatsEmailsAccessTokenErrorWeHadAProblemTryingToAccessOptions>;
            };
        };
    };
    terms: {
        heading: TextTranslator<TranslateOptions>;
        section01: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
            partA: TextTranslator<TranslateOptions>;
            partB: TextTranslator<TranslateOptions>;
        };
        section02: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
        };
        section03: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
        };
        section04: {
            heading: TextTranslator<TranslateOptions>;
            part01: TextTranslator<TranslateOptions>;
            part02: TextTranslator<TranslateOptions>;
        };
        section05: {
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
                partC: TextTranslator<TranslateOptions>;
                partD: TextTranslator<TranslateOptions>;
            };
        };
        section06: {
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
                partC: TextTranslator<TranslateOptions>;
                partD: TextTranslator<TranslateOptions>;
                partE: TextTranslator<TranslateOptions>;
                partF: TextTranslator<TranslateOptions>;
                partG: TextTranslator<TranslateOptions>;
            };
            part02: {
                heading: TextTranslator<TranslateOptions>;
            };
        };
        section07: {
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
            };
            part02: {
                heading: TextTranslator<TranslateOptions>;
            };
            part03: {
                heading: TextTranslator<TranslateOptions>;
            };
            part04: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
            };
            part05: {
                heading: TextTranslator<TranslateOptions>;
            };
        };
        section08: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
            partA: TextTranslator<TranslateOptions>;
            partB: TextTranslator<TranslateOptions>;
        };
        section09: {
            heading: TextTranslator<TranslateOptions>;
            part01: TextTranslator<TranslateOptions>;
            part02: TextTranslator<TranslateOptions>;
        };
        section10: {
            heading: TextTranslator<TranslateOptions>;
            partA: {
                heading: TextTranslator<TranslateOptions>;
                part01: TextTranslator<TranslateOptions>;
                part02: TextTranslator<TranslateOptions>;
                part03: TextTranslator<TranslateOptions>;
                part04: TextTranslator<TranslateOptions>;
                part05: TextTranslator<TranslateOptions>;
            };
            partB: {
                heading: TextTranslator<TranslateOptions>;
                part01: TextTranslator<TranslateOptions>;
                part02: TextTranslator<TranslateOptions>;
                part03: TextTranslator<TranslateOptions>;
                part04: TextTranslator<TranslateOptions>;
            };
        };
        section11: {
            heading: TextTranslator<TranslateOptions>;
            partA: {
                heading: TextTranslator<TranslateOptions>;
                part01: TextTranslator<TranslateOptions>;
                part02: TextTranslator<TranslateOptions>;
                part03: TextTranslator<TranslateOptions>;
                part04: TextTranslator<TranslateOptions>;
                part05: TextTranslator<TranslateOptions>;
                part06: TextTranslator<TranslateOptions>;
            };
            partB: {
                heading: TextTranslator<TranslateOptions>;
            };
        };
        section12: {
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
            };
            part02: TextTranslator<TranslateOptions>;
            part03: TextTranslator<TranslateOptions>;
        };
        section13: {
            heading: TextTranslator<TranslateOptions>;
            part01: TextTranslator<TranslateOptions>;
            part02: TextTranslator<TranslateOptions>;
        };
        section14: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
        };
        section15: {
            heading: TextTranslator<TranslateOptions>;
            part01: TextTranslator<TranslateOptions>;
            part02: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: {
                    heading: TextTranslator<TranslateOptions>;
                    part01: TextTranslator<TranslateOptions>;
                    part02: TextTranslator<TranslateOptions>;
                };
                partC: TextTranslator<TranslateOptions>;
            };
        };
        section16: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
                partC: TextTranslator<TranslateOptions>;
                partD: {
                    heading: TextTranslator<TranslateOptions>;
                    part01: TextTranslator<TranslateOptions>;
                    part02: TextTranslator<TranslateOptions>;
                    part03: TextTranslator<TranslateOptions>;
                    part04: TextTranslator<TranslateOptions>;
                    part05: TextTranslator<TranslateOptions>;
                    part06: TextTranslator<TranslateOptions>;
                    part07: TextTranslator<TranslateOptions>;
                    part08: TextTranslator<TranslateOptions>;
                    part09: TextTranslator<TranslateOptions>;
                };
            };
        };
        section17: {
            heading: TextTranslator<TranslateOptions>;
            part01: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
                partC: TextTranslator<TranslateOptions>;
                partD: TextTranslator<TranslateOptions>;
                partE: TextTranslator<TranslateOptions>;
            };
            part02: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
                partC: TextTranslator<TranslateOptions>;
                partD: TextTranslator<TranslateOptions>;
            };
            part03: {
                heading: TextTranslator<TranslateOptions>;
                partA: TextTranslator<TranslateOptions>;
                partB: TextTranslator<TranslateOptions>;
            };
        };
        section18: {
            description: TextTranslator<TranslateOptions>;
            heading: TextTranslator<TranslateOptions>;
        };
        section19: {
            heading: TextTranslator<TranslateOptions>;
            partA: TextTranslator<TranslateOptions>;
            partB: TextTranslator<TranslateOptions>;
            partC: TextTranslator<TranslateOptions>;
            partD: TextTranslator<TranslateOptions>;
            partE: TextTranslator<TranslateOptions>;
            partF: TextTranslator<TranslateOptions>;
            partG: TextTranslator<TranslateOptions>;
            partH: TextTranslator<TranslateOptions>;
        };
    };
    timezones: {
        adak: TextTranslator<TranslateOptions>;
        adelaide: TextTranslator<TranslateOptions>;
        almaty: TextTranslator<TranslateOptions>;
        amman: TextTranslator<TranslateOptions>;
        anchorage: TextTranslator<TranslateOptions>;
        apia: TextTranslator<TranslateOptions>;
        araguaina: TextTranslator<TranslateOptions>;
        astrakhan: TextTranslator<TranslateOptions>;
        asuncion: TextTranslator<TranslateOptions>;
        auckland: TextTranslator<TranslateOptions>;
        azores: TextTranslator<TranslateOptions>;
        baghdad: TextTranslator<TranslateOptions>;
        bahia: TextTranslator<TranslateOptions>;
        baku: TextTranslator<TranslateOptions>;
        bangkok: TextTranslator<TranslateOptions>;
        barnaul: TextTranslator<TranslateOptions>;
        beirut: TextTranslator<TranslateOptions>;
        berlin: TextTranslator<TranslateOptions>;
        bogota: TextTranslator<TranslateOptions>;
        bougainville: TextTranslator<TranslateOptions>;
        brisbane: TextTranslator<TranslateOptions>;
        bucharest: TextTranslator<TranslateOptions>;
        budapest: TextTranslator<TranslateOptions>;
        buenosAires: TextTranslator<TranslateOptions>;
        cairo: TextTranslator<TranslateOptions>;
        calcutta: TextTranslator<TranslateOptions>;
        cancun: TextTranslator<TranslateOptions>;
        capeVerde: TextTranslator<TranslateOptions>;
        caracas: TextTranslator<TranslateOptions>;
        casablanca: TextTranslator<TranslateOptions>;
        cayenne: TextTranslator<TranslateOptions>;
        chatham: TextTranslator<TranslateOptions>;
        chicago: TextTranslator<TranslateOptions>;
        chihuahua: TextTranslator<TranslateOptions>;
        chisinau: TextTranslator<TranslateOptions>;
        chita: TextTranslator<TranslateOptions>;
        colombo: TextTranslator<TranslateOptions>;
        cuiaba: TextTranslator<TranslateOptions>;
        damascus: TextTranslator<TranslateOptions>;
        darwin: TextTranslator<TranslateOptions>;
        denver: TextTranslator<TranslateOptions>;
        dhaka: TextTranslator<TranslateOptions>;
        dubai: TextTranslator<TranslateOptions>;
        easter: TextTranslator<TranslateOptions>;
        edmonton: TextTranslator<TranslateOptions>;
        enderbury: TextTranslator<TranslateOptions>;
        eucla: TextTranslator<TranslateOptions>;
        fiji: TextTranslator<TranslateOptions>;
        gambier: TextTranslator<TranslateOptions>;
        godthab: TextTranslator<TranslateOptions>;
        grandTurk: TextTranslator<TranslateOptions>;
        guadalcanal: TextTranslator<TranslateOptions>;
        guatemala: TextTranslator<TranslateOptions>;
        halifax: TextTranslator<TranslateOptions>;
        havana: TextTranslator<TranslateOptions>;
        hebron: TextTranslator<TranslateOptions>;
        hoChiMinh: TextTranslator<TranslateOptions>;
        hobart: TextTranslator<TranslateOptions>;
        honolulu: TextTranslator<TranslateOptions>;
        hovd: TextTranslator<TranslateOptions>;
        indianapolis: TextTranslator<TranslateOptions>;
        irkutsk: TextTranslator<TranslateOptions>;
        istanbul: TextTranslator<TranslateOptions>;
        jerusalem: TextTranslator<TranslateOptions>;
        johannesburg: TextTranslator<TranslateOptions>;
        juba: TextTranslator<TranslateOptions>;
        kabul: TextTranslator<TranslateOptions>;
        kaliningrad: TextTranslator<TranslateOptions>;
        kamchatka: TextTranslator<TranslateOptions>;
        karachi: TextTranslator<TranslateOptions>;
        katmandu: TextTranslator<TranslateOptions>;
        khartoum: TextTranslator<TranslateOptions>;
        kiev: TextTranslator<TranslateOptions>;
        kiritimati: TextTranslator<TranslateOptions>;
        krasnoyarsk: TextTranslator<TranslateOptions>;
        kualaLumpur: TextTranslator<TranslateOptions>;
        laPaz: TextTranslator<TranslateOptions>;
        lagos: TextTranslator<TranslateOptions>;
        london: TextTranslator<TranslateOptions>;
        lordHowe: TextTranslator<TranslateOptions>;
        losAngeles: TextTranslator<TranslateOptions>;
        magadan: TextTranslator<TranslateOptions>;
        manila: TextTranslator<TranslateOptions>;
        marquesas: TextTranslator<TranslateOptions>;
        mauritius: TextTranslator<TranslateOptions>;
        melbourne: TextTranslator<TranslateOptions>;
        mexicoCity: TextTranslator<TranslateOptions>;
        minsk: TextTranslator<TranslateOptions>;
        miquelon: TextTranslator<TranslateOptions>;
        montevideo: TextTranslator<TranslateOptions>;
        moscow: TextTranslator<TranslateOptions>;
        nairobi: TextTranslator<TranslateOptions>;
        newYork: TextTranslator<TranslateOptions>;
        newfoundland: TextTranslator<TranslateOptions>;
        norfolk: TextTranslator<TranslateOptions>;
        noronha: TextTranslator<TranslateOptions>;
        novosibirsk: TextTranslator<TranslateOptions>;
        omsk: TextTranslator<TranslateOptions>;
        pagoPago: TextTranslator<TranslateOptions>;
        paris: TextTranslator<TranslateOptions>;
        perth: TextTranslator<TranslateOptions>;
        phoenix: TextTranslator<TranslateOptions>;
        pitcairn: TextTranslator<TranslateOptions>;
        portAuPrince: TextTranslator<TranslateOptions>;
        portMoresby: TextTranslator<TranslateOptions>;
        puntaArenas: TextTranslator<TranslateOptions>;
        pyongyang: TextTranslator<TranslateOptions>;
        qyzylorda: TextTranslator<TranslateOptions>;
        rangoon: TextTranslator<TranslateOptions>;
        regina: TextTranslator<TranslateOptions>;
        reykjavik: TextTranslator<TranslateOptions>;
        riyadh: TextTranslator<TranslateOptions>;
        sakhalin: TextTranslator<TranslateOptions>;
        samara: TextTranslator<TranslateOptions>;
        santiago: TextTranslator<TranslateOptions>;
        saoPaulo: TextTranslator<TranslateOptions>;
        saoTome: TextTranslator<TranslateOptions>;
        saratov: TextTranslator<TranslateOptions>;
        seoul: TextTranslator<TranslateOptions>;
        shanghai: TextTranslator<TranslateOptions>;
        singapore: TextTranslator<TranslateOptions>;
        srednekolymsk: TextTranslator<TranslateOptions>;
        stJohns: TextTranslator<TranslateOptions>;
        sydney: TextTranslator<TranslateOptions>;
        taipei: TextTranslator<TranslateOptions>;
        tarawa: TextTranslator<TranslateOptions>;
        tashkent: TextTranslator<TranslateOptions>;
        tbilisi: TextTranslator<TranslateOptions>;
        tehran: TextTranslator<TranslateOptions>;
        tijuana: TextTranslator<TranslateOptions>;
        tokyo: TextTranslator<TranslateOptions>;
        tomsk: TextTranslator<TranslateOptions>;
        tongatapu: TextTranslator<TranslateOptions>;
        toronto: TextTranslator<TranslateOptions>;
        tripoli: TextTranslator<TranslateOptions>;
        ulaanbaatar: TextTranslator<TranslateOptions>;
        vancouver: TextTranslator<TranslateOptions>;
        vladivostok: TextTranslator<TranslateOptions>;
        volgograd: TextTranslator<TranslateOptions>;
        warsaw: TextTranslator<TranslateOptions>;
        whitehorse: TextTranslator<TranslateOptions>;
        windhoek: TextTranslator<TranslateOptions>;
        winnipeg: TextTranslator<TranslateOptions>;
        yakutsk: TextTranslator<TranslateOptions>;
        yekaterinburg: TextTranslator<TranslateOptions>;
        yerevan: TextTranslator<TranslateOptions>;
    };
    user: {
        bulkDeleteModal: {
            confirmText: TextTranslator<TranslateOptions>;
            hasErrorsMessage: TextTranslator<UserBulkDeleteModalHasErrorsMessageOptions>;
            message: TextTranslator<TranslateOptions>;
            messagePlural: TextTranslator<UserBulkDeleteModalMessagePluralOptions>;
            submitButton: TextTranslator<TranslateOptions>;
            submitButtonPlural: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            titlePlural: TextTranslator<TranslateOptions>;
            toasts: {
                error: TextTranslator<TranslateOptions>;
                success: TextTranslator<TranslateOptions>;
            };
        };
        bulkResetPasswordsModal: {
            buttonSendBoth: TextTranslator<TranslateOptions>;
            buttonSendPasswordResets: TextTranslator<TranslateOptions>;
            buttonSendUserInvites: TextTranslator<TranslateOptions>;
            confirmResendInvite: TextTranslator<UserBulkResetPasswordsModalConfirmResendInviteOptions>;
            confirmSendPasswordReset: TextTranslator<UserBulkResetPasswordsModalConfirmSendPasswordResetOptions>;
            description: TextTranslator<TranslateOptions>;
            fetchUserErrorMessage: TextTranslator<UserBulkResetPasswordsModalFetchUserErrorMessageOptions>;
            notifyPartialError: TextTranslator<TranslateOptions>;
            notifySendBothSuccess: TextTranslator<TranslateOptions>;
            notifySendPasswordResetsSuccess: TextTranslator<TranslateOptions>;
            notifySendUserInvitesSuccess: TextTranslator<TranslateOptions>;
            resendUserInvitesTitle: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            usersWithoutAcceptedInviteMessage: TextTranslator<UserBulkResetPasswordsModalUsersWithoutAcceptedInviteMessageOptions>;
        };
        bulkUpdateLocationsModal: {
            addLocationsCountText: TextTranslator<UserBulkUpdateLocationsModalAddLocationsCountTextOptions>;
            addLocationsCountTooltip: TextTranslator<TranslateOptions>;
            confirmText: TextTranslator<UserBulkUpdateLocationsModalConfirmTextOptions>;
            confirmTitle: TextTranslator<TranslateOptions>;
            hasErrorsMessage: TextTranslator<UserBulkUpdateLocationsModalHasErrorsMessageOptions>;
            message: TextTranslator<TranslateOptions>;
            removeLocationsCountText: TextTranslator<UserBulkUpdateLocationsModalRemoveLocationsCountTextOptions>;
            removeLocationsCountTooltip: TextTranslator<TranslateOptions>;
            submitButton: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            toasts: {
                error: TextTranslator<TranslateOptions>;
                success: TextTranslator<TranslateOptions>;
            };
        };
        bulkUpdateRolesModal: {
            addRolesCountText: TextTranslator<UserBulkUpdateRolesModalAddRolesCountTextOptions>;
            addRolesCountTextPlural: TextTranslator<UserBulkUpdateRolesModalAddRolesCountTextPluralOptions>;
            addRolesCountTooltip: TextTranslator<TranslateOptions>;
            addRolesCountTooltipPlural: TextTranslator<TranslateOptions>;
            confirmText: TextTranslator<UserBulkUpdateRolesModalConfirmTextOptions>;
            confirmTitle: TextTranslator<TranslateOptions>;
            existingTitle: TextTranslator<UserBulkUpdateRolesModalExistingTitleOptions>;
            hasErrorsMessage: TextTranslator<UserBulkUpdateRolesModalHasErrorsMessageOptions>;
            message: TextTranslator<TranslateOptions>;
            newRoleTooltip: TextTranslator<TranslateOptions>;
            newTitle: TextTranslator<UserBulkUpdateRolesModalNewTitleOptions>;
            partialExistingRoleTooltip: TextTranslator<TranslateOptions>;
            removeRolesCountText: TextTranslator<UserBulkUpdateRolesModalRemoveRolesCountTextOptions>;
            removeRolesCountTextPlural: TextTranslator<UserBulkUpdateRolesModalRemoveRolesCountTextPluralOptions>;
            removeRolesCountTooltip: TextTranslator<TranslateOptions>;
            removeRolesCountTooltipPlural: TextTranslator<TranslateOptions>;
            removedTitle: TextTranslator<UserBulkUpdateRolesModalRemovedTitleOptions>;
            roleListTitle: TextTranslator<TranslateOptions>;
            selectedRolesListTitle: TextTranslator<UserBulkUpdateRolesModalSelectedRolesListTitleOptions>;
            submitButton: TextTranslator<TranslateOptions>;
            title: TextTranslator<TranslateOptions>;
            toasts: {
                error: TextTranslator<TranslateOptions>;
                success: TextTranslator<TranslateOptions>;
            };
        };
        editUserDetails: {
            addNotifications: TextTranslator<TranslateOptions>;
            addRole: TextTranslator<TranslateOptions>;
            confirmDeleteUser: TextTranslator<TranslateOptions>;
            headers: {
                assignedLocations: TextTranslator<TranslateOptions>;
                guidedTour: TextTranslator<TranslateOptions>;
                notifications: TextTranslator<TranslateOptions>;
                roles: TextTranslator<TranslateOptions>;
                userDetails: TextTranslator<TranslateOptions>;
            };
            notifyDeleteUserSuccess: TextTranslator<TranslateOptions>;
            notifySendPasswordResetSuccess: TextTranslator<TranslateOptions>;
            notifyUpdateUserDetailsSuccess: TextTranslator<TranslateOptions>;
            saveAssignedLocations: TextTranslator<TranslateOptions>;
            saveUserDetails: TextTranslator<TranslateOptions>;
            selectOptions: {
                deleteUser: TextTranslator<TranslateOptions>;
                placeholder: TextTranslator<TranslateOptions>;
                sendPasswordResetEmail: TextTranslator<TranslateOptions>;
            };
        };
        usersLocationsBox: {
            existingLocationsTitle: TextTranslator<UserUsersLocationsBoxExistingLocationsTitleOptions>;
            newLocationsTitle: TextTranslator<UserUsersLocationsBoxNewLocationsTitleOptions>;
            removedLocationsTitle: TextTranslator<UserUsersLocationsBoxRemovedLocationsTitleOptions>;
            rightTitle: TextTranslator<UserUsersLocationsBoxRightTitleOptions>;
        };
    };
}

export function makeTextService(localeCode?: string): TextTranslators {
    const text = {
        account: {
            accountAlreadyExists: makeTranslator(KEYS.ACCOUNT.ACCOUNT_ALREADY_EXISTS, localeCode),
            createAccount: makeTranslator(KEYS.ACCOUNT.CREATE_ACCOUNT, localeCode),
            details: {
                accountDetailsUpdated: makeTranslator(KEYS.ACCOUNT.DETAILS.ACCOUNT_DETAILS_UPDATED, localeCode),
                addressLineOne: makeTranslator(KEYS.ACCOUNT.DETAILS.ADDRESS_LINE_ONE, localeCode),
                addressLineThree: makeTranslator(KEYS.ACCOUNT.DETAILS.ADDRESS_LINE_THREE, localeCode),
                addressLineTwo: makeTranslator(KEYS.ACCOUNT.DETAILS.ADDRESS_LINE_TWO, localeCode),
                attentionTo: makeTranslator(KEYS.ACCOUNT.DETAILS.ATTENTION_TO, localeCode),
                billingDetails: makeTranslator(KEYS.ACCOUNT.DETAILS.BILLING_DETAILS, localeCode),
                companyName: makeTranslator(KEYS.ACCOUNT.DETAILS.COMPANY_NAME, localeCode),
                contactDetails: makeTranslator(KEYS.ACCOUNT.DETAILS.CONTACT_DETAILS, localeCode),
                country: makeTranslator(KEYS.ACCOUNT.DETAILS.COUNTRY, localeCode),
                displayAddress: makeTranslator(KEYS.ACCOUNT.DETAILS.DISPLAY_ADDRESS, localeCode),
                failedToUpdateAccountDetails: makeTranslator(KEYS.ACCOUNT.DETAILS.FAILED_TO_UPDATE_ACCOUNT_DETAILS, localeCode),
                imageMustBeSquareAndAtLeastMinimumSize: makeTranslator(KEYS.ACCOUNT.DETAILS.IMAGE_MUST_BE_SQUARE_AND_AT_LEAST_MINIMUM_SIZE, localeCode),
                locationDetails: makeTranslator(KEYS.ACCOUNT.DETAILS.LOCATION_DETAILS, localeCode),
                locationDetailsSaved: makeTranslator(KEYS.ACCOUNT.DETAILS.LOCATION_DETAILS_SAVED, localeCode),
                locationEmail: makeTranslator(KEYS.ACCOUNT.DETAILS.LOCATION_EMAIL, localeCode),
                locationLogo: makeTranslator(KEYS.ACCOUNT.DETAILS.LOCATION_LOGO, localeCode),
                locationPhoneNumber: makeTranslator(KEYS.ACCOUNT.DETAILS.LOCATION_PHONE_NUMBER, localeCode),
                minimumImageDimensionRequirement: makeTranslator(KEYS.ACCOUNT.DETAILS.MINIMUM_IMAGE_DIMENSION_REQUIREMENT, localeCode),
                notes: makeTranslator(KEYS.ACCOUNT.DETAILS.NOTES, localeCode),
                phone: makeTranslator(KEYS.ACCOUNT.DETAILS.PHONE, localeCode),
                postcode: makeTranslator(KEYS.ACCOUNT.DETAILS.POSTCODE, localeCode),
                preferredMeetingTimes: makeTranslator(KEYS.ACCOUNT.DETAILS.PREFERRED_MEETING_TIMES, localeCode),
                sameAsContactDetails: makeTranslator(KEYS.ACCOUNT.DETAILS.SAME_AS_CONTACT_DETAILS, localeCode),
                shippingAddress: makeTranslator(KEYS.ACCOUNT.DETAILS.SHIPPING_ADDRESS, localeCode),
                squareAspectRatioRequired: makeTranslator(KEYS.ACCOUNT.DETAILS.SQUARE_ASPECT_RATIO_REQUIRED, localeCode),
                state: makeTranslator(KEYS.ACCOUNT.DETAILS.STATE, localeCode),
                suburb: makeTranslator(KEYS.ACCOUNT.DETAILS.SUBURB, localeCode),
                websiteUrl: makeTranslator(KEYS.ACCOUNT.DETAILS.WEBSITE_URL, localeCode)
            },
            locationDetails: {
                createMapLocation: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.CREATE_MAP_LOCATION, localeCode),
                getLocationDetails: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.GET_LOCATION_DETAILS, localeCode),
                removeLocationMap: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.REMOVE_LOCATION_MAP, localeCode),
                shippingDetailsUpdated: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.SHIPPING_DETAILS_UPDATED, localeCode),
                startMapPayment: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.START_MAP_PAYMENT, localeCode),
                updateLocationDetails: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.UPDATE_LOCATION_DETAILS, localeCode),
                updateShippingDetails: makeTranslator(KEYS.ACCOUNT.LOCATION_DETAILS.UPDATE_SHIPPING_DETAILS, localeCode)
            },
            map: {
                confirmPaymentDetails: makeTranslator(KEYS.ACCOUNT.MAP.CONFIRM_PAYMENT_DETAILS, localeCode),
                createNewMap: makeTranslator(KEYS.ACCOUNT.MAP.CREATE_NEW_MAP, localeCode),
                createNewMapFor: makeTranslator(KEYS.ACCOUNT.MAP.CREATE_NEW_MAP_FOR, localeCode),
                editMap: makeTranslator(KEYS.ACCOUNT.MAP.EDIT_MAP, localeCode),
                getMapServiceCost: makeTranslator(KEYS.ACCOUNT.MAP.GET_MAP_SERVICE_COST, localeCode),
                mapGenerationFailed: makeTranslator(KEYS.ACCOUNT.MAP.MAP_GENERATION_FAILED, localeCode),
                mapGenerationInprogress: makeTranslator(KEYS.ACCOUNT.MAP.MAP_GENERATION_INPROGRESS, localeCode),
                paymentInformation: {
                    part1: makeTranslator(KEYS.ACCOUNT.MAP.PAYMENT_INFORMATION.PART_1, localeCode),
                    part2: makeTranslator(KEYS.ACCOUNT.MAP.PAYMENT_INFORMATION.PART_2, localeCode)
                },
                problemRetrievingCost: makeTranslator(KEYS.ACCOUNT.MAP.PROBLEM_RETRIEVING_COST, localeCode),
                searchForAddress: makeTranslator(KEYS.ACCOUNT.MAP.SEARCH_FOR_ADDRESS, localeCode),
                unsupportedCurrency: makeTranslator(KEYS.ACCOUNT.MAP.UNSUPPORTED_CURRENCY, localeCode)
            },
            notifyUnauthenticated: makeTranslator(KEYS.ACCOUNT.NOTIFY_UNAUTHENTICATED, localeCode),
            notifyUnauthorized: makeTranslator(KEYS.ACCOUNT.NOTIFY_UNAUTHORIZED, localeCode)
        },
        admin: {
            banner: {
                bannerMessage: makeTranslator(KEYS.ADMIN.BANNER.BANNER_MESSAGE, localeCode),
                bannerNotification: makeTranslator(KEYS.ADMIN.BANNER.BANNER_NOTIFICATION, localeCode),
                createBannerNotification: makeTranslator(KEYS.ADMIN.BANNER.CREATE_BANNER_NOTIFICATION, localeCode),
                deleteCurrentBannerNotification: makeTranslator(KEYS.ADMIN.BANNER.DELETE_CURRENT_BANNER_NOTIFICATION, localeCode),
                dismissable: makeTranslator(KEYS.ADMIN.BANNER.DISMISSABLE, localeCode),
                getCurrentBannerNotification: makeTranslator(KEYS.ADMIN.BANNER.GET_CURRENT_BANNER_NOTIFICATION, localeCode),
                notificationType: makeTranslator(KEYS.ADMIN.BANNER.NOTIFICATION_TYPE, localeCode),
                notifyCreated: makeTranslator(KEYS.ADMIN.BANNER.NOTIFY_CREATED, localeCode),
                notifyDeleted: makeTranslator(KEYS.ADMIN.BANNER.NOTIFY_DELETED, localeCode),
                tip: makeTranslator(KEYS.ADMIN.BANNER.TIP, localeCode)
            },
            brands: {
                assign: makeTranslator(KEYS.ADMIN.BRANDS.ASSIGN, localeCode),
                assignBrand: makeTranslator(KEYS.ADMIN.BRANDS.ASSIGN_BRAND, localeCode),
                assignClients: makeTranslator(KEYS.ADMIN.BRANDS.ASSIGN_CLIENTS, localeCode),
                assignClientsTo: makeTranslator(KEYS.ADMIN.BRANDS.ASSIGN_CLIENTS_TO, localeCode),
                brand: makeTranslator(KEYS.ADMIN.BRANDS.BRAND, localeCode),
                brandColor: makeTranslator(KEYS.ADMIN.BRANDS.BRAND_COLOR, localeCode),
                brandName: makeTranslator(KEYS.ADMIN.BRANDS.BRAND_NAME, localeCode),
                brands: makeTranslator(KEYS.ADMIN.BRANDS.BRANDS, localeCode),
                cannotAssignClientIf: makeTranslator(KEYS.ADMIN.BRANDS.CANNOT_ASSIGN_CLIENT_IF, localeCode),
                checkClientsToAssignTo: makeTranslator(KEYS.ADMIN.BRANDS.CHECK_CLIENTS_TO_ASSIGN_TO, localeCode),
                filterBrands: makeTranslator(KEYS.ADMIN.BRANDS.FILTER_BRANDS, localeCode),
                filterClients: makeTranslator(KEYS.ADMIN.BRANDS.FILTER_CLIENTS, localeCode),
                newBrand: makeTranslator(KEYS.ADMIN.BRANDS.NEW_BRAND, localeCode),
                pleaseEnterNameColorLogo: makeTranslator(KEYS.ADMIN.BRANDS.PLEASE_ENTER_NAME_COLOR_LOGO, localeCode),
                thisWillPermanentlyDelete: makeTranslator(KEYS.ADMIN.BRANDS.THIS_WILL_PERMANENTLY_DELETE, localeCode),
                updateBrand: makeTranslator(KEYS.ADMIN.BRANDS.UPDATE_BRAND, localeCode),
                uploadLogo: makeTranslator(KEYS.ADMIN.BRANDS.UPLOAD_LOGO, localeCode),
                youCanAssignClientsFrom: makeTranslator(KEYS.ADMIN.BRANDS.YOU_CAN_ASSIGN_CLIENTS_FROM, localeCode)
            },
            clubreadyConnect: {
                action: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.ACTION, localeCode),
                chainIdConfigurationTitle: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.CHAIN_ID_CONFIGURATION_TITLE, localeCode),
                clubreadyDisabledForClientHelpText: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.CLUBREADY_DISABLED_FOR_CLIENT_HELP_TEXT, localeCode),
                clientTitle: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.CLIENT_TITLE, localeCode),
                filterClients: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.FILTER_CLIENTS, localeCode),
                noIntegrationFoundForClient: makeTranslator(KEYS.ADMIN.CLUBREADY_CONNECT.NO_INTEGRATION_FOUND_FOR_CLIENT, localeCode)
            },
            externalAuthApps: {
                apiKey: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.API_KEY, localeCode),
                appName: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.APP_NAME, localeCode),
                confirmDelete: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.CONFIRM_DELETE, localeCode),
                connections: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.CONNECTIONS, localeCode),
                contactEmail: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.CONTACT_EMAIL, localeCode),
                createAuthApp: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.CREATE_AUTH_APP, localeCode),
                deleteApp: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP, localeCode),
                deleteAppDisclaimer: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DELETE_APP_DISCLAIMER, localeCode),
                deleteConnection: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DELETE_CONNECTION, localeCode),
                details: {
                    dsUser: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DETAILS.DS_USER, localeCode),
                    externalUserIdentifier: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DETAILS.EXTERNAL_USER_IDENTIFIER, localeCode),
                    noAppConnections: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.DETAILS.NO_APP_CONNECTIONS, localeCode)
                },
                secret: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.SECRET, localeCode),
                secretEditWarning: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.SECRET_EDIT_WARNING, localeCode),
                secretTooltip: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.SECRET_TOOLTIP, localeCode),
                title: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.TITLE, localeCode),
                tokenEndpoint: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT, localeCode),
                tokenEndpointTooltip: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.TOKEN_ENDPOINT_TOOLTIP, localeCode),
                updateAuthApp: makeTranslator(KEYS.ADMIN.EXTERNAL_AUTH_APPS.UPDATE_AUTH_APP, localeCode)
            },
            maintenance: {
                date: makeTranslator(KEYS.ADMIN.MAINTENANCE.DATE, localeCode),
                expectedDowntime: makeTranslator(KEYS.ADMIN.MAINTENANCE.EXPECTED_DOWNTIME, localeCode),
                expectedDowntimeMustBeAtLeastZero: makeTranslator(KEYS.ADMIN.MAINTENANCE.EXPECTED_DOWNTIME_MUST_BE_AT_LEAST_ZERO, localeCode),
                maintenanceWindow: makeTranslator(KEYS.ADMIN.MAINTENANCE.MAINTENANCE_WINDOW, localeCode),
                minutes: makeTranslator(KEYS.ADMIN.MAINTENANCE.MINUTES, localeCode),
                notifyMaintenanceRemoved: makeTranslator(KEYS.ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_REMOVED, localeCode),
                notifyMaintenanceUpdated: makeTranslator(KEYS.ADMIN.MAINTENANCE.NOTIFY_MAINTENANCE_UPDATED, localeCode),
                removeMaintenanceConfirm: makeTranslator(KEYS.ADMIN.MAINTENANCE.REMOVE_MAINTENANCE_CONFIRM, localeCode),
                startDateIsRequired: makeTranslator(KEYS.ADMIN.MAINTENANCE.START_DATE_IS_REQUIRED, localeCode),
                startDateMustBeInTheFuture: makeTranslator(KEYS.ADMIN.MAINTENANCE.START_DATE_MUST_BE_IN_THE_FUTURE, localeCode),
                startTime: makeTranslator(KEYS.ADMIN.MAINTENANCE.START_TIME, localeCode),
                startTimeMustBeInTheFuture: makeTranslator(KEYS.ADMIN.MAINTENANCE.START_TIME_MUST_BE_IN_THE_FUTURE, localeCode)
            },
            mapsReport: {
                amountPaid: makeTranslator(KEYS.ADMIN.MAPS_REPORT.AMOUNT_PAID, localeCode),
                clientName: makeTranslator(KEYS.ADMIN.MAPS_REPORT.CLIENT_NAME, localeCode),
                heading: makeTranslator(KEYS.ADMIN.MAPS_REPORT.HEADING, localeCode),
                locationName: makeTranslator(KEYS.ADMIN.MAPS_REPORT.LOCATION_NAME, localeCode),
                purchasedDate: makeTranslator(KEYS.ADMIN.MAPS_REPORT.PURCHASED_DATE, localeCode)
            },
            nav: {
                agencies: makeTranslator(KEYS.ADMIN.NAV.AGENCIES, localeCode),
                authenticationApps: makeTranslator(KEYS.ADMIN.NAV.AUTHENTICATION_APPS, localeCode),
                bannerNotification: makeTranslator(KEYS.ADMIN.NAV.BANNER_NOTIFICATION, localeCode),
                brands: makeTranslator(KEYS.ADMIN.NAV.BRANDS, localeCode),
                calendarItems: makeTranslator(KEYS.ADMIN.NAV.CALENDAR_ITEMS, localeCode),
                clubreadyConnect: makeTranslator(KEYS.ADMIN.NAV.CLUBREADY_CONNECT, localeCode),
                mapsReport: makeTranslator(KEYS.ADMIN.NAV.MAPS_REPORT, localeCode),
                payableServices: makeTranslator(KEYS.ADMIN.NAV.PAYABLE_SERVICES, localeCode),
                platforms: makeTranslator(KEYS.ADMIN.NAV.PLATFORMS, localeCode),
                servicing: makeTranslator(KEYS.ADMIN.NAV.SERVICING, localeCode),
                siteMaintenance: makeTranslator(KEYS.ADMIN.NAV.SITE_MAINTENANCE, localeCode),
                subscriptions: makeTranslator(KEYS.ADMIN.NAV.SUBSCRIPTIONS, localeCode),
                tasks: makeTranslator(KEYS.ADMIN.NAV.TASKS, localeCode),
                templatePreviews: makeTranslator(KEYS.ADMIN.NAV.TEMPLATE_PREVIEWS, localeCode)
            },
            notifyGenerateLocationMapStarted: makeTranslator(KEYS.ADMIN.NOTIFY_GENERATE_LOCATION_MAP_STARTED, localeCode),
            notifyPurgeSessionsStarted: makeTranslator(KEYS.ADMIN.NOTIFY_PURGE_SESSIONS_STARTED, localeCode),
            notifyTestInAppNotificationsStarted: makeTranslator(KEYS.ADMIN.NOTIFY_TEST_IN_APP_NOTIFICATIONS_STARTED, localeCode),
            notifyThumbnailGenerationStarted: makeTranslator(KEYS.ADMIN.NOTIFY_THUMBNAIL_GENERATION_STARTED, localeCode),
            payableService: {
                confirmDeleteCost: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.CONFIRM_DELETE_COST, localeCode),
                costInvalidPrecision: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.COST_INVALID_PRECISION, localeCode),
                costMustBePositive: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.COST_MUST_BE_POSITIVE, localeCode),
                createServiceCost: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.CREATE_SERVICE_COST, localeCode),
                deleteServiceCost: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.DELETE_SERVICE_COST, localeCode),
                notifyServiceCostsUpdated: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.NOTIFY_SERVICE_COSTS_UPDATED, localeCode),
                updateServiceCost: makeTranslator(KEYS.ADMIN.PAYABLE_SERVICE.UPDATE_SERVICE_COST, localeCode)
            },
            servicing: {
                blockedPublishes: {
                    title: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TITLE, localeCode),
                    subtitle: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.SUBTITLE, localeCode),
                    table: {
                        headers: {
                            updatedAt: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.UPDATED_AT, localeCode),
                            scheduledFor: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR, localeCode),
                            content: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.HEADERS.CONTENT, localeCode)
                        },
                        contentLabels: {
                            subject: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT, localeCode),
                            emailHtml: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML, localeCode),
                            recipients: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS, localeCode),
                            template: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE, localeCode)
                        },
                        actions: {
                            retryNow: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.RETRY_NOW, localeCode),
                            markFailed: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_FAILED, localeCode),
                            markSuccessful: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.ACTIONS.MARK_SUCCESSFUL, localeCode)
                        },
                        notFoundMessage: makeTranslator(KEYS.ADMIN.SERVICING.BLOCKED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE, localeCode)
                    }
                },
                failedPublishes: {
                    title: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TITLE, localeCode),
                    subtitle: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.SUBTITLE, localeCode),
                    table: {
                        headers: {
                            failedAt: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.FAILED_AT, localeCode),
                            scheduledFor: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.SCHEDULED_FOR, localeCode),
                            content: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.HEADERS.CONTENT, localeCode)
                        },
                        contentLabels: {
                            subject: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.SUBJECT, localeCode),
                            emailHtml: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.EMAIL_HTML, localeCode),
                            recipients: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.RECIPIENTS, localeCode),
                            template: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.CONTENT_LABELS.TEMPLATE, localeCode)
                        },
                        notFoundMessage: makeTranslator(KEYS.ADMIN.SERVICING.FAILED_PUBLISHES.TABLE.NOT_FOUND_MESSAGE, localeCode)
                    }
                }
            },
            subscriptions: {
                clientSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.CLIENT_SUBSCRIPTION, localeCode),
                defaultSubFor: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.DEFAULT_SUB_FOR, localeCode),
                defaultSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION, localeCode),
                defaultSubscriptionUpdated: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.DEFAULT_SUBSCRIPTION_UPDATED, localeCode),
                deleteRecurringConfirm: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.DELETE_RECURRING_CONFIRM, localeCode),
                location: {
                    canBeUsedToCancel: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.CAN_BE_USED_TO_CANCEL, localeCode),
                    dateGap: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.DATE_GAP, localeCode),
                    endDateIsExclusive: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.END_DATE_IS_EXCLUSIVE, localeCode),
                    future: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.FUTURE, localeCode),
                    inactive: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE, localeCode),
                    inactiveSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.INACTIVE_SUBSCRIPTION, localeCode),
                    initialSubscriptionFor: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.INITIAL_SUBSCRIPTION_FOR, localeCode),
                    leaveItBlank: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.LEAVE_IT_BLANK, localeCode),
                    legend: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.LEGEND, localeCode),
                    locationSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION, localeCode),
                    locationSubscriptionRecurring: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.LOCATION_SUBSCRIPTION_RECURRING, localeCode),
                    next: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.NEXT, localeCode),
                    noRecurringPayments: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.NO_RECURRING_PAYMENTS, localeCode),
                    notifyRecurringPaymentDeleted: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.NOTIFY_RECURRING_PAYMENT_DELETED, localeCode),
                    recurringPayment: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT, localeCode),
                    recurringPaymentSchedule: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.RECURRING_PAYMENT_SCHEDULE, localeCode),
                    saveRecurringPayment: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.SAVE_RECURRING_PAYMENT, localeCode),
                    subscriptionUpdated: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.SUBSCRIPTION_UPDATED, localeCode),
                    theNextDateIsAfter: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.THE_NEXT_DATE_IS_AFTER, localeCode),
                    thisCanBeUsedTempDiscount: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TEMP_DISCOUNT, localeCode),
                    thisCanBeUsedToSkipPayment: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.THIS_CAN_BE_USED_TO_SKIP_PAYMENT, localeCode),
                    updateSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.LOCATION.UPDATE_SUBSCRIPTION, localeCode)
                },
                noClients: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.NO_CLIENTS, localeCode),
                noLocations: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.NO_LOCATIONS, localeCode),
                notifyRecurringPaymentDeleted: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_DELETED, localeCode),
                notifyRecurringPaymentSaved: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.NOTIFY_RECURRING_PAYMENT_SAVED, localeCode),
                notifySubscriptionUpdated: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.NOTIFY_SUBSCRIPTION_UPDATED, localeCode),
                subscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.SUBSCRIPTION, localeCode),
                updateDefaultSubscription: makeTranslator(KEYS.ADMIN.SUBSCRIPTIONS.UPDATE_DEFAULT_SUBSCRIPTION, localeCode)
            },
            users: {
                addNewUser: makeTranslator(KEYS.ADMIN.USERS.ADD_NEW_USER, localeCode)
            }
        },
        agencies: {
            addNewAgency: makeTranslator(KEYS.AGENCIES.ADD_NEW_AGENCY, localeCode),
            agency: {
                confirmDelete: makeTranslator(KEYS.AGENCIES.AGENCY.CONFIRM_DELETE, localeCode),
                deleteAgency: makeTranslator(KEYS.AGENCIES.AGENCY.DELETE_AGENCY, localeCode),
                deletedConfirmationMessage: makeTranslator(KEYS.AGENCIES.AGENCY.DELETED_CONFIRMATION_MESSAGE, localeCode),
                editAgency: makeTranslator(KEYS.AGENCIES.AGENCY.EDIT_AGENCY, localeCode),
                whitelabelLogo: makeTranslator(KEYS.AGENCIES.AGENCY.WHITELABEL_LOGO, localeCode)
            },
            agencyCreated: makeTranslator(KEYS.AGENCIES.AGENCY_CREATED, localeCode),
            agencyName: makeTranslator(KEYS.AGENCIES.AGENCY_NAME, localeCode),
            agencyNameRequired: makeTranslator(KEYS.AGENCIES.AGENCY_NAME_REQUIRED, localeCode),
            agencyUpdated: makeTranslator(KEYS.AGENCIES.AGENCY_UPDATED, localeCode),
            user: {
                addAgencyUser: makeTranslator(KEYS.AGENCIES.USER.ADD_AGENCY_USER, localeCode),
                addNewUserTo: makeTranslator(KEYS.AGENCIES.USER.ADD_NEW_USER_TO, localeCode),
                admin: makeTranslator(KEYS.AGENCIES.USER.ADMIN, localeCode),
                editAgencyUser: makeTranslator(KEYS.AGENCIES.USER.EDIT_AGENCY_USER, localeCode),
                editUser: makeTranslator(KEYS.AGENCIES.USER.EDIT_USER, localeCode),
                noUsersAssigned: makeTranslator(KEYS.AGENCIES.USER.NO_USERS_ASSIGNED, localeCode),
                removeUser: makeTranslator(KEYS.AGENCIES.USER.REMOVE_USER, localeCode),
                userAddedSuccessMessage: makeTranslator(KEYS.AGENCIES.USER.USER_ADDED_SUCCESS_MESSAGE, localeCode),
                userRemovedSuccessMessage: makeTranslator(KEYS.AGENCIES.USER.USER_REMOVED_SUCCESS_MESSAGE, localeCode),
                userUpdatedSuccessMessage: makeTranslator(KEYS.AGENCIES.USER.USER_UPDATED_SUCCESS_MESSAGE, localeCode)
            }
        },
        agency: {
            assignToAgencyManager: {
                warningButtonLabel: makeTranslator(KEYS.AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_BUTTON_LABEL, localeCode),
                warningMessage: makeTranslator(KEYS.AGENCY.ASSIGN_TO_AGENCY_MANAGER.WARNING_MESSAGE, localeCode)
            },
            client: {
                activities: {
                    activityAdded: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED, localeCode),
                    activityAddedError: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ACTIVITY_ADDED_ERROR, localeCode),
                    activityNameMustBeUnique: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ACTIVITY_NAME_MUST_BE_UNIQUE, localeCode),
                    addActivity: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ADD_ACTIVITY, localeCode),
                    addChannel: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL, localeCode),
                    addPlatform: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM, localeCode),
                    addChannelError: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ADD_CHANNEL_ERROR, localeCode),
                    addPlatformError: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.ADD_PLATFORM_ERROR, localeCode),
                    channelName: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME, localeCode),
                    platformName: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.PLATFORM_NAME, localeCode),
                    channelNameMustBeUnique: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.CHANNEL_NAME_MUST_BE_UNIQUE, localeCode),
                    channelType: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.CHANNEL_TYPE, localeCode),
                    platformType: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.PLATFORM_TYPE, localeCode),
                    deleteActivity: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY, localeCode),
                    deleteActivityDescription: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_DESCRIPTION, localeCode),
                    deleteActivityError: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_ERROR, localeCode),
                    deleteActivitySuccess: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_ACTIVITY_SUCCESS, localeCode),
                    deleteChannel: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL, localeCode),
                    deleteChannelDescription: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_DESCRIPTION, localeCode),
                    deletePlatformDescription: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_PLATFORM_DESCRIPTION, localeCode),
                    deleteChannelError: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.DELETE_CHANNEL_ERROR, localeCode),
                    linkedPlatformOptional: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.LINKED_PLATFORM_OPTIONAL, localeCode),
                    refreshData: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.REFRESH_DATA, localeCode),
                    retrieveActivities: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.RETRIEVE_ACTIVITIES, localeCode),
                    retrieveBuildingPlatforms: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.RETRIEVE_BUILDING_PLATFORMS, localeCode),
                    saveNewChannel: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.SAVE_NEW_CHANNEL, localeCode),
                    updateActivityOrder: makeTranslator(KEYS.AGENCY.CLIENT.ACTIVITIES.UPDATE_ACTIVITY_ORDER, localeCode)
                },
                brandColors: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLORS, localeCode),
                brandColours: {
                    addNewBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.ADD_NEW_BRAND_COLOUR, localeCode),
                    colour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.COLOUR, localeCode),
                    createNewBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.CREATE_NEW_BRAND_COLOUR, localeCode),
                    createdBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.CREATED_BRAND_COLOUR, localeCode),
                    deleteBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.DELETE_BRAND_COLOUR, localeCode),
                    deleteConfirmation: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.DELETE_CONFIRMATION, localeCode),
                    deletedBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.DELETED_BRAND_COLOUR, localeCode),
                    successfullyAddedBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_ADDED_BRAND_COLOUR, localeCode),
                    successfullyRenamedBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_RENAMED_BRAND_COLOUR, localeCode),
                    successfullyUpdatedBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.SUCCESSFULLY_UPDATED_BRAND_COLOUR, localeCode),
                    updateBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.UPDATE_BRAND_COLOUR, localeCode),
                    updateColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.UPDATE_COLOUR, localeCode),
                    updateOrder: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.UPDATE_ORDER, localeCode),
                    updatedBrandColour: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR, localeCode),
                    updatedBrandColourOrder: makeTranslator(KEYS.AGENCY.CLIENT.BRAND_COLOURS.UPDATED_BRAND_COLOUR_ORDER, localeCode)
                },
                builderTemplateCategories: {
                    confirmDelete: makeTranslator(KEYS.AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.CONFIRM_DELETE, localeCode),
                    editCategory: makeTranslator(KEYS.AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.EDIT_CATEGORY, localeCode),
                    endDateMustBeAfterStartDateOrAbsent: makeTranslator(KEYS.AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.END_DATE_MUST_BE_AFTER_START_DATE_OR_ABSENT, localeCode),
                    newCategory: makeTranslator(KEYS.AGENCY.CLIENT.BUILDER_TEMPLATE_CATEGORIES.NEW_CATEGORY, localeCode)
                },
                conversionAmount: makeTranslator(KEYS.AGENCY.CLIENT.CONVERSION_AMOUNT, localeCode),
                conversionAmountUpdated: makeTranslator(KEYS.AGENCY.CLIENT.CONVERSION_AMOUNT_UPDATED, localeCode),
                conversionWorth: makeTranslator(KEYS.AGENCY.CLIENT.CONVERSION_WORTH, localeCode),
                filterClients: makeTranslator(KEYS.AGENCY.CLIENT.FILTER_CLIENTS, localeCode),
                links: {
                    addNewLink: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.ADD_NEW_LINK, localeCode),
                    createNewLink: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.CREATE_NEW_LINK, localeCode),
                    deleteConfirmation: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.DELETE_CONFIRMATION, localeCode),
                    deleteLink: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.DELETE_LINK, localeCode),
                    getLinks: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.GET_LINKS, localeCode),
                    linkPatternRequirement: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.LINK_PATTERN_REQUIREMENT, localeCode),
                    title: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.TITLE, localeCode),
                    updateOrder: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.UPDATE_ORDER, localeCode),
                    url: makeTranslator(KEYS.AGENCY.CLIENT.LINKS.URL, localeCode)
                },
                location: {
                    activities: {
                        activityAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_ADDED, localeCode),
                        activityName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_NAME, localeCode),
                        activityRemoved: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.ACTIVITY_REMOVED, localeCode),
                        addNewActivity: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.ADD_NEW_ACTIVITY, localeCode),
                        channels: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.CHANNELS, localeCode),
                        deleteActivity: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.DELETE_ACTIVITY, localeCode),
                        migratePlatform: {
                            platformAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_ADDED, localeCode),
                            platformDeleted: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_PLATFORM.PLATFORM_DELETED, localeCode)
                        },
                        migrateChannel: {
                            channel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL, localeCode),
                            channelAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_ADDED, localeCode),
                            channelDeleted: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CHANNEL_DELETED, localeCode),
                            confirmClickDeleteChannel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.CONFIRM_CLICK_DELETE_CHANNEL, localeCode),
                            deleteChannel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.DELETE_CHANNEL, localeCode),
                            migrate: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.MIGRATE, localeCode),
                            replaceAll: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.MIGRATE_CHANNEL.REPLACE_ALL, localeCode)
                        },
                        platformLink: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.PLATFORM_LINK, localeCode),
                        type: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.ACTIVITIES.TYPE, localeCode)
                    },
                    billingUpdate: {
                        sendBillingDetailsUpdateRequest: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_BILLING_DETAILS_UPDATE_REQUEST, localeCode),
                        sendRequest: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SEND_REQUEST, localeCode),
                        signatorysEmailAddress: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.BILLING_UPDATE.SIGNATORYS_EMAIL_ADDRESS, localeCode)
                    },
                    categories: {
                        notifyUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.CATEGORIES.NOTIFY_UPDATED, localeCode)
                    },
                    featuredTemplateSets: {
                        actions: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.ACTIONS, localeCode),
                        deleteTemplateTag: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.DELETE_TEMPLATE_TAG, localeCode),
                        editFeaturedTemplateSet: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.EDIT_FEATURED_TEMPLATE_SET, localeCode),
                        endDate: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.END_DATE, localeCode),
                        newFeaturedTemplateSet: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.NEW_FEATURED_TEMPLATE_SET, localeCode),
                        startDate: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FEATURED_TEMPLATE_SETS.START_DATE, localeCode)
                    },
                    fonts: {
                        bold: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.BOLD, localeCode),
                        byChoosingAFont: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.BY_CHOOSING_A_FONT, localeCode),
                        chooseFont: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.CHOOSE_FONT, localeCode),
                        condensed: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.CONDENSED, localeCode),
                        custom: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.CUSTOM, localeCode),
                        doYouHavePermission: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.DO_YOU_HAVE_PERMISSION, localeCode),
                        expanded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.EXPANDED, localeCode),
                        extraCondensed: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.EXTRA_CONDENSED, localeCode),
                        extraExpanded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.EXTRA_EXPANDED, localeCode),
                        fontFamily: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.FONT_FAMILY, localeCode),
                        fontsSaved: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.FONTS_SAVED, localeCode),
                        iConfirmIHavePermission: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.I_CONFIRM_I_HAVE_PERMISSION, localeCode),
                        italic: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.ITALIC, localeCode),
                        localFile: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.LOCAL_FILE, localeCode),
                        noFonts: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.NO_FONTS, localeCode),
                        normal: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.NORMAL, localeCode),
                        oblique: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.OBLIQUE, localeCode),
                        selectFont: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.SELECT_FONT, localeCode),
                        semiCondensed: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.SEMI_CONDENSED, localeCode),
                        semiExpanded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.SEMI_EXPANDED, localeCode),
                        stretch: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.STRETCH, localeCode),
                        style: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.STYLE, localeCode),
                        ultraCondensed: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.ULTRA_CONDENSED, localeCode),
                        ultraExpanded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.ULTRA_EXPANDED, localeCode),
                        weight: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.WEIGHT, localeCode),
                        youHaveConfirmed: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.FONTS.YOU_HAVE_CONFIRMED, localeCode)
                    },
                    learnMenu: {
                        addSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SECTION, localeCode),
                        addSubSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION, localeCode),
                        addSubSectionToSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.ADD_SUB_SECTION_TO_SECTION, localeCode),
                        couldNotSaveLearnMenu: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.COULD_NOT_SAVE_LEARN_MENU, localeCode),
                        deleteSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SECTION, localeCode),
                        deleteSubSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.DELETE_SUB_SECTION, localeCode),
                        learnMenuSaved: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.LEARN_MENU_SAVED, localeCode),
                        newSubSection: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.NEW_SUB_SECTION, localeCode),
                        subSections: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS, localeCode),
                        subSectionsFor: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LEARN_MENU.SUB_SECTIONS_FOR, localeCode)
                    },
                    locationDetails: {
                        deleteConfirmation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DELETE_CONFIRMATION, localeCode),
                        displayNameTooLong: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.DISPLAY_NAME_TOO_LONG, localeCode),
                        locationDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.LOCATION_DETAILS, localeCode),
                        supportedPlannerLimit: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.LOCATION_DETAILS.SUPPORTED_PLANNER_LIMIT, localeCode)
                    },
                    manage: {
                        addLocation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.ADD_LOCATION, localeCode),
                        createdLocationError: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_ERROR, localeCode),
                        createdLocationSuccess: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.CREATED_LOCATION_SUCCESS, localeCode),
                        deleteLocationDescription: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_DESCRIPTION, localeCode),
                        deleteLocationError: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_ERROR, localeCode),
                        deleteLocationLabel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_LABEL, localeCode),
                        deleteLocationSuccess: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.DELETE_LOCATION_SUCCESS, localeCode),
                        editDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.EDIT_DETAILS, localeCode),
                        errors: {
                            errorUpdatingLocation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.ERROR_UPDATING_LOCATION, localeCode),
                            noClientId: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_CLIENT_ID, localeCode),
                            noLocationOrAccessForbidden: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.ERRORS.NO_LOCATION_OR_ACCESS_FORBIDDEN, localeCode)
                        },
                        filterLocations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.FILTER_LOCATIONS, localeCode),
                        locationName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_NAME, localeCode),
                        locationUpdateSuccess: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.LOCATION_UPDATE_SUCCESS, localeCode),
                        noFieldValue: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.NO_FIELD_VALUE, localeCode),
                        properties: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.PROPERTIES, localeCode),
                        publicDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.MANAGE.PUBLIC_DETAILS, localeCode)
                    },
                    nav: {
                        activities: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.ACTIVITIES, localeCode),
                        agency: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.AGENCY, localeCode),
                        brandColours: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.BRAND_COLOURS, localeCode),
                        builderTemplateCategories: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.BUILDER_TEMPLATE_CATEGORIES, localeCode),
                        clients: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.CLIENTS, localeCode),
                        featuredTemplateSets: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.FEATURED_TEMPLATE_SETS, localeCode),
                        fonts: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.FONTS, localeCode),
                        learnMenu: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.LEARN_MENU, localeCode),
                        links: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.LINKS, localeCode),
                        locationCategories: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.LOCATION_CATEGORIES, localeCode),
                        locations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.LOCATIONS, localeCode),
                        platforms: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.PLATFORMS, localeCode),
                        users: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NAV.USERS, localeCode)
                    },
                    notifyLocationDeleteError: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETE_ERROR, localeCode),
                    notifyLocationDeleted: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_DELETED, localeCode),
                    notifyLocationUpdateError: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATE_ERROR, localeCode),
                    notifyLocationUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.NOTIFY_LOCATION_UPDATED, localeCode),
                    summaryFields: {
                        addNewFieldGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.ADD_NEW_FIELD_GROUP, localeCode),
                        deleteField: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD, localeCode),
                        deleteFieldConfirm: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_FIELD_CONFIRM, localeCode),
                        deleteGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.DELETE_GROUP, localeCode),
                        fieldLabel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.FIELD_LABEL, localeCode),
                        groupName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.GROUP_NAME, localeCode),
                        newField: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.SUMMARY_FIELDS.NEW_FIELD, localeCode)
                    },
                    users: {
                        addExistingUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER, localeCode),
                        addExistingUserHelpText: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_HELP_TEXT, localeCode),
                        addExistingUserLabel: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_LABEL, localeCode),
                        addExistingUserNoMatches: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_NO_MATCHES, localeCode),
                        addExistingUserPlaceholder: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_PLACEHOLDER, localeCode),
                        addExistingUserSelected: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_EXISTING_USER_SELECTED, localeCode),
                        addNewUserTo: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ADD_NEW_USER_TO, localeCode),
                        assignUserToLocations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ASSIGN_USER_TO_LOCATIONS, localeCode),
                        currentlySelected: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.CURRENTLY_SELECTED, localeCode),
                        deleteConfirmation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.DELETE_CONFIRMATION, localeCode),
                        deleteUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.DELETE_USER, localeCode),
                        failedToAddExistingUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.FAILED_TO_ADD_EXISTING_USER, localeCode),
                        filterFirstName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.FILTER_FIRST_NAME, localeCode),
                        filterLastName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.FILTER_LAST_NAME, localeCode),
                        filterUsername: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.FILTER_USERNAME, localeCode),
                        firstName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.FIRST_NAME, localeCode),
                        lastName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.LAST_NAME, localeCode),
                        locationsUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.LOCATIONS_UPDATED, localeCode),
                        noUsersAssignedToCompany: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.NO_USERS_ASSIGNED_TO_COMPANY, localeCode),
                        noUsersFound: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.NO_USERS_FOUND, localeCode),
                        removeUserModal: {
                            deleteUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.DELETE_USER, localeCode),
                            removeFromLocation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_FROM_LOCATION, localeCode),
                            removeOrDeleteUserMessage: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_MESSAGE, localeCode),
                            removeOrDeleteUserTitle: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.REMOVE_USER_MODAL.REMOVE_OR_DELETE_USER_TITLE, localeCode)
                        },
                        roles: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.ROLES, localeCode),
                        selectUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.SELECT_USER, localeCode),
                        userAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_ADDED, localeCode),
                        userEdit: {
                            analyst: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST, localeCode),
                            analystTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ANALYST_TOOLTIP, localeCode),
                            builder: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER, localeCode),
                            builderTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.BUILDER_TOOLTIP, localeCode),
                            clients: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CLIENTS, localeCode),
                            connectToAccess: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.CONNECT_TO_ACCESS, localeCode),
                            editClientUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_CLIENT_USER, localeCode),
                            editUser: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EDIT_USER, localeCode),
                            email: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.EMAIL, localeCode),
                            firstName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.FIRST_NAME, localeCode),
                            lastName: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.LAST_NAME, localeCode),
                            marketingUpdates: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.MARKETING_UPDATES, localeCode),
                            notifications: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.NOTIFICATIONS, localeCode),
                            password: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PASSWORD, localeCode),
                            planner: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER, localeCode),
                            plannerTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PLANNER_TOOLTIP, localeCode),
                            publisher: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER, localeCode),
                            publisherTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.PUBLISHER_TOOLTIP, localeCode),
                            roles: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.ROLES, localeCode),
                            specialRequester: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER, localeCode),
                            specialRequesterTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTER_TOOLTIP, localeCode),
                            specialRequests: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.SPECIAL_REQUESTS, localeCode),
                            timezone: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.TIMEZONE, localeCode),
                            update: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.UPDATE, localeCode),
                            userDeleted: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_DELETED, localeCode),
                            userUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_EDIT.USER_UPDATED, localeCode)
                        },
                        userRemoved: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USER_REMOVED, localeCode),
                        usernameEmail: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USERNAME_EMAIL, localeCode),
                        users: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USERS, localeCode),
                        usersExistingLocations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.USERS_EXISTING_LOCATIONS, localeCode),
                        yourInviteHasBeenSent: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION.USERS.YOUR_INVITE_HAS_BEEN_SENT, localeCode)
                    }
                },
                locationCategories: {
                    addRegionOrGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_REGION_OR_GROUP, localeCode),
                    addToGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ADD_TO_GROUP, localeCode),
                    associateCollectionPlaceholder: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_COLLECTION_PLACEHOLDER, localeCode),
                    associateTemplateCategoryPlaceholder: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ASSOCIATE_TEMPLATE_CATEGORY_PLACEHOLDER, localeCode),
                    deleteConfirmation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_CONFIRMATION, localeCode),
                    deleteGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_GROUP, localeCode),
                    deleteLocationCategoryConfirm: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.DELETE_LOCATION_CATEGORY_CONFIRM, localeCode),
                    deletedLocationCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.DELETED_LOCATION_CATEGORY, localeCode),
                    errors: {
                        failedAssociateCollections: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_COLLECTIONS, localeCode),
                        failedAssociateTemplateCategories: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.FAILED_ASSOCIATE_TEMPLATE_CATEGORIES, localeCode),
                        missingCollectionsOrCategories: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.ERRORS.MISSING_COLLECTIONS_OR_CATEGORIES, localeCode)
                    },
                    followingLocationsAlreadyAssociatedWithRegion: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.FOLLOWING_LOCATIONS_ALREADY_ASSOCIATED_WITH_REGION, localeCode),
                    group: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.GROUP, localeCode),
                    labels: {
                        collections: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.COLLECTIONS, localeCode),
                        linkTemplateCategoriesAndCollections: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS, localeCode),
                        name: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.NAME, localeCode),
                        type: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LABELS.TYPE, localeCode)
                    },
                    locationCategories: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_CATEGORIES, localeCode),
                    locationGroup: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_GROUP, localeCode),
                    locationRegion: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.LOCATION_REGION, localeCode),
                    newOption: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.NEW_OPTION, localeCode),
                    notifyEnterLabelForCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.NOTIFY_ENTER_LABEL_FOR_CATEGORY, localeCode),
                    optionAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_ADDED, localeCode),
                    optionDeleted: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.OPTION_DELETED, localeCode),
                    partiallyAddedLocationCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_ADDED_LOCATION_CATEGORY, localeCode),
                    partiallyEditedLocationCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.PARTIALLY_EDITED_LOCATION_CATEGORY, localeCode),
                    radioDisabledMessage: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.RADIO_DISABLED_MESSAGE, localeCode),
                    region: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.REGION, localeCode),
                    selectedLocations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.SELECTED_LOCATIONS, localeCode),
                    successfullyAddedLocationCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_ADDED_LOCATION_CATEGORY, localeCode),
                    successfullyEditedLocationCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.SUCCESSFULLY_EDITED_LOCATION_CATEGORY, localeCode),
                    tooltips: {
                        groupMessage: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.GROUP_MESSAGE, localeCode),
                        linkTemplateCategoriesAndCollections: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.LINK_TEMPLATE_CATEGORIES_AND_COLLECTIONS, localeCode),
                        regionMessage: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.TOOLTIPS.REGION_MESSAGE, localeCode)
                    },
                    updatedLocationsForCategory: makeTranslator(KEYS.AGENCY.CLIENT.LOCATION_CATEGORIES.UPDATED_LOCATIONS_FOR_CATEGORY, localeCode)
                },
                locations: {
                    addNewLocation: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.ADD_NEW_LOCATION, localeCode),
                    country: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.COUNTRY, localeCode),
                    countryUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.COUNTRY_UPDATED, localeCode),
                    currency: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.CURRENCY, localeCode),
                    currencyUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.CURRENCY_UPDATED, localeCode),
                    defaultSupportedPlannerLimit: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT, localeCode),
                    defaultSupportedPlannerLimitUpdated: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.DEFAULT_SUPPORTED_PLANNER_LIMIT_UPDATED, localeCode),
                    deleteClient: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.DELETE_CLIENT, localeCode),
                    deletePermanently: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.DELETE_PERMANENTLY, localeCode),
                    emails: {
                        signUp: {
                            activateYourEnhancedPackage: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.ACTIVATE_YOUR_ENHANCED_PACKAGE, localeCode),
                            agencyInvitedYou: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.AGENCY_INVITED_YOU, localeCode),
                            clickBelowToUpdateDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BELOW_TO_UPDATE_DETAILS, localeCode),
                            clickButtonToCompleteSignUp: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.CLICK_BUTTON_TO_COMPLETE_SIGN_UP, localeCode),
                            defaultEmailSubject: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.DEFAULT_EMAIL_SUBJECT, localeCode),
                            inclusionsChangedToOfferBetterValue: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.INCLUSIONS_CHANGED_TO_OFFER_BETTER_VALUE, localeCode),
                            signUp: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.SIGN_UP, localeCode),
                            theseDetailsAllowSpecificServices: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.THESE_DETAILS_ALLOW_SPECIFIC_SERVICES, localeCode),
                            weRequireConfirmationOfDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WE_REQUIRE_CONFIRMATION_OF_DETAILS, localeCode),
                            welcomeToDigitalStack: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.WELCOME_TO_DIGITAL_STACK, localeCode),
                            youNeedToFillOutDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOU_NEED_TO_FILL_OUT_DETAILS, localeCode),
                            youreInvited: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGN_UP.YOURE_INVITED, localeCode)
                        },
                        signedUp: {
                            locationSignedUp: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.LOCATION_SIGNED_UP, localeCode),
                            newLocationSignedUp: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.NEW_LOCATION_SIGNED_UP, localeCode),
                            visitDigitalStack: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.SIGNED_UP.VISIT_DIGITAL_STACK, localeCode)
                        },
                        updateBillingDetails: {
                            clickToUpdateBillingDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.CLICK_TO_UPDATE_BILLING_DETAILS, localeCode),
                            requestToUpdateBillingDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.REQUEST_TO_UPDATE_BILLING_DETAILS, localeCode),
                            subjectLine: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.SUBJECT_LINE, localeCode),
                            updateYourBillingDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.UPDATE_YOUR_BILLING_DETAILS, localeCode),
                            weRequireYouToUpdateBillingDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.EMAILS.UPDATE_BILLING_DETAILS.WE_REQUIRE_YOU_TO_UPDATE_BILLING_DETAILS, localeCode)
                        }
                    },
                    errorDeletingClient: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.ERROR_DELETING_CLIENT, localeCode),
                    headers: {
                        yourBrands: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.HEADERS.YOUR_BRANDS, localeCode)
                    },
                    invitationSent: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.INVITATION_SENT, localeCode),
                    invite: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.INVITE, localeCode),
                    location: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.LOCATION, localeCode),
                    locationAdded: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.LOCATION_ADDED, localeCode),
                    locationGroupsNoCategoriesTooltip: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.LOCATION_GROUPS_NO_CATEGORIES_TOOLTIP, localeCode),
                    locations: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.LOCATIONS, localeCode),
                    noLocationGroups: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.NO_LOCATION_GROUPS, localeCode),
                    noLocationsAssigned: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.NO_LOCATIONS_ASSIGNED, localeCode),
                    permanentlyDeletedClient: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.PERMANENTLY_DELETED_CLIENT, localeCode),
                    requestUpdateBillingDetailsSent: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.REQUEST_UPDATE_BILLING_DETAILS_SENT, localeCode),
                    resend: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.RESEND, localeCode),
                    signedUp: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.SIGNED_UP, localeCode),
                    subscriptionActive: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_ACTIVE, localeCode),
                    subscriptionAmount: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.SUBSCRIPTION_AMOUNT, localeCode),
                    timezone: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.TIMEZONE, localeCode),
                    updateBillingDetails: makeTranslator(KEYS.AGENCY.CLIENT.LOCATIONS.UPDATE_BILLING_DETAILS, localeCode)
                },
                notificationEmailAddressesUpdated: makeTranslator(KEYS.AGENCY.CLIENT.NOTIFICATION_EMAIL_ADDRESSES_UPDATED, localeCode),
                numberOfLocations: makeTranslator(KEYS.AGENCY.CLIENT.NUMBER_OF_LOCATIONS, localeCode),
                platforms: {
                    all: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.ALL, localeCode),
                    cannotRemovePlatformLinkedChannels: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_CHANNELS, localeCode),
                    cannotRemovePlatformLinkedTemplates: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.CANNOT_REMOVE_PLATFORM_LINKED_TEMPLATES, localeCode),
                    configure: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.CONFIGURE, localeCode),
                    confirmRemovePlatform: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM, localeCode),
                    confirmRemovePlatformTitle: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.CONFIRM_REMOVE_PLATFORM_TITLE, localeCode),
                    disablePlatform: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.DISABLE_PLATFORM, localeCode),
                    enablePlatform: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.ENABLE_PLATFORM, localeCode),
                    enabled: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.ENABLED, localeCode),
                    fetchClientPlatforms: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.FETCH_CLIENT_PLATFORMS, localeCode),
                    filterByStatus: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.FILTER_BY_STATUS, localeCode),
                    filterPlatforms: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.FILTER_PLATFORMS, localeCode),
                    platform: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.PLATFORM, localeCode),
                    required: makeTranslator(KEYS.AGENCY.CLIENT.PLATFORMS.REQUIRED, localeCode)
                },
                updateConversionDetails: makeTranslator(KEYS.AGENCY.CLIENT.UPDATE_CONVERSION_DETAILS, localeCode),
                updateNotificationEmailAddresses: makeTranslator(KEYS.AGENCY.CLIENT.UPDATE_NOTIFICATION_EMAIL_ADDRESSES, localeCode),
                users: {
                    countSelected: makeTranslator(KEYS.AGENCY.CLIENT.USERS.COUNT_SELECTED, localeCode),
                    searchForUsersOrEmailAddresses: makeTranslator(KEYS.AGENCY.CLIENT.USERS.SEARCH_FOR_USERS_OR_EMAIL_ADDRESSES, localeCode),
                    sortDirectionTip: makeTranslator(KEYS.AGENCY.CLIENT.USERS.SORT_DIRECTION_TIP, localeCode),
                    title: makeTranslator(KEYS.AGENCY.CLIENT.USERS.TITLE, localeCode)
                }
            },
            clients: {
                addClient: {
                    channelLabel: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.CHANNEL_LABEL, localeCode),
                    clientAdded: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.CLIENT_ADDED, localeCode),
                    general: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.GENERAL, localeCode),
                    newChannel: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.NEW_CHANNEL, localeCode),
                    selectAPlatformToLinkThisChannelToOptional: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.SELECT_A_PLATFORM_TO_LINK_THIS_CHANNEL_TO_OPTIONAL, localeCode),
                    selfService: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.SELF_SERVICE, localeCode),
                    supported: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_CLIENT.SUPPORTED, localeCode)
                },
                addNewClient: makeTranslator(KEYS.AGENCY.CLIENTS.ADD_NEW_CLIENT, localeCode),
                clientName: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_NAME, localeCode),
                clientTable: {
                    actions: {
                        clientActions: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.CLIENT_ACTIONS, localeCode),
                        deleteClientDescription: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_DESCRIPTION, localeCode),
                        deleteClientLabel: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.DELETE_CLIENT_LABEL, localeCode),
                        enterNewName: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.ENTER_NEW_NAME, localeCode),
                        rename: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.ACTIONS.RENAME, localeCode)
                    },
                    headers: {
                        actions: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.ACTIONS, localeCode),
                        avgBuilds: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.AVG_BUILDS, localeCode),
                        numLocations: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.NUM_LOCATIONS, localeCode),
                        percentageConnected: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.PERCENTAGE_CONNECTED, localeCode),
                        title: makeTranslator(KEYS.AGENCY.CLIENTS.CLIENT_TABLE.HEADERS.TITLE, localeCode)
                    }
                },
                youHaveNotAddedAny: makeTranslator(KEYS.AGENCY.CLIENTS.YOU_HAVE_NOT_ADDED_ANY, localeCode)
            },
            contactDetails: {
                adwordsMarketing: makeTranslator(KEYS.AGENCY.CONTACT_DETAILS.ADWORDS_MARKETING, localeCode),
                agencyContactDetails: makeTranslator(KEYS.AGENCY.CONTACT_DETAILS.AGENCY_CONTACT_DETAILS, localeCode),
                contactDetails: makeTranslator(KEYS.AGENCY.CONTACT_DETAILS.CONTACT_DETAILS, localeCode),
                specialRequestDisclaimer: makeTranslator(KEYS.AGENCY.CONTACT_DETAILS.SPECIAL_REQUEST_DISCLAIMER, localeCode),
                updateContacts: makeTranslator(KEYS.AGENCY.CONTACT_DETAILS.UPDATE_CONTACTS, localeCode)
            },
            hashtagSets: {
                actions: {
                    addHashtagSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.ADD_HASHTAG_SET, localeCode),
                    messages: {
                        couldNotCreateSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_CREATE_SET, localeCode),
                        couldNotDeleteSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_DELETE_SET, localeCode),
                        couldNotUpdateSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.COULD_NOT_UPDATE_SET, localeCode),
                        createdSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.CREATED_SET, localeCode),
                        deletedSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.DELETED_SET, localeCode),
                        updatedSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.MESSAGES.UPDATED_SET, localeCode)
                    },
                    updateHashtagSet: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.ACTIONS.UPDATE_HASHTAG_SET, localeCode)
                },
                dialog: {
                    minimumOne: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.DIALOG.MINIMUM_ONE, localeCode),
                    requiredForAllPosts: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.DIALOG.REQUIRED_FOR_ALL_POSTS, localeCode),
                    startByTypingYourHashtags: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.DIALOG.START_BY_TYPING_YOUR_HASHTAGS, localeCode)
                },
                hashtagSets: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.HASHTAG_SETS, localeCode),
                hashtags: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.HASHTAGS, localeCode),
                tableHeaders: {
                    description: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.TABLE_HEADERS.DESCRIPTION, localeCode),
                    numberHashtags: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.TABLE_HEADERS.NUMBER_HASHTAGS, localeCode),
                    title: makeTranslator(KEYS.AGENCY.HASHTAG_SETS.TABLE_HEADERS.TITLE, localeCode)
                }
            },
            notifications: {
                agencyEmailNotifications: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.AGENCY_EMAIL_NOTIFICATIONS, localeCode),
                agencyNotifications: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.AGENCY_NOTIFICATIONS, localeCode),
                clickRate: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.CLICK_RATE, localeCode),
                clicks: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.CLICKS, localeCode),
                emailAddress: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.EMAIL_ADDRESS, localeCode),
                failedToLoad: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.FAILED_TO_LOAD, localeCode),
                helpText: {
                    clicks: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.HELP_TEXT.CLICKS, localeCode),
                    sent: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.HELP_TEXT.SENT, localeCode)
                },
                newComments: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.NEW_COMMENTS, localeCode),
                newSpecialRequests: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.NEW_SPECIAL_REQUESTS, localeCode),
                noLinkProvided: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.NO_LINK_PROVIDED, localeCode),
                noNotificationsFound: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.NO_NOTIFICATIONS_FOUND, localeCode),
                notificationsWillBeSent: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.NOTIFICATIONS_WILL_BE_SENT, localeCode),
                openLink: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.OPEN_LINK, localeCode),
                sendConfirm: {
                    message: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE, localeCode),
                    messagePlural: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SEND_CONFIRM.MESSAGE_plural, localeCode),
                    title: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SEND_CONFIRM.TITLE, localeCode)
                },
                sendNotification: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SEND_NOTIFICATION, localeCode),
                sendingInfo: {
                    mobile: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENDING_INFO.MOBILE, localeCode),
                    title: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENDING_INFO.TITLE, localeCode),
                    website: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENDING_INFO.WEBSITE, localeCode)
                },
                sent: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENT, localeCode),
                sentBy: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENT_BY, localeCode),
                sentNotifications: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SENT_NOTIFICATIONS, localeCode),
                subject: makeTranslator(KEYS.AGENCY.NOTIFICATIONS.SUBJECT, localeCode)
            },
            printSkuGroups: {
                agencyPrintProducts: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.AGENCY_PRINT_PRODUCTS, localeCode),
                attachedProviders: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.ATTACHED_PROVIDERS, localeCode),
                defaultCurrency: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.DEFAULT_CURRENCY, localeCode),
                printProvider: {
                    addNewPrintProvider: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ADD_NEW_PRINT_PROVIDER, localeCode),
                    attachToSkuGroup: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.ATTACH_TO_SKU_GROUP, localeCode),
                    authRequestConfirmation: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.AUTH_REQUEST_CONFIRMATION, localeCode),
                    noAvailableClients: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.NO_AVAILABLE_CLIENTS, localeCode),
                    paymentAuth: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PAYMENT_AUTH, localeCode),
                    printProviderAdded: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ADDED, localeCode),
                    printProviderAttached: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_ATTACHED, localeCode),
                    printProviderDetached: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.PRINT_PROVIDER_DETACHED, localeCode),
                    sendAuthRequest: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDER.SEND_AUTH_REQUEST, localeCode)
                },
                printProviders: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_PROVIDERS, localeCode),
                printSkuGroups: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.PRINT_SKU_GROUPS, localeCode),
                quantityOption: {
                    addNewQuantityOption: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.ADD_NEW_QUANTITY_OPTION, localeCode),
                    quantityAlreadyExists: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_ALREADY_EXISTS, localeCode),
                    quantityOptionAdded: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTION.QUANTITY_OPTION_ADDED, localeCode)
                },
                quantityOptions: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.QUANTITY_OPTIONS, localeCode),
                sku: {
                    addNewSku: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.ADD_NEW_SKU, localeCode),
                    createSku: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.CREATE_SKU, localeCode),
                    deleteSku: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.DELETE_SKU, localeCode),
                    editSku: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.EDIT_SKU, localeCode),
                    exclusive: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.EXCLUSIVE, localeCode),
                    formatsAppliedTo: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.FORMATS_APPLIED_TO, localeCode),
                    linearPricing: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.LINEAR_PRICING, localeCode),
                    sku: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU, localeCode),
                    skuAdded: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU_ADDED, localeCode),
                    skuDeleteConfirmation: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETE_CONFIRMATION, localeCode),
                    skuDeleted: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU_DELETED, localeCode),
                    skuGroupMissing: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU_GROUP_MISSING, localeCode),
                    skuUpdated: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU.SKU_UPDATED, localeCode)
                },
                skuGroups: {
                    addNewSkuGroup: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ADD_NEW_SKU_GROUP, localeCode),
                    deleteSkuGroup: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.DELETE_SKU_GROUP, localeCode),
                    editSkuGroup: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP, localeCode),
                    editSkuGroupTitle: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.EDIT_SKU_GROUP_TITLE, localeCode),
                    orderInformation: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.ORDER_INFORMATION, localeCode),
                    paymentGateway: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_GATEWAY, localeCode),
                    paymentUrl: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.PAYMENT_URL, localeCode),
                    skuGroup: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP, localeCode),
                    skuGroupAdded: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_ADDED, localeCode),
                    skuGroupDeleteConfirmation: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETE_CONFIRMATION, localeCode),
                    skuGroupDeleted: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DELETED, localeCode),
                    skuGroupDetails: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_DETAILS, localeCode),
                    skuGroupUpdated: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKU_GROUPS.SKU_GROUP_UPDATED, localeCode)
                },
                skus: makeTranslator(KEYS.AGENCY.PRINT_SKU_GROUPS.SKUS, localeCode)
            },
            sendReports: {
                actions: {
                    openReport: makeTranslator(KEYS.AGENCY.SEND_REPORTS.ACTIONS.OPEN_REPORT, localeCode)
                },
                agencyUserReportTable: {
                    headers: {
                        clicked: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.CLICKED, localeCode),
                        read: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.READ, localeCode),
                        recipientEmail: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL, localeCode),
                        recipientEmailFilterLabel: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_LABEL, localeCode),
                        recipientEmailFilterPlaceholder: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_EMAIL_FILTER_PLACEHOLDER, localeCode),
                        recipientName: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME, localeCode),
                        recipientNameFilterLabel: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_LABEL, localeCode),
                        recipientNameFilterPlaceholder: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.RECIPIENT_NAME_FILTER_PLACEHOLDER, localeCode),
                        sent: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.HEADERS.SENT, localeCode)
                    },
                    noRecipientsFound: makeTranslator(KEYS.AGENCY.SEND_REPORTS.AGENCY_USER_REPORT_TABLE.NO_RECIPIENTS_FOUND, localeCode)
                },
                report: {
                    clickedSubtitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.CLICKED_SUBTITLE, localeCode),
                    clickedTitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.CLICKED_TITLE, localeCode),
                    readSubtitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.READ_SUBTITLE, localeCode),
                    readTitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.READ_TITLE, localeCode),
                    sentFrom: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_FROM, localeCode),
                    sentSubtitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_SUBTITLE, localeCode),
                    sentTitle: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TITLE, localeCode),
                    sentToPart1: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_1, localeCode),
                    sentToPart2: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2, localeCode),
                    sentToPart2Plural: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_2_plural, localeCode),
                    sentToPart3: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TO_PART_3, localeCode),
                    sentToUsersFilteredByTitles: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SENT_TO_USERS_FILTERED_BY_TITLES, localeCode),
                    subtitleNotSent: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SUBTITLE_NOT_SENT, localeCode),
                    subtitleSentBy: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.SUBTITLE_SENT_BY, localeCode),
                    typeEmailTooltip: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.TYPE_EMAIL_TOOLTIP, localeCode),
                    typeInAppTooltip: makeTranslator(KEYS.AGENCY.SEND_REPORTS.REPORT.TYPE_IN_APP_TOOLTIP, localeCode)
                },
                title: makeTranslator(KEYS.AGENCY.SEND_REPORTS.TITLE, localeCode)
            },
            users: {
                clientUsers: makeTranslator(KEYS.AGENCY.USERS.CLIENT_USERS, localeCode),
                interactionDeleteUser: makeTranslator(KEYS.AGENCY.USERS.INTERACTION_DELETE_USER, localeCode),
                interactionGetClientUsers: makeTranslator(KEYS.AGENCY.USERS.INTERACTION_GET_CLIENT_USERS, localeCode),
                onlyShowOrphans: makeTranslator(KEYS.AGENCY.USERS.ONLY_SHOW_ORPHANS, localeCode)
            }
        },
        apps: {
            accessTokenConfigNotFoundOrPermissionError: makeTranslator(KEYS.APPS.ACCESS_TOKEN_CONFIG_NOT_FOUND_OR_PERMISSION_ERROR, localeCode),
            accountSuccessfullyConnected: {
                message: makeTranslator(KEYS.APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.MESSAGE, localeCode),
                title: makeTranslator(KEYS.APPS.ACCOUNT_SUCCESSFULLY_CONNECTED.TITLE, localeCode)
            },
            adwordsCustomer: makeTranslator(KEYS.APPS.ADWORDS_CUSTOMER, localeCode),
            analyticsProfile: makeTranslator(KEYS.APPS.ANALYTICS_PROFILE, localeCode),
            authorise: makeTranslator(KEYS.APPS.AUTHORISE, localeCode),
            authorizedAccount: makeTranslator(KEYS.APPS.AUTHORIZED_ACCOUNT, localeCode),
            business: makeTranslator(KEYS.APPS.BUSINESS, localeCode),
            campaignsFoundInAdwordsThatMatchName: makeTranslator(KEYS.APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME, localeCode),
            campaignsFoundInAdwordsThatMatchNamePlural: makeTranslator(KEYS.APPS.CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME_plural, localeCode),
            checkAccessToGoogleAdwords: makeTranslator(KEYS.APPS.CHECK_ACCESS_TO_GOOGLE_ADWORDS, localeCode),
            checkMatchedCampaignsRelateToLocation: makeTranslator(KEYS.APPS.CHECK_MATCHED_CAMPAIGNS_RELATE_TO_LOCATION, localeCode),
            company: makeTranslator(KEYS.APPS.COMPANY, localeCode),
            connectToAccessWelcomeMessage: {
                clubPilates: {
                    heading: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.HEADING, localeCode),
                    message: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.MESSAGE, localeCode),
                    subheading: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.CLUB_PILATES.SUBHEADING, localeCode)
                },
                default: {
                    heading: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.HEADING, localeCode),
                    message: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.MESSAGE, localeCode),
                    subheading: makeTranslator(KEYS.APPS.CONNECT_TO_ACCESS_WELCOME_MESSAGE.DEFAULT.SUBHEADING, localeCode)
                }
            },
            connectToAccount: makeTranslator(KEYS.APPS.CONNECT_TO_ACCOUNT, localeCode),
            connectToNewAccount: makeTranslator(KEYS.APPS.CONNECT_TO_NEW_ACCOUNT, localeCode),
            connectingViaAccount: makeTranslator(KEYS.APPS.CONNECTING_VIA_ACCOUNT, localeCode),
            customerId: makeTranslator(KEYS.APPS.CUSTOMER_ID, localeCode),
            deauthorise: makeTranslator(KEYS.APPS.DEAUTHORISE, localeCode),
            disconnectAccount: makeTranslator(KEYS.APPS.DISCONNECT_ACCOUNT, localeCode),
            disconnectFromAccount: makeTranslator(KEYS.APPS.DISCONNECT_FROM_ACCOUNT, localeCode),
            editConfiguration: makeTranslator(KEYS.APPS.EDIT_CONFIGURATION, localeCode),
            errors: {
                debugMessageWrap: makeTranslator(KEYS.APPS.ERRORS.DEBUG_MESSAGE_WRAP, localeCode),
                invalidConfiguration: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.INVALID_CONFIGURATION.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.INVALID_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode)
                },
                missingConfiguration: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.MISSING_CONFIGURATION.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.MISSING_CONFIGURATION.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode)
                },
                missingPermissions: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.MISSING_PERMISSIONS.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode),
                    provideResolutionCantConfigureAlternate: makeTranslator(KEYS.APPS.ERRORS.MISSING_PERMISSIONS.PROVIDE_RESOLUTION_CANT_CONFIGURE_ALTERNATE, localeCode)
                },
                facebookPasswordChanged: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_PASSWORD_CHANGED.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode)
                },
                facebookInvalidSession: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_INVALID_SESSION.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_INVALID_SESSION.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode)
                },
                facebookAccessTokenIssue: {
                    explainIssue: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.EXPLAIN_ISSUE, localeCode),
                    provideResolutionCanConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CAN_CONFIGURE, localeCode),
                    provideResolutionCantConfigure: makeTranslator(KEYS.APPS.ERRORS.FACEBOOK_ACCESS_TOKEN_ISSUE.PROVIDE_RESOLUTION_CANT_CONFIGURE, localeCode)
                },
                weveEncounteredIssues: makeTranslator(KEYS.APPS.ERRORS.WEVE_ENCOUNTERED_ISSUES, localeCode)
            },
            facebook: {
                pageIdAndNameRequired: makeTranslator(KEYS.APPS.FACEBOOK.PAGE_ID_AND_NAME_REQUIRED, localeCode),
                pageUpdated: makeTranslator(KEYS.APPS.FACEBOOK.PAGE_UPDATED, localeCode)
            },
            facebookMarketing: {
                accountName: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.ACCOUNT_NAME, localeCode),
                adAccountCleared: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.AD_ACCOUNT_CLEARED, localeCode),
                adAccountSet: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.AD_ACCOUNT_SET, localeCode),
                checkAuthorisation: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.CHECK_AUTHORISATION, localeCode),
                checkConfigAccess: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.CHECK_CONFIG_ACCESS, localeCode),
                facebookAdAccount: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.FACEBOOK_AD_ACCOUNT, localeCode),
                retrieveAdAccounts: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.RETRIEVE_AD_ACCOUNTS, localeCode),
                retrieveConfig: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.RETRIEVE_CONFIG, localeCode),
                title: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.TITLE, localeCode),
                updateAdAccount: makeTranslator(KEYS.APPS.FACEBOOK_MARKETING.UPDATE_AD_ACCOUNT, localeCode)
            },
            facebookPage: makeTranslator(KEYS.APPS.FACEBOOK_PAGE, localeCode),
            facebookPageHelp: makeTranslator(KEYS.APPS.FACEBOOK_PAGE_HELP, localeCode),
            facebookPageNotAvailable: makeTranslator(KEYS.APPS.FACEBOOK_PAGE_NOT_AVAILABLE, localeCode),
            fetchServiceConfig: makeTranslator(KEYS.APPS.FETCH_SERVICE_CONFIG, localeCode),
            fitware: makeTranslator(KEYS.APPS.FITWARE, localeCode),
            fitwareClub: makeTranslator(KEYS.APPS.FITWARE_CLUB, localeCode),
            fitwareNote: makeTranslator(KEYS.APPS.FITWARE_NOTE, localeCode),
            four51: {
                company: makeTranslator(KEYS.APPS.FOUR51.COMPANY, localeCode),
                companyUpdated: makeTranslator(KEYS.APPS.FOUR51.COMPANY_UPDATED, localeCode),
                credentialsDeleted: makeTranslator(KEYS.APPS.FOUR51.CREDENTIALS_DELETED, localeCode),
                credentialsUpdated: makeTranslator(KEYS.APPS.FOUR51.CREDENTIALS_UPDATED, localeCode),
                deleteCredentialsWarning: makeTranslator(KEYS.APPS.FOUR51.DELETE_CREDENTIALS_WARNING, localeCode),
                invalidNewCredentials: makeTranslator(KEYS.APPS.FOUR51.INVALID_NEW_CREDENTIALS, localeCode),
                ssoKey: makeTranslator(KEYS.APPS.FOUR51.SSO_KEY, localeCode),
                store: makeTranslator(KEYS.APPS.FOUR51.STORE, localeCode)
            },
            googleAdwords: {
                campaignName: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME, localeCode),
                campaignNameDoesntMatchContinue: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_DOESNT_MATCH_CONTINUE, localeCode),
                campaignNameMatchesCountContinue: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.CAMPAIGN_NAME_MATCHES_COUNT_CONTINUE, localeCode),
                customer: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.CUSTOMER, localeCode),
                multipleCampaignsFound: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.MULTIPLE_CAMPAIGNS_FOUND, localeCode),
                noCampaignsFound: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS.NO_CAMPAIGNS_FOUND, localeCode)
            },
            googleAdwordsCampaignName: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS_CAMPAIGN_NAME, localeCode),
            googleAdwordsCustomerCleared: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS_CUSTOMER_CLEARED, localeCode),
            googleAdwordsCustomerSet: makeTranslator(KEYS.APPS.GOOGLE_ADWORDS_CUSTOMER_SET, localeCode),
            googleAnalytics: {
                pagePath: makeTranslator(KEYS.APPS.GOOGLE_ANALYTICS.PAGE_PATH, localeCode)
            },
            googleAnalyticsPagePath: makeTranslator(KEYS.APPS.GOOGLE_ANALYTICS_PAGE_PATH, localeCode),
            googleMyBusiness: {
                accountName: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.ACCOUNT_NAME, localeCode),
                asyncDescriptions: {
                    fetchingAccountNames: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_ACCOUNT_NAMES, localeCode),
                    fetchingCanConfigure: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE, localeCode),
                    fetchingLocationNames: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.FETCHING_LOCATION_NAMES, localeCode),
                    updatingConfig: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.ASYNC_DESCRIPTIONS.UPDATING_CONFIG, localeCode)
                },
                configUpdated: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.CONFIG_UPDATED, localeCode),
                locationName: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.LOCATION_NAME, localeCode),
                locationNotEnabledHelpTextExplanation: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_EXPLANATION, localeCode),
                locationNotEnabledHelpTextTitle: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.LOCATION_NOT_ENABLED_HELP_TEXT_TITLE, localeCode),
                noAddress: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.NO_ADDRESS, localeCode),
                states: {
                    disabled: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.DISABLED, localeCode),
                    disconnected: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.DISCONNECTED, localeCode),
                    localPostApiDisabled: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.LOCAL_POST_API_DISABLED, localeCode),
                    needsReverification: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.NEEDS_REVERIFICATION, localeCode),
                    notPublished: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.NOT_PUBLISHED, localeCode),
                    notVerified: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.NOT_VERIFIED, localeCode),
                    pendingReview: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_REVIEW, localeCode),
                    pendingVerification: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.PENDING_VERIFICATION, localeCode),
                    suspended: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.SUSPENDED, localeCode),
                    temporarilyEnabled: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.TEMPORARILY_ENABLED, localeCode),
                    verified: makeTranslator(KEYS.APPS.GOOGLE_MY_BUSINESS.STATES.VERIFIED, localeCode)
                }
            },
            instagram: {
                accountNotListed: makeTranslator(KEYS.APPS.INSTAGRAM.ACCOUNT_NOT_LISTED, localeCode),
                accountNotListedExplanation: makeTranslator(KEYS.APPS.INSTAGRAM.ACCOUNT_NOT_LISTED_EXPLANATION, localeCode),
                configUpdatedSuccessMessage: makeTranslator(KEYS.APPS.INSTAGRAM.CONFIG_UPDATED_SUCCESS_MESSAGE, localeCode),
                connectedAccount: makeTranslator(KEYS.APPS.INSTAGRAM.CONNECTED_ACCOUNT, localeCode),
                connectedAccountInfo: makeTranslator(KEYS.APPS.INSTAGRAM.CONNECTED_ACCOUNT_INFO, localeCode),
                fetchAvailableInstagramAccounts: makeTranslator(KEYS.APPS.INSTAGRAM.FETCH_AVAILABLE_INSTAGRAM_ACCOUNTS, localeCode),
                fetchingCanConfigure: makeTranslator(KEYS.APPS.INSTAGRAM.FETCHING_CAN_CONFIGURE, localeCode),
                updateConfig: makeTranslator(KEYS.APPS.INSTAGRAM.UPDATE_CONFIG, localeCode)
            },
            linkToGoogleAdwords: makeTranslator(KEYS.APPS.LINK_TO_GOOGLE_ADWORDS, localeCode),
            linkedin: {
                asyncDescriptions: {
                    fetchingCanConfigure: makeTranslator(KEYS.APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_CAN_CONFIGURE, localeCode),
                    fetchingPageNames: makeTranslator(KEYS.APPS.LINKEDIN.ASYNC_DESCRIPTIONS.FETCHING_PAGE_NAMES, localeCode),
                    updatingConfig: makeTranslator(KEYS.APPS.LINKEDIN.ASYNC_DESCRIPTIONS.UPDATING_CONFIG, localeCode)
                },
                configUpdated: makeTranslator(KEYS.APPS.LINKEDIN.CONFIG_UPDATED, localeCode),
                pageName: makeTranslator(KEYS.APPS.LINKEDIN.PAGE_NAME, localeCode),
                pageNotListed: makeTranslator(KEYS.APPS.LINKEDIN.PAGE_NOT_LISTED, localeCode),
                pageNotListedExplanation: makeTranslator(KEYS.APPS.LINKEDIN.PAGE_NOT_LISTED_EXPLANATION, localeCode)
            },
            manualEntry: makeTranslator(KEYS.APPS.MANUAL_ENTRY, localeCode),
            noCampaignsFoundInAdwordsThatMatchName: makeTranslator(KEYS.APPS.NO_CAMPAIGNS_FOUND_IN_ADWORDS_THAT_MATCH_NAME, localeCode),
            noFacebookPageAccessHeading: makeTranslator(KEYS.APPS.NO_FACEBOOK_PAGE_ACCESS_HEADING, localeCode),
            pageId: makeTranslator(KEYS.APPS.PAGE_ID, localeCode),
            pageName: makeTranslator(KEYS.APPS.PAGE_NAME, localeCode),
            pleaseSelectAnAdwordsCustomer: makeTranslator(KEYS.APPS.PLEASE_SELECT_AN_ADWORDS_CUSTOMER, localeCode),
            printProvider: makeTranslator(KEYS.APPS.PRINT_PROVIDER, localeCode),
            printProviderSkuGroupAttached: makeTranslator(KEYS.APPS.PRINT_PROVIDER_SKU_GROUP_ATTACHED, localeCode),
            propertyId: makeTranslator(KEYS.APPS.PROPERTY_ID, localeCode),
            refreshMatchingCampaigns: makeTranslator(KEYS.APPS.REFRESH_MATCHING_CAMPAIGNS, localeCode),
            thisWillMatchCampaignsWithNameContainingText: makeTranslator(KEYS.APPS.THIS_WILL_MATCH_CAMPAIGNS_WITH_NAME_CONTAINING_TEXT, localeCode),
            updateGoogleAdwordsCustomer: makeTranslator(KEYS.APPS.UPDATE_GOOGLE_ADWORDS_CUSTOMER, localeCode),
            updatedGoogleAdwordsCampaignName: makeTranslator(KEYS.APPS.UPDATED_GOOGLE_ADWORDS_CAMPAIGN_NAME, localeCode)
        },
        assetLibrary: {
            automaticallyExpireTheseAssets: makeTranslator(KEYS.ASSET_LIBRARY.AUTOMATICALLY_EXPIRE_THESE_ASSETS, localeCode),
            bin: makeTranslator(KEYS.ASSET_LIBRARY.BIN, localeCode),
            binAssets: makeTranslator(KEYS.ASSET_LIBRARY.BIN_ASSETS, localeCode),
            chooseCollection: makeTranslator(KEYS.ASSET_LIBRARY.CHOOSE_COLLECTION, localeCode),
            chooseCollectionRequest: makeTranslator(KEYS.ASSET_LIBRARY.CHOOSE_COLLECTION_REQUEST, localeCode),
            collectionLimitReached: makeTranslator(KEYS.ASSET_LIBRARY.COLLECTION_LIMIT_REACHED, localeCode),
            copyAssetUrl: makeTranslator(KEYS.ASSET_LIBRARY.COPY_ASSET_URL, localeCode),
            createFolderModalTitle: makeTranslator(KEYS.ASSET_LIBRARY.CREATE_FOLDER_MODAL_TITLE, localeCode),
            deleteCollectionNote: makeTranslator(KEYS.ASSET_LIBRARY.DELETE_COLLECTION_NOTE, localeCode),
            differentExpiryDateAlert: makeTranslator(KEYS.ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_ALERT, localeCode),
            differentExpiryDateInfo: makeTranslator(KEYS.ASSET_LIBRARY.DIFFERENT_EXPIRY_DATE_INFO, localeCode),
            editFolder: makeTranslator(KEYS.ASSET_LIBRARY.EDIT_FOLDER, localeCode),
            expiredAssets: makeTranslator(KEYS.ASSET_LIBRARY.EXPIRED_ASSETS, localeCode),
            explain: makeTranslator(KEYS.ASSET_LIBRARY.EXPLAIN, localeCode),
            hideBin: makeTranslator(KEYS.ASSET_LIBRARY.HIDE_BIN, localeCode),
            list: makeTranslator(KEYS.ASSET_LIBRARY.LIST, localeCode),
            moveAssetsToFolder: makeTranslator(KEYS.ASSET_LIBRARY.MOVE_ASSETS_TO_FOLDER, localeCode),
            movingAssets: makeTranslator(KEYS.ASSET_LIBRARY.MOVING_ASSETS, localeCode),
            newFolder: makeTranslator(KEYS.ASSET_LIBRARY.NEW_FOLDER, localeCode),
            noAssetsInFolder: makeTranslator(KEYS.ASSET_LIBRARY.NO_ASSETS_IN_FOLDER, localeCode),
            noCollectionsFound: makeTranslator(KEYS.ASSET_LIBRARY.NO_COLLECTIONS_FOUND, localeCode),
            pleaseSelectCollection: makeTranslator(KEYS.ASSET_LIBRARY.PLEASE_SELECT_COLLECTION, localeCode),
            removeExpirationDate: makeTranslator(KEYS.ASSET_LIBRARY.REMOVE_EXPIRATION_DATE, localeCode),
            restore: makeTranslator(KEYS.ASSET_LIBRARY.RESTORE, localeCode),
            savingAssets: makeTranslator(KEYS.ASSET_LIBRARY.SAVING_ASSETS, localeCode),
            searchCollections: makeTranslator(KEYS.ASSET_LIBRARY.SEARCH_COLLECTIONS, localeCode),
            securityWarning: makeTranslator(KEYS.ASSET_LIBRARY.SECURITY_WARNING, localeCode),
            securityWarningDescription: makeTranslator(KEYS.ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION, localeCode),
            selectedClients: makeTranslator(KEYS.ASSET_LIBRARY.SELECTED_CLIENTS, localeCode),
            selectedLocations: makeTranslator(KEYS.ASSET_LIBRARY.SELECTED_LOCATIONS, localeCode),
            sharedWith: makeTranslator(KEYS.ASSET_LIBRARY.SHARED_WITH, localeCode),
            showBin: makeTranslator(KEYS.ASSET_LIBRARY.SHOW_BIN, localeCode),
            thumbnail: makeTranslator(KEYS.ASSET_LIBRARY.THUMBNAIL, localeCode),
            unableToLoad: makeTranslator(KEYS.ASSET_LIBRARY.UNABLE_TO_LOAD, localeCode),
            uploadAsset: makeTranslator(KEYS.ASSET_LIBRARY.UPLOAD_ASSET, localeCode),
            uploadingAssets: makeTranslator(KEYS.ASSET_LIBRARY.UPLOADING_ASSETS, localeCode)
        },
        build: {
            actual: makeTranslator(KEYS.BUILD.ACTUAL, localeCode),
            addressNotSet: makeTranslator(KEYS.BUILD.ADDRESS_NOT_SET, localeCode),
            agencyFilters: {
                hideMobile: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.HIDE_MOBILE, localeCode),
                hidePublished: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.HIDE_PUBLISHED, localeCode),
                hideUnpublished: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.HIDE_UNPUBLISHED, localeCode),
                isMultiImage: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.IS_MULTI_IMAGE, localeCode),
                onlyLocationDrafts: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS, localeCode),
                onlyLocationDraftsButton: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.ONLY_LOCATION_DRAFTS_BUTTON, localeCode),
                onlyMobile: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.ONLY_MOBILE, localeCode),
                title: makeTranslator(KEYS.BUILD.AGENCY_FILTERS.TITLE, localeCode)
            },
            allClients: makeTranslator(KEYS.BUILD.ALL_CLIENTS, localeCode),
            allEditableElements: makeTranslator(KEYS.BUILD.ALL_EDITABLE_ELEMENTS, localeCode),
            allFormats: makeTranslator(KEYS.BUILD.ALL_FORMATS, localeCode),
            animation: {
                addFrameAfter: makeTranslator(KEYS.BUILD.ANIMATION.ADD_FRAME_AFTER, localeCode),
                addFrameBefore: makeTranslator(KEYS.BUILD.ANIMATION.ADD_FRAME_BEFORE, localeCode),
                animation: makeTranslator(KEYS.BUILD.ANIMATION.ANIMATION, localeCode),
                confirmDeleteFrame: makeTranslator(KEYS.BUILD.ANIMATION.CONFIRM_DELETE_FRAME, localeCode),
                deleteFrame: makeTranslator(KEYS.BUILD.ANIMATION.DELETE_FRAME, localeCode),
                duration: makeTranslator(KEYS.BUILD.ANIMATION.DURATION, localeCode),
                frameNumberOfCount: makeTranslator(KEYS.BUILD.ANIMATION.FRAME_NUMBER_OF_COUNT, localeCode),
                play: makeTranslator(KEYS.BUILD.ANIMATION.PLAY, localeCode),
                stop: makeTranslator(KEYS.BUILD.ANIMATION.STOP, localeCode),
                toggleAnimationConfirm: makeTranslator(KEYS.BUILD.ANIMATION.TOGGLE_ANIMATION_CONFIRM, localeCode)
            },
            atLeastOneFormatRequired: makeTranslator(KEYS.BUILD.AT_LEAST_ONE_FORMAT_REQUIRED, localeCode),
            backToGallery: makeTranslator(KEYS.BUILD.BACK_TO_GALLERY, localeCode),
            background: makeTranslator(KEYS.BUILD.BACKGROUND, localeCode),
            blendMode: {
                color: makeTranslator(KEYS.BUILD.BLEND_MODE.COLOR, localeCode),
                difference: makeTranslator(KEYS.BUILD.BLEND_MODE.DIFFERENCE, localeCode),
                hardLight: makeTranslator(KEYS.BUILD.BLEND_MODE.HARD_LIGHT, localeCode),
                hue: makeTranslator(KEYS.BUILD.BLEND_MODE.HUE, localeCode),
                multiply: makeTranslator(KEYS.BUILD.BLEND_MODE.MULTIPLY, localeCode),
                normal: makeTranslator(KEYS.BUILD.BLEND_MODE.NORMAL, localeCode),
                overlay: makeTranslator(KEYS.BUILD.BLEND_MODE.OVERLAY, localeCode),
                saturation: makeTranslator(KEYS.BUILD.BLEND_MODE.SATURATION, localeCode),
                screen: makeTranslator(KEYS.BUILD.BLEND_MODE.SCREEN, localeCode),
                softLight: makeTranslator(KEYS.BUILD.BLEND_MODE.SOFT_LIGHT, localeCode)
            },
            builderMode: {
                advanced: makeTranslator(KEYS.BUILD.BUILDER_MODE.ADVANCED, localeCode),
                simple: makeTranslator(KEYS.BUILD.BUILDER_MODE.SIMPLE, localeCode)
            },
            builderTemplateDeleteConfirmationModal: {
                confirmationMessage: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE, localeCode),
                confirmationMessagePlural: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural, localeCode),
                title: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_DELETE_CONFIRMATION_MODAL.TITLE, localeCode)
            },
            builderTemplateUpdateConfirmationModal: {
                affectedLocations: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.AFFECTED_LOCATIONS, localeCode),
                confirmationMessage: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE, localeCode),
                confirmationMessagePlural: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.CONFIRMATION_MESSAGE_plural, localeCode),
                deleteLocationDrafts: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.DELETE_LOCATION_DRAFTS, localeCode),
                keepLocationDrafts: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.KEEP_LOCATION_DRAFTS, localeCode),
                title: makeTranslator(KEYS.BUILD.BUILDER_TEMPLATE_UPDATE_CONFIRMATION_MODAL.TITLE, localeCode)
            },
            cantFindWhatYouAreLookingFor: makeTranslator(KEYS.BUILD.CANT_FIND_WHAT_YOU_ARE_LOOKING_FOR, localeCode),
            channelData: makeTranslator(KEYS.BUILD.CHANNEL_DATA, localeCode),
            cmykColorDisclaimer: makeTranslator(KEYS.BUILD.CMYK_COLOR_DISCLAIMER, localeCode),
            colorPicker: {
                black: makeTranslator(KEYS.BUILD.COLOR_PICKER.BLACK, localeCode),
                blue: makeTranslator(KEYS.BUILD.COLOR_PICKER.BLUE, localeCode),
                cmyk: makeTranslator(KEYS.BUILD.COLOR_PICKER.CMYK, localeCode),
                cmykHeader: makeTranslator(KEYS.BUILD.COLOR_PICKER.CMYK_HEADER, localeCode),
                cyan: makeTranslator(KEYS.BUILD.COLOR_PICKER.CYAN, localeCode),
                green: makeTranslator(KEYS.BUILD.COLOR_PICKER.GREEN, localeCode),
                hsl: makeTranslator(KEYS.BUILD.COLOR_PICKER.HSL, localeCode),
                hue: makeTranslator(KEYS.BUILD.COLOR_PICKER.HUE, localeCode),
                lum: makeTranslator(KEYS.BUILD.COLOR_PICKER.LUM, localeCode),
                magenta: makeTranslator(KEYS.BUILD.COLOR_PICKER.MAGENTA, localeCode),
                name: makeTranslator(KEYS.BUILD.COLOR_PICKER.NAME, localeCode),
                opacity: makeTranslator(KEYS.BUILD.COLOR_PICKER.OPACITY, localeCode),
                red: makeTranslator(KEYS.BUILD.COLOR_PICKER.RED, localeCode),
                rgb: makeTranslator(KEYS.BUILD.COLOR_PICKER.RGB, localeCode),
                rgbHeader: makeTranslator(KEYS.BUILD.COLOR_PICKER.RGB_HEADER, localeCode),
                sat: makeTranslator(KEYS.BUILD.COLOR_PICKER.SAT, localeCode),
                yellow: makeTranslator(KEYS.BUILD.COLOR_PICKER.YELLOW, localeCode)
            },
            complete: makeTranslator(KEYS.BUILD.COMPLETE, localeCode),
            confirmBuilderTemplateUpdate: makeTranslator(KEYS.BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE, localeCode),
            confirmBuilderTemplateUpdateMessage: makeTranslator(KEYS.BUILD.CONFIRM_BUILDER_TEMPLATE_UPDATE_MESSAGE, localeCode),
            confirmDeleteAllChannelData: makeTranslator(KEYS.BUILD.CONFIRM_DELETE_ALL_CHANNEL_DATA, localeCode),
            customImageRequired: makeTranslator(KEYS.BUILD.CUSTOM_IMAGE_REQUIRED, localeCode),
            customTextRequired: makeTranslator(KEYS.BUILD.CUSTOM_TEXT_REQUIRED, localeCode),
            deleteConfirmation: makeTranslator(KEYS.BUILD.DELETE_CONFIRMATION, localeCode),
            deleteTemplate: makeTranslator(KEYS.BUILD.DELETE_TEMPLATE, localeCode),
            desktopView: makeTranslator(KEYS.BUILD.DESKTOP_VIEW, localeCode),
            dimensions: makeTranslator(KEYS.BUILD.DIMENSIONS, localeCode),
            duplicate: makeTranslator(KEYS.BUILD.DUPLICATE, localeCode),
            duplicateLayer: makeTranslator(KEYS.BUILD.DUPLICATE_LAYER, localeCode),
            editableElements: makeTranslator(KEYS.BUILD.EDITABLE_ELEMENTS, localeCode),
            ellipse: makeTranslator(KEYS.BUILD.ELLIPSE, localeCode),
            email: {
                authorizeOnAppsPage: makeTranslator(KEYS.BUILD.EMAIL.AUTHORIZE_ON_APPS_PAGE, localeCode),
                blackTextEditorBackground: makeTranslator(KEYS.BUILD.EMAIL.BLACK_TEXT_EDITOR_BACKGROUND, localeCode),
                cantAddImageElement: makeTranslator(KEYS.BUILD.EMAIL.CANT_ADD_IMAGE_ELEMENT, localeCode),
                defaultInstructions: makeTranslator(KEYS.BUILD.EMAIL.DEFAULT_INSTRUCTIONS, localeCode),
                editSource: makeTranslator(KEYS.BUILD.EMAIL.EDIT_SOURCE, localeCode),
                editSourceWarning: makeTranslator(KEYS.BUILD.EMAIL.EDIT_SOURCE_WARNING, localeCode),
                emailBuilder: makeTranslator(KEYS.BUILD.EMAIL.EMAIL_BUILDER, localeCode),
                emailPreview: makeTranslator(KEYS.BUILD.EMAIL.EMAIL_PREVIEW, localeCode),
                failedToParseHtml: makeTranslator(KEYS.BUILD.EMAIL.FAILED_TO_PARSE_HTML, localeCode),
                failedToProcessZipFile: makeTranslator(KEYS.BUILD.EMAIL.FAILED_TO_PROCESS_ZIP_FILE, localeCode),
                failedToReadZipFile: makeTranslator(KEYS.BUILD.EMAIL.FAILED_TO_READ_ZIP_FILE, localeCode),
                failedToValidateZipFile: makeTranslator(KEYS.BUILD.EMAIL.FAILED_TO_VALIDATE_ZIP_FILE, localeCode),
                imageExceedsRecommendedSizeWarning: makeTranslator(KEYS.BUILD.EMAIL.IMAGE_EXCEEDS_RECOMMENDED_SIZE_WARNING, localeCode),
                imageTimeout: makeTranslator(KEYS.BUILD.EMAIL.IMAGE_TIMEOUT, localeCode),
                locationNotAuthorized: makeTranslator(KEYS.BUILD.EMAIL.LOCATION_NOT_AUTHORIZED, localeCode),
                mailMerge: makeTranslator(KEYS.BUILD.EMAIL.MAIL_MERGE, localeCode),
                noCampaginMonitorSetupForLocation: makeTranslator(KEYS.BUILD.EMAIL.NO_CAMPAGIN_MONITOR_SETUP_FOR_LOCATION, localeCode),
                pleaseAddressIssuesWithZipFile: makeTranslator(KEYS.BUILD.EMAIL.PLEASE_ADDRESS_ISSUES_WITH_ZIP_FILE, localeCode),
                selectZipFile: makeTranslator(KEYS.BUILD.EMAIL.SELECT_ZIP_FILE, localeCode),
                updatePlannerStatus: makeTranslator(KEYS.BUILD.EMAIL.UPDATE_PLANNER_STATUS, localeCode),
                uploadOnlyOnePreview: makeTranslator(KEYS.BUILD.EMAIL.UPLOAD_ONLY_ONE_PREVIEW, localeCode),
                uploadOnlyOneZipFile: makeTranslator(KEYS.BUILD.EMAIL.UPLOAD_ONLY_ONE_ZIP_FILE, localeCode),
                visibility: makeTranslator(KEYS.BUILD.EMAIL.VISIBILITY, localeCode),
                visible: makeTranslator(KEYS.BUILD.EMAIL.VISIBLE, localeCode),
                zipFile: makeTranslator(KEYS.BUILD.EMAIL.ZIP_FILE, localeCode),
                zipValidation: {
                    htmlMissing: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.HTML_MISSING, localeCode),
                    htmlMultiple: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.HTML_MULTIPLE, localeCode),
                    imageMissing: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.IMAGE_MISSING, localeCode),
                    imageUnreferenced: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.IMAGE_UNREFERENCED, localeCode),
                    previewImageMissing: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MISSING, localeCode),
                    previewImageMultiple: makeTranslator(KEYS.BUILD.EMAIL.ZIP_VALIDATION.PREVIEW_IMAGE_MULTIPLE, localeCode)
                }
            },
            error: {
                dimensionsForPngInPrintTemplatesLimited: makeTranslator(KEYS.BUILD.ERROR.DIMENSIONS_FOR_PNG_IN_PRINT_TEMPLATES_LIMITED, localeCode),
                failedToCreateTag: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_CREATE_TAG, localeCode),
                failedToDeleteTemplate: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_DELETE_TEMPLATE, localeCode),
                failedToGetClients: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_GET_CLIENTS, localeCode),
                failedToGetLocation: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_GET_LOCATION, localeCode),
                failedToRetrieveBuilderTemplateFormats: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_RETRIEVE_BUILDER_TEMPLATE_FORMATS, localeCode),
                failedToRetrieveTemplate: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_RETRIEVE_TEMPLATE, localeCode),
                failedToSaveTemplate: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_SAVE_TEMPLATE, localeCode),
                failedToUploadImages: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_UPLOAD_IMAGES, localeCode),
                failedToUploadThumbnail: makeTranslator(KEYS.BUILD.ERROR.FAILED_TO_UPLOAD_THUMBNAIL, localeCode)
            },
            featuredTemplateSets: makeTranslator(KEYS.BUILD.FEATURED_TEMPLATE_SETS, localeCode),
            fetchingBuilderTemplateInfo: makeTranslator(KEYS.BUILD.FETCHING_BUILDER_TEMPLATE_INFO, localeCode),
            firstComment: makeTranslator(KEYS.BUILD.FIRST_COMMENT, localeCode),
            fit: makeTranslator(KEYS.BUILD.FIT, localeCode),
            fonts: {
                addFont: makeTranslator(KEYS.BUILD.FONTS.ADD_FONT, localeCode),
                addFontForClient: makeTranslator(KEYS.BUILD.FONTS.ADD_FONT_FOR_CLIENT, localeCode),
                areYouSureDeleteFamily: makeTranslator(KEYS.BUILD.FONTS.ARE_YOU_SURE_DELETE_FAMILY, localeCode),
                checkYouAreViewingCorrectClient: makeTranslator(KEYS.BUILD.FONTS.CHECK_YOU_ARE_VIEWING_CORRECT_CLIENT, localeCode),
                contextActions: makeTranslator(KEYS.BUILD.FONTS.CONTEXT_ACTIONS, localeCode),
                createFontInstructions: makeTranslator(KEYS.BUILD.FONTS.CREATE_FONT_INSTRUCTIONS, localeCode),
                deleteFontFamily: makeTranslator(KEYS.BUILD.FONTS.DELETE_FONT_FAMILY, localeCode),
                enterNewFontFamily: makeTranslator(KEYS.BUILD.FONTS.ENTER_NEW_FONT_FAMILY, localeCode),
                errorLoadingFonts: makeTranslator(KEYS.BUILD.FONTS.ERROR_LOADING_FONTS, localeCode),
                errors: {
                    couldNotDeleteFont: makeTranslator(KEYS.BUILD.FONTS.ERRORS.COULD_NOT_DELETE_FONT, localeCode),
                    errorRenaming: makeTranslator(KEYS.BUILD.FONTS.ERRORS.ERROR_RENAMING, localeCode),
                    issueUploadingFont: makeTranslator(KEYS.BUILD.FONTS.ERRORS.ISSUE_UPLOADING_FONT, localeCode)
                },
                filterFonts: makeTranslator(KEYS.BUILD.FONTS.FILTER_FONTS, localeCode),
                fontActions: makeTranslator(KEYS.BUILD.FONTS.FONT_ACTIONS, localeCode),
                fontDeleted: makeTranslator(KEYS.BUILD.FONTS.FONT_DELETED, localeCode),
                fontFamily: makeTranslator(KEYS.BUILD.FONTS.FONT_FAMILY, localeCode),
                fontType: makeTranslator(KEYS.BUILD.FONTS.FONT_TYPE, localeCode),
                fontUploaded: makeTranslator(KEYS.BUILD.FONTS.FONT_UPLOADED, localeCode),
                fontsMissing: makeTranslator(KEYS.BUILD.FONTS.FONTS_MISSING, localeCode),
                pleaseContactAgencyToFix: makeTranslator(KEYS.BUILD.FONTS.PLEASE_CONTACT_AGENCY_TO_FIX, localeCode),
                renamedFont: makeTranslator(KEYS.BUILD.FONTS.RENAMED_FONT, localeCode),
                someFontsCouldNotBeLoaded: makeTranslator(KEYS.BUILD.FONTS.SOME_FONTS_COULD_NOT_BE_LOADED, localeCode),
                templateUsesMissingFonts: makeTranslator(KEYS.BUILD.FONTS.TEMPLATE_USES_MISSING_FONTS, localeCode)
            },
            formatsSelected: makeTranslator(KEYS.BUILD.FORMATS_SELECTED, localeCode),
            formatsSelectedPlural: makeTranslator(KEYS.BUILD.FORMATS_SELECTED_plural, localeCode),
            four51: {
                noAccessModalMessage: makeTranslator(KEYS.BUILD.FOUR51.NO_ACCESS_MODAL_MESSAGE, localeCode),
                noAccessModalTitle: makeTranslator(KEYS.BUILD.FOUR51.NO_ACCESS_MODAL_TITLE, localeCode)
            },
            gallery: makeTranslator(KEYS.BUILD.GALLERY, localeCode),
            hideDetails: makeTranslator(KEYS.BUILD.HIDE_DETAILS, localeCode),
            image: {
                unsupportedFormat: makeTranslator(KEYS.BUILD.IMAGE.UNSUPPORTED_FORMAT, localeCode)
            },
            imageChooser: {
                confirmAcknowledged: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.CONFIRM_ACKNOWLEDGED, localeCode),
                confirmPermission: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.CONFIRM_PERMISSION, localeCode),
                imageSource: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.IMAGE_SOURCE, localeCode),
                localFile: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.LOCAL_FILE, localeCode),
                locationLogo: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.LOCATION_LOGO, localeCode),
                maxUploadError: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.MAX_UPLOAD_ERROR, localeCode),
                permissionDisclaimer: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER, localeCode),
                permissionDisclaimerStrong: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.PERMISSION_DISCLAIMER_STRONG, localeCode),
                permissionError: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.PERMISSION_ERROR, localeCode),
                selectImage: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.SELECT_IMAGE, localeCode),
                selectImageFromYourLibrary: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.SELECT_IMAGE_FROM_YOUR_LIBRARY, localeCode),
                suggestedCollection: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.SUGGESTED_COLLECTION, localeCode),
                uploadImageFromYourDevice: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.UPLOAD_IMAGE_FROM_YOUR_DEVICE, localeCode),
                uploadedAssetImage: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.UPLOADED_ASSET_IMAGE, localeCode),
                uploadedPlannerImage: makeTranslator(KEYS.BUILD.IMAGE_CHOOSER.UPLOADED_PLANNER_IMAGE, localeCode)
            },
            imageCropper: {
                clear: makeTranslator(KEYS.BUILD.IMAGE_CROPPER.CLEAR, localeCode),
                cropImage: makeTranslator(KEYS.BUILD.IMAGE_CROPPER.CROP_IMAGE, localeCode),
                rotate: makeTranslator(KEYS.BUILD.IMAGE_CROPPER.ROTATE, localeCode)
            },
            imageCropperPromptMessage: makeTranslator(KEYS.BUILD.IMAGE_CROPPER_PROMPT_MESSAGE, localeCode),
            imageFormatName: {
                jpgLimitedFileSize: makeTranslator(KEYS.BUILD.IMAGE_FORMAT_NAME.JPG_LIMITED_FILE_SIZE, localeCode)
            },
            imageMustBeEditable: makeTranslator(KEYS.BUILD.IMAGE_MUST_BE_EDITABLE, localeCode),
            imageResolutionPicker: {
                confirmDpi: makeTranslator(KEYS.BUILD.IMAGE_RESOLUTION_PICKER.CONFIRM_DPI, localeCode),
                dpi: makeTranslator(KEYS.BUILD.IMAGE_RESOLUTION_PICKER.DPI, localeCode),
                dpiIsRequired: makeTranslator(KEYS.BUILD.IMAGE_RESOLUTION_PICKER.DPI_IS_REQUIRED, localeCode),
                imageResolution: makeTranslator(KEYS.BUILD.IMAGE_RESOLUTION_PICKER.IMAGE_RESOLUTION, localeCode)
            },
            imageSelected: makeTranslator(KEYS.BUILD.IMAGE_SELECTED, localeCode),
            keyboardShortcutsReference: makeTranslator(KEYS.BUILD.KEYBOARD_SHORTCUTS_REFERENCE, localeCode),
            keywordSearch: makeTranslator(KEYS.BUILD.KEYWORD_SEARCH, localeCode),
            landscape: makeTranslator(KEYS.BUILD.LANDSCAPE, localeCode),
            layers: makeTranslator(KEYS.BUILD.LAYERS, localeCode),
            leavePagePrompt: {
                confirm: makeTranslator(KEYS.BUILD.LEAVE_PAGE_PROMPT.CONFIRM, localeCode),
                title: makeTranslator(KEYS.BUILD.LEAVE_PAGE_PROMPT.TITLE, localeCode)
            },
            locationDetailsMissingMessage: makeTranslator(KEYS.BUILD.LOCATION_DETAILS_MISSING_MESSAGE, localeCode),
            locationDraft: {
                areYouSureYouWantToOverrideTemplateRevisionWithTitle: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.ARE_YOU_SURE_YOU_WANT_TO_OVERRIDE_TEMPLATE_REVISION_WITH_TITLE, localeCode),
                confirmDelete: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.CONFIRM_DELETE, localeCode),
                confirmDeleteTitle: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.CONFIRM_DELETE_TITLE, localeCode),
                createdLocationDraft: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.CREATED_LOCATION_DRAFT, localeCode),
                enterNameForNewTemplateRevision: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.ENTER_NAME_FOR_NEW_TEMPLATE_REVISION, localeCode),
                loadAPreviousRevision: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_REVISION, localeCode),
                loadAPreviousTemplateRevision: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.LOAD_A_PREVIOUS_TEMPLATE_REVISION, localeCode),
                pleaseConfirmLocationRevisionSave: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.PLEASE_CONFIRM_LOCATION_REVISION_SAVE, localeCode),
                saveAsANewRevision: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.SAVE_AS_A_NEW_REVISION, localeCode),
                saveLocationRevision: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION, localeCode),
                saveLocationRevisionWithTitle: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.SAVE_LOCATION_REVISION_WITH_TITLE, localeCode),
                saveOverCurrentRevisionWithTitle: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.SAVE_OVER_CURRENT_REVISION_WITH_TITLE, localeCode),
                templateHasDraftTooltip: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.TEMPLATE_HAS_DRAFT_TOOLTIP, localeCode),
                updatedAt: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.UPDATED_AT, localeCode),
                updatedLocationDraft: makeTranslator(KEYS.BUILD.LOCATION_DRAFT.UPDATED_LOCATION_DRAFT, localeCode)
            },
            locationEmailNotSet: makeTranslator(KEYS.BUILD.LOCATION_EMAIL_NOT_SET, localeCode),
            locationLogoNotSet: makeTranslator(KEYS.BUILD.LOCATION_LOGO_NOT_SET, localeCode),
            locationMapNotCreated: makeTranslator(KEYS.BUILD.LOCATION_MAP_NOT_CREATED, localeCode),
            loopForever: makeTranslator(KEYS.BUILD.LOOP_FOREVER, localeCode),
            looping: makeTranslator(KEYS.BUILD.LOOPING, localeCode),
            lowercase: makeTranslator(KEYS.BUILD.LOWERCASE, localeCode),
            makeTemplateOnlyAvailableForMobileApp: makeTranslator(KEYS.BUILD.MAKE_TEMPLATE_ONLY_AVAILABLE_FOR_MOBILE_APP, localeCode),
            map: {
                pin: makeTranslator(KEYS.BUILD.MAP.PIN, localeCode)
            },
            maximumFileSizeKb: makeTranslator(KEYS.BUILD.MAXIMUM_FILE_SIZE_KB, localeCode),
            memberEngager: {
                assignToMultipleLocations: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.ASSIGN_TO_MULTIPLE_LOCATIONS, localeCode),
                automatedEmail: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.AUTOMATED_EMAIL, localeCode),
                automatedEmails: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.AUTOMATED_EMAILS, localeCode),
                directEmailTitle: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.DIRECT_EMAIL_TITLE, localeCode),
                editContent: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.EDIT_CONTENT, localeCode),
                editSubject: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.EDIT_SUBJECT, localeCode),
                failedToLoadAutomatedEmail: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAIL, localeCode),
                failedToLoadAutomatedEmails: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.FAILED_TO_LOAD_AUTOMATED_EMAILS, localeCode),
                findNewTemplate: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.FIND_NEW_TEMPLATE, localeCode),
                noDirectEmailTemplatesFound: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.NO_DIRECT_EMAIL_TEMPLATES_FOUND, localeCode),
                scheduledEmail: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAIL, localeCode),
                scheduledEmails: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS, localeCode),
                scheduledEmailsWell: {
                    deleteMessageLine1: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_1, localeCode),
                    deleteMessageLine2: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_MESSAGE_LINE_2, localeCode),
                    deleteScheduledEmailApiError: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.DELETE_SCHEDULED_EMAIL_API_ERROR, localeCode),
                    noScheduledEmails: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.NO_SCHEDULED_EMAILS, localeCode),
                    preview: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.PREVIEW, localeCode),
                    scheduledEmailAlreadyDeleted: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_ALREADY_DELETED, localeCode),
                    scheduledEmailDeleted: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_DELETED, localeCode),
                    scheduledEmailNotFound: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.SCHEDULED_EMAIL_NOT_FOUND, localeCode),
                    table: {
                        lists: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.LISTS, localeCode),
                        scheduled: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SCHEDULED, localeCode),
                        subject: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.SCHEDULED_EMAILS_WELL.TABLE.SUBJECT, localeCode)
                    }
                },
                title: makeTranslator(KEYS.BUILD.MEMBER_ENGAGER.TITLE, localeCode)
            },
            metrics: {
                em: makeTranslator(KEYS.BUILD.METRICS.EM, localeCode),
                points: makeTranslator(KEYS.BUILD.METRICS.POINTS, localeCode),
                pointsShort: makeTranslator(KEYS.BUILD.METRICS.POINTS_SHORT, localeCode)
            },
            millisecondsShort: makeTranslator(KEYS.BUILD.MILLISECONDS_SHORT, localeCode),
            mobileAppTemplate: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE, localeCode),
            mobileAppTemplateValidation: {
                animationPresent: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.ANIMATION_PRESENT, localeCode),
                mapLayerPresent: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.MAP_LAYER_PRESENT, localeCode),
                notMobileCompatible: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.NOT_MOBILE_COMPATIBLE, localeCode),
                unsupportedBuilderTemplateFormat: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_BUILDER_TEMPLATE_FORMAT, localeCode),
                unsupportedDocumentFormat: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_DOCUMENT_FORMAT, localeCode),
                unsupportedEditableFields: makeTranslator(KEYS.BUILD.MOBILE_APP_TEMPLATE_VALIDATION.UNSUPPORTED_EDITABLE_FIELDS, localeCode)
            },
            mobileInfo: makeTranslator(KEYS.BUILD.MOBILE_INFO, localeCode),
            mobileView: makeTranslator(KEYS.BUILD.MOBILE_VIEW, localeCode),
            moveDown: makeTranslator(KEYS.BUILD.MOVE_DOWN, localeCode),
            moveUp: makeTranslator(KEYS.BUILD.MOVE_UP, localeCode),
            multiImage: {
                muliImageCounterTooltip: makeTranslator(KEYS.BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP, localeCode),
                muliImageCounterTooltipPlural: makeTranslator(KEYS.BUILD.MULTI_IMAGE.MULI_IMAGE_COUNTER_TOOLTIP_plural, localeCode),
                multiImage: makeTranslator(KEYS.BUILD.MULTI_IMAGE.MULTI_IMAGE, localeCode),
                multiImageTemplate: makeTranslator(KEYS.BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE, localeCode),
                notifierExplanation: makeTranslator(KEYS.BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION, localeCode),
                removeImage: {
                    message: makeTranslator(KEYS.BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE, localeCode),
                    title: makeTranslator(KEYS.BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE, localeCode)
                }
            },
            mustViewAllFrames: makeTranslator(KEYS.BUILD.MUST_VIEW_ALL_FRAMES, localeCode),
            mustViewAllImages: makeTranslator(KEYS.BUILD.MUST_VIEW_ALL_IMAGES, localeCode),
            mustViewAllPages: makeTranslator(KEYS.BUILD.MUST_VIEW_ALL_PAGES, localeCode),
            newTemplate: makeTranslator(KEYS.BUILD.NEW_TEMPLATE, localeCode),
            newTemplateEmail: makeTranslator(KEYS.BUILD.NEW_TEMPLATE_EMAIL, localeCode),
            newTemplateImage: makeTranslator(KEYS.BUILD.NEW_TEMPLATE_IMAGE, localeCode),
            newTemplatePrint: makeTranslator(KEYS.BUILD.NEW_TEMPLATE_PRINT, localeCode),
            newTemplateVideo: makeTranslator(KEYS.BUILD.NEW_TEMPLATE_VIDEO, localeCode),
            noContent: makeTranslator(KEYS.BUILD.NO_CONTENT, localeCode),
            notifyTextPlaceholderExists: makeTranslator(KEYS.BUILD.NOTIFY_TEXT_PLACEHOLDER_EXISTS, localeCode),
            optimizingImage: makeTranslator(KEYS.BUILD.OPTIMIZING_IMAGE, localeCode),
            originalTemplate: makeTranslator(KEYS.BUILD.ORIGINAL_TEMPLATE, localeCode),
            overlays: {
                imageLayer: makeTranslator(KEYS.BUILD.OVERLAYS.IMAGE_LAYER, localeCode),
                mapLayer: makeTranslator(KEYS.BUILD.OVERLAYS.MAP_LAYER, localeCode),
                videoLayer: makeTranslator(KEYS.BUILD.OVERLAYS.VIDEO_LAYER, localeCode)
            },
            phoneNumberNotSet: makeTranslator(KEYS.BUILD.PHONE_NUMBER_NOT_SET, localeCode),
            placeholder: makeTranslator(KEYS.BUILD.PLACEHOLDER, localeCode),
            placeholders: makeTranslator(KEYS.BUILD.PLACEHOLDERS, localeCode),
            plannerDetails: makeTranslator(KEYS.BUILD.PLANNER_DETAILS, localeCode),
            platform: makeTranslator(KEYS.BUILD.PLATFORM, localeCode),
            portrait: makeTranslator(KEYS.BUILD.PORTRAIT, localeCode),
            positionX: makeTranslator(KEYS.BUILD.POSITION_X, localeCode),
            positionY: makeTranslator(KEYS.BUILD.POSITION_Y, localeCode),
            previewImage: makeTranslator(KEYS.BUILD.PREVIEW_IMAGE, localeCode),
            print: {
                addPageAfter: makeTranslator(KEYS.BUILD.PRINT.ADD_PAGE_AFTER, localeCode),
                addPageBefore: makeTranslator(KEYS.BUILD.PRINT.ADD_PAGE_BEFORE, localeCode),
                bleed: makeTranslator(KEYS.BUILD.PRINT.BLEED, localeCode),
                confirmDeletePage: makeTranslator(KEYS.BUILD.PRINT.CONFIRM_DELETE_PAGE, localeCode),
                deletePage: makeTranslator(KEYS.BUILD.PRINT.DELETE_PAGE, localeCode),
                extraInfo: makeTranslator(KEYS.BUILD.PRINT.EXTRA_INFO, localeCode),
                pageNumber: makeTranslator(KEYS.BUILD.PRINT.PAGE_NUMBER, localeCode),
                pageNumberOfCount: makeTranslator(KEYS.BUILD.PRINT.PAGE_NUMBER_OF_COUNT, localeCode),
                pleaseEnterPageNumberBetween: makeTranslator(KEYS.BUILD.PRINT.PLEASE_ENTER_PAGE_NUMBER_BETWEEN, localeCode),
                selectAtLeastOneFormat: makeTranslator(KEYS.BUILD.PRINT.SELECT_AT_LEAST_ONE_FORMAT, localeCode),
                whichPageToCopyLayerTo: makeTranslator(KEYS.BUILD.PRINT.WHICH_PAGE_TO_COPY_LAYER_TO, localeCode)
            },
            properties: makeTranslator(KEYS.BUILD.PROPERTIES, localeCode),
            publish: {
                alreadyScheduled: makeTranslator(KEYS.BUILD.PUBLISH.ALREADY_SCHEDULED, localeCode),
                campaignMonitor: {
                    campaignName: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.CAMPAIGN_NAME, localeCode),
                    confirmationEmailAddress: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.CONFIRMATION_EMAIL_ADDRESS, localeCode),
                    fromEmail: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_EMAIL, localeCode),
                    fromName: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.FROM_NAME, localeCode),
                    inCampaignMonitorAccountsTimezone: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.IN_CAMPAIGN_MONITOR_ACCOUNTS_TIMEZONE, localeCode),
                    lists: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.LISTS, localeCode),
                    noListsFoundSetUpYourMailingLists: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS, localeCode),
                    noSegmentsFound: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.NO_SEGMENTS_FOUND, localeCode),
                    notifyPublishSuccess: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.NOTIFY_PUBLISH_SUCCESS, localeCode),
                    preview: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW, localeCode),
                    previewSend: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SEND, localeCode),
                    previewSkip: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.PREVIEW_SKIP, localeCode),
                    publishToCampaignMonitor: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.PUBLISH_TO_CAMPAIGN_MONITOR, localeCode),
                    recipients: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.RECIPIENTS, localeCode),
                    replyTo: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.REPLY_TO, localeCode),
                    saveDraft: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.SAVE_DRAFT, localeCode),
                    segments: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.SEGMENTS, localeCode),
                    send: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.SEND, localeCode),
                    subject: makeTranslator(KEYS.BUILD.PUBLISH.CAMPAIGN_MONITOR.SUBJECT, localeCode)
                },
                clubReady: {
                    active: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ACTIVE, localeCode),
                    activeMembers: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ACTIVE_MEMBERS, localeCode),
                    addedAtAnyTime: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ADDED_AT_ANY_TIME, localeCode),
                    addedBetween: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ADDED_BETWEEN, localeCode),
                    after: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.AFTER, localeCode),
                    allActiveMembers: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS, localeCode),
                    allInactiveMembers: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ALL_INACTIVE_MEMBERS, localeCode),
                    atLeastOneListMustBeSelected: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.AT_LEAST_ONE_LIST_MUST_BE_SELECTED, localeCode),
                    before: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.BEFORE, localeCode),
                    club: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CLUB, localeCode),
                    cooledOffProspects: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.COOLED_OFF_PROSPECTS, localeCode),
                    custom: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM, localeCode),
                    customListDescriptionPlaceholder: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_PLACEHOLDER, localeCode),
                    customListDescriptionWarning: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_DESCRIPTION_WARNING, localeCode),
                    customListMatches: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_MATCHES, localeCode),
                    customListOfEmailAddresses: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES, localeCode),
                    customListOfEmailAddressesWarning: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.CUSTOM_LIST_OF_EMAIL_ADDRESSES_WARNING, localeCode),
                    disabledPublishHelpText: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.DISABLED_PUBLISH_HELP_TEXT, localeCode),
                    duplicateEmails: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.DUPLICATE_EMAILS, localeCode),
                    emailListMustHaveValues: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.EMAIL_LIST_MUST_HAVE_VALUES, localeCode),
                    emailSubjectAndSchedule: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.EMAIL_SUBJECT_AND_SCHEDULE, localeCode),
                    exportInfo: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.EXPORT_INFO, localeCode),
                    exportTitle: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.EXPORT_TITLE, localeCode),
                    filtered: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.FILTERED, localeCode),
                    iConfirmThatTheAboveDetailsAreCorrect: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.I_CONFIRM_THAT_THE_ABOVE_DETAILS_ARE_CORRECT, localeCode),
                    inactive: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.INACTIVE, localeCode),
                    inactiveMembers: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.INACTIVE_MEMBERS, localeCode),
                    invalid: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.INVALID, localeCode),
                    matchedOutOf: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.MATCHED_OUT_OF, localeCode),
                    memberListNotice: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.MEMBER_LIST_NOTICE, localeCode),
                    moreClubCount: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT, localeCode),
                    moreClubCountPlural: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT_plural, localeCode),
                    noSenderInfoForOneOrMoreLocations: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_FOR_ONE_OR_MORE_LOCATIONS, localeCode),
                    noSenderInfoHasBeenSetForLocation: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.NO_SENDER_INFO_HAS_BEEN_SET_FOR_LOCATION, localeCode),
                    notInterested: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.NOT_INTERESTED, localeCode),
                    oneOrMoreListsDisabledMessage: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.ONE_OR_MORE_LISTS_DISABLED_MESSAGE, localeCode),
                    optout: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.OPTOUT, localeCode),
                    pasteEmailAddressesBelow: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PASTE_EMAIL_ADDRESSES_BELOW, localeCode),
                    previewEmailFailed: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_FAILED, localeCode),
                    previewEmailSent: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PREVIEW_EMAIL_SENT, localeCode),
                    prospects: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PROSPECTS, localeCode),
                    prospectsPast30Days: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PROSPECTS_PAST_30_DAYS, localeCode),
                    publishDelayWarningMessage: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.PUBLISH_DELAY_WARNING_MESSAGE, localeCode),
                    refetchVerify: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.REFETCH_VERIFY, localeCode),
                    selectYourClubReadyLists: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SELECT_YOUR_CLUB_READY_LISTS, localeCode),
                    selectedListsDoesNotContainEnoughUsersToSendTo: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO, localeCode),
                    selectedListsDoesNotContainEnoughUsersToSendToPlural: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_DOES_NOT_CONTAIN_ENOUGH_USERS_TO_SEND_TO_plural, localeCode),
                    selectedListsSummary: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SELECTED_LISTS_SUMMARY, localeCode),
                    selectedMembersAndOrProspects: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SELECTED_MEMBERS_AND_OR_PROSPECTS, localeCode),
                    sendATestEmail: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SEND_A_TEST_EMAIL, localeCode),
                    sendTo: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SEND_TO, localeCode),
                    sendToClubReadyList: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SEND_TO_CLUB_READY_LIST, localeCode),
                    sendToInfo: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SEND_TO_INFO, localeCode),
                    sender: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SENDER, localeCode),
                    senderNotVerifiedMessage: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_MESSAGE, localeCode),
                    senderNotVerifiedTooltip: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SENDER_NOT_VERIFIED_TOOLTIP, localeCode),
                    senderVerifiedTooltip: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SENDER_VERIFIED_TOOLTIP, localeCode),
                    subject: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SUBJECT, localeCode),
                    suppressedListInfo: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.SUPPRESSED_LIST_INFO, localeCode),
                    total: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.TOTAL, localeCode),
                    validDateRequiredActivityAfterOption: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_AFTER_OPTION, localeCode),
                    validDateRequiredActivityBeforeOption: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BEFORE_OPTION, localeCode),
                    validDateRequiredActivityBetweenOption: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.VALID_DATE_REQUIRED_ACTIVITY_BETWEEN_OPTION, localeCode),
                    whenWouldYouLikeToSendThisEmail: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.WHEN_WOULD_YOU_LIKE_TO_SEND_THIS_EMAIL, localeCode),
                    warnPublishTooLarge: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.WARN_PUBLISH_TOO_LARGE, localeCode),
                    withActivityAfter: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER, localeCode),
                    withActivityBefore: makeTranslator(KEYS.BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE, localeCode)
                },
                congratulations: makeTranslator(KEYS.BUILD.PUBLISH.CONGRATULATIONS, localeCode),
                currentlySelected: makeTranslator(KEYS.BUILD.PUBLISH.CURRENTLY_SELECTED, localeCode),
                downloadToYourComputer: makeTranslator(KEYS.BUILD.PUBLISH.DOWNLOAD_TO_YOUR_COMPUTER, localeCode),
                exportOptions: makeTranslator(KEYS.BUILD.PUBLISH.EXPORT_OPTIONS, localeCode),
                facebook: {
                    accessCheckFailure: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.ACCESS_CHECK_FAILURE, localeCode),
                    caption: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.CAPTION, localeCode),
                    captionHelpText: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.CAPTION_HELP_TEXT, localeCode),
                    facebookPage: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.FACEBOOK_PAGE, localeCode),
                    hashtagsHelpTextCaption: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_CAPTION, localeCode),
                    hashtagsHelpTextFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.HASHTAGS_HELP_TEXT_FIRST_COMMENT, localeCode),
                    headers: {
                        postDetails: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.HEADERS.POST_DETAILS, localeCode),
                        postSchedule: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.HEADERS.POST_SCHEDULE, localeCode)
                    },
                    inputLabels: {
                        displayHashtagsIn: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN, localeCode),
                        displayHashtagsInCaption: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION, localeCode),
                        displayHashtagsInFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT, localeCode),
                        hashtags: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.INPUT_LABELS.HASHTAGS, localeCode)
                    },
                    pageListRemaining: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING, localeCode),
                    pageListRemainingPlural: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PAGE_LIST_REMAINING_plural, localeCode),
                    pagesCount: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PAGES_COUNT, localeCode),
                    pagesCountPlural: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PAGES_COUNT_plural, localeCode),
                    publishToFacebook: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PUBLISH_TO_FACEBOOK, localeCode),
                    publishVideoToFacebook: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.PUBLISH_VIDEO_TO_FACEBOOK, localeCode),
                    scheduledFacebookPostMustBeNoMoreThan28DaysInFuture: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.SCHEDULED_FACEBOOK_POST_MUST_BE_NO_MORE_THAN_28_DAYS_IN_FUTURE, localeCode),
                    suggestedCaption: makeTranslator(KEYS.BUILD.PUBLISH.FACEBOOK.SUGGESTED_CAPTION, localeCode)
                },
                fetchFileSizeOptions: makeTranslator(KEYS.BUILD.PUBLISH.FETCH_FILE_SIZE_OPTIONS, localeCode),
                finalConfirmation: makeTranslator(KEYS.BUILD.PUBLISH.FINAL_CONFIRMATION, localeCode),
                fitware: {
                    automatedEmailCategoriesFailedToLoad: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORIES_FAILED_TO_LOAD, localeCode),
                    automatedEmailCategory: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY, localeCode),
                    automatedEmailCategoryMissingInSomeLocationsHelpText: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_CATEGORY_MISSING_IN_SOME_LOCATIONS_HELP_TEXT, localeCode),
                    automatedEmailUpdatedDescription: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_DESCRIPTION, localeCode),
                    automatedEmailUpdatedTitle: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.AUTOMATED_EMAIL_UPDATED_TITLE, localeCode),
                    confirmDeclaration: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.CONFIRM_DECLARATION, localeCode),
                    directEmailPlatformHelpText: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_HELP_TEXT, localeCode),
                    directEmailPlatformLabel: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.DIRECT_EMAIL_PLATFORM_LABEL, localeCode),
                    fitwareAutomatedEmail: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL, localeCode),
                    fitwareAutomatedEmailHelpText: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.FITWARE_AUTOMATED_EMAIL_HELP_TEXT, localeCode),
                    memberLists: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.MEMBER_LISTS, localeCode),
                    memberListsFailedToLoad: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.MEMBER_LISTS_FAILED_TO_LOAD, localeCode),
                    noMemberListsFound: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.NO_MEMBER_LISTS_FOUND, localeCode),
                    platformsHeading: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PLATFORMS_HEADING, localeCode),
                    preview: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PREVIEW, localeCode),
                    previewEmailAddress: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PREVIEW_EMAIL_ADDRESS, localeCode),
                    previewSend: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PREVIEW_SEND, localeCode),
                    previewSkip: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PREVIEW_SKIP, localeCode),
                    publishToFitware: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.PUBLISH_TO_FITWARE, localeCode),
                    returnToMemberEngager: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.RETURN_TO_MEMBER_ENGAGER, localeCode),
                    scheduledTime: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.SCHEDULED_TIME, localeCode),
                    send: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.SEND, localeCode),
                    sender: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.SENDER, localeCode),
                    senderPlural: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.SENDER_plural, localeCode),
                    stepTitles: {
                        automatedEmailCategory: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.AUTOMATED_EMAIL_CATEGORY, localeCode),
                        memberLists: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.MEMBER_LISTS, localeCode),
                        publishing: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.PUBLISHING, localeCode),
                        scheduledTime: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.SCHEDULED_TIME, localeCode),
                        sendPreview: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.SEND_PREVIEW, localeCode),
                        subject: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.SUBJECT, localeCode),
                        summary: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.STEP_TITLES.SUMMARY, localeCode)
                    },
                    subject: makeTranslator(KEYS.BUILD.PUBLISH.FITWARE.SUBJECT, localeCode)
                },
                goBackConfirmMessage: makeTranslator(KEYS.BUILD.PUBLISH.GO_BACK_CONFIRM_MESSAGE, localeCode),
                goBackConfirmTitle: makeTranslator(KEYS.BUILD.PUBLISH.GO_BACK_CONFIRM_TITLE, localeCode),
                googleMyBusiness: {
                    accessCheckFailure: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.ACCESS_CHECK_FAILURE, localeCode),
                    businessLocation: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUSINESS_LOCATION, localeCode),
                    buttonLink: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_LINK, localeCode),
                    buttonType: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPE, localeCode),
                    buttonTypes: {
                        book: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.BOOK, localeCode),
                        call: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.CALL, localeCode),
                        learnMore: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.LEARN_MORE, localeCode),
                        order: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.ORDER, localeCode),
                        shop: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SHOP, localeCode),
                        signUp: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.BUTTON_TYPES.SIGN_UP, localeCode)
                    },
                    callToAction: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CALL_TO_ACTION, localeCode),
                    cannotStartEventBeforeScheduledTime: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_EVENT_BEFORE_SCHEDULED_TIME, localeCode),
                    cannotStartOfferBeforeScheduledTime: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CANNOT_START_OFFER_BEFORE_SCHEDULED_TIME, localeCode),
                    characterLimitReached: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.CHARACTER_LIMIT_REACHED, localeCode),
                    eventDescription: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_DESCRIPTION, localeCode),
                    eventTitle: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.EVENT_TITLE, localeCode),
                    offerCode: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_CODE, localeCode),
                    offerDescription: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_DESCRIPTION, localeCode),
                    offerLink: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_LINK, localeCode),
                    offerTitle: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.OFFER_TITLE, localeCode),
                    postBody: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_BODY, localeCode),
                    postType: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPE, localeCode),
                    postTypes: {
                        event: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.EVENT, localeCode),
                        offer: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.OFFER, localeCode),
                        product: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.PRODUCT, localeCode),
                        standard: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.POST_TYPES.STANDARD, localeCode)
                    },
                    publishToGoogleMyBusiness: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.PUBLISH_TO_GOOGLE_MY_BUSINESS, localeCode),
                    termsAndConditions: makeTranslator(KEYS.BUILD.PUBLISH.GOOGLE_MY_BUSINESS.TERMS_AND_CONDITIONS, localeCode)
                },
                hashtags: {
                    clientHashtags: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.CLIENT_HASHTAGS, localeCode),
                    errorLimitHashtagCount: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT, localeCode),
                    errorLimitHashtagCountPlural: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_COUNT_plural, localeCode),
                    errorLimitHashtagLength: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_LENGTH, localeCode),
                    errorLimitHashtagSet: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.ERROR_LIMIT_HASHTAG_SET, localeCode),
                    hashtagCharacterCount: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.HASHTAG_CHARACTER_COUNT, localeCode),
                    hashtagSetAlreadyAdded: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.HASHTAG_SET_ALREADY_ADDED, localeCode),
                    hashtagTagCount: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.HASHTAG_TAG_COUNT, localeCode),
                    locationHashtags: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.LOCATION_HASHTAGS, localeCode),
                    noHashtagSets: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.NO_HASHTAG_SETS, localeCode),
                    useHashtagSets: makeTranslator(KEYS.BUILD.PUBLISH.HASHTAGS.USE_HASHTAG_SETS, localeCode)
                },
                imageFormat: makeTranslator(KEYS.BUILD.PUBLISH.IMAGE_FORMAT, localeCode),
                includeBleedAndTrimMarks: makeTranslator(KEYS.BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS, localeCode),
                includeBleedAndTrimMarksDisclaimer: makeTranslator(KEYS.BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_DISCLAIMER, localeCode),
                includeBleedAndTrimMarksHelp: makeTranslator(KEYS.BUILD.PUBLISH.INCLUDE_BLEED_AND_TRIM_MARKS_HELP, localeCode),
                instagram: {
                    accessCheckFailure: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ACCESS_CHECK_FAILURE, localeCode),
                    appNotInstalled: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.APP_NOT_INSTALLED, localeCode),
                    appNotificationsDisabled: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.APP_NOTIFICATIONS_DISABLED, localeCode),
                    appSetupProperly: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.APP_SETUP_PROPERLY, localeCode),
                    appUserRequired: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.APP_USER_REQUIRED, localeCode),
                    asTheFirstCommentOnThePost: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.AS_THE_FIRST_COMMENT_ON_THE_POST, localeCode),
                    aspectRatioHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_HELP_TEXT, localeCode),
                    aspectRatioStoryHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_STORY_HELP_TEXT, localeCode),
                    aspectRatioVideoHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ASPECT_RATIO_VIDEO_HELP_TEXT, localeCode),
                    assignUserToPost: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ASSIGN_USER_TO_POST, localeCode),
                    atTheBottomOnThePostCaption: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.AT_THE_BOTTOM_ON_THE_POST_CAPTION, localeCode),
                    caption: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.CAPTION, localeCode),
                    captionHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.CAPTION_HELP_TEXT, localeCode),
                    enterValidMobileNumber: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.ENTER_VALID_MOBILE_NUMBER, localeCode),
                    exceededMaxImageCountHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.EXCEEDED_MAX_IMAGE_COUNT_HELP_TEXT, localeCode),
                    hashtagsHelpTextCaption: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_CAPTION, localeCode),
                    hashtagsHelpTextFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.HASHTAGS_HELP_TEXT_FIRST_COMMENT, localeCode),
                    headers: {
                        postDetails: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_DETAILS, localeCode),
                        postSchedule: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.HEADERS.POST_SCHEDULE, localeCode)
                    },
                    inputLabels: {
                        displayHashtagsIn: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN, localeCode),
                        displayHashtagsInCaption: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION, localeCode),
                        displayHashtagsInFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT, localeCode),
                        hashtags: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INPUT_LABELS.HASHTAGS, localeCode)
                    },
                    instagramPage: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INSTAGRAM_PAGE, localeCode),
                    invalidDimensionsHeightHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_HEIGHT_HELP_TEXT, localeCode),
                    invalidDimensionsWidthHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.INVALID_DIMENSIONS_WIDTH_HELP_TEXT, localeCode),
                    missingPermissionsHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.MISSING_PERMISSIONS_HELP_TEXT, localeCode),
                    mobileNumber: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER, localeCode),
                    mobileNumberInfo: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.MOBILE_NUMBER_INFO, localeCode),
                    notificationForInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_FOR_INSTAGRAM, localeCode),
                    notificationSchedule: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.NOTIFICATION_SCHEDULE, localeCode),
                    postsFromMobileHint: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.POSTS_FROM_MOBILE_HINT, localeCode),
                    postsWillExpire: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE, localeCode),
                    postsWillExpirePlural: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.POSTS_WILL_EXPIRE_plural, localeCode),
                    publishVideoToInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.PUBLISH_VIDEO_TO_INSTAGRAM, localeCode),
                    publishImageToInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.PUBLISH_IMAGE_TO_INSTAGRAM, localeCode),
                    publishStoryToInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.PUBLISH_STORY_TO_INSTAGRAM, localeCode),
                    scheduleVideoViaApi: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIDEO_VIA_API, localeCode),
                    scheduleImageViaApi: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_IMAGE_VIA_API, localeCode),
                    scheduleStoryViaApi: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_STORY_VIA_API, localeCode),
                    scheduleForInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM, localeCode),
                    scheduleForInstagramStory: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_FOR_INSTAGRAM_STORY, localeCode),
                    scheduleNotificationForInstagram: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_NOTIFICATION_FOR_INSTAGRAM, localeCode),
                    scheduleViaMobileApp: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULE_VIA_MOBILE_APP, localeCode),
                    scheduledInstagramPostMustBeNoMoreThan75DaysInFuture: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULED_INSTAGRAM_POST_MUST_BE_NO_MORE_THAN_75_DAYS_IN_FUTURE, localeCode),
                    scheduledPostMustBeAtLeastMinsInFuture: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SCHEDULED_POST_MUST_BE_AT_LEAST_MINS_IN_FUTURE, localeCode),
                    searchForUser: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SEARCH_FOR_USER, localeCode),
                    selectRelevantCountryCode: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SELECT_RELEVANT_COUNTRY_CODE, localeCode),
                    sendPostDetails: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SEND_POST_DETAILS, localeCode),
                    sendSmsAsWell: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SEND_SMS_AS_WELL, localeCode),
                    storyMultiImageHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.STORY_MULTI_IMAGE_HELP_TEXT, localeCode),
                    storyVideoDurationHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.STORY_VIDEO_DURATION_HELP_TEXT, localeCode),
                    suggestedCaption: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.SUGGESTED_CAPTION, localeCode),
                    videoDurationHelpText: makeTranslator(KEYS.BUILD.PUBLISH.INSTAGRAM.VIDEO_DURATION_HELP_TEXT, localeCode)
                },
                linkedin: {
                    accessCheckFailure: makeTranslator(KEYS.BUILD.PUBLISH.LINKEDIN.ACCESS_CHECK_FAILURE, localeCode),
                    caption: makeTranslator(KEYS.BUILD.PUBLISH.LINKEDIN.CAPTION, localeCode),
                    captionHelpText: makeTranslator(KEYS.BUILD.PUBLISH.LINKEDIN.CAPTION_HELP_TEXT, localeCode),
                    linkedinPage: makeTranslator(KEYS.BUILD.PUBLISH.LINKEDIN.LINKEDIN_PAGE, localeCode),
                    publishToLinkedin: makeTranslator(KEYS.BUILD.PUBLISH.LINKEDIN.PUBLISH_TO_LINKEDIN, localeCode)
                },
                local: {
                    publishVideoToLocal: makeTranslator(KEYS.BUILD.PUBLISH.LOCAL.PUBLISH_VIDEO_TO_LOCAL, localeCode)
                },
                mailchimp: {
                    campaignName: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.CAMPAIGN_NAME, localeCode),
                    confirmationEmailAddress: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.CONFIRMATION_EMAIL_ADDRESS, localeCode),
                    fromEmail: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.FROM_EMAIL, localeCode),
                    fromName: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.FROM_NAME, localeCode),
                    lists: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.LISTS, localeCode),
                    noListsFoundSetUpYourMailingLists: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.NO_LISTS_FOUND_SET_UP_YOUR_MAILING_LISTS, localeCode),
                    noSegmentsFound: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.NO_SEGMENTS_FOUND, localeCode),
                    preview: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.PREVIEW, localeCode),
                    previewSend: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.PREVIEW_SEND, localeCode),
                    previewSkip: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.PREVIEW_SKIP, localeCode),
                    publishToMailchimp: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.PUBLISH_TO_MAILCHIMP, localeCode),
                    recipient: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.RECIPIENT, localeCode),
                    replyTo: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.REPLY_TO, localeCode),
                    saveDraft: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.SAVE_DRAFT, localeCode),
                    schedulingUnavailable: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.SCHEDULING_UNAVAILABLE, localeCode),
                    segments: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.SEGMENTS, localeCode),
                    send: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.SEND, localeCode),
                    subject: makeTranslator(KEYS.BUILD.PUBLISH.MAILCHIMP.SUBJECT, localeCode)
                },
                multipleLocations: {
                    currentlyPublishing: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.CURRENTLY_PUBLISHING, localeCode),
                    editUndoAlertMessage: {
                        part1: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_1, localeCode),
                        part2: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_2, localeCode),
                        part3: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.EDIT_UNDO_ALERT_MESSAGE.PART_3, localeCode)
                    },
                    noAccessHelp: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.NO_ACCESS_HELP, localeCode),
                    publishedVideosSuccessfully: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHED_VIDEOS_SUCCESSFULLY, localeCode),
                    publishingToTheseLocations: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.PUBLISHING_TO_THESE_LOCATIONS, localeCode),
                    refreshLocations: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.REFRESH_LOCATIONS, localeCode),
                    scheduledVideosSuccessfully: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.SCHEDULED_VIDEOS_SUCCESSFULLY, localeCode),
                    someLocationsFailedToPublish: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_PUBLISH, localeCode),
                    totalPublishingProgress: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.TOTAL_PUBLISHING_PROGRESS, localeCode),
                    wouldYouLikeToRetryForFailedLocations: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS, localeCode)
                },
                multiplePlatforms: {
                    facebookAndInstagramVideo: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_VIDEO, localeCode),
                    facebookAndInstagramImage: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.FACEBOOK_AND_INSTAGRAM_IMAGE, localeCode),
                    hashtagsHelpTextCaption: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_CAPTION, localeCode),
                    hashtagsHelpTextFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.HASHTAGS_HELP_TEXT_FIRST_COMMENT, localeCode),
                    headers: {
                        postDetails: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_DETAILS, localeCode),
                        postSchedule: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.HEADERS.POST_SCHEDULE, localeCode)
                    },
                    inputLabels: {
                        displayHashtagsIn: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN, localeCode),
                        displayHashtagsInCaption: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_CAPTION, localeCode),
                        displayHashtagsInFirstComment: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.DISPLAY_HASHTAGS_IN_FIRST_COMMENT, localeCode),
                        hashtags: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.INPUT_LABELS.HASHTAGS, localeCode)
                    },
                    publishVideoToFacebookAndInstagram: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_VIDEO_TO_FACEBOOK_AND_INSTAGRAM, localeCode),
                    publishImageToFacebookAndInstagram: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISH_IMAGE_TO_FACEBOOK_AND_INSTAGRAM, localeCode),
                    publishedToPlatform: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHED_TO_PLATFORM, localeCode),
                    publishingToPlatform: makeTranslator(KEYS.BUILD.PUBLISH.MULTIPLE_PLATFORMS.PUBLISHING_TO_PLATFORM, localeCode)
                },
                noAccessHelp: makeTranslator(KEYS.BUILD.PUBLISH.NO_ACCESS_HELP, localeCode),
                noPlatformSelected: makeTranslator(KEYS.BUILD.PUBLISH.NO_PLATFORM_SELECTED, localeCode),
                noPlatformsAvailable: makeTranslator(KEYS.BUILD.PUBLISH.NO_PLATFORMS_AVAILABLE, localeCode),
                noThanks: makeTranslator(KEYS.BUILD.PUBLISH.NO_THANKS, localeCode),
                noThanksImDone: makeTranslator(KEYS.BUILD.PUBLISH.NO_THANKS_IM_DONE, localeCode),
                onceAuthorizedHelp: makeTranslator(KEYS.BUILD.PUBLISH.ONCE_AUTHORIZED_HELP, localeCode),
                originalSize: makeTranslator(KEYS.BUILD.PUBLISH.ORIGINAL_SIZE, localeCode),
                print: {
                    artworkReviewSuggested: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.ARTWORK_REVIEW_SUGGESTED, localeCode),
                    beginPayment: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.BEGIN_PAYMENT, localeCode),
                    canOnlySendToPrintProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.CAN_ONLY_SEND_TO_PRINT_PROVIDER, localeCode),
                    confirmArtworkReview: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.CONFIRM_ARTWORK_REVIEW, localeCode),
                    holdUp: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.HOLD_UP, localeCode),
                    includesFallbackFontMessage: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE, localeCode),
                    includesFallbackFontMessageSolution: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.INCLUDES_FALLBACK_FONT_MESSAGE_SOLUTION, localeCode),
                    instructionsPlaceholder: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER, localeCode),
                    instructionsPlaceholderForSku: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.INSTRUCTIONS_PLACEHOLDER_FOR_SKU, localeCode),
                    payment: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.PAYMENT, localeCode),
                    paymentDue: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.PAYMENT_DUE, localeCode),
                    printProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.PRINT_PROVIDER, localeCode),
                    printRequestDetails: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.PRINT_REQUEST_DETAILS, localeCode),
                    replyEmail: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REPLY_EMAIL, localeCode),
                    replyEmailSubheading: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REPLY_EMAIL_SUBHEADING, localeCode),
                    requestDetailsIsMissingData: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REQUEST_DETAILS_IS_MISSING_DATA, localeCode),
                    reviewArtworkBeforeSending: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REVIEW_ARTWORK_BEFORE_SENDING, localeCode),
                    reviewConfirmation: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REVIEW_CONFIRMATION, localeCode),
                    reviewDocument: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.REVIEW_DOCUMENT, localeCode),
                    saveAsLocationPrintProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SAVE_AS_LOCATION_PRINT_PROVIDER, localeCode),
                    selectPrintProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SELECT_PRINT_PROVIDER, localeCode),
                    sendAndCompletePayment: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SEND_AND_COMPLETE_PAYMENT, localeCode),
                    sendOrder: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SEND_ORDER, localeCode),
                    sendToPrintProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SEND_TO_PRINT_PROVIDER, localeCode),
                    sendingArtwork: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SENDING_ARTWORK, localeCode),
                    successfullySent: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.SUCCESSFULLY_SENT, localeCode),
                    yourPrintProvider: makeTranslator(KEYS.BUILD.PUBLISH.PRINT.YOUR_PRINT_PROVIDER, localeCode)
                },
                publish: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISH, localeCode),
                publishImmediately: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISH_IMMEDIATELY, localeCode),
                publishVideoAction: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISH_VIDEO_ACTION, localeCode),
                published: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISHED, localeCode),
                publishedSuccessfully: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISHED_SUCCESSFULLY, localeCode),
                publishedToSomeLocations: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISHED_TO_SOME_LOCATIONS, localeCode),
                publishingFailed: makeTranslator(KEYS.BUILD.PUBLISH.PUBLISHING_FAILED, localeCode),
                refreshPlatforms: makeTranslator(KEYS.BUILD.PUBLISH.REFRESH_PLATFORMS, localeCode),
                relativeToLocation: makeTranslator(KEYS.BUILD.PUBLISH.RELATIVE_TO_LOCATION, localeCode),
                reschedule: {
                    newTime: makeTranslator(KEYS.BUILD.PUBLISH.RESCHEDULE.NEW_TIME, localeCode),
                    rescheduleItem: makeTranslator(KEYS.BUILD.PUBLISH.RESCHEDULE.RESCHEDULE_ITEM, localeCode)
                },
                savedSuccessfully: makeTranslator(KEYS.BUILD.PUBLISH.SAVED_SUCCESSFULLY, localeCode),
                scheduleForLater: makeTranslator(KEYS.BUILD.PUBLISH.SCHEDULE_FOR_LATER, localeCode),
                scheduledPostMustBeAtLeast10MinsInFuture: makeTranslator(KEYS.BUILD.PUBLISH.SCHEDULED_POST_MUST_BE_AT_LEAST_10_MINS_IN_FUTURE, localeCode),
                scheduledPostTimePickerWarning: makeTranslator(KEYS.BUILD.PUBLISH.SCHEDULED_POST_TIME_PICKER_WARNING, localeCode),
                scheduledSuccessfully: makeTranslator(KEYS.BUILD.PUBLISH.SCHEDULED_SUCCESSFULLY, localeCode),
                sendImmediately: makeTranslator(KEYS.BUILD.PUBLISH.SEND_IMMEDIATELY, localeCode),
                termsAndConditionsHelpText: makeTranslator(KEYS.BUILD.PUBLISH.TERMS_AND_CONDITIONS_HELP_TEXT, localeCode),
                twitter: {
                    accessCheckFailure: makeTranslator(KEYS.BUILD.PUBLISH.TWITTER.ACCESS_CHECK_FAILURE, localeCode),
                    cannotPublishMultiImageHelpText: makeTranslator(KEYS.BUILD.PUBLISH.TWITTER.CANNOT_PUBLISH_MULTI_IMAGE_HELP_TEXT, localeCode),
                    cannotStopScheduledPost: makeTranslator(KEYS.BUILD.PUBLISH.TWITTER.CANNOT_STOP_SCHEDULED_POST, localeCode),
                    publishToTwitter: makeTranslator(KEYS.BUILD.PUBLISH.TWITTER.PUBLISH_TO_TWITTER, localeCode),
                    tweet: makeTranslator(KEYS.BUILD.PUBLISH.TWITTER.TWEET, localeCode)
                },
                uploading: makeTranslator(KEYS.BUILD.PUBLISH.UPLOADING, localeCode),
                willReceiveNotification: makeTranslator(KEYS.BUILD.PUBLISH.WILL_RECEIVE_NOTIFICATION, localeCode),
                willReceiveScheduledNotification: makeTranslator(KEYS.BUILD.PUBLISH.WILL_RECEIVE_SCHEDULED_NOTIFICATION, localeCode),
                willRecieveSmsDetails: makeTranslator(KEYS.BUILD.PUBLISH.WILL_RECIEVE_SMS_DETAILS, localeCode),
                willRecieveSmsReminder: makeTranslator(KEYS.BUILD.PUBLISH.WILL_RECIEVE_SMS_REMINDER, localeCode),
                wouldYouLikeToSchedulePostOnAnotherPlatform: makeTranslator(KEYS.BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_POST_ON_ANOTHER_PLATFORM, localeCode),
                wouldYouLikeToScheduleThisPostAgain: makeTranslator(KEYS.BUILD.PUBLISH.WOULD_YOU_LIKE_TO_SCHEDULE_THIS_POST_AGAIN, localeCode),
                yesPlease: makeTranslator(KEYS.BUILD.PUBLISH.YES_PLEASE, localeCode),
                yesPleaseButDifferentTemplate: makeTranslator(KEYS.BUILD.PUBLISH.YES_PLEASE_BUT_DIFFERENT_TEMPLATE, localeCode),
                yesPleaseButLater: makeTranslator(KEYS.BUILD.PUBLISH.YES_PLEASE_BUT_LATER, localeCode)
            },
            publishToMultipleLocations: makeTranslator(KEYS.BUILD.PUBLISH_TO_MULTIPLE_LOCATIONS, localeCode),
            publishingFailed: makeTranslator(KEYS.BUILD.PUBLISHING_FAILED, localeCode),
            recentlyAdded: makeTranslator(KEYS.BUILD.RECENTLY_ADDED, localeCode),
            rectangle: makeTranslator(KEYS.BUILD.RECTANGLE, localeCode),
            repetitions: makeTranslator(KEYS.BUILD.REPETITIONS, localeCode),
            requestSupport: makeTranslator(KEYS.BUILD.REQUEST_SUPPORT, localeCode),
            resourcesLoaded: makeTranslator(KEYS.BUILD.RESOURCES_LOADED, localeCode),
            resourcesLoadedPlural: makeTranslator(KEYS.BUILD.RESOURCES_LOADED_plural, localeCode),
            returnToBuilder: makeTranslator(KEYS.BUILD.RETURN_TO_BUILDER, localeCode),
            savingTemplate: makeTranslator(KEYS.BUILD.SAVING_TEMPLATE, localeCode),
            scheduledTime: makeTranslator(KEYS.BUILD.SCHEDULED_TIME, localeCode),
            selectPreviewImage: makeTranslator(KEYS.BUILD.SELECT_PREVIEW_IMAGE, localeCode),
            separateTagsWithSpaces: makeTranslator(KEYS.BUILD.SEPARATE_TAGS_WITH_SPACES, localeCode),
            showDetails: makeTranslator(KEYS.BUILD.SHOW_DETAILS, localeCode),
            showOldEmailTemplates: makeTranslator(KEYS.BUILD.SHOW_OLD_EMAIL_TEMPLATES, localeCode),
            summaryHiddenMessage: makeTranslator(KEYS.BUILD.SUMMARY_HIDDEN_MESSAGE, localeCode),
            template: makeTranslator(KEYS.BUILD.TEMPLATE, localeCode),
            templateAdmin: {
                copyAsUnpublished: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED, localeCode),
                copyAsUnpublishedTooltip: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_AS_UNPUBLISHED_TOOLTIP, localeCode),
                copyError: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_ERROR, localeCode),
                copyNoClients: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_NO_CLIENTS, localeCode),
                copySuccess: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_SUCCESS, localeCode),
                copySuccessExtended: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_SUCCESS_EXTENDED, localeCode),
                copyTo: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.COPY_TO, localeCode),
                deleteTemplate: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE, localeCode),
                deleteTemplateSuccess: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.DELETE_TEMPLATE_SUCCESS, localeCode),
                duplicateTemplate: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE, localeCode),
                duplicateTemplateSuccess: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.DUPLICATE_TEMPLATE_SUCCESS, localeCode),
                editAttributes: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.EDIT_ATTRIBUTES, localeCode),
                includeAssignedCategories: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES, localeCode),
                includeAssignedCategoriesTooltip: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.INCLUDE_ASSIGNED_CATEGORIES_TOOLTIP, localeCode),
                manageBuildableTemplate: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.MANAGE_BUILDABLE_TEMPLATE, localeCode),
                templateUpdated: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.TEMPLATE_UPDATED, localeCode),
                toggleTemplateStatusPublished: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED, localeCode),
                toggleTemplateStatusPublishedSuccess: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_PUBLISHED_SUCCESS, localeCode),
                toggleTemplateStatusUnpublished: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED, localeCode),
                toggleTemplateStatusUnpublishedSuccess: makeTranslator(KEYS.BUILD.TEMPLATE_ADMIN.TOGGLE_TEMPLATE_STATUS_UNPUBLISHED_SUCCESS, localeCode)
            },
            templateCouldNotBeExportedUnderTheFileSizeLimit: makeTranslator(KEYS.BUILD.TEMPLATE_COULD_NOT_BE_EXPORTED_UNDER_THE_FILE_SIZE_LIMIT, localeCode),
            templateDeleted: makeTranslator(KEYS.BUILD.TEMPLATE_DELETED, localeCode),
            templateGallery: makeTranslator(KEYS.BUILD.TEMPLATE_GALLERY, localeCode),
            templateNotFoundOrUnauthorized: makeTranslator(KEYS.BUILD.TEMPLATE_NOT_FOUND_OR_UNAUTHORIZED, localeCode),
            templateSaved: makeTranslator(KEYS.BUILD.TEMPLATE_SAVED, localeCode),
            textAlignmentHorizontal: {
                center: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_HORIZONTAL.CENTER, localeCode),
                justify: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_HORIZONTAL.JUSTIFY, localeCode),
                left: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_HORIZONTAL.LEFT, localeCode),
                right: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_HORIZONTAL.RIGHT, localeCode)
            },
            textAlignmentVertical: {
                bottom: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_VERTICAL.BOTTOM, localeCode),
                center: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_VERTICAL.CENTER, localeCode),
                top: makeTranslator(KEYS.BUILD.TEXT_ALIGNMENT_VERTICAL.TOP, localeCode)
            },
            textClipping: makeTranslator(KEYS.BUILD.TEXT_CLIPPING, localeCode),
            textFormattingWorkaround: makeTranslator(KEYS.BUILD.TEXT_FORMATTING_WORKAROUND, localeCode),
            textLineHeightFix: makeTranslator(KEYS.BUILD.TEXT_LINE_HEIGHT_FIX, localeCode),
            textMustBeEditable: makeTranslator(KEYS.BUILD.TEXT_MUST_BE_EDITABLE, localeCode),
            timeUnitsAgo: {
                dayAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.DAY_AGO, localeCode),
                dayAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.DAY_AGO_plural, localeCode),
                hourAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.HOUR_AGO, localeCode),
                hourAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.HOUR_AGO_plural, localeCode),
                minuteAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.MINUTE_AGO, localeCode),
                minuteAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.MINUTE_AGO_plural, localeCode),
                monthAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.MONTH_AGO, localeCode),
                monthAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.MONTH_AGO_plural, localeCode),
                secondAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.SECOND_AGO, localeCode),
                secondAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.SECOND_AGO_plural, localeCode),
                weekAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.WEEK_AGO, localeCode),
                weekAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.WEEK_AGO_plural, localeCode),
                yearAgo: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.YEAR_AGO, localeCode),
                yearAgoPlural: makeTranslator(KEYS.BUILD.TIME_UNITS_AGO.YEAR_AGO_plural, localeCode)
            },
            toggleUnpublished: makeTranslator(KEYS.BUILD.TOGGLE_UNPUBLISHED, localeCode),
            transform: makeTranslator(KEYS.BUILD.TRANSFORM, localeCode),
            unpublishedInfo: makeTranslator(KEYS.BUILD.UNPUBLISHED_INFO, localeCode),
            unpublishedTemplate: makeTranslator(KEYS.BUILD.UNPUBLISHED_TEMPLATE, localeCode),
            unpublishedTemplatePublishWarning: makeTranslator(KEYS.BUILD.UNPUBLISHED_TEMPLATE_PUBLISH_WARNING, localeCode),
            updateTemplate: makeTranslator(KEYS.BUILD.UPDATE_TEMPLATE, localeCode),
            uppercase: makeTranslator(KEYS.BUILD.UPPERCASE, localeCode),
            video: {
                checkingAccess: makeTranslator(KEYS.BUILD.VIDEO.CHECKING_ACCESS, localeCode),
                downloadVideo: makeTranslator(KEYS.BUILD.VIDEO.DOWNLOAD_VIDEO, localeCode),
                failedToPublishVideo: makeTranslator(KEYS.BUILD.VIDEO.FAILED_TO_PUBLISH_VIDEO, localeCode),
                finalizingVideo: makeTranslator(KEYS.BUILD.VIDEO.FINALIZING_VIDEO, localeCode),
                networkError: makeTranslator(KEYS.BUILD.VIDEO.NETWORK_ERROR, localeCode),
                noVideoLayers: makeTranslator(KEYS.BUILD.VIDEO.NO_VIDEO_LAYERS, localeCode),
                noVideoUploaded: makeTranslator(KEYS.BUILD.VIDEO.NO_VIDEO_UPLOADED, localeCode),
                pleaseWait: makeTranslator(KEYS.BUILD.VIDEO.PLEASE_WAIT, localeCode),
                preparingVideo: makeTranslator(KEYS.BUILD.VIDEO.PREPARING_VIDEO, localeCode),
                processingVideo: makeTranslator(KEYS.BUILD.VIDEO.PROCESSING_VIDEO, localeCode),
                processingTimeDisclaimer: makeTranslator(KEYS.BUILD.VIDEO.PROCESSING_TIME_DISCLAIMER, localeCode),
                publishingFailedMessage: makeTranslator(KEYS.BUILD.VIDEO.PUBLISHING_FAILED_MESSAGE, localeCode),
                readyToDownload: makeTranslator(KEYS.BUILD.VIDEO.READY_TO_DOWNLOAD, localeCode),
                removeAudio: makeTranslator(KEYS.BUILD.VIDEO.REMOVE_AUDIO, localeCode),
                renderingVideo: makeTranslator(KEYS.BUILD.VIDEO.RENDERING_VIDEO, localeCode),
                retyWithoutAudio: makeTranslator(KEYS.BUILD.VIDEO.RETY_WITHOUT_AUDIO, localeCode),
                unsupportedFormat: makeTranslator(KEYS.BUILD.VIDEO.UNSUPPORTED_FORMAT, localeCode),
                uploading: makeTranslator(KEYS.BUILD.VIDEO.UPLOADING, localeCode),
                videoIsReady: makeTranslator(KEYS.BUILD.VIDEO.VIDEO_IS_READY, localeCode),
                videoIsReadyToDownload: makeTranslator(KEYS.BUILD.VIDEO.VIDEO_IS_READY_TO_DOWNLOAD, localeCode)
            },
            videoChooser: {
                confirmAcknowledged: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.CONFIRM_ACKNOWLEDGED, localeCode),
                confirmPermission: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.CONFIRM_PERMISSION, localeCode),
                localFile: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.LOCAL_FILE, localeCode),
                maxUploadError: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.MAX_UPLOAD_ERROR, localeCode),
                permissionDisclaimer: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER, localeCode),
                permissionDisclaimerStrong: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.PERMISSION_DISCLAIMER_STRONG, localeCode),
                permissionError: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.PERMISSION_ERROR, localeCode),
                selectVideo: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.SELECT_VIDEO, localeCode),
                selectVideoFromYourLibrary: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.SELECT_VIDEO_FROM_YOUR_LIBRARY, localeCode),
                suggestedCollection: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.SUGGESTED_COLLECTION, localeCode),
                uploadVideoFromYourDevice: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.UPLOAD_VIDEO_FROM_YOUR_DEVICE, localeCode),
                uploadedAssetVideo: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.UPLOADED_ASSET_VIDEO, localeCode),
                uploadedPlannerVideo: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.UPLOADED_PLANNER_VIDEO, localeCode),
                videoSource: makeTranslator(KEYS.BUILD.VIDEO_CHOOSER.VIDEO_SOURCE, localeCode)
            },
            websiteUrlNotSet: makeTranslator(KEYS.BUILD.WEBSITE_URL_NOT_SET, localeCode),
            youAreCurrentlyBuilding: makeTranslator(KEYS.BUILD.YOU_ARE_CURRENTLY_BUILDING, localeCode),
            youHaveNItemsToBuildAndSchedule: makeTranslator(KEYS.BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE, localeCode),
            youHaveNItemsToBuildAndSchedulePlural: makeTranslator(KEYS.BUILD.YOU_HAVE_N_ITEMS_TO_BUILD_AND_SCHEDULE_plural, localeCode),
            youHaveNItemsToCheckout: makeTranslator(KEYS.BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT, localeCode),
            youHaveNItemsToCheckoutPlural: makeTranslator(KEYS.BUILD.YOU_HAVE_N_ITEMS_TO_CHECKOUT_plural, localeCode)
        },
        client: {
            clientLocationEngagementTable: {
                headers: {
                    builtItems: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.BUILT_ITEMS, localeCode),
                    facebookAds: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.FACEBOOK_ADS, localeCode),
                    googleAds: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GOOGLE_ADS, localeCode),
                    groups: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.GROUPS, localeCode),
                    leads: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LEADS, localeCode),
                    location: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.LOCATION, localeCode),
                    region: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.HEADERS.REGION, localeCode)
                },
                labelFilterLocations: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.LABEL_FILTER_LOCATIONS, localeCode),
                noGroups: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_GROUPS, localeCode),
                noLocationsFound: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_LOCATIONS_FOUND, localeCode),
                noRegion: makeTranslator(KEYS.CLIENT.CLIENT_LOCATION_ENGAGEMENT_TABLE.NO_REGION, localeCode)
            },
            clientTemplateCategories: {
                addTemplateCategory: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ADD_TEMPLATE_CATEGORY, localeCode),
                deleteTemplateCategory: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEMPLATE_CATEGORY, localeCode),
                deleteText: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.DELETE_TEXT, localeCode),
                editTemplateCategory: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.EDIT_TEMPLATE_CATEGORY, localeCode),
                error: {
                    create: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.CREATE, localeCode),
                    emptyCategoryLabel: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.EMPTY_CATEGORY_LABEL, localeCode),
                    endDateBeforeStartDate: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.END_DATE_BEFORE_START_DATE, localeCode),
                    invalidEndDate: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_END_DATE, localeCode),
                    invalidStartDate: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.INVALID_START_DATE, localeCode),
                    modify: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.ERROR.MODIFY, localeCode)
                },
                formLabels: {
                    endDateOptional: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.END_DATE_OPTIONAL, localeCode),
                    startDate: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.FORM_LABELS.START_DATE, localeCode)
                },
                label: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.LABEL, localeCode),
                success: {
                    create: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.CREATE, localeCode),
                    modify: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.SUCCESS.MODIFY, localeCode)
                },
                title: makeTranslator(KEYS.CLIENT.CLIENT_TEMPLATE_CATEGORIES.TITLE, localeCode)
            },
            clientUsersLocation: {
                addUser: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.ADD_USER, localeCode),
                assignUserToLocations: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.ASSIGN_USER_TO_LOCATIONS, localeCode),
                buttons: {
                    sendInvite: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.BUTTONS.SEND_INVITE, localeCode)
                },
                createNewUser: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.CREATE_NEW_USER, localeCode),
                deleteOrphanedUser: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.DELETE_ORPHANED_USER, localeCode),
                filterUserPlaceholder: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.FILTER_USER_PLACEHOLDER, localeCode),
                invalidEmailHelperText: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.INVALID_EMAIL_HELPER_TEXT, localeCode),
                inviteNewUser: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.INVITE_NEW_USER, localeCode),
                inviteUser: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.INVITE_USER, localeCode),
                labels: {
                    emailAddress: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.LABELS.EMAIL_ADDRESS, localeCode),
                    giveAccessTo: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.LABELS.GIVE_ACCESS_TO, localeCode),
                    userDetails: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_DETAILS, localeCode),
                    userRoles: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.LABELS.USER_ROLES, localeCode)
                },
                locationAccess: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.LOCATION_ACCESS, localeCode),
                matchingUserFound: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.MATCHING_USER_FOUND, localeCode),
                matchingUsersFound: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.MATCHING_USERS_FOUND, localeCode),
                modalTitle: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.MODAL_TITLE, localeCode),
                placeholders: {
                    emailAddress: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.EMAIL_ADDRESS, localeCode),
                    selectRoles: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.PLACEHOLDERS.SELECT_ROLES, localeCode)
                },
                updateLocations: makeTranslator(KEYS.CLIENT.CLIENT_USERS_LOCATION.UPDATE_LOCATIONS, localeCode)
            },
            clientUsersTable: {
                bulkActions: {
                    delete: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.DELETE, localeCode),
                    resendUserInvites: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESEND_USER_INVITES, localeCode),
                    resetPassword: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.RESET_PASSWORD, localeCode),
                    updateLocations: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_LOCATIONS, localeCode),
                    updateRoles: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BULK_ACTIONS.UPDATE_ROLES, localeCode)
                },
                buttonBulkActionsPrimary: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_PRIMARY, localeCode),
                buttonBulkActionsSecondary: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.BUTTON_BULK_ACTIONS_SECONDARY, localeCode),
                mobileTooltip: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.MOBILE_TOOLTIP, localeCode),
                title: makeTranslator(KEYS.CLIENT.CLIENT_USERS_TABLE.TITLE, localeCode)
            },
            editClientUserModal: {
                labels: {
                    emailAddress: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.EMAIL_ADDRESS, localeCode),
                    firstName: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.FIRST_NAME, localeCode),
                    generalDetails: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GENERAL_DETAILS, localeCode),
                    guidedTour: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.GUIDED_TOUR, localeCode),
                    lastName: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LAST_NAME, localeCode),
                    locationsAccess: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.LOCATIONS_ACCESS, localeCode),
                    preferences: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.PREFERENCES, localeCode),
                    title: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.TITLE, localeCode),
                    userRoles: makeTranslator(KEYS.CLIENT.EDIT_CLIENT_USER_MODAL.LABELS.USER_ROLES, localeCode)
                }
            },
            engagementHelpText: {
                activity: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.ACTIVITY, localeCode),
                builtItems: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.BUILT_ITEMS, localeCode),
                connections: {
                    currentlyRequiredPlatforms: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.CURRENTLY_REQUIRED_PLATFORMS, localeCode),
                    dataNotImpactedByDateSelection: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.DATA_NOT_IMPACTED_BY_DATE_SELECTION, localeCode),
                    howToSetRequiredPlatforms: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.HOW_TO_SET_REQUIRED_PLATFORMS, localeCode),
                    requiredConnectionsExplanation: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.REQUIRED_CONNECTIONS_EXPLANATION, localeCode),
                    totalConnectionsExplanation: makeTranslator(KEYS.CLIENT.ENGAGEMENT_HELP_TEXT.CONNECTIONS.TOTAL_CONNECTIONS_EXPLANATION, localeCode)
                }
            },
            errorStyleGuideDelete: makeTranslator(KEYS.CLIENT.ERROR_STYLE_GUIDE_DELETE, localeCode),
            errorStyleGuideReplace: makeTranslator(KEYS.CLIENT.ERROR_STYLE_GUIDE_REPLACE, localeCode),
            errorStyleGuideUpload: makeTranslator(KEYS.CLIENT.ERROR_STYLE_GUIDE_UPLOAD, localeCode),
            errors: {
                noClientId: makeTranslator(KEYS.CLIENT.ERRORS.NO_CLIENT_ID, localeCode),
                noClientSelected: makeTranslator(KEYS.CLIENT.ERRORS.NO_CLIENT_SELECTED, localeCode),
                noDateRange: makeTranslator(KEYS.CLIENT.ERRORS.NO_DATE_RANGE, localeCode),
                unexpectedError: makeTranslator(KEYS.CLIENT.ERRORS.UNEXPECTED_ERROR, localeCode)
            },
            locationActivity: {
                builtItemsCount: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.BUILT_ITEMS_COUNT, localeCode),
                headers: {
                    activity: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.HEADERS.ACTIVITY, localeCode),
                    builtItems: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.HEADERS.BUILT_ITEMS, localeCode),
                    connections: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.HEADERS.CONNECTIONS, localeCode),
                    mostEngagedLocations: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.HEADERS.MOST_ENGAGED_LOCATIONS, localeCode)
                },
                labelBuiltItemsCumulative: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.LABEL_BUILT_ITEMS_CUMULATIVE, localeCode),
                locationsActive: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.LOCATIONS_ACTIVE, localeCode),
                locationsUsingMobileApp: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.LOCATIONS_USING_MOBILE_APP, localeCode),
                requiredPlatformsConnected: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.REQUIRED_PLATFORMS_CONNECTED, localeCode),
                sortBuiltItems: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.SORT_BUILT_ITEMS, localeCode),
                sortLocation: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.SORT_LOCATION, localeCode),
                sortTitle: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.SORT_TITLE, localeCode),
                templatesBuilt: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.TEMPLATES_BUILT, localeCode),
                totalPlatformsConnected: makeTranslator(KEYS.CLIENT.LOCATION_ACTIVITY.TOTAL_PLATFORMS_CONNECTED, localeCode)
            },
            overview: {
                errors: {
                    failToLoad: makeTranslator(KEYS.CLIENT.OVERVIEW.ERRORS.FAIL_TO_LOAD, localeCode)
                },
                headers: {
                    templateCategories: makeTranslator(KEYS.CLIENT.OVERVIEW.HEADERS.TEMPLATE_CATEGORIES, localeCode),
                    templatesBuilt: makeTranslator(KEYS.CLIENT.OVERVIEW.HEADERS.TEMPLATES_BUILT, localeCode)
                },
                socialTemplateReporting: {
                    title: makeTranslator(KEYS.CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.TITLE, localeCode),
                    body: makeTranslator(KEYS.CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BODY, localeCode),
                    button: makeTranslator(KEYS.CLIENT.OVERVIEW.SOCIAL_TEMPLATE_REPORTING.BUTTON, localeCode)
                },
                templateCategories: {
                    assetsUsed: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED, localeCode),
                    assetsUsedPlural: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.ASSETS_USED_plural, localeCode),
                    digital: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.DIGITAL, localeCode),
                    email: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.EMAIL, localeCode),
                    print: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATE_CATEGORIES.PRINT, localeCode)
                },
                templatesBuiltByLocationCategory: makeTranslator(KEYS.CLIENT.OVERVIEW.TEMPLATES_BUILT_BY_LOCATION_CATEGORY, localeCode)
            },
            regionActivity: {
                categoriesTable: {
                    averageBuiltItemsPerLocation: makeTranslator(KEYS.CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.AVERAGE_BUILT_ITEMS_PER_LOCATION, localeCode),
                    errors: {
                        failToLoad: makeTranslator(KEYS.CLIENT.REGION_ACTIVITY.CATEGORIES_TABLE.ERRORS.FAIL_TO_LOAD, localeCode)
                    }
                },
                filterName: makeTranslator(KEYS.CLIENT.REGION_ACTIVITY.FILTER_NAME, localeCode),
                headers: {
                    builtItems: makeTranslator(KEYS.CLIENT.REGION_ACTIVITY.HEADERS.BUILT_ITEMS, localeCode)
                }
            },
            styleGuidePageTitle: makeTranslator(KEYS.CLIENT.STYLE_GUIDE_PAGE_TITLE, localeCode),
            successStyleGuideDelete: makeTranslator(KEYS.CLIENT.SUCCESS_STYLE_GUIDE_DELETE, localeCode),
            successStyleGuideReplace: makeTranslator(KEYS.CLIENT.SUCCESS_STYLE_GUIDE_REPLACE, localeCode),
            successStyleGuideUpload: makeTranslator(KEYS.CLIENT.SUCCESS_STYLE_GUIDE_UPLOAD, localeCode)
        },
        common: {
            actions: makeTranslator(KEYS.COMMON.ACTIONS, localeCode),
            active: makeTranslator(KEYS.COMMON.ACTIVE, localeCode),
            add: makeTranslator(KEYS.COMMON.ADD, localeCode),
            addNewTag: makeTranslator(KEYS.COMMON.ADD_NEW_TAG, localeCode),
            addTag: makeTranslator(KEYS.COMMON.ADD_TAG, localeCode),
            address: makeTranslator(KEYS.COMMON.ADDRESS, localeCode),
            admin: makeTranslator(KEYS.COMMON.ADMIN, localeCode),
            after: makeTranslator(KEYS.COMMON.AFTER, localeCode),
            agencies: makeTranslator(KEYS.COMMON.AGENCIES, localeCode),
            agency: makeTranslator(KEYS.COMMON.AGENCY, localeCode),
            all: makeTranslator(KEYS.COMMON.ALL, localeCode),
            allAssets: makeTranslator(KEYS.COMMON.ALL_ASSETS, localeCode),
            allLocations: makeTranslator(KEYS.COMMON.ALL_LOCATIONS, localeCode),
            amount: makeTranslator(KEYS.COMMON.AMOUNT, localeCode),
            and: makeTranslator(KEYS.COMMON.AND, localeCode),
            andXOtherLocations: makeTranslator(KEYS.COMMON.AND_X_OTHER_LOCATIONS, localeCode),
            andXOtherLocationsPlural: makeTranslator(KEYS.COMMON.AND_X_OTHER_LOCATIONS_plural, localeCode),
            anybody: makeTranslator(KEYS.COMMON.ANYBODY, localeCode),
            apps: makeTranslator(KEYS.COMMON.APPS, localeCode),
            areYouSure: makeTranslator(KEYS.COMMON.ARE_YOU_SURE, localeCode),
            areYouSureYouWantToDeleteNumAssets: makeTranslator(KEYS.COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_NUM_ASSETS, localeCode),
            areYouSureYouWantToDeleteThisAsset: makeTranslator(KEYS.COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ASSET, localeCode),
            areYouSureYouWantToDeleteThisCollection: makeTranslator(KEYS.COMMON.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COLLECTION, localeCode),
            assetCollection: makeTranslator(KEYS.COMMON.ASSET_COLLECTION, localeCode),
            assetLibrary: makeTranslator(KEYS.COMMON.ASSET_LIBRARY, localeCode),
            assignedTo: makeTranslator(KEYS.COMMON.ASSIGNED_TO, localeCode),
            attach: makeTranslator(KEYS.COMMON.ATTACH, localeCode),
            attachFile: makeTranslator(KEYS.COMMON.ATTACH_FILE, localeCode),
            attachments: makeTranslator(KEYS.COMMON.ATTACHMENTS, localeCode),
            back: makeTranslator(KEYS.COMMON.BACK, localeCode),
            beta: makeTranslator(KEYS.COMMON.BETA, localeCode),
            browse: makeTranslator(KEYS.COMMON.BROWSE, localeCode),
            build: makeTranslator(KEYS.COMMON.BUILD, localeCode),
            built: makeTranslator(KEYS.COMMON.BUILT, localeCode),
            businessName: makeTranslator(KEYS.COMMON.BUSINESS_NAME, localeCode),
            cancel: makeTranslator(KEYS.COMMON.CANCEL, localeCode),
            cancelledWhileInQueue: makeTranslator(KEYS.COMMON.CANCELLED_WHILE_IN_QUEUE, localeCode),
            cancelledWhileProcessing: makeTranslator(KEYS.COMMON.CANCELLED_WHILE_PROCESSING, localeCode),
            cannotFindAsset: makeTranslator(KEYS.COMMON.CANNOT_FIND_ASSET, localeCode),
            categories: makeTranslator(KEYS.COMMON.CATEGORIES, localeCode),
            category: makeTranslator(KEYS.COMMON.CATEGORY, localeCode),
            change: makeTranslator(KEYS.COMMON.CHANGE, localeCode),
            changesSaved: makeTranslator(KEYS.COMMON.CHANGES_SAVED, localeCode),
            channel: makeTranslator(KEYS.COMMON.CHANNEL, localeCode),
            channels: makeTranslator(KEYS.COMMON.CHANNELS, localeCode),
            checkConnection: makeTranslator(KEYS.COMMON.CHECK_CONNECTION, localeCode),
            clear: makeTranslator(KEYS.COMMON.CLEAR, localeCode),
            client: makeTranslator(KEYS.COMMON.CLIENT, localeCode),
            clientUsedMaxCollections: makeTranslator(KEYS.COMMON.CLIENT_USED_MAX_COLLECTIONS, localeCode),
            clientWithLocation: makeTranslator(KEYS.COMMON.CLIENT_WITH_LOCATION, localeCode),
            clients: makeTranslator(KEYS.COMMON.CLIENTS, localeCode),
            close: makeTranslator(KEYS.COMMON.CLOSE, localeCode),
            collection: makeTranslator(KEYS.COMMON.COLLECTION, localeCode),
            colour: makeTranslator(KEYS.COMMON.COLOUR, localeCode),
            columns: makeTranslator(KEYS.COMMON.COLUMNS, localeCode),
            copy: makeTranslator(KEYS.COMMON.COPY, localeCode),
            comments: {
                addComment: makeTranslator(KEYS.COMMON.COMMENTS.ADD_COMMENT, localeCode),
                areYouSureDeleteComment: makeTranslator(KEYS.COMMON.COMMENTS.ARE_YOU_SURE_DELETE_COMMENT, localeCode),
                cannotDeleteComments: makeTranslator(KEYS.COMMON.COMMENTS.CANNOT_DELETE_COMMENTS, localeCode),
                comment: makeTranslator(KEYS.COMMON.COMMENTS.COMMENT, localeCode),
                comments: makeTranslator(KEYS.COMMON.COMMENTS.COMMENTS, localeCode),
                commentsHeadingDefault: makeTranslator(KEYS.COMMON.COMMENTS.COMMENTS_HEADING_DEFAULT, localeCode),
                deleteComment: makeTranslator(KEYS.COMMON.COMMENTS.DELETE_COMMENT, localeCode),
                enterComment: makeTranslator(KEYS.COMMON.COMMENTS.ENTER_COMMENT, localeCode),
                unknownParent: makeTranslator(KEYS.COMMON.COMMENTS.UNKNOWN_PARENT, localeCode)
            },
            companies: {
                ltNetwork: makeTranslator(KEYS.COMMON.COMPANIES.LT_NETWORK, localeCode)
            },
            confirm: makeTranslator(KEYS.COMMON.CONFIRM, localeCode),
            confirmModalInput: makeTranslator(KEYS.COMMON.CONFIRM_MODAL_INPUT, localeCode),
            confirmation: makeTranslator(KEYS.COMMON.CONFIRMATION, localeCode),
            connectPage: {
                connectPage: makeTranslator(KEYS.COMMON.CONNECT_PAGE.CONNECT_PAGE, localeCode),
                filter: {
                    accountName: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.ACCOUNT_NAME, localeCode),
                    clearLocationId: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.CLEAR_LOCATION_ID, localeCode),
                    client: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.CLIENT, localeCode),
                    location: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.LOCATION, localeCode),
                    pageName: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.PAGE_NAME, localeCode),
                    status: makeTranslator(KEYS.COMMON.CONNECT_PAGE.FILTER.STATUS, localeCode)
                },
                statusDropdown: {
                    connect: makeTranslator(KEYS.COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECT, localeCode),
                    connected: makeTranslator(KEYS.COMMON.CONNECT_PAGE.STATUS_DROPDOWN.CONNECTED, localeCode),
                    error: makeTranslator(KEYS.COMMON.CONNECT_PAGE.STATUS_DROPDOWN.ERROR, localeCode),
                    expired: makeTranslator(KEYS.COMMON.CONNECT_PAGE.STATUS_DROPDOWN.EXPIRED, localeCode),
                    incomplete: makeTranslator(KEYS.COMMON.CONNECT_PAGE.STATUS_DROPDOWN.INCOMPLETE, localeCode)
                },
                tableHeaders: {
                    accountMapping: makeTranslator(KEYS.COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_MAPPING, localeCode),
                    accountName: makeTranslator(KEYS.COMMON.CONNECT_PAGE.TABLE_HEADERS.ACCOUNT_NAME, localeCode)
                }
            },
            connectionIssues: makeTranslator(KEYS.COMMON.CONNECTION_ISSUES, localeCode),
            continue: makeTranslator(KEYS.COMMON.CONTINUE, localeCode),
            copiedToClipboard: makeTranslator(KEYS.COMMON.COPIED_TO_CLIPBOARD, localeCode),
            copiedToClipboardFailed: makeTranslator(KEYS.COMMON.COPIED_TO_CLIPBOARD_FAILED, localeCode),
            costs: makeTranslator(KEYS.COMMON.COSTS, localeCode),
            couldNotDetermineBootstrapBreakpoint: makeTranslator(KEYS.COMMON.COULD_NOT_DETERMINE_BOOTSTRAP_BREAKPOINT, localeCode),
            countries: {
                australia: makeTranslator(KEYS.COMMON.COUNTRIES.AUSTRALIA, localeCode),
                austria: makeTranslator(KEYS.COMMON.COUNTRIES.AUSTRIA, localeCode),
                belgium: makeTranslator(KEYS.COMMON.COUNTRIES.BELGIUM, localeCode),
                canada: makeTranslator(KEYS.COMMON.COUNTRIES.CANADA, localeCode),
                czechia: makeTranslator(KEYS.COMMON.COUNTRIES.CZECHIA, localeCode),
                denmark: makeTranslator(KEYS.COMMON.COUNTRIES.DENMARK, localeCode),
                dominicanRepublic: makeTranslator(KEYS.COMMON.COUNTRIES.DOMINICAN_REPUBLIC, localeCode),
                egypt: makeTranslator(KEYS.COMMON.COUNTRIES.EGYPT, localeCode),
                finland: makeTranslator(KEYS.COMMON.COUNTRIES.FINLAND, localeCode),
                france: makeTranslator(KEYS.COMMON.COUNTRIES.FRANCE, localeCode),
                georgia: makeTranslator(KEYS.COMMON.COUNTRIES.GEORGIA, localeCode),
                germany: makeTranslator(KEYS.COMMON.COUNTRIES.GERMANY, localeCode),
                hongKong: makeTranslator(KEYS.COMMON.COUNTRIES.HONG_KONG, localeCode),
                hungary: makeTranslator(KEYS.COMMON.COUNTRIES.HUNGARY, localeCode),
                india: makeTranslator(KEYS.COMMON.COUNTRIES.INDIA, localeCode),
                indonesia: makeTranslator(KEYS.COMMON.COUNTRIES.INDONESIA, localeCode),
                ireland: makeTranslator(KEYS.COMMON.COUNTRIES.IRELAND, localeCode),
                italy: makeTranslator(KEYS.COMMON.COUNTRIES.ITALY, localeCode),
                japan: makeTranslator(KEYS.COMMON.COUNTRIES.JAPAN, localeCode),
                latvia: makeTranslator(KEYS.COMMON.COUNTRIES.LATVIA, localeCode),
                lithuania: makeTranslator(KEYS.COMMON.COUNTRIES.LITHUANIA, localeCode),
                malaysia: makeTranslator(KEYS.COMMON.COUNTRIES.MALAYSIA, localeCode),
                mauritius: makeTranslator(KEYS.COMMON.COUNTRIES.MAURITIUS, localeCode),
                mexico: makeTranslator(KEYS.COMMON.COUNTRIES.MEXICO, localeCode),
                myanmar: makeTranslator(KEYS.COMMON.COUNTRIES.MYANMAR, localeCode),
                netherlands: makeTranslator(KEYS.COMMON.COUNTRIES.NETHERLANDS, localeCode),
                newZealand: makeTranslator(KEYS.COMMON.COUNTRIES.NEW_ZEALAND, localeCode),
                norway: makeTranslator(KEYS.COMMON.COUNTRIES.NORWAY, localeCode),
                peru: makeTranslator(KEYS.COMMON.COUNTRIES.PERU, localeCode),
                philippines: makeTranslator(KEYS.COMMON.COUNTRIES.PHILIPPINES, localeCode),
                portugal: makeTranslator(KEYS.COMMON.COUNTRIES.PORTUGAL, localeCode),
                saudiArabia: makeTranslator(KEYS.COMMON.COUNTRIES.SAUDI_ARABIA, localeCode),
                singapore: makeTranslator(KEYS.COMMON.COUNTRIES.SINGAPORE, localeCode),
                southAfrica: makeTranslator(KEYS.COMMON.COUNTRIES.SOUTH_AFRICA, localeCode),
                southKorea: makeTranslator(KEYS.COMMON.COUNTRIES.SOUTH_KOREA, localeCode),
                spain: makeTranslator(KEYS.COMMON.COUNTRIES.SPAIN, localeCode),
                sweden: makeTranslator(KEYS.COMMON.COUNTRIES.SWEDEN, localeCode),
                switzerland: makeTranslator(KEYS.COMMON.COUNTRIES.SWITZERLAND, localeCode),
                taiwan: makeTranslator(KEYS.COMMON.COUNTRIES.TAIWAN, localeCode),
                thailand: makeTranslator(KEYS.COMMON.COUNTRIES.THAILAND, localeCode),
                turkey: makeTranslator(KEYS.COMMON.COUNTRIES.TURKEY, localeCode),
                unitedArabEmirates: makeTranslator(KEYS.COMMON.COUNTRIES.UNITED_ARAB_EMIRATES, localeCode),
                unitedKingdom: makeTranslator(KEYS.COMMON.COUNTRIES.UNITED_KINGDOM, localeCode),
                unitedStatesOfAmerica: makeTranslator(KEYS.COMMON.COUNTRIES.UNITED_STATES_OF_AMERICA, localeCode),
                vietnam: makeTranslator(KEYS.COMMON.COUNTRIES.VIETNAM, localeCode)
            },
            country: makeTranslator(KEYS.COMMON.COUNTRY, localeCode),
            create: makeTranslator(KEYS.COMMON.CREATE, localeCode),
            created: makeTranslator(KEYS.COMMON.CREATED, localeCode),
            createdAt: makeTranslator(KEYS.COMMON.CREATED_AT, localeCode),
            currency: makeTranslator(KEYS.COMMON.CURRENCY, localeCode),
            currentLocationUsedMaxCollections: makeTranslator(KEYS.COMMON.CURRENT_LOCATION_USED_MAX_COLLECTIONS, localeCode),
            currentlySelectedCount: makeTranslator(KEYS.COMMON.CURRENTLY_SELECTED_COUNT, localeCode),
            customize: makeTranslator(KEYS.COMMON.CUSTOMIZE, localeCode),
            date: makeTranslator(KEYS.COMMON.DATE, localeCode),
            dateAdded: makeTranslator(KEYS.COMMON.DATE_ADDED, localeCode),
            day: makeTranslator(KEYS.COMMON.DAY, localeCode),
            days: makeTranslator(KEYS.COMMON.DAYS, localeCode),
            daysOfTheWeekLong: {
                friday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.FRIDAY, localeCode),
                monday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.MONDAY, localeCode),
                saturday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.SATURDAY, localeCode),
                sunday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.SUNDAY, localeCode),
                thursday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.THURSDAY, localeCode),
                tuesday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.TUESDAY, localeCode),
                wednesday: makeTranslator(KEYS.COMMON.DAYS_OF_THE_WEEK_LONG.WEDNESDAY, localeCode)
            },
            delete: makeTranslator(KEYS.COMMON.DELETE, localeCode),
            deleteAsset: makeTranslator(KEYS.COMMON.DELETE_ASSET, localeCode),
            deleteCheckedTags: makeTranslator(KEYS.COMMON.DELETE_CHECKED_TAGS, localeCode),
            deleteCheckedTagsConfirm: makeTranslator(KEYS.COMMON.DELETE_CHECKED_TAGS_CONFIRM, localeCode),
            deletePermanently: makeTranslator(KEYS.COMMON.DELETE_PERMANENTLY, localeCode),
            deleteSomething: makeTranslator(KEYS.COMMON.DELETE_SOMETHING, localeCode),
            deleted: makeTranslator(KEYS.COMMON.DELETED, localeCode),
            description: makeTranslator(KEYS.COMMON.DESCRIPTION, localeCode),
            deselectAll: makeTranslator(KEYS.COMMON.DESELECT_ALL, localeCode),
            desktop: makeTranslator(KEYS.COMMON.DESKTOP, localeCode),
            detach: makeTranslator(KEYS.COMMON.DETACH, localeCode),
            details: makeTranslator(KEYS.COMMON.DETAILS, localeCode),
            disable: makeTranslator(KEYS.COMMON.DISABLE, localeCode),
            disabled: makeTranslator(KEYS.COMMON.DISABLED, localeCode),
            dismiss: makeTranslator(KEYS.COMMON.DISMISS, localeCode),
            displayName: makeTranslator(KEYS.COMMON.DISPLAY_NAME, localeCode),
            done: makeTranslator(KEYS.COMMON.DONE, localeCode),
            download: makeTranslator(KEYS.COMMON.DOWNLOAD, localeCode),
            edit: makeTranslator(KEYS.COMMON.EDIT, localeCode),
            editAsset: makeTranslator(KEYS.COMMON.EDIT_ASSET, localeCode),
            editAssets: makeTranslator(KEYS.COMMON.EDIT_ASSETS, localeCode),
            editCollection: makeTranslator(KEYS.COMMON.EDIT_COLLECTION, localeCode),
            editMultipleAssets: makeTranslator(KEYS.COMMON.EDIT_MULTIPLE_ASSETS, localeCode),
            email: makeTranslator(KEYS.COMMON.EMAIL, localeCode),
            emailAddress: makeTranslator(KEYS.COMMON.EMAIL_ADDRESS, localeCode),
            enable: makeTranslator(KEYS.COMMON.ENABLE, localeCode),
            enabled: makeTranslator(KEYS.COMMON.ENABLED, localeCode),
            endDate: makeTranslator(KEYS.COMMON.END_DATE, localeCode),
            enterNewName: makeTranslator(KEYS.COMMON.ENTER_NEW_NAME, localeCode),
            error: makeTranslator(KEYS.COMMON.ERROR, localeCode),
            example: makeTranslator(KEYS.COMMON.EXAMPLE, localeCode),
            exceededSizeLimitCollection: makeTranslator(KEYS.COMMON.EXCEEDED_SIZE_LIMIT_COLLECTION, localeCode),
            expireOnDate: makeTranslator(KEYS.COMMON.EXPIRE_ON_DATE, localeCode),
            expired: makeTranslator(KEYS.COMMON.EXPIRED, localeCode),
            expiry: makeTranslator(KEYS.COMMON.EXPIRY, localeCode),
            failedTo: makeTranslator(KEYS.COMMON.FAILED_TO, localeCode),
            failedToLoadImage: makeTranslator(KEYS.COMMON.FAILED_TO_LOAD_IMAGE, localeCode),
            failedToRetrieveLocations: makeTranslator(KEYS.COMMON.FAILED_TO_RETRIEVE_LOCATIONS, localeCode),
            fetchData: makeTranslator(KEYS.COMMON.FETCH_DATA, localeCode),
            file: makeTranslator(KEYS.COMMON.FILE, localeCode),
            fileSize: makeTranslator(KEYS.COMMON.FILE_SIZE, localeCode),
            fileUploaded: makeTranslator(KEYS.COMMON.FILE_UPLOADED, localeCode),
            files: makeTranslator(KEYS.COMMON.FILES, localeCode),
            filter: makeTranslator(KEYS.COMMON.FILTER, localeCode),
            filterCollections: makeTranslator(KEYS.COMMON.FILTER_COLLECTIONS, localeCode),
            filters: makeTranslator(KEYS.COMMON.FILTERS, localeCode),
            finish: makeTranslator(KEYS.COMMON.FINISH, localeCode),
            firstName: makeTranslator(KEYS.COMMON.FIRST_NAME, localeCode),
            format: makeTranslator(KEYS.COMMON.FORMAT, localeCode),
            formats: makeTranslator(KEYS.COMMON.FORMATS, localeCode),
            from: makeTranslator(KEYS.COMMON.FROM, localeCode),
            fullScreen: makeTranslator(KEYS.COMMON.FULL_SCREEN, localeCode),
            gmt: makeTranslator(KEYS.COMMON.GMT, localeCode),
            googleAdsDisclaimer: makeTranslator(KEYS.COMMON.GOOGLE_ADS_DISCLAIMER, localeCode),
            googleAdsDisclaimerConversionData: makeTranslator(KEYS.COMMON.GOOGLE_ADS_DISCLAIMER_CONVERSION_DATA, localeCode),
            groups: makeTranslator(KEYS.COMMON.GROUPS, localeCode),
            height: makeTranslator(KEYS.COMMON.HEIGHT, localeCode),
            hide: makeTranslator(KEYS.COMMON.HIDE, localeCode),
            image: makeTranslator(KEYS.COMMON.IMAGE, localeCode),
            info: makeTranslator(KEYS.COMMON.INFO, localeCode),
            instructions: makeTranslator(KEYS.COMMON.INSTRUCTIONS, localeCode),
            invite: makeTranslator(KEYS.COMMON.INVITE, localeCode),
            item: makeTranslator(KEYS.COMMON.ITEM, localeCode),
            label: makeTranslator(KEYS.COMMON.LABEL, localeCode),
            lastActivity: makeTranslator(KEYS.COMMON.LAST_ACTIVITY, localeCode),
            lastMonth: makeTranslator(KEYS.COMMON.LAST_MONTH, localeCode),
            lastName: makeTranslator(KEYS.COMMON.LAST_NAME, localeCode),
            lastUpdated: makeTranslator(KEYS.COMMON.LAST_UPDATED, localeCode),
            learnMore: makeTranslator(KEYS.COMMON.LEARN_MORE, localeCode),
            leavePageConfirmation: makeTranslator(KEYS.COMMON.LEAVE_PAGE_CONFIRMATION, localeCode),
            leavePageConfirmationLong: makeTranslator(KEYS.COMMON.LEAVE_PAGE_CONFIRMATION_LONG, localeCode),
            leavePagePrompt: {
                confirm: makeTranslator(KEYS.COMMON.LEAVE_PAGE_PROMPT.CONFIRM, localeCode),
                title: makeTranslator(KEYS.COMMON.LEAVE_PAGE_PROMPT.TITLE, localeCode)
            },
            legend: makeTranslator(KEYS.COMMON.LEGEND, localeCode),
            less: makeTranslator(KEYS.COMMON.LESS, localeCode),
            link: makeTranslator(KEYS.COMMON.LINK, localeCode),
            loadMore: makeTranslator(KEYS.COMMON.LOAD_MORE, localeCode),
            loading: makeTranslator(KEYS.COMMON.LOADING, localeCode),
            locale: makeTranslator(KEYS.COMMON.LOCALE, localeCode),
            localeRequired: makeTranslator(KEYS.COMMON.LOCALE_REQUIRED, localeCode),
            location: makeTranslator(KEYS.COMMON.LOCATION, localeCode),
            locationUsedMaxCollections: makeTranslator(KEYS.COMMON.LOCATION_USED_MAX_COLLECTIONS, localeCode),
            locations: makeTranslator(KEYS.COMMON.LOCATIONS, localeCode),
            login: makeTranslator(KEYS.COMMON.LOGIN, localeCode),
            manager: makeTranslator(KEYS.COMMON.MANAGER, localeCode),
            map: makeTranslator(KEYS.COMMON.MAP, localeCode),
            marketing: makeTranslator(KEYS.COMMON.MARKETING, localeCode),
            message: makeTranslator(KEYS.COMMON.MESSAGE, localeCode),
            mobile: makeTranslator(KEYS.COMMON.MOBILE, localeCode),
            more: makeTranslator(KEYS.COMMON.MORE, localeCode),
            moreCharsForSearch: makeTranslator(KEYS.COMMON.MORE_CHARS_FOR_SEARCH, localeCode),
            most: makeTranslator(KEYS.COMMON.MOST, localeCode),
            moveToFolder: makeTranslator(KEYS.COMMON.MOVE_TO_FOLDER, localeCode),
            mustBeXOrMore: makeTranslator(KEYS.COMMON.MUST_BE_X_OR_MORE, localeCode),
            name: makeTranslator(KEYS.COMMON.NAME, localeCode),
            never: makeTranslator(KEYS.COMMON.NEVER, localeCode),
            new: makeTranslator(KEYS.COMMON.NEW, localeCode),
            newCollection: makeTranslator(KEYS.COMMON.NEW_COLLECTION, localeCode),
            next: makeTranslator(KEYS.COMMON.NEXT, localeCode),
            nextAmount: makeTranslator(KEYS.COMMON.NEXT_AMOUNT, localeCode),
            nextDate: makeTranslator(KEYS.COMMON.NEXT_DATE, localeCode),
            no: makeTranslator(KEYS.COMMON.NO, localeCode),
            noAssetCollectionsFound: makeTranslator(KEYS.COMMON.NO_ASSET_COLLECTIONS_FOUND, localeCode),
            noAssetsAreCurrentlyAvaliableFor: makeTranslator(KEYS.COMMON.NO_ASSETS_ARE_CURRENTLY_AVALIABLE_FOR, localeCode),
            noAssetsFound: makeTranslator(KEYS.COMMON.NO_ASSETS_FOUND, localeCode),
            noMatchingCollectionsFound: makeTranslator(KEYS.COMMON.NO_MATCHING_COLLECTIONS_FOUND, localeCode),
            noResults: makeTranslator(KEYS.COMMON.NO_RESULTS, localeCode),
            noThanks: makeTranslator(KEYS.COMMON.NO_THANKS, localeCode),
            nobody: makeTranslator(KEYS.COMMON.NOBODY, localeCode),
            none: makeTranslator(KEYS.COMMON.NONE, localeCode),
            notLoggedIn: makeTranslator(KEYS.COMMON.NOT_LOGGED_IN, localeCode),
            notSeeingWhatExpected: makeTranslator(KEYS.COMMON.NOT_SEEING_WHAT_EXPECTED, localeCode),
            note: makeTranslator(KEYS.COMMON.NOTE, localeCode),
            nothingFound: makeTranslator(KEYS.COMMON.NOTHING_FOUND, localeCode),
            notification: makeTranslator(KEYS.COMMON.NOTIFICATION, localeCode),
            notifications: makeTranslator(KEYS.COMMON.NOTIFICATIONS, localeCode),
            numOfTotal: makeTranslator(KEYS.COMMON.NUM_OF_TOTAL, localeCode),
            ok: makeTranslator(KEYS.COMMON.OK, localeCode),
            on: makeTranslator(KEYS.COMMON.ON, localeCode),
            opAddAsset: makeTranslator(KEYS.COMMON.OP_ADD_ASSET, localeCode),
            opCreateCollection: makeTranslator(KEYS.COMMON.OP_CREATE_COLLECTION, localeCode),
            opDeleteAssets: makeTranslator(KEYS.COMMON.OP_DELETE_ASSETS, localeCode),
            opDeleteCollection: makeTranslator(KEYS.COMMON.OP_DELETE_COLLECTION, localeCode),
            opEditAssets: makeTranslator(KEYS.COMMON.OP_EDIT_ASSETS, localeCode),
            opEditCollection: makeTranslator(KEYS.COMMON.OP_EDIT_COLLECTION, localeCode),
            opGetAssets: makeTranslator(KEYS.COMMON.OP_GET_ASSETS, localeCode),
            opGetCollection: makeTranslator(KEYS.COMMON.OP_GET_COLLECTION, localeCode),
            opGetCollections: makeTranslator(KEYS.COMMON.OP_GET_COLLECTIONS, localeCode),
            opGetLocations: makeTranslator(KEYS.COMMON.OP_GET_LOCATIONS, localeCode),
            opGetNumCollections: makeTranslator(KEYS.COMMON.OP_GET_NUM_COLLECTIONS, localeCode),
            opGetPermissions: makeTranslator(KEYS.COMMON.OP_GET_PERMISSIONS, localeCode),
            open: makeTranslator(KEYS.COMMON.OPEN, localeCode),
            openCalendar: makeTranslator(KEYS.COMMON.OPEN_CALENDAR, localeCode),
            openYourFile: makeTranslator(KEYS.COMMON.OPEN_YOUR_FILE, localeCode),
            optional: makeTranslator(KEYS.COMMON.OPTIONAL, localeCode),
            options: makeTranslator(KEYS.COMMON.OPTIONS, localeCode),
            or: makeTranslator(KEYS.COMMON.OR, localeCode),
            other: makeTranslator(KEYS.COMMON.OTHER, localeCode),
            outOfRange: makeTranslator(KEYS.COMMON.OUT_OF_RANGE, localeCode),
            password: makeTranslator(KEYS.COMMON.PASSWORD, localeCode),
            pay: makeTranslator(KEYS.COMMON.PAY, localeCode),
            perPage: makeTranslator(KEYS.COMMON.PER_PAGE, localeCode),
            phoneNumber: makeTranslator(KEYS.COMMON.PHONE_NUMBER, localeCode),
            planned: makeTranslator(KEYS.COMMON.PLANNED, localeCode),
            platform: makeTranslator(KEYS.COMMON.PLATFORM, localeCode),
            platforms: makeTranslator(KEYS.COMMON.PLATFORMS, localeCode),
            pleaseContactYourAgencyForFurtherInformation: makeTranslator(KEYS.COMMON.PLEASE_CONTACT_YOUR_AGENCY_FOR_FURTHER_INFORMATION, localeCode),
            preview: makeTranslator(KEYS.COMMON.PREVIEW, localeCode),
            previous: makeTranslator(KEYS.COMMON.PREVIOUS, localeCode),
            price: makeTranslator(KEYS.COMMON.PRICE, localeCode),
            primary: makeTranslator(KEYS.COMMON.PRIMARY, localeCode),
            print: makeTranslator(KEYS.COMMON.PRINT, localeCode),
            private: makeTranslator(KEYS.COMMON.PRIVATE, localeCode),
            processing: makeTranslator(KEYS.COMMON.PROCESSING, localeCode),
            products: {
                campaignMonitor: makeTranslator(KEYS.COMMON.PRODUCTS.CAMPAIGN_MONITOR, localeCode),
                clubready: makeTranslator(KEYS.COMMON.PRODUCTS.CLUBREADY, localeCode),
                digitalStack: makeTranslator(KEYS.COMMON.PRODUCTS.DIGITAL_STACK, localeCode),
                facebook: makeTranslator(KEYS.COMMON.PRODUCTS.FACEBOOK, localeCode),
                facebookAds: makeTranslator(KEYS.COMMON.PRODUCTS.FACEBOOK_ADS, localeCode),
                facebookAndInstagramAds: makeTranslator(KEYS.COMMON.PRODUCTS.FACEBOOK_AND_INSTAGRAM_ADS, localeCode),
                fitware: makeTranslator(KEYS.COMMON.PRODUCTS.FITWARE, localeCode),
                four51: makeTranslator(KEYS.COMMON.PRODUCTS.FOUR51, localeCode),
                glofox: makeTranslator(KEYS.COMMON.PRODUCTS.GLOFOX, localeCode),
                google: makeTranslator(KEYS.COMMON.PRODUCTS.GOOGLE, localeCode),
                googleAdwords: makeTranslator(KEYS.COMMON.PRODUCTS.GOOGLE_ADWORDS, localeCode),
                googleAnalytics: makeTranslator(KEYS.COMMON.PRODUCTS.GOOGLE_ANALYTICS, localeCode),
                googleMyBusiness: makeTranslator(KEYS.COMMON.PRODUCTS.GOOGLE_MY_BUSINESS, localeCode),
                instagram: makeTranslator(KEYS.COMMON.PRODUCTS.INSTAGRAM, localeCode),
                instagramViaFacebook: makeTranslator(KEYS.COMMON.PRODUCTS.INSTAGRAM_VIA_FACEBOOK, localeCode),
                linkedin: makeTranslator(KEYS.COMMON.PRODUCTS.LINKEDIN, localeCode),
                mailchimp: makeTranslator(KEYS.COMMON.PRODUCTS.MAILCHIMP, localeCode),
                sendgrid: makeTranslator(KEYS.COMMON.PRODUCTS.SENDGRID, localeCode),
                twitter: makeTranslator(KEYS.COMMON.PRODUCTS.TWITTER, localeCode)
            },
            progressModal: {
                statusMessage: makeTranslator(KEYS.COMMON.PROGRESS_MODAL.STATUS_MESSAGE, localeCode)
            },
            public: makeTranslator(KEYS.COMMON.PUBLIC, localeCode),
            quantity: makeTranslator(KEYS.COMMON.QUANTITY, localeCode),
            refresh: makeTranslator(KEYS.COMMON.REFRESH, localeCode),
            region: makeTranslator(KEYS.COMMON.REGION, localeCode),
            reload: makeTranslator(KEYS.COMMON.RELOAD, localeCode),
            remove: makeTranslator(KEYS.COMMON.REMOVE, localeCode),
            rename: makeTranslator(KEYS.COMMON.RENAME, localeCode),
            renameSomething: makeTranslator(KEYS.COMMON.RENAME_SOMETHING, localeCode),
            replacePdf: makeTranslator(KEYS.COMMON.REPLACE_PDF, localeCode),
            required: makeTranslator(KEYS.COMMON.REQUIRED, localeCode),
            requiredFieldHelp: makeTranslator(KEYS.COMMON.REQUIRED_FIELD_HELP, localeCode),
            requiredFieldMessage: makeTranslator(KEYS.COMMON.REQUIRED_FIELD_MESSAGE, localeCode),
            retry: makeTranslator(KEYS.COMMON.RETRY, localeCode),
            review: makeTranslator(KEYS.COMMON.REVIEW, localeCode),
            role: makeTranslator(KEYS.COMMON.ROLE, localeCode),
            save: makeTranslator(KEYS.COMMON.SAVE, localeCode),
            saveNew: makeTranslator(KEYS.COMMON.SAVE_NEW, localeCode),
            schedule: makeTranslator(KEYS.COMMON.SCHEDULE, localeCode),
            scheduled: makeTranslator(KEYS.COMMON.SCHEDULED, localeCode),
            search: makeTranslator(KEYS.COMMON.SEARCH, localeCode),
            searchAssets: makeTranslator(KEYS.COMMON.SEARCH_ASSETS, localeCode),
            searchCollections: makeTranslator(KEYS.COMMON.SEARCH_COLLECTIONS, localeCode),
            searchEverything: makeTranslator(KEYS.COMMON.SEARCH_EVERYTHING, localeCode),
            searchResults: makeTranslator(KEYS.COMMON.SEARCH_RESULTS, localeCode),
            searchWithin: makeTranslator(KEYS.COMMON.SEARCH_WITHIN, localeCode),
            selectAClient: makeTranslator(KEYS.COMMON.SELECT_A_CLIENT, localeCode),
            selectAll: makeTranslator(KEYS.COMMON.SELECT_ALL, localeCode),
            selectAnOption: makeTranslator(KEYS.COMMON.SELECT_AN_OPTION, localeCode),
            selectStartAndEndDates: makeTranslator(KEYS.COMMON.SELECT_START_AND_END_DATES, localeCode),
            selected: makeTranslator(KEYS.COMMON.SELECTED, localeCode),
            selectedClients: makeTranslator(KEYS.COMMON.SELECTED_CLIENTS, localeCode),
            send: makeTranslator(KEYS.COMMON.SEND, localeCode),
            sendQuote: makeTranslator(KEYS.COMMON.SEND_QUOTE, localeCode),
            sending: makeTranslator(KEYS.COMMON.SENDING, localeCode),
            settings: makeTranslator(KEYS.COMMON.SETTINGS, localeCode),
            shipping: makeTranslator(KEYS.COMMON.SHIPPING, localeCode),
            shippingFee: makeTranslator(KEYS.COMMON.SHIPPING_FEE, localeCode),
            showAll: makeTranslator(KEYS.COMMON.SHOW_ALL, localeCode),
            showLess: makeTranslator(KEYS.COMMON.SHOW_LESS, localeCode),
            skip: makeTranslator(KEYS.COMMON.SKIP, localeCode),
            someAssets: makeTranslator(KEYS.COMMON.SOME_ASSETS, localeCode),
            sort: makeTranslator(KEYS.COMMON.SORT, localeCode),
            sortBy: makeTranslator(KEYS.COMMON.SORT_BY, localeCode),
            sortDirectionTip: makeTranslator(KEYS.COMMON.SORT_DIRECTION_TIP, localeCode),
            sortDirectionTipAsc: makeTranslator(KEYS.COMMON.SORT_DIRECTION_TIP_ASC, localeCode),
            sortDirectionTipDesc: makeTranslator(KEYS.COMMON.SORT_DIRECTION_TIP_DESC, localeCode),
            startDate: makeTranslator(KEYS.COMMON.START_DATE, localeCode),
            status: makeTranslator(KEYS.COMMON.STATUS, localeCode),
            stepNOfCount: makeTranslator(KEYS.COMMON.STEP_N_OF_COUNT, localeCode),
            subject: makeTranslator(KEYS.COMMON.SUBJECT, localeCode),
            submit: makeTranslator(KEYS.COMMON.SUBMIT, localeCode),
            tag: makeTranslator(KEYS.COMMON.TAG, localeCode),
            tags: makeTranslator(KEYS.COMMON.TAGS, localeCode),
            templateCategory: makeTranslator(KEYS.COMMON.TEMPLATE_CATEGORY, localeCode),
            termsAndConditions: makeTranslator(KEYS.COMMON.TERMS_AND_CONDITIONS, localeCode),
            termsAndConditionsWithSymbol: makeTranslator(KEYS.COMMON.TERMS_AND_CONDITIONS_WITH_SYMBOL, localeCode),
            text: makeTranslator(KEYS.COMMON.TEXT, localeCode),
            thisDocumentCannotBePreviewed: makeTranslator(KEYS.COMMON.THIS_DOCUMENT_CANNOT_BE_PREVIEWED, localeCode),
            thisMonth: makeTranslator(KEYS.COMMON.THIS_MONTH, localeCode),
            timePeriod: {
                afternoon: makeTranslator(KEYS.COMMON.TIME_PERIOD.AFTERNOON, localeCode),
                morning: makeTranslator(KEYS.COMMON.TIME_PERIOD.MORNING, localeCode)
            },
            timezone: makeTranslator(KEYS.COMMON.TIMEZONE, localeCode),
            title: makeTranslator(KEYS.COMMON.TITLE, localeCode),
            jobTitle: makeTranslator(KEYS.COMMON.JOB_TITLE, localeCode),
            titles: {
                dr: makeTranslator(KEYS.COMMON.TITLES.DR, localeCode),
                miss: makeTranslator(KEYS.COMMON.TITLES.MISS, localeCode),
                mr: makeTranslator(KEYS.COMMON.TITLES.MR, localeCode),
                mrs: makeTranslator(KEYS.COMMON.TITLES.MRS, localeCode),
                ms: makeTranslator(KEYS.COMMON.TITLES.MS, localeCode),
                prof: makeTranslator(KEYS.COMMON.TITLES.PROF, localeCode),
                sir: makeTranslator(KEYS.COMMON.TITLES.SIR, localeCode)
            },
            today: makeTranslator(KEYS.COMMON.TODAY, localeCode),
            toggleNavigation: makeTranslator(KEYS.COMMON.TOGGLE_NAVIGATION, localeCode),
            tomorrow: makeTranslator(KEYS.COMMON.TOMORROW, localeCode),
            tooltips: {
                selectAll: makeTranslator(KEYS.COMMON.TOOLTIPS.SELECT_ALL, localeCode)
            },
            total: makeTranslator(KEYS.COMMON.TOTAL, localeCode),
            type: makeTranslator(KEYS.COMMON.TYPE, localeCode),
            units: {
                inches: makeTranslator(KEYS.COMMON.UNITS.INCHES, localeCode),
                millimeters: makeTranslator(KEYS.COMMON.UNITS.MILLIMETERS, localeCode)
            },
            unknown: makeTranslator(KEYS.COMMON.UNKNOWN, localeCode),
            unpublished: makeTranslator(KEYS.COMMON.UNPUBLISHED, localeCode),
            unsupportedImageFileType: makeTranslator(KEYS.COMMON.UNSUPPORTED_IMAGE_FILE_TYPE, localeCode),
            update: makeTranslator(KEYS.COMMON.UPDATE, localeCode),
            updating: makeTranslator(KEYS.COMMON.UPDATING, localeCode),
            upload: makeTranslator(KEYS.COMMON.UPLOAD, localeCode),
            uploadAFile: makeTranslator(KEYS.COMMON.UPLOAD_A_FILE, localeCode),
            uploadALogo: makeTranslator(KEYS.COMMON.UPLOAD_A_LOGO, localeCode),
            uploadAPdf: makeTranslator(KEYS.COMMON.UPLOAD_A_PDF, localeCode),
            uploadDeleteConfirm: makeTranslator(KEYS.COMMON.UPLOAD_DELETE_CONFIRM, localeCode),
            uploadFiles: makeTranslator(KEYS.COMMON.UPLOAD_FILES, localeCode),
            url: makeTranslator(KEYS.COMMON.URL, localeCode),
            useDisplayName: makeTranslator(KEYS.COMMON.USE_DISPLAY_NAME, localeCode),
            user: makeTranslator(KEYS.COMMON.USER, localeCode),
            username: makeTranslator(KEYS.COMMON.USERNAME, localeCode),
            users: makeTranslator(KEYS.COMMON.USERS, localeCode),
            validation: {
                invalidDate: makeTranslator(KEYS.COMMON.VALIDATION.INVALID_DATE, localeCode),
                invalidEmail: makeTranslator(KEYS.COMMON.VALIDATION.INVALID_EMAIL, localeCode),
                mustConfirmDetailsToContinue: makeTranslator(KEYS.COMMON.VALIDATION.MUST_CONFIRM_DETAILS_TO_CONTINUE, localeCode),
                required: makeTranslator(KEYS.COMMON.VALIDATION.REQUIRED, localeCode),
                stringTooLong: makeTranslator(KEYS.COMMON.VALIDATION.STRING_TOO_LONG, localeCode)
            },
            video: makeTranslator(KEYS.COMMON.VIDEO, localeCode),
            view: makeTranslator(KEYS.COMMON.VIEW, localeCode),
            viewMore: makeTranslator(KEYS.COMMON.VIEW_MORE, localeCode),
            visibleToWhich: makeTranslator(KEYS.COMMON.VISIBLE_TO_WHICH, localeCode),
            web: makeTranslator(KEYS.COMMON.WEB, localeCode),
            width: makeTranslator(KEYS.COMMON.WIDTH, localeCode),
            yep: makeTranslator(KEYS.COMMON.YEP, localeCode),
            yes: makeTranslator(KEYS.COMMON.YES, localeCode),
            yesterday: makeTranslator(KEYS.COMMON.YESTERDAY, localeCode),
            youCurrentlyHaveNoCollections: makeTranslator(KEYS.COMMON.YOU_CURRENTLY_HAVE_NO_COLLECTIONS, localeCode),
            yourBrowserDoesNotSupportEmbeddedVideos: makeTranslator(KEYS.COMMON.YOUR_BROWSER_DOES_NOT_SUPPORT_EMBEDDED_VIDEOS, localeCode)
        },
        components: {
            toggleCollapseCheckbox: makeTranslator(KEYS.COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX, localeCode)
        },
        dashboard: {
            brandsDashboard: {
                menuItems: {
                    activities: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ACTIVITIES, localeCode),
                    agency: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY, localeCode),
                    agencyBrands: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.AGENCY_BRANDS, localeCode),
                    communicate: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE, localeCode),
                    communicateSend: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND, localeCode),
                    communicateSendReports: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.COMMUNICATE_SEND_REPORTS, localeCode),
                    connections: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS, localeCode),
                    connectionsPlatforms: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.CONNECTIONS_PLATFORMS, localeCode),
                    dashboard: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.DASHBOARD, localeCode),
                    engagement: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT, localeCode),
                    engagementLocationActivity: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_LOCATION_ACTIVITY, localeCode),
                    engagementOverview: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_OVERVIEW, localeCode),
                    engagementRegionGroupActivity: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_REGION_GROUP_ACTIVITY, localeCode),
                    engagementTemplateUse: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ENGAGEMENT_TEMPLATE_USE, localeCode),
                    learnMenu: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.LEARN_MENU, localeCode),
                    manage: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE, localeCode),
                    manageHashtagSets: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_HASHTAG_SETS, localeCode),
                    manageLearnMenu: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LEARN_MENU, localeCode),
                    manageLocations: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_LOCATIONS, localeCode),
                    manageRegionsGroups: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_REGIONS_GROUPS, localeCode),
                    manageUsers: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.MANAGE_USERS, localeCode),
                    roadmap: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.ROADMAP, localeCode),
                    style: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE, localeCode),
                    styleColors: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_COLORS, localeCode),
                    styleFonts: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_FONTS, localeCode),
                    styleStyleGuide: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.STYLE_STYLE_GUIDE, localeCode),
                    templates: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATES, localeCode),
                    templateCategories: makeTranslator(KEYS.DASHBOARD.BRANDS_DASHBOARD.MENU_ITEMS.TEMPLATE_CATEGORIES, localeCode)
                }
            },
            builtPosts: makeTranslator(KEYS.DASHBOARD.BUILT_POSTS, localeCode),
            dueInNDays: makeTranslator(KEYS.DASHBOARD.DUE_IN_N_DAYS, localeCode),
            dueInNDaysPlural: makeTranslator(KEYS.DASHBOARD.DUE_IN_N_DAYS_plural, localeCode),
            dueInNWeeks: makeTranslator(KEYS.DASHBOARD.DUE_IN_N_WEEKS, localeCode),
            dueInNWeeksPlural: makeTranslator(KEYS.DASHBOARD.DUE_IN_N_WEEKS_plural, localeCode),
            dueToday: makeTranslator(KEYS.DASHBOARD.DUE_TODAY, localeCode),
            dueTomorrow: makeTranslator(KEYS.DASHBOARD.DUE_TOMORROW, localeCode),
            failedToSetYourLocation: makeTranslator(KEYS.DASHBOARD.FAILED_TO_SET_YOUR_LOCATION, localeCode),
            fetchDashboardDetails: makeTranslator(KEYS.DASHBOARD.FETCH_DASHBOARD_DETAILS, localeCode),
            fetchLatestWebinar: makeTranslator(KEYS.DASHBOARD.FETCH_LATEST_WEBINAR, localeCode),
            fetchUpcomingEvents: makeTranslator(KEYS.DASHBOARD.FETCH_UPCOMING_EVENTS, localeCode),
            heroMessage: makeTranslator(KEYS.DASHBOARD.HERO_MESSAGE, localeCode),
            howAreYouTracking: makeTranslator(KEYS.DASHBOARD.HOW_ARE_YOU_TRACKING, localeCode),
            inNWeeks: makeTranslator(KEYS.DASHBOARD.IN_N_WEEKS, localeCode),
            inNWeeksPlural: makeTranslator(KEYS.DASHBOARD.IN_N_WEEKS_plural, localeCode),
            latestWebinar: {
                agencyAdviceForShowingWebinar: makeTranslator(KEYS.DASHBOARD.LATEST_WEBINAR.AGENCY_ADVICE_FOR_SHOWING_WEBINAR, localeCode),
                moreWebinars: makeTranslator(KEYS.DASHBOARD.LATEST_WEBINAR.MORE_WEBINARS, localeCode),
                webinar: makeTranslator(KEYS.DASHBOARD.LATEST_WEBINAR.WEBINAR, localeCode)
            },
            learnMore: makeTranslator(KEYS.DASHBOARD.LEARN_MORE, localeCode),
            location: makeTranslator(KEYS.DASHBOARD.LOCATION, localeCode),
            noUpcomingEvents: makeTranslator(KEYS.DASHBOARD.NO_UPCOMING_EVENTS, localeCode),
            performanceSummary: {
                averageShort: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.AVERAGE_SHORT, localeCode),
                connectAppsToSeePerformance: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.CONNECT_APPS_TO_SEE_PERFORMANCE, localeCode),
                difference: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.DIFFERENCE, localeCode),
                failedToGetPerformanceMetric: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.FAILED_TO_GET_PERFORMANCE_METRIC, localeCode),
                fetchPerformanceMetrics: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.FETCH_PERFORMANCE_METRICS, localeCode),
                fullPerformanceReport: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.FULL_PERFORMANCE_REPORT, localeCode),
                insufficientDataRecorded: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED, localeCode),
                insufficientDataRecordedPlural: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.INSUFFICIENT_DATA_RECORDED_plural, localeCode),
                metrics: {
                    adwordsConversionValue: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSION_VALUE, localeCode),
                    adwordsConversions: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.ADWORDS_CONVERSIONS, localeCode),
                    facebookEngagementClicks: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_CLICKS, localeCode),
                    facebookEngagementReach: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.FACEBOOK_ENGAGEMENT_REACH, localeCode),
                    instagramFollowers: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.INSTAGRAM_FOLLOWERS, localeCode),
                    spend: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.SPEND, localeCode),
                    twitterLikes: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.METRICS.TWITTER_LIKES, localeCode)
                },
                performanceHeading: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.PERFORMANCE_HEADING, localeCode),
                serviceNotAuthorised: makeTranslator(KEYS.DASHBOARD.PERFORMANCE_SUMMARY.SERVICE_NOT_AUTHORISED, localeCode)
            },
            readyToBuildThese: makeTranslator(KEYS.DASHBOARD.READY_TO_BUILD_THESE, localeCode),
            suggestedTemplates: {
                agencyAdviceForFeaturingTemplates: makeTranslator(KEYS.DASHBOARD.SUGGESTED_TEMPLATES.AGENCY_ADVICE_FOR_FEATURING_TEMPLATES, localeCode),
                buildAndScheduleGallery: makeTranslator(KEYS.DASHBOARD.SUGGESTED_TEMPLATES.BUILD_AND_SCHEDULE_GALLERY, localeCode),
                fetchSuggestedTemplates: makeTranslator(KEYS.DASHBOARD.SUGGESTED_TEMPLATES.FETCH_SUGGESTED_TEMPLATES, localeCode),
                suggestedTemplates: makeTranslator(KEYS.DASHBOARD.SUGGESTED_TEMPLATES.SUGGESTED_TEMPLATES, localeCode)
            },
            upcomingEvents: {
                planCalendar: makeTranslator(KEYS.DASHBOARD.UPCOMING_EVENTS.PLAN_CALENDAR, localeCode),
                upcoming: makeTranslator(KEYS.DASHBOARD.UPCOMING_EVENTS.UPCOMING, localeCode)
            },
            upcomingGeneralEvents: makeTranslator(KEYS.DASHBOARD.UPCOMING_GENERAL_EVENTS, localeCode),
            watchVideo: makeTranslator(KEYS.DASHBOARD.WATCH_VIDEO, localeCode),
            welcomeMessage: makeTranslator(KEYS.DASHBOARD.WELCOME_MESSAGE, localeCode),
            welcomePage: {
                didYouKnow: makeTranslator(KEYS.DASHBOARD.WELCOME_PAGE.DID_YOU_KNOW, localeCode),
                numCountries: makeTranslator(KEYS.DASHBOARD.WELCOME_PAGE.NUM_COUNTRIES, localeCode),
                numLocations: makeTranslator(KEYS.DASHBOARD.WELCOME_PAGE.NUM_LOCATIONS, localeCode),
                welcomeBack: makeTranslator(KEYS.DASHBOARD.WELCOME_PAGE.WELCOME_BACK, localeCode),
                whatsNew: makeTranslator(KEYS.DASHBOARD.WELCOME_PAGE.WHATS_NEW, localeCode)
            }
        },
        email: {
            automatedEmailDoNotReply: makeTranslator(KEYS.EMAIL.AUTOMATED_EMAIL_DO_NOT_REPLY, localeCode),
            ifYouWishToUnsubscribe: makeTranslator(KEYS.EMAIL.IF_YOU_WISH_TO_UNSUBSCRIBE, localeCode),
            inviteEmail: {
                buttonText: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.BUTTON_TEXT, localeCode),
                downloadTheApp: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.DOWNLOAD_THE_APP, localeCode),
                ifThisEmailShouldNotHaveBeenSentToYou: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.IF_THIS_EMAIL_SHOULD_NOT_HAVE_BEEN_SENT_TO_YOU, localeCode),
                instructions: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.INSTRUCTIONS, localeCode),
                subject: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.SUBJECT, localeCode),
                welcome: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.WELCOME, localeCode),
                whereToGetHelp: makeTranslator(KEYS.EMAIL.INVITE_EMAIL.WHERE_TO_GET_HELP, localeCode)
            },
            linkWillExpire: makeTranslator(KEYS.EMAIL.LINK_WILL_EXPIRE, localeCode),
            linkWillExpireHour: makeTranslator(KEYS.EMAIL.LINK_WILL_EXPIRE_HOUR, localeCode),
            linkWillExpireHourPlural: makeTranslator(KEYS.EMAIL.LINK_WILL_EXPIRE_HOUR_plural, localeCode),
            linkWillExpirePlural: makeTranslator(KEYS.EMAIL.LINK_WILL_EXPIRE_plural, localeCode),
            logInToChangeProfileSettings: makeTranslator(KEYS.EMAIL.LOG_IN_TO_CHANGE_PROFILE_SETTINGS, localeCode),
            logInToRespond: makeTranslator(KEYS.EMAIL.LOG_IN_TO_RESPOND, localeCode),
            logInToRespondOrViewAttachments: makeTranslator(KEYS.EMAIL.LOG_IN_TO_RESPOND_OR_VIEW_ATTACHMENTS, localeCode),
            sendToPrint: {
                artworkHasBeenSentTo: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.ARTWORK_HAS_BEEN_SENT_TO, localeCode),
                downloadArtwork: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.DOWNLOAD_ARTWORK, localeCode),
                instructions: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.INSTRUCTIONS, localeCode),
                orderNumber: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.ORDER_NUMBER, localeCode),
                printProviderDetails: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.PRINT_PROVIDER_DETAILS, localeCode),
                providerWillBeInTouch: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.PROVIDER_WILL_BE_IN_TOUCH, localeCode),
                quantity: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.QUANTITY, localeCode),
                sku: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.SKU, localeCode),
                skuname: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.SKUNAME, localeCode),
                subject: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.SUBJECT, localeCode),
                subjectOrderNumber: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.SUBJECT_ORDER_NUMBER, localeCode),
                userInvoiceSubject: makeTranslator(KEYS.EMAIL.SEND_TO_PRINT.USER_INVOICE_SUBJECT, localeCode)
            }
        },
        errors: {
            assetLibrary: {
                assets: {
                    fetchFailed: makeTranslator(KEYS.ERRORS.ASSET_LIBRARY.ASSETS.FETCH_FAILED, localeCode)
                },
                collections: {
                    fetchFailed: makeTranslator(KEYS.ERRORS.ASSET_LIBRARY.COLLECTIONS.FETCH_FAILED, localeCode)
                }
            },
            badRequestErrors: {
                billingDetailsUpdateAlreadyFinalised: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_FINALISED, localeCode),
                billingDetailsUpdateAlreadyReceived: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.BILLING_DETAILS_UPDATE_ALREADY_RECEIVED, localeCode),
                cannotChangeCollectionType: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CANNOT_CHANGE_COLLECTION_TYPE, localeCode),
                cannotCreatePrivateComment: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CANNOT_CREATE_PRIVATE_COMMENT, localeCode),
                cannotLinkAccessToken: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CANNOT_LINK_ACCESS_TOKEN, localeCode),
                cannotOverrideCustomFontFile: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CANNOT_OVERRIDE_CUSTOM_FONT_FILE, localeCode),
                clientDoesNotExist: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CLIENT_DOES_NOT_EXIST, localeCode),
                clientIdsDoNotMatch: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.CLIENT_IDS_DO_NOT_MATCH, localeCode),
                endDateMustBeBeforeStartDateOrAbsent: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.END_DATE_MUST_BE_BEFORE_START_DATE_OR_ABSENT, localeCode),
                facebookMarketingAdAccountInvalidCriteria: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.FACEBOOK_MARKETING_AD_ACCOUNT_INVALID_CRITERIA, localeCode),
                fileNameCannotStartWithPipe: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.FILE_NAME_CANNOT_START_WITH_PIPE, localeCode),
                invalidDocument: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.INVALID_DOCUMENT, localeCode),
                invalidId: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.INVALID_ID, localeCode),
                invalidSession: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.INVALID_SESSION, localeCode),
                invalidUrlToSign: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.INVALID_URL_TO_SIGN, localeCode),
                locationAlreadySignedUp: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.LOCATION_ALREADY_SIGNED_UP, localeCode),
                locationSubscriptionExpired: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.LOCATION_SUBSCRIPTION_EXPIRED, localeCode),
                operationRestrictedToSelf: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.OPERATION_RESTRICTED_TO_SELF, localeCode),
                paymentAlreadyFinalised: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.PAYMENT_ALREADY_FINALISED, localeCode),
                plannerActionDateBelowThreshold: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD, localeCode),
                plannerActionDateBelowThresholdPlural: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.PLANNER_ACTION_DATE_BELOW_THRESHOLD_plural, localeCode),
                plannerCannotSpecifyAllOrFuture: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.PLANNER_CANNOT_SPECIFY_ALL_OR_FUTURE, localeCode),
                recurringPaymentCannotBeDeleted: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_CANNOT_BE_DELETED, localeCode),
                recurringPaymentDatesOverlapWithExisting: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_DATES_OVERLAP_WITH_EXISTING, localeCode),
                recurringPaymentLastCannotBeDeleted: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.RECURRING_PAYMENT_LAST_CANNOT_BE_DELETED, localeCode),
                reportSummaryIdInvalid: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.REPORT_SUMMARY_ID_INVALID, localeCode),
                requestReturnedNoResponseData: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.REQUEST_RETURNED_NO_RESPONSE_DATA, localeCode),
                scheduledDateCannotBeMoreThanOneYearInTheFuture: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.SCHEDULED_DATE_CANNOT_BE_MORE_THAN_ONE_YEAR_IN_THE_FUTURE, localeCode),
                sendToFour51MissingData: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.SEND_TO_FOUR51_MISSING_DATA, localeCode),
                skuHasBothPriceAndQuantityOptions: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_BOTH_PRICE_AND_QUANTITY_OPTIONS, localeCode),
                skuHasNoPricingData: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.SKU_HAS_NO_PRICING_DATA, localeCode),
                specialRequestInvalidDate: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.SPECIAL_REQUEST_INVALID_DATE, localeCode),
                userBelongsToMultipleAgencies: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.USER_BELONGS_TO_MULTIPLE_AGENCIES, localeCode),
                userNotFound: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.USER_NOT_FOUND, localeCode),
                validationError: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.VALIDATION_ERROR, localeCode),
                videoIdNotFound: makeTranslator(KEYS.ERRORS.BAD_REQUEST_ERRORS.VIDEO_ID_NOT_FOUND, localeCode)
            },
            brand: {
                brandColours: {
                    errorAddingBrandColour: makeTranslator(KEYS.ERRORS.BRAND.BRAND_COLOURS.ERROR_ADDING_BRAND_COLOUR, localeCode),
                    errorDeletingBrandColour: makeTranslator(KEYS.ERRORS.BRAND.BRAND_COLOURS.ERROR_DELETING_BRAND_COLOUR, localeCode),
                    errorRenamingBrandColour: makeTranslator(KEYS.ERRORS.BRAND.BRAND_COLOURS.ERROR_RENAMING_BRAND_COLOUR, localeCode),
                    errorUpdatingBrandColour: makeTranslator(KEYS.ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR, localeCode),
                    errorUpdatingBrandColourOrder: makeTranslator(KEYS.ERRORS.BRAND.BRAND_COLOURS.ERROR_UPDATING_BRAND_COLOUR_ORDER, localeCode)
                },
                locationCategories: {
                    categoryLabelRequired: makeTranslator(KEYS.ERRORS.BRAND.LOCATION_CATEGORIES.CATEGORY_LABEL_REQUIRED, localeCode),
                    errorAddingLocationCategory: makeTranslator(KEYS.ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_ADDING_LOCATION_CATEGORY, localeCode),
                    errorDeletingLocationCategory: makeTranslator(KEYS.ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_DELETING_LOCATION_CATEGORY, localeCode),
                    errorRenamingLocationCategory: makeTranslator(KEYS.ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_RENAMING_LOCATION_CATEGORY, localeCode),
                    errorUpdatingLocationsForCategory: makeTranslator(KEYS.ERRORS.BRAND.LOCATION_CATEGORIES.ERROR_UPDATING_LOCATIONS_FOR_CATEGORY, localeCode)
                },
                noClientSelected: makeTranslator(KEYS.ERRORS.BRAND.NO_CLIENT_SELECTED, localeCode)
            },
            exceptionId: makeTranslator(KEYS.ERRORS.EXCEPTION_ID, localeCode),
            externalServiceErrors: {
                acrCloud: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD, localeCode),
                acrCloudEmptyResponse: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.ACR_CLOUD_EMPTY_RESPONSE, localeCode),
                emailFailure: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.EMAIL_FAILURE, localeCode),
                ewayError: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.EWAY_ERROR, localeCode),
                fitwareError: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_ERROR, localeCode),
                fitwareUnrecognisedResponse: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.FITWARE_UNRECOGNISED_RESPONSE, localeCode),
                passthrough: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.PASSTHROUGH, localeCode),
                twitterError: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_ERROR, localeCode),
                twitterUnknownError: makeTranslator(KEYS.ERRORS.EXTERNAL_SERVICE_ERRORS.TWITTER_UNKNOWN_ERROR, localeCode)
            },
            facebookErrors: {
                maxCharacterLimitForCaptionReached: makeTranslator(KEYS.ERRORS.FACEBOOK_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED, localeCode),
                missingFirstCommentHashtagsPermission: makeTranslator(KEYS.ERRORS.FACEBOOK_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION, localeCode),
                someLocationsAreMissingFirstCommentHashtagsPermission: makeTranslator(KEYS.ERRORS.FACEBOOK_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION, localeCode),
                untranslatedErrorMessage: makeTranslator(KEYS.ERRORS.FACEBOOK_ERRORS.UNTRANSLATED_ERROR_MESSAGE, localeCode)
            },
            facebookMarketingErrors: {
                permissionsNotGranted: makeTranslator(KEYS.ERRORS.FACEBOOK_MARKETING_ERRORS.PERMISSIONS_NOT_GRANTED, localeCode)
            },
            finaliseBillingDetailsUpdateError: makeTranslator(KEYS.ERRORS.FINALISE_BILLING_DETAILS_UPDATE_ERROR, localeCode),
            fitwareMemberEngager: {
                unrecognisedResponse: makeTranslator(KEYS.ERRORS.FITWARE_MEMBER_ENGAGER.UNRECOGNISED_RESPONSE, localeCode),
                untranslatedErrorMessage: makeTranslator(KEYS.ERRORS.FITWARE_MEMBER_ENGAGER.UNTRANSLATED_ERROR_MESSAGE, localeCode)
            },
            forbiddenErrors: {
                accessForbidden: makeTranslator(KEYS.ERRORS.FORBIDDEN_ERRORS.ACCESS_FORBIDDEN, localeCode),
                cannotAccessClient: makeTranslator(KEYS.ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_CLIENT, localeCode),
                cannotAccessLocation: makeTranslator(KEYS.ERRORS.FORBIDDEN_ERRORS.CANNOT_ACCESS_LOCATION, localeCode),
                noPermissionToViewClient: makeTranslator(KEYS.ERRORS.FORBIDDEN_ERRORS.NO_PERMISSION_TO_VIEW_CLIENT, localeCode),
                tryThisMustBeAssignedToAClient: makeTranslator(KEYS.ERRORS.FORBIDDEN_ERRORS.TRY_THIS_MUST_BE_ASSIGNED_TO_A_CLIENT, localeCode)
            },
            four51: {
                invalidQuantity: makeTranslator(KEYS.ERRORS.FOUR51.INVALID_QUANTITY, localeCode),
                invalidUsernameOrPassword: makeTranslator(KEYS.ERRORS.FOUR51.INVALID_USERNAME_OR_PASSWORD, localeCode),
                productMisconfigured: makeTranslator(KEYS.ERRORS.FOUR51.PRODUCT_MISCONFIGURED, localeCode),
                unrecognisedResponse: makeTranslator(KEYS.ERRORS.FOUR51.UNRECOGNISED_RESPONSE, localeCode),
                untranslatedErrorMessage: makeTranslator(KEYS.ERRORS.FOUR51.UNTRANSLATED_ERROR_MESSAGE, localeCode)
            },
            generateMapErrors: {
                failed: makeTranslator(KEYS.ERRORS.GENERATE_MAP_ERRORS.FAILED, localeCode),
                mapAlreadyExists: makeTranslator(KEYS.ERRORS.GENERATE_MAP_ERRORS.MAP_ALREADY_EXISTS, localeCode),
                noMapForLocation: makeTranslator(KEYS.ERRORS.GENERATE_MAP_ERRORS.NO_MAP_FOR_LOCATION, localeCode),
                paymentFailed: makeTranslator(KEYS.ERRORS.GENERATE_MAP_ERRORS.PAYMENT_FAILED, localeCode)
            },
            generic: makeTranslator(KEYS.ERRORS.GENERIC, localeCode),
            googleAds: {
                permissions: makeTranslator(KEYS.ERRORS.GOOGLE_ADS.PERMISSIONS, localeCode),
                permissionsLocationReport: makeTranslator(KEYS.ERRORS.GOOGLE_ADS.PERMISSIONS_LOCATION_REPORT, localeCode),
                unknown: makeTranslator(KEYS.ERRORS.GOOGLE_ADS.UNKNOWN, localeCode)
            },
            googleAnalytics: {
                permissions: makeTranslator(KEYS.ERRORS.GOOGLE_ANALYTICS.PERMISSIONS, localeCode),
                dataParseError: makeTranslator(KEYS.ERRORS.GOOGLE_ANALYTICS.DATA_PARSE_ERROR, localeCode),
                dataResponseError: makeTranslator(KEYS.ERRORS.GOOGLE_ANALYTICS.DATA_RESPONSE_ERROR, localeCode)
            },
            googleMyBusiness: {
                failedToPost: makeTranslator(KEYS.ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_POST, localeCode),
                failedToRetrieveLocationName: makeTranslator(KEYS.ERRORS.GOOGLE_MY_BUSINESS.FAILED_TO_RETRIEVE_LOCATION_NAME, localeCode),
                serviceNotConfigured: makeTranslator(KEYS.ERRORS.GOOGLE_MY_BUSINESS.SERVICE_NOT_CONFIGURED, localeCode)
            },
            googleOauthErrors: {
                invalidGrant: makeTranslator(KEYS.ERRORS.GOOGLE_OAUTH_ERRORS.INVALID_GRANT, localeCode)
            },
            instagramErrors: {
                apiRateLimitNotFound: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMIT_NOT_FOUND, localeCode),
                apiRateLimited: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED, localeCode),
                apiRateLimitedContinuePosting: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.API_RATE_LIMITED_CONTINUE_POSTING, localeCode),
                failedToPost: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.FAILED_TO_POST, localeCode),
                maxCharacterLimitForCaptionReached: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.MAX_CHARACTER_LIMIT_FOR_CAPTION_REACHED, localeCode),
                missingFirstCommentHashtagsPermission: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION, localeCode),
                someLocationsAreMissingFirstCommentHashtagsPermission: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.SOME_LOCATIONS_ARE_MISSING_FIRST_COMMENT_HASHTAGS_PERMISSION, localeCode),
                untranslatedErrorMessage: makeTranslator(KEYS.ERRORS.INSTAGRAM_ERRORS.UNTRANSLATED_ERROR_MESSAGE, localeCode)
            },
            invalidInputErrors: {
                base64StringMissingMimeType: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.BASE64_STRING_MISSING_MIME_TYPE, localeCode),
                colour: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.COLOUR, localeCode),
                ewayMultiplePaymentTransactions: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_PAYMENT_TRANSACTIONS, localeCode),
                ewayMultipleTokenisationTransactions: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TOKENISATION_TRANSACTIONS, localeCode),
                ewayMultipleTransactions: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.EWAY_MULTIPLE_TRANSACTIONS, localeCode),
                ewayZeroPaymentTransactions: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_PAYMENT_TRANSACTIONS, localeCode),
                ewayZeroTransactions: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.EWAY_ZERO_TRANSACTIONS, localeCode),
                facebookPageIdMigration: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.FACEBOOK_PAGE_ID_MIGRATION, localeCode),
                fileTooLarge: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.FILE_TOO_LARGE, localeCode),
                graphqlInput: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.GRAPHQL_INPUT, localeCode),
                invalidUrl: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.INVALID_URL, localeCode),
                missingFile: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.MISSING_FILE, localeCode),
                repositoryHasNullModel: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.REPOSITORY_HAS_NULL_MODEL, localeCode),
                uploadIdMissing: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.UPLOAD_ID_MISSING, localeCode),
                zeroWidthOrHeightVideo: makeTranslator(KEYS.ERRORS.INVALID_INPUT_ERRORS.ZERO_WIDTH_OR_HEIGHT_VIDEO, localeCode)
            },
            linkedin: {
                failedToPost: makeTranslator(KEYS.ERRORS.LINKEDIN.FAILED_TO_POST, localeCode),
                invalidGrant: makeTranslator(KEYS.ERRORS.LINKEDIN.INVALID_GRANT, localeCode),
                serviceNotConfigured: makeTranslator(KEYS.ERRORS.LINKEDIN.SERVICE_NOT_CONFIGURED, localeCode)
            },
            locationDraft: {
                cannotSaveLocationRevisionWithoutATitle: makeTranslator(KEYS.ERRORS.LOCATION_DRAFT.CANNOT_SAVE_LOCATION_REVISION_WITHOUT_A_TITLE, localeCode),
                failedToSave: makeTranslator(KEYS.ERRORS.LOCATION_DRAFT.FAILED_TO_SAVE, localeCode)
            },
            loginTokenErrors: {
                apiKeyInvalid: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_INVALID, localeCode),
                apiKeyMissing: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.API_KEY_MISSING, localeCode),
                tokenKeysMismatch: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_KEYS_MISMATCH, localeCode),
                tokenReferenceNotFound: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.TOKEN_REFERENCE_NOT_FOUND, localeCode),
                userNotFound: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.USER_NOT_FOUND, localeCode),
                usernameNotSpecified: makeTranslator(KEYS.ERRORS.LOGIN_TOKEN_ERRORS.USERNAME_NOT_SPECIFIED, localeCode)
            },
            missingValueErrors: {
                facebookAdSetMissingEndDate: makeTranslator(KEYS.ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_END_DATE, localeCode),
                facebookAdSetMissingStartDate: makeTranslator(KEYS.ERRORS.MISSING_VALUE_ERRORS.FACEBOOK_AD_SET_MISSING_START_DATE, localeCode),
                gatherStatsErrorHandlerMissingLocationId: makeTranslator(KEYS.ERRORS.MISSING_VALUE_ERRORS.GATHER_STATS_ERROR_HANDLER_MISSING_LOCATION_ID, localeCode),
                replacementValueForLocalResource: makeTranslator(KEYS.ERRORS.MISSING_VALUE_ERRORS.REPLACEMENT_VALUE_FOR_LOCAL_RESOURCE, localeCode)
            },
            multipleErrors: makeTranslator(KEYS.ERRORS.MULTIPLE_ERRORS, localeCode),
            noNetworkConnectionError: makeTranslator(KEYS.ERRORS.NO_NETWORK_CONNECTION_ERROR, localeCode),
            noStatsDataErrors: {
                googleAdwordsZeroValues: makeTranslator(KEYS.ERRORS.NO_STATS_DATA_ERRORS.GOOGLE_ADWORDS_ZERO_VALUES, localeCode),
                noStatsForDateRange: makeTranslator(KEYS.ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_DATE_RANGE, localeCode),
                noStatsForGivenPeriod: makeTranslator(KEYS.ERRORS.NO_STATS_DATA_ERRORS.NO_STATS_FOR_GIVEN_PERIOD, localeCode)
            },
            notFoundErrors: {
                agencyLocaleNotFoundWithId: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.AGENCY_LOCALE_NOT_FOUND_WITH_ID, localeCode),
                entityNotFound: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND, localeCode),
                entityNotFoundWithId: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_ID, localeCode),
                entityNotFoundWithToken: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.ENTITY_NOT_FOUND_WITH_TOKEN, localeCode),
                entityToDeleteNotFound: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_DELETE_NOT_FOUND, localeCode),
                entityToUpdateNotFound: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.ENTITY_TO_UPDATE_NOT_FOUND, localeCode),
                googleAdwordsGetReportDefinitionNoAccessToken: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.GOOGLE_ADWORDS_GET_REPORT_DEFINITION_NO_ACCESS_TOKEN, localeCode),
                noFacebookAccessTokenForLocation: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.NO_FACEBOOK_ACCESS_TOKEN_FOR_LOCATION, localeCode),
                noMatchingEmail: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.NO_MATCHING_EMAIL, localeCode),
                resourceNotFound: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.RESOURCE_NOT_FOUND, localeCode),
                userDoesNotBelongToAnyAgencies: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.USER_DOES_NOT_BELONG_TO_ANY_AGENCIES, localeCode),
                userNotFound: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND, localeCode),
                userNotFoundWithId: makeTranslator(KEYS.ERRORS.NOT_FOUND_ERRORS.USER_NOT_FOUND_WITH_ID, localeCode)
            },
            oauthErrors: {
                authorisationDenied: makeTranslator(KEYS.ERRORS.OAUTH_ERRORS.AUTHORISATION_DENIED, localeCode),
                callbackConfirmationFailed: makeTranslator(KEYS.ERRORS.OAUTH_ERRORS.CALLBACK_CONFIRMATION_FAILED, localeCode),
                noOauthToken: makeTranslator(KEYS.ERRORS.OAUTH_ERRORS.NO_OAUTH_TOKEN, localeCode),
                tokenDoesNotMatch: makeTranslator(KEYS.ERRORS.OAUTH_ERRORS.TOKEN_DOES_NOT_MATCH, localeCode),
                unknownGrantType: makeTranslator(KEYS.ERRORS.OAUTH_ERRORS.UNKNOWN_GRANT_TYPE, localeCode)
            },
            parsingErrors: {
                four51AuthToken: makeTranslator(KEYS.ERRORS.PARSING_ERRORS.FOUR51_AUTH_TOKEN, localeCode),
                parsingError: makeTranslator(KEYS.ERRORS.PARSING_ERRORS.PARSING_ERROR, localeCode)
            },
            publish: {
                errors: {
                    accessTokenHasExpired: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.ACCESS_TOKEN_HAS_EXPIRED, localeCode),
                    duplicatePostsDetected: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.DUPLICATE_POSTS_DETECTED, localeCode),
                    failedToPublishToLocation: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.FAILED_TO_PUBLISH_TO_LOCATION, localeCode),
                    genericErrorMessage: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.GENERIC_ERROR_MESSAGE, localeCode),
                    instagramCarouselPostRequirementsNotMet: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.INSTAGRAM_CAROUSEL_POST_REQUIREMENTS_NOT_MET, localeCode),
                    instagramMediaDownloadTimeout: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.INSTAGRAM_MEDIA_DOWNLOAD_TIMEOUT, localeCode),
                    instagramSuspectedSpam: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.INSTAGRAM_SUSPECTED_SPAM, localeCode),
                    instagramTagCountReached: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.INSTAGRAM_TAG_COUNT_REACHED, localeCode),
                    notShownMissingFromList: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.NOT_SHOWN_MISSING_FROM_LIST, localeCode),
                    permissionsNotGranted: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.PERMISSIONS_NOT_GRANTED, localeCode),
                    serviceInvalidAspectRatio: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_ASPECT_RATIO, localeCode),
                    serviceInvalidScheduleDate: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.SERVICE_INVALID_SCHEDULE_DATE, localeCode),
                    serviceMaximumCaptionLengthExceeded: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_CAPTION_LENGTH_EXCEEDED, localeCode),
                    serviceMaximumMediaSizeExceeded: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_MEDIA_SIZE_EXCEEDED, localeCode),
                    serviceMaximumPublishCountReached: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.SERVICE_MAXIMUM_PUBLISH_COUNT_REACHED, localeCode),
                    unsupportedFileFormat: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.UNSUPPORTED_FILE_FORMAT, localeCode),
                    userCredentialsChanged: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.USER_CREDENTIALS_CHANGED, localeCode),
                    userInterventionRequired: makeTranslator(KEYS.ERRORS.PUBLISH.ERRORS.USER_INTERVENTION_REQUIRED, localeCode)
                },
                invalidLocationNodeId: makeTranslator(KEYS.ERRORS.PUBLISH.INVALID_LOCATION_NODE_ID, localeCode),
                oneOrMoreArtifactIdsAreInvalid: makeTranslator(KEYS.ERRORS.PUBLISH.ONE_OR_MORE_ARTIFACT_IDS_ARE_INVALID, localeCode),
                schedulingStatusErrors: {
                    unknown: makeTranslator(KEYS.ERRORS.PUBLISH.SCHEDULING_STATUS_ERRORS.UNKNOWN, localeCode)
                }
            },
            requestTokenErrors: {
                apiKeyInvalid: makeTranslator(KEYS.ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_INVALID, localeCode),
                apiKeyNotSpecified: makeTranslator(KEYS.ERRORS.REQUEST_TOKEN_ERRORS.API_KEY_NOT_SPECIFIED, localeCode),
                issuerNotSpecified: makeTranslator(KEYS.ERRORS.REQUEST_TOKEN_ERRORS.ISSUER_NOT_SPECIFIED, localeCode),
                tokenInvalid: makeTranslator(KEYS.ERRORS.REQUEST_TOKEN_ERRORS.TOKEN_INVALID, localeCode)
            },
            scheduling: {
                delete: {
                    tooCloseToScheduledTime: makeTranslator(KEYS.ERRORS.SCHEDULING.DELETE.TOO_CLOSE_TO_SCHEDULED_TIME, localeCode),
                    unknown: makeTranslator(KEYS.ERRORS.SCHEDULING.DELETE.UNKNOWN, localeCode)
                },
                reschedule: {
                    tooCloseToScheduledTime: makeTranslator(KEYS.ERRORS.SCHEDULING.RESCHEDULE.TOO_CLOSE_TO_SCHEDULED_TIME, localeCode),
                    unknown: makeTranslator(KEYS.ERRORS.SCHEDULING.RESCHEDULE.UNKNOWN, localeCode)
                }
            },
            sendgrid: {
                couldNotFindUnsubGroup: makeTranslator(KEYS.ERRORS.SENDGRID.COULD_NOT_FIND_UNSUB_GROUP, localeCode),
                deleteEmailError: makeTranslator(KEYS.ERRORS.SENDGRID.DELETE_EMAIL_ERROR, localeCode),
                rescheduleEmailError: makeTranslator(KEYS.ERRORS.SENDGRID.RESCHEDULE_EMAIL_ERROR, localeCode),
                singleSendFailed: makeTranslator(KEYS.ERRORS.SENDGRID.SINGLE_SEND_FAILED, localeCode),
                singleSendFailedNoId: makeTranslator(KEYS.ERRORS.SENDGRID.SINGLE_SEND_FAILED_NO_ID, localeCode),
                wait30Mins: makeTranslator(KEYS.ERRORS.SENDGRID.WAIT_30_MINS, localeCode)
            },
            serviceAccessErrors: {
                accessExpiredOrForbidden: makeTranslator(KEYS.ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN, localeCode),
                accessExpiredOrForbiddenWithDetails: makeTranslator(KEYS.ERRORS.SERVICE_ACCESS_ERRORS.ACCESS_EXPIRED_OR_FORBIDDEN_WITH_DETAILS, localeCode),
                facebookAccountCannotAccessPage: makeTranslator(KEYS.ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_ACCOUNT_CANNOT_ACCESS_PAGE, localeCode),
                facebookPageTokenNotReturned: makeTranslator(KEYS.ERRORS.SERVICE_ACCESS_ERRORS.FACEBOOK_PAGE_TOKEN_NOT_RETURNED, localeCode)
            },
            serviceAuthenticationErrors: {
                failedToAuthorise: makeTranslator(KEYS.ERRORS.SERVICE_AUTHENTICATION_ERRORS.FAILED_TO_AUTHORISE, localeCode)
            },
            serviceConfigurationErrors: {
                clientMissingFitwareBusiness: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.CLIENT_MISSING_FITWARE_BUSINESS, localeCode),
                facebookPageNotConfigured: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FACEBOOK_PAGE_NOT_CONFIGURED, localeCode),
                fitwareClientConfigMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_CLIENT_CONFIG_MISSING, localeCode),
                fitwareMemberEngagerClubMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MEMBER_ENGAGER_CLUB_MISSING, localeCode),
                fitwareMissingData: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FITWARE_MISSING_DATA, localeCode),
                four51CredentialsMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_CREDENTIALS_MISSING, localeCode),
                four51StoreCompanyOrSsoKeyMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.FOUR51_STORE_COMPANY_OR_SSO_KEY_MISSING, localeCode),
                googleAdwordsCampaignNameNotConfigured: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CAMPAIGN_NAME_NOT_CONFIGURED, localeCode),
                googleAdwordsCustomerNotConfigured: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_CUSTOMER_NOT_CONFIGURED, localeCode),
                googleAdwordsNotConnected: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ADWORDS_NOT_CONNECTED, localeCode),
                googleAnalyticsPagePathMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_PAGE_PATH_MISSING, localeCode),
                googleAnalyticsViewIdMissing: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.GOOGLE_ANALYTICS_VIEW_ID_MISSING, localeCode),
                locationMissingFacebookPageId: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FACEBOOK_PAGE_ID, localeCode),
                locationMissingFitwareClubNumber: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_FITWARE_CLUB_NUMBER, localeCode),
                locationMissingInstagramPageId: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.LOCATION_MISSING_INSTAGRAM_PAGE_ID, localeCode),
                serviceNotConfigured: makeTranslator(KEYS.ERRORS.SERVICE_CONFIGURATION_ERRORS.SERVICE_NOT_CONFIGURED, localeCode)
            },
            serviceCredentialsMissingErrors: {
                noAuthenticationForService: makeTranslator(KEYS.ERRORS.SERVICE_CREDENTIALS_MISSING_ERRORS.NO_AUTHENTICATION_FOR_SERVICE, localeCode)
            },
            serviceDisabledForClient: makeTranslator(KEYS.ERRORS.SERVICE_DISABLED_FOR_CLIENT, localeCode),
            serviceRateLimitError: makeTranslator(KEYS.ERRORS.SERVICE_RATE_LIMIT_ERROR, localeCode),
            stripe: {
                unrecognisedResponse: makeTranslator(KEYS.ERRORS.STRIPE.UNRECOGNISED_RESPONSE, localeCode),
                untranslatedErrorMessage: makeTranslator(KEYS.ERRORS.STRIPE.UNTRANSLATED_ERROR_MESSAGE, localeCode)
            },
            templateCannotBeDownloadedNoPermission: makeTranslator(KEYS.ERRORS.TEMPLATE_CANNOT_BE_DOWNLOADED_NO_PERMISSION, localeCode),
            unauthorizedErrors: {
                pleaseLogin: makeTranslator(KEYS.ERRORS.UNAUTHORIZED_ERRORS.PLEASE_LOGIN, localeCode),
                resource: makeTranslator(KEYS.ERRORS.UNAUTHORIZED_ERRORS.RESOURCE, localeCode)
            },
            unexpectedError: makeTranslator(KEYS.ERRORS.UNEXPECTED_ERROR, localeCode),
            unexpectedInputErrors: {
                facebookPageMigrationIdsNotFound: makeTranslator(KEYS.ERRORS.UNEXPECTED_INPUT_ERRORS.FACEBOOK_PAGE_MIGRATION_IDS_NOT_FOUND, localeCode)
            },
            unsupportedCurrency: makeTranslator(KEYS.ERRORS.UNSUPPORTED_CURRENCY, localeCode),
            unsupportedOperationErrors: {
                accessTokenCannotDetermineAffectedTargetName: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.ACCESS_TOKEN_CANNOT_DETERMINE_AFFECTED_TARGET_NAME, localeCode),
                assignedLocationMapperGivenMultipleLocations: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.ASSIGNED_LOCATION_MAPPER_GIVEN_MULTIPLE_LOCATIONS, localeCode),
                bannerNotificationAlreadyExists: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.BANNER_NOTIFICATION_ALREADY_EXISTS, localeCode),
                controllerMissingValidation: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.CONTROLLER_MISSING_VALIDATION, localeCode),
                facebookApiClientInstanitatedWithoutAFacebookPageId: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID, localeCode),
                facebookMarketingApiClientInstanitatedWithoutAFacebookPageId: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.FACEBOOK_MARKETING_API_CLIENT_INSTANITATED_WITHOUT_A_FACEBOOK_PAGE_ID, localeCode),
                imageFormatConversion: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.IMAGE_FORMAT_CONVERSION, localeCode),
                monthlyRecurringEventsOnly: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.MONTHLY_RECURRING_EVENTS_ONLY, localeCode),
                plannerOperationNotSupported: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.PLANNER_OPERATION_NOT_SUPPORTED, localeCode),
                printProviderSkuMissingQuantityOptions: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.PRINT_PROVIDER_SKU_MISSING_QUANTITY_OPTIONS, localeCode),
                socketServerAlreadyReady: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.SOCKET_SERVER_ALREADY_READY, localeCode),
                unsupportedWindowsTimezone: makeTranslator(KEYS.ERRORS.UNSUPPORTED_OPERATION_ERRORS.UNSUPPORTED_WINDOWS_TIMEZONE, localeCode)
            },
            videoImport: {
                networkError: makeTranslator(KEYS.ERRORS.VIDEO_IMPORT.NETWORK_ERROR, localeCode),
                unknownError: makeTranslator(KEYS.ERRORS.VIDEO_IMPORT.UNKNOWN_ERROR, localeCode),
                unsupportedFileType: makeTranslator(KEYS.ERRORS.VIDEO_IMPORT.UNSUPPORTED_FILE_TYPE, localeCode),
                unsupportedVideoType: makeTranslator(KEYS.ERRORS.VIDEO_IMPORT.UNSUPPORTED_VIDEO_TYPE, localeCode)
            },
            videoPreviewUnsupported: makeTranslator(KEYS.ERRORS.VIDEO_PREVIEW_UNSUPPORTED, localeCode)
        },
        footer: {
            privacyPolicy: makeTranslator(KEYS.FOOTER.PRIVACY_POLICY, localeCode),
            termsAndConditions: makeTranslator(KEYS.FOOTER.TERMS_AND_CONDITIONS, localeCode)
        },
        help: {
            builderKeyboardShortcuts: {
                alignment: {
                    multipleCenterHorizontal: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_HORIZONTAL.WINDOWS, localeCode)
                    },
                    multipleCenterVertical: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_CENTER_VERTICAL.WINDOWS, localeCode)
                    },
                    multipleLeftRight: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_LEFT_RIGHT.WINDOWS, localeCode)
                    },
                    multipleTopBottom: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.MULTIPLE_TOP_BOTTOM.WINDOWS, localeCode)
                    },
                    singleCenterHorizontal: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_HORIZONTAL.WINDOWS, localeCode)
                    },
                    singleCenterVertical: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_CENTER_VERTICAL.WINDOWS, localeCode)
                    },
                    singleLeftRight: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_LEFT_RIGHT.WINDOWS, localeCode)
                    },
                    singleTopBottom: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.SINGLE_TOP_BOTTOM.WINDOWS, localeCode)
                    },
                    title: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.ALIGNMENT.TITLE, localeCode)
                },
                general: {
                    delete: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DELETE.WINDOWS, localeCode)
                    },
                    duplicate: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.DUPLICATE.WINDOWS, localeCode)
                    },
                    multiSelect: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.MULTI_SELECT.WINDOWS, localeCode)
                    },
                    redo: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.REDO.WINDOWS, localeCode)
                    },
                    title: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.TITLE, localeCode),
                    undo: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.GENERAL.UNDO.WINDOWS, localeCode)
                    }
                },
                movement: {
                    arrowLeftRight: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT.WINDOWS, localeCode)
                    },
                    arrowLeftRightModifier: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_LEFT_RIGHT_MODIFIER.WINDOWS, localeCode)
                    },
                    arrowUpDown: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN.WINDOWS, localeCode)
                    },
                    arrowUpDownModifier: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.ARROW_UP_DOWN_MODIFIER.WINDOWS, localeCode)
                    },
                    horizontalLock: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.HORIZONTAL_LOCK.WINDOWS, localeCode)
                    },
                    title: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.TITLE, localeCode),
                    verticalLock: {
                        description: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.DESCRIPTION, localeCode),
                        mac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.MAC, localeCode),
                        windows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MOVEMENT.VERTICAL_LOCK.WINDOWS, localeCode)
                    }
                },
                multipleLayersSelected: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.MULTIPLE_LAYERS_SELECTED, localeCode),
                shortcutMac: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_MAC, localeCode),
                shortcutWindows: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.SHORTCUT_WINDOWS, localeCode),
                title: makeTranslator(KEYS.HELP.BUILDER_KEYBOARD_SHORTCUTS.TITLE, localeCode)
            },
            common: {
                whatCanIDo: makeTranslator(KEYS.HELP.COMMON.WHAT_CAN_I_DO, localeCode),
                whatDoesThisMean: makeTranslator(KEYS.HELP.COMMON.WHAT_DOES_THIS_MEAN, localeCode),
                whyAmISeeingThis: makeTranslator(KEYS.HELP.COMMON.WHY_AM_I_SEEING_THIS, localeCode)
            },
            help: makeTranslator(KEYS.HELP.HELP, localeCode),
            noAssignedLocations: {
                cantUseDigitalStack: makeTranslator(KEYS.HELP.NO_ASSIGNED_LOCATIONS.CANT_USE_DIGITAL_STACK, localeCode),
                contactYourAgency: makeTranslator(KEYS.HELP.NO_ASSIGNED_LOCATIONS.CONTACT_YOUR_AGENCY, localeCode),
                dontHaveLocationsAssigned: makeTranslator(KEYS.HELP.NO_ASSIGNED_LOCATIONS.DONT_HAVE_LOCATIONS_ASSIGNED, localeCode),
                title: makeTranslator(KEYS.HELP.NO_ASSIGNED_LOCATIONS.TITLE, localeCode)
            }
        },
        integration: {
            auth: {
                apiKey: {
                    apiKey: makeTranslator(KEYS.INTEGRATION.AUTH.API_KEY.API_KEY, localeCode),
                    apiKeyRequired: makeTranslator(KEYS.INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED, localeCode),
                    apiKeyRequiredExplain: makeTranslator(KEYS.INTEGRATION.AUTH.API_KEY.API_KEY_REQUIRED_EXPLAIN, localeCode),
                    previousKey: makeTranslator(KEYS.INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY, localeCode),
                    previousKeyExplain: makeTranslator(KEYS.INTEGRATION.AUTH.API_KEY.PREVIOUS_KEY_EXPLAIN, localeCode)
                }
            },
            client: {
                clubReady: {
                    chainId: makeTranslator(KEYS.INTEGRATION.CLIENT.CLUB_READY.CHAIN_ID, localeCode),
                    enterChainId: makeTranslator(KEYS.INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID, localeCode),
                    enterChainIdWithClientTitle: makeTranslator(KEYS.INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_WITH_CLIENT_TITLE, localeCode),
                    enterChainIdExplain: makeTranslator(KEYS.INTEGRATION.CLIENT.CLUB_READY.ENTER_CHAIN_ID_EXPLAIN, localeCode),
                    multipleChainExplain: makeTranslator(KEYS.INTEGRATION.CLIENT.CLUB_READY.MULTIPLE_CHAIN_EXPLAIN, localeCode)
                },
                notifier: {
                    issueWithAccount: makeTranslator(KEYS.INTEGRATION.CLIENT.NOTIFIER.ISSUE_WITH_ACCOUNT, localeCode),
                    resolution1: makeTranslator(KEYS.INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_1, localeCode),
                    resolution2: makeTranslator(KEYS.INTEGRATION.CLIENT.NOTIFIER.RESOLUTION_2, localeCode)
                },
                statusTip: {
                    disable: makeTranslator(KEYS.INTEGRATION.CLIENT.STATUS_TIP.DISABLE, localeCode),
                    edit: makeTranslator(KEYS.INTEGRATION.CLIENT.STATUS_TIP.EDIT, localeCode),
                    enable: makeTranslator(KEYS.INTEGRATION.CLIENT.STATUS_TIP.ENABLE, localeCode)
                }
            },
            configureIntegration: makeTranslator(KEYS.INTEGRATION.CONFIGURE_INTEGRATION, localeCode),
            disableFor: makeTranslator(KEYS.INTEGRATION.DISABLE_FOR, localeCode),
            disabledIntegration: makeTranslator(KEYS.INTEGRATION.DISABLED_INTEGRATION, localeCode),
            editAccountConfiguration: makeTranslator(KEYS.INTEGRATION.EDIT_ACCOUNT_CONFIGURATION, localeCode),
            enableFor: makeTranslator(KEYS.INTEGRATION.ENABLE_FOR, localeCode),
            enabledIntegration: makeTranslator(KEYS.INTEGRATION.ENABLED_INTEGRATION, localeCode),
            errors: {
                genericEnableError: makeTranslator(KEYS.INTEGRATION.ERRORS.GENERIC_ENABLE_ERROR, localeCode)
            },
            fitware: {
                notifyBusinessCleared: makeTranslator(KEYS.INTEGRATION.FITWARE.NOTIFY_BUSINESS_CLEARED, localeCode),
                notifyBusinessSet: makeTranslator(KEYS.INTEGRATION.FITWARE.NOTIFY_BUSINESS_SET, localeCode),
                notifyClubUpdated: makeTranslator(KEYS.INTEGRATION.FITWARE.NOTIFY_CLUB_UPDATED, localeCode)
            },
            integrationConfiguration: makeTranslator(KEYS.INTEGRATION.INTEGRATION_CONFIGURATION, localeCode),
            integrations: makeTranslator(KEYS.INTEGRATION.INTEGRATIONS, localeCode),
            location: {
                clubReady: {
                    clubId: makeTranslator(KEYS.INTEGRATION.LOCATION.CLUB_READY.CLUB_ID, localeCode),
                    clubReadyConfiguration: makeTranslator(KEYS.INTEGRATION.LOCATION.CLUB_READY.CLUB_READY_CONFIGURATION, localeCode),
                    configureSuccess: makeTranslator(KEYS.INTEGRATION.LOCATION.CLUB_READY.CONFIGURE_SUCCESS, localeCode),
                    enterClubId: makeTranslator(KEYS.INTEGRATION.LOCATION.CLUB_READY.ENTER_CLUB_ID, localeCode)
                },
                noIntegrationsToConfigure: {
                    explain: makeTranslator(KEYS.INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.EXPLAIN, localeCode),
                    resolve: makeTranslator(KEYS.INTEGRATION.LOCATION.NO_INTEGRATIONS_TO_CONFIGURE.RESOLVE, localeCode)
                }
            },
            notifyAccessCheckFailed: makeTranslator(KEYS.INTEGRATION.NOTIFY_ACCESS_CHECK_FAILED, localeCode),
            notifyCouldNotAuthorizeService: makeTranslator(KEYS.INTEGRATION.NOTIFY_COULD_NOT_AUTHORIZE_SERVICE, localeCode),
            notifyCouldNotDeauthorizeService: makeTranslator(KEYS.INTEGRATION.NOTIFY_COULD_NOT_DEAUTHORIZE_SERVICE, localeCode),
            notifyServiceDeauthorized: makeTranslator(KEYS.INTEGRATION.NOTIFY_SERVICE_DEAUTHORIZED, localeCode),
            promptConnectToGoogleAdsDialog: {
                promptText: makeTranslator(KEYS.INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.PROMPT_TEXT, localeCode),
                signInText: makeTranslator(KEYS.INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.SIGN_IN_TEXT, localeCode),
                title: makeTranslator(KEYS.INTEGRATION.PROMPT_CONNECT_TO_GOOGLE_ADS_DIALOG.TITLE, localeCode)
            },
            setupIntegrationsFor: makeTranslator(KEYS.INTEGRATION.SETUP_INTEGRATIONS_FOR, localeCode)
        },
        intro: {
            account: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.ACCOUNT.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.ACCOUNT.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.ACCOUNT.COMPLETE.TIP, localeCode)
                },
                page: {
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.ACCOUNT.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.ACCOUNT.PAGE.ONE.STEP.ONE, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.ACCOUNT.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.ACCOUNT.PAGE.TWO.STEP.ONE, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.ACCOUNT.TITLE, localeCode)
            },
            alreadyKnowHowThisWorks: makeTranslator(KEYS.INTRO.ALREADY_KNOW_HOW_THIS_WORKS, localeCode),
            apps: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.APPS.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.APPS.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.APPS.COMPLETE.TIP, localeCode)
                },
                page: {
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.APPS.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.APPS.PAGE.ONE.STEP.ONE, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.APPS.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.APPS.PAGE.TWO.STEP.ONE, localeCode),
                            two: makeTranslator(KEYS.INTRO.APPS.PAGE.TWO.STEP.TWO, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.APPS.TITLE, localeCode)
            },
            build: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.BUILD.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.BUILD.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.BUILD.COMPLETE.TIP, localeCode)
                },
                page: {
                    five: {
                        doneLabel: makeTranslator(KEYS.INTRO.BUILD.PAGE.FIVE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.BUILD.PAGE.FIVE.STEP.ONE, localeCode),
                            three: makeTranslator(KEYS.INTRO.BUILD.PAGE.FIVE.STEP.THREE, localeCode),
                            two: makeTranslator(KEYS.INTRO.BUILD.PAGE.FIVE.STEP.TWO, localeCode)
                        }
                    },
                    four: {
                        doneLabel: makeTranslator(KEYS.INTRO.BUILD.PAGE.FOUR.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.BUILD.PAGE.FOUR.STEP.ONE, localeCode),
                            three: makeTranslator(KEYS.INTRO.BUILD.PAGE.FOUR.STEP.THREE, localeCode),
                            two: makeTranslator(KEYS.INTRO.BUILD.PAGE.FOUR.STEP.TWO, localeCode)
                        }
                    },
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.BUILD.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.BUILD.PAGE.ONE.STEP.ONE, localeCode),
                            two: makeTranslator(KEYS.INTRO.BUILD.PAGE.ONE.STEP.TWO, localeCode)
                        }
                    },
                    three: {
                        doneLabel: makeTranslator(KEYS.INTRO.BUILD.PAGE.THREE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.BUILD.PAGE.THREE.STEP.ONE, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.BUILD.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.BUILD.PAGE.TWO.STEP.ONE, localeCode),
                            two: makeTranslator(KEYS.INTRO.BUILD.PAGE.TWO.STEP.TWO, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.BUILD.TITLE, localeCode)
            },
            cancelTourMessage: makeTranslator(KEYS.INTRO.CANCEL_TOUR_MESSAGE, localeCode),
            cancelTourTitle: makeTranslator(KEYS.INTRO.CANCEL_TOUR_TITLE, localeCode),
            completeTheTour: makeTranslator(KEYS.INTRO.COMPLETE_THE_TOUR, localeCode),
            completeTheseItemsLater: makeTranslator(KEYS.INTRO.COMPLETE_THESE_ITEMS_LATER, localeCode),
            completedAllTheItems: makeTranslator(KEYS.INTRO.COMPLETED_ALL_THE_ITEMS, localeCode),
            congratulations: makeTranslator(KEYS.INTRO.CONGRATULATIONS, localeCode),
            doneLabel: makeTranslator(KEYS.INTRO.DONE_LABEL, localeCode),
            examplePlannerTitle: makeTranslator(KEYS.INTRO.EXAMPLE_PLANNER_TITLE, localeCode),
            exampleTemplateTitle: makeTranslator(KEYS.INTRO.EXAMPLE_TEMPLATE_TITLE, localeCode),
            findOutWhat: makeTranslator(KEYS.INTRO.FIND_OUT_WHAT, localeCode),
            helpUsMake: makeTranslator(KEYS.INTRO.HELP_US_MAKE, localeCode),
            imReady: makeTranslator(KEYS.INTRO.IM_READY, localeCode),
            itLooksLikeYoureNew: makeTranslator(KEYS.INTRO.IT_LOOKS_LIKE_YOURE_NEW, localeCode),
            learn: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.LEARN.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.LEARN.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.LEARN.COMPLETE.TIP, localeCode)
                },
                page: {
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.LEARN.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.LEARN.PAGE.ONE.STEP.ONE, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.LEARN.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.LEARN.PAGE.TWO.STEP.ONE, localeCode),
                            two: makeTranslator(KEYS.INTRO.LEARN.PAGE.TWO.STEP.TWO, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.LEARN.TITLE, localeCode)
            },
            letMeDoItSomeMore: makeTranslator(KEYS.INTRO.LET_ME_DO_IT_SOME_MORE, localeCode),
            letsContinue: makeTranslator(KEYS.INTRO.LETS_CONTINUE, localeCode),
            mostPeopleAreSurprised: makeTranslator(KEYS.INTRO.MOST_PEOPLE_ARE_SURPRISED, localeCode),
            notifyPostponeTour: makeTranslator(KEYS.INTRO.NOTIFY_POSTPONE_TOUR, localeCode),
            notifyStopTour: makeTranslator(KEYS.INTRO.NOTIFY_STOP_TOUR, localeCode),
            okThatMakesSense: makeTranslator(KEYS.INTRO.OK_THAT_MAKES_SENSE, localeCode),
            plan: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.PLAN.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.PLAN.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.PLAN.COMPLETE.TIP, localeCode)
                },
                page: {
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.PLAN.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.PLAN.PAGE.ONE.STEP.ONE, localeCode)
                        }
                    },
                    three: {
                        doneLabel: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.DONE_LABEL, localeCode),
                        step: {
                            five: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.FIVE, localeCode),
                            four: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.FOUR, localeCode),
                            one: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.ONE, localeCode),
                            seven: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.SEVEN, localeCode),
                            six: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.SIX, localeCode),
                            three: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.THREE, localeCode),
                            two: makeTranslator(KEYS.INTRO.PLAN.PAGE.THREE.STEP.TWO, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            eight: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.EIGHT, localeCode),
                            five: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.FIVE, localeCode),
                            four: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.FOUR, localeCode),
                            one: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.ONE, localeCode),
                            seven: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.SEVEN, localeCode),
                            six: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.SIX, localeCode),
                            three: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.THREE, localeCode),
                            two: makeTranslator(KEYS.INTRO.PLAN.PAGE.TWO.STEP.TWO, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.PLAN.TITLE, localeCode)
            },
            pleaseAcceptThis: makeTranslator(KEYS.INTRO.PLEASE_ACCEPT_THIS, localeCode),
            quickTip: makeTranslator(KEYS.INTRO.QUICK_TIP, localeCode),
            report: {
                complete: {
                    heading: makeTranslator(KEYS.INTRO.REPORT.COMPLETE.HEADING, localeCode),
                    subheading: makeTranslator(KEYS.INTRO.REPORT.COMPLETE.SUBHEADING, localeCode),
                    tip: makeTranslator(KEYS.INTRO.REPORT.COMPLETE.TIP, localeCode)
                },
                page: {
                    one: {
                        doneLabel: makeTranslator(KEYS.INTRO.REPORT.PAGE.ONE.DONE_LABEL, localeCode),
                        step: {
                            one: makeTranslator(KEYS.INTRO.REPORT.PAGE.ONE.STEP.ONE, localeCode)
                        }
                    },
                    two: {
                        doneLabel: makeTranslator(KEYS.INTRO.REPORT.PAGE.TWO.DONE_LABEL, localeCode),
                        step: {
                            four: makeTranslator(KEYS.INTRO.REPORT.PAGE.TWO.STEP.FOUR, localeCode),
                            one: makeTranslator(KEYS.INTRO.REPORT.PAGE.TWO.STEP.ONE, localeCode),
                            three: makeTranslator(KEYS.INTRO.REPORT.PAGE.TWO.STEP.THREE, localeCode),
                            two: makeTranslator(KEYS.INTRO.REPORT.PAGE.TWO.STEP.TWO, localeCode)
                        }
                    }
                },
                title: makeTranslator(KEYS.INTRO.REPORT.TITLE, localeCode)
            },
            resetAll: makeTranslator(KEYS.INTRO.RESET_ALL, localeCode),
            showMe: makeTranslator(KEYS.INTRO.SHOW_ME, localeCode),
            showMeCompleted: makeTranslator(KEYS.INTRO.SHOW_ME_COMPLETED, localeCode),
            skipLabel: makeTranslator(KEYS.INTRO.SKIP_LABEL, localeCode),
            tickOffTheItemsBelow: makeTranslator(KEYS.INTRO.TICK_OFF_THE_ITEMS_BELOW, localeCode),
            video: {
                title: makeTranslator(KEYS.INTRO.VIDEO.TITLE, localeCode)
            },
            welcomeToDigitalStack: makeTranslator(KEYS.INTRO.WELCOME_TO_DIGITAL_STACK, localeCode),
            youreReadyForTheStack: makeTranslator(KEYS.INTRO.YOURE_READY_FOR_THE_STACK, localeCode),
            youveGotThroughThemAll: makeTranslator(KEYS.INTRO.YOUVE_GOT_THROUGH_THEM_ALL, localeCode)
        },
        learn: {
            addNewItem: makeTranslator(KEYS.LEARN.ADD_NEW_ITEM, localeCode),
            addNewLearnItem: makeTranslator(KEYS.LEARN.ADD_NEW_LEARN_ITEM, localeCode),
            applicationWide: makeTranslator(KEYS.LEARN.APPLICATION_WIDE, localeCode),
            deleteConfirm: makeTranslator(KEYS.LEARN.DELETE_CONFIRM, localeCode),
            editItem: makeTranslator(KEYS.LEARN.EDIT_ITEM, localeCode),
            editLearnItem: makeTranslator(KEYS.LEARN.EDIT_LEARN_ITEM, localeCode),
            email: {
                commentAddedToLearnArticle: makeTranslator(KEYS.LEARN.EMAIL.COMMENT_ADDED_TO_LEARN_ARTICLE, localeCode),
                viewLearnArticle: makeTranslator(KEYS.LEARN.EMAIL.VIEW_LEARN_ARTICLE, localeCode)
            },
            helpful: makeTranslator(KEYS.LEARN.HELPFUL, localeCode),
            loading: makeTranslator(KEYS.LEARN.LOADING, localeCode),
            maxUploadError: makeTranslator(KEYS.LEARN.MAX_UPLOAD_ERROR, localeCode),
            noArticles: makeTranslator(KEYS.LEARN.NO_ARTICLES, localeCode),
            noLearnAvailable: makeTranslator(KEYS.LEARN.NO_LEARN_AVAILABLE, localeCode),
            notifyLearnCreated: makeTranslator(KEYS.LEARN.NOTIFY_LEARN_CREATED, localeCode),
            notifyLearnUpdated: makeTranslator(KEYS.LEARN.NOTIFY_LEARN_UPDATED, localeCode),
            recentArticles: makeTranslator(KEYS.LEARN.RECENT_ARTICLES, localeCode),
            retrieveAllLearnArticles: makeTranslator(KEYS.LEARN.RETRIEVE_ALL_LEARN_ARTICLES, localeCode),
            retrieveMoreLearnArticles: makeTranslator(KEYS.LEARN.RETRIEVE_MORE_LEARN_ARTICLES, localeCode),
            tagName: makeTranslator(KEYS.LEARN.TAG_NAME, localeCode),
            thanksFeedback: makeTranslator(KEYS.LEARN.THANKS_FEEDBACK, localeCode),
            thumbnail: {
                createVideoThumbnail: makeTranslator(KEYS.LEARN.THUMBNAIL.CREATE_VIDEO_THUMBNAIL, localeCode),
                generateFromVideo: makeTranslator(KEYS.LEARN.THUMBNAIL.GENERATE_FROM_VIDEO, localeCode),
                sliderHelp: makeTranslator(KEYS.LEARN.THUMBNAIL.SLIDER_HELP, localeCode),
                uploadCustom: makeTranslator(KEYS.LEARN.THUMBNAIL.UPLOAD_CUSTOM, localeCode),
                uploadNewThumbnail: makeTranslator(KEYS.LEARN.THUMBNAIL.UPLOAD_NEW_THUMBNAIL, localeCode)
            },
            tryThisDeleted: makeTranslator(KEYS.LEARN.TRY_THIS_DELETED, localeCode)
        },
        login: {
            email: {
                invite: {
                    clickButtonToLogIn: makeTranslator(KEYS.LOGIN.EMAIL.INVITE.CLICK_BUTTON_TO_LOG_IN, localeCode),
                    logIntoDigitalStack: makeTranslator(KEYS.LOGIN.EMAIL.INVITE.LOG_INTO_DIGITAL_STACK, localeCode),
                    youHaveBeenInvited: makeTranslator(KEYS.LOGIN.EMAIL.INVITE.YOU_HAVE_BEEN_INVITED, localeCode)
                },
                resetPassword: {
                    ifYouDidNotRequestThis: makeTranslator(KEYS.LOGIN.EMAIL.RESET_PASSWORD.IF_YOU_DID_NOT_REQUEST_THIS, localeCode),
                    passwordResetInstructions: makeTranslator(KEYS.LOGIN.EMAIL.RESET_PASSWORD.PASSWORD_RESET_INSTRUCTIONS, localeCode),
                    resetMyPassword: makeTranslator(KEYS.LOGIN.EMAIL.RESET_PASSWORD.RESET_MY_PASSWORD, localeCode),
                    someoneRequestedToResetPassword: makeTranslator(KEYS.LOGIN.EMAIL.RESET_PASSWORD.SOMEONE_REQUESTED_TO_RESET_PASSWORD, localeCode),
                    toResetClickLink: makeTranslator(KEYS.LOGIN.EMAIL.RESET_PASSWORD.TO_RESET_CLICK_LINK, localeCode)
                },
                welcomeToDigitalStack: makeTranslator(KEYS.LOGIN.EMAIL.WELCOME_TO_DIGITAL_STACK, localeCode)
            },
            errorSendingPasswordResetInstructions: makeTranslator(KEYS.LOGIN.ERROR_SENDING_PASSWORD_RESET_INSTRUCTIONS, localeCode),
            forgotPassword: makeTranslator(KEYS.LOGIN.FORGOT_PASSWORD, localeCode),
            forgottenPassword: makeTranslator(KEYS.LOGIN.FORGOTTEN_PASSWORD, localeCode),
            invalidEmailAddress: makeTranslator(KEYS.LOGIN.INVALID_EMAIL_ADDRESS, localeCode),
            login: makeTranslator(KEYS.LOGIN.LOGIN, localeCode),
            loginConfirmIdentity: makeTranslator(KEYS.LOGIN.LOGIN_CONFIRM_IDENTITY, localeCode),
            loginToLinkAccounts: makeTranslator(KEYS.LOGIN.LOGIN_TO_LINK_ACCOUNTS, localeCode),
            password: makeTranslator(KEYS.LOGIN.PASSWORD, localeCode),
            passwordAgain: makeTranslator(KEYS.LOGIN.PASSWORD_AGAIN, localeCode),
            passwordResetFailed: makeTranslator(KEYS.LOGIN.PASSWORD_RESET_FAILED, localeCode),
            passwordResetInstructions: makeTranslator(KEYS.LOGIN.PASSWORD_RESET_INSTRUCTIONS, localeCode),
            passwordResetInstructionsSent: makeTranslator(KEYS.LOGIN.PASSWORD_RESET_INSTRUCTIONS_SENT, localeCode),
            passwordResetPleaseLogin: makeTranslator(KEYS.LOGIN.PASSWORD_RESET_PLEASE_LOGIN, localeCode),
            passwordTooShort: makeTranslator(KEYS.LOGIN.PASSWORD_TOO_SHORT, localeCode),
            passwordTooShortPlural: makeTranslator(KEYS.LOGIN.PASSWORD_TOO_SHORT_plural, localeCode),
            passwordsDontMatch: makeTranslator(KEYS.LOGIN.PASSWORDS_DONT_MATCH, localeCode),
            problemWithInviteLink: makeTranslator(KEYS.LOGIN.PROBLEM_WITH_INVITE_LINK, localeCode),
            problemWithLink: makeTranslator(KEYS.LOGIN.PROBLEM_WITH_LINK, localeCode),
            requestPasswordReset: makeTranslator(KEYS.LOGIN.REQUEST_PASSWORD_RESET, localeCode),
            resetPassword: makeTranslator(KEYS.LOGIN.RESET_PASSWORD, localeCode),
            sendPasswordReset: makeTranslator(KEYS.LOGIN.SEND_PASSWORD_RESET, localeCode),
            sendPasswordResetEmailConfirmationModal: {
                body: makeTranslator(KEYS.LOGIN.SEND_PASSWORD_RESET_EMAIL_CONFIRMATION_MODAL.BODY, localeCode)
            },
            signedInAs: makeTranslator(KEYS.LOGIN.SIGNED_IN_AS, localeCode),
            signedOut: makeTranslator(KEYS.LOGIN.SIGNED_OUT, localeCode),
            username: makeTranslator(KEYS.LOGIN.USERNAME, localeCode),
            usernamePasswordIncorrectError: makeTranslator(KEYS.LOGIN.USERNAME_PASSWORD_INCORRECT_ERROR, localeCode),
            welcomeToDigitalStack: makeTranslator(KEYS.LOGIN.WELCOME_TO_DIGITAL_STACK, localeCode),
            youWillReceivePasswordResetInstructionsShortly: makeTranslator(KEYS.LOGIN.YOU_WILL_RECEIVE_PASSWORD_RESET_INSTRUCTIONS_SHORTLY, localeCode)
        },
        marketing: {
            emails: {
                weeklyMarketingUpdate: {
                    completeMyMonthPlanner: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COMPLETE_MY_MONTH_PLANNER, localeCode),
                    countActivitiesAwaitingContent: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT, localeCode),
                    countActivitiesAwaitingContentPlural: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_AWAITING_CONTENT_plural, localeCode),
                    countActivitiesPlanned: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED, localeCode),
                    countActivitiesPlannedPlural: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.COUNT_ACTIVITIES_PLANNED_plural, localeCode),
                    findYourUpdateBelow: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW, localeCode),
                    findYourUpdateBelowMultipleLocations: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.FIND_YOUR_UPDATE_BELOW_MULTIPLE_LOCATIONS, localeCode),
                    getOnTopOfYourPlanningForMonth: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.GET_ON_TOP_OF_YOUR_PLANNING_FOR_MONTH, localeCode),
                    locationForMonth: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.LOCATION_FOR_MONTH, localeCode),
                    noActivitiesPlanned: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.NO_ACTIVITIES_PLANNED, localeCode),
                    viewMyMonthPlanner: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.VIEW_MY_MONTH_PLANNER, localeCode),
                    weeklyMarketingUpdate: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WEEKLY_MARKETING_UPDATE, localeCode),
                    whatsOnThisWeekAtLocation: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.WHATS_ON_THIS_WEEK_AT_LOCATION, localeCode),
                    yourWeeklyUpdate: makeTranslator(KEYS.MARKETING.EMAILS.WEEKLY_MARKETING_UPDATE.YOUR_WEEKLY_UPDATE, localeCode)
                }
            }
        },
        menu: {
            account: makeTranslator(KEYS.MENU.ACCOUNT, localeCode),
            admin: makeTranslator(KEYS.MENU.ADMIN, localeCode),
            agencies: makeTranslator(KEYS.MENU.AGENCIES, localeCode),
            agency: makeTranslator(KEYS.MENU.AGENCY, localeCode),
            assets: makeTranslator(KEYS.MENU.ASSETS, localeCode),
            brand: makeTranslator(KEYS.MENU.BRAND, localeCode),
            brands: makeTranslator(KEYS.MENU.BRANDS, localeCode),
            brandSettings: makeTranslator(KEYS.MENU.BRAND_SETTINGS, localeCode),
            build: makeTranslator(KEYS.MENU.BUILD, localeCode),
            calendar: makeTranslator(KEYS.MENU.CALENDAR, localeCode),
            calendarActivities: makeTranslator(KEYS.MENU.CALENDAR_ACTIVITIES, localeCode),
            clients: makeTranslator(KEYS.MENU.CLIENTS, localeCode),
            closeNavigation: makeTranslator(KEYS.MENU.CLOSE_NAVIGATION, localeCode),
            colors: makeTranslator(KEYS.MENU.COLORS, localeCode),
            communicate: makeTranslator(KEYS.MENU.COMMUNICATE, localeCode),
            connect: makeTranslator(KEYS.MENU.CONNECT, localeCode),
            connections: makeTranslator(KEYS.MENU.CONNECTIONS, localeCode),
            fonts: makeTranslator(KEYS.MENU.FONTS, localeCode),
            hashtagSets: makeTranslator(KEYS.MENU.HASHTAG_SETS, localeCode),
            help: makeTranslator(KEYS.MENU.HELP, localeCode),
            integrations: makeTranslator(KEYS.MENU.INTEGRATIONS, localeCode),
            learn: makeTranslator(KEYS.MENU.LEARN, localeCode),
            learnMenu: makeTranslator(KEYS.MENU.LEARN_MENU, localeCode),
            location: makeTranslator(KEYS.MENU.LOCATION, localeCode),
            locations: makeTranslator(KEYS.MENU.LOCATIONS, localeCode),
            locationActivity: makeTranslator(KEYS.MENU.LOCATION_ACTIVITY, localeCode),
            locationDetails: makeTranslator(KEYS.MENU.LOCATION_DETAILS, localeCode),
            locationUsers: makeTranslator(KEYS.MENU.LOCATION_USERS, localeCode),
            mainNavigation: makeTranslator(KEYS.MENU.MAIN_NAVIGATION, localeCode),
            markAllAsRead: makeTranslator(KEYS.MENU.MARK_ALL_AS_READ, localeCode),
            more: makeTranslator(KEYS.MENU.MORE, localeCode),
            notifications: makeTranslator(KEYS.MENU.NOTIFICATIONS, localeCode),
            notificationCouldNotBeMarkedAsRead: makeTranslator(KEYS.MENU.NOTIFICATION_COULD_NOT_BE_MARKED_AS_READ, localeCode),
            openNavigation: makeTranslator(KEYS.MENU.OPEN_NAVIGATION, localeCode),
            overview: makeTranslator(KEYS.MENU.OVERVIEW, localeCode),
            payments: makeTranslator(KEYS.MENU.PAYMENTS, localeCode),
            performance: makeTranslator(KEYS.MENU.PERFORMANCE, localeCode),
            plan: makeTranslator(KEYS.MENU.PLAN, localeCode),
            platforms: makeTranslator(KEYS.MENU.PLATFORMS, localeCode),
            profile: makeTranslator(KEYS.MENU.PROFILE, localeCode),
            regionsGroups: makeTranslator(KEYS.MENU.REGIONS_GROUPS, localeCode),
            regionGroupActivity: makeTranslator(KEYS.MENU.REGION_GROUP_ACTIVITY, localeCode),
            report: makeTranslator(KEYS.MENU.REPORT, localeCode),
            reporting: makeTranslator(KEYS.MENU.REPORTING, localeCode),
            requests: makeTranslator(KEYS.MENU.REQUESTS, localeCode),
            roadmap: makeTranslator(KEYS.MENU.ROADMAP, localeCode),
            scheduled: makeTranslator(KEYS.MENU.SCHEDULED, localeCode),
            send: makeTranslator(KEYS.MENU.SEND, localeCode),
            signOut: makeTranslator(KEYS.MENU.SIGN_OUT, localeCode),
            specialRequests: makeTranslator(KEYS.MENU.SPECIAL_REQUESTS, localeCode),
            styles: makeTranslator(KEYS.MENU.STYLES, localeCode),
            styleGuide: makeTranslator(KEYS.MENU.STYLE_GUIDE, localeCode),
            templates: makeTranslator(KEYS.MENU.TEMPLATES, localeCode),
            templateCategories: makeTranslator(KEYS.MENU.TEMPLATE_CATEGORIES, localeCode),
            templateUse: makeTranslator(KEYS.MENU.TEMPLATE_USE, localeCode),
            viewAllNotifications: makeTranslator(KEYS.MENU.VIEW_ALL_NOTIFICATIONS, localeCode),
            youHaveNoUnreadNotifications: makeTranslator(KEYS.MENU.YOU_HAVE_NO_UNREAD_NOTIFICATIONS, localeCode)
        },
        notifications: {
            badger: {
                markAllAsRead: makeTranslator(KEYS.NOTIFICATIONS.BADGER.MARK_ALL_AS_READ, localeCode),
                noUnreadNotifications: makeTranslator(KEYS.NOTIFICATIONS.BADGER.NO_UNREAD_NOTIFICATIONS, localeCode),
                viewAll: makeTranslator(KEYS.NOTIFICATIONS.BADGER.VIEW_ALL, localeCode)
            },
            callToActionButtonLabels: {
                openLink: makeTranslator(KEYS.NOTIFICATIONS.CALL_TO_ACTION_BUTTON_LABELS.OPEN_LINK, localeCode)
            },
            list: {
                noNotifications: makeTranslator(KEYS.NOTIFICATIONS.LIST.NO_NOTIFICATIONS, localeCode)
            },
            messages: {
                customAgencyMessage: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.CUSTOM_AGENCY_MESSAGE, localeCode),
                emailScheduleFailed: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULE_FAILED, localeCode),
                emailScheduled: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.EMAIL_SCHEDULED, localeCode),
                imagePublishFailed: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED, localeCode),
                imagePublishFailedNoError: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.IMAGE_PUBLISH_FAILED_NO_ERROR, localeCode),
                integrationConnectivityFailure: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.INTEGRATION_CONNECTIVITY_FAILURE, localeCode),
                integrationConfigurationMisconfigured: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.INTEGRATION_CONFIGURATION_MISCONFIGURED, localeCode),
                locationMapGenerated: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATED, localeCode),
                locationMapGenerationFailed: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.LOCATION_MAP_GENERATION_FAILED, localeCode),
                mediaTemplateReadyForDownload: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_READY_FOR_DOWNLOAD, localeCode),
                mediaTemplateTimeToSchedule: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.MEDIA_TEMPLATE_TIME_TO_SCHEDULE, localeCode),
                scheduledPosts: {
                    noNotifiableDevices: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.SCHEDULED_POSTS.NO_NOTIFIABLE_DEVICES, localeCode)
                },
                test: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.TEST, localeCode),
                videoPublishFailed: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_PUBLISH_FAILED, localeCode),
                videoPublishedExternally: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY, localeCode),
                videoPublishedExternallyV2: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_EXTERNALLY_V2, localeCode),
                videoPublishedLocally: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_PUBLISHED_LOCALLY, localeCode),
                videoScheduledExternally: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY, localeCode),
                videoScheduledExternallyV2: makeTranslator(KEYS.NOTIFICATIONS.MESSAGES.VIDEO_SCHEDULED_EXTERNALLY_V2, localeCode)
            },
            sendNotificationWizard: {
                common: {
                    emailNotification: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.EMAIL_NOTIFICATION, localeCode),
                    notificationType: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.NOTIFICATION_TYPE, localeCode),
                    pushNotification: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMMON.PUSH_NOTIFICATION, localeCode)
                },
                compose: {
                    email: {
                        ctaButton: {
                            label: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LABEL, localeCode),
                            link: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.CTA_BUTTON.LINK, localeCode)
                        },
                        editorButtons: {
                            alignCenter: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_CENTER, localeCode),
                            alignLeft: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_LEFT, localeCode),
                            alignRight: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ALIGN_RIGHT, localeCode),
                            bold: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BOLD, localeCode),
                            bulletedList: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.BULLETED_LIST, localeCode),
                            headingNum: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.HEADING_NUM, localeCode),
                            image: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.IMAGE, localeCode),
                            italics: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.ITALICS, localeCode),
                            numberedList: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EDITOR_BUTTONS.NUMBERED_LIST, localeCode)
                        },
                        emailContent: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.EMAIL_CONTENT, localeCode),
                        errors: {
                            bannerImageRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.BANNER_IMAGE_REQUIRED, localeCode),
                            ctaLabelRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LABEL_REQUIRED, localeCode),
                            ctaLinkRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.CTA_LINK_REQUIRED, localeCode),
                            fromEmailAddressRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_EMAIL_ADDRESS_REQUIRED, localeCode),
                            fromNameRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.FROM_NAME_REQUIRED, localeCode),
                            shouldSaveBannerSectionNameRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_BANNER_SECTION_NAME_REQUIRED, localeCode),
                            shouldSaveFooterSectionNameRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SHOULD_SAVE_FOOTER_SECTION_NAME_REQUIRED, localeCode),
                            subjectRequired: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.ERRORS.SUBJECT_REQUIRED, localeCode)
                        },
                        inputLabels: {
                            bannerImageSwitch: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH, localeCode),
                            bannerImageSwitchImage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_IMAGE, localeCode),
                            bannerImageSwitchLogo: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_LOGO, localeCode),
                            bannerImageSwitchNone: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_NONE, localeCode),
                            bannerImageSwitchSaved: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.BANNER_IMAGE_SWITCH_SAVED, localeCode),
                            footerContent: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_CONTENT, localeCode),
                            footerSwitch: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH, localeCode),
                            footerSwitchExisting: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_EXISTING, localeCode),
                            footerSwitchNew: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NEW, localeCode),
                            footerSwitchNone: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FOOTER_SWITCH_NONE, localeCode),
                            fromAddress: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS, localeCode),
                            fromAddressSwitchCustom: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_CUSTOM, localeCode),
                            fromAddressSwitchDefault: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_ADDRESS_SWITCH_DEFAULT, localeCode),
                            fromEmailAddress: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_EMAIL_ADDRESS, localeCode),
                            fromName: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.FROM_NAME, localeCode),
                            logo: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.LOGO, localeCode),
                            savedEmailPartBannerSelect: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_BANNER_SELECT, localeCode),
                            savedEmailPartFooterSelect: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SAVED_EMAIL_PART_FOOTER_SELECT, localeCode),
                            shouldSaveBannerSection: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION, localeCode),
                            shouldSaveBannerSectionName: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_BANNER_SECTION_NAME, localeCode),
                            shouldSaveFooterSection: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION, localeCode),
                            shouldSaveFooterSectionName: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.INPUT_LABELS.SHOULD_SAVE_FOOTER_SECTION_NAME, localeCode)
                        },
                        placeholders: {
                            shouldSaveBannerSectionName: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_BANNER_SECTION_NAME, localeCode),
                            shouldSaveFooterSectionName: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.PLACEHOLDERS.SHOULD_SAVE_FOOTER_SECTION_NAME, localeCode)
                        },
                        sectionSaveAgencyNote: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_AGENCY_NOTE, localeCode),
                        sectionSaveBrandNote: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.EMAIL.SECTION_SAVE_BRAND_NOTE, localeCode)
                    },
                    push: {
                        inputLabels: {
                            link: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.LINK, localeCode),
                            message: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.MESSAGE, localeCode),
                            optional: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.OPTIONAL, localeCode),
                            subject: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.INPUT_LABELS.SUBJECT, localeCode)
                        },
                        preview: {
                            notification: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.NOTIFICATION, localeCode),
                            openLink: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.COMPOSE.PUSH.PREVIEW.OPEN_LINK, localeCode)
                        }
                    }
                },
                confirmForm: {
                    confirmCopy: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.CONFIRM_COPY, localeCode),
                    description: {
                        lineOne: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_ONE, localeCode),
                        lineTwo: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.DESCRIPTION.LINE_TWO, localeCode)
                    },
                    formLabels: {
                        clientCountTextLocation: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATION, localeCode),
                        clientCountTextLocations: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.CLIENT_COUNT_TEXT_LOCATIONS, localeCode),
                        immediately: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.IMMEDIATELY, localeCode),
                        notificationType: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.NOTIFICATION_TYPE, localeCode),
                        totalRecipients: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.TOTAL_RECIPIENTS, localeCode),
                        userFilter: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.FORM_LABELS.USER_FILTER, localeCode)
                    },
                    sendNotification: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_NOTIFICATION, localeCode),
                    sendTestEmail: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.CONFIRM_FORM.SEND_TEST_EMAIL, localeCode)
                },
                notificationError: {
                    emailMessage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_MESSAGE, localeCode),
                    emailPreviewMessage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_ERROR.EMAIL_PREVIEW_MESSAGE, localeCode)
                },
                notificationSuccess: {
                    emailDescription: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_DESCRIPTION, localeCode),
                    emailMessage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_MESSAGE, localeCode),
                    emailPreviewMessage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.EMAIL_PREVIEW_MESSAGE, localeCode),
                    pushDescription: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_DESCRIPTION, localeCode),
                    pushMessage: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.PUSH_MESSAGE, localeCode),
                    sendAnother: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_SUCCESS.SEND_ANOTHER, localeCode)
                },
                notificationTypeSelector: {
                    buttons: {
                        email: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.EMAIL, localeCode),
                        push: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.NOTIFICATION_TYPE_SELECTOR.BUTTONS.PUSH, localeCode)
                    }
                },
                pickLocations: {
                    currentlySelected: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.CURRENTLY_SELECTED, localeCode),
                    description: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.DESCRIPTION, localeCode),
                    errors: {
                        titleFilterInvalidEntries: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.ERRORS.TITLE_FILTER_INVALID_ENTRIES, localeCode)
                    },
                    headers: {
                        filterByTitle: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.HEADERS.FILTER_BY_TITLE, localeCode)
                    },
                    labels: {
                        filterByTitles: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_BY_TITLES, localeCode),
                        filterSwitchAllUsers: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_ALL_USERS, localeCode),
                        filterSwitchFilterByTitle: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.FILTER_SWITCH_FILTER_BY_TITLE, localeCode),
                        totalRecipients: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.PICK_LOCATIONS.LABELS.TOTAL_RECIPIENTS, localeCode)
                    }
                },
                steps: {
                    compose: {
                        headingText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.HEADING_TEXT, localeCode),
                        stepperText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.COMPOSE.STEPPER_TEXT, localeCode)
                    },
                    notificationType: {
                        headingText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.HEADING_TEXT, localeCode),
                        stepperText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.NOTIFICATION_TYPE.STEPPER_TEXT, localeCode)
                    },
                    review: {
                        headingText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.HEADING_TEXT, localeCode),
                        stepperText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.REVIEW.STEPPER_TEXT, localeCode)
                    },
                    selectLocations: {
                        headingText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.HEADING_TEXT, localeCode),
                        stepperText: makeTranslator(KEYS.NOTIFICATIONS.SEND_NOTIFICATION_WIZARD.STEPS.SELECT_LOCATIONS.STEPPER_TEXT, localeCode)
                    }
                }
            },
            subjects: {
                customAgencyMessage: makeTranslator(KEYS.NOTIFICATIONS.SUBJECTS.CUSTOM_AGENCY_MESSAGE, localeCode)
            }
        },
        overview: {
            allEvents: makeTranslator(KEYS.OVERVIEW.ALL_EVENTS, localeCode),
            bulkActions: makeTranslator(KEYS.OVERVIEW.BULK_ACTIONS, localeCode),
            confirmPlannerEvents: makeTranslator(KEYS.OVERVIEW.CONFIRM_PLANNER_EVENTS, localeCode),
            deleteAllPlannerEvents: makeTranslator(KEYS.OVERVIEW.DELETE_ALL_PLANNER_EVENTS, localeCode),
            deleteRecurringEvent: makeTranslator(KEYS.OVERVIEW.DELETE_RECURRING_EVENT, localeCode),
            deletedPlannerEvents: makeTranslator(KEYS.OVERVIEW.DELETED_PLANNER_EVENTS, localeCode),
            deletedSomePlannerEvents: makeTranslator(KEYS.OVERVIEW.DELETED_SOME_PLANNER_EVENTS, localeCode),
            deletingPlannerEvents: makeTranslator(KEYS.OVERVIEW.DELETING_PLANNER_EVENTS, localeCode),
            deletingThesePlannerEvents: makeTranslator(KEYS.OVERVIEW.DELETING_THESE_PLANNER_EVENTS, localeCode),
            deletingTitle: makeTranslator(KEYS.OVERVIEW.DELETING_TITLE, localeCode),
            done: makeTranslator(KEYS.OVERVIEW.DONE, localeCode),
            dueBy: makeTranslator(KEYS.OVERVIEW.DUE_BY, localeCode),
            failedDeletePlannerEvents: makeTranslator(KEYS.OVERVIEW.FAILED_DELETE_PLANNER_EVENTS, localeCode),
            filter: {
                channels: makeTranslator(KEYS.OVERVIEW.FILTER.CHANNELS, localeCode),
                client: makeTranslator(KEYS.OVERVIEW.FILTER.CLIENT, localeCode),
                item: makeTranslator(KEYS.OVERVIEW.FILTER.ITEM, localeCode),
                location: makeTranslator(KEYS.OVERVIEW.FILTER.LOCATION, localeCode),
                status: makeTranslator(KEYS.OVERVIEW.FILTER.STATUS, localeCode)
            },
            filteredAmount: makeTranslator(KEYS.OVERVIEW.FILTERED_AMOUNT, localeCode),
            futureEvents: makeTranslator(KEYS.OVERVIEW.FUTURE_EVENTS, localeCode),
            loadedLocations: makeTranslator(KEYS.OVERVIEW.LOADED_LOCATIONS, localeCode),
            locationEventsFailedPublish: makeTranslator(KEYS.OVERVIEW.LOCATION_EVENTS_FAILED_PUBLISH, localeCode),
            locationEventsFailedSave: makeTranslator(KEYS.OVERVIEW.LOCATION_EVENTS_FAILED_SAVE, localeCode),
            maxSpend: makeTranslator(KEYS.OVERVIEW.MAX_SPEND, localeCode),
            noContent: makeTranslator(KEYS.OVERVIEW.NO_CONTENT, localeCode),
            savingForTitle: makeTranslator(KEYS.OVERVIEW.SAVING_FOR_TITLE, localeCode),
            savingPlannerEvent: makeTranslator(KEYS.OVERVIEW.SAVING_PLANNER_EVENT, localeCode),
            selectedPlannerEvents: makeTranslator(KEYS.OVERVIEW.SELECTED_PLANNER_EVENTS, localeCode),
            somePlannerSeries: makeTranslator(KEYS.OVERVIEW.SOME_PLANNER_SERIES, localeCode),
            thisEvent: makeTranslator(KEYS.OVERVIEW.THIS_EVENT, localeCode)
        },
        payments: {
            askAgencyToSendAnother: makeTranslator(KEYS.PAYMENTS.ASK_AGENCY_TO_SEND_ANOTHER, localeCode),
            authorityConfirmation: makeTranslator(KEYS.PAYMENTS.AUTHORITY_CONFIRMATION, localeCode),
            businessName: makeTranslator(KEYS.PAYMENTS.BUSINESS_NAME, localeCode),
            couldNotFindInvitation: makeTranslator(KEYS.PAYMENTS.COULD_NOT_FIND_INVITATION, localeCode),
            customerDetails: makeTranslator(KEYS.PAYMENTS.CUSTOMER_DETAILS, localeCode),
            emailAddress: makeTranslator(KEYS.PAYMENTS.EMAIL_ADDRESS, localeCode),
            emails: {
                amountDue: makeTranslator(KEYS.PAYMENTS.EMAILS.AMOUNT_DUE, localeCode),
                attemptedPaymentDate: makeTranslator(KEYS.PAYMENTS.EMAILS.ATTEMPTED_PAYMENT_DATE, localeCode),
                dueDate: makeTranslator(KEYS.PAYMENTS.EMAILS.DUE_DATE, localeCode),
                failedSubjectLine: makeTranslator(KEYS.PAYMENTS.EMAILS.FAILED_SUBJECT_LINE, localeCode),
                failedToTakePayment: makeTranslator(KEYS.PAYMENTS.EMAILS.FAILED_TO_TAKE_PAYMENT, localeCode),
                ifYouNeedToUpdateCreditCard: makeTranslator(KEYS.PAYMENTS.EMAILS.IF_YOU_NEED_TO_UPDATE_CREDIT_CARD, localeCode),
                invoiceDescription: makeTranslator(KEYS.PAYMENTS.EMAILS.INVOICE_DESCRIPTION, localeCode),
                invoiceNumber: makeTranslator(KEYS.PAYMENTS.EMAILS.INVOICE_NUMBER, localeCode),
                paymentFailedForLocation: makeTranslator(KEYS.PAYMENTS.EMAILS.PAYMENT_FAILED_FOR_LOCATION, localeCode),
                report: {
                    failedSubjectLine: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE, localeCode),
                    failedSubjectLinePlural: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.FAILED_SUBJECT_LINE_plural, localeCode),
                    failedToTakePayments: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.FAILED_TO_TAKE_PAYMENTS, localeCode),
                    paymentFailedForLocations: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS, localeCode),
                    paymentFailedForLocationsPlural: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.PAYMENT_FAILED_FOR_LOCATIONS_plural, localeCode),
                    paymentFailureReason: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.PAYMENT_FAILURE_REASON, localeCode),
                    technicalIssues: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES, localeCode),
                    technicalIssuesNote: makeTranslator(KEYS.PAYMENTS.EMAILS.REPORT.TECHNICAL_ISSUES_NOTE, localeCode)
                },
                retry: {
                    weWillAttemptToChargeAgain: makeTranslator(KEYS.PAYMENTS.EMAILS.RETRY.WE_WILL_ATTEMPT_TO_CHARGE_AGAIN, localeCode)
                },
                rollover: {
                    weWillAddOutstandingAmountToNextPayment: makeTranslator(KEYS.PAYMENTS.EMAILS.ROLLOVER.WE_WILL_ADD_OUTSTANDING_AMOUNT_TO_NEXT_PAYMENT, localeCode)
                },
                subscriptionAmount: makeTranslator(KEYS.PAYMENTS.EMAILS.SUBSCRIPTION_AMOUNT, localeCode),
                youMayNeedToContactYourFinancialInstitution: makeTranslator(KEYS.PAYMENTS.EMAILS.YOU_MAY_NEED_TO_CONTACT_YOUR_FINANCIAL_INSTITUTION, localeCode)
            },
            finalisingPayment: makeTranslator(KEYS.PAYMENTS.FINALISING_PAYMENT, localeCode),
            goBack: makeTranslator(KEYS.PAYMENTS.GO_BACK, localeCode),
            invoiceDescription: makeTranslator(KEYS.PAYMENTS.INVOICE_DESCRIPTION, localeCode),
            invoiceNumber: makeTranslator(KEYS.PAYMENTS.INVOICE_NUMBER, localeCode),
            mastercard: makeTranslator(KEYS.PAYMENTS.MASTERCARD, localeCode),
            noPayment: makeTranslator(KEYS.PAYMENTS.NO_PAYMENT, localeCode),
            noPaymentInformation: makeTranslator(KEYS.PAYMENTS.NO_PAYMENT_INFORMATION, localeCode),
            payNow: makeTranslator(KEYS.PAYMENTS.PAY_NOW, localeCode),
            paymentAmount: makeTranslator(KEYS.PAYMENTS.PAYMENT_AMOUNT, localeCode),
            paymentCurrency: makeTranslator(KEYS.PAYMENTS.PAYMENT_CURRENCY, localeCode),
            paymentFailed: makeTranslator(KEYS.PAYMENTS.PAYMENT_FAILED, localeCode),
            paymentSuccessful: makeTranslator(KEYS.PAYMENTS.PAYMENT_SUCCESSFUL, localeCode),
            phoneNumber: makeTranslator(KEYS.PAYMENTS.PHONE_NUMBER, localeCode),
            pleaseConfirm: makeTranslator(KEYS.PAYMENTS.PLEASE_CONFIRM, localeCode),
            receiptNumber: makeTranslator(KEYS.PAYMENTS.RECEIPT_NUMBER, localeCode),
            redirectContinue: makeTranslator(KEYS.PAYMENTS.REDIRECT_CONTINUE, localeCode),
            redirectNote: makeTranslator(KEYS.PAYMENTS.REDIRECT_NOTE, localeCode),
            redirecting: makeTranslator(KEYS.PAYMENTS.REDIRECTING, localeCode),
            signUp: {
                agencyWelcomesYou: makeTranslator(KEYS.PAYMENTS.SIGN_UP.AGENCY_WELCOMES_YOU, localeCode),
                amountPerMonth: makeTranslator(KEYS.PAYMENTS.SIGN_UP.AMOUNT_PER_MONTH, localeCode),
                finalisingSignUp: makeTranslator(KEYS.PAYMENTS.SIGN_UP.FINALISING_SIGN_UP, localeCode),
                firstBillingDate: makeTranslator(KEYS.PAYMENTS.SIGN_UP.FIRST_BILLING_DATE, localeCode),
                firstBillingDateIs: makeTranslator(KEYS.PAYMENTS.SIGN_UP.FIRST_BILLING_DATE_IS, localeCode),
                iAgreeToThe: makeTranslator(KEYS.PAYMENTS.SIGN_UP.I_AGREE_TO_THE, localeCode),
                signUp: makeTranslator(KEYS.PAYMENTS.SIGN_UP.SIGN_UP, localeCode),
                signUpFailed: makeTranslator(KEYS.PAYMENTS.SIGN_UP.SIGN_UP_FAILED, localeCode),
                signUpSuccessful: makeTranslator(KEYS.PAYMENTS.SIGN_UP.SIGN_UP_SUCCESSFUL, localeCode),
                youWillBePromptedForCreditCard: makeTranslator(KEYS.PAYMENTS.SIGN_UP.YOU_WILL_BE_PROMPTED_FOR_CREDIT_CARD, localeCode)
            },
            starting: makeTranslator(KEYS.PAYMENTS.STARTING, localeCode),
            stripe: {
                authRequest: {
                    authoriseYourAccount: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_REQUEST.AUTHORISE_YOUR_ACCOUNT, localeCode),
                    byAuthorising: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_REQUEST.BY_AUTHORISING, localeCode),
                    clickButtonBelow: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_REQUEST.CLICK_BUTTON_BELOW, localeCode),
                    expired: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_REQUEST.EXPIRED, localeCode),
                    requestInvalid: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_REQUEST.REQUEST_INVALID, localeCode)
                },
                authResponse: {
                    accessDenied: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.ACCESS_DENIED, localeCode),
                    error: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.ERROR, localeCode),
                    failed: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.FAILED, localeCode),
                    looksLikeSomethingWentWrong: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_SOMETHING_WENT_WRONG, localeCode),
                    looksLikeYouDeniedAccess: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.LOOKS_LIKE_YOU_DENIED_ACCESS, localeCode),
                    success: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.SUCCESS, localeCode),
                    unknownError: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.UNKNOWN_ERROR, localeCode),
                    yourStripeAccountIsConnected: makeTranslator(KEYS.PAYMENTS.STRIPE.AUTH_RESPONSE.YOUR_STRIPE_ACCOUNT_IS_CONNECTED, localeCode)
                },
                createStripeCharge: makeTranslator(KEYS.PAYMENTS.STRIPE.CREATE_STRIPE_CHARGE, localeCode),
                emails: {
                    authRequest: {
                        authMyAccount: makeTranslator(KEYS.PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.AUTH_MY_ACCOUNT, localeCode),
                        subjectLine: makeTranslator(KEYS.PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.SUBJECT_LINE, localeCode),
                        toAuthClickLink: makeTranslator(KEYS.PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.TO_AUTH_CLICK_LINK, localeCode),
                        userRequestedYouToAuth: makeTranslator(KEYS.PAYMENTS.STRIPE.EMAILS.AUTH_REQUEST.USER_REQUESTED_YOU_TO_AUTH, localeCode)
                    }
                },
                fetchStripeAuthRequest: makeTranslator(KEYS.PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_REQUEST, localeCode),
                fetchStripeAuthUrl: makeTranslator(KEYS.PAYMENTS.STRIPE.FETCH_STRIPE_AUTH_URL, localeCode),
                fetchStripePublishableKey: makeTranslator(KEYS.PAYMENTS.STRIPE.FETCH_STRIPE_PUBLISHABLE_KEY, localeCode),
                submitAuthCodeToStripe: makeTranslator(KEYS.PAYMENTS.STRIPE.SUBMIT_AUTH_CODE_TO_STRIPE, localeCode)
            },
            thankYou: makeTranslator(KEYS.PAYMENTS.THANK_YOU, localeCode),
            updateBillingDetails: {
                billingDetailsUpdated: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.BILLING_DETAILS_UPDATED, localeCode),
                finalisingChanges: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.FINALISING_CHANGES, localeCode),
                loadingBillingDetails: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.LOADING_BILLING_DETAILS, localeCode),
                updateBillingDetails: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS, localeCode),
                updateBillingDetailsInDigitalStack: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_BILLING_DETAILS_IN_DIGITAL_STACK, localeCode),
                updateFailed: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_FAILED, localeCode),
                updateSuccessful: makeTranslator(KEYS.PAYMENTS.UPDATE_BILLING_DETAILS.UPDATE_SUCCESSFUL, localeCode)
            },
            visa: makeTranslator(KEYS.PAYMENTS.VISA, localeCode),
            weOnlyAccept: makeTranslator(KEYS.PAYMENTS.WE_ONLY_ACCEPT, localeCode),
            yourBusiness: makeTranslator(KEYS.PAYMENTS.YOUR_BUSINESS, localeCode)
        },
        plan: {
            activities: {
                actions: {
                    addActivity: makeTranslator(KEYS.PLAN.ACTIVITIES.ACTIONS.ADD_ACTIVITY, localeCode)
                },
                channels: {
                    channelForActivity: makeTranslator(KEYS.PLAN.ACTIVITIES.CHANNELS.CHANNEL_FOR_ACTIVITY, localeCode),
                    channelType: {
                        general: makeTranslator(KEYS.PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.GENERAL, localeCode),
                        selfService: makeTranslator(KEYS.PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SELF_SERVICE, localeCode),
                        supported: makeTranslator(KEYS.PLAN.ACTIVITIES.CHANNELS.CHANNEL_TYPE.SUPPORTED, localeCode)
                    }
                }
            },
            agencyToBuild: makeTranslator(KEYS.PLAN.AGENCY_TO_BUILD, localeCode),
            agencyToBuildSpecific: makeTranslator(KEYS.PLAN.AGENCY_TO_BUILD_SPECIFIC, localeCode),
            agencyToBuildTooltip: makeTranslator(KEYS.PLAN.AGENCY_TO_BUILD_TOOLTIP, localeCode),
            associatedBuilderResources: {
                addTemplate: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.ADD_TEMPLATE, localeCode),
                associateTemplateOrCategory: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.ASSOCIATE_TEMPLATE_OR_CATEGORY, localeCode),
                invalidSingleTemplateExplanation: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.INVALID_SINGLE_TEMPLATE_EXPLANATION, localeCode),
                pasteATemplateUrl: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.PASTE_A_TEMPLATE_URL, localeCode),
                selectACollection: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_COLLECTION, localeCode),
                selectATemplateCategory: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.SELECT_A_TEMPLATE_CATEGORY, localeCode),
                singleTemplate: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.SINGLE_TEMPLATE, localeCode),
                templateUrl: makeTranslator(KEYS.PLAN.ASSOCIATED_BUILDER_RESOURCES.TEMPLATE_URL, localeCode)
            },
            buildAndSchedule: makeTranslator(KEYS.PLAN.BUILD_AND_SCHEDULE, localeCode),
            buildAndScheduleTooltip: makeTranslator(KEYS.PLAN.BUILD_AND_SCHEDULE_TOOLTIP, localeCode),
            campaigns: {
                actions: {
                    archiveMessage: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_MESSAGE, localeCode),
                    archiveThisCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.ARCHIVE_THIS_CAMPAIGN, localeCode),
                    deployThisCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.DEPLOY_THIS_CAMPAIGN, localeCode),
                    renameCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.RENAME_CAMPAIGN, localeCode),
                    unarchiveMessage: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_MESSAGE, localeCode),
                    unarchiveThisCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.ACTIONS.UNARCHIVE_THIS_CAMPAIGN, localeCode)
                },
                addItem: makeTranslator(KEYS.PLAN.CAMPAIGNS.ADD_ITEM, localeCode),
                addNewCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.ADD_NEW_CAMPAIGN, localeCode),
                campaignNameFilterLabel: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGN_NAME_FILTER_LABEL, localeCode),
                campaignNotFound: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGN_NOT_FOUND, localeCode),
                campaignRenamedTo: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGN_RENAMED_TO, localeCode),
                campaigns: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS, localeCode),
                campaignsList: {
                    headers: {
                        duration: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.DURATION, localeCode),
                        name: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.NAME, localeCode),
                        totalItems: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS_LIST.HEADERS.TOTAL_ITEMS, localeCode)
                    },
                    noCampaignsFound: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NO_CAMPAIGNS_FOUND, localeCode),
                    numDays: makeTranslator(KEYS.PLAN.CAMPAIGNS.CAMPAIGNS_LIST.NUM_DAYS, localeCode)
                },
                createdNewCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.CREATED_NEW_CAMPAIGN, localeCode),
                deploys: {
                    adjustEventDatesTitle: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.ADJUST_EVENT_DATES_TITLE, localeCode),
                    campaignDeployed: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.CAMPAIGN_DEPLOYED, localeCode),
                    deploy: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY, localeCode),
                    deployCampaign: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN, localeCode),
                    deployCampaignToLocation: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_CAMPAIGN_TO_LOCATION, localeCode),
                    deployFormCopy: {
                        adjustDates: {
                            explainStep: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP, localeCode),
                            explainStepAdjustDetail: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_ADJUST_DETAIL, localeCode),
                            explainStepRemoveDetail: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.ADJUST_DATES.EXPLAIN_STEP_REMOVE_DETAIL, localeCode)
                        },
                        confirm: {
                            confirmCopy: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.CONFIRM_COPY, localeCode),
                            deploymentExplanationCopy: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.DEPLOYMENT_EXPLANATION_COPY, localeCode),
                            endDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.END_DATE, localeCode),
                            events: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS, localeCode),
                            eventsPerLocation: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.EVENTS_PER_LOCATION, localeCode),
                            header: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.HEADER, localeCode),
                            locations: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS, localeCode),
                            locationsWithClient: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT, localeCode),
                            locationsWithClientSingular: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.LOCATIONS_WITH_CLIENT_SINGULAR, localeCode),
                            pleaseConfirm: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.PLEASE_CONFIRM, localeCode),
                            startDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DATE, localeCode),
                            startDeployment: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.CONFIRM.START_DEPLOYMENT, localeCode)
                        },
                        pickLocations: {
                            explainStep: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP, localeCode),
                            explainStepDetail: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.PICK_LOCATIONS.EXPLAIN_STEP_DETAIL, localeCode)
                        },
                        startingDate: {
                            explainStep: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP, localeCode),
                            explainStepDetail: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STARTING_DATE.EXPLAIN_STEP_DETAIL, localeCode)
                        },
                        steps: {
                            adjustDates: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.ADJUST_DATES, localeCode),
                            pickLocations: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.PICK_LOCATIONS, localeCode),
                            review: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.REVIEW, localeCode),
                            setStartingDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_FORM_COPY.STEPS.SET_STARTING_DATE, localeCode)
                        }
                    },
                    deployTo: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOY_TO, localeCode),
                    deploymentHistory: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY, localeCode),
                    deploymentHistoryList: {
                        campaignNotFound: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.CAMPAIGN_NOT_FOUND, localeCode),
                        filters: {
                            locationPlaceholder: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.LOCATION_PLACEHOLDER, localeCode),
                            statusLabel: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_LABEL, localeCode),
                            statusPlaceholder: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.FILTERS.STATUS_PLACEHOLDER, localeCode)
                        },
                        headers: {
                            createDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.CREATE_DATE, localeCode),
                            location: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.LOCATION, localeCode),
                            startDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.START_DATE, localeCode),
                            status: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.HEADERS.STATUS, localeCode)
                        },
                        noDeployments: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_LIST.NO_DEPLOYMENTS, localeCode)
                    },
                    deploymentHistoryStatus: {
                        active: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE, localeCode),
                        activeHelp: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ACTIVE_HELP, localeCode),
                        completed: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED, localeCode),
                        completedHelp: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.COMPLETED_HELP, localeCode),
                        failed: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED, localeCode),
                        failedHelp: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.FAILED_HELP, localeCode),
                        rollingout: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT, localeCode),
                        rollingoutHelp: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.ROLLINGOUT_HELP, localeCode),
                        scheduled: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED, localeCode),
                        scheduledHelp: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.DEPLOYMENT_HISTORY_STATUS.SCHEDULED_HELP, localeCode)
                    },
                    errors: {
                        deploymentFailed: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.ERRORS.DEPLOYMENT_FAILED, localeCode),
                        mustIncludeOneEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_EVENT, localeCode),
                        mustIncludeOneLocation: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.ERRORS.MUST_INCLUDE_ONE_LOCATION, localeCode)
                    },
                    pickLocations: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.PICK_LOCATIONS, localeCode),
                    selectStartingDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.SELECT_STARTING_DATE, localeCode),
                    startingDate: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.STARTING_DATE, localeCode),
                    successfulDeployCopy: makeTranslator(KEYS.PLAN.CAMPAIGNS.DEPLOYS.SUCCESSFUL_DEPLOY_COPY, localeCode)
                },
                errors: {
                    uploadFailed: makeTranslator(KEYS.PLAN.CAMPAIGNS.ERRORS.UPLOAD_FAILED, localeCode)
                },
                eventsList: {
                    headers: {
                        actions: makeTranslator(KEYS.PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.ACTIONS, localeCode),
                        channel: makeTranslator(KEYS.PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.CHANNEL, localeCode),
                        day: makeTranslator(KEYS.PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.DAY, localeCode),
                        instructionsDescription: makeTranslator(KEYS.PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.INSTRUCTIONS_DESCRIPTION, localeCode),
                        title: makeTranslator(KEYS.PLAN.CAMPAIGNS.EVENTS_LIST.HEADERS.TITLE, localeCode)
                    }
                },
                isArchived: makeTranslator(KEYS.PLAN.CAMPAIGNS.IS_ARCHIVED, localeCode),
                overview: makeTranslator(KEYS.PLAN.CAMPAIGNS.OVERVIEW, localeCode),
                plannerEvents: {
                    areYouSureDeletePlannerEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.ARE_YOU_SURE_DELETE_PLANNER_EVENT, localeCode),
                    errors: {
                        issueCreatingPlannerEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_CREATING_PLANNER_EVENT, localeCode),
                        issueDeletingPlannerEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_DELETING_PLANNER_EVENT, localeCode),
                        issueUpdatingPlannerEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.ERRORS.ISSUE_UPDATING_PLANNER_EVENT, localeCode)
                    },
                    newPlannerEvent: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.NEW_PLANNER_EVENT, localeCode),
                    plannerEventCreated: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_CREATED, localeCode),
                    plannerEventDeleted: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_DELETED, localeCode),
                    plannerEventNotFound: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_NOT_FOUND, localeCode),
                    plannerEventUpdated: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENT_UPDATED, localeCode),
                    plannerEvents: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.PLANNER_EVENTS, localeCode),
                    readyToAction: makeTranslator(KEYS.PLAN.CAMPAIGNS.PLANNER_EVENTS.READY_TO_ACTION, localeCode)
                },
                returnToCampaignsPage: makeTranslator(KEYS.PLAN.CAMPAIGNS.RETURN_TO_CAMPAIGNS_PAGE, localeCode)
            },
            contentRequired: makeTranslator(KEYS.PLAN.CONTENT_REQUIRED, localeCode),
            contentRequiredTooltip: makeTranslator(KEYS.PLAN.CONTENT_REQUIRED_TOOLTIP, localeCode),
            dangerousDateHeading: makeTranslator(KEYS.PLAN.DANGEROUS_DATE_HEADING, localeCode),
            dangerousDateNote: makeTranslator(KEYS.PLAN.DANGEROUS_DATE_NOTE, localeCode),
            event: {
                activity: makeTranslator(KEYS.PLAN.EVENT.ACTIVITY, localeCode),
                addRemoveLocations: makeTranslator(KEYS.PLAN.EVENT.ADD_REMOVE_LOCATIONS, localeCode),
                addToPlanner: makeTranslator(KEYS.PLAN.EVENT.ADD_TO_PLANNER, localeCode),
                additionalLocations: makeTranslator(KEYS.PLAN.EVENT.ADDITIONAL_LOCATIONS, localeCode),
                backToCalendar: makeTranslator(KEYS.PLAN.EVENT.BACK_TO_CALENDAR, localeCode),
                buildNow: makeTranslator(KEYS.PLAN.EVENT.BUILD_NOW, localeCode),
                confirmDelete: makeTranslator(KEYS.PLAN.EVENT.CONFIRM_DELETE, localeCode),
                daily: makeTranslator(KEYS.PLAN.EVENT.DAILY, localeCode),
                dateOfMonthExample: makeTranslator(KEYS.PLAN.EVENT.DATE_OF_MONTH_EXAMPLE, localeCode),
                dateOfMonthInYearExample: makeTranslator(KEYS.PLAN.EVENT.DATE_OF_MONTH_IN_YEAR_EXAMPLE, localeCode),
                dateOfWeekExample: makeTranslator(KEYS.PLAN.EVENT.DATE_OF_WEEK_EXAMPLE, localeCode),
                dateOfWeekInYearExample: makeTranslator(KEYS.PLAN.EVENT.DATE_OF_WEEK_IN_YEAR_EXAMPLE, localeCode),
                dateSubmitted: makeTranslator(KEYS.PLAN.EVENT.DATE_SUBMITTED, localeCode),
                dateUpdated: makeTranslator(KEYS.PLAN.EVENT.DATE_UPDATED, localeCode),
                deletePlannerEvent: makeTranslator(KEYS.PLAN.EVENT.DELETE_PLANNER_EVENT, localeCode),
                deleteRecurring: makeTranslator(KEYS.PLAN.EVENT.DELETE_RECURRING, localeCode),
                deletionAlert: makeTranslator(KEYS.PLAN.EVENT.DELETION_ALERT, localeCode),
                editPlanner: makeTranslator(KEYS.PLAN.EVENT.EDIT_PLANNER, localeCode),
                ends: makeTranslator(KEYS.PLAN.EVENT.ENDS, localeCode),
                eventSeries: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES, localeCode),
                eventSeriesChooseAll: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES_CHOOSE_ALL, localeCode),
                eventSeriesChooseCurrent: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES_CHOOSE_CURRENT, localeCode),
                eventSeriesChooseFuture: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES_CHOOSE_FUTURE, localeCode),
                eventSeriesOptionsDelete: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES_OPTIONS_DELETE, localeCode),
                eventSeriesOptionsUpdate: makeTranslator(KEYS.PLAN.EVENT.EVENT_SERIES_OPTIONS_UPDATE, localeCode),
                failedToCreateUpdatePlanner: makeTranslator(KEYS.PLAN.EVENT.FAILED_TO_CREATE_UPDATE_PLANNER, localeCode),
                failedToDeletePlanner: makeTranslator(KEYS.PLAN.EVENT.FAILED_TO_DELETE_PLANNER, localeCode),
                failedToRetrievePlanner: makeTranslator(KEYS.PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER, localeCode),
                failedToRetrievePlannerInfo: makeTranslator(KEYS.PLAN.EVENT.FAILED_TO_RETRIEVE_PLANNER_INFO, localeCode),
                fifth: makeTranslator(KEYS.PLAN.EVENT.FIFTH, localeCode),
                first: makeTranslator(KEYS.PLAN.EVENT.FIRST, localeCode),
                fortnightly: makeTranslator(KEYS.PLAN.EVENT.FORTNIGHTLY, localeCode),
                fourth: makeTranslator(KEYS.PLAN.EVENT.FOURTH, localeCode),
                friday: makeTranslator(KEYS.PLAN.EVENT.FRIDAY, localeCode),
                instructionsToManager: makeTranslator(KEYS.PLAN.EVENT.INSTRUCTIONS_TO_MANAGER, localeCode),
                monday: makeTranslator(KEYS.PLAN.EVENT.MONDAY, localeCode),
                noArtwork: makeTranslator(KEYS.PLAN.EVENT.NO_ARTWORK, localeCode),
                occurrences: makeTranslator(KEYS.PLAN.EVENT.OCCURRENCES, localeCode),
                oldActivities: makeTranslator(KEYS.PLAN.EVENT.OLD_ACTIVITIES, localeCode),
                plannerEventDeleted: makeTranslator(KEYS.PLAN.EVENT.PLANNER_EVENT_DELETED, localeCode),
                pleaseDeleteItemVia: makeTranslator(KEYS.PLAN.EVENT.PLEASE_DELETE_ITEM_VIA, localeCode),
                readyToAction: makeTranslator(KEYS.PLAN.EVENT.READY_TO_ACTION, localeCode),
                recurringEventQuestion: makeTranslator(KEYS.PLAN.EVENT.RECURRING_EVENT_QUESTION, localeCode),
                repeatBy: makeTranslator(KEYS.PLAN.EVENT.REPEAT_BY, localeCode),
                requiredInfo: makeTranslator(KEYS.PLAN.EVENT.REQUIRED_INFO, localeCode),
                saturday: makeTranslator(KEYS.PLAN.EVENT.SATURDAY, localeCode),
                saveBuildLater: makeTranslator(KEYS.PLAN.EVENT.SAVE_BUILD_LATER, localeCode),
                saveBuildNow: makeTranslator(KEYS.PLAN.EVENT.SAVE_BUILD_NOW, localeCode),
                saveMoreContentRequired: makeTranslator(KEYS.PLAN.EVENT.SAVE_MORE_CONTENT_REQUIRED, localeCode),
                scheduledPage: makeTranslator(KEYS.PLAN.EVENT.SCHEDULED_PAGE, localeCode),
                second: makeTranslator(KEYS.PLAN.EVENT.SECOND, localeCode),
                selfService: makeTranslator(KEYS.PLAN.EVENT.SELF_SERVICE, localeCode),
                startsOn: makeTranslator(KEYS.PLAN.EVENT.STARTS_ON, localeCode),
                submittedBy: makeTranslator(KEYS.PLAN.EVENT.SUBMITTED_BY, localeCode),
                sunday: makeTranslator(KEYS.PLAN.EVENT.SUNDAY, localeCode),
                supportActionOne: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_ACTION_ONE, localeCode),
                supportActionThree: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_ACTION_THREE, localeCode),
                supportActionTwo: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_ACTION_TWO, localeCode),
                supportActions: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_ACTIONS, localeCode),
                supportHeading: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_HEADING, localeCode),
                supportNote: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_NOTE, localeCode),
                supportOverplanned: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_OVERPLANNED, localeCode),
                supportRequested: makeTranslator(KEYS.PLAN.EVENT.SUPPORT_REQUESTED, localeCode),
                templateCategoryExpired: makeTranslator(KEYS.PLAN.EVENT.TEMPLATE_CATEGORY_EXPIRED, localeCode),
                third: makeTranslator(KEYS.PLAN.EVENT.THIRD, localeCode),
                thursday: makeTranslator(KEYS.PLAN.EVENT.THURSDAY, localeCode),
                tuesday: makeTranslator(KEYS.PLAN.EVENT.TUESDAY, localeCode),
                updateRecurring: makeTranslator(KEYS.PLAN.EVENT.UPDATE_RECURRING, localeCode),
                updatedBy: makeTranslator(KEYS.PLAN.EVENT.UPDATED_BY, localeCode),
                wednesday: makeTranslator(KEYS.PLAN.EVENT.WEDNESDAY, localeCode),
                weekly: makeTranslator(KEYS.PLAN.EVENT.WEEKLY, localeCode)
            },
            generalItem: makeTranslator(KEYS.PLAN.GENERAL_ITEM, localeCode),
            generalItemTooltip: makeTranslator(KEYS.PLAN.GENERAL_ITEM_TOOLTIP, localeCode),
            introDummyActivity: makeTranslator(KEYS.PLAN.INTRO_DUMMY_ACTIVITY, localeCode),
            introDummyChannel: makeTranslator(KEYS.PLAN.INTRO_DUMMY_CHANNEL, localeCode),
            multipleLocations: {
                savingForTheseLocations: makeTranslator(KEYS.PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_THESE_LOCATIONS, localeCode),
                savingForTitle: makeTranslator(KEYS.PLAN.MULTIPLE_LOCATIONS.SAVING_FOR_TITLE, localeCode),
                someLocationsFailedToSave: makeTranslator(KEYS.PLAN.MULTIPLE_LOCATIONS.SOME_LOCATIONS_FAILED_TO_SAVE, localeCode),
                totalSavingProgress: makeTranslator(KEYS.PLAN.MULTIPLE_LOCATIONS.TOTAL_SAVING_PROGRESS, localeCode),
                wouldYouLikeToRetryForFailedLocations: makeTranslator(KEYS.PLAN.MULTIPLE_LOCATIONS.WOULD_YOU_LIKE_TO_RETRY_FOR_FAILED_LOCATIONS, localeCode)
            },
            nextMonth: makeTranslator(KEYS.PLAN.NEXT_MONTH, localeCode),
            nextWeek: makeTranslator(KEYS.PLAN.NEXT_WEEK, localeCode),
            notifyPlannerCreateError: makeTranslator(KEYS.PLAN.NOTIFY_PLANNER_CREATE_ERROR, localeCode),
            notifyPlannerCreated: makeTranslator(KEYS.PLAN.NOTIFY_PLANNER_CREATED, localeCode),
            notifyPlannerCreatedPartial: makeTranslator(KEYS.PLAN.NOTIFY_PLANNER_CREATED_PARTIAL, localeCode),
            notifyPlannerEventDeleted: makeTranslator(KEYS.PLAN.NOTIFY_PLANNER_EVENT_DELETED, localeCode),
            notifyPlannerUpdated: makeTranslator(KEYS.PLAN.NOTIFY_PLANNER_UPDATED, localeCode),
            pastDateCantPlan: makeTranslator(KEYS.PLAN.PAST_DATE_CANT_PLAN, localeCode),
            pastDateHeading: makeTranslator(KEYS.PLAN.PAST_DATE_HEADING, localeCode),
            pastDateRecurring: makeTranslator(KEYS.PLAN.PAST_DATE_RECURRING, localeCode),
            plan: makeTranslator(KEYS.PLAN.PLAN, localeCode),
            planner: makeTranslator(KEYS.PLAN.PLANNER, localeCode),
            previousMonth: makeTranslator(KEYS.PLAN.PREVIOUS_MONTH, localeCode),
            previousWeek: makeTranslator(KEYS.PLAN.PREVIOUS_WEEK, localeCode),
            readyToBuild: makeTranslator(KEYS.PLAN.READY_TO_BUILD, localeCode),
            readyToBuildTooltip: makeTranslator(KEYS.PLAN.READY_TO_BUILD_TOOLTIP, localeCode),
            savingPlannerEvent: makeTranslator(KEYS.PLAN.SAVING_PLANNER_EVENT, localeCode),
            specialRequest: makeTranslator(KEYS.PLAN.SPECIAL_REQUEST, localeCode),
            updateRecurringDate: makeTranslator(KEYS.PLAN.UPDATE_RECURRING_DATE, localeCode),
            viewByMonth: makeTranslator(KEYS.PLAN.VIEW_BY_MONTH, localeCode),
            viewByWeek: makeTranslator(KEYS.PLAN.VIEW_BY_WEEK, localeCode)
        },
        profile: {
            changeImage: makeTranslator(KEYS.PROFILE.CHANGE_IMAGE, localeCode),
            changeProfilePicture: makeTranslator(KEYS.PROFILE.CHANGE_PROFILE_PICTURE, localeCode),
            confirmRemoveProfilePicture: makeTranslator(KEYS.PROFILE.CONFIRM_REMOVE_PROFILE_PICTURE, localeCode),
            email: makeTranslator(KEYS.PROFILE.EMAIL, localeCode),
            emailRequired: makeTranslator(KEYS.PROFILE.EMAIL_REQUIRED, localeCode),
            firstName: makeTranslator(KEYS.PROFILE.FIRST_NAME, localeCode),
            firstNameRequired: makeTranslator(KEYS.PROFILE.FIRST_NAME_REQUIRED, localeCode),
            inviteSent: makeTranslator(KEYS.PROFILE.INVITE_SENT, localeCode),
            lastName: makeTranslator(KEYS.PROFILE.LAST_NAME, localeCode),
            lastNameRequired: makeTranslator(KEYS.PROFILE.LAST_NAME_REQUIRED, localeCode),
            marketingUpdates: makeTranslator(KEYS.PROFILE.MARKETING_UPDATES, localeCode),
            minimumImageDimensionRequirement: makeTranslator(KEYS.PROFILE.MINIMUM_IMAGE_DIMENSION_REQUIREMENT, localeCode),
            notifications: makeTranslator(KEYS.PROFILE.NOTIFICATIONS, localeCode),
            password: makeTranslator(KEYS.PROFILE.PASSWORD, localeCode),
            profile: makeTranslator(KEYS.PROFILE.PROFILE, localeCode),
            profilePicture: makeTranslator(KEYS.PROFILE.PROFILE_PICTURE, localeCode),
            removeImage: makeTranslator(KEYS.PROFILE.REMOVE_IMAGE, localeCode),
            resendInvite: makeTranslator(KEYS.PROFILE.RESEND_INVITE, localeCode),
            sendingInvite: makeTranslator(KEYS.PROFILE.SENDING_INVITE, localeCode),
            specialRequests: makeTranslator(KEYS.PROFILE.SPECIAL_REQUESTS, localeCode),
            timezone: makeTranslator(KEYS.PROFILE.TIMEZONE, localeCode),
            units: makeTranslator(KEYS.PROFILE.UNITS, localeCode),
            unsupportedImageFormat: makeTranslator(KEYS.PROFILE.UNSUPPORTED_IMAGE_FORMAT, localeCode),
            userAccountUpdated: makeTranslator(KEYS.PROFILE.USER_ACCOUNT_UPDATED, localeCode),
            userLocaleChangedPageWillReload: makeTranslator(KEYS.PROFILE.USER_LOCALE_CHANGED_PAGE_WILL_RELOAD, localeCode),
            userProfile: makeTranslator(KEYS.PROFILE.USER_PROFILE, localeCode)
        },
        report: {
            adName: makeTranslator(KEYS.REPORT.AD_NAME, localeCode),
            addRemoveLocations: makeTranslator(KEYS.REPORT.ADD_REMOVE_LOCATIONS, localeCode),
            adjustSpend: makeTranslator(KEYS.REPORT.ADJUST_SPEND, localeCode),
            adjustedDailyBudget: makeTranslator(KEYS.REPORT.ADJUSTED_DAILY_BUDGET, localeCode),
            advertising: makeTranslator(KEYS.REPORT.ADVERTISING, localeCode),
            allMonetaryFiguresAreInCurrency: makeTranslator(KEYS.REPORT.ALL_MONETARY_FIGURES_ARE_IN_CURRENCY, localeCode),
            averagePosition: makeTranslator(KEYS.REPORT.AVERAGE_POSITION, localeCode),
            bounced: makeTranslator(KEYS.REPORT.BOUNCED, localeCode),
            brandAwareness: makeTranslator(KEYS.REPORT.BRAND_AWARENESS, localeCode),
            brandAwarenessByAd: makeTranslator(KEYS.REPORT.BRAND_AWARENESS_BY_AD, localeCode),
            brandAwarenessByKeyword: makeTranslator(KEYS.REPORT.BRAND_AWARENESS_BY_KEYWORD, localeCode),
            budget: makeTranslator(KEYS.REPORT.BUDGET, localeCode),
            byAd: makeTranslator(KEYS.REPORT.BY_AD, localeCode),
            byKeyword: makeTranslator(KEYS.REPORT.BY_KEYWORD, localeCode),
            campaign: makeTranslator(KEYS.REPORT.CAMPAIGN, localeCode),
            campaignMonitor: {
                title: makeTranslator(KEYS.REPORT.CAMPAIGN_MONITOR.TITLE, localeCode)
            },
            cantReportMoreThanThreeMonths: makeTranslator(KEYS.REPORT.CANT_REPORT_MORE_THAN_THREE_MONTHS, localeCode),
            clickRate: makeTranslator(KEYS.REPORT.CLICK_RATE, localeCode),
            clickThroughRate: makeTranslator(KEYS.REPORT.CLICK_THROUGH_RATE, localeCode),
            clickThroughRateHint: makeTranslator(KEYS.REPORT.CLICK_THROUGH_RATE_HINT, localeCode),
            clicked: makeTranslator(KEYS.REPORT.CLICKED, localeCode),
            clicks: makeTranslator(KEYS.REPORT.CLICKS, localeCode),
            clientOrLocation: makeTranslator(KEYS.REPORT.CLIENT_OR_LOCATION, localeCode),
            collapsePosts: makeTranslator(KEYS.REPORT.COLLAPSE_POSTS, localeCode),
            collapseRows: makeTranslator(KEYS.REPORT.COLLAPSE_ROWS, localeCode),
            confirmDeleteReportSummary: makeTranslator(KEYS.REPORT.CONFIRM_DELETE_REPORT_SUMMARY, localeCode),
            consumed: makeTranslator(KEYS.REPORT.CONSUMED, localeCode),
            consumption: makeTranslator(KEYS.REPORT.CONSUMPTION, localeCode),
            conversionValue: makeTranslator(KEYS.REPORT.CONVERSION_VALUE, localeCode),
            conversionValueHint: makeTranslator(KEYS.REPORT.CONVERSION_VALUE_HINT, localeCode),
            conversions: makeTranslator(KEYS.REPORT.CONVERSIONS, localeCode),
            conversionsByAd: makeTranslator(KEYS.REPORT.CONVERSIONS_BY_AD, localeCode),
            conversionsByKeyword: makeTranslator(KEYS.REPORT.CONVERSIONS_BY_KEYWORD, localeCode),
            conversionsPlatformNotConfiguredForLocation: makeTranslator(KEYS.REPORT.CONVERSIONS_PLATFORM_NOT_CONFIGURED_FOR_LOCATION, localeCode),
            costPerClick: makeTranslator(KEYS.REPORT.COST_PER_CLICK, localeCode),
            costPerConversion: makeTranslator(KEYS.REPORT.COST_PER_CONVERSION, localeCode),
            costPerLead: makeTranslator(KEYS.REPORT.COST_PER_LEAD, localeCode),
            costPerUniqueClick: makeTranslator(KEYS.REPORT.COST_PER_UNIQUE_CLICK, localeCode),
            currency: makeTranslator(KEYS.REPORT.CURRENCY, localeCode),
            currentSpend: makeTranslator(KEYS.REPORT.CURRENT_SPEND, localeCode),
            deviceSelection: makeTranslator(KEYS.REPORT.DEVICE_SELECTION, localeCode),
            deviceSelectionHint: makeTranslator(KEYS.REPORT.DEVICE_SELECTION_HINT, localeCode),
            devices: {
                desktop: makeTranslator(KEYS.REPORT.DEVICES.DESKTOP, localeCode),
                mobile: makeTranslator(KEYS.REPORT.DEVICES.MOBILE, localeCode),
                tablet: makeTranslator(KEYS.REPORT.DEVICES.TABLET, localeCode),
                unknown: makeTranslator(KEYS.REPORT.DEVICES.UNKNOWN, localeCode)
            },
            emailCampaigns: {
                bounces: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.BOUNCES, localeCode),
                buttons: {
                    downloadCsv: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.BUTTONS.DOWNLOAD_CSV, localeCode),
                    exportCsv: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.BUTTONS.EXPORT_CSV, localeCode)
                },
                clickRate: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.CLICK_RATE, localeCode),
                clicks: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.CLICKS, localeCode),
                delivered: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.DELIVERED, localeCode),
                errorCouldNotBeRetrieved: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.ERROR_COULD_NOT_BE_RETRIEVED, localeCode),
                errorExportingCsv: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.ERROR_EXPORTING_CSV, localeCode),
                exportingPleaseWait: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.EXPORTING_PLEASE_WAIT, localeCode),
                htmlPreviewDialogTitle: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.HTML_PREVIEW_DIALOG_TITLE, localeCode),
                invalidEmails: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.INVALID_EMAILS, localeCode),
                notConnected: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.NOT_CONNECTED, localeCode),
                notifications: {
                    exportingError: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_ERROR, localeCode),
                    exportingSuccess: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.NOTIFICATIONS.EXPORTING_SUCCESS, localeCode)
                },
                numberRecipients: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.NUMBER_RECIPIENTS, localeCode),
                openRate: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.OPEN_RATE, localeCode),
                opens: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.OPENS, localeCode),
                pleaseSelectEmailPlatform: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.PLEASE_SELECT_EMAIL_PLATFORM, localeCode),
                recipients: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS, localeCode),
                recipientsTable: {
                    clickedLink: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.CLICKED_LINK, localeCode),
                    delivered: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.DELIVERED, localeCode),
                    markedAsSpam: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.MARKED_AS_SPAM, localeCode),
                    noRecipientsFound: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.NO_RECIPIENTS_FOUND, localeCode),
                    opened: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.OPENED, localeCode),
                    recipientEmail: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL, localeCode),
                    recipientEmailFilterLabel: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_LABEL, localeCode),
                    recipientEmailFilterPlaceholder: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_EMAIL_FILTER_PLACEHOLDER, localeCode),
                    recipientName: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME, localeCode),
                    recipientNameFilterLabel: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_LABEL, localeCode),
                    recipientNameFilterPlaceholder: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.RECIPIENT_NAME_FILTER_PLACEHOLDER, localeCode),
                    unsubscribed: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.RECIPIENTS_TABLE.UNSUBSCRIBED, localeCode)
                },
                sendingOn: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.SENDING_ON, localeCode),
                sentTo: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.SENT_TO, localeCode),
                spamReports: makeTranslator(KEYS.REPORT.EMAIL_CAMPAIGNS.SPAM_REPORTS, localeCode)
            },
            endDate: makeTranslator(KEYS.REPORT.END_DATE, localeCode),
            endDateBeforeStartDate: makeTranslator(KEYS.REPORT.END_DATE_BEFORE_START_DATE, localeCode),
            engagedUsers: makeTranslator(KEYS.REPORT.ENGAGED_USERS, localeCode),
            engagement: makeTranslator(KEYS.REPORT.ENGAGEMENT, localeCode),
            engagementClicks: makeTranslator(KEYS.REPORT.ENGAGEMENT_CLICKS, localeCode),
            engagementReach: makeTranslator(KEYS.REPORT.ENGAGEMENT_REACH, localeCode),
            facebook: {
                audienceInsights: {
                    ageRange: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE, localeCode),
                    ageRangeAll: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_ALL, localeCode),
                    ageRangeMen: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_MEN, localeCode),
                    ageRangeOther: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER, localeCode),
                    ageRangeWomen: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN, localeCode),
                    days: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.DAYS, localeCode),
                    gender: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER, localeCode),
                    genderMen: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_MEN, localeCode),
                    genderOther: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_OTHER, localeCode),
                    genderWomen: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.GENDER_WOMEN, localeCode),
                    hours: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.HOURS, localeCode),
                    onlineFollowers: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS, localeCode),
                    onlineFollowersHelpDays: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS, localeCode),
                    onlineFollowersHelpHours: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS, localeCode),
                    title: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TITLE, localeCode),
                    topLocations: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS, localeCode),
                    topLocationsHelp: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_LOCATIONS_HELP, localeCode),
                    topPostTimes: makeTranslator(KEYS.REPORT.FACEBOOK.AUDIENCE_INSIGHTS.TOP_POST_TIMES, localeCode)
                },
                incorrectDataPopoverText: makeTranslator(KEYS.REPORT.FACEBOOK.INCORRECT_DATA_POPOVER_TEXT, localeCode),
                likesReport: {
                    newPageLikes: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.NEW_PAGE_LIKES, localeCode),
                    newPosts: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.NEW_POSTS, localeCode),
                    now: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.NOW, localeCode),
                    pageLikes: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES, localeCode),
                    pageLikesGrowth: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.PAGE_LIKES_GROWTH, localeCode),
                    periodAgo: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.PERIOD_AGO, localeCode),
                    title: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.TITLE, localeCode),
                    totalPageLikes: makeTranslator(KEYS.REPORT.FACEBOOK.LIKES_REPORT.TOTAL_PAGE_LIKES, localeCode)
                },
                notConnected: makeTranslator(KEYS.REPORT.FACEBOOK.NOT_CONNECTED, localeCode),
                postsReport: {
                    engagement: makeTranslator(KEYS.REPORT.FACEBOOK.POSTS_REPORT.ENGAGEMENT, localeCode),
                    time: makeTranslator(KEYS.REPORT.FACEBOOK.POSTS_REPORT.TIME, localeCode),
                    title: makeTranslator(KEYS.REPORT.FACEBOOK.POSTS_REPORT.TITLE, localeCode),
                    viewMore: makeTranslator(KEYS.REPORT.FACEBOOK.POSTS_REPORT.VIEW_MORE, localeCode),
                    viewPost: makeTranslator(KEYS.REPORT.FACEBOOK.POSTS_REPORT.VIEW_POST, localeCode)
                }
            },
            facebookAdvertising: makeTranslator(KEYS.REPORT.FACEBOOK_ADVERTISING, localeCode),
            facebookTopPosts: makeTranslator(KEYS.REPORT.FACEBOOK_TOP_POSTS, localeCode),
            fitwareMemberEngager: {
                bounces: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.BOUNCES, localeCode),
                reportLimitations: {
                    title: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.TITLE, localeCode),
                    message: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.REPORT_LIMITATIONS.MESSAGE, localeCode)
                },
                locationEmail: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.LOCATION_EMAIL, localeCode),
                opens: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.OPENS, localeCode),
                spamReports: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.SPAM_REPORTS, localeCode),
                title: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.TITLE, localeCode),
                unsubscribes: makeTranslator(KEYS.REPORT.FITWARE_MEMBER_ENGAGER.UNSUBSCRIBES, localeCode)
            },
            followersFrom: makeTranslator(KEYS.REPORT.FOLLOWERS_FROM, localeCode),
            followersGrowth: makeTranslator(KEYS.REPORT.FOLLOWERS_GROWTH, localeCode),
            followersTo: makeTranslator(KEYS.REPORT.FOLLOWERS_TO, localeCode),
            followingRequestWillBeSentToAgency: makeTranslator(KEYS.REPORT.FOLLOWING_REQUEST_WILL_BE_SENT_TO_AGENCY, localeCode),
            generalEvents: makeTranslator(KEYS.REPORT.GENERAL_EVENTS, localeCode),
            generalTemplateTypes: {
                all: makeTranslator(KEYS.REPORT.GENERAL_TEMPLATE_TYPES.ALL, localeCode),
                digital: makeTranslator(KEYS.REPORT.GENERAL_TEMPLATE_TYPES.DIGITAL, localeCode),
                email: makeTranslator(KEYS.REPORT.GENERAL_TEMPLATE_TYPES.EMAIL, localeCode),
                print: makeTranslator(KEYS.REPORT.GENERAL_TEMPLATE_TYPES.PRINT, localeCode)
            },
            generatedReportPrintFooter: makeTranslator(KEYS.REPORT.GENERATED_REPORT_PRINT_FOOTER, localeCode),
            generatingReport: makeTranslator(KEYS.REPORT.GENERATING_REPORT, localeCode),
            go: makeTranslator(KEYS.REPORT.GO, localeCode),
            googleAds: {
                adNameTooltipNumDescription: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION, localeCode),
                adNameTooltipNumDescriptionPlural: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_DESCRIPTION_plural, localeCode),
                adNameTooltipNumHeadline: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE, localeCode),
                adNameTooltipNumHeadlinePlural: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_HEADLINE_plural, localeCode),
                adNameTooltipNumUrl: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL, localeCode),
                adNameTooltipNumUrlPlural: makeTranslator(KEYS.REPORT.GOOGLE_ADS.AD_NAME_TOOLTIP_NUM_URL_plural, localeCode),
                columns: {
                    adName: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.AD_NAME, localeCode),
                    averageCpc: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC, localeCode),
                    averageCpcTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.AVERAGE_CPC_TOOLTIP, localeCode),
                    conversions: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS, localeCode),
                    conversionsTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.CONVERSIONS_TOOLTIP, localeCode),
                    cost: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.COST, localeCode),
                    costPerConversion: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION, localeCode),
                    costPerConversionTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.COST_PER_CONVERSION_TOOLTIP, localeCode),
                    costTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.COST_TOOLTIP, localeCode),
                    currency: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.CURRENCY, localeCode),
                    currencyTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.CURRENCY_TOOLTIP, localeCode),
                    impressions: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS, localeCode),
                    impressionsTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.IMPRESSIONS_TOOLTIP, localeCode),
                    interactionRate: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE, localeCode),
                    interactionRateTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.INTERACTION_RATE_TOOLTIP, localeCode),
                    interactions: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS, localeCode),
                    interactionsTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.INTERACTIONS_TOOLTIP, localeCode),
                    keyword: makeTranslator(KEYS.REPORT.GOOGLE_ADS.COLUMNS.KEYWORD, localeCode)
                },
                keywordBroadMatchTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.KEYWORD_BROAD_MATCH_TOOLTIP, localeCode),
                keywordExactMatchTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.KEYWORD_EXACT_MATCH_TOOLTIP, localeCode),
                keywordPhraseMatchTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.KEYWORD_PHRASE_MATCH_TOOLTIP, localeCode),
                keywordUnknownMatchTooltip: makeTranslator(KEYS.REPORT.GOOGLE_ADS.KEYWORD_UNKNOWN_MATCH_TOOLTIP, localeCode)
            },
            googleAdwordsSpendAdjustmentRequest: {
                additionalNotes: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.ADDITIONAL_NOTES, localeCode),
                extraStepsMayBeRequired: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.EXTRA_STEPS_MAY_BE_REQUIRED, localeCode),
                failedToRequestSpendAdjustment: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.FAILED_TO_REQUEST_SPEND_ADJUSTMENT, localeCode),
                increaseMyGoogleAdwordsBudget: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.INCREASE_MY_GOOGLE_ADWORDS_BUDGET, localeCode),
                requestHasBeenSent: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_HAS_BEEN_SENT, localeCode),
                requestToAdjustSpend: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.REQUEST_TO_ADJUST_SPEND, localeCode),
                sendRequest: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.SEND_REQUEST, localeCode),
                userHasRequestedAnAdjustmentToAdwordsSpend: makeTranslator(KEYS.REPORT.GOOGLE_ADWORDS_SPEND_ADJUSTMENT_REQUEST.USER_HAS_REQUESTED_AN_ADJUSTMENT_TO_ADWORDS_SPEND, localeCode)
            },
            googleMyBusiness: {
                confirmDeleteMessage: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.CONFIRM_DELETE_MESSAGE, localeCode),
                customerFeedback: {
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.CUSTOMER_FEEDBACK.TITLE, localeCode)
                },
                directionsReport: {
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.DIRECTIONS_REPORT.TITLE, localeCode)
                },
                metricsNoLongerAvaliableBanner: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.METRICS_NO_LONGER_AVALIABLE_BANNER, localeCode),
                notConnectedPart1: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_1, localeCode),
                notConnectedPart2: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.NOT_CONNECTED_PART_2, localeCode),
                photoQuantityReport: {
                    merchantTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.MERCHANT_TITLE, localeCode),
                    othersTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.OTHERS_TITLE, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_QUANTITY_REPORT.TITLE, localeCode)
                },
                photoViewsReport: {
                    merchantTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.MERCHANT_TITLE, localeCode),
                    othersTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.OTHERS_TITLE, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.PHOTO_VIEWS_REPORT.TITLE, localeCode)
                },
                recentPosts: {
                    postClicks: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_CLICKS, localeCode),
                    postViews: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.POST_VIEWS, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.TITLE, localeCode),
                    viewPost: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.RECENT_POSTS.VIEW_POST, localeCode)
                },
                reply: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.REPLY, localeCode),
                replyLengthError: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.REPLY_LENGTH_ERROR, localeCode),
                replyingPublicly: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.REPLYING_PUBLICLY, localeCode),
                searchReport: {
                    brandedDescription: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_DESCRIPTION, localeCode),
                    brandedTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.BRANDED_TITLE, localeCode),
                    directDescription: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_DESCRIPTION, localeCode),
                    directTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DIRECT_TITLE, localeCode),
                    discoveryDescription: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_DESCRIPTION, localeCode),
                    discoveryTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.DISCOVERY_TITLE, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.SEARCH_REPORT.TITLE, localeCode)
                },
                toolbar: {
                    days30: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_30, localeCode),
                    days7: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_7, localeCode),
                    days90: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOOLBAR.DAYS_90, localeCode)
                },
                topQuestions: {
                    anonymousAuthorName: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANONYMOUS_AUTHOR_NAME, localeCode),
                    answerListTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWER_LIST_TITLE, localeCode),
                    answers: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.ANSWERS, localeCode),
                    questions: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.QUESTIONS, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.TITLE, localeCode),
                    upvotes: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_QUESTIONS.UPVOTES, localeCode)
                },
                topReviews: {
                    anonymousReviewerName: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.ANONYMOUS_REVIEWER_NAME, localeCode),
                    repliedAt: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REPLIED_AT, localeCode),
                    reviews: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.REVIEWS, localeCode),
                    subTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.SUB_TITLE, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.TOP_REVIEWS.TITLE, localeCode)
                },
                viewFullReply: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REPLY, localeCode),
                viewFullReview: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_FULL_REVIEW, localeCode),
                viewReport: {
                    callsChartLabel: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_CHART_LABEL, localeCode),
                    callsTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.CALLS_TITLE, localeCode),
                    directionsChartLabel: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_CHART_LABEL, localeCode),
                    directionsTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.DIRECTIONS_TITLE, localeCode),
                    title: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.TITLE, localeCode),
                    websitesChartLabel: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_CHART_LABEL, localeCode),
                    websitesTitle: makeTranslator(KEYS.REPORT.GOOGLE_MY_BUSINESS.VIEW_REPORT.WEBSITES_TITLE, localeCode)
                }
            },
            growth: makeTranslator(KEYS.REPORT.GROWTH, localeCode),
            hideSummary: makeTranslator(KEYS.REPORT.HIDE_SUMMARY, localeCode),
            impressions: makeTranslator(KEYS.REPORT.IMPRESSIONS, localeCode),
            instagram: {
                audienceInsights: {
                    ageRangeAll: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_ALL, localeCode),
                    ageRangeMen: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_MEN, localeCode),
                    ageRangeOther: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_OTHER, localeCode),
                    ageRangeWomen: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.AGE_RANGE_WOMEN, localeCode),
                    days: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.DAYS, localeCode),
                    hours: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.HOURS, localeCode),
                    onlineFollowers: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS, localeCode),
                    onlineFollowersHelpDays: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_DAYS, localeCode),
                    onlineFollowersHelpHours: makeTranslator(KEYS.REPORT.INSTAGRAM.AUDIENCE_INSIGHTS.ONLINE_FOLLOWERS_HELP_HOURS, localeCode)
                },
                businessAccountReport: {
                    followersChartLabel: makeTranslator(KEYS.REPORT.INSTAGRAM.BUSINESS_ACCOUNT_REPORT.FOLLOWERS_CHART_LABEL, localeCode)
                },
                notConnectedPart1: makeTranslator(KEYS.REPORT.INSTAGRAM.NOT_CONNECTED_PART_1, localeCode),
                notConnectedPart2: makeTranslator(KEYS.REPORT.INSTAGRAM.NOT_CONNECTED_PART_2, localeCode),
                notConnectedScopesPart1: makeTranslator(KEYS.REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_1, localeCode),
                notConnectedScopesPart2: makeTranslator(KEYS.REPORT.INSTAGRAM.NOT_CONNECTED_SCOPES_PART_2, localeCode),
                postsReport: {
                    currentPosts: makeTranslator(KEYS.REPORT.INSTAGRAM.POSTS_REPORT.CURRENT_POSTS, localeCode),
                    title: makeTranslator(KEYS.REPORT.INSTAGRAM.POSTS_REPORT.TITLE, localeCode),
                    viewMore: makeTranslator(KEYS.REPORT.INSTAGRAM.POSTS_REPORT.VIEW_MORE, localeCode),
                    viewPost: makeTranslator(KEYS.REPORT.INSTAGRAM.POSTS_REPORT.VIEW_POST, localeCode)
                },
                storiesReport: {
                    activeStories: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.ACTIVE_STORIES, localeCode),
                    noActiveStoriesMessage: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.NO_ACTIVE_STORIES_MESSAGE, localeCode),
                    noPastStoriesMessage: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.NO_PAST_STORIES_MESSAGE, localeCode),
                    pastStories: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.PAST_STORIES, localeCode),
                    title: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.TITLE, localeCode),
                    viewMore: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.VIEW_MORE, localeCode),
                    viewPost: makeTranslator(KEYS.REPORT.INSTAGRAM.STORIES_REPORT.VIEW_POST, localeCode)
                }
            },
            invalidEndDate: makeTranslator(KEYS.REPORT.INVALID_END_DATE, localeCode),
            invalidStartDate: makeTranslator(KEYS.REPORT.INVALID_START_DATE, localeCode),
            keyword: makeTranslator(KEYS.REPORT.KEYWORD, localeCode),
            lastLogin: makeTranslator(KEYS.REPORT.LAST_LOGIN, localeCode),
            leads: makeTranslator(KEYS.REPORT.LEADS, localeCode),
            likesCommentsShares: makeTranslator(KEYS.REPORT.LIKES_COMMENTS_SHARES, localeCode),
            limited: makeTranslator(KEYS.REPORT.LIMITED, localeCode),
            location: makeTranslator(KEYS.REPORT.LOCATION, localeCode),
            locationAd: makeTranslator(KEYS.REPORT.LOCATION_AD, localeCode),
            locationConversionTypeAd: makeTranslator(KEYS.REPORT.LOCATION_CONVERSION_TYPE_AD, localeCode),
            locationConversionTypeKeyword: makeTranslator(KEYS.REPORT.LOCATION_CONVERSION_TYPE_KEYWORD, localeCode),
            locationKeyword: makeTranslator(KEYS.REPORT.LOCATION_KEYWORD, localeCode),
            loginDate: makeTranslator(KEYS.REPORT.LOGIN_DATE, localeCode),
            mailchimp: {
                title: makeTranslator(KEYS.REPORT.MAILCHIMP.TITLE, localeCode)
            },
            maximumSpend: makeTranslator(KEYS.REPORT.MAXIMUM_SPEND, localeCode),
            maximumSpendHint: makeTranslator(KEYS.REPORT.MAXIMUM_SPEND_HINT, localeCode),
            moreRows: makeTranslator(KEYS.REPORT.MORE_ROWS, localeCode),
            moreRowsPlural: makeTranslator(KEYS.REPORT.MORE_ROWS_plural, localeCode),
            mostUsedActivities: makeTranslator(KEYS.REPORT.MOST_USED_ACTIVITIES, localeCode),
            multipleLocationReport: makeTranslator(KEYS.REPORT.MULTIPLE_LOCATION_REPORT, localeCode),
            newFollowers: makeTranslator(KEYS.REPORT.NEW_FOLLOWERS, localeCode),
            newLikes: makeTranslator(KEYS.REPORT.NEW_LIKES, localeCode),
            newPosts: makeTranslator(KEYS.REPORT.NEW_POSTS, localeCode),
            newReportSummary: makeTranslator(KEYS.REPORT.NEW_REPORT_SUMMARY, localeCode),
            newVisitors: makeTranslator(KEYS.REPORT.NEW_VISITORS, localeCode),
            noAdwordStatsFound: makeTranslator(KEYS.REPORT.NO_ADWORD_STATS_FOUND, localeCode),
            noCampaignsFound: makeTranslator(KEYS.REPORT.NO_CAMPAIGNS_FOUND, localeCode),
            noUnreachedMarketForPeriod: makeTranslator(KEYS.REPORT.NO_UNREACHED_MARKET_FOR_PERIOD, localeCode),
            noVisitorsFound: makeTranslator(KEYS.REPORT.NO_VISITORS_FOUND, localeCode),
            notConnectedPart1: makeTranslator(KEYS.REPORT.NOT_CONNECTED_PART_1, localeCode),
            notConnectedPart2: makeTranslator(KEYS.REPORT.NOT_CONNECTED_PART_2, localeCode),
            notEnoughData: makeTranslator(KEYS.REPORT.NOT_ENOUGH_DATA, localeCode),
            numberOfTemplatesBuilt: makeTranslator(KEYS.REPORT.NUMBER_OF_TEMPLATES_BUILT, localeCode),
            organic: makeTranslator(KEYS.REPORT.ORGANIC, localeCode),
            overview: {
                emailCampaigns: {
                    campaignMonitorCheckBackSoon: makeTranslator(KEYS.REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_CHECK_BACK_SOON, localeCode),
                    campaignMonitorTooltip: makeTranslator(KEYS.REPORT.OVERVIEW.EMAIL_CAMPAIGNS.CAMPAIGN_MONITOR_TOOLTIP, localeCode),
                    title: makeTranslator(KEYS.REPORT.OVERVIEW.EMAIL_CAMPAIGNS.TITLE, localeCode)
                },
                facebook: {
                    title: makeTranslator(KEYS.REPORT.OVERVIEW.FACEBOOK.TITLE, localeCode),
                    engagement: makeTranslator(KEYS.REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT, localeCode),
                    engagementHint: makeTranslator(KEYS.REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_HINT, localeCode),
                    engagementRate: makeTranslator(KEYS.REPORT.OVERVIEW.FACEBOOK.ENGAGEMENT_RATE, localeCode)
                }
            },
            paid: makeTranslator(KEYS.REPORT.PAID, localeCode),
            paidImpressions: makeTranslator(KEYS.REPORT.PAID_IMPRESSIONS, localeCode),
            paidUniqueViews: makeTranslator(KEYS.REPORT.PAID_UNIQUE_VIEWS, localeCode),
            paidViewsDeprecation: makeTranslator(KEYS.REPORT.PAID_VIEWS_DEPRECATION, localeCode),
            peopleReached: makeTranslator(KEYS.REPORT.PEOPLE_REACHED, localeCode),
            plannedVsAdhoc: {
                builtFromGallery: makeTranslator(KEYS.REPORT.PLANNED_VS_ADHOC.BUILT_FROM_GALLERY, localeCode),
                builtFromPlanner: makeTranslator(KEYS.REPORT.PLANNED_VS_ADHOC.BUILT_FROM_PLANNER, localeCode),
                plannedVsAdhoc: makeTranslator(KEYS.REPORT.PLANNED_VS_ADHOC.PLANNED_VS_ADHOC, localeCode)
            },
            planningAndExecution: makeTranslator(KEYS.REPORT.PLANNING_AND_EXECUTION, localeCode),
            platform: makeTranslator(KEYS.REPORT.PLATFORM, localeCode),
            popularBuilderTemplateDetails: {
                buttons: {
                    downloadCsv: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.DOWNLOAD_CSV, localeCode),
                    exportCsv: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.BUTTONS.EXPORT_CSV, localeCode)
                },
                errorExportingCsv: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.ERROR_EXPORTING_CSV, localeCode),
                exportingPleaseWait: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.EXPORTING_PLEASE_WAIT, localeCode),
                notifications: {
                    exportingError: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_ERROR, localeCode),
                    exportingSuccess: makeTranslator(KEYS.REPORT.POPULAR_BUILDER_TEMPLATE_DETAILS.NOTIFICATIONS.EXPORTING_SUCCESS, localeCode)
                }
            },
            popularCategories: {
                byPlatform: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.BY_PLATFORM, localeCode),
                category: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.CATEGORY, localeCode),
                orderInGallery: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.ORDER_IN_GALLERY, localeCode),
                templateCategoryPopularity: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.TEMPLATE_CATEGORY_POPULARITY, localeCode),
                timesUsed: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.TIMES_USED, localeCode),
                totalUses: makeTranslator(KEYS.REPORT.POPULAR_CATEGORIES.TOTAL_USES, localeCode)
            },
            positiveFeedback: makeTranslator(KEYS.REPORT.POSITIVE_FEEDBACK, localeCode),
            potentialRoi: makeTranslator(KEYS.REPORT.POTENTIAL_ROI, localeCode),
            potentialRoiHint: makeTranslator(KEYS.REPORT.POTENTIAL_ROI_HINT, localeCode),
            printThisPage: makeTranslator(KEYS.REPORT.PRINT_THIS_PAGE, localeCode),
            reach: makeTranslator(KEYS.REPORT.REACH, localeCode),
            reached: makeTranslator(KEYS.REPORT.REACHED, localeCode),
            recipients: makeTranslator(KEYS.REPORT.RECIPIENTS, localeCode),
            recommendations: makeTranslator(KEYS.REPORT.RECOMMENDATIONS, localeCode),
            recommendedSpend: makeTranslator(KEYS.REPORT.RECOMMENDED_SPEND, localeCode),
            recommendedSpendHint: makeTranslator(KEYS.REPORT.RECOMMENDED_SPEND_HINT, localeCode),
            reportLoadedLocations: makeTranslator(KEYS.REPORT.REPORT_LOADED_LOCATIONS, localeCode),
            reportLoadedLocationsPlural: makeTranslator(KEYS.REPORT.REPORT_LOADED_LOCATIONS_plural, localeCode),
            reportSummary: makeTranslator(KEYS.REPORT.REPORT_SUMMARY, localeCode),
            reportSummaryText: {
                deleted: makeTranslator(KEYS.REPORT.REPORT_SUMMARY_TEXT.DELETED, localeCode),
                invalidDateRange: makeTranslator(KEYS.REPORT.REPORT_SUMMARY_TEXT.INVALID_DATE_RANGE, localeCode),
                saved: makeTranslator(KEYS.REPORT.REPORT_SUMMARY_TEXT.SAVED, localeCode)
            },
            reports: makeTranslator(KEYS.REPORT.REPORTS, localeCode),
            reportsArchived: makeTranslator(KEYS.REPORT.REPORTS_ARCHIVED, localeCode),
            requestSpendAdjustment: makeTranslator(KEYS.REPORT.REQUEST_SPEND_ADJUSTMENT, localeCode),
            returnOnInvestment: makeTranslator(KEYS.REPORT.RETURN_ON_INVESTMENT, localeCode),
            returnOnInvestmentHint: makeTranslator(KEYS.REPORT.RETURN_ON_INVESTMENT_HINT, localeCode),
            returningVisitors: makeTranslator(KEYS.REPORT.RETURNING_VISITORS, localeCode),
            roi: makeTranslator(KEYS.REPORT.ROI, localeCode),
            roiHint: makeTranslator(KEYS.REPORT.ROI_HINT, localeCode),
            roiPercent: makeTranslator(KEYS.REPORT.ROI_PERCENT, localeCode),
            sales: makeTranslator(KEYS.REPORT.SALES, localeCode),
            scheduledDate: makeTranslator(KEYS.REPORT.SCHEDULED_DATE, localeCode),
            selectAtLeastOneLocation: makeTranslator(KEYS.REPORT.SELECT_AT_LEAST_ONE_LOCATION, localeCode),
            selectedLocations: makeTranslator(KEYS.REPORT.SELECTED_LOCATIONS, localeCode),
            selfServiceEvents: makeTranslator(KEYS.REPORT.SELF_SERVICE_EVENTS, localeCode),
            selfServiceOrGeneralEvents: makeTranslator(KEYS.REPORT.SELF_SERVICE_OR_GENERAL_EVENTS, localeCode),
            sentDate: makeTranslator(KEYS.REPORT.SENT_DATE, localeCode),
            showAllRows: makeTranslator(KEYS.REPORT.SHOW_ALL_ROWS, localeCode),
            showSummary: makeTranslator(KEYS.REPORT.SHOW_SUMMARY, localeCode),
            showTopN: makeTranslator(KEYS.REPORT.SHOW_TOP_N, localeCode),
            specialRequests: makeTranslator(KEYS.REPORT.SPECIAL_REQUESTS, localeCode),
            spend: makeTranslator(KEYS.REPORT.SPEND, localeCode),
            startDate: makeTranslator(KEYS.REPORT.START_DATE, localeCode),
            startDateBeforeToday: makeTranslator(KEYS.REPORT.START_DATE_BEFORE_TODAY, localeCode),
            status: makeTranslator(KEYS.REPORT.STATUS, localeCode),
            summary: makeTranslator(KEYS.REPORT.SUMMARY, localeCode),
            supportedEvents: makeTranslator(KEYS.REPORT.SUPPORTED_EVENTS, localeCode),
            templateUsage: makeTranslator(KEYS.REPORT.TEMPLATE_USAGE, localeCode),
            templateUseByLocation: makeTranslator(KEYS.REPORT.TEMPLATE_USE_BY_LOCATION, localeCode),
            templateUses: makeTranslator(KEYS.REPORT.TEMPLATE_USES, localeCode),
            templateUsesPlural: makeTranslator(KEYS.REPORT.TEMPLATE_USES_plural, localeCode),
            templatesBuiltByTime: makeTranslator(KEYS.REPORT.TEMPLATES_BUILT_BY_TIME, localeCode),
            total: makeTranslator(KEYS.REPORT.TOTAL, localeCode),
            totalCloseRatio: makeTranslator(KEYS.REPORT.TOTAL_CLOSE_RATIO, localeCode),
            totalConversionWorth: makeTranslator(KEYS.REPORT.TOTAL_CONVERSION_WORTH, localeCode),
            totalConversions: makeTranslator(KEYS.REPORT.TOTAL_CONVERSIONS, localeCode),
            totalEvents: makeTranslator(KEYS.REPORT.TOTAL_EVENTS, localeCode),
            totalImpressions: makeTranslator(KEYS.REPORT.TOTAL_IMPRESSIONS, localeCode),
            totalLeads: makeTranslator(KEYS.REPORT.TOTAL_LEADS, localeCode),
            totalPosts: makeTranslator(KEYS.REPORT.TOTAL_POSTS, localeCode),
            totalReachVsTotalPaid: makeTranslator(KEYS.REPORT.TOTAL_REACH_VS_TOTAL_PAID, localeCode),
            totalSales: makeTranslator(KEYS.REPORT.TOTAL_SALES, localeCode),
            totalSpend: makeTranslator(KEYS.REPORT.TOTAL_SPEND, localeCode),
            totalUniqueViews: makeTranslator(KEYS.REPORT.TOTAL_UNIQUE_VIEWS, localeCode),
            totalVisitors: makeTranslator(KEYS.REPORT.TOTAL_VISITORS, localeCode),
            tourCloseRatio: makeTranslator(KEYS.REPORT.TOUR_CLOSE_RATIO, localeCode),
            tourSale: makeTranslator(KEYS.REPORT.TOUR_SALE, localeCode),
            tourShowUps: makeTranslator(KEYS.REPORT.TOUR_SHOW_UPS, localeCode),
            types: {
                emailCampaigns: {
                    name: makeTranslator(KEYS.REPORT.TYPES.EMAIL_CAMPAIGNS.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.EMAIL_CAMPAIGNS.TITLE, localeCode)
                },
                facebook: {
                    name: makeTranslator(KEYS.REPORT.TYPES.FACEBOOK.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.FACEBOOK.TITLE, localeCode)
                },
                googleMyBusiness: {
                    name: makeTranslator(KEYS.REPORT.TYPES.GOOGLE_MY_BUSINESS.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.GOOGLE_MY_BUSINESS.TITLE, localeCode)
                },
                instagram: {
                    name: makeTranslator(KEYS.REPORT.TYPES.INSTAGRAM.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.INSTAGRAM.TITLE, localeCode)
                },
                overview: {
                    name: makeTranslator(KEYS.REPORT.TYPES.OVERVIEW.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.OVERVIEW.TITLE, localeCode)
                },
                paidMedia: {
                    name: makeTranslator(KEYS.REPORT.TYPES.PAID_MEDIA.NAME, localeCode),
                    title: makeTranslator(KEYS.REPORT.TYPES.PAID_MEDIA.TITLE, localeCode)
                },
                title: makeTranslator(KEYS.REPORT.TYPES.TITLE, localeCode)
            },
            uniqueClicks: makeTranslator(KEYS.REPORT.UNIQUE_CLICKS, localeCode),
            uniqueOpened: makeTranslator(KEYS.REPORT.UNIQUE_OPENED, localeCode),
            unreachedMarket: makeTranslator(KEYS.REPORT.UNREACHED_MARKET, localeCode),
            unreachedMarketHint: makeTranslator(KEYS.REPORT.UNREACHED_MARKET_HINT, localeCode),
            valuePerConversion: makeTranslator(KEYS.REPORT.VALUE_PER_CONVERSION, localeCode),
            visitors: makeTranslator(KEYS.REPORT.VISITORS, localeCode),
            waitForLocations: makeTranslator(KEYS.REPORT.WAIT_FOR_LOCATIONS, localeCode),
            walkInCloseRatio: makeTranslator(KEYS.REPORT.WALK_IN_CLOSE_RATIO, localeCode),
            walkInSale: makeTranslator(KEYS.REPORT.WALK_IN_SALE, localeCode),
            walkInTotal: makeTranslator(KEYS.REPORT.WALK_IN_TOTAL, localeCode),
            website: makeTranslator(KEYS.REPORT.WEBSITE, localeCode)
        },
        requests: {
            alreadyPaidDifference: makeTranslator(KEYS.REQUESTS.ALREADY_PAID_DIFFERENCE, localeCode),
            amendmentsRequested: makeTranslator(KEYS.REQUESTS.AMENDMENTS_REQUESTED, localeCode),
            awaitingApproval: makeTranslator(KEYS.REQUESTS.AWAITING_APPROVAL, localeCode),
            awaitingHeadOfficeApproval: makeTranslator(KEYS.REQUESTS.AWAITING_HEAD_OFFICE_APPROVAL, localeCode),
            beginPayment: makeTranslator(KEYS.REQUESTS.BEGIN_PAYMENT, localeCode),
            brief: makeTranslator(KEYS.REQUESTS.BRIEF, localeCode),
            clickToLoadClosedRequests: makeTranslator(KEYS.REQUESTS.CLICK_TO_LOAD_CLOSED_REQUESTS, localeCode),
            clientLocation: makeTranslator(KEYS.REQUESTS.CLIENT_LOCATION, localeCode),
            closed: makeTranslator(KEYS.REQUESTS.CLOSED, localeCode),
            dateRequestedBy: makeTranslator(KEYS.REQUESTS.DATE_REQUESTED_BY, localeCode),
            dateRequiredBy: makeTranslator(KEYS.REQUESTS.DATE_REQUIRED_BY, localeCode),
            dateSubmitted: makeTranslator(KEYS.REQUESTS.DATE_SUBMITTED, localeCode),
            deliverables: makeTranslator(KEYS.REQUESTS.DELIVERABLES, localeCode),
            emails: {
                added: {
                    newSpecialRequest: makeTranslator(KEYS.REQUESTS.EMAILS.ADDED.NEW_SPECIAL_REQUEST, localeCode),
                    requestIsDueBy: makeTranslator(KEYS.REQUESTS.EMAILS.ADDED.REQUEST_IS_DUE_BY, localeCode)
                },
                commentAdded: {
                    specialRequestHasBeenUpdated: makeTranslator(KEYS.REQUESTS.EMAILS.COMMENT_ADDED.SPECIAL_REQUEST_HAS_BEEN_UPDATED, localeCode),
                    subjectLine: makeTranslator(KEYS.REQUESTS.EMAILS.COMMENT_ADDED.SUBJECT_LINE, localeCode)
                },
                viewSpecialRequest: makeTranslator(KEYS.REQUESTS.EMAILS.VIEW_SPECIAL_REQUEST, localeCode)
            },
            escalated: makeTranslator(KEYS.REQUESTS.ESCALATED, localeCode),
            failedToGetSpecialRequest: makeTranslator(KEYS.REQUESTS.FAILED_TO_GET_SPECIAL_REQUEST, localeCode),
            failedToGetSpecialRequests: makeTranslator(KEYS.REQUESTS.FAILED_TO_GET_SPECIAL_REQUESTS, localeCode),
            filter: {
                client: makeTranslator(KEYS.REQUESTS.FILTER.CLIENT, localeCode),
                date: makeTranslator(KEYS.REQUESTS.FILTER.DATE, localeCode),
                status: makeTranslator(KEYS.REQUESTS.FILTER.STATUS, localeCode),
                title: makeTranslator(KEYS.REQUESTS.FILTER.TITLE, localeCode)
            },
            id: makeTranslator(KEYS.REQUESTS.ID, localeCode),
            inProgress: makeTranslator(KEYS.REQUESTS.IN_PROGRESS, localeCode),
            invalidDateRequiredBy: makeTranslator(KEYS.REQUESTS.INVALID_DATE_REQUIRED_BY, localeCode),
            loadManagersFailed: makeTranslator(KEYS.REQUESTS.LOAD_MANAGERS_FAILED, localeCode),
            moreInfoRequired: makeTranslator(KEYS.REQUESTS.MORE_INFO_REQUIRED, localeCode),
            newRequest: makeTranslator(KEYS.REQUESTS.NEW_REQUEST, localeCode),
            payment: makeTranslator(KEYS.REQUESTS.PAYMENT, localeCode),
            paymentOverpaid: makeTranslator(KEYS.REQUESTS.PAYMENT_OVERPAID, localeCode),
            paymentRequired: makeTranslator(KEYS.REQUESTS.PAYMENT_REQUIRED, localeCode),
            pleaseEnterDeliverables: makeTranslator(KEYS.REQUESTS.PLEASE_ENTER_DELIVERABLES, localeCode),
            previousQuoteDifference: makeTranslator(KEYS.REQUESTS.PREVIOUS_QUOTE_DIFFERENCE, localeCode),
            quote: makeTranslator(KEYS.REQUESTS.QUOTE, localeCode),
            quoteApproved: makeTranslator(KEYS.REQUESTS.QUOTE_APPROVED, localeCode),
            quoteRejected: makeTranslator(KEYS.REQUESTS.QUOTE_REJECTED, localeCode),
            quoteSent: makeTranslator(KEYS.REQUESTS.QUOTE_SENT, localeCode),
            quoted: makeTranslator(KEYS.REQUESTS.QUOTED, localeCode),
            requestSaved: makeTranslator(KEYS.REQUESTS.REQUEST_SAVED, localeCode),
            retrieveSpecialRequest: makeTranslator(KEYS.REQUESTS.RETRIEVE_SPECIAL_REQUEST, localeCode),
            saveSpecialRequest: makeTranslator(KEYS.REQUESTS.SAVE_SPECIAL_REQUEST, localeCode),
            selectedDeliverables: makeTranslator(KEYS.REQUESTS.SELECTED_DELIVERABLES, localeCode),
            sendQuote: makeTranslator(KEYS.REQUESTS.SEND_QUOTE, localeCode),
            status: makeTranslator(KEYS.REQUESTS.STATUS, localeCode),
            submitted: makeTranslator(KEYS.REQUESTS.SUBMITTED, localeCode),
            updated: makeTranslator(KEYS.REQUESTS.UPDATED, localeCode)
        },
        roadmap: {
            later: {
                heading: makeTranslator(KEYS.ROADMAP.LATER.HEADING, localeCode),
                items: {
                    item1: makeTranslator(KEYS.ROADMAP.LATER.ITEMS.ITEM_1, localeCode),
                    item2: makeTranslator(KEYS.ROADMAP.LATER.ITEMS.ITEM_2, localeCode),
                    item3: makeTranslator(KEYS.ROADMAP.LATER.ITEMS.ITEM_3, localeCode),
                    item4: makeTranslator(KEYS.ROADMAP.LATER.ITEMS.ITEM_4, localeCode),
                    item5: makeTranslator(KEYS.ROADMAP.LATER.ITEMS.ITEM_5, localeCode)
                }
            },
            next: {
                heading: makeTranslator(KEYS.ROADMAP.NEXT.HEADING, localeCode),
                items: {
                    item1: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_1, localeCode),
                    item2: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_2, localeCode),
                    item3: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_3, localeCode),
                    item4: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_4, localeCode),
                    item5: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_5, localeCode),
                    item6: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_6, localeCode),
                    item7: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_7, localeCode),
                    item8: makeTranslator(KEYS.ROADMAP.NEXT.ITEMS.ITEM_8, localeCode)
                }
            },
            now: {
                heading: makeTranslator(KEYS.ROADMAP.NOW.HEADING, localeCode),
                items: {
                    item1: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_1, localeCode),
                    item2: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_2, localeCode),
                    item3: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_3, localeCode),
                    item4: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_4, localeCode),
                    item5: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_5, localeCode),
                    item6: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_6, localeCode),
                    item7: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_7, localeCode),
                    item8: makeTranslator(KEYS.ROADMAP.NOW.ITEMS.ITEM_8, localeCode)
                }
            },
            recentlyDelivered: {
                heading: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.HEADING, localeCode),
                items: {
                    item1: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_1, localeCode),
                    item2: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_2, localeCode),
                    item3: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_3, localeCode),
                    item4: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_4, localeCode),
                    item5: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_5, localeCode),
                    item6: makeTranslator(KEYS.ROADMAP.RECENTLY_DELIVERED.ITEMS.ITEM_6, localeCode)
                }
            }
        },
        schedule: {
            emails: {
                downloadTheApp: makeTranslator(KEYS.SCHEDULE.EMAILS.DOWNLOAD_THE_APP, localeCode),
                failedToNotify: {
                    content: makeTranslator(KEYS.SCHEDULE.EMAILS.FAILED_TO_NOTIFY.CONTENT, localeCode),
                    heading1: makeTranslator(KEYS.SCHEDULE.EMAILS.FAILED_TO_NOTIFY.HEADING_1, localeCode),
                    subjectLine: makeTranslator(KEYS.SCHEDULE.EMAILS.FAILED_TO_NOTIFY.SUBJECT_LINE, localeCode)
                },
                noDevices: {
                    content1: makeTranslator(KEYS.SCHEDULE.EMAILS.NO_DEVICES.CONTENT_1, localeCode),
                    content2: makeTranslator(KEYS.SCHEDULE.EMAILS.NO_DEVICES.CONTENT_2, localeCode),
                    content3: makeTranslator(KEYS.SCHEDULE.EMAILS.NO_DEVICES.CONTENT_3, localeCode),
                    heading1: makeTranslator(KEYS.SCHEDULE.EMAILS.NO_DEVICES.HEADING_1, localeCode),
                    subjectLine: makeTranslator(KEYS.SCHEDULE.EMAILS.NO_DEVICES.SUBJECT_LINE, localeCode)
                }
            },
            page: {
                dialogs: {
                    delete: {
                        confirm: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.CONFIRM, localeCode),
                        disabledLegacy: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_LEGACY, localeCode),
                        disabledScheduling: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.DISABLED_SCHEDULING, localeCode),
                        failedToDelete: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.FAILED_TO_DELETE, localeCode),
                        optionForMultiple: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_MULTIPLE, localeCode),
                        optionForSingle: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.OPTION_FOR_SINGLE, localeCode),
                        successfullyDeletedPost: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.SUCCESSFULLY_DELETED_POST, localeCode),
                        title: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.DELETE.TITLE, localeCode)
                    },
                    editCaption: {
                        contactingPlatform: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.CONTACTING_PLATFORM, localeCode),
                        failedToEdit: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.FAILED_TO_EDIT, localeCode),
                        optionForMultiple: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_MULTIPLE, localeCode),
                        optionForSingle: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.OPTION_FOR_SINGLE, localeCode),
                        successfullyEditedCaption: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.SUCCESSFULLY_EDITED_CAPTION, localeCode),
                        title: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.EDIT_CAPTION.TITLE, localeCode)
                    },
                    reschedule: {
                        confirm: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.CONFIRM, localeCode),
                        deleted: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DELETED, localeCode),
                        disabledLegacy: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_LEGACY, localeCode),
                        disabledScheduling: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.DISABLED_SCHEDULING, localeCode),
                        failedToReschedule: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.FAILED_TO_RESCHEDULE, localeCode),
                        optionForMultiple: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_MULTIPLE, localeCode),
                        optionForSingle: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.OPTION_FOR_SINGLE, localeCode),
                        successfullyRescheduledPost: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.SUCCESSFULLY_RESCHEDULED_POST, localeCode),
                        title: makeTranslator(KEYS.SCHEDULE.PAGE.DIALOGS.RESCHEDULE.TITLE, localeCode)
                    }
                },
                headerTitle: makeTranslator(KEYS.SCHEDULE.PAGE.HEADER_TITLE, localeCode),
                reschedule: makeTranslator(KEYS.SCHEDULE.PAGE.RESCHEDULE, localeCode),
                table: {
                    headers: {
                        action: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.HEADERS.ACTION, localeCode),
                        caption: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.HEADERS.CAPTION, localeCode),
                        locations: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.HEADERS.LOCATIONS, localeCode),
                        post: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.HEADERS.POST, localeCode),
                        time: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.HEADERS.TIME, localeCode)
                    },
                    loadNewerPosts: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.LOAD_NEWER_POSTS, localeCode),
                    loadOlderPosts: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.LOAD_OLDER_POSTS, localeCode),
                    noScheduledPostsFoundForPlatform: makeTranslator(KEYS.SCHEDULE.PAGE.TABLE.NO_SCHEDULED_POSTS_FOUND_FOR_PLATFORM, localeCode)
                }
            },
            posts: {
                caption: makeTranslator(KEYS.SCHEDULE.POSTS.CAPTION, localeCode),
                copiedToClipboard: makeTranslator(KEYS.SCHEDULE.POSTS.COPIED_TO_CLIPBOARD, localeCode),
                copiedToClipboardFailed: makeTranslator(KEYS.SCHEDULE.POSTS.COPIED_TO_CLIPBOARD_FAILED, localeCode),
                copyCaption: makeTranslator(KEYS.SCHEDULE.POSTS.COPY_CAPTION, localeCode),
                downloadImage: makeTranslator(KEYS.SCHEDULE.POSTS.DOWNLOAD_IMAGE, localeCode),
                getScheduledDetails: makeTranslator(KEYS.SCHEDULE.POSTS.GET_SCHEDULED_DETAILS, localeCode),
                postDetailsSms: makeTranslator(KEYS.SCHEDULE.POSTS.POST_DETAILS_SMS, localeCode),
                postImmediately: makeTranslator(KEYS.SCHEDULE.POSTS.POST_IMMEDIATELY, localeCode),
                postScheduledFor: makeTranslator(KEYS.SCHEDULE.POSTS.POST_SCHEDULED_FOR, localeCode),
                smsDownloadMessage: makeTranslator(KEYS.SCHEDULE.POSTS.SMS_DOWNLOAD_MESSAGE, localeCode),
                unableToFindPost: makeTranslator(KEYS.SCHEDULE.POSTS.UNABLE_TO_FIND_POST, localeCode),
                unableToFindPostHeading: makeTranslator(KEYS.SCHEDULE.POSTS.UNABLE_TO_FIND_POST_HEADING, localeCode)
            },
            pushNotifications: {
                timeToPost: makeTranslator(KEYS.SCHEDULE.PUSH_NOTIFICATIONS.TIME_TO_POST, localeCode)
            },
            scheduledWithMobileApp: makeTranslator(KEYS.SCHEDULE.SCHEDULED_WITH_MOBILE_APP, localeCode)
        },
        shoppingCart: {
            addToCart: makeTranslator(KEYS.SHOPPING_CART.ADD_TO_CART, localeCode),
            checkout: {
                address: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.ADDRESS, localeCode),
                cardDetails: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.CARD_DETAILS, localeCode),
                checkout: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.CHECKOUT, localeCode),
                completePayment: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.COMPLETE_PAYMENT, localeCode),
                deleteItem: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.DELETE_ITEM, localeCode),
                deleteItemConfirmation: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.DELETE_ITEM_CONFIRMATION, localeCode),
                incTax: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.INC_TAX, localeCode),
                locations: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.LOCATIONS, localeCode),
                payAmount: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PAY_AMOUNT, localeCode),
                paymentPending: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PAYMENT_PENDING, localeCode),
                paymentSuccessful: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PAYMENT_SUCCESSFUL, localeCode),
                printOrder: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PRINT_ORDER, localeCode),
                printProviderNotConfiguredProperly: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PRINT_PROVIDER_NOT_CONFIGURED_PROPERLY, localeCode),
                purchaseComplete: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.PURCHASE_COMPLETE, localeCode),
                quantity: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.QUANTITY, localeCode),
                shipping: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.SHIPPING, localeCode),
                shippingDetailsInvalid: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.SHIPPING_DETAILS_INVALID, localeCode),
                updateItemQuantity: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.UPDATE_ITEM_QUANTITY, localeCode),
                viewReceipt: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.VIEW_RECEIPT, localeCode),
                yourReceiptCanBeViewedBelow: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT.YOUR_RECEIPT_CAN_BE_VIEWED_BELOW, localeCode)
            },
            checkoutNow: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT_NOW, localeCode),
            checkoutYourPrintItems: makeTranslator(KEYS.SHOPPING_CART.CHECKOUT_YOUR_PRINT_ITEMS, localeCode),
            emails: {
                date: makeTranslator(KEYS.SHOPPING_CART.EMAILS.DATE, localeCode),
                orderNumber: makeTranslator(KEYS.SHOPPING_CART.EMAILS.ORDER_NUMBER, localeCode),
                printOrderForProvider: {
                    agency: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.AGENCY, localeCode),
                    client: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CLIENT, localeCode),
                    contactEmail: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.CONTACT_EMAIL, localeCode),
                    orderReceived: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.ORDER_RECEIVED, localeCode),
                    subjectLine: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_PROVIDER.SUBJECT_LINE, localeCode)
                },
                printOrderForUser: {
                    orderReceived: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.ORDER_RECEIVED, localeCode),
                    printProvider: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER, localeCode),
                    printProviderEmail: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.PRINT_PROVIDER_EMAIL, localeCode),
                    subjectLine: makeTranslator(KEYS.SHOPPING_CART.EMAILS.PRINT_ORDER_FOR_USER.SUBJECT_LINE, localeCode)
                }
            },
            fetchItemCount: makeTranslator(KEYS.SHOPPING_CART.FETCH_ITEM_COUNT, localeCode),
            fetchOrders: makeTranslator(KEYS.SHOPPING_CART.FETCH_ORDERS, localeCode),
            printRequestAddedToCart: makeTranslator(KEYS.SHOPPING_CART.PRINT_REQUEST_ADDED_TO_CART, localeCode)
        },
        stats: {
            emails: {
                accessTokenError: {
                    accessErrorFor: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.ACCESS_ERROR_FOR, localeCode),
                    authorizeService: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.AUTHORIZE_SERVICE, localeCode),
                    ifAccessToIsNoLongerRequired: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_ACCESS_TO_IS_NO_LONGER_REQUIRED, localeCode),
                    ifNotResolvedContactSupport: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.IF_NOT_RESOLVED_CONTACT_SUPPORT, localeCode),
                    subjectLine: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.SUBJECT_LINE, localeCode),
                    tryLoggingInAndReAuthorizing: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.TRY_LOGGING_IN_AND_RE_AUTHORIZING, localeCode),
                    weHadAProblemTryingToAccess: makeTranslator(KEYS.STATS.EMAILS.ACCESS_TOKEN_ERROR.WE_HAD_A_PROBLEM_TRYING_TO_ACCESS, localeCode)
                }
            }
        },
        terms: {
            heading: makeTranslator(KEYS.TERMS.HEADING, localeCode),
            section01: {
                description: makeTranslator(KEYS.TERMS.SECTION_01.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_01.HEADING, localeCode),
                partA: makeTranslator(KEYS.TERMS.SECTION_01.PART_A, localeCode),
                partB: makeTranslator(KEYS.TERMS.SECTION_01.PART_B, localeCode)
            },
            section02: {
                description: makeTranslator(KEYS.TERMS.SECTION_02.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_02.HEADING, localeCode)
            },
            section03: {
                description: makeTranslator(KEYS.TERMS.SECTION_03.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_03.HEADING, localeCode)
            },
            section04: {
                heading: makeTranslator(KEYS.TERMS.SECTION_04.HEADING, localeCode),
                part01: makeTranslator(KEYS.TERMS.SECTION_04.PART_01, localeCode),
                part02: makeTranslator(KEYS.TERMS.SECTION_04.PART_02, localeCode)
            },
            section05: {
                heading: makeTranslator(KEYS.TERMS.SECTION_05.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_05.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_05.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_05.PART_01.PART_B, localeCode),
                    partC: makeTranslator(KEYS.TERMS.SECTION_05.PART_01.PART_C, localeCode),
                    partD: makeTranslator(KEYS.TERMS.SECTION_05.PART_01.PART_D, localeCode)
                }
            },
            section06: {
                heading: makeTranslator(KEYS.TERMS.SECTION_06.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_B, localeCode),
                    partC: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_C, localeCode),
                    partD: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_D, localeCode),
                    partE: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_E, localeCode),
                    partF: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_F, localeCode),
                    partG: makeTranslator(KEYS.TERMS.SECTION_06.PART_01.PART_G, localeCode)
                },
                part02: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_06.PART_02.HEADING, localeCode)
                }
            },
            section07: {
                heading: makeTranslator(KEYS.TERMS.SECTION_07.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_07.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_07.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_07.PART_01.PART_B, localeCode)
                },
                part02: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_07.PART_02.HEADING, localeCode)
                },
                part03: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_07.PART_03.HEADING, localeCode)
                },
                part04: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_07.PART_04.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_07.PART_04.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_07.PART_04.PART_B, localeCode)
                },
                part05: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_07.PART_05.HEADING, localeCode)
                }
            },
            section08: {
                description: makeTranslator(KEYS.TERMS.SECTION_08.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_08.HEADING, localeCode),
                partA: makeTranslator(KEYS.TERMS.SECTION_08.PART_A, localeCode),
                partB: makeTranslator(KEYS.TERMS.SECTION_08.PART_B, localeCode)
            },
            section09: {
                heading: makeTranslator(KEYS.TERMS.SECTION_09.HEADING, localeCode),
                part01: makeTranslator(KEYS.TERMS.SECTION_09.PART_01, localeCode),
                part02: makeTranslator(KEYS.TERMS.SECTION_09.PART_02, localeCode)
            },
            section10: {
                heading: makeTranslator(KEYS.TERMS.SECTION_10.HEADING, localeCode),
                partA: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.HEADING, localeCode),
                    part01: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.PART_01, localeCode),
                    part02: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.PART_02, localeCode),
                    part03: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.PART_03, localeCode),
                    part04: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.PART_04, localeCode),
                    part05: makeTranslator(KEYS.TERMS.SECTION_10.PART_A.PART_05, localeCode)
                },
                partB: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_10.PART_B.HEADING, localeCode),
                    part01: makeTranslator(KEYS.TERMS.SECTION_10.PART_B.PART_01, localeCode),
                    part02: makeTranslator(KEYS.TERMS.SECTION_10.PART_B.PART_02, localeCode),
                    part03: makeTranslator(KEYS.TERMS.SECTION_10.PART_B.PART_03, localeCode),
                    part04: makeTranslator(KEYS.TERMS.SECTION_10.PART_B.PART_04, localeCode)
                }
            },
            section11: {
                heading: makeTranslator(KEYS.TERMS.SECTION_11.HEADING, localeCode),
                partA: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.HEADING, localeCode),
                    part01: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_01, localeCode),
                    part02: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_02, localeCode),
                    part03: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_03, localeCode),
                    part04: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_04, localeCode),
                    part05: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_05, localeCode),
                    part06: makeTranslator(KEYS.TERMS.SECTION_11.PART_A.PART_06, localeCode)
                },
                partB: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_11.PART_B.HEADING, localeCode)
                }
            },
            section12: {
                heading: makeTranslator(KEYS.TERMS.SECTION_12.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_12.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_12.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_12.PART_01.PART_B, localeCode)
                },
                part02: makeTranslator(KEYS.TERMS.SECTION_12.PART_02, localeCode),
                part03: makeTranslator(KEYS.TERMS.SECTION_12.PART_03, localeCode)
            },
            section13: {
                heading: makeTranslator(KEYS.TERMS.SECTION_13.HEADING, localeCode),
                part01: makeTranslator(KEYS.TERMS.SECTION_13.PART_01, localeCode),
                part02: makeTranslator(KEYS.TERMS.SECTION_13.PART_02, localeCode)
            },
            section14: {
                description: makeTranslator(KEYS.TERMS.SECTION_14.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_14.HEADING, localeCode)
            },
            section15: {
                heading: makeTranslator(KEYS.TERMS.SECTION_15.HEADING, localeCode),
                part01: makeTranslator(KEYS.TERMS.SECTION_15.PART_01, localeCode),
                part02: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.PART_A, localeCode),
                    partB: {
                        heading: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.PART_B.HEADING, localeCode),
                        part01: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.PART_B.PART_01, localeCode),
                        part02: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.PART_B.PART_02, localeCode)
                    },
                    partC: makeTranslator(KEYS.TERMS.SECTION_15.PART_02.PART_C, localeCode)
                }
            },
            section16: {
                description: makeTranslator(KEYS.TERMS.SECTION_16.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_16.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_B, localeCode),
                    partC: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_C, localeCode),
                    partD: {
                        heading: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.HEADING, localeCode),
                        part01: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_01, localeCode),
                        part02: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_02, localeCode),
                        part03: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_03, localeCode),
                        part04: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_04, localeCode),
                        part05: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_05, localeCode),
                        part06: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_06, localeCode),
                        part07: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_07, localeCode),
                        part08: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_08, localeCode),
                        part09: makeTranslator(KEYS.TERMS.SECTION_16.PART_01.PART_D.PART_09, localeCode)
                    }
                }
            },
            section17: {
                heading: makeTranslator(KEYS.TERMS.SECTION_17.HEADING, localeCode),
                part01: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.PART_B, localeCode),
                    partC: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.PART_C, localeCode),
                    partD: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.PART_D, localeCode),
                    partE: makeTranslator(KEYS.TERMS.SECTION_17.PART_01.PART_E, localeCode)
                },
                part02: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_17.PART_02.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_17.PART_02.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_17.PART_02.PART_B, localeCode),
                    partC: makeTranslator(KEYS.TERMS.SECTION_17.PART_02.PART_C, localeCode),
                    partD: makeTranslator(KEYS.TERMS.SECTION_17.PART_02.PART_D, localeCode)
                },
                part03: {
                    heading: makeTranslator(KEYS.TERMS.SECTION_17.PART_03.HEADING, localeCode),
                    partA: makeTranslator(KEYS.TERMS.SECTION_17.PART_03.PART_A, localeCode),
                    partB: makeTranslator(KEYS.TERMS.SECTION_17.PART_03.PART_B, localeCode)
                }
            },
            section18: {
                description: makeTranslator(KEYS.TERMS.SECTION_18.DESCRIPTION, localeCode),
                heading: makeTranslator(KEYS.TERMS.SECTION_18.HEADING, localeCode)
            },
            section19: {
                heading: makeTranslator(KEYS.TERMS.SECTION_19.HEADING, localeCode),
                partA: makeTranslator(KEYS.TERMS.SECTION_19.PART_A, localeCode),
                partB: makeTranslator(KEYS.TERMS.SECTION_19.PART_B, localeCode),
                partC: makeTranslator(KEYS.TERMS.SECTION_19.PART_C, localeCode),
                partD: makeTranslator(KEYS.TERMS.SECTION_19.PART_D, localeCode),
                partE: makeTranslator(KEYS.TERMS.SECTION_19.PART_E, localeCode),
                partF: makeTranslator(KEYS.TERMS.SECTION_19.PART_F, localeCode),
                partG: makeTranslator(KEYS.TERMS.SECTION_19.PART_G, localeCode),
                partH: makeTranslator(KEYS.TERMS.SECTION_19.PART_H, localeCode)
            }
        },
        timezones: {
            adak: makeTranslator(KEYS.TIMEZONES.ADAK, localeCode),
            adelaide: makeTranslator(KEYS.TIMEZONES.ADELAIDE, localeCode),
            almaty: makeTranslator(KEYS.TIMEZONES.ALMATY, localeCode),
            amman: makeTranslator(KEYS.TIMEZONES.AMMAN, localeCode),
            anchorage: makeTranslator(KEYS.TIMEZONES.ANCHORAGE, localeCode),
            apia: makeTranslator(KEYS.TIMEZONES.APIA, localeCode),
            araguaina: makeTranslator(KEYS.TIMEZONES.ARAGUAINA, localeCode),
            astrakhan: makeTranslator(KEYS.TIMEZONES.ASTRAKHAN, localeCode),
            asuncion: makeTranslator(KEYS.TIMEZONES.ASUNCION, localeCode),
            auckland: makeTranslator(KEYS.TIMEZONES.AUCKLAND, localeCode),
            azores: makeTranslator(KEYS.TIMEZONES.AZORES, localeCode),
            baghdad: makeTranslator(KEYS.TIMEZONES.BAGHDAD, localeCode),
            bahia: makeTranslator(KEYS.TIMEZONES.BAHIA, localeCode),
            baku: makeTranslator(KEYS.TIMEZONES.BAKU, localeCode),
            bangkok: makeTranslator(KEYS.TIMEZONES.BANGKOK, localeCode),
            barnaul: makeTranslator(KEYS.TIMEZONES.BARNAUL, localeCode),
            beirut: makeTranslator(KEYS.TIMEZONES.BEIRUT, localeCode),
            berlin: makeTranslator(KEYS.TIMEZONES.BERLIN, localeCode),
            bogota: makeTranslator(KEYS.TIMEZONES.BOGOTA, localeCode),
            bougainville: makeTranslator(KEYS.TIMEZONES.BOUGAINVILLE, localeCode),
            brisbane: makeTranslator(KEYS.TIMEZONES.BRISBANE, localeCode),
            bucharest: makeTranslator(KEYS.TIMEZONES.BUCHAREST, localeCode),
            budapest: makeTranslator(KEYS.TIMEZONES.BUDAPEST, localeCode),
            buenosAires: makeTranslator(KEYS.TIMEZONES.BUENOS_AIRES, localeCode),
            cairo: makeTranslator(KEYS.TIMEZONES.CAIRO, localeCode),
            calcutta: makeTranslator(KEYS.TIMEZONES.CALCUTTA, localeCode),
            cancun: makeTranslator(KEYS.TIMEZONES.CANCUN, localeCode),
            capeVerde: makeTranslator(KEYS.TIMEZONES.CAPE_VERDE, localeCode),
            caracas: makeTranslator(KEYS.TIMEZONES.CARACAS, localeCode),
            casablanca: makeTranslator(KEYS.TIMEZONES.CASABLANCA, localeCode),
            cayenne: makeTranslator(KEYS.TIMEZONES.CAYENNE, localeCode),
            chatham: makeTranslator(KEYS.TIMEZONES.CHATHAM, localeCode),
            chicago: makeTranslator(KEYS.TIMEZONES.CHICAGO, localeCode),
            chihuahua: makeTranslator(KEYS.TIMEZONES.CHIHUAHUA, localeCode),
            chisinau: makeTranslator(KEYS.TIMEZONES.CHISINAU, localeCode),
            chita: makeTranslator(KEYS.TIMEZONES.CHITA, localeCode),
            colombo: makeTranslator(KEYS.TIMEZONES.COLOMBO, localeCode),
            cuiaba: makeTranslator(KEYS.TIMEZONES.CUIABA, localeCode),
            damascus: makeTranslator(KEYS.TIMEZONES.DAMASCUS, localeCode),
            darwin: makeTranslator(KEYS.TIMEZONES.DARWIN, localeCode),
            denver: makeTranslator(KEYS.TIMEZONES.DENVER, localeCode),
            dhaka: makeTranslator(KEYS.TIMEZONES.DHAKA, localeCode),
            dubai: makeTranslator(KEYS.TIMEZONES.DUBAI, localeCode),
            easter: makeTranslator(KEYS.TIMEZONES.EASTER, localeCode),
            edmonton: makeTranslator(KEYS.TIMEZONES.EDMONTON, localeCode),
            enderbury: makeTranslator(KEYS.TIMEZONES.ENDERBURY, localeCode),
            eucla: makeTranslator(KEYS.TIMEZONES.EUCLA, localeCode),
            fiji: makeTranslator(KEYS.TIMEZONES.FIJI, localeCode),
            gambier: makeTranslator(KEYS.TIMEZONES.GAMBIER, localeCode),
            godthab: makeTranslator(KEYS.TIMEZONES.GODTHAB, localeCode),
            grandTurk: makeTranslator(KEYS.TIMEZONES.GRAND_TURK, localeCode),
            guadalcanal: makeTranslator(KEYS.TIMEZONES.GUADALCANAL, localeCode),
            guatemala: makeTranslator(KEYS.TIMEZONES.GUATEMALA, localeCode),
            halifax: makeTranslator(KEYS.TIMEZONES.HALIFAX, localeCode),
            havana: makeTranslator(KEYS.TIMEZONES.HAVANA, localeCode),
            hebron: makeTranslator(KEYS.TIMEZONES.HEBRON, localeCode),
            hoChiMinh: makeTranslator(KEYS.TIMEZONES.HO_CHI_MINH, localeCode),
            hobart: makeTranslator(KEYS.TIMEZONES.HOBART, localeCode),
            honolulu: makeTranslator(KEYS.TIMEZONES.HONOLULU, localeCode),
            hovd: makeTranslator(KEYS.TIMEZONES.HOVD, localeCode),
            indianapolis: makeTranslator(KEYS.TIMEZONES.INDIANAPOLIS, localeCode),
            irkutsk: makeTranslator(KEYS.TIMEZONES.IRKUTSK, localeCode),
            istanbul: makeTranslator(KEYS.TIMEZONES.ISTANBUL, localeCode),
            jerusalem: makeTranslator(KEYS.TIMEZONES.JERUSALEM, localeCode),
            johannesburg: makeTranslator(KEYS.TIMEZONES.JOHANNESBURG, localeCode),
            juba: makeTranslator(KEYS.TIMEZONES.JUBA, localeCode),
            kabul: makeTranslator(KEYS.TIMEZONES.KABUL, localeCode),
            kaliningrad: makeTranslator(KEYS.TIMEZONES.KALININGRAD, localeCode),
            kamchatka: makeTranslator(KEYS.TIMEZONES.KAMCHATKA, localeCode),
            karachi: makeTranslator(KEYS.TIMEZONES.KARACHI, localeCode),
            katmandu: makeTranslator(KEYS.TIMEZONES.KATMANDU, localeCode),
            khartoum: makeTranslator(KEYS.TIMEZONES.KHARTOUM, localeCode),
            kiev: makeTranslator(KEYS.TIMEZONES.KIEV, localeCode),
            kiritimati: makeTranslator(KEYS.TIMEZONES.KIRITIMATI, localeCode),
            krasnoyarsk: makeTranslator(KEYS.TIMEZONES.KRASNOYARSK, localeCode),
            kualaLumpur: makeTranslator(KEYS.TIMEZONES.KUALA_LUMPUR, localeCode),
            laPaz: makeTranslator(KEYS.TIMEZONES.LA_PAZ, localeCode),
            lagos: makeTranslator(KEYS.TIMEZONES.LAGOS, localeCode),
            london: makeTranslator(KEYS.TIMEZONES.LONDON, localeCode),
            lordHowe: makeTranslator(KEYS.TIMEZONES.LORD_HOWE, localeCode),
            losAngeles: makeTranslator(KEYS.TIMEZONES.LOS_ANGELES, localeCode),
            magadan: makeTranslator(KEYS.TIMEZONES.MAGADAN, localeCode),
            manila: makeTranslator(KEYS.TIMEZONES.MANILA, localeCode),
            marquesas: makeTranslator(KEYS.TIMEZONES.MARQUESAS, localeCode),
            mauritius: makeTranslator(KEYS.TIMEZONES.MAURITIUS, localeCode),
            melbourne: makeTranslator(KEYS.TIMEZONES.MELBOURNE, localeCode),
            mexicoCity: makeTranslator(KEYS.TIMEZONES.MEXICO_CITY, localeCode),
            minsk: makeTranslator(KEYS.TIMEZONES.MINSK, localeCode),
            miquelon: makeTranslator(KEYS.TIMEZONES.MIQUELON, localeCode),
            montevideo: makeTranslator(KEYS.TIMEZONES.MONTEVIDEO, localeCode),
            moscow: makeTranslator(KEYS.TIMEZONES.MOSCOW, localeCode),
            nairobi: makeTranslator(KEYS.TIMEZONES.NAIROBI, localeCode),
            newYork: makeTranslator(KEYS.TIMEZONES.NEW_YORK, localeCode),
            newfoundland: makeTranslator(KEYS.TIMEZONES.NEWFOUNDLAND, localeCode),
            norfolk: makeTranslator(KEYS.TIMEZONES.NORFOLK, localeCode),
            noronha: makeTranslator(KEYS.TIMEZONES.NORONHA, localeCode),
            novosibirsk: makeTranslator(KEYS.TIMEZONES.NOVOSIBIRSK, localeCode),
            omsk: makeTranslator(KEYS.TIMEZONES.OMSK, localeCode),
            pagoPago: makeTranslator(KEYS.TIMEZONES.PAGO_PAGO, localeCode),
            paris: makeTranslator(KEYS.TIMEZONES.PARIS, localeCode),
            perth: makeTranslator(KEYS.TIMEZONES.PERTH, localeCode),
            phoenix: makeTranslator(KEYS.TIMEZONES.PHOENIX, localeCode),
            pitcairn: makeTranslator(KEYS.TIMEZONES.PITCAIRN, localeCode),
            portAuPrince: makeTranslator(KEYS.TIMEZONES.PORT_AU_PRINCE, localeCode),
            portMoresby: makeTranslator(KEYS.TIMEZONES.PORT_MORESBY, localeCode),
            puntaArenas: makeTranslator(KEYS.TIMEZONES.PUNTA_ARENAS, localeCode),
            pyongyang: makeTranslator(KEYS.TIMEZONES.PYONGYANG, localeCode),
            qyzylorda: makeTranslator(KEYS.TIMEZONES.QYZYLORDA, localeCode),
            rangoon: makeTranslator(KEYS.TIMEZONES.RANGOON, localeCode),
            regina: makeTranslator(KEYS.TIMEZONES.REGINA, localeCode),
            reykjavik: makeTranslator(KEYS.TIMEZONES.REYKJAVIK, localeCode),
            riyadh: makeTranslator(KEYS.TIMEZONES.RIYADH, localeCode),
            sakhalin: makeTranslator(KEYS.TIMEZONES.SAKHALIN, localeCode),
            samara: makeTranslator(KEYS.TIMEZONES.SAMARA, localeCode),
            santiago: makeTranslator(KEYS.TIMEZONES.SANTIAGO, localeCode),
            saoPaulo: makeTranslator(KEYS.TIMEZONES.SAO_PAULO, localeCode),
            saoTome: makeTranslator(KEYS.TIMEZONES.SAO_TOME, localeCode),
            saratov: makeTranslator(KEYS.TIMEZONES.SARATOV, localeCode),
            seoul: makeTranslator(KEYS.TIMEZONES.SEOUL, localeCode),
            shanghai: makeTranslator(KEYS.TIMEZONES.SHANGHAI, localeCode),
            singapore: makeTranslator(KEYS.TIMEZONES.SINGAPORE, localeCode),
            srednekolymsk: makeTranslator(KEYS.TIMEZONES.SREDNEKOLYMSK, localeCode),
            stJohns: makeTranslator(KEYS.TIMEZONES.ST_JOHNS, localeCode),
            sydney: makeTranslator(KEYS.TIMEZONES.SYDNEY, localeCode),
            taipei: makeTranslator(KEYS.TIMEZONES.TAIPEI, localeCode),
            tarawa: makeTranslator(KEYS.TIMEZONES.TARAWA, localeCode),
            tashkent: makeTranslator(KEYS.TIMEZONES.TASHKENT, localeCode),
            tbilisi: makeTranslator(KEYS.TIMEZONES.TBILISI, localeCode),
            tehran: makeTranslator(KEYS.TIMEZONES.TEHRAN, localeCode),
            tijuana: makeTranslator(KEYS.TIMEZONES.TIJUANA, localeCode),
            tokyo: makeTranslator(KEYS.TIMEZONES.TOKYO, localeCode),
            tomsk: makeTranslator(KEYS.TIMEZONES.TOMSK, localeCode),
            tongatapu: makeTranslator(KEYS.TIMEZONES.TONGATAPU, localeCode),
            toronto: makeTranslator(KEYS.TIMEZONES.TORONTO, localeCode),
            tripoli: makeTranslator(KEYS.TIMEZONES.TRIPOLI, localeCode),
            ulaanbaatar: makeTranslator(KEYS.TIMEZONES.ULAANBAATAR, localeCode),
            vancouver: makeTranslator(KEYS.TIMEZONES.VANCOUVER, localeCode),
            vladivostok: makeTranslator(KEYS.TIMEZONES.VLADIVOSTOK, localeCode),
            volgograd: makeTranslator(KEYS.TIMEZONES.VOLGOGRAD, localeCode),
            warsaw: makeTranslator(KEYS.TIMEZONES.WARSAW, localeCode),
            whitehorse: makeTranslator(KEYS.TIMEZONES.WHITEHORSE, localeCode),
            windhoek: makeTranslator(KEYS.TIMEZONES.WINDHOEK, localeCode),
            winnipeg: makeTranslator(KEYS.TIMEZONES.WINNIPEG, localeCode),
            yakutsk: makeTranslator(KEYS.TIMEZONES.YAKUTSK, localeCode),
            yekaterinburg: makeTranslator(KEYS.TIMEZONES.YEKATERINBURG, localeCode),
            yerevan: makeTranslator(KEYS.TIMEZONES.YEREVAN, localeCode)
        },
        user: {
            bulkDeleteModal: {
                confirmText: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.CONFIRM_TEXT, localeCode),
                hasErrorsMessage: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.HAS_ERRORS_MESSAGE, localeCode),
                message: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.MESSAGE, localeCode),
                messagePlural: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.MESSAGE_plural, localeCode),
                submitButton: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.SUBMIT_BUTTON, localeCode),
                submitButtonPlural: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.SUBMIT_BUTTON_plural, localeCode),
                title: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.TITLE, localeCode),
                titlePlural: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.TITLE_plural, localeCode),
                toasts: {
                    error: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.TOASTS.ERROR, localeCode),
                    success: makeTranslator(KEYS.USER.BULK_DELETE_MODAL.TOASTS.SUCCESS, localeCode)
                }
            },
            bulkResetPasswordsModal: {
                buttonSendBoth: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_BOTH, localeCode),
                buttonSendPasswordResets: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_PASSWORD_RESETS, localeCode),
                buttonSendUserInvites: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.BUTTON_SEND_USER_INVITES, localeCode),
                confirmResendInvite: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_RESEND_INVITE, localeCode),
                confirmSendPasswordReset: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.CONFIRM_SEND_PASSWORD_RESET, localeCode),
                description: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.DESCRIPTION, localeCode),
                fetchUserErrorMessage: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.FETCH_USER_ERROR_MESSAGE, localeCode),
                notifyPartialError: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_PARTIAL_ERROR, localeCode),
                notifySendBothSuccess: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_BOTH_SUCCESS, localeCode),
                notifySendPasswordResetsSuccess: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_PASSWORD_RESETS_SUCCESS, localeCode),
                notifySendUserInvitesSuccess: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.NOTIFY_SEND_USER_INVITES_SUCCESS, localeCode),
                resendUserInvitesTitle: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.RESEND_USER_INVITES_TITLE, localeCode),
                title: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.TITLE, localeCode),
                usersWithoutAcceptedInviteMessage: makeTranslator(KEYS.USER.BULK_RESET_PASSWORDS_MODAL.USERS_WITHOUT_ACCEPTED_INVITE_MESSAGE, localeCode)
            },
            bulkUpdateLocationsModal: {
                addLocationsCountText: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TEXT, localeCode),
                addLocationsCountTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.ADD_LOCATIONS_COUNT_TOOLTIP, localeCode),
                confirmText: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TEXT, localeCode),
                confirmTitle: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.CONFIRM_TITLE, localeCode),
                hasErrorsMessage: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.HAS_ERRORS_MESSAGE, localeCode),
                message: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.MESSAGE, localeCode),
                removeLocationsCountText: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TEXT, localeCode),
                removeLocationsCountTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.REMOVE_LOCATIONS_COUNT_TOOLTIP, localeCode),
                submitButton: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.SUBMIT_BUTTON, localeCode),
                title: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.TITLE, localeCode),
                toasts: {
                    error: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.ERROR, localeCode),
                    success: makeTranslator(KEYS.USER.BULK_UPDATE_LOCATIONS_MODAL.TOASTS.SUCCESS, localeCode)
                }
            },
            bulkUpdateRolesModal: {
                addRolesCountText: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT, localeCode),
                addRolesCountTextPlural: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TEXT_plural, localeCode),
                addRolesCountTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP, localeCode),
                addRolesCountTooltipPlural: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.ADD_ROLES_COUNT_TOOLTIP_plural, localeCode),
                confirmText: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TEXT, localeCode),
                confirmTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.CONFIRM_TITLE, localeCode),
                existingTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.EXISTING_TITLE, localeCode),
                hasErrorsMessage: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.HAS_ERRORS_MESSAGE, localeCode),
                message: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.MESSAGE, localeCode),
                newRoleTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.NEW_ROLE_TOOLTIP, localeCode),
                newTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.NEW_TITLE, localeCode),
                partialExistingRoleTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.PARTIAL_EXISTING_ROLE_TOOLTIP, localeCode),
                removeRolesCountText: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT, localeCode),
                removeRolesCountTextPlural: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TEXT_plural, localeCode),
                removeRolesCountTooltip: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP, localeCode),
                removeRolesCountTooltipPlural: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.REMOVE_ROLES_COUNT_TOOLTIP_plural, localeCode),
                removedTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.REMOVED_TITLE, localeCode),
                roleListTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.ROLE_LIST_TITLE, localeCode),
                selectedRolesListTitle: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.SELECTED_ROLES_LIST_TITLE, localeCode),
                submitButton: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.SUBMIT_BUTTON, localeCode),
                title: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.TITLE, localeCode),
                toasts: {
                    error: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.TOASTS.ERROR, localeCode),
                    success: makeTranslator(KEYS.USER.BULK_UPDATE_ROLES_MODAL.TOASTS.SUCCESS, localeCode)
                }
            },
            editUserDetails: {
                addNotifications: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.ADD_NOTIFICATIONS, localeCode),
                addRole: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.ADD_ROLE, localeCode),
                confirmDeleteUser: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.CONFIRM_DELETE_USER, localeCode),
                headers: {
                    assignedLocations: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.HEADERS.ASSIGNED_LOCATIONS, localeCode),
                    guidedTour: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.HEADERS.GUIDED_TOUR, localeCode),
                    notifications: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.HEADERS.NOTIFICATIONS, localeCode),
                    roles: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.HEADERS.ROLES, localeCode),
                    userDetails: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.HEADERS.USER_DETAILS, localeCode)
                },
                notifyDeleteUserSuccess: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.NOTIFY_DELETE_USER_SUCCESS, localeCode),
                notifySendPasswordResetSuccess: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.NOTIFY_SEND_PASSWORD_RESET_SUCCESS, localeCode),
                notifyUpdateUserDetailsSuccess: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.NOTIFY_UPDATE_USER_DETAILS_SUCCESS, localeCode),
                saveAssignedLocations: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.SAVE_ASSIGNED_LOCATIONS, localeCode),
                saveUserDetails: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.SAVE_USER_DETAILS, localeCode),
                selectOptions: {
                    deleteUser: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.SELECT_OPTIONS.DELETE_USER, localeCode),
                    placeholder: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.SELECT_OPTIONS.PLACEHOLDER, localeCode),
                    sendPasswordResetEmail: makeTranslator(KEYS.USER.EDIT_USER_DETAILS.SELECT_OPTIONS.SEND_PASSWORD_RESET_EMAIL, localeCode)
                }
            },
            usersLocationsBox: {
                existingLocationsTitle: makeTranslator(KEYS.USER.USERS_LOCATIONS_BOX.EXISTING_LOCATIONS_TITLE, localeCode),
                newLocationsTitle: makeTranslator(KEYS.USER.USERS_LOCATIONS_BOX.NEW_LOCATIONS_TITLE, localeCode),
                removedLocationsTitle: makeTranslator(KEYS.USER.USERS_LOCATIONS_BOX.REMOVED_LOCATIONS_TITLE, localeCode),
                rightTitle: makeTranslator(KEYS.USER.USERS_LOCATIONS_BOX.RIGHT_TITLE, localeCode)
            }
        }
    };

    const result = (key: SegmentKey, options?: TranslateOptions) => {
        options = options || {};
        options = { localeCode, ...options };
        return translate(key, options);
    };

    for (const namespace of Object.getOwnPropertyNames(text)) {
        (result as any)[namespace] = (text as any)[namespace];
    }

    return result as any;
}